/******/ (function(modules) { // webpackBootstrap
    /******/ 	// The module cache
    /******/ 	var installedModules = {};
    /******/
    /******/ 	// The require function
    /******/ 	function __webpack_require__(moduleId) {
        /******/
        /******/ 		// Check if module is in cache
        /******/ 		if(installedModules[moduleId]) {
            /******/ 			return installedModules[moduleId].exports;
            /******/ 		}
        /******/ 		// Create a new module (and put it into the cache)
        /******/ 		var module = installedModules[moduleId] = {
            /******/ 			i: moduleId,
            /******/ 			l: false,
            /******/ 			exports: {}
            /******/ 		};
        /******/
        /******/ 		// Execute the module function
        /******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
        /******/
        /******/ 		// Flag the module as loaded
        /******/ 		module.l = true;
        /******/
        /******/ 		// Return the exports of the module
        /******/ 		return module.exports;
        /******/ 	}
    /******/
    /******/
    /******/ 	// expose the modules object (__webpack_modules__)
    /******/ 	__webpack_require__.m = modules;
    /******/
    /******/ 	// expose the module cache
    /******/ 	__webpack_require__.c = installedModules;
    /******/
    /******/ 	// define getter function for harmony exports
    /******/ 	__webpack_require__.d = function(exports, name, getter) {
        /******/ 		if(!__webpack_require__.o(exports, name)) {
            /******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
            /******/ 		}
        /******/ 	};
    /******/
    /******/ 	// define __esModule on exports
    /******/ 	__webpack_require__.r = function(exports) {
        /******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
            /******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
            /******/ 		}
        /******/ 		Object.defineProperty(exports, '__esModule', { value: true });
        /******/ 	};
    /******/
    /******/ 	// create a fake namespace object
    /******/ 	// mode & 1: value is a module id, require it
    /******/ 	// mode & 2: merge all properties of value into the ns
    /******/ 	// mode & 4: return value when already ns object
    /******/ 	// mode & 8|1: behave like require
    /******/ 	__webpack_require__.t = function(value, mode) {
        /******/ 		if(mode & 1) value = __webpack_require__(value);
        /******/ 		if(mode & 8) return value;
        /******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
        /******/ 		var ns = Object.create(null);
        /******/ 		__webpack_require__.r(ns);
        /******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
        /******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
        /******/ 		return ns;
        /******/ 	};
    /******/
    /******/ 	// getDefaultExport function for compatibility with non-harmony modules
    /******/ 	__webpack_require__.n = function(module) {
        /******/ 		var getter = module && module.__esModule ?
                /******/ 			function getDefault() { return module['default']; } :
                /******/ 			function getModuleExports() { return module; };
        /******/ 		__webpack_require__.d(getter, 'a', getter);
        /******/ 		return getter;
        /******/ 	};
    /******/
    /******/ 	// Object.prototype.hasOwnProperty.call
    /******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
    /******/
    /******/ 	// __webpack_public_path__
    /******/ 	__webpack_require__.p = "";
    /******/
    /******/
    /******/ 	// Load entry module and return exports
    /******/ 	return __webpack_require__(__webpack_require__.s = 33);
    /******/ })
/************************************************************************/
/******/ ([
    /* 0 */
    /***/ (function(module, exports, __webpack_require__) {

        var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
         * jQuery JavaScript Library v3.5.1
         * https://jquery.com/
         *
         * Includes Sizzle.js
         * https://sizzlejs.com/
         *
         * Copyright JS Foundation and other contributors
         * Released under the MIT license
         * https://jquery.org/license
         *
         * Date: 2020-05-04T22:49Z
         */
        ( function( global, factory ) {

            "use strict";

            if (  true && typeof module.exports === "object" ) {

                // For CommonJS and CommonJS-like environments where a proper `window`
                // is present, execute the factory and get jQuery.
                // For environments that do not have a `window` with a `document`
                // (such as Node.js), expose a factory as module.exports.
                // This accentuates the need for the creation of a real `window`.
                // e.g. var jQuery = require("jquery")(window);
                // See ticket #14549 for more info.
                module.exports = global.document ?
                        factory( global, true ) :
                        function( w ) {
                            if ( !w.document ) {
                                throw new Error( "jQuery requires a window with a document" );
                            }
                            return factory( w );
                        };
            } else {
                factory( global );
            }

// Pass this if window is not defined yet
        } )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
// enough that all such attempts are guarded in a try block.
            "use strict";

            var arr = [];

            var getProto = Object.getPrototypeOf;

            var slice = arr.slice;

            var flat = arr.flat ? function( array ) {
                return arr.flat.call( array );
            } : function( array ) {
                return arr.concat.apply( [], array );
            };


            var push = arr.push;

            var indexOf = arr.indexOf;

            var class2type = {};

            var toString = class2type.toString;

            var hasOwn = class2type.hasOwnProperty;

            var fnToString = hasOwn.toString;

            var ObjectFunctionString = fnToString.call( Object );

            var support = {};

            var isFunction = function isFunction( obj ) {

                // Support: Chrome <=57, Firefox <=52
                // In some browsers, typeof returns "function" for HTML <object> elements
                // (i.e., `typeof document.createElement( "object" ) === "function"`).
                // We don't want to classify *any* DOM node as a function.
                return typeof obj === "function" && typeof obj.nodeType !== "number";
            };


            var isWindow = function isWindow( obj ) {
                return obj != null && obj === obj.window;
            };


            var document = window.document;



            var preservedScriptAttributes = {
                type: true,
                src: true,
                nonce: true,
                noModule: true
            };

            function DOMEval( code, node, doc ) {
                doc = doc || document;

                var i, val,
                        script = doc.createElement( "script" );

                script.text = code;
                if ( node ) {
                    for ( i in preservedScriptAttributes ) {

                        // Support: Firefox 64+, Edge 18+
                        // Some browsers don't support the "nonce" property on scripts.
                        // On the other hand, just using `getAttribute` is not enough as
                        // the `nonce` attribute is reset to an empty string whenever it
                        // becomes browsing-context connected.
                        // See https://github.com/whatwg/html/issues/2369
                        // See https://html.spec.whatwg.org/#nonce-attributes
                        // The `node.getAttribute` check was added for the sake of
                        // `jQuery.globalEval` so that it can fake a nonce-containing node
                        // via an object.
                        val = node[ i ] || node.getAttribute && node.getAttribute( i );
                        if ( val ) {
                            script.setAttribute( i, val );
                        }
                    }
                }
                doc.head.appendChild( script ).parentNode.removeChild( script );
            }


            function toType( obj ) {
                if ( obj == null ) {
                    return obj + "";
                }

                // Support: Android <=2.3 only (functionish RegExp)
                return typeof obj === "object" || typeof obj === "function" ?
                class2type[ toString.call( obj ) ] || "object" :
                        typeof obj;
            }
            /* global Symbol */
// Defining this global in .eslintrc.json would create a danger of using the global
// unguarded in another place, it seems safer to define global only for this module



            var
                    version = "3.5.1",

            // Define a local copy of jQuery
                    jQuery = function( selector, context ) {

                        // The jQuery object is actually just the init constructor 'enhanced'
                        // Need init if jQuery is called (just allow error to be thrown if not included)
                        return new jQuery.fn.init( selector, context );
                    };

            jQuery.fn = jQuery.prototype = {

                // The current version of jQuery being used
                jquery: version,

                constructor: jQuery,

                // The default length of a jQuery object is 0
                length: 0,

                toArray: function() {
                    return slice.call( this );
                },

                // Get the Nth element in the matched element set OR
                // Get the whole matched element set as a clean array
                get: function( num ) {

                    // Return all the elements in a clean array
                    if ( num == null ) {
                        return slice.call( this );
                    }

                    // Return just the one element from the set
                    return num < 0 ? this[ num + this.length ] : this[ num ];
                },

                // Take an array of elements and push it onto the stack
                // (returning the new matched element set)
                pushStack: function( elems ) {

                    // Build a new jQuery matched element set
                    var ret = jQuery.merge( this.constructor(), elems );

                    // Add the old object onto the stack (as a reference)
                    ret.prevObject = this;

                    // Return the newly-formed element set
                    return ret;
                },

                // Execute a callback for every element in the matched set.
                each: function( callback ) {
                    return jQuery.each( this, callback );
                },

                map: function( callback ) {
                    return this.pushStack( jQuery.map( this, function( elem, i ) {
                        return callback.call( elem, i, elem );
                    } ) );
                },

                slice: function() {
                    return this.pushStack( slice.apply( this, arguments ) );
                },

                first: function() {
                    return this.eq( 0 );
                },

                last: function() {
                    return this.eq( -1 );
                },

                even: function() {
                    return this.pushStack( jQuery.grep( this, function( _elem, i ) {
                        return ( i + 1 ) % 2;
                    } ) );
                },

                odd: function() {
                    return this.pushStack( jQuery.grep( this, function( _elem, i ) {
                        return i % 2;
                    } ) );
                },

                eq: function( i ) {
                    var len = this.length,
                            j = +i + ( i < 0 ? len : 0 );
                    return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
                },

                end: function() {
                    return this.prevObject || this.constructor();
                },

                // For internal use only.
                // Behaves like an Array's method, not like a jQuery method.
                push: push,
                sort: arr.sort,
                splice: arr.splice
            };

            jQuery.extend = jQuery.fn.extend = function() {
                var options, name, src, copy, copyIsArray, clone,
                        target = arguments[ 0 ] || {},
                        i = 1,
                        length = arguments.length,
                        deep = false;

                // Handle a deep copy situation
                if ( typeof target === "boolean" ) {
                    deep = target;

                    // Skip the boolean and the target
                    target = arguments[ i ] || {};
                    i++;
                }

                // Handle case when target is a string or something (possible in deep copy)
                if ( typeof target !== "object" && !isFunction( target ) ) {
                    target = {};
                }

                // Extend jQuery itself if only one argument is passed
                if ( i === length ) {
                    target = this;
                    i--;
                }

                for ( ; i < length; i++ ) {

                    // Only deal with non-null/undefined values
                    if ( ( options = arguments[ i ] ) != null ) {

                        // Extend the base object
                        for ( name in options ) {
                            copy = options[ name ];

                            // Prevent Object.prototype pollution
                            // Prevent never-ending loop
                            if ( name === "__proto__" || target === copy ) {
                                continue;
                            }

                            // Recurse if we're merging plain objects or arrays
                            if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
                                    ( copyIsArray = Array.isArray( copy ) ) ) ) {
                                src = target[ name ];

                                // Ensure proper type for the source value
                                if ( copyIsArray && !Array.isArray( src ) ) {
                                    clone = [];
                                } else if ( !copyIsArray && !jQuery.isPlainObject( src ) ) {
                                    clone = {};
                                } else {
                                    clone = src;
                                }
                                copyIsArray = false;

                                // Never move original objects, clone them
                                target[ name ] = jQuery.extend( deep, clone, copy );

                                // Don't bring in undefined values
                            } else if ( copy !== undefined ) {
                                target[ name ] = copy;
                            }
                        }
                    }
                }

                // Return the modified object
                return target;
            };

            jQuery.extend( {

                // Unique for each copy of jQuery on the page
                expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

                // Assume jQuery is ready without the ready module
                isReady: true,

                error: function( msg ) {
                    throw new Error( msg );
                },

                noop: function() {},

                isPlainObject: function( obj ) {
                    var proto, Ctor;

                    // Detect obvious negatives
                    // Use toString instead of jQuery.type to catch host objects
                    if ( !obj || toString.call( obj ) !== "[object Object]" ) {
                        return false;
                    }

                    proto = getProto( obj );

                    // Objects with no prototype (e.g., `Object.create( null )`) are plain
                    if ( !proto ) {
                        return true;
                    }

                    // Objects with prototype are plain iff they were constructed by a global Object function
                    Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
                    return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
                },

                isEmptyObject: function( obj ) {
                    var name;

                    for ( name in obj ) {
                        return false;
                    }
                    return true;
                },

                // Evaluates a script in a provided context; falls back to the global one
                // if not specified.
                globalEval: function( code, options, doc ) {
                    DOMEval( code, { nonce: options && options.nonce }, doc );
                },

                each: function( obj, callback ) {
                    var length, i = 0;

                    if ( isArrayLike( obj ) ) {
                        length = obj.length;
                        for ( ; i < length; i++ ) {
                            if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
                                break;
                            }
                        }
                    } else {
                        for ( i in obj ) {
                            if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
                                break;
                            }
                        }
                    }

                    return obj;
                },

                // results is for internal usage only
                makeArray: function( arr, results ) {
                    var ret = results || [];

                    if ( arr != null ) {
                        if ( isArrayLike( Object( arr ) ) ) {
                            jQuery.merge( ret,
                                    typeof arr === "string" ?
                                            [ arr ] : arr
                            );
                        } else {
                            push.call( ret, arr );
                        }
                    }

                    return ret;
                },

                inArray: function( elem, arr, i ) {
                    return arr == null ? -1 : indexOf.call( arr, elem, i );
                },

                // Support: Android <=4.0 only, PhantomJS 1 only
                // push.apply(_, arraylike) throws on ancient WebKit
                merge: function( first, second ) {
                    var len = +second.length,
                            j = 0,
                            i = first.length;

                    for ( ; j < len; j++ ) {
                        first[ i++ ] = second[ j ];
                    }

                    first.length = i;

                    return first;
                },

                grep: function( elems, callback, invert ) {
                    var callbackInverse,
                            matches = [],
                            i = 0,
                            length = elems.length,
                            callbackExpect = !invert;

                    // Go through the array, only saving the items
                    // that pass the validator function
                    for ( ; i < length; i++ ) {
                        callbackInverse = !callback( elems[ i ], i );
                        if ( callbackInverse !== callbackExpect ) {
                            matches.push( elems[ i ] );
                        }
                    }

                    return matches;
                },

                // arg is for internal usage only
                map: function( elems, callback, arg ) {
                    var length, value,
                            i = 0,
                            ret = [];

                    // Go through the array, translating each of the items to their new values
                    if ( isArrayLike( elems ) ) {
                        length = elems.length;
                        for ( ; i < length; i++ ) {
                            value = callback( elems[ i ], i, arg );

                            if ( value != null ) {
                                ret.push( value );
                            }
                        }

                        // Go through every key on the object,
                    } else {
                        for ( i in elems ) {
                            value = callback( elems[ i ], i, arg );

                            if ( value != null ) {
                                ret.push( value );
                            }
                        }
                    }

                    // Flatten any nested arrays
                    return flat( ret );
                },

                // A global GUID counter for objects
                guid: 1,

                // jQuery.support is not used in Core but other projects attach their
                // properties to it so it needs to exist.
                support: support
            } );

            if ( typeof Symbol === "function" ) {
                jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
            }

// Populate the class2type map
            jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
                    function( _i, name ) {
                        class2type[ "[object " + name + "]" ] = name.toLowerCase();
                    } );

            function isArrayLike( obj ) {

                // Support: real iOS 8.2 only (not reproducible in simulator)
                // `in` check used to prevent JIT error (gh-2145)
                // hasOwn isn't used here due to false negatives
                // regarding Nodelist length in IE
                var length = !!obj && "length" in obj && obj.length,
                        type = toType( obj );

                if ( isFunction( obj ) || isWindow( obj ) ) {
                    return false;
                }

                return type === "array" || length === 0 ||
                        typeof length === "number" && length > 0 && ( length - 1 ) in obj;
            }
            var Sizzle =
                    /*!
                     * Sizzle CSS Selector Engine v2.3.5
                     * https://sizzlejs.com/
                     *
                     * Copyright JS Foundation and other contributors
                     * Released under the MIT license
                     * https://js.foundation/
                     *
                     * Date: 2020-03-14
                     */
                    ( function( window ) {
                        var i,
                                support,
                                Expr,
                                getText,
                                isXML,
                                tokenize,
                                compile,
                                select,
                                outermostContext,
                                sortInput,
                                hasDuplicate,

                        // Local document vars
                                setDocument,
                                document,
                                docElem,
                                documentIsHTML,
                                rbuggyQSA,
                                rbuggyMatches,
                                matches,
                                contains,

                        // Instance-specific data
                                expando = "sizzle" + 1 * new Date(),
                                preferredDoc = window.document,
                                dirruns = 0,
                                done = 0,
                                classCache = createCache(),
                                tokenCache = createCache(),
                                compilerCache = createCache(),
                                nonnativeSelectorCache = createCache(),
                                sortOrder = function( a, b ) {
                                    if ( a === b ) {
                                        hasDuplicate = true;
                                    }
                                    return 0;
                                },

                        // Instance methods
                                hasOwn = ( {} ).hasOwnProperty,
                                arr = [],
                                pop = arr.pop,
                                pushNative = arr.push,
                                push = arr.push,
                                slice = arr.slice,

                        // Use a stripped-down indexOf as it's faster than native
                        // https://jsperf.com/thor-indexof-vs-for/5
                                indexOf = function( list, elem ) {
                                    var i = 0,
                                            len = list.length;
                                    for ( ; i < len; i++ ) {
                                        if ( list[ i ] === elem ) {
                                            return i;
                                        }
                                    }
                                    return -1;
                                },

                                booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|" +
                                        "ismap|loop|multiple|open|readonly|required|scoped",

                        // Regular expressions

                        // http://www.w3.org/TR/css3-selectors/#whitespace
                                whitespace = "[\\x20\\t\\r\\n\\f]",

                        // https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
                                identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace +
                                        "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",

                        // Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
                                attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +

                                        // Operator (capture 2)
                                        "*([*^$|!~]?=)" + whitespace +

                                        // "Attribute values must be CSS identifiers [capture 5]
                                        // or strings [capture 3 or capture 4]"
                                        "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" +
                                        whitespace + "*\\]",

                                pseudos = ":(" + identifier + ")(?:\\((" +

                                        // To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
                                        // 1. quoted (capture 3; capture 4 or capture 5)
                                        "('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +

                                        // 2. simple (capture 6)
                                        "((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +

                                        // 3. anything else (capture 2)
                                        ".*" +
                                        ")\\)|)",

                        // Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
                                rwhitespace = new RegExp( whitespace + "+", "g" ),
                                rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" +
                                        whitespace + "+$", "g" ),

                                rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
                                rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace +
                                        "*" ),
                                rdescend = new RegExp( whitespace + "|>" ),

                                rpseudo = new RegExp( pseudos ),
                                ridentifier = new RegExp( "^" + identifier + "$" ),

                                matchExpr = {
                                    "ID": new RegExp( "^#(" + identifier + ")" ),
                                    "CLASS": new RegExp( "^\\.(" + identifier + ")" ),
                                    "TAG": new RegExp( "^(" + identifier + "|[*])" ),
                                    "ATTR": new RegExp( "^" + attributes ),
                                    "PSEUDO": new RegExp( "^" + pseudos ),
                                    "CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
                                            whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" +
                                            whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
                                    "bool": new RegExp( "^(?:" + booleans + ")$", "i" ),

                                    // For use in libraries implementing .is()
                                    // We use this for POS matching in `select`
                                    "needsContext": new RegExp( "^" + whitespace +
                                            "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace +
                                            "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
                                },

                                rhtml = /HTML$/i,
                                rinputs = /^(?:input|select|textarea|button)$/i,
                                rheader = /^h\d$/i,

                                rnative = /^[^{]+\{\s*\[native \w/,

                        // Easily-parseable/retrievable ID or TAG or CLASS selectors
                                rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

                                rsibling = /[+~]/,

                        // CSS escapes
                        // http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
                                runescape = new RegExp( "\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g" ),
                                funescape = function( escape, nonHex ) {
                                    var high = "0x" + escape.slice( 1 ) - 0x10000;

                                    return nonHex ?

                                            // Strip the backslash prefix from a non-hex escape sequence
                                            nonHex :

                                            // Replace a hexadecimal escape sequence with the encoded Unicode code point
                                            // Support: IE <=11+
                                            // For values outside the Basic Multilingual Plane (BMP), manually construct a
                                            // surrogate pair
                                            high < 0 ?
                                                    String.fromCharCode( high + 0x10000 ) :
                                                    String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
                                },

                        // CSS string/identifier serialization
                        // https://drafts.csswg.org/cssom/#common-serializing-idioms
                                rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
                                fcssescape = function( ch, asCodePoint ) {
                                    if ( asCodePoint ) {

                                        // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
                                        if ( ch === "\0" ) {
                                            return "\uFFFD";
                                        }

                                        // Control characters and (dependent upon position) numbers get escaped as code points
                                        return ch.slice( 0, -1 ) + "\\" +
                                                ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
                                    }

                                    // Other potentially-special ASCII characters get backslash-escaped
                                    return "\\" + ch;
                                },

                        // Used for iframes
                        // See setDocument()
                        // Removing the function wrapper causes a "Permission Denied"
                        // error in IE
                                unloadHandler = function() {
                                    setDocument();
                                },

                                inDisabledFieldset = addCombinator(
                                        function( elem ) {
                                            return elem.disabled === true && elem.nodeName.toLowerCase() === "fieldset";
                                        },
                                        { dir: "parentNode", next: "legend" }
                                );

// Optimize for push.apply( _, NodeList )
                        try {
                            push.apply(
                                    ( arr = slice.call( preferredDoc.childNodes ) ),
                                    preferredDoc.childNodes
                            );

                            // Support: Android<4.0
                            // Detect silently failing push.apply
                            // eslint-disable-next-line no-unused-expressions
                            arr[ preferredDoc.childNodes.length ].nodeType;
                        } catch ( e ) {
                            push = { apply: arr.length ?

                                    // Leverage slice if possible
                                    function( target, els ) {
                                        pushNative.apply( target, slice.call( els ) );
                                    } :

                                    // Support: IE<9
                                    // Otherwise append directly
                                    function( target, els ) {
                                        var j = target.length,
                                                i = 0;

                                        // Can't trust NodeList.length
                                        while ( ( target[ j++ ] = els[ i++ ] ) ) {}
                                        target.length = j - 1;
                                    }
                            };
                        }

                        function Sizzle( selector, context, results, seed ) {
                            var m, i, elem, nid, match, groups, newSelector,
                                    newContext = context && context.ownerDocument,

                            // nodeType defaults to 9, since context defaults to document
                                    nodeType = context ? context.nodeType : 9;

                            results = results || [];

                            // Return early from calls with invalid selector or context
                            if ( typeof selector !== "string" || !selector ||
                                    nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

                                return results;
                            }

                            // Try to shortcut find operations (as opposed to filters) in HTML documents
                            if ( !seed ) {
                                setDocument( context );
                                context = context || document;

                                if ( documentIsHTML ) {

                                    // If the selector is sufficiently simple, try using a "get*By*" DOM method
                                    // (excepting DocumentFragment context, where the methods don't exist)
                                    if ( nodeType !== 11 && ( match = rquickExpr.exec( selector ) ) ) {

                                        // ID selector
                                        if ( ( m = match[ 1 ] ) ) {

                                            // Document context
                                            if ( nodeType === 9 ) {
                                                if ( ( elem = context.getElementById( m ) ) ) {

                                                    // Support: IE, Opera, Webkit
                                                    // TODO: identify versions
                                                    // getElementById can match elements by name instead of ID
                                                    if ( elem.id === m ) {
                                                        results.push( elem );
                                                        return results;
                                                    }
                                                } else {
                                                    return results;
                                                }

                                                // Element context
                                            } else {

                                                // Support: IE, Opera, Webkit
                                                // TODO: identify versions
                                                // getElementById can match elements by name instead of ID
                                                if ( newContext && ( elem = newContext.getElementById( m ) ) &&
                                                        contains( context, elem ) &&
                                                        elem.id === m ) {

                                                    results.push( elem );
                                                    return results;
                                                }
                                            }

                                            // Type selector
                                        } else if ( match[ 2 ] ) {
                                            push.apply( results, context.getElementsByTagName( selector ) );
                                            return results;

                                            // Class selector
                                        } else if ( ( m = match[ 3 ] ) && support.getElementsByClassName &&
                                                context.getElementsByClassName ) {

                                            push.apply( results, context.getElementsByClassName( m ) );
                                            return results;
                                        }
                                    }

                                    // Take advantage of querySelectorAll
                                    if ( support.qsa &&
                                            !nonnativeSelectorCache[ selector + " " ] &&
                                            ( !rbuggyQSA || !rbuggyQSA.test( selector ) ) &&

                                            // Support: IE 8 only
                                            // Exclude object elements
                                            ( nodeType !== 1 || context.nodeName.toLowerCase() !== "object" ) ) {

                                        newSelector = selector;
                                        newContext = context;

                                        // qSA considers elements outside a scoping root when evaluating child or
                                        // descendant combinators, which is not what we want.
                                        // In such cases, we work around the behavior by prefixing every selector in the
                                        // list with an ID selector referencing the scope context.
                                        // The technique has to be used as well when a leading combinator is used
                                        // as such selectors are not recognized by querySelectorAll.
                                        // Thanks to Andrew Dupont for this technique.
                                        if ( nodeType === 1 &&
                                                ( rdescend.test( selector ) || rcombinators.test( selector ) ) ) {

                                            // Expand context for sibling selectors
                                            newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
                                                    context;

                                            // We can use :scope instead of the ID hack if the browser
                                            // supports it & if we're not changing the context.
                                            if ( newContext !== context || !support.scope ) {

                                                // Capture the context ID, setting it first if necessary
                                                if ( ( nid = context.getAttribute( "id" ) ) ) {
                                                    nid = nid.replace( rcssescape, fcssescape );
                                                } else {
                                                    context.setAttribute( "id", ( nid = expando ) );
                                                }
                                            }

                                            // Prefix every selector in the list
                                            groups = tokenize( selector );
                                            i = groups.length;
                                            while ( i-- ) {
                                                groups[ i ] = ( nid ? "#" + nid : ":scope" ) + " " +
                                                        toSelector( groups[ i ] );
                                            }
                                            newSelector = groups.join( "," );
                                        }

                                        try {
                                            push.apply( results,
                                                    newContext.querySelectorAll( newSelector )
                                            );
                                            return results;
                                        } catch ( qsaError ) {
                                            nonnativeSelectorCache( selector, true );
                                        } finally {
                                            if ( nid === expando ) {
                                                context.removeAttribute( "id" );
                                            }
                                        }
                                    }
                                }
                            }

                            // All others
                            return select( selector.replace( rtrim, "$1" ), context, results, seed );
                        }

                        /**
                         * Create key-value caches of limited size
                         * @returns {function(string, object)} Returns the Object data after storing it on itself with
                         *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
                         *	deleting the oldest entry
                         */
                        function createCache() {
                            var keys = [];

                            function cache( key, value ) {

                                // Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
                                if ( keys.push( key + " " ) > Expr.cacheLength ) {

                                    // Only keep the most recent entries
                                    delete cache[ keys.shift() ];
                                }
                                return ( cache[ key + " " ] = value );
                            }
                            return cache;
                        }

                        /**
                         * Mark a function for special use by Sizzle
                         * @param {Function} fn The function to mark
                         */
                        function markFunction( fn ) {
                            fn[ expando ] = true;
                            return fn;
                        }

                        /**
                         * Support testing using an element
                         * @param {Function} fn Passed the created element and returns a boolean result
                         */
                        function assert( fn ) {
                            var el = document.createElement( "fieldset" );

                            try {
                                return !!fn( el );
                            } catch ( e ) {
                                return false;
                            } finally {

                                // Remove from its parent by default
                                if ( el.parentNode ) {
                                    el.parentNode.removeChild( el );
                                }

                                // release memory in IE
                                el = null;
                            }
                        }

                        /**
                         * Adds the same handler for all of the specified attrs
                         * @param {String} attrs Pipe-separated list of attributes
                         * @param {Function} handler The method that will be applied
                         */
                        function addHandle( attrs, handler ) {
                            var arr = attrs.split( "|" ),
                                    i = arr.length;

                            while ( i-- ) {
                                Expr.attrHandle[ arr[ i ] ] = handler;
                            }
                        }

                        /**
                         * Checks document order of two siblings
                         * @param {Element} a
                         * @param {Element} b
                         * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
                         */
                        function siblingCheck( a, b ) {
                            var cur = b && a,
                                    diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
                                            a.sourceIndex - b.sourceIndex;

                            // Use IE sourceIndex if available on both nodes
                            if ( diff ) {
                                return diff;
                            }

                            // Check if b follows a
                            if ( cur ) {
                                while ( ( cur = cur.nextSibling ) ) {
                                    if ( cur === b ) {
                                        return -1;
                                    }
                                }
                            }

                            return a ? 1 : -1;
                        }

                        /**
                         * Returns a function to use in pseudos for input types
                         * @param {String} type
                         */
                        function createInputPseudo( type ) {
                            return function( elem ) {
                                var name = elem.nodeName.toLowerCase();
                                return name === "input" && elem.type === type;
                            };
                        }

                        /**
                         * Returns a function to use in pseudos for buttons
                         * @param {String} type
                         */
                        function createButtonPseudo( type ) {
                            return function( elem ) {
                                var name = elem.nodeName.toLowerCase();
                                return ( name === "input" || name === "button" ) && elem.type === type;
                            };
                        }

                        /**
                         * Returns a function to use in pseudos for :enabled/:disabled
                         * @param {Boolean} disabled true for :disabled; false for :enabled
                         */
                        function createDisabledPseudo( disabled ) {

                            // Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
                            return function( elem ) {

                                // Only certain elements can match :enabled or :disabled
                                // https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
                                // https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
                                if ( "form" in elem ) {

                                    // Check for inherited disabledness on relevant non-disabled elements:
                                    // * listed form-associated elements in a disabled fieldset
                                    //   https://html.spec.whatwg.org/multipage/forms.html#category-listed
                                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
                                    // * option elements in a disabled optgroup
                                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
                                    // All such elements have a "form" property.
                                    if ( elem.parentNode && elem.disabled === false ) {

                                        // Option elements defer to a parent optgroup if present
                                        if ( "label" in elem ) {
                                            if ( "label" in elem.parentNode ) {
                                                return elem.parentNode.disabled === disabled;
                                            } else {
                                                return elem.disabled === disabled;
                                            }
                                        }

                                        // Support: IE 6 - 11
                                        // Use the isDisabled shortcut property to check for disabled fieldset ancestors
                                        return elem.isDisabled === disabled ||

                                                // Where there is no isDisabled, check manually
                                                /* jshint -W018 */
                                                elem.isDisabled !== !disabled &&
                                                inDisabledFieldset( elem ) === disabled;
                                    }

                                    return elem.disabled === disabled;

                                    // Try to winnow out elements that can't be disabled before trusting the disabled property.
                                    // Some victims get caught in our net (label, legend, menu, track), but it shouldn't
                                    // even exist on them, let alone have a boolean value.
                                } else if ( "label" in elem ) {
                                    return elem.disabled === disabled;
                                }

                                // Remaining elements are neither :enabled nor :disabled
                                return false;
                            };
                        }

                        /**
                         * Returns a function to use in pseudos for positionals
                         * @param {Function} fn
                         */
                        function createPositionalPseudo( fn ) {
                            return markFunction( function( argument ) {
                                argument = +argument;
                                return markFunction( function( seed, matches ) {
                                    var j,
                                            matchIndexes = fn( [], seed.length, argument ),
                                            i = matchIndexes.length;

                                    // Match elements found at the specified indexes
                                    while ( i-- ) {
                                        if ( seed[ ( j = matchIndexes[ i ] ) ] ) {
                                            seed[ j ] = !( matches[ j ] = seed[ j ] );
                                        }
                                    }
                                } );
                            } );
                        }

                        /**
                         * Checks a node for validity as a Sizzle context
                         * @param {Element|Object=} context
                         * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
                         */
                        function testContext( context ) {
                            return context && typeof context.getElementsByTagName !== "undefined" && context;
                        }

// Expose support vars for convenience
                        support = Sizzle.support = {};

                        /**
                         * Detects XML nodes
                         * @param {Element|Object} elem An element or a document
                         * @returns {Boolean} True iff elem is a non-HTML XML node
                         */
                        isXML = Sizzle.isXML = function( elem ) {
                            var namespace = elem.namespaceURI,
                                    docElem = ( elem.ownerDocument || elem ).documentElement;

                            // Support: IE <=8
                            // Assume HTML when documentElement doesn't yet exist, such as inside loading iframes
                            // https://bugs.jquery.com/ticket/4833
                            return !rhtml.test( namespace || docElem && docElem.nodeName || "HTML" );
                        };

                        /**
                         * Sets document-related variables once based on the current document
                         * @param {Element|Object} [doc] An element or document object to use to set the document
                         * @returns {Object} Returns the current document
                         */
                        setDocument = Sizzle.setDocument = function( node ) {
                            var hasCompare, subWindow,
                                    doc = node ? node.ownerDocument || node : preferredDoc;

                            // Return early if doc is invalid or already selected
                            // Support: IE 11+, Edge 17 - 18+
                            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                            // two documents; shallow comparisons work.
                            // eslint-disable-next-line eqeqeq
                            if ( doc == document || doc.nodeType !== 9 || !doc.documentElement ) {
                                return document;
                            }

                            // Update global variables
                            document = doc;
                            docElem = document.documentElement;
                            documentIsHTML = !isXML( document );

                            // Support: IE 9 - 11+, Edge 12 - 18+
                            // Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
                            // Support: IE 11+, Edge 17 - 18+
                            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                            // two documents; shallow comparisons work.
                            // eslint-disable-next-line eqeqeq
                            if ( preferredDoc != document &&
                                    ( subWindow = document.defaultView ) && subWindow.top !== subWindow ) {

                                // Support: IE 11, Edge
                                if ( subWindow.addEventListener ) {
                                    subWindow.addEventListener( "unload", unloadHandler, false );

                                    // Support: IE 9 - 10 only
                                } else if ( subWindow.attachEvent ) {
                                    subWindow.attachEvent( "onunload", unloadHandler );
                                }
                            }

                            // Support: IE 8 - 11+, Edge 12 - 18+, Chrome <=16 - 25 only, Firefox <=3.6 - 31 only,
                            // Safari 4 - 5 only, Opera <=11.6 - 12.x only
                            // IE/Edge & older browsers don't support the :scope pseudo-class.
                            // Support: Safari 6.0 only
                            // Safari 6.0 supports :scope but it's an alias of :root there.
                            support.scope = assert( function( el ) {
                                docElem.appendChild( el ).appendChild( document.createElement( "div" ) );
                                return typeof el.querySelectorAll !== "undefined" &&
                                        !el.querySelectorAll( ":scope fieldset div" ).length;
                            } );

                            /* Attributes
                             ---------------------------------------------------------------------- */

                            // Support: IE<8
                            // Verify that getAttribute really returns attributes and not properties
                            // (excepting IE8 booleans)
                            support.attributes = assert( function( el ) {
                                el.className = "i";
                                return !el.getAttribute( "className" );
                            } );

                            /* getElement(s)By*
                             ---------------------------------------------------------------------- */

                            // Check if getElementsByTagName("*") returns only elements
                            support.getElementsByTagName = assert( function( el ) {
                                el.appendChild( document.createComment( "" ) );
                                return !el.getElementsByTagName( "*" ).length;
                            } );

                            // Support: IE<9
                            support.getElementsByClassName = rnative.test( document.getElementsByClassName );

                            // Support: IE<10
                            // Check if getElementById returns elements by name
                            // The broken getElementById methods don't pick up programmatically-set names,
                            // so use a roundabout getElementsByName test
                            support.getById = assert( function( el ) {
                                docElem.appendChild( el ).id = expando;
                                return !document.getElementsByName || !document.getElementsByName( expando ).length;
                            } );

                            // ID filter and find
                            if ( support.getById ) {
                                Expr.filter[ "ID" ] = function( id ) {
                                    var attrId = id.replace( runescape, funescape );
                                    return function( elem ) {
                                        return elem.getAttribute( "id" ) === attrId;
                                    };
                                };
                                Expr.find[ "ID" ] = function( id, context ) {
                                    if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
                                        var elem = context.getElementById( id );
                                        return elem ? [ elem ] : [];
                                    }
                                };
                            } else {
                                Expr.filter[ "ID" ] =  function( id ) {
                                    var attrId = id.replace( runescape, funescape );
                                    return function( elem ) {
                                        var node = typeof elem.getAttributeNode !== "undefined" &&
                                                elem.getAttributeNode( "id" );
                                        return node && node.value === attrId;
                                    };
                                };

                                // Support: IE 6 - 7 only
                                // getElementById is not reliable as a find shortcut
                                Expr.find[ "ID" ] = function( id, context ) {
                                    if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
                                        var node, i, elems,
                                                elem = context.getElementById( id );

                                        if ( elem ) {

                                            // Verify the id attribute
                                            node = elem.getAttributeNode( "id" );
                                            if ( node && node.value === id ) {
                                                return [ elem ];
                                            }

                                            // Fall back on getElementsByName
                                            elems = context.getElementsByName( id );
                                            i = 0;
                                            while ( ( elem = elems[ i++ ] ) ) {
                                                node = elem.getAttributeNode( "id" );
                                                if ( node && node.value === id ) {
                                                    return [ elem ];
                                                }
                                            }
                                        }

                                        return [];
                                    }
                                };
                            }

                            // Tag
                            Expr.find[ "TAG" ] = support.getElementsByTagName ?
                                    function( tag, context ) {
                                        if ( typeof context.getElementsByTagName !== "undefined" ) {
                                            return context.getElementsByTagName( tag );

                                            // DocumentFragment nodes don't have gEBTN
                                        } else if ( support.qsa ) {
                                            return context.querySelectorAll( tag );
                                        }
                                    } :

                                    function( tag, context ) {
                                        var elem,
                                                tmp = [],
                                                i = 0,

                                        // By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
                                                results = context.getElementsByTagName( tag );

                                        // Filter out possible comments
                                        if ( tag === "*" ) {
                                            while ( ( elem = results[ i++ ] ) ) {
                                                if ( elem.nodeType === 1 ) {
                                                    tmp.push( elem );
                                                }
                                            }

                                            return tmp;
                                        }
                                        return results;
                                    };

                            // Class
                            Expr.find[ "CLASS" ] = support.getElementsByClassName && function( className, context ) {
                                        if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
                                            return context.getElementsByClassName( className );
                                        }
                                    };

                            /* QSA/matchesSelector
                             ---------------------------------------------------------------------- */

                            // QSA and matchesSelector support

                            // matchesSelector(:active) reports false when true (IE9/Opera 11.5)
                            rbuggyMatches = [];

                            // qSa(:focus) reports false when true (Chrome 21)
                            // We allow this because of a bug in IE8/9 that throws an error
                            // whenever `document.activeElement` is accessed on an iframe
                            // So, we allow :focus to pass through QSA all the time to avoid the IE error
                            // See https://bugs.jquery.com/ticket/13378
                            rbuggyQSA = [];

                            if ( ( support.qsa = rnative.test( document.querySelectorAll ) ) ) {

                                // Build QSA regex
                                // Regex strategy adopted from Diego Perini
                                assert( function( el ) {

                                    var input;

                                    // Select is set to empty string on purpose
                                    // This is to test IE's treatment of not explicitly
                                    // setting a boolean content attribute,
                                    // since its presence should be enough
                                    // https://bugs.jquery.com/ticket/12359
                                    docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
                                            "<select id='" + expando + "-\r\\' msallowcapture=''>" +
                                            "<option selected=''></option></select>";

                                    // Support: IE8, Opera 11-12.16
                                    // Nothing should be selected when empty strings follow ^= or $= or *=
                                    // The test attribute must be unknown in Opera but "safe" for WinRT
                                    // https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
                                    if ( el.querySelectorAll( "[msallowcapture^='']" ).length ) {
                                        rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
                                    }

                                    // Support: IE8
                                    // Boolean attributes and "value" are not treated correctly
                                    if ( !el.querySelectorAll( "[selected]" ).length ) {
                                        rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
                                    }

                                    // Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
                                    if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
                                        rbuggyQSA.push( "~=" );
                                    }

                                    // Support: IE 11+, Edge 15 - 18+
                                    // IE 11/Edge don't find elements on a `[name='']` query in some cases.
                                    // Adding a temporary attribute to the document before the selection works
                                    // around the issue.
                                    // Interestingly, IE 10 & older don't seem to have the issue.
                                    input = document.createElement( "input" );
                                    input.setAttribute( "name", "" );
                                    el.appendChild( input );
                                    if ( !el.querySelectorAll( "[name='']" ).length ) {
                                        rbuggyQSA.push( "\\[" + whitespace + "*name" + whitespace + "*=" +
                                                whitespace + "*(?:''|\"\")" );
                                    }

                                    // Webkit/Opera - :checked should return selected option elements
                                    // http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
                                    // IE8 throws error here and will not see later tests
                                    if ( !el.querySelectorAll( ":checked" ).length ) {
                                        rbuggyQSA.push( ":checked" );
                                    }

                                    // Support: Safari 8+, iOS 8+
                                    // https://bugs.webkit.org/show_bug.cgi?id=136851
                                    // In-page `selector#id sibling-combinator selector` fails
                                    if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
                                        rbuggyQSA.push( ".#.+[+~]" );
                                    }

                                    // Support: Firefox <=3.6 - 5 only
                                    // Old Firefox doesn't throw on a badly-escaped identifier.
                                    el.querySelectorAll( "\\\f" );
                                    rbuggyQSA.push( "[\\r\\n\\f]" );
                                } );

                                assert( function( el ) {
                                    el.innerHTML = "<a href='' disabled='disabled'></a>" +
                                            "<select disabled='disabled'><option/></select>";

                                    // Support: Windows 8 Native Apps
                                    // The type and name attributes are restricted during .innerHTML assignment
                                    var input = document.createElement( "input" );
                                    input.setAttribute( "type", "hidden" );
                                    el.appendChild( input ).setAttribute( "name", "D" );

                                    // Support: IE8
                                    // Enforce case-sensitivity of name attribute
                                    if ( el.querySelectorAll( "[name=d]" ).length ) {
                                        rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
                                    }

                                    // FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
                                    // IE8 throws error here and will not see later tests
                                    if ( el.querySelectorAll( ":enabled" ).length !== 2 ) {
                                        rbuggyQSA.push( ":enabled", ":disabled" );
                                    }

                                    // Support: IE9-11+
                                    // IE's :disabled selector does not pick up the children of disabled fieldsets
                                    docElem.appendChild( el ).disabled = true;
                                    if ( el.querySelectorAll( ":disabled" ).length !== 2 ) {
                                        rbuggyQSA.push( ":enabled", ":disabled" );
                                    }

                                    // Support: Opera 10 - 11 only
                                    // Opera 10-11 does not throw on post-comma invalid pseudos
                                    el.querySelectorAll( "*,:x" );
                                    rbuggyQSA.push( ",.*:" );
                                } );
                            }

                            if ( ( support.matchesSelector = rnative.test( ( matches = docElem.matches ||
                                            docElem.webkitMatchesSelector ||
                                            docElem.mozMatchesSelector ||
                                            docElem.oMatchesSelector ||
                                            docElem.msMatchesSelector ) ) ) ) {

                                assert( function( el ) {

                                    // Check to see if it's possible to do matchesSelector
                                    // on a disconnected node (IE 9)
                                    support.disconnectedMatch = matches.call( el, "*" );

                                    // This should fail with an exception
                                    // Gecko does not error, returns false instead
                                    matches.call( el, "[s!='']:x" );
                                    rbuggyMatches.push( "!=", pseudos );
                                } );
                            }

                            rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join( "|" ) );
                            rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join( "|" ) );

                            /* Contains
                             ---------------------------------------------------------------------- */
                            hasCompare = rnative.test( docElem.compareDocumentPosition );

                            // Element contains another
                            // Purposefully self-exclusive
                            // As in, an element does not contain itself
                            contains = hasCompare || rnative.test( docElem.contains ) ?
                                    function( a, b ) {
                                        var adown = a.nodeType === 9 ? a.documentElement : a,
                                                bup = b && b.parentNode;
                                        return a === bup || !!( bup && bup.nodeType === 1 && (
                                                        adown.contains ?
                                                                adown.contains( bup ) :
                                                        a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
                                                ) );
                                    } :
                                    function( a, b ) {
                                        if ( b ) {
                                            while ( ( b = b.parentNode ) ) {
                                                if ( b === a ) {
                                                    return true;
                                                }
                                            }
                                        }
                                        return false;
                                    };

                            /* Sorting
                             ---------------------------------------------------------------------- */

                            // Document order sorting
                            sortOrder = hasCompare ?
                                    function( a, b ) {

                                        // Flag for duplicate removal
                                        if ( a === b ) {
                                            hasDuplicate = true;
                                            return 0;
                                        }

                                        // Sort on method existence if only one input has compareDocumentPosition
                                        var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
                                        if ( compare ) {
                                            return compare;
                                        }

                                        // Calculate position if both inputs belong to the same document
                                        // Support: IE 11+, Edge 17 - 18+
                                        // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                                        // two documents; shallow comparisons work.
                                        // eslint-disable-next-line eqeqeq
                                        compare = ( a.ownerDocument || a ) == ( b.ownerDocument || b ) ?
                                                a.compareDocumentPosition( b ) :

                                                // Otherwise we know they are disconnected
                                                1;

                                        // Disconnected nodes
                                        if ( compare & 1 ||
                                                ( !support.sortDetached && b.compareDocumentPosition( a ) === compare ) ) {

                                            // Choose the first element that is related to our preferred document
                                            // Support: IE 11+, Edge 17 - 18+
                                            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                                            // two documents; shallow comparisons work.
                                            // eslint-disable-next-line eqeqeq
                                            if ( a == document || a.ownerDocument == preferredDoc &&
                                                    contains( preferredDoc, a ) ) {
                                                return -1;
                                            }

                                            // Support: IE 11+, Edge 17 - 18+
                                            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                                            // two documents; shallow comparisons work.
                                            // eslint-disable-next-line eqeqeq
                                            if ( b == document || b.ownerDocument == preferredDoc &&
                                                    contains( preferredDoc, b ) ) {
                                                return 1;
                                            }

                                            // Maintain original order
                                            return sortInput ?
                                                    ( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
                                                    0;
                                        }

                                        return compare & 4 ? -1 : 1;
                                    } :
                                    function( a, b ) {

                                        // Exit early if the nodes are identical
                                        if ( a === b ) {
                                            hasDuplicate = true;
                                            return 0;
                                        }

                                        var cur,
                                                i = 0,
                                                aup = a.parentNode,
                                                bup = b.parentNode,
                                                ap = [ a ],
                                                bp = [ b ];

                                        // Parentless nodes are either documents or disconnected
                                        if ( !aup || !bup ) {

                                            // Support: IE 11+, Edge 17 - 18+
                                            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                                            // two documents; shallow comparisons work.
                                            /* eslint-disable eqeqeq */
                                            return a == document ? -1 :
                                                    b == document ? 1 :
                                                            /* eslint-enable eqeqeq */
                                                            aup ? -1 :
                                                                    bup ? 1 :
                                                                            sortInput ?
                                                                                    ( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
                                                                                    0;

                                            // If the nodes are siblings, we can do a quick check
                                        } else if ( aup === bup ) {
                                            return siblingCheck( a, b );
                                        }

                                        // Otherwise we need full lists of their ancestors for comparison
                                        cur = a;
                                        while ( ( cur = cur.parentNode ) ) {
                                            ap.unshift( cur );
                                        }
                                        cur = b;
                                        while ( ( cur = cur.parentNode ) ) {
                                            bp.unshift( cur );
                                        }

                                        // Walk down the tree looking for a discrepancy
                                        while ( ap[ i ] === bp[ i ] ) {
                                            i++;
                                        }

                                        return i ?

                                                // Do a sibling check if the nodes have a common ancestor
                                                siblingCheck( ap[ i ], bp[ i ] ) :

                                                // Otherwise nodes in our document sort first
                                                // Support: IE 11+, Edge 17 - 18+
                                                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                                                // two documents; shallow comparisons work.
                                                /* eslint-disable eqeqeq */
                                                ap[ i ] == preferredDoc ? -1 :
                                                        bp[ i ] == preferredDoc ? 1 :
                                                                /* eslint-enable eqeqeq */
                                                                0;
                                    };

                            return document;
                        };

                        Sizzle.matches = function( expr, elements ) {
                            return Sizzle( expr, null, null, elements );
                        };

                        Sizzle.matchesSelector = function( elem, expr ) {
                            setDocument( elem );

                            if ( support.matchesSelector && documentIsHTML &&
                                    !nonnativeSelectorCache[ expr + " " ] &&
                                    ( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
                                    ( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {

                                try {
                                    var ret = matches.call( elem, expr );

                                    // IE 9's matchesSelector returns false on disconnected nodes
                                    if ( ret || support.disconnectedMatch ||

                                            // As well, disconnected nodes are said to be in a document
                                            // fragment in IE 9
                                            elem.document && elem.document.nodeType !== 11 ) {
                                        return ret;
                                    }
                                } catch ( e ) {
                                    nonnativeSelectorCache( expr, true );
                                }
                            }

                            return Sizzle( expr, document, null, [ elem ] ).length > 0;
                        };

                        Sizzle.contains = function( context, elem ) {

                            // Set document vars if needed
                            // Support: IE 11+, Edge 17 - 18+
                            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                            // two documents; shallow comparisons work.
                            // eslint-disable-next-line eqeqeq
                            if ( ( context.ownerDocument || context ) != document ) {
                                setDocument( context );
                            }
                            return contains( context, elem );
                        };

                        Sizzle.attr = function( elem, name ) {

                            // Set document vars if needed
                            // Support: IE 11+, Edge 17 - 18+
                            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                            // two documents; shallow comparisons work.
                            // eslint-disable-next-line eqeqeq
                            if ( ( elem.ownerDocument || elem ) != document ) {
                                setDocument( elem );
                            }

                            var fn = Expr.attrHandle[ name.toLowerCase() ],

                            // Don't get fooled by Object.prototype properties (jQuery #13807)
                                    val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
                                            fn( elem, name, !documentIsHTML ) :
                                            undefined;

                            return val !== undefined ?
                                    val :
                                    support.attributes || !documentIsHTML ?
                                            elem.getAttribute( name ) :
                                            ( val = elem.getAttributeNode( name ) ) && val.specified ?
                                                    val.value :
                                                    null;
                        };

                        Sizzle.escape = function( sel ) {
                            return ( sel + "" ).replace( rcssescape, fcssescape );
                        };

                        Sizzle.error = function( msg ) {
                            throw new Error( "Syntax error, unrecognized expression: " + msg );
                        };

                        /**
                         * Document sorting and removing duplicates
                         * @param {ArrayLike} results
                         */
                        Sizzle.uniqueSort = function( results ) {
                            var elem,
                                    duplicates = [],
                                    j = 0,
                                    i = 0;

                            // Unless we *know* we can detect duplicates, assume their presence
                            hasDuplicate = !support.detectDuplicates;
                            sortInput = !support.sortStable && results.slice( 0 );
                            results.sort( sortOrder );

                            if ( hasDuplicate ) {
                                while ( ( elem = results[ i++ ] ) ) {
                                    if ( elem === results[ i ] ) {
                                        j = duplicates.push( i );
                                    }
                                }
                                while ( j-- ) {
                                    results.splice( duplicates[ j ], 1 );
                                }
                            }

                            // Clear input after sorting to release objects
                            // See https://github.com/jquery/sizzle/pull/225
                            sortInput = null;

                            return results;
                        };

                        /**
                         * Utility function for retrieving the text value of an array of DOM nodes
                         * @param {Array|Element} elem
                         */
                        getText = Sizzle.getText = function( elem ) {
                            var node,
                                    ret = "",
                                    i = 0,
                                    nodeType = elem.nodeType;

                            if ( !nodeType ) {

                                // If no nodeType, this is expected to be an array
                                while ( ( node = elem[ i++ ] ) ) {

                                    // Do not traverse comment nodes
                                    ret += getText( node );
                                }
                            } else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {

                                // Use textContent for elements
                                // innerText usage removed for consistency of new lines (jQuery #11153)
                                if ( typeof elem.textContent === "string" ) {
                                    return elem.textContent;
                                } else {

                                    // Traverse its children
                                    for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
                                        ret += getText( elem );
                                    }
                                }
                            } else if ( nodeType === 3 || nodeType === 4 ) {
                                return elem.nodeValue;
                            }

                            // Do not include comment or processing instruction nodes

                            return ret;
                        };

                        Expr = Sizzle.selectors = {

                            // Can be adjusted by the user
                            cacheLength: 50,

                            createPseudo: markFunction,

                            match: matchExpr,

                            attrHandle: {},

                            find: {},

                            relative: {
                                ">": { dir: "parentNode", first: true },
                                " ": { dir: "parentNode" },
                                "+": { dir: "previousSibling", first: true },
                                "~": { dir: "previousSibling" }
                            },

                            preFilter: {
                                "ATTR": function( match ) {
                                    match[ 1 ] = match[ 1 ].replace( runescape, funescape );

                                    // Move the given value to match[3] whether quoted or unquoted
                                    match[ 3 ] = ( match[ 3 ] || match[ 4 ] ||
                                    match[ 5 ] || "" ).replace( runescape, funescape );

                                    if ( match[ 2 ] === "~=" ) {
                                        match[ 3 ] = " " + match[ 3 ] + " ";
                                    }

                                    return match.slice( 0, 4 );
                                },

                                "CHILD": function( match ) {

                                    /* matches from matchExpr["CHILD"]
                                     1 type (only|nth|...)
                                     2 what (child|of-type)
                                     3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
                                     4 xn-component of xn+y argument ([+-]?\d*n|)
                                     5 sign of xn-component
                                     6 x of xn-component
                                     7 sign of y-component
                                     8 y of y-component
                                     */
                                    match[ 1 ] = match[ 1 ].toLowerCase();

                                    if ( match[ 1 ].slice( 0, 3 ) === "nth" ) {

                                        // nth-* requires argument
                                        if ( !match[ 3 ] ) {
                                            Sizzle.error( match[ 0 ] );
                                        }

                                        // numeric x and y parameters for Expr.filter.CHILD
                                        // remember that false/true cast respectively to 0/1
                                        match[ 4 ] = +( match[ 4 ] ?
                                        match[ 5 ] + ( match[ 6 ] || 1 ) :
                                        2 * ( match[ 3 ] === "even" || match[ 3 ] === "odd" ) );
                                        match[ 5 ] = +( ( match[ 7 ] + match[ 8 ] ) || match[ 3 ] === "odd" );

                                        // other types prohibit arguments
                                    } else if ( match[ 3 ] ) {
                                        Sizzle.error( match[ 0 ] );
                                    }

                                    return match;
                                },

                                "PSEUDO": function( match ) {
                                    var excess,
                                            unquoted = !match[ 6 ] && match[ 2 ];

                                    if ( matchExpr[ "CHILD" ].test( match[ 0 ] ) ) {
                                        return null;
                                    }

                                    // Accept quoted arguments as-is
                                    if ( match[ 3 ] ) {
                                        match[ 2 ] = match[ 4 ] || match[ 5 ] || "";

                                        // Strip excess characters from unquoted arguments
                                    } else if ( unquoted && rpseudo.test( unquoted ) &&

                                            // Get excess from tokenize (recursively)
                                            ( excess = tokenize( unquoted, true ) ) &&

                                            // advance to the next closing parenthesis
                                            ( excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length ) ) {

                                        // excess is a negative index
                                        match[ 0 ] = match[ 0 ].slice( 0, excess );
                                        match[ 2 ] = unquoted.slice( 0, excess );
                                    }

                                    // Return only captures needed by the pseudo filter method (type and argument)
                                    return match.slice( 0, 3 );
                                }
                            },

                            filter: {

                                "TAG": function( nodeNameSelector ) {
                                    var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
                                    return nodeNameSelector === "*" ?
                                            function() {
                                                return true;
                                            } :
                                            function( elem ) {
                                                return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
                                            };
                                },

                                "CLASS": function( className ) {
                                    var pattern = classCache[ className + " " ];

                                    return pattern ||
                                            ( pattern = new RegExp( "(^|" + whitespace +
                                                    ")" + className + "(" + whitespace + "|$)" ) ) && classCache(
                                                    className, function( elem ) {
                                                        return pattern.test(
                                                                typeof elem.className === "string" && elem.className ||
                                                                typeof elem.getAttribute !== "undefined" &&
                                                                elem.getAttribute( "class" ) ||
                                                                ""
                                                        );
                                                    } );
                                },

                                "ATTR": function( name, operator, check ) {
                                    return function( elem ) {
                                        var result = Sizzle.attr( elem, name );

                                        if ( result == null ) {
                                            return operator === "!=";
                                        }
                                        if ( !operator ) {
                                            return true;
                                        }

                                        result += "";

                                        /* eslint-disable max-len */

                                        return operator === "=" ? result === check :
                                                operator === "!=" ? result !== check :
                                                        operator === "^=" ? check && result.indexOf( check ) === 0 :
                                                                operator === "*=" ? check && result.indexOf( check ) > -1 :
                                                                        operator === "$=" ? check && result.slice( -check.length ) === check :
                                                                                operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
                                                                                        operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
                                                                                                false;
                                        /* eslint-enable max-len */

                                    };
                                },

                                "CHILD": function( type, what, _argument, first, last ) {
                                    var simple = type.slice( 0, 3 ) !== "nth",
                                            forward = type.slice( -4 ) !== "last",
                                            ofType = what === "of-type";

                                    return first === 1 && last === 0 ?

                                            // Shortcut for :nth-*(n)
                                            function( elem ) {
                                                return !!elem.parentNode;
                                            } :

                                            function( elem, _context, xml ) {
                                                var cache, uniqueCache, outerCache, node, nodeIndex, start,
                                                        dir = simple !== forward ? "nextSibling" : "previousSibling",
                                                        parent = elem.parentNode,
                                                        name = ofType && elem.nodeName.toLowerCase(),
                                                        useCache = !xml && !ofType,
                                                        diff = false;

                                                if ( parent ) {

                                                    // :(first|last|only)-(child|of-type)
                                                    if ( simple ) {
                                                        while ( dir ) {
                                                            node = elem;
                                                            while ( ( node = node[ dir ] ) ) {
                                                                if ( ofType ?
                                                                        node.nodeName.toLowerCase() === name :
                                                                        node.nodeType === 1 ) {

                                                                    return false;
                                                                }
                                                            }

                                                            // Reverse direction for :only-* (if we haven't yet done so)
                                                            start = dir = type === "only" && !start && "nextSibling";
                                                        }
                                                        return true;
                                                    }

                                                    start = [ forward ? parent.firstChild : parent.lastChild ];

                                                    // non-xml :nth-child(...) stores cache data on `parent`
                                                    if ( forward && useCache ) {

                                                        // Seek `elem` from a previously-cached index

                                                        // ...in a gzip-friendly way
                                                        node = parent;
                                                        outerCache = node[ expando ] || ( node[ expando ] = {} );

                                                        // Support: IE <9 only
                                                        // Defend against cloned attroperties (jQuery gh-1709)
                                                        uniqueCache = outerCache[ node.uniqueID ] ||
                                                                ( outerCache[ node.uniqueID ] = {} );

                                                        cache = uniqueCache[ type ] || [];
                                                        nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
                                                        diff = nodeIndex && cache[ 2 ];
                                                        node = nodeIndex && parent.childNodes[ nodeIndex ];

                                                        while ( ( node = ++nodeIndex && node && node[ dir ] ||

                                                                // Fallback to seeking `elem` from the start
                                                                ( diff = nodeIndex = 0 ) || start.pop() ) ) {

                                                            // When found, cache indexes on `parent` and break
                                                            if ( node.nodeType === 1 && ++diff && node === elem ) {
                                                                uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
                                                                break;
                                                            }
                                                        }

                                                    } else {

                                                        // Use previously-cached element index if available
                                                        if ( useCache ) {

                                                            // ...in a gzip-friendly way
                                                            node = elem;
                                                            outerCache = node[ expando ] || ( node[ expando ] = {} );

                                                            // Support: IE <9 only
                                                            // Defend against cloned attroperties (jQuery gh-1709)
                                                            uniqueCache = outerCache[ node.uniqueID ] ||
                                                                    ( outerCache[ node.uniqueID ] = {} );

                                                            cache = uniqueCache[ type ] || [];
                                                            nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
                                                            diff = nodeIndex;
                                                        }

                                                        // xml :nth-child(...)
                                                        // or :nth-last-child(...) or :nth(-last)?-of-type(...)
                                                        if ( diff === false ) {

                                                            // Use the same loop as above to seek `elem` from the start
                                                            while ( ( node = ++nodeIndex && node && node[ dir ] ||
                                                                    ( diff = nodeIndex = 0 ) || start.pop() ) ) {

                                                                if ( ( ofType ?
                                                                        node.nodeName.toLowerCase() === name :
                                                                        node.nodeType === 1 ) &&
                                                                        ++diff ) {

                                                                    // Cache the index of each encountered element
                                                                    if ( useCache ) {
                                                                        outerCache = node[ expando ] ||
                                                                                ( node[ expando ] = {} );

                                                                        // Support: IE <9 only
                                                                        // Defend against cloned attroperties (jQuery gh-1709)
                                                                        uniqueCache = outerCache[ node.uniqueID ] ||
                                                                                ( outerCache[ node.uniqueID ] = {} );

                                                                        uniqueCache[ type ] = [ dirruns, diff ];
                                                                    }

                                                                    if ( node === elem ) {
                                                                        break;
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }

                                                    // Incorporate the offset, then check against cycle size
                                                    diff -= last;
                                                    return diff === first || ( diff % first === 0 && diff / first >= 0 );
                                                }
                                            };
                                },

                                "PSEUDO": function( pseudo, argument ) {

                                    // pseudo-class names are case-insensitive
                                    // http://www.w3.org/TR/selectors/#pseudo-classes
                                    // Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
                                    // Remember that setFilters inherits from pseudos
                                    var args,
                                            fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
                                                    Sizzle.error( "unsupported pseudo: " + pseudo );

                                    // The user may use createPseudo to indicate that
                                    // arguments are needed to create the filter function
                                    // just as Sizzle does
                                    if ( fn[ expando ] ) {
                                        return fn( argument );
                                    }

                                    // But maintain support for old signatures
                                    if ( fn.length > 1 ) {
                                        args = [ pseudo, pseudo, "", argument ];
                                        return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
                                                markFunction( function( seed, matches ) {
                                                    var idx,
                                                            matched = fn( seed, argument ),
                                                            i = matched.length;
                                                    while ( i-- ) {
                                                        idx = indexOf( seed, matched[ i ] );
                                                        seed[ idx ] = !( matches[ idx ] = matched[ i ] );
                                                    }
                                                } ) :
                                                function( elem ) {
                                                    return fn( elem, 0, args );
                                                };
                                    }

                                    return fn;
                                }
                            },

                            pseudos: {

                                // Potentially complex pseudos
                                "not": markFunction( function( selector ) {

                                    // Trim the selector passed to compile
                                    // to avoid treating leading and trailing
                                    // spaces as combinators
                                    var input = [],
                                            results = [],
                                            matcher = compile( selector.replace( rtrim, "$1" ) );

                                    return matcher[ expando ] ?
                                            markFunction( function( seed, matches, _context, xml ) {
                                                var elem,
                                                        unmatched = matcher( seed, null, xml, [] ),
                                                        i = seed.length;

                                                // Match elements unmatched by `matcher`
                                                while ( i-- ) {
                                                    if ( ( elem = unmatched[ i ] ) ) {
                                                        seed[ i ] = !( matches[ i ] = elem );
                                                    }
                                                }
                                            } ) :
                                            function( elem, _context, xml ) {
                                                input[ 0 ] = elem;
                                                matcher( input, null, xml, results );

                                                // Don't keep the element (issue #299)
                                                input[ 0 ] = null;
                                                return !results.pop();
                                            };
                                } ),

                                "has": markFunction( function( selector ) {
                                    return function( elem ) {
                                        return Sizzle( selector, elem ).length > 0;
                                    };
                                } ),

                                "contains": markFunction( function( text ) {
                                    text = text.replace( runescape, funescape );
                                    return function( elem ) {
                                        return ( elem.textContent || getText( elem ) ).indexOf( text ) > -1;
                                    };
                                } ),

                                // "Whether an element is represented by a :lang() selector
                                // is based solely on the element's language value
                                // being equal to the identifier C,
                                // or beginning with the identifier C immediately followed by "-".
                                // The matching of C against the element's language value is performed case-insensitively.
                                // The identifier C does not have to be a valid language name."
                                // http://www.w3.org/TR/selectors/#lang-pseudo
                                "lang": markFunction( function( lang ) {

                                    // lang value must be a valid identifier
                                    if ( !ridentifier.test( lang || "" ) ) {
                                        Sizzle.error( "unsupported lang: " + lang );
                                    }
                                    lang = lang.replace( runescape, funescape ).toLowerCase();
                                    return function( elem ) {
                                        var elemLang;
                                        do {
                                            if ( ( elemLang = documentIsHTML ?
                                                            elem.lang :
                                                    elem.getAttribute( "xml:lang" ) || elem.getAttribute( "lang" ) ) ) {

                                                elemLang = elemLang.toLowerCase();
                                                return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
                                            }
                                        } while ( ( elem = elem.parentNode ) && elem.nodeType === 1 );
                                        return false;
                                    };
                                } ),

                                // Miscellaneous
                                "target": function( elem ) {
                                    var hash = window.location && window.location.hash;
                                    return hash && hash.slice( 1 ) === elem.id;
                                },

                                "root": function( elem ) {
                                    return elem === docElem;
                                },

                                "focus": function( elem ) {
                                    return elem === document.activeElement &&
                                            ( !document.hasFocus || document.hasFocus() ) &&
                                            !!( elem.type || elem.href || ~elem.tabIndex );
                                },

                                // Boolean properties
                                "enabled": createDisabledPseudo( false ),
                                "disabled": createDisabledPseudo( true ),

                                "checked": function( elem ) {

                                    // In CSS3, :checked should return both checked and selected elements
                                    // http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
                                    var nodeName = elem.nodeName.toLowerCase();
                                    return ( nodeName === "input" && !!elem.checked ) ||
                                            ( nodeName === "option" && !!elem.selected );
                                },

                                "selected": function( elem ) {

                                    // Accessing this property makes selected-by-default
                                    // options in Safari work properly
                                    if ( elem.parentNode ) {
                                        // eslint-disable-next-line no-unused-expressions
                                        elem.parentNode.selectedIndex;
                                    }

                                    return elem.selected === true;
                                },

                                // Contents
                                "empty": function( elem ) {

                                    // http://www.w3.org/TR/selectors/#empty-pseudo
                                    // :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
                                    //   but not by others (comment: 8; processing instruction: 7; etc.)
                                    // nodeType < 6 works because attributes (2) do not appear as children
                                    for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
                                        if ( elem.nodeType < 6 ) {
                                            return false;
                                        }
                                    }
                                    return true;
                                },

                                "parent": function( elem ) {
                                    return !Expr.pseudos[ "empty" ]( elem );
                                },

                                // Element/input types
                                "header": function( elem ) {
                                    return rheader.test( elem.nodeName );
                                },

                                "input": function( elem ) {
                                    return rinputs.test( elem.nodeName );
                                },

                                "button": function( elem ) {
                                    var name = elem.nodeName.toLowerCase();
                                    return name === "input" && elem.type === "button" || name === "button";
                                },

                                "text": function( elem ) {
                                    var attr;
                                    return elem.nodeName.toLowerCase() === "input" &&
                                            elem.type === "text" &&

                                            // Support: IE<8
                                            // New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
                                            ( ( attr = elem.getAttribute( "type" ) ) == null ||
                                            attr.toLowerCase() === "text" );
                                },

                                // Position-in-collection
                                "first": createPositionalPseudo( function() {
                                    return [ 0 ];
                                } ),

                                "last": createPositionalPseudo( function( _matchIndexes, length ) {
                                    return [ length - 1 ];
                                } ),

                                "eq": createPositionalPseudo( function( _matchIndexes, length, argument ) {
                                    return [ argument < 0 ? argument + length : argument ];
                                } ),

                                "even": createPositionalPseudo( function( matchIndexes, length ) {
                                    var i = 0;
                                    for ( ; i < length; i += 2 ) {
                                        matchIndexes.push( i );
                                    }
                                    return matchIndexes;
                                } ),

                                "odd": createPositionalPseudo( function( matchIndexes, length ) {
                                    var i = 1;
                                    for ( ; i < length; i += 2 ) {
                                        matchIndexes.push( i );
                                    }
                                    return matchIndexes;
                                } ),

                                "lt": createPositionalPseudo( function( matchIndexes, length, argument ) {
                                    var i = argument < 0 ?
                                    argument + length :
                                            argument > length ?
                                                    length :
                                                    argument;
                                    for ( ; --i >= 0; ) {
                                        matchIndexes.push( i );
                                    }
                                    return matchIndexes;
                                } ),

                                "gt": createPositionalPseudo( function( matchIndexes, length, argument ) {
                                    var i = argument < 0 ? argument + length : argument;
                                    for ( ; ++i < length; ) {
                                        matchIndexes.push( i );
                                    }
                                    return matchIndexes;
                                } )
                            }
                        };

                        Expr.pseudos[ "nth" ] = Expr.pseudos[ "eq" ];

// Add button/input type pseudos
                        for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
                            Expr.pseudos[ i ] = createInputPseudo( i );
                        }
                        for ( i in { submit: true, reset: true } ) {
                            Expr.pseudos[ i ] = createButtonPseudo( i );
                        }

// Easy API for creating new setFilters
                        function setFilters() {}
                        setFilters.prototype = Expr.filters = Expr.pseudos;
                        Expr.setFilters = new setFilters();

                        tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
                            var matched, match, tokens, type,
                                    soFar, groups, preFilters,
                                    cached = tokenCache[ selector + " " ];

                            if ( cached ) {
                                return parseOnly ? 0 : cached.slice( 0 );
                            }

                            soFar = selector;
                            groups = [];
                            preFilters = Expr.preFilter;

                            while ( soFar ) {

                                // Comma and first run
                                if ( !matched || ( match = rcomma.exec( soFar ) ) ) {
                                    if ( match ) {

                                        // Don't consume trailing commas as valid
                                        soFar = soFar.slice( match[ 0 ].length ) || soFar;
                                    }
                                    groups.push( ( tokens = [] ) );
                                }

                                matched = false;

                                // Combinators
                                if ( ( match = rcombinators.exec( soFar ) ) ) {
                                    matched = match.shift();
                                    tokens.push( {
                                        value: matched,

                                        // Cast descendant combinators to space
                                        type: match[ 0 ].replace( rtrim, " " )
                                    } );
                                    soFar = soFar.slice( matched.length );
                                }

                                // Filters
                                for ( type in Expr.filter ) {
                                    if ( ( match = matchExpr[ type ].exec( soFar ) ) && ( !preFilters[ type ] ||
                                            ( match = preFilters[ type ]( match ) ) ) ) {
                                        matched = match.shift();
                                        tokens.push( {
                                            value: matched,
                                            type: type,
                                            matches: match
                                        } );
                                        soFar = soFar.slice( matched.length );
                                    }
                                }

                                if ( !matched ) {
                                    break;
                                }
                            }

                            // Return the length of the invalid excess
                            // if we're just parsing
                            // Otherwise, throw an error or return tokens
                            return parseOnly ?
                                    soFar.length :
                                    soFar ?
                                            Sizzle.error( selector ) :

                                            // Cache the tokens
                                            tokenCache( selector, groups ).slice( 0 );
                        };

                        function toSelector( tokens ) {
                            var i = 0,
                                    len = tokens.length,
                                    selector = "";
                            for ( ; i < len; i++ ) {
                                selector += tokens[ i ].value;
                            }
                            return selector;
                        }

                        function addCombinator( matcher, combinator, base ) {
                            var dir = combinator.dir,
                                    skip = combinator.next,
                                    key = skip || dir,
                                    checkNonElements = base && key === "parentNode",
                                    doneName = done++;

                            return combinator.first ?

                                    // Check against closest ancestor/preceding element
                                    function( elem, context, xml ) {
                                        while ( ( elem = elem[ dir ] ) ) {
                                            if ( elem.nodeType === 1 || checkNonElements ) {
                                                return matcher( elem, context, xml );
                                            }
                                        }
                                        return false;
                                    } :

                                    // Check against all ancestor/preceding elements
                                    function( elem, context, xml ) {
                                        var oldCache, uniqueCache, outerCache,
                                                newCache = [ dirruns, doneName ];

                                        // We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
                                        if ( xml ) {
                                            while ( ( elem = elem[ dir ] ) ) {
                                                if ( elem.nodeType === 1 || checkNonElements ) {
                                                    if ( matcher( elem, context, xml ) ) {
                                                        return true;
                                                    }
                                                }
                                            }
                                        } else {
                                            while ( ( elem = elem[ dir ] ) ) {
                                                if ( elem.nodeType === 1 || checkNonElements ) {
                                                    outerCache = elem[ expando ] || ( elem[ expando ] = {} );

                                                    // Support: IE <9 only
                                                    // Defend against cloned attroperties (jQuery gh-1709)
                                                    uniqueCache = outerCache[ elem.uniqueID ] ||
                                                            ( outerCache[ elem.uniqueID ] = {} );

                                                    if ( skip && skip === elem.nodeName.toLowerCase() ) {
                                                        elem = elem[ dir ] || elem;
                                                    } else if ( ( oldCache = uniqueCache[ key ] ) &&
                                                            oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

                                                        // Assign to newCache so results back-propagate to previous elements
                                                        return ( newCache[ 2 ] = oldCache[ 2 ] );
                                                    } else {

                                                        // Reuse newcache so results back-propagate to previous elements
                                                        uniqueCache[ key ] = newCache;

                                                        // A match means we're done; a fail means we have to keep checking
                                                        if ( ( newCache[ 2 ] = matcher( elem, context, xml ) ) ) {
                                                            return true;
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                        return false;
                                    };
                        }

                        function elementMatcher( matchers ) {
                            return matchers.length > 1 ?
                                    function( elem, context, xml ) {
                                        var i = matchers.length;
                                        while ( i-- ) {
                                            if ( !matchers[ i ]( elem, context, xml ) ) {
                                                return false;
                                            }
                                        }
                                        return true;
                                    } :
                                    matchers[ 0 ];
                        }

                        function multipleContexts( selector, contexts, results ) {
                            var i = 0,
                                    len = contexts.length;
                            for ( ; i < len; i++ ) {
                                Sizzle( selector, contexts[ i ], results );
                            }
                            return results;
                        }

                        function condense( unmatched, map, filter, context, xml ) {
                            var elem,
                                    newUnmatched = [],
                                    i = 0,
                                    len = unmatched.length,
                                    mapped = map != null;

                            for ( ; i < len; i++ ) {
                                if ( ( elem = unmatched[ i ] ) ) {
                                    if ( !filter || filter( elem, context, xml ) ) {
                                        newUnmatched.push( elem );
                                        if ( mapped ) {
                                            map.push( i );
                                        }
                                    }
                                }
                            }

                            return newUnmatched;
                        }

                        function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
                            if ( postFilter && !postFilter[ expando ] ) {
                                postFilter = setMatcher( postFilter );
                            }
                            if ( postFinder && !postFinder[ expando ] ) {
                                postFinder = setMatcher( postFinder, postSelector );
                            }
                            return markFunction( function( seed, results, context, xml ) {
                                var temp, i, elem,
                                        preMap = [],
                                        postMap = [],
                                        preexisting = results.length,

                                // Get initial elements from seed or context
                                        elems = seed || multipleContexts(
                                                        selector || "*",
                                                        context.nodeType ? [ context ] : context,
                                                        []
                                                ),

                                // Prefilter to get matcher input, preserving a map for seed-results synchronization
                                        matcherIn = preFilter && ( seed || !selector ) ?
                                                condense( elems, preMap, preFilter, context, xml ) :
                                                elems,

                                        matcherOut = matcher ?

                                                // If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
                                                postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

                                                        // ...intermediate processing is necessary
                                                        [] :

                                                        // ...otherwise use results directly
                                                        results :
                                                matcherIn;

                                // Find primary matches
                                if ( matcher ) {
                                    matcher( matcherIn, matcherOut, context, xml );
                                }

                                // Apply postFilter
                                if ( postFilter ) {
                                    temp = condense( matcherOut, postMap );
                                    postFilter( temp, [], context, xml );

                                    // Un-match failing elements by moving them back to matcherIn
                                    i = temp.length;
                                    while ( i-- ) {
                                        if ( ( elem = temp[ i ] ) ) {
                                            matcherOut[ postMap[ i ] ] = !( matcherIn[ postMap[ i ] ] = elem );
                                        }
                                    }
                                }

                                if ( seed ) {
                                    if ( postFinder || preFilter ) {
                                        if ( postFinder ) {

                                            // Get the final matcherOut by condensing this intermediate into postFinder contexts
                                            temp = [];
                                            i = matcherOut.length;
                                            while ( i-- ) {
                                                if ( ( elem = matcherOut[ i ] ) ) {

                                                    // Restore matcherIn since elem is not yet a final match
                                                    temp.push( ( matcherIn[ i ] = elem ) );
                                                }
                                            }
                                            postFinder( null, ( matcherOut = [] ), temp, xml );
                                        }

                                        // Move matched elements from seed to results to keep them synchronized
                                        i = matcherOut.length;
                                        while ( i-- ) {
                                            if ( ( elem = matcherOut[ i ] ) &&
                                                    ( temp = postFinder ? indexOf( seed, elem ) : preMap[ i ] ) > -1 ) {

                                                seed[ temp ] = !( results[ temp ] = elem );
                                            }
                                        }
                                    }

                                    // Add elements to results, through postFinder if defined
                                } else {
                                    matcherOut = condense(
                                            matcherOut === results ?
                                                    matcherOut.splice( preexisting, matcherOut.length ) :
                                                    matcherOut
                                    );
                                    if ( postFinder ) {
                                        postFinder( null, results, matcherOut, xml );
                                    } else {
                                        push.apply( results, matcherOut );
                                    }
                                }
                            } );
                        }

                        function matcherFromTokens( tokens ) {
                            var checkContext, matcher, j,
                                    len = tokens.length,
                                    leadingRelative = Expr.relative[ tokens[ 0 ].type ],
                                    implicitRelative = leadingRelative || Expr.relative[ " " ],
                                    i = leadingRelative ? 1 : 0,

                            // The foundational matcher ensures that elements are reachable from top-level context(s)
                                    matchContext = addCombinator( function( elem ) {
                                        return elem === checkContext;
                                    }, implicitRelative, true ),
                                    matchAnyContext = addCombinator( function( elem ) {
                                        return indexOf( checkContext, elem ) > -1;
                                    }, implicitRelative, true ),
                                    matchers = [ function( elem, context, xml ) {
                                        var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
                                                        ( checkContext = context ).nodeType ?
                                                                matchContext( elem, context, xml ) :
                                                                matchAnyContext( elem, context, xml ) );

                                        // Avoid hanging onto element (issue #299)
                                        checkContext = null;
                                        return ret;
                                    } ];

                            for ( ; i < len; i++ ) {
                                if ( ( matcher = Expr.relative[ tokens[ i ].type ] ) ) {
                                    matchers = [ addCombinator( elementMatcher( matchers ), matcher ) ];
                                } else {
                                    matcher = Expr.filter[ tokens[ i ].type ].apply( null, tokens[ i ].matches );

                                    // Return special upon seeing a positional matcher
                                    if ( matcher[ expando ] ) {

                                        // Find the next relative operator (if any) for proper handling
                                        j = ++i;
                                        for ( ; j < len; j++ ) {
                                            if ( Expr.relative[ tokens[ j ].type ] ) {
                                                break;
                                            }
                                        }
                                        return setMatcher(
                                                i > 1 && elementMatcher( matchers ),
                                                i > 1 && toSelector(

                                                        // If the preceding token was a descendant combinator, insert an implicit any-element `*`
                                                        tokens
                                                                .slice( 0, i - 1 )
                                                                .concat( { value: tokens[ i - 2 ].type === " " ? "*" : "" } )
                                                ).replace( rtrim, "$1" ),
                                                matcher,
                                                i < j && matcherFromTokens( tokens.slice( i, j ) ),
                                                j < len && matcherFromTokens( ( tokens = tokens.slice( j ) ) ),
                                                j < len && toSelector( tokens )
                                        );
                                    }
                                    matchers.push( matcher );
                                }
                            }

                            return elementMatcher( matchers );
                        }

                        function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
                            var bySet = setMatchers.length > 0,
                                    byElement = elementMatchers.length > 0,
                                    superMatcher = function( seed, context, xml, results, outermost ) {
                                        var elem, j, matcher,
                                                matchedCount = 0,
                                                i = "0",
                                                unmatched = seed && [],
                                                setMatched = [],
                                                contextBackup = outermostContext,

                                        // We must always have either seed elements or outermost context
                                                elems = seed || byElement && Expr.find[ "TAG" ]( "*", outermost ),

                                        // Use integer dirruns iff this is the outermost matcher
                                                dirrunsUnique = ( dirruns += contextBackup == null ? 1 : Math.random() || 0.1 ),
                                                len = elems.length;

                                        if ( outermost ) {

                                            // Support: IE 11+, Edge 17 - 18+
                                            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                                            // two documents; shallow comparisons work.
                                            // eslint-disable-next-line eqeqeq
                                            outermostContext = context == document || context || outermost;
                                        }

                                        // Add elements passing elementMatchers directly to results
                                        // Support: IE<9, Safari
                                        // Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
                                        for ( ; i !== len && ( elem = elems[ i ] ) != null; i++ ) {
                                            if ( byElement && elem ) {
                                                j = 0;

                                                // Support: IE 11+, Edge 17 - 18+
                                                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                                                // two documents; shallow comparisons work.
                                                // eslint-disable-next-line eqeqeq
                                                if ( !context && elem.ownerDocument != document ) {
                                                    setDocument( elem );
                                                    xml = !documentIsHTML;
                                                }
                                                while ( ( matcher = elementMatchers[ j++ ] ) ) {
                                                    if ( matcher( elem, context || document, xml ) ) {
                                                        results.push( elem );
                                                        break;
                                                    }
                                                }
                                                if ( outermost ) {
                                                    dirruns = dirrunsUnique;
                                                }
                                            }

                                            // Track unmatched elements for set filters
                                            if ( bySet ) {

                                                // They will have gone through all possible matchers
                                                if ( ( elem = !matcher && elem ) ) {
                                                    matchedCount--;
                                                }

                                                // Lengthen the array for every element, matched or not
                                                if ( seed ) {
                                                    unmatched.push( elem );
                                                }
                                            }
                                        }

                                        // `i` is now the count of elements visited above, and adding it to `matchedCount`
                                        // makes the latter nonnegative.
                                        matchedCount += i;

                                        // Apply set filters to unmatched elements
                                        // NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
                                        // equals `i`), unless we didn't visit _any_ elements in the above loop because we have
                                        // no element matchers and no seed.
                                        // Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
                                        // case, which will result in a "00" `matchedCount` that differs from `i` but is also
                                        // numerically zero.
                                        if ( bySet && i !== matchedCount ) {
                                            j = 0;
                                            while ( ( matcher = setMatchers[ j++ ] ) ) {
                                                matcher( unmatched, setMatched, context, xml );
                                            }

                                            if ( seed ) {

                                                // Reintegrate element matches to eliminate the need for sorting
                                                if ( matchedCount > 0 ) {
                                                    while ( i-- ) {
                                                        if ( !( unmatched[ i ] || setMatched[ i ] ) ) {
                                                            setMatched[ i ] = pop.call( results );
                                                        }
                                                    }
                                                }

                                                // Discard index placeholder values to get only actual matches
                                                setMatched = condense( setMatched );
                                            }

                                            // Add matches to results
                                            push.apply( results, setMatched );

                                            // Seedless set matches succeeding multiple successful matchers stipulate sorting
                                            if ( outermost && !seed && setMatched.length > 0 &&
                                                    ( matchedCount + setMatchers.length ) > 1 ) {

                                                Sizzle.uniqueSort( results );
                                            }
                                        }

                                        // Override manipulation of globals by nested matchers
                                        if ( outermost ) {
                                            dirruns = dirrunsUnique;
                                            outermostContext = contextBackup;
                                        }

                                        return unmatched;
                                    };

                            return bySet ?
                                    markFunction( superMatcher ) :
                                    superMatcher;
                        }

                        compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
                            var i,
                                    setMatchers = [],
                                    elementMatchers = [],
                                    cached = compilerCache[ selector + " " ];

                            if ( !cached ) {

                                // Generate a function of recursive functions that can be used to check each element
                                if ( !match ) {
                                    match = tokenize( selector );
                                }
                                i = match.length;
                                while ( i-- ) {
                                    cached = matcherFromTokens( match[ i ] );
                                    if ( cached[ expando ] ) {
                                        setMatchers.push( cached );
                                    } else {
                                        elementMatchers.push( cached );
                                    }
                                }

                                // Cache the compiled function
                                cached = compilerCache(
                                        selector,
                                        matcherFromGroupMatchers( elementMatchers, setMatchers )
                                );

                                // Save selector and tokenization
                                cached.selector = selector;
                            }
                            return cached;
                        };

                        /**
                         * A low-level selection function that works with Sizzle's compiled
                         *  selector functions
                         * @param {String|Function} selector A selector or a pre-compiled
                         *  selector function built with Sizzle.compile
                         * @param {Element} context
                         * @param {Array} [results]
                         * @param {Array} [seed] A set of elements to match against
                         */
                        select = Sizzle.select = function( selector, context, results, seed ) {
                            var i, tokens, token, type, find,
                                    compiled = typeof selector === "function" && selector,
                                    match = !seed && tokenize( ( selector = compiled.selector || selector ) );

                            results = results || [];

                            // Try to minimize operations if there is only one selector in the list and no seed
                            // (the latter of which guarantees us context)
                            if ( match.length === 1 ) {

                                // Reduce context if the leading compound selector is an ID
                                tokens = match[ 0 ] = match[ 0 ].slice( 0 );
                                if ( tokens.length > 2 && ( token = tokens[ 0 ] ).type === "ID" &&
                                        context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[ 1 ].type ] ) {

                                    context = ( Expr.find[ "ID" ]( token.matches[ 0 ]
                                            .replace( runescape, funescape ), context ) || [] )[ 0 ];
                                    if ( !context ) {
                                        return results;

                                        // Precompiled matchers will still verify ancestry, so step up a level
                                    } else if ( compiled ) {
                                        context = context.parentNode;
                                    }

                                    selector = selector.slice( tokens.shift().value.length );
                                }

                                // Fetch a seed set for right-to-left matching
                                i = matchExpr[ "needsContext" ].test( selector ) ? 0 : tokens.length;
                                while ( i-- ) {
                                    token = tokens[ i ];

                                    // Abort if we hit a combinator
                                    if ( Expr.relative[ ( type = token.type ) ] ) {
                                        break;
                                    }
                                    if ( ( find = Expr.find[ type ] ) ) {

                                        // Search, expanding context for leading sibling combinators
                                        if ( ( seed = find(
                                                        token.matches[ 0 ].replace( runescape, funescape ),
                                                        rsibling.test( tokens[ 0 ].type ) && testContext( context.parentNode ) ||
                                                        context
                                                ) ) ) {

                                            // If seed is empty or no tokens remain, we can return early
                                            tokens.splice( i, 1 );
                                            selector = seed.length && toSelector( tokens );
                                            if ( !selector ) {
                                                push.apply( results, seed );
                                                return results;
                                            }

                                            break;
                                        }
                                    }
                                }
                            }

                            // Compile and execute a filtering function if one is not provided
                            // Provide `match` to avoid retokenization if we modified the selector above
                            ( compiled || compile( selector, match ) )(
                                    seed,
                                    context,
                                    !documentIsHTML,
                                    results,
                                    !context || rsibling.test( selector ) && testContext( context.parentNode ) || context
                            );
                            return results;
                        };

// One-time assignments

// Sort stability
                        support.sortStable = expando.split( "" ).sort( sortOrder ).join( "" ) === expando;

// Support: Chrome 14-35+
// Always assume duplicates if they aren't passed to the comparison function
                        support.detectDuplicates = !!hasDuplicate;

// Initialize against the default document
                        setDocument();

// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
// Detached nodes confoundingly follow *each other*
                        support.sortDetached = assert( function( el ) {

                            // Should return 1, but returns 4 (following)
                            return el.compareDocumentPosition( document.createElement( "fieldset" ) ) & 1;
                        } );

// Support: IE<8
// Prevent attribute/property "interpolation"
// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
                        if ( !assert( function( el ) {
                                    el.innerHTML = "<a href='#'></a>";
                                    return el.firstChild.getAttribute( "href" ) === "#";
                                } ) ) {
                            addHandle( "type|href|height|width", function( elem, name, isXML ) {
                                if ( !isXML ) {
                                    return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
                                }
                            } );
                        }

// Support: IE<9
// Use defaultValue in place of getAttribute("value")
                        if ( !support.attributes || !assert( function( el ) {
                                    el.innerHTML = "<input/>";
                                    el.firstChild.setAttribute( "value", "" );
                                    return el.firstChild.getAttribute( "value" ) === "";
                                } ) ) {
                            addHandle( "value", function( elem, _name, isXML ) {
                                if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
                                    return elem.defaultValue;
                                }
                            } );
                        }

// Support: IE<9
// Use getAttributeNode to fetch booleans when getAttribute lies
                        if ( !assert( function( el ) {
                                    return el.getAttribute( "disabled" ) == null;
                                } ) ) {
                            addHandle( booleans, function( elem, name, isXML ) {
                                var val;
                                if ( !isXML ) {
                                    return elem[ name ] === true ? name.toLowerCase() :
                                            ( val = elem.getAttributeNode( name ) ) && val.specified ?
                                                    val.value :
                                                    null;
                                }
                            } );
                        }

                        return Sizzle;

                    } )( window );



            jQuery.find = Sizzle;
            jQuery.expr = Sizzle.selectors;

// Deprecated
            jQuery.expr[ ":" ] = jQuery.expr.pseudos;
            jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
            jQuery.text = Sizzle.getText;
            jQuery.isXMLDoc = Sizzle.isXML;
            jQuery.contains = Sizzle.contains;
            jQuery.escapeSelector = Sizzle.escape;




            var dir = function( elem, dir, until ) {
                var matched = [],
                        truncate = until !== undefined;

                while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
                    if ( elem.nodeType === 1 ) {
                        if ( truncate && jQuery( elem ).is( until ) ) {
                            break;
                        }
                        matched.push( elem );
                    }
                }
                return matched;
            };


            var siblings = function( n, elem ) {
                var matched = [];

                for ( ; n; n = n.nextSibling ) {
                    if ( n.nodeType === 1 && n !== elem ) {
                        matched.push( n );
                    }
                }

                return matched;
            };


            var rneedsContext = jQuery.expr.match.needsContext;



            function nodeName( elem, name ) {

                return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();

            };
            var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );



// Implement the identical functionality for filter and not
            function winnow( elements, qualifier, not ) {
                if ( isFunction( qualifier ) ) {
                    return jQuery.grep( elements, function( elem, i ) {
                        return !!qualifier.call( elem, i, elem ) !== not;
                    } );
                }

                // Single element
                if ( qualifier.nodeType ) {
                    return jQuery.grep( elements, function( elem ) {
                        return ( elem === qualifier ) !== not;
                    } );
                }

                // Arraylike of elements (jQuery, arguments, Array)
                if ( typeof qualifier !== "string" ) {
                    return jQuery.grep( elements, function( elem ) {
                        return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
                    } );
                }

                // Filtered directly for both simple and complex selectors
                return jQuery.filter( qualifier, elements, not );
            }

            jQuery.filter = function( expr, elems, not ) {
                var elem = elems[ 0 ];

                if ( not ) {
                    expr = ":not(" + expr + ")";
                }

                if ( elems.length === 1 && elem.nodeType === 1 ) {
                    return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
                }

                return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
                    return elem.nodeType === 1;
                } ) );
            };

            jQuery.fn.extend( {
                find: function( selector ) {
                    var i, ret,
                            len = this.length,
                            self = this;

                    if ( typeof selector !== "string" ) {
                        return this.pushStack( jQuery( selector ).filter( function() {
                            for ( i = 0; i < len; i++ ) {
                                if ( jQuery.contains( self[ i ], this ) ) {
                                    return true;
                                }
                            }
                        } ) );
                    }

                    ret = this.pushStack( [] );

                    for ( i = 0; i < len; i++ ) {
                        jQuery.find( selector, self[ i ], ret );
                    }

                    return len > 1 ? jQuery.uniqueSort( ret ) : ret;
                },
                filter: function( selector ) {
                    return this.pushStack( winnow( this, selector || [], false ) );
                },
                not: function( selector ) {
                    return this.pushStack( winnow( this, selector || [], true ) );
                },
                is: function( selector ) {
                    return !!winnow(
                            this,

                            // If this is a positional/relative selector, check membership in the returned set
                            // so $("p:first").is("p:last") won't return true for a doc with two "p".
                            typeof selector === "string" && rneedsContext.test( selector ) ?
                                    jQuery( selector ) :
                            selector || [],
                            false
                    ).length;
                }
            } );


// Initialize a jQuery object


// A central reference to the root jQuery(document)
            var rootjQuery,

            // A simple way to check for HTML strings
            // Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
            // Strict HTML recognition (#11290: must start with <)
            // Shortcut simple #id case for speed
                    rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,

                    init = jQuery.fn.init = function( selector, context, root ) {
                        var match, elem;

                        // HANDLE: $(""), $(null), $(undefined), $(false)
                        if ( !selector ) {
                            return this;
                        }

                        // Method init() accepts an alternate rootjQuery
                        // so migrate can support jQuery.sub (gh-2101)
                        root = root || rootjQuery;

                        // Handle HTML strings
                        if ( typeof selector === "string" ) {
                            if ( selector[ 0 ] === "<" &&
                                    selector[ selector.length - 1 ] === ">" &&
                                    selector.length >= 3 ) {

                                // Assume that strings that start and end with <> are HTML and skip the regex check
                                match = [ null, selector, null ];

                            } else {
                                match = rquickExpr.exec( selector );
                            }

                            // Match html or make sure no context is specified for #id
                            if ( match && ( match[ 1 ] || !context ) ) {

                                // HANDLE: $(html) -> $(array)
                                if ( match[ 1 ] ) {
                                    context = context instanceof jQuery ? context[ 0 ] : context;

                                    // Option to run scripts is true for back-compat
                                    // Intentionally let the error be thrown if parseHTML is not present
                                    jQuery.merge( this, jQuery.parseHTML(
                                            match[ 1 ],
                                            context && context.nodeType ? context.ownerDocument || context : document,
                                            true
                                    ) );

                                    // HANDLE: $(html, props)
                                    if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
                                        for ( match in context ) {

                                            // Properties of context are called as methods if possible
                                            if ( isFunction( this[ match ] ) ) {
                                                this[ match ]( context[ match ] );

                                                // ...and otherwise set as attributes
                                            } else {
                                                this.attr( match, context[ match ] );
                                            }
                                        }
                                    }

                                    return this;

                                    // HANDLE: $(#id)
                                } else {
                                    elem = document.getElementById( match[ 2 ] );

                                    if ( elem ) {

                                        // Inject the element directly into the jQuery object
                                        this[ 0 ] = elem;
                                        this.length = 1;
                                    }
                                    return this;
                                }

                                // HANDLE: $(expr, $(...))
                            } else if ( !context || context.jquery ) {
                                return ( context || root ).find( selector );

                                // HANDLE: $(expr, context)
                                // (which is just equivalent to: $(context).find(expr)
                            } else {
                                return this.constructor( context ).find( selector );
                            }

                            // HANDLE: $(DOMElement)
                        } else if ( selector.nodeType ) {
                            this[ 0 ] = selector;
                            this.length = 1;
                            return this;

                            // HANDLE: $(function)
                            // Shortcut for document ready
                        } else if ( isFunction( selector ) ) {
                            return root.ready !== undefined ?
                                    root.ready( selector ) :

                                    // Execute immediately if ready is not present
                                    selector( jQuery );
                        }

                        return jQuery.makeArray( selector, this );
                    };

// Give the init function the jQuery prototype for later instantiation
            init.prototype = jQuery.fn;

// Initialize central reference
            rootjQuery = jQuery( document );


            var rparentsprev = /^(?:parents|prev(?:Until|All))/,

            // Methods guaranteed to produce a unique set when starting from a unique set
                    guaranteedUnique = {
                        children: true,
                        contents: true,
                        next: true,
                        prev: true
                    };

            jQuery.fn.extend( {
                has: function( target ) {
                    var targets = jQuery( target, this ),
                            l = targets.length;

                    return this.filter( function() {
                        var i = 0;
                        for ( ; i < l; i++ ) {
                            if ( jQuery.contains( this, targets[ i ] ) ) {
                                return true;
                            }
                        }
                    } );
                },

                closest: function( selectors, context ) {
                    var cur,
                            i = 0,
                            l = this.length,
                            matched = [],
                            targets = typeof selectors !== "string" && jQuery( selectors );

                    // Positional selectors never match, since there's no _selection_ context
                    if ( !rneedsContext.test( selectors ) ) {
                        for ( ; i < l; i++ ) {
                            for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

                                // Always skip document fragments
                                if ( cur.nodeType < 11 && ( targets ?
                                        targets.index( cur ) > -1 :

                                                // Don't pass non-elements to Sizzle
                                        cur.nodeType === 1 &&
                                        jQuery.find.matchesSelector( cur, selectors ) ) ) {

                                    matched.push( cur );
                                    break;
                                }
                            }
                        }
                    }

                    return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
                },

                // Determine the position of an element within the set
                index: function( elem ) {

                    // No argument, return index in parent
                    if ( !elem ) {
                        return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
                    }

                    // Index in selector
                    if ( typeof elem === "string" ) {
                        return indexOf.call( jQuery( elem ), this[ 0 ] );
                    }

                    // Locate the position of the desired element
                    return indexOf.call( this,

                            // If it receives a jQuery object, the first element is used
                            elem.jquery ? elem[ 0 ] : elem
                    );
                },

                add: function( selector, context ) {
                    return this.pushStack(
                            jQuery.uniqueSort(
                                    jQuery.merge( this.get(), jQuery( selector, context ) )
                            )
                    );
                },

                addBack: function( selector ) {
                    return this.add( selector == null ?
                            this.prevObject : this.prevObject.filter( selector )
                    );
                }
            } );

            function sibling( cur, dir ) {
                while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
                return cur;
            }

            jQuery.each( {
                parent: function( elem ) {
                    var parent = elem.parentNode;
                    return parent && parent.nodeType !== 11 ? parent : null;
                },
                parents: function( elem ) {
                    return dir( elem, "parentNode" );
                },
                parentsUntil: function( elem, _i, until ) {
                    return dir( elem, "parentNode", until );
                },
                next: function( elem ) {
                    return sibling( elem, "nextSibling" );
                },
                prev: function( elem ) {
                    return sibling( elem, "previousSibling" );
                },
                nextAll: function( elem ) {
                    return dir( elem, "nextSibling" );
                },
                prevAll: function( elem ) {
                    return dir( elem, "previousSibling" );
                },
                nextUntil: function( elem, _i, until ) {
                    return dir( elem, "nextSibling", until );
                },
                prevUntil: function( elem, _i, until ) {
                    return dir( elem, "previousSibling", until );
                },
                siblings: function( elem ) {
                    return siblings( ( elem.parentNode || {} ).firstChild, elem );
                },
                children: function( elem ) {
                    return siblings( elem.firstChild );
                },
                contents: function( elem ) {
                    if ( elem.contentDocument != null &&

                            // Support: IE 11+
                            // <object> elements with no `data` attribute has an object
                            // `contentDocument` with a `null` prototype.
                            getProto( elem.contentDocument ) ) {

                        return elem.contentDocument;
                    }

                    // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
                    // Treat the template element as a regular one in browsers that
                    // don't support it.
                    if ( nodeName( elem, "template" ) ) {
                        elem = elem.content || elem;
                    }

                    return jQuery.merge( [], elem.childNodes );
                }
            }, function( name, fn ) {
                jQuery.fn[ name ] = function( until, selector ) {
                    var matched = jQuery.map( this, fn, until );

                    if ( name.slice( -5 ) !== "Until" ) {
                        selector = until;
                    }

                    if ( selector && typeof selector === "string" ) {
                        matched = jQuery.filter( selector, matched );
                    }

                    if ( this.length > 1 ) {

                        // Remove duplicates
                        if ( !guaranteedUnique[ name ] ) {
                            jQuery.uniqueSort( matched );
                        }

                        // Reverse order for parents* and prev-derivatives
                        if ( rparentsprev.test( name ) ) {
                            matched.reverse();
                        }
                    }

                    return this.pushStack( matched );
                };
            } );
            var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );



// Convert String-formatted options into Object-formatted ones
            function createOptions( options ) {
                var object = {};
                jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
                    object[ flag ] = true;
                } );
                return object;
            }

            /*
             * Create a callback list using the following parameters:
             *
             *	options: an optional list of space-separated options that will change how
             *			the callback list behaves or a more traditional option object
             *
             * By default a callback list will act like an event callback list and can be
             * "fired" multiple times.
             *
             * Possible options:
             *
             *	once:			will ensure the callback list can only be fired once (like a Deferred)
             *
             *	memory:			will keep track of previous values and will call any callback added
             *					after the list has been fired right away with the latest "memorized"
             *					values (like a Deferred)
             *
             *	unique:			will ensure a callback can only be added once (no duplicate in the list)
             *
             *	stopOnFalse:	interrupt callings when a callback returns false
             *
             */
            jQuery.Callbacks = function( options ) {

                // Convert options from String-formatted to Object-formatted if needed
                // (we check in cache first)
                options = typeof options === "string" ?
                        createOptions( options ) :
                        jQuery.extend( {}, options );

                var // Flag to know if list is currently firing
                        firing,

                // Last fire value for non-forgettable lists
                        memory,

                // Flag to know if list was already fired
                        fired,

                // Flag to prevent firing
                        locked,

                // Actual callback list
                        list = [],

                // Queue of execution data for repeatable lists
                        queue = [],

                // Index of currently firing callback (modified by add/remove as needed)
                        firingIndex = -1,

                // Fire callbacks
                        fire = function() {

                            // Enforce single-firing
                            locked = locked || options.once;

                            // Execute callbacks for all pending executions,
                            // respecting firingIndex overrides and runtime changes
                            fired = firing = true;
                            for ( ; queue.length; firingIndex = -1 ) {
                                memory = queue.shift();
                                while ( ++firingIndex < list.length ) {

                                    // Run callback and check for early termination
                                    if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
                                            options.stopOnFalse ) {

                                        // Jump to end and forget the data so .add doesn't re-fire
                                        firingIndex = list.length;
                                        memory = false;
                                    }
                                }
                            }

                            // Forget the data if we're done with it
                            if ( !options.memory ) {
                                memory = false;
                            }

                            firing = false;

                            // Clean up if we're done firing for good
                            if ( locked ) {

                                // Keep an empty list if we have data for future add calls
                                if ( memory ) {
                                    list = [];

                                    // Otherwise, this object is spent
                                } else {
                                    list = "";
                                }
                            }
                        },

                // Actual Callbacks object
                        self = {

                            // Add a callback or a collection of callbacks to the list
                            add: function() {
                                if ( list ) {

                                    // If we have memory from a past run, we should fire after adding
                                    if ( memory && !firing ) {
                                        firingIndex = list.length - 1;
                                        queue.push( memory );
                                    }

                                    ( function add( args ) {
                                        jQuery.each( args, function( _, arg ) {
                                            if ( isFunction( arg ) ) {
                                                if ( !options.unique || !self.has( arg ) ) {
                                                    list.push( arg );
                                                }
                                            } else if ( arg && arg.length && toType( arg ) !== "string" ) {

                                                // Inspect recursively
                                                add( arg );
                                            }
                                        } );
                                    } )( arguments );

                                    if ( memory && !firing ) {
                                        fire();
                                    }
                                }
                                return this;
                            },

                            // Remove a callback from the list
                            remove: function() {
                                jQuery.each( arguments, function( _, arg ) {
                                    var index;
                                    while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
                                        list.splice( index, 1 );

                                        // Handle firing indexes
                                        if ( index <= firingIndex ) {
                                            firingIndex--;
                                        }
                                    }
                                } );
                                return this;
                            },

                            // Check if a given callback is in the list.
                            // If no argument is given, return whether or not list has callbacks attached.
                            has: function( fn ) {
                                return fn ?
                                jQuery.inArray( fn, list ) > -1 :
                                list.length > 0;
                            },

                            // Remove all callbacks from the list
                            empty: function() {
                                if ( list ) {
                                    list = [];
                                }
                                return this;
                            },

                            // Disable .fire and .add
                            // Abort any current/pending executions
                            // Clear all callbacks and values
                            disable: function() {
                                locked = queue = [];
                                list = memory = "";
                                return this;
                            },
                            disabled: function() {
                                return !list;
                            },

                            // Disable .fire
                            // Also disable .add unless we have memory (since it would have no effect)
                            // Abort any pending executions
                            lock: function() {
                                locked = queue = [];
                                if ( !memory && !firing ) {
                                    list = memory = "";
                                }
                                return this;
                            },
                            locked: function() {
                                return !!locked;
                            },

                            // Call all callbacks with the given context and arguments
                            fireWith: function( context, args ) {
                                if ( !locked ) {
                                    args = args || [];
                                    args = [ context, args.slice ? args.slice() : args ];
                                    queue.push( args );
                                    if ( !firing ) {
                                        fire();
                                    }
                                }
                                return this;
                            },

                            // Call all the callbacks with the given arguments
                            fire: function() {
                                self.fireWith( this, arguments );
                                return this;
                            },

                            // To know if the callbacks have already been called at least once
                            fired: function() {
                                return !!fired;
                            }
                        };

                return self;
            };


            function Identity( v ) {
                return v;
            }
            function Thrower( ex ) {
                throw ex;
            }

            function adoptValue( value, resolve, reject, noValue ) {
                var method;

                try {

                    // Check for promise aspect first to privilege synchronous behavior
                    if ( value && isFunction( ( method = value.promise ) ) ) {
                        method.call( value ).done( resolve ).fail( reject );

                        // Other thenables
                    } else if ( value && isFunction( ( method = value.then ) ) ) {
                        method.call( value, resolve, reject );

                        // Other non-thenables
                    } else {

                        // Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
                        // * false: [ value ].slice( 0 ) => resolve( value )
                        // * true: [ value ].slice( 1 ) => resolve()
                        resolve.apply( undefined, [ value ].slice( noValue ) );
                    }

                    // For Promises/A+, convert exceptions into rejections
                    // Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
                    // Deferred#then to conditionally suppress rejection.
                } catch ( value ) {

                    // Support: Android 4.0 only
                    // Strict mode functions invoked without .call/.apply get global-object context
                    reject.apply( undefined, [ value ] );
                }
            }

            jQuery.extend( {

                Deferred: function( func ) {
                    var tuples = [

                                // action, add listener, callbacks,
                                // ... .then handlers, argument index, [final state]
                                [ "notify", "progress", jQuery.Callbacks( "memory" ),
                                    jQuery.Callbacks( "memory" ), 2 ],
                                [ "resolve", "done", jQuery.Callbacks( "once memory" ),
                                    jQuery.Callbacks( "once memory" ), 0, "resolved" ],
                                [ "reject", "fail", jQuery.Callbacks( "once memory" ),
                                    jQuery.Callbacks( "once memory" ), 1, "rejected" ]
                            ],
                            state = "pending",
                            promise = {
                                state: function() {
                                    return state;
                                },
                                always: function() {
                                    deferred.done( arguments ).fail( arguments );
                                    return this;
                                },
                                "catch": function( fn ) {
                                    return promise.then( null, fn );
                                },

                                // Keep pipe for back-compat
                                pipe: function( /* fnDone, fnFail, fnProgress */ ) {
                                    var fns = arguments;

                                    return jQuery.Deferred( function( newDefer ) {
                                        jQuery.each( tuples, function( _i, tuple ) {

                                            // Map tuples (progress, done, fail) to arguments (done, fail, progress)
                                            var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];

                                            // deferred.progress(function() { bind to newDefer or newDefer.notify })
                                            // deferred.done(function() { bind to newDefer or newDefer.resolve })
                                            // deferred.fail(function() { bind to newDefer or newDefer.reject })
                                            deferred[ tuple[ 1 ] ]( function() {
                                                var returned = fn && fn.apply( this, arguments );
                                                if ( returned && isFunction( returned.promise ) ) {
                                                    returned.promise()
                                                            .progress( newDefer.notify )
                                                            .done( newDefer.resolve )
                                                            .fail( newDefer.reject );
                                                } else {
                                                    newDefer[ tuple[ 0 ] + "With" ](
                                                            this,
                                                            fn ? [ returned ] : arguments
                                                    );
                                                }
                                            } );
                                        } );
                                        fns = null;
                                    } ).promise();
                                },
                                then: function( onFulfilled, onRejected, onProgress ) {
                                    var maxDepth = 0;
                                    function resolve( depth, deferred, handler, special ) {
                                        return function() {
                                            var that = this,
                                                    args = arguments,
                                                    mightThrow = function() {
                                                        var returned, then;

                                                        // Support: Promises/A+ section 2.3.3.3.3
                                                        // https://promisesaplus.com/#point-59
                                                        // Ignore double-resolution attempts
                                                        if ( depth < maxDepth ) {
                                                            return;
                                                        }

                                                        returned = handler.apply( that, args );

                                                        // Support: Promises/A+ section 2.3.1
                                                        // https://promisesaplus.com/#point-48
                                                        if ( returned === deferred.promise() ) {
                                                            throw new TypeError( "Thenable self-resolution" );
                                                        }

                                                        // Support: Promises/A+ sections 2.3.3.1, 3.5
                                                        // https://promisesaplus.com/#point-54
                                                        // https://promisesaplus.com/#point-75
                                                        // Retrieve `then` only once
                                                        then = returned &&

                                                                // Support: Promises/A+ section 2.3.4
                                                                // https://promisesaplus.com/#point-64
                                                                // Only check objects and functions for thenability
                                                                ( typeof returned === "object" ||
                                                                typeof returned === "function" ) &&
                                                                returned.then;

                                                        // Handle a returned thenable
                                                        if ( isFunction( then ) ) {

                                                            // Special processors (notify) just wait for resolution
                                                            if ( special ) {
                                                                then.call(
                                                                        returned,
                                                                        resolve( maxDepth, deferred, Identity, special ),
                                                                        resolve( maxDepth, deferred, Thrower, special )
                                                                );

                                                                // Normal processors (resolve) also hook into progress
                                                            } else {

                                                                // ...and disregard older resolution values
                                                                maxDepth++;

                                                                then.call(
                                                                        returned,
                                                                        resolve( maxDepth, deferred, Identity, special ),
                                                                        resolve( maxDepth, deferred, Thrower, special ),
                                                                        resolve( maxDepth, deferred, Identity,
                                                                                deferred.notifyWith )
                                                                );
                                                            }

                                                            // Handle all other returned values
                                                        } else {

                                                            // Only substitute handlers pass on context
                                                            // and multiple values (non-spec behavior)
                                                            if ( handler !== Identity ) {
                                                                that = undefined;
                                                                args = [ returned ];
                                                            }

                                                            // Process the value(s)
                                                            // Default process is resolve
                                                            ( special || deferred.resolveWith )( that, args );
                                                        }
                                                    },

                                            // Only normal processors (resolve) catch and reject exceptions
                                                    process = special ?
                                                            mightThrow :
                                                            function() {
                                                                try {
                                                                    mightThrow();
                                                                } catch ( e ) {

                                                                    if ( jQuery.Deferred.exceptionHook ) {
                                                                        jQuery.Deferred.exceptionHook( e,
                                                                                process.stackTrace );
                                                                    }

                                                                    // Support: Promises/A+ section 2.3.3.3.4.1
                                                                    // https://promisesaplus.com/#point-61
                                                                    // Ignore post-resolution exceptions
                                                                    if ( depth + 1 >= maxDepth ) {

                                                                        // Only substitute handlers pass on context
                                                                        // and multiple values (non-spec behavior)
                                                                        if ( handler !== Thrower ) {
                                                                            that = undefined;
                                                                            args = [ e ];
                                                                        }

                                                                        deferred.rejectWith( that, args );
                                                                    }
                                                                }
                                                            };

                                            // Support: Promises/A+ section 2.3.3.3.1
                                            // https://promisesaplus.com/#point-57
                                            // Re-resolve promises immediately to dodge false rejection from
                                            // subsequent errors
                                            if ( depth ) {
                                                process();
                                            } else {

                                                // Call an optional hook to record the stack, in case of exception
                                                // since it's otherwise lost when execution goes async
                                                if ( jQuery.Deferred.getStackHook ) {
                                                    process.stackTrace = jQuery.Deferred.getStackHook();
                                                }
                                                window.setTimeout( process );
                                            }
                                        };
                                    }

                                    return jQuery.Deferred( function( newDefer ) {

                                        // progress_handlers.add( ... )
                                        tuples[ 0 ][ 3 ].add(
                                                resolve(
                                                        0,
                                                        newDefer,
                                                        isFunction( onProgress ) ?
                                                                onProgress :
                                                                Identity,
                                                        newDefer.notifyWith
                                                )
                                        );

                                        // fulfilled_handlers.add( ... )
                                        tuples[ 1 ][ 3 ].add(
                                                resolve(
                                                        0,
                                                        newDefer,
                                                        isFunction( onFulfilled ) ?
                                                                onFulfilled :
                                                                Identity
                                                )
                                        );

                                        // rejected_handlers.add( ... )
                                        tuples[ 2 ][ 3 ].add(
                                                resolve(
                                                        0,
                                                        newDefer,
                                                        isFunction( onRejected ) ?
                                                                onRejected :
                                                                Thrower
                                                )
                                        );
                                    } ).promise();
                                },

                                // Get a promise for this deferred
                                // If obj is provided, the promise aspect is added to the object
                                promise: function( obj ) {
                                    return obj != null ? jQuery.extend( obj, promise ) : promise;
                                }
                            },
                            deferred = {};

                    // Add list-specific methods
                    jQuery.each( tuples, function( i, tuple ) {
                        var list = tuple[ 2 ],
                                stateString = tuple[ 5 ];

                        // promise.progress = list.add
                        // promise.done = list.add
                        // promise.fail = list.add
                        promise[ tuple[ 1 ] ] = list.add;

                        // Handle state
                        if ( stateString ) {
                            list.add(
                                    function() {

                                        // state = "resolved" (i.e., fulfilled)
                                        // state = "rejected"
                                        state = stateString;
                                    },

                                    // rejected_callbacks.disable
                                    // fulfilled_callbacks.disable
                                    tuples[ 3 - i ][ 2 ].disable,

                                    // rejected_handlers.disable
                                    // fulfilled_handlers.disable
                                    tuples[ 3 - i ][ 3 ].disable,

                                    // progress_callbacks.lock
                                    tuples[ 0 ][ 2 ].lock,

                                    // progress_handlers.lock
                                    tuples[ 0 ][ 3 ].lock
                            );
                        }

                        // progress_handlers.fire
                        // fulfilled_handlers.fire
                        // rejected_handlers.fire
                        list.add( tuple[ 3 ].fire );

                        // deferred.notify = function() { deferred.notifyWith(...) }
                        // deferred.resolve = function() { deferred.resolveWith(...) }
                        // deferred.reject = function() { deferred.rejectWith(...) }
                        deferred[ tuple[ 0 ] ] = function() {
                            deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
                            return this;
                        };

                        // deferred.notifyWith = list.fireWith
                        // deferred.resolveWith = list.fireWith
                        // deferred.rejectWith = list.fireWith
                        deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
                    } );

                    // Make the deferred a promise
                    promise.promise( deferred );

                    // Call given func if any
                    if ( func ) {
                        func.call( deferred, deferred );
                    }

                    // All done!
                    return deferred;
                },

                // Deferred helper
                when: function( singleValue ) {
                    var

                    // count of uncompleted subordinates
                            remaining = arguments.length,

                    // count of unprocessed arguments
                            i = remaining,

                    // subordinate fulfillment data
                            resolveContexts = Array( i ),
                            resolveValues = slice.call( arguments ),

                    // the master Deferred
                            master = jQuery.Deferred(),

                    // subordinate callback factory
                            updateFunc = function( i ) {
                                return function( value ) {
                                    resolveContexts[ i ] = this;
                                    resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
                                    if ( !( --remaining ) ) {
                                        master.resolveWith( resolveContexts, resolveValues );
                                    }
                                };
                            };

                    // Single- and empty arguments are adopted like Promise.resolve
                    if ( remaining <= 1 ) {
                        adoptValue( singleValue, master.done( updateFunc( i ) ).resolve, master.reject,
                                !remaining );

                        // Use .then() to unwrap secondary thenables (cf. gh-3000)
                        if ( master.state() === "pending" ||
                                isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {

                            return master.then();
                        }
                    }

                    // Multiple arguments are aggregated like Promise.all array elements
                    while ( i-- ) {
                        adoptValue( resolveValues[ i ], updateFunc( i ), master.reject );
                    }

                    return master.promise();
                }
            } );


// These usually indicate a programmer mistake during development,
// warn about them ASAP rather than swallowing them by default.
            var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

            jQuery.Deferred.exceptionHook = function( error, stack ) {

                // Support: IE 8 - 9 only
                // Console exists when dev tools are open, which can happen at any time
                if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
                    window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
                }
            };




            jQuery.readyException = function( error ) {
                window.setTimeout( function() {
                    throw error;
                } );
            };




// The deferred used on DOM ready
            var readyList = jQuery.Deferred();

            jQuery.fn.ready = function( fn ) {

                readyList
                        .then( fn )

                        // Wrap jQuery.readyException in a function so that the lookup
                        // happens at the time of error handling instead of callback
                        // registration.
                        .catch( function( error ) {
                            jQuery.readyException( error );
                        } );

                return this;
            };

            jQuery.extend( {

                // Is the DOM ready to be used? Set to true once it occurs.
                isReady: false,

                // A counter to track how many items to wait for before
                // the ready event fires. See #6781
                readyWait: 1,

                // Handle when the DOM is ready
                ready: function( wait ) {

                    // Abort if there are pending holds or we're already ready
                    if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
                        return;
                    }

                    // Remember that the DOM is ready
                    jQuery.isReady = true;

                    // If a normal DOM Ready event fired, decrement, and wait if need be
                    if ( wait !== true && --jQuery.readyWait > 0 ) {
                        return;
                    }

                    // If there are functions bound, to execute
                    readyList.resolveWith( document, [ jQuery ] );
                }
            } );

            jQuery.ready.then = readyList.then;

// The ready event handler and self cleanup method
            function completed() {
                document.removeEventListener( "DOMContentLoaded", completed );
                window.removeEventListener( "load", completed );
                jQuery.ready();
            }

// Catch cases where $(document).ready() is called
// after the browser event has already occurred.
// Support: IE <=9 - 10 only
// Older IE sometimes signals "interactive" too soon
            if ( document.readyState === "complete" ||
                    ( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

                // Handle it asynchronously to allow scripts the opportunity to delay ready
                window.setTimeout( jQuery.ready );

            } else {

                // Use the handy event callback
                document.addEventListener( "DOMContentLoaded", completed );

                // A fallback to window.onload, that will always work
                window.addEventListener( "load", completed );
            }




// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
            var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
                var i = 0,
                        len = elems.length,
                        bulk = key == null;

                // Sets many values
                if ( toType( key ) === "object" ) {
                    chainable = true;
                    for ( i in key ) {
                        access( elems, fn, i, key[ i ], true, emptyGet, raw );
                    }

                    // Sets one value
                } else if ( value !== undefined ) {
                    chainable = true;

                    if ( !isFunction( value ) ) {
                        raw = true;
                    }

                    if ( bulk ) {

                        // Bulk operations run against the entire set
                        if ( raw ) {
                            fn.call( elems, value );
                            fn = null;

                            // ...except when executing function values
                        } else {
                            bulk = fn;
                            fn = function( elem, _key, value ) {
                                return bulk.call( jQuery( elem ), value );
                            };
                        }
                    }

                    if ( fn ) {
                        for ( ; i < len; i++ ) {
                            fn(
                                    elems[ i ], key, raw ?
                                            value :
                                            value.call( elems[ i ], i, fn( elems[ i ], key ) )
                            );
                        }
                    }
                }

                if ( chainable ) {
                    return elems;
                }

                // Gets
                if ( bulk ) {
                    return fn.call( elems );
                }

                return len ? fn( elems[ 0 ], key ) : emptyGet;
            };


// Matches dashed string for camelizing
            var rmsPrefix = /^-ms-/,
                    rdashAlpha = /-([a-z])/g;

// Used by camelCase as callback to replace()
            function fcamelCase( _all, letter ) {
                return letter.toUpperCase();
            }

// Convert dashed to camelCase; used by the css and data modules
// Support: IE <=9 - 11, Edge 12 - 15
// Microsoft forgot to hump their vendor prefix (#9572)
            function camelCase( string ) {
                return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
            }
            var acceptData = function( owner ) {

                // Accepts only:
                //  - Node
                //    - Node.ELEMENT_NODE
                //    - Node.DOCUMENT_NODE
                //  - Object
                //    - Any
                return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
            };




            function Data() {
                this.expando = jQuery.expando + Data.uid++;
            }

            Data.uid = 1;

            Data.prototype = {

                cache: function( owner ) {

                    // Check if the owner object already has a cache
                    var value = owner[ this.expando ];

                    // If not, create one
                    if ( !value ) {
                        value = {};

                        // We can accept data for non-element nodes in modern browsers,
                        // but we should not, see #8335.
                        // Always return an empty object.
                        if ( acceptData( owner ) ) {

                            // If it is a node unlikely to be stringify-ed or looped over
                            // use plain assignment
                            if ( owner.nodeType ) {
                                owner[ this.expando ] = value;

                                // Otherwise secure it in a non-enumerable property
                                // configurable must be true to allow the property to be
                                // deleted when data is removed
                            } else {
                                Object.defineProperty( owner, this.expando, {
                                    value: value,
                                    configurable: true
                                } );
                            }
                        }
                    }

                    return value;
                },
                set: function( owner, data, value ) {
                    var prop,
                            cache = this.cache( owner );

                    // Handle: [ owner, key, value ] args
                    // Always use camelCase key (gh-2257)
                    if ( typeof data === "string" ) {
                        cache[ camelCase( data ) ] = value;

                        // Handle: [ owner, { properties } ] args
                    } else {

                        // Copy the properties one-by-one to the cache object
                        for ( prop in data ) {
                            cache[ camelCase( prop ) ] = data[ prop ];
                        }
                    }
                    return cache;
                },
                get: function( owner, key ) {
                    return key === undefined ?
                            this.cache( owner ) :

                            // Always use camelCase key (gh-2257)
                    owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
                },
                access: function( owner, key, value ) {

                    // In cases where either:
                    //
                    //   1. No key was specified
                    //   2. A string key was specified, but no value provided
                    //
                    // Take the "read" path and allow the get method to determine
                    // which value to return, respectively either:
                    //
                    //   1. The entire cache object
                    //   2. The data stored at the key
                    //
                    if ( key === undefined ||
                            ( ( key && typeof key === "string" ) && value === undefined ) ) {

                        return this.get( owner, key );
                    }

                    // When the key is not a string, or both a key and value
                    // are specified, set or extend (existing objects) with either:
                    //
                    //   1. An object of properties
                    //   2. A key and value
                    //
                    this.set( owner, key, value );

                    // Since the "set" path can have two possible entry points
                    // return the expected data based on which path was taken[*]
                    return value !== undefined ? value : key;
                },
                remove: function( owner, key ) {
                    var i,
                            cache = owner[ this.expando ];

                    if ( cache === undefined ) {
                        return;
                    }

                    if ( key !== undefined ) {

                        // Support array or space separated string of keys
                        if ( Array.isArray( key ) ) {

                            // If key is an array of keys...
                            // We always set camelCase keys, so remove that.
                            key = key.map( camelCase );
                        } else {
                            key = camelCase( key );

                            // If a key with the spaces exists, use it.
                            // Otherwise, create an array by matching non-whitespace
                            key = key in cache ?
                                    [ key ] :
                                    ( key.match( rnothtmlwhite ) || [] );
                        }

                        i = key.length;

                        while ( i-- ) {
                            delete cache[ key[ i ] ];
                        }
                    }

                    // Remove the expando if there's no more data
                    if ( key === undefined || jQuery.isEmptyObject( cache ) ) {

                        // Support: Chrome <=35 - 45
                        // Webkit & Blink performance suffers when deleting properties
                        // from DOM nodes, so set to undefined instead
                        // https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
                        if ( owner.nodeType ) {
                            owner[ this.expando ] = undefined;
                        } else {
                            delete owner[ this.expando ];
                        }
                    }
                },
                hasData: function( owner ) {
                    var cache = owner[ this.expando ];
                    return cache !== undefined && !jQuery.isEmptyObject( cache );
                }
            };
            var dataPriv = new Data();

            var dataUser = new Data();



//	Implementation Summary
//
//	1. Enforce API surface and semantic compatibility with 1.9.x branch
//	2. Improve the module's maintainability by reducing the storage
//		paths to a single mechanism.
//	3. Use the same single mechanism to support "private" and "user" data.
//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
//	5. Avoid exposing implementation details on user objects (eg. expando properties)
//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

            var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
                    rmultiDash = /[A-Z]/g;

            function getData( data ) {
                if ( data === "true" ) {
                    return true;
                }

                if ( data === "false" ) {
                    return false;
                }

                if ( data === "null" ) {
                    return null;
                }

                // Only convert to a number if it doesn't change the string
                if ( data === +data + "" ) {
                    return +data;
                }

                if ( rbrace.test( data ) ) {
                    return JSON.parse( data );
                }

                return data;
            }

            function dataAttr( elem, key, data ) {
                var name;

                // If nothing was found internally, try to fetch any
                // data from the HTML5 data-* attribute
                if ( data === undefined && elem.nodeType === 1 ) {
                    name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
                    data = elem.getAttribute( name );

                    if ( typeof data === "string" ) {
                        try {
                            data = getData( data );
                        } catch ( e ) {}

                        // Make sure we set the data so it isn't changed later
                        dataUser.set( elem, key, data );
                    } else {
                        data = undefined;
                    }
                }
                return data;
            }

            jQuery.extend( {
                hasData: function( elem ) {
                    return dataUser.hasData( elem ) || dataPriv.hasData( elem );
                },

                data: function( elem, name, data ) {
                    return dataUser.access( elem, name, data );
                },

                removeData: function( elem, name ) {
                    dataUser.remove( elem, name );
                },

                // TODO: Now that all calls to _data and _removeData have been replaced
                // with direct calls to dataPriv methods, these can be deprecated.
                _data: function( elem, name, data ) {
                    return dataPriv.access( elem, name, data );
                },

                _removeData: function( elem, name ) {
                    dataPriv.remove( elem, name );
                }
            } );

            jQuery.fn.extend( {
                data: function( key, value ) {
                    var i, name, data,
                            elem = this[ 0 ],
                            attrs = elem && elem.attributes;

                    // Gets all values
                    if ( key === undefined ) {
                        if ( this.length ) {
                            data = dataUser.get( elem );

                            if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
                                i = attrs.length;
                                while ( i-- ) {

                                    // Support: IE 11 only
                                    // The attrs elements can be null (#14894)
                                    if ( attrs[ i ] ) {
                                        name = attrs[ i ].name;
                                        if ( name.indexOf( "data-" ) === 0 ) {
                                            name = camelCase( name.slice( 5 ) );
                                            dataAttr( elem, name, data[ name ] );
                                        }
                                    }
                                }
                                dataPriv.set( elem, "hasDataAttrs", true );
                            }
                        }

                        return data;
                    }

                    // Sets multiple values
                    if ( typeof key === "object" ) {
                        return this.each( function() {
                            dataUser.set( this, key );
                        } );
                    }

                    return access( this, function( value ) {
                        var data;

                        // The calling jQuery object (element matches) is not empty
                        // (and therefore has an element appears at this[ 0 ]) and the
                        // `value` parameter was not undefined. An empty jQuery object
                        // will result in `undefined` for elem = this[ 0 ] which will
                        // throw an exception if an attempt to read a data cache is made.
                        if ( elem && value === undefined ) {

                            // Attempt to get data from the cache
                            // The key will always be camelCased in Data
                            data = dataUser.get( elem, key );
                            if ( data !== undefined ) {
                                return data;
                            }

                            // Attempt to "discover" the data in
                            // HTML5 custom data-* attrs
                            data = dataAttr( elem, key );
                            if ( data !== undefined ) {
                                return data;
                            }

                            // We tried really hard, but the data doesn't exist.
                            return;
                        }

                        // Set the data...
                        this.each( function() {

                            // We always store the camelCased key
                            dataUser.set( this, key, value );
                        } );
                    }, null, value, arguments.length > 1, null, true );
                },

                removeData: function( key ) {
                    return this.each( function() {
                        dataUser.remove( this, key );
                    } );
                }
            } );


            jQuery.extend( {
                queue: function( elem, type, data ) {
                    var queue;

                    if ( elem ) {
                        type = ( type || "fx" ) + "queue";
                        queue = dataPriv.get( elem, type );

                        // Speed up dequeue by getting out quickly if this is just a lookup
                        if ( data ) {
                            if ( !queue || Array.isArray( data ) ) {
                                queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
                            } else {
                                queue.push( data );
                            }
                        }
                        return queue || [];
                    }
                },

                dequeue: function( elem, type ) {
                    type = type || "fx";

                    var queue = jQuery.queue( elem, type ),
                            startLength = queue.length,
                            fn = queue.shift(),
                            hooks = jQuery._queueHooks( elem, type ),
                            next = function() {
                                jQuery.dequeue( elem, type );
                            };

                    // If the fx queue is dequeued, always remove the progress sentinel
                    if ( fn === "inprogress" ) {
                        fn = queue.shift();
                        startLength--;
                    }

                    if ( fn ) {

                        // Add a progress sentinel to prevent the fx queue from being
                        // automatically dequeued
                        if ( type === "fx" ) {
                            queue.unshift( "inprogress" );
                        }

                        // Clear up the last queue stop function
                        delete hooks.stop;
                        fn.call( elem, next, hooks );
                    }

                    if ( !startLength && hooks ) {
                        hooks.empty.fire();
                    }
                },

                // Not public - generate a queueHooks object, or return the current one
                _queueHooks: function( elem, type ) {
                    var key = type + "queueHooks";
                    return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
                                empty: jQuery.Callbacks( "once memory" ).add( function() {
                                    dataPriv.remove( elem, [ type + "queue", key ] );
                                } )
                            } );
                }
            } );

            jQuery.fn.extend( {
                queue: function( type, data ) {
                    var setter = 2;

                    if ( typeof type !== "string" ) {
                        data = type;
                        type = "fx";
                        setter--;
                    }

                    if ( arguments.length < setter ) {
                        return jQuery.queue( this[ 0 ], type );
                    }

                    return data === undefined ?
                            this :
                            this.each( function() {
                                var queue = jQuery.queue( this, type, data );

                                // Ensure a hooks for this queue
                                jQuery._queueHooks( this, type );

                                if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
                                    jQuery.dequeue( this, type );
                                }
                            } );
                },
                dequeue: function( type ) {
                    return this.each( function() {
                        jQuery.dequeue( this, type );
                    } );
                },
                clearQueue: function( type ) {
                    return this.queue( type || "fx", [] );
                },

                // Get a promise resolved when queues of a certain type
                // are emptied (fx is the type by default)
                promise: function( type, obj ) {
                    var tmp,
                            count = 1,
                            defer = jQuery.Deferred(),
                            elements = this,
                            i = this.length,
                            resolve = function() {
                                if ( !( --count ) ) {
                                    defer.resolveWith( elements, [ elements ] );
                                }
                            };

                    if ( typeof type !== "string" ) {
                        obj = type;
                        type = undefined;
                    }
                    type = type || "fx";

                    while ( i-- ) {
                        tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
                        if ( tmp && tmp.empty ) {
                            count++;
                            tmp.empty.add( resolve );
                        }
                    }
                    resolve();
                    return defer.promise( obj );
                }
            } );
            var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;

            var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );


            var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

            var documentElement = document.documentElement;



            var isAttached = function( elem ) {
                        return jQuery.contains( elem.ownerDocument, elem );
                    },
                    composed = { composed: true };

            // Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
            // Check attachment across shadow DOM boundaries when possible (gh-3504)
            // Support: iOS 10.0-10.2 only
            // Early iOS 10 versions support `attachShadow` but not `getRootNode`,
            // leading to errors. We need to check for `getRootNode`.
            if ( documentElement.getRootNode ) {
                isAttached = function( elem ) {
                    return jQuery.contains( elem.ownerDocument, elem ) ||
                            elem.getRootNode( composed ) === elem.ownerDocument;
                };
            }
            var isHiddenWithinTree = function( elem, el ) {

                // isHiddenWithinTree might be called from jQuery#filter function;
                // in that case, element will be second argument
                elem = el || elem;

                // Inline style trumps all
                return elem.style.display === "none" ||
                        elem.style.display === "" &&

                        // Otherwise, check computed style
                        // Support: Firefox <=43 - 45
                        // Disconnected elements can have computed display: none, so first confirm that elem is
                        // in the document.
                        isAttached( elem ) &&

                        jQuery.css( elem, "display" ) === "none";
            };



            function adjustCSS( elem, prop, valueParts, tween ) {
                var adjusted, scale,
                        maxIterations = 20,
                        currentValue = tween ?
                                function() {
                                    return tween.cur();
                                } :
                                function() {
                                    return jQuery.css( elem, prop, "" );
                                },
                        initial = currentValue(),
                        unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

                // Starting value computation is required for potential unit mismatches
                        initialInUnit = elem.nodeType &&
                                ( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
                                rcssNum.exec( jQuery.css( elem, prop ) );

                if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

                    // Support: Firefox <=54
                    // Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
                    initial = initial / 2;

                    // Trust units reported by jQuery.css
                    unit = unit || initialInUnit[ 3 ];

                    // Iteratively approximate from a nonzero starting point
                    initialInUnit = +initial || 1;

                    while ( maxIterations-- ) {

                        // Evaluate and update our best guess (doubling guesses that zero out).
                        // Finish if the scale equals or crosses 1 (making the old*new product non-positive).
                        jQuery.style( elem, prop, initialInUnit + unit );
                        if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
                            maxIterations = 0;
                        }
                        initialInUnit = initialInUnit / scale;

                    }

                    initialInUnit = initialInUnit * 2;
                    jQuery.style( elem, prop, initialInUnit + unit );

                    // Make sure we update the tween properties later on
                    valueParts = valueParts || [];
                }

                if ( valueParts ) {
                    initialInUnit = +initialInUnit || +initial || 0;

                    // Apply relative offset (+=/-=) if specified
                    adjusted = valueParts[ 1 ] ?
                    initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
                            +valueParts[ 2 ];
                    if ( tween ) {
                        tween.unit = unit;
                        tween.start = initialInUnit;
                        tween.end = adjusted;
                    }
                }
                return adjusted;
            }


            var defaultDisplayMap = {};

            function getDefaultDisplay( elem ) {
                var temp,
                        doc = elem.ownerDocument,
                        nodeName = elem.nodeName,
                        display = defaultDisplayMap[ nodeName ];

                if ( display ) {
                    return display;
                }

                temp = doc.body.appendChild( doc.createElement( nodeName ) );
                display = jQuery.css( temp, "display" );

                temp.parentNode.removeChild( temp );

                if ( display === "none" ) {
                    display = "block";
                }
                defaultDisplayMap[ nodeName ] = display;

                return display;
            }

            function showHide( elements, show ) {
                var display, elem,
                        values = [],
                        index = 0,
                        length = elements.length;

                // Determine new display value for elements that need to change
                for ( ; index < length; index++ ) {
                    elem = elements[ index ];
                    if ( !elem.style ) {
                        continue;
                    }

                    display = elem.style.display;
                    if ( show ) {

                        // Since we force visibility upon cascade-hidden elements, an immediate (and slow)
                        // check is required in this first loop unless we have a nonempty display value (either
                        // inline or about-to-be-restored)
                        if ( display === "none" ) {
                            values[ index ] = dataPriv.get( elem, "display" ) || null;
                            if ( !values[ index ] ) {
                                elem.style.display = "";
                            }
                        }
                        if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
                            values[ index ] = getDefaultDisplay( elem );
                        }
                    } else {
                        if ( display !== "none" ) {
                            values[ index ] = "none";

                            // Remember what we're overwriting
                            dataPriv.set( elem, "display", display );
                        }
                    }
                }

                // Set the display of the elements in a second loop to avoid constant reflow
                for ( index = 0; index < length; index++ ) {
                    if ( values[ index ] != null ) {
                        elements[ index ].style.display = values[ index ];
                    }
                }

                return elements;
            }

            jQuery.fn.extend( {
                show: function() {
                    return showHide( this, true );
                },
                hide: function() {
                    return showHide( this );
                },
                toggle: function( state ) {
                    if ( typeof state === "boolean" ) {
                        return state ? this.show() : this.hide();
                    }

                    return this.each( function() {
                        if ( isHiddenWithinTree( this ) ) {
                            jQuery( this ).show();
                        } else {
                            jQuery( this ).hide();
                        }
                    } );
                }
            } );
            var rcheckableType = ( /^(?:checkbox|radio)$/i );

            var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]*)/i );

            var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );



            ( function() {
                var fragment = document.createDocumentFragment(),
                        div = fragment.appendChild( document.createElement( "div" ) ),
                        input = document.createElement( "input" );

                // Support: Android 4.0 - 4.3 only
                // Check state lost if the name is set (#11217)
                // Support: Windows Web Apps (WWA)
                // `name` and `type` must use .setAttribute for WWA (#14901)
                input.setAttribute( "type", "radio" );
                input.setAttribute( "checked", "checked" );
                input.setAttribute( "name", "t" );

                div.appendChild( input );

                // Support: Android <=4.1 only
                // Older WebKit doesn't clone checked state correctly in fragments
                support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

                // Support: IE <=11 only
                // Make sure textarea (and checkbox) defaultValue is properly cloned
                div.innerHTML = "<textarea>x</textarea>";
                support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;

                // Support: IE <=9 only
                // IE <=9 replaces <option> tags with their contents when inserted outside of
                // the select element.
                div.innerHTML = "<option></option>";
                support.option = !!div.lastChild;
            } )();


// We have to close these tags to support XHTML (#13200)
            var wrapMap = {

                // XHTML parsers do not magically insert elements in the
                // same way that tag soup parsers do. So we cannot shorten
                // this by omitting <tbody> or other required elements.
                thead: [ 1, "<table>", "</table>" ],
                col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
                tr: [ 2, "<table><tbody>", "</tbody></table>" ],
                td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

                _default: [ 0, "", "" ]
            };

            wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
            wrapMap.th = wrapMap.td;

// Support: IE <=9 only
            if ( !support.option ) {
                wrapMap.optgroup = wrapMap.option = [ 1, "<select multiple='multiple'>", "</select>" ];
            }


            function getAll( context, tag ) {

                // Support: IE <=9 - 11 only
                // Use typeof to avoid zero-argument method invocation on host objects (#15151)
                var ret;

                if ( typeof context.getElementsByTagName !== "undefined" ) {
                    ret = context.getElementsByTagName( tag || "*" );

                } else if ( typeof context.querySelectorAll !== "undefined" ) {
                    ret = context.querySelectorAll( tag || "*" );

                } else {
                    ret = [];
                }

                if ( tag === undefined || tag && nodeName( context, tag ) ) {
                    return jQuery.merge( [ context ], ret );
                }

                return ret;
            }


// Mark scripts as having already been evaluated
            function setGlobalEval( elems, refElements ) {
                var i = 0,
                        l = elems.length;

                for ( ; i < l; i++ ) {
                    dataPriv.set(
                            elems[ i ],
                            "globalEval",
                            !refElements || dataPriv.get( refElements[ i ], "globalEval" )
                    );
                }
            }


            var rhtml = /<|&#?\w+;/;

            function buildFragment( elems, context, scripts, selection, ignored ) {
                var elem, tmp, tag, wrap, attached, j,
                        fragment = context.createDocumentFragment(),
                        nodes = [],
                        i = 0,
                        l = elems.length;

                for ( ; i < l; i++ ) {
                    elem = elems[ i ];

                    if ( elem || elem === 0 ) {

                        // Add nodes directly
                        if ( toType( elem ) === "object" ) {

                            // Support: Android <=4.0 only, PhantomJS 1 only
                            // push.apply(_, arraylike) throws on ancient WebKit
                            jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

                            // Convert non-html into a text node
                        } else if ( !rhtml.test( elem ) ) {
                            nodes.push( context.createTextNode( elem ) );

                            // Convert html into DOM nodes
                        } else {
                            tmp = tmp || fragment.appendChild( context.createElement( "div" ) );

                            // Deserialize a standard representation
                            tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
                            wrap = wrapMap[ tag ] || wrapMap._default;
                            tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

                            // Descend through wrappers to the right content
                            j = wrap[ 0 ];
                            while ( j-- ) {
                                tmp = tmp.lastChild;
                            }

                            // Support: Android <=4.0 only, PhantomJS 1 only
                            // push.apply(_, arraylike) throws on ancient WebKit
                            jQuery.merge( nodes, tmp.childNodes );

                            // Remember the top-level container
                            tmp = fragment.firstChild;

                            // Ensure the created nodes are orphaned (#12392)
                            tmp.textContent = "";
                        }
                    }
                }

                // Remove wrapper from fragment
                fragment.textContent = "";

                i = 0;
                while ( ( elem = nodes[ i++ ] ) ) {

                    // Skip elements already in the context collection (trac-4087)
                    if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
                        if ( ignored ) {
                            ignored.push( elem );
                        }
                        continue;
                    }

                    attached = isAttached( elem );

                    // Append to fragment
                    tmp = getAll( fragment.appendChild( elem ), "script" );

                    // Preserve script evaluation history
                    if ( attached ) {
                        setGlobalEval( tmp );
                    }

                    // Capture executables
                    if ( scripts ) {
                        j = 0;
                        while ( ( elem = tmp[ j++ ] ) ) {
                            if ( rscriptType.test( elem.type || "" ) ) {
                                scripts.push( elem );
                            }
                        }
                    }
                }

                return fragment;
            }


            var
                    rkeyEvent = /^key/,
                    rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
                    rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

            function returnTrue() {
                return true;
            }

            function returnFalse() {
                return false;
            }

// Support: IE <=9 - 11+
// focus() and blur() are asynchronous, except when they are no-op.
// So expect focus to be synchronous when the element is already active,
// and blur to be synchronous when the element is not already active.
// (focus and blur are always synchronous in other supported browsers,
// this just defines when we can count on it).
            function expectSync( elem, type ) {
                return ( elem === safeActiveElement() ) === ( type === "focus" );
            }

// Support: IE <=9 only
// Accessing document.activeElement can throw unexpectedly
// https://bugs.jquery.com/ticket/13393
            function safeActiveElement() {
                try {
                    return document.activeElement;
                } catch ( err ) { }
            }

            function on( elem, types, selector, data, fn, one ) {
                var origFn, type;

                // Types can be a map of types/handlers
                if ( typeof types === "object" ) {

                    // ( types-Object, selector, data )
                    if ( typeof selector !== "string" ) {

                        // ( types-Object, data )
                        data = data || selector;
                        selector = undefined;
                    }
                    for ( type in types ) {
                        on( elem, type, selector, data, types[ type ], one );
                    }
                    return elem;
                }

                if ( data == null && fn == null ) {

                    // ( types, fn )
                    fn = selector;
                    data = selector = undefined;
                } else if ( fn == null ) {
                    if ( typeof selector === "string" ) {

                        // ( types, selector, fn )
                        fn = data;
                        data = undefined;
                    } else {

                        // ( types, data, fn )
                        fn = data;
                        data = selector;
                        selector = undefined;
                    }
                }
                if ( fn === false ) {
                    fn = returnFalse;
                } else if ( !fn ) {
                    return elem;
                }

                if ( one === 1 ) {
                    origFn = fn;
                    fn = function( event ) {

                        // Can use an empty set, since event contains the info
                        jQuery().off( event );
                        return origFn.apply( this, arguments );
                    };

                    // Use same guid so caller can remove using origFn
                    fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
                }
                return elem.each( function() {
                    jQuery.event.add( this, types, fn, data, selector );
                } );
            }

            /*
             * Helper functions for managing events -- not part of the public interface.
             * Props to Dean Edwards' addEvent library for many of the ideas.
             */
            jQuery.event = {

                global: {},

                add: function( elem, types, handler, data, selector ) {

                    var handleObjIn, eventHandle, tmp,
                            events, t, handleObj,
                            special, handlers, type, namespaces, origType,
                            elemData = dataPriv.get( elem );

                    // Only attach events to objects that accept data
                    if ( !acceptData( elem ) ) {
                        return;
                    }

                    // Caller can pass in an object of custom data in lieu of the handler
                    if ( handler.handler ) {
                        handleObjIn = handler;
                        handler = handleObjIn.handler;
                        selector = handleObjIn.selector;
                    }

                    // Ensure that invalid selectors throw exceptions at attach time
                    // Evaluate against documentElement in case elem is a non-element node (e.g., document)
                    if ( selector ) {
                        jQuery.find.matchesSelector( documentElement, selector );
                    }

                    // Make sure that the handler has a unique ID, used to find/remove it later
                    if ( !handler.guid ) {
                        handler.guid = jQuery.guid++;
                    }

                    // Init the element's event structure and main handler, if this is the first
                    if ( !( events = elemData.events ) ) {
                        events = elemData.events = Object.create( null );
                    }
                    if ( !( eventHandle = elemData.handle ) ) {
                        eventHandle = elemData.handle = function( e ) {

                            // Discard the second event of a jQuery.event.trigger() and
                            // when an event is called after a page has unloaded
                            return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
                                    jQuery.event.dispatch.apply( elem, arguments ) : undefined;
                        };
                    }

                    // Handle multiple events separated by a space
                    types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
                    t = types.length;
                    while ( t-- ) {
                        tmp = rtypenamespace.exec( types[ t ] ) || [];
                        type = origType = tmp[ 1 ];
                        namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

                        // There *must* be a type, no attaching namespace-only handlers
                        if ( !type ) {
                            continue;
                        }

                        // If event changes its type, use the special event handlers for the changed type
                        special = jQuery.event.special[ type ] || {};

                        // If selector defined, determine special event api type, otherwise given type
                        type = ( selector ? special.delegateType : special.bindType ) || type;

                        // Update special based on newly reset type
                        special = jQuery.event.special[ type ] || {};

                        // handleObj is passed to all event handlers
                        handleObj = jQuery.extend( {
                            type: type,
                            origType: origType,
                            data: data,
                            handler: handler,
                            guid: handler.guid,
                            selector: selector,
                            needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
                            namespace: namespaces.join( "." )
                        }, handleObjIn );

                        // Init the event handler queue if we're the first
                        if ( !( handlers = events[ type ] ) ) {
                            handlers = events[ type ] = [];
                            handlers.delegateCount = 0;

                            // Only use addEventListener if the special events handler returns false
                            if ( !special.setup ||
                                    special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

                                if ( elem.addEventListener ) {
                                    elem.addEventListener( type, eventHandle );
                                }
                            }
                        }

                        if ( special.add ) {
                            special.add.call( elem, handleObj );

                            if ( !handleObj.handler.guid ) {
                                handleObj.handler.guid = handler.guid;
                            }
                        }

                        // Add to the element's handler list, delegates in front
                        if ( selector ) {
                            handlers.splice( handlers.delegateCount++, 0, handleObj );
                        } else {
                            handlers.push( handleObj );
                        }

                        // Keep track of which events have ever been used, for event optimization
                        jQuery.event.global[ type ] = true;
                    }

                },

                // Detach an event or set of events from an element
                remove: function( elem, types, handler, selector, mappedTypes ) {

                    var j, origCount, tmp,
                            events, t, handleObj,
                            special, handlers, type, namespaces, origType,
                            elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );

                    if ( !elemData || !( events = elemData.events ) ) {
                        return;
                    }

                    // Once for each type.namespace in types; type may be omitted
                    types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
                    t = types.length;
                    while ( t-- ) {
                        tmp = rtypenamespace.exec( types[ t ] ) || [];
                        type = origType = tmp[ 1 ];
                        namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

                        // Unbind all events (on this namespace, if provided) for the element
                        if ( !type ) {
                            for ( type in events ) {
                                jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
                            }
                            continue;
                        }

                        special = jQuery.event.special[ type ] || {};
                        type = ( selector ? special.delegateType : special.bindType ) || type;
                        handlers = events[ type ] || [];
                        tmp = tmp[ 2 ] &&
                                new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

                        // Remove matching events
                        origCount = j = handlers.length;
                        while ( j-- ) {
                            handleObj = handlers[ j ];

                            if ( ( mappedTypes || origType === handleObj.origType ) &&
                                    ( !handler || handler.guid === handleObj.guid ) &&
                                    ( !tmp || tmp.test( handleObj.namespace ) ) &&
                                    ( !selector || selector === handleObj.selector ||
                                    selector === "**" && handleObj.selector ) ) {
                                handlers.splice( j, 1 );

                                if ( handleObj.selector ) {
                                    handlers.delegateCount--;
                                }
                                if ( special.remove ) {
                                    special.remove.call( elem, handleObj );
                                }
                            }
                        }

                        // Remove generic event handler if we removed something and no more handlers exist
                        // (avoids potential for endless recursion during removal of special event handlers)
                        if ( origCount && !handlers.length ) {
                            if ( !special.teardown ||
                                    special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

                                jQuery.removeEvent( elem, type, elemData.handle );
                            }

                            delete events[ type ];
                        }
                    }

                    // Remove data and the expando if it's no longer used
                    if ( jQuery.isEmptyObject( events ) ) {
                        dataPriv.remove( elem, "handle events" );
                    }
                },

                dispatch: function( nativeEvent ) {

                    var i, j, ret, matched, handleObj, handlerQueue,
                            args = new Array( arguments.length ),

                    // Make a writable jQuery.Event from the native event object
                            event = jQuery.event.fix( nativeEvent ),

                            handlers = (
                                            dataPriv.get( this, "events" ) || Object.create( null )
                                    )[ event.type ] || [],
                            special = jQuery.event.special[ event.type ] || {};

                    // Use the fix-ed jQuery.Event rather than the (read-only) native event
                    args[ 0 ] = event;

                    for ( i = 1; i < arguments.length; i++ ) {
                        args[ i ] = arguments[ i ];
                    }

                    event.delegateTarget = this;

                    // Call the preDispatch hook for the mapped type, and let it bail if desired
                    if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
                        return;
                    }

                    // Determine handlers
                    handlerQueue = jQuery.event.handlers.call( this, event, handlers );

                    // Run delegates first; they may want to stop propagation beneath us
                    i = 0;
                    while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
                        event.currentTarget = matched.elem;

                        j = 0;
                        while ( ( handleObj = matched.handlers[ j++ ] ) &&
                        !event.isImmediatePropagationStopped() ) {

                            // If the event is namespaced, then each handler is only invoked if it is
                            // specially universal or its namespaces are a superset of the event's.
                            if ( !event.rnamespace || handleObj.namespace === false ||
                                    event.rnamespace.test( handleObj.namespace ) ) {

                                event.handleObj = handleObj;
                                event.data = handleObj.data;

                                ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
                                handleObj.handler ).apply( matched.elem, args );

                                if ( ret !== undefined ) {
                                    if ( ( event.result = ret ) === false ) {
                                        event.preventDefault();
                                        event.stopPropagation();
                                    }
                                }
                            }
                        }
                    }

                    // Call the postDispatch hook for the mapped type
                    if ( special.postDispatch ) {
                        special.postDispatch.call( this, event );
                    }

                    return event.result;
                },

                handlers: function( event, handlers ) {
                    var i, handleObj, sel, matchedHandlers, matchedSelectors,
                            handlerQueue = [],
                            delegateCount = handlers.delegateCount,
                            cur = event.target;

                    // Find delegate handlers
                    if ( delegateCount &&

                            // Support: IE <=9
                            // Black-hole SVG <use> instance trees (trac-13180)
                            cur.nodeType &&

                            // Support: Firefox <=42
                            // Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
                            // https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
                            // Support: IE 11 only
                            // ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
                            !( event.type === "click" && event.button >= 1 ) ) {

                        for ( ; cur !== this; cur = cur.parentNode || this ) {

                            // Don't check non-elements (#13208)
                            // Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
                            if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
                                matchedHandlers = [];
                                matchedSelectors = {};
                                for ( i = 0; i < delegateCount; i++ ) {
                                    handleObj = handlers[ i ];

                                    // Don't conflict with Object.prototype properties (#13203)
                                    sel = handleObj.selector + " ";

                                    if ( matchedSelectors[ sel ] === undefined ) {
                                        matchedSelectors[ sel ] = handleObj.needsContext ?
                                        jQuery( sel, this ).index( cur ) > -1 :
                                                jQuery.find( sel, this, null, [ cur ] ).length;
                                    }
                                    if ( matchedSelectors[ sel ] ) {
                                        matchedHandlers.push( handleObj );
                                    }
                                }
                                if ( matchedHandlers.length ) {
                                    handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
                                }
                            }
                        }
                    }

                    // Add the remaining (directly-bound) handlers
                    cur = this;
                    if ( delegateCount < handlers.length ) {
                        handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
                    }

                    return handlerQueue;
                },

                addProp: function( name, hook ) {
                    Object.defineProperty( jQuery.Event.prototype, name, {
                        enumerable: true,
                        configurable: true,

                        get: isFunction( hook ) ?
                                function() {
                                    if ( this.originalEvent ) {
                                        return hook( this.originalEvent );
                                    }
                                } :
                                function() {
                                    if ( this.originalEvent ) {
                                        return this.originalEvent[ name ];
                                    }
                                },

                        set: function( value ) {
                            Object.defineProperty( this, name, {
                                enumerable: true,
                                configurable: true,
                                writable: true,
                                value: value
                            } );
                        }
                    } );
                },

                fix: function( originalEvent ) {
                    return originalEvent[ jQuery.expando ] ?
                            originalEvent :
                            new jQuery.Event( originalEvent );
                },

                special: {
                    load: {

                        // Prevent triggered image.load events from bubbling to window.load
                        noBubble: true
                    },
                    click: {

                        // Utilize native event to ensure correct state for checkable inputs
                        setup: function( data ) {

                            // For mutual compressibility with _default, replace `this` access with a local var.
                            // `|| data` is dead code meant only to preserve the variable through minification.
                            var el = this || data;

                            // Claim the first handler
                            if ( rcheckableType.test( el.type ) &&
                                    el.click && nodeName( el, "input" ) ) {

                                // dataPriv.set( el, "click", ... )
                                leverageNative( el, "click", returnTrue );
                            }

                            // Return false to allow normal processing in the caller
                            return false;
                        },
                        trigger: function( data ) {

                            // For mutual compressibility with _default, replace `this` access with a local var.
                            // `|| data` is dead code meant only to preserve the variable through minification.
                            var el = this || data;

                            // Force setup before triggering a click
                            if ( rcheckableType.test( el.type ) &&
                                    el.click && nodeName( el, "input" ) ) {

                                leverageNative( el, "click" );
                            }

                            // Return non-false to allow normal event-path propagation
                            return true;
                        },

                        // For cross-browser consistency, suppress native .click() on links
                        // Also prevent it if we're currently inside a leveraged native-event stack
                        _default: function( event ) {
                            var target = event.target;
                            return rcheckableType.test( target.type ) &&
                                    target.click && nodeName( target, "input" ) &&
                                    dataPriv.get( target, "click" ) ||
                                    nodeName( target, "a" );
                        }
                    },

                    beforeunload: {
                        postDispatch: function( event ) {

                            // Support: Firefox 20+
                            // Firefox doesn't alert if the returnValue field is not set.
                            if ( event.result !== undefined && event.originalEvent ) {
                                event.originalEvent.returnValue = event.result;
                            }
                        }
                    }
                }
            };

// Ensure the presence of an event listener that handles manually-triggered
// synthetic events by interrupting progress until reinvoked in response to
// *native* events that it fires directly, ensuring that state changes have
// already occurred before other listeners are invoked.
            function leverageNative( el, type, expectSync ) {

                // Missing expectSync indicates a trigger call, which must force setup through jQuery.event.add
                if ( !expectSync ) {
                    if ( dataPriv.get( el, type ) === undefined ) {
                        jQuery.event.add( el, type, returnTrue );
                    }
                    return;
                }

                // Register the controller as a special universal handler for all event namespaces
                dataPriv.set( el, type, false );
                jQuery.event.add( el, type, {
                    namespace: false,
                    handler: function( event ) {
                        var notAsync, result,
                                saved = dataPriv.get( this, type );

                        if ( ( event.isTrigger & 1 ) && this[ type ] ) {

                            // Interrupt processing of the outer synthetic .trigger()ed event
                            // Saved data should be false in such cases, but might be a leftover capture object
                            // from an async native handler (gh-4350)
                            if ( !saved.length ) {

                                // Store arguments for use when handling the inner native event
                                // There will always be at least one argument (an event object), so this array
                                // will not be confused with a leftover capture object.
                                saved = slice.call( arguments );
                                dataPriv.set( this, type, saved );

                                // Trigger the native event and capture its result
                                // Support: IE <=9 - 11+
                                // focus() and blur() are asynchronous
                                notAsync = expectSync( this, type );
                                this[ type ]();
                                result = dataPriv.get( this, type );
                                if ( saved !== result || notAsync ) {
                                    dataPriv.set( this, type, false );
                                } else {
                                    result = {};
                                }
                                if ( saved !== result ) {

                                    // Cancel the outer synthetic event
                                    event.stopImmediatePropagation();
                                    event.preventDefault();
                                    return result.value;
                                }

                                // If this is an inner synthetic event for an event with a bubbling surrogate
                                // (focus or blur), assume that the surrogate already propagated from triggering the
                                // native event and prevent that from happening again here.
                                // This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
                                // bubbling surrogate propagates *after* the non-bubbling base), but that seems
                                // less bad than duplication.
                            } else if ( ( jQuery.event.special[ type ] || {} ).delegateType ) {
                                event.stopPropagation();
                            }

                            // If this is a native event triggered above, everything is now in order
                            // Fire an inner synthetic event with the original arguments
                        } else if ( saved.length ) {

                            // ...and capture the result
                            dataPriv.set( this, type, {
                                value: jQuery.event.trigger(

                                        // Support: IE <=9 - 11+
                                        // Extend with the prototype to reset the above stopImmediatePropagation()
                                        jQuery.extend( saved[ 0 ], jQuery.Event.prototype ),
                                        saved.slice( 1 ),
                                        this
                                )
                            } );

                            // Abort handling of the native event
                            event.stopImmediatePropagation();
                        }
                    }
                } );
            }

            jQuery.removeEvent = function( elem, type, handle ) {

                // This "if" is needed for plain objects
                if ( elem.removeEventListener ) {
                    elem.removeEventListener( type, handle );
                }
            };

            jQuery.Event = function( src, props ) {

                // Allow instantiation without the 'new' keyword
                if ( !( this instanceof jQuery.Event ) ) {
                    return new jQuery.Event( src, props );
                }

                // Event object
                if ( src && src.type ) {
                    this.originalEvent = src;
                    this.type = src.type;

                    // Events bubbling up the document may have been marked as prevented
                    // by a handler lower down the tree; reflect the correct value.
                    this.isDefaultPrevented = src.defaultPrevented ||
                    src.defaultPrevented === undefined &&

                    // Support: Android <=2.3 only
                    src.returnValue === false ?
                            returnTrue :
                            returnFalse;

                    // Create target properties
                    // Support: Safari <=6 - 7 only
                    // Target should not be a text node (#504, #13143)
                    this.target = ( src.target && src.target.nodeType === 3 ) ?
                            src.target.parentNode :
                            src.target;

                    this.currentTarget = src.currentTarget;
                    this.relatedTarget = src.relatedTarget;

                    // Event type
                } else {
                    this.type = src;
                }

                // Put explicitly provided properties onto the event object
                if ( props ) {
                    jQuery.extend( this, props );
                }

                // Create a timestamp if incoming event doesn't have one
                this.timeStamp = src && src.timeStamp || Date.now();

                // Mark it as fixed
                this[ jQuery.expando ] = true;
            };

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
            jQuery.Event.prototype = {
                constructor: jQuery.Event,
                isDefaultPrevented: returnFalse,
                isPropagationStopped: returnFalse,
                isImmediatePropagationStopped: returnFalse,
                isSimulated: false,

                preventDefault: function() {
                    var e = this.originalEvent;

                    this.isDefaultPrevented = returnTrue;

                    if ( e && !this.isSimulated ) {
                        e.preventDefault();
                    }
                },
                stopPropagation: function() {
                    var e = this.originalEvent;

                    this.isPropagationStopped = returnTrue;

                    if ( e && !this.isSimulated ) {
                        e.stopPropagation();
                    }
                },
                stopImmediatePropagation: function() {
                    var e = this.originalEvent;

                    this.isImmediatePropagationStopped = returnTrue;

                    if ( e && !this.isSimulated ) {
                        e.stopImmediatePropagation();
                    }

                    this.stopPropagation();
                }
            };

// Includes all common event props including KeyEvent and MouseEvent specific props
            jQuery.each( {
                altKey: true,
                bubbles: true,
                cancelable: true,
                changedTouches: true,
                ctrlKey: true,
                detail: true,
                eventPhase: true,
                metaKey: true,
                pageX: true,
                pageY: true,
                shiftKey: true,
                view: true,
                "char": true,
                code: true,
                charCode: true,
                key: true,
                keyCode: true,
                button: true,
                buttons: true,
                clientX: true,
                clientY: true,
                offsetX: true,
                offsetY: true,
                pointerId: true,
                pointerType: true,
                screenX: true,
                screenY: true,
                targetTouches: true,
                toElement: true,
                touches: true,

                which: function( event ) {
                    var button = event.button;

                    // Add which for key events
                    if ( event.which == null && rkeyEvent.test( event.type ) ) {
                        return event.charCode != null ? event.charCode : event.keyCode;
                    }

                    // Add which for click: 1 === left; 2 === middle; 3 === right
                    if ( !event.which && button !== undefined && rmouseEvent.test( event.type ) ) {
                        if ( button & 1 ) {
                            return 1;
                        }

                        if ( button & 2 ) {
                            return 3;
                        }

                        if ( button & 4 ) {
                            return 2;
                        }

                        return 0;
                    }

                    return event.which;
                }
            }, jQuery.event.addProp );

            jQuery.each( { focus: "focusin", blur: "focusout" }, function( type, delegateType ) {
                jQuery.event.special[ type ] = {

                    // Utilize native event if possible so blur/focus sequence is correct
                    setup: function() {

                        // Claim the first handler
                        // dataPriv.set( this, "focus", ... )
                        // dataPriv.set( this, "blur", ... )
                        leverageNative( this, type, expectSync );

                        // Return false to allow normal processing in the caller
                        return false;
                    },
                    trigger: function() {

                        // Force setup before trigger
                        leverageNative( this, type );

                        // Return non-false to allow normal event-path propagation
                        return true;
                    },

                    delegateType: delegateType
                };
            } );

// Create mouseenter/leave events using mouseover/out and event-time checks
// so that event delegation works in jQuery.
// Do the same for pointerenter/pointerleave and pointerover/pointerout
//
// Support: Safari 7 only
// Safari sends mouseenter too often; see:
// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
// for the description of the bug (it existed in older Chrome versions as well).
            jQuery.each( {
                mouseenter: "mouseover",
                mouseleave: "mouseout",
                pointerenter: "pointerover",
                pointerleave: "pointerout"
            }, function( orig, fix ) {
                jQuery.event.special[ orig ] = {
                    delegateType: fix,
                    bindType: fix,

                    handle: function( event ) {
                        var ret,
                                target = this,
                                related = event.relatedTarget,
                                handleObj = event.handleObj;

                        // For mouseenter/leave call the handler if related is outside the target.
                        // NB: No relatedTarget if the mouse left/entered the browser window
                        if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
                            event.type = handleObj.origType;
                            ret = handleObj.handler.apply( this, arguments );
                            event.type = fix;
                        }
                        return ret;
                    }
                };
            } );

            jQuery.fn.extend( {

                on: function( types, selector, data, fn ) {
                    return on( this, types, selector, data, fn );
                },
                one: function( types, selector, data, fn ) {
                    return on( this, types, selector, data, fn, 1 );
                },
                off: function( types, selector, fn ) {
                    var handleObj, type;
                    if ( types && types.preventDefault && types.handleObj ) {

                        // ( event )  dispatched jQuery.Event
                        handleObj = types.handleObj;
                        jQuery( types.delegateTarget ).off(
                                handleObj.namespace ?
                                handleObj.origType + "." + handleObj.namespace :
                                        handleObj.origType,
                                handleObj.selector,
                                handleObj.handler
                        );
                        return this;
                    }
                    if ( typeof types === "object" ) {

                        // ( types-object [, selector] )
                        for ( type in types ) {
                            this.off( type, selector, types[ type ] );
                        }
                        return this;
                    }
                    if ( selector === false || typeof selector === "function" ) {

                        // ( types [, fn] )
                        fn = selector;
                        selector = undefined;
                    }
                    if ( fn === false ) {
                        fn = returnFalse;
                    }
                    return this.each( function() {
                        jQuery.event.remove( this, types, fn, selector );
                    } );
                }
            } );


            var

            // Support: IE <=10 - 11, Edge 12 - 13 only
            // In IE/Edge using regex groups here causes severe slowdowns.
            // See https://connect.microsoft.com/IE/feedback/details/1736512/
                    rnoInnerhtml = /<script|<style|<link/i,

            // checked="checked" or checked
                    rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
                    rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

// Prefer a tbody over its parent table for containing new rows
            function manipulationTarget( elem, content ) {
                if ( nodeName( elem, "table" ) &&
                        nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {

                    return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
                }

                return elem;
            }

// Replace/restore the type attribute of script elements for safe DOM manipulation
            function disableScript( elem ) {
                elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
                return elem;
            }
            function restoreScript( elem ) {
                if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
                    elem.type = elem.type.slice( 5 );
                } else {
                    elem.removeAttribute( "type" );
                }

                return elem;
            }

            function cloneCopyEvent( src, dest ) {
                var i, l, type, pdataOld, udataOld, udataCur, events;

                if ( dest.nodeType !== 1 ) {
                    return;
                }

                // 1. Copy private data: events, handlers, etc.
                if ( dataPriv.hasData( src ) ) {
                    pdataOld = dataPriv.get( src );
                    events = pdataOld.events;

                    if ( events ) {
                        dataPriv.remove( dest, "handle events" );

                        for ( type in events ) {
                            for ( i = 0, l = events[ type ].length; i < l; i++ ) {
                                jQuery.event.add( dest, type, events[ type ][ i ] );
                            }
                        }
                    }
                }

                // 2. Copy user data
                if ( dataUser.hasData( src ) ) {
                    udataOld = dataUser.access( src );
                    udataCur = jQuery.extend( {}, udataOld );

                    dataUser.set( dest, udataCur );
                }
            }

// Fix IE bugs, see support tests
            function fixInput( src, dest ) {
                var nodeName = dest.nodeName.toLowerCase();

                // Fails to persist the checked state of a cloned checkbox or radio button.
                if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
                    dest.checked = src.checked;

                    // Fails to return the selected option to the default selected state when cloning options
                } else if ( nodeName === "input" || nodeName === "textarea" ) {
                    dest.defaultValue = src.defaultValue;
                }
            }

            function domManip( collection, args, callback, ignored ) {

                // Flatten any nested arrays
                args = flat( args );

                var fragment, first, scripts, hasScripts, node, doc,
                        i = 0,
                        l = collection.length,
                        iNoClone = l - 1,
                        value = args[ 0 ],
                        valueIsFunction = isFunction( value );

                // We can't cloneNode fragments that contain checked, in WebKit
                if ( valueIsFunction ||
                        ( l > 1 && typeof value === "string" &&
                        !support.checkClone && rchecked.test( value ) ) ) {
                    return collection.each( function( index ) {
                        var self = collection.eq( index );
                        if ( valueIsFunction ) {
                            args[ 0 ] = value.call( this, index, self.html() );
                        }
                        domManip( self, args, callback, ignored );
                    } );
                }

                if ( l ) {
                    fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
                    first = fragment.firstChild;

                    if ( fragment.childNodes.length === 1 ) {
                        fragment = first;
                    }

                    // Require either new content or an interest in ignored elements to invoke the callback
                    if ( first || ignored ) {
                        scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
                        hasScripts = scripts.length;

                        // Use the original fragment for the last item
                        // instead of the first because it can end up
                        // being emptied incorrectly in certain situations (#8070).
                        for ( ; i < l; i++ ) {
                            node = fragment;

                            if ( i !== iNoClone ) {
                                node = jQuery.clone( node, true, true );

                                // Keep references to cloned scripts for later restoration
                                if ( hasScripts ) {

                                    // Support: Android <=4.0 only, PhantomJS 1 only
                                    // push.apply(_, arraylike) throws on ancient WebKit
                                    jQuery.merge( scripts, getAll( node, "script" ) );
                                }
                            }

                            callback.call( collection[ i ], node, i );
                        }

                        if ( hasScripts ) {
                            doc = scripts[ scripts.length - 1 ].ownerDocument;

                            // Reenable scripts
                            jQuery.map( scripts, restoreScript );

                            // Evaluate executable scripts on first document insertion
                            for ( i = 0; i < hasScripts; i++ ) {
                                node = scripts[ i ];
                                if ( rscriptType.test( node.type || "" ) &&
                                        !dataPriv.access( node, "globalEval" ) &&
                                        jQuery.contains( doc, node ) ) {

                                    if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {

                                        // Optional AJAX dependency, but won't run scripts if not present
                                        if ( jQuery._evalUrl && !node.noModule ) {
                                            jQuery._evalUrl( node.src, {
                                                nonce: node.nonce || node.getAttribute( "nonce" )
                                            }, doc );
                                        }
                                    } else {
                                        DOMEval( node.textContent.replace( rcleanScript, "" ), node, doc );
                                    }
                                }
                            }
                        }
                    }
                }

                return collection;
            }

            function remove( elem, selector, keepData ) {
                var node,
                        nodes = selector ? jQuery.filter( selector, elem ) : elem,
                        i = 0;

                for ( ; ( node = nodes[ i ] ) != null; i++ ) {
                    if ( !keepData && node.nodeType === 1 ) {
                        jQuery.cleanData( getAll( node ) );
                    }

                    if ( node.parentNode ) {
                        if ( keepData && isAttached( node ) ) {
                            setGlobalEval( getAll( node, "script" ) );
                        }
                        node.parentNode.removeChild( node );
                    }
                }

                return elem;
            }

            jQuery.extend( {
                htmlPrefilter: function( html ) {
                    return html;
                },

                clone: function( elem, dataAndEvents, deepDataAndEvents ) {
                    var i, l, srcElements, destElements,
                            clone = elem.cloneNode( true ),
                            inPage = isAttached( elem );

                    // Fix IE cloning issues
                    if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
                            !jQuery.isXMLDoc( elem ) ) {

                        // We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
                        destElements = getAll( clone );
                        srcElements = getAll( elem );

                        for ( i = 0, l = srcElements.length; i < l; i++ ) {
                            fixInput( srcElements[ i ], destElements[ i ] );
                        }
                    }

                    // Copy the events from the original to the clone
                    if ( dataAndEvents ) {
                        if ( deepDataAndEvents ) {
                            srcElements = srcElements || getAll( elem );
                            destElements = destElements || getAll( clone );

                            for ( i = 0, l = srcElements.length; i < l; i++ ) {
                                cloneCopyEvent( srcElements[ i ], destElements[ i ] );
                            }
                        } else {
                            cloneCopyEvent( elem, clone );
                        }
                    }

                    // Preserve script evaluation history
                    destElements = getAll( clone, "script" );
                    if ( destElements.length > 0 ) {
                        setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
                    }

                    // Return the cloned set
                    return clone;
                },

                cleanData: function( elems ) {
                    var data, elem, type,
                            special = jQuery.event.special,
                            i = 0;

                    for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
                        if ( acceptData( elem ) ) {
                            if ( ( data = elem[ dataPriv.expando ] ) ) {
                                if ( data.events ) {
                                    for ( type in data.events ) {
                                        if ( special[ type ] ) {
                                            jQuery.event.remove( elem, type );

                                            // This is a shortcut to avoid jQuery.event.remove's overhead
                                        } else {
                                            jQuery.removeEvent( elem, type, data.handle );
                                        }
                                    }
                                }

                                // Support: Chrome <=35 - 45+
                                // Assign undefined instead of using delete, see Data#remove
                                elem[ dataPriv.expando ] = undefined;
                            }
                            if ( elem[ dataUser.expando ] ) {

                                // Support: Chrome <=35 - 45+
                                // Assign undefined instead of using delete, see Data#remove
                                elem[ dataUser.expando ] = undefined;
                            }
                        }
                    }
                }
            } );

            jQuery.fn.extend( {
                detach: function( selector ) {
                    return remove( this, selector, true );
                },

                remove: function( selector ) {
                    return remove( this, selector );
                },

                text: function( value ) {
                    return access( this, function( value ) {
                        return value === undefined ?
                                jQuery.text( this ) :
                                this.empty().each( function() {
                                    if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
                                        this.textContent = value;
                                    }
                                } );
                    }, null, value, arguments.length );
                },

                append: function() {
                    return domManip( this, arguments, function( elem ) {
                        if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
                            var target = manipulationTarget( this, elem );
                            target.appendChild( elem );
                        }
                    } );
                },

                prepend: function() {
                    return domManip( this, arguments, function( elem ) {
                        if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
                            var target = manipulationTarget( this, elem );
                            target.insertBefore( elem, target.firstChild );
                        }
                    } );
                },

                before: function() {
                    return domManip( this, arguments, function( elem ) {
                        if ( this.parentNode ) {
                            this.parentNode.insertBefore( elem, this );
                        }
                    } );
                },

                after: function() {
                    return domManip( this, arguments, function( elem ) {
                        if ( this.parentNode ) {
                            this.parentNode.insertBefore( elem, this.nextSibling );
                        }
                    } );
                },

                empty: function() {
                    var elem,
                            i = 0;

                    for ( ; ( elem = this[ i ] ) != null; i++ ) {
                        if ( elem.nodeType === 1 ) {

                            // Prevent memory leaks
                            jQuery.cleanData( getAll( elem, false ) );

                            // Remove any remaining nodes
                            elem.textContent = "";
                        }
                    }

                    return this;
                },

                clone: function( dataAndEvents, deepDataAndEvents ) {
                    dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
                    deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

                    return this.map( function() {
                        return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
                    } );
                },

                html: function( value ) {
                    return access( this, function( value ) {
                        var elem = this[ 0 ] || {},
                                i = 0,
                                l = this.length;

                        if ( value === undefined && elem.nodeType === 1 ) {
                            return elem.innerHTML;
                        }

                        // See if we can take a shortcut and just use innerHTML
                        if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
                                !wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

                            value = jQuery.htmlPrefilter( value );

                            try {
                                for ( ; i < l; i++ ) {
                                    elem = this[ i ] || {};

                                    // Remove element nodes and prevent memory leaks
                                    if ( elem.nodeType === 1 ) {
                                        jQuery.cleanData( getAll( elem, false ) );
                                        elem.innerHTML = value;
                                    }
                                }

                                elem = 0;

                                // If using innerHTML throws an exception, use the fallback method
                            } catch ( e ) {}
                        }

                        if ( elem ) {
                            this.empty().append( value );
                        }
                    }, null, value, arguments.length );
                },

                replaceWith: function() {
                    var ignored = [];

                    // Make the changes, replacing each non-ignored context element with the new content
                    return domManip( this, arguments, function( elem ) {
                        var parent = this.parentNode;

                        if ( jQuery.inArray( this, ignored ) < 0 ) {
                            jQuery.cleanData( getAll( this ) );
                            if ( parent ) {
                                parent.replaceChild( elem, this );
                            }
                        }

                        // Force callback invocation
                    }, ignored );
                }
            } );

            jQuery.each( {
                appendTo: "append",
                prependTo: "prepend",
                insertBefore: "before",
                insertAfter: "after",
                replaceAll: "replaceWith"
            }, function( name, original ) {
                jQuery.fn[ name ] = function( selector ) {
                    var elems,
                            ret = [],
                            insert = jQuery( selector ),
                            last = insert.length - 1,
                            i = 0;

                    for ( ; i <= last; i++ ) {
                        elems = i === last ? this : this.clone( true );
                        jQuery( insert[ i ] )[ original ]( elems );

                        // Support: Android <=4.0 only, PhantomJS 1 only
                        // .get() because push.apply(_, arraylike) throws on ancient WebKit
                        push.apply( ret, elems.get() );
                    }

                    return this.pushStack( ret );
                };
            } );
            var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

            var getStyles = function( elem ) {

                // Support: IE <=11 only, Firefox <=30 (#15098, #14150)
                // IE throws on elements created in popups
                // FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
                var view = elem.ownerDocument.defaultView;

                if ( !view || !view.opener ) {
                    view = window;
                }

                return view.getComputedStyle( elem );
            };

            var swap = function( elem, options, callback ) {
                var ret, name,
                        old = {};

                // Remember the old values, and insert the new ones
                for ( name in options ) {
                    old[ name ] = elem.style[ name ];
                    elem.style[ name ] = options[ name ];
                }

                ret = callback.call( elem );

                // Revert the old values
                for ( name in options ) {
                    elem.style[ name ] = old[ name ];
                }

                return ret;
            };


            var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );



            ( function() {

                // Executing both pixelPosition & boxSizingReliable tests require only one layout
                // so they're executed at the same time to save the second computation.
                function computeStyleTests() {

                    // This is a singleton, we need to execute it only once
                    if ( !div ) {
                        return;
                    }

                    container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
                            "margin-top:1px;padding:0;border:0";
                    div.style.cssText =
                            "position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
                            "margin:auto;border:1px;padding:1px;" +
                            "width:60%;top:1%";
                    documentElement.appendChild( container ).appendChild( div );

                    var divStyle = window.getComputedStyle( div );
                    pixelPositionVal = divStyle.top !== "1%";

                    // Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
                    reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;

                    // Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
                    // Some styles come back with percentage values, even though they shouldn't
                    div.style.right = "60%";
                    pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;

                    // Support: IE 9 - 11 only
                    // Detect misreporting of content dimensions for box-sizing:border-box elements
                    boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;

                    // Support: IE 9 only
                    // Detect overflow:scroll screwiness (gh-3699)
                    // Support: Chrome <=64
                    // Don't get tricked when zoom affects offsetWidth (gh-4029)
                    div.style.position = "absolute";
                    scrollboxSizeVal = roundPixelMeasures( div.offsetWidth / 3 ) === 12;

                    documentElement.removeChild( container );

                    // Nullify the div so it wouldn't be stored in the memory and
                    // it will also be a sign that checks already performed
                    div = null;
                }

                function roundPixelMeasures( measure ) {
                    return Math.round( parseFloat( measure ) );
                }

                var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
                        reliableTrDimensionsVal, reliableMarginLeftVal,
                        container = document.createElement( "div" ),
                        div = document.createElement( "div" );

                // Finish early in limited (non-browser) environments
                if ( !div.style ) {
                    return;
                }

                // Support: IE <=9 - 11 only
                // Style of cloned element affects source element cloned (#8908)
                div.style.backgroundClip = "content-box";
                div.cloneNode( true ).style.backgroundClip = "";
                support.clearCloneStyle = div.style.backgroundClip === "content-box";

                jQuery.extend( support, {
                    boxSizingReliable: function() {
                        computeStyleTests();
                        return boxSizingReliableVal;
                    },
                    pixelBoxStyles: function() {
                        computeStyleTests();
                        return pixelBoxStylesVal;
                    },
                    pixelPosition: function() {
                        computeStyleTests();
                        return pixelPositionVal;
                    },
                    reliableMarginLeft: function() {
                        computeStyleTests();
                        return reliableMarginLeftVal;
                    },
                    scrollboxSize: function() {
                        computeStyleTests();
                        return scrollboxSizeVal;
                    },

                    // Support: IE 9 - 11+, Edge 15 - 18+
                    // IE/Edge misreport `getComputedStyle` of table rows with width/height
                    // set in CSS while `offset*` properties report correct values.
                    // Behavior in IE 9 is more subtle than in newer versions & it passes
                    // some versions of this test; make sure not to make it pass there!
                    reliableTrDimensions: function() {
                        var table, tr, trChild, trStyle;
                        if ( reliableTrDimensionsVal == null ) {
                            table = document.createElement( "table" );
                            tr = document.createElement( "tr" );
                            trChild = document.createElement( "div" );

                            table.style.cssText = "position:absolute;left:-11111px";
                            tr.style.height = "1px";
                            trChild.style.height = "9px";

                            documentElement
                                    .appendChild( table )
                                    .appendChild( tr )
                                    .appendChild( trChild );

                            trStyle = window.getComputedStyle( tr );
                            reliableTrDimensionsVal = parseInt( trStyle.height ) > 3;

                            documentElement.removeChild( table );
                        }
                        return reliableTrDimensionsVal;
                    }
                } );
            } )();


            function curCSS( elem, name, computed ) {
                var width, minWidth, maxWidth, ret,

                // Support: Firefox 51+
                // Retrieving style before computed somehow
                // fixes an issue with getting wrong values
                // on detached elements
                        style = elem.style;

                computed = computed || getStyles( elem );

                // getPropertyValue is needed for:
                //   .css('filter') (IE 9 only, #12537)
                //   .css('--customProperty) (#3144)
                if ( computed ) {
                    ret = computed.getPropertyValue( name ) || computed[ name ];

                    if ( ret === "" && !isAttached( elem ) ) {
                        ret = jQuery.style( elem, name );
                    }

                    // A tribute to the "awesome hack by Dean Edwards"
                    // Android Browser returns percentage for some values,
                    // but width seems to be reliably pixels.
                    // This is against the CSSOM draft spec:
                    // https://drafts.csswg.org/cssom/#resolved-values
                    if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {

                        // Remember the original values
                        width = style.width;
                        minWidth = style.minWidth;
                        maxWidth = style.maxWidth;

                        // Put in the new values to get a computed value out
                        style.minWidth = style.maxWidth = style.width = ret;
                        ret = computed.width;

                        // Revert the changed values
                        style.width = width;
                        style.minWidth = minWidth;
                        style.maxWidth = maxWidth;
                    }
                }

                return ret !== undefined ?

                        // Support: IE <=9 - 11 only
                        // IE returns zIndex value as an integer.
                ret + "" :
                        ret;
            }


            function addGetHookIf( conditionFn, hookFn ) {

                // Define the hook, we'll check on the first run if it's really needed.
                return {
                    get: function() {
                        if ( conditionFn() ) {

                            // Hook not needed (or it's not possible to use it due
                            // to missing dependency), remove it.
                            delete this.get;
                            return;
                        }

                        // Hook needed; redefine it so that the support test is not executed again.
                        return ( this.get = hookFn ).apply( this, arguments );
                    }
                };
            }


            var cssPrefixes = [ "Webkit", "Moz", "ms" ],
                    emptyStyle = document.createElement( "div" ).style,
                    vendorProps = {};

// Return a vendor-prefixed property or undefined
            function vendorPropName( name ) {

                // Check for vendor prefixed names
                var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
                        i = cssPrefixes.length;

                while ( i-- ) {
                    name = cssPrefixes[ i ] + capName;
                    if ( name in emptyStyle ) {
                        return name;
                    }
                }
            }

// Return a potentially-mapped jQuery.cssProps or vendor prefixed property
            function finalPropName( name ) {
                var final = jQuery.cssProps[ name ] || vendorProps[ name ];

                if ( final ) {
                    return final;
                }
                if ( name in emptyStyle ) {
                    return name;
                }
                return vendorProps[ name ] = vendorPropName( name ) || name;
            }


            var

            // Swappable if display is none or starts with table
            // except "table", "table-cell", or "table-caption"
            // See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
                    rdisplayswap = /^(none|table(?!-c[ea]).+)/,
                    rcustomProp = /^--/,
                    cssShow = { position: "absolute", visibility: "hidden", display: "block" },
                    cssNormalTransform = {
                        letterSpacing: "0",
                        fontWeight: "400"
                    };

            function setPositiveNumber( _elem, value, subtract ) {

                // Any relative (+/-) values have already been
                // normalized at this point
                var matches = rcssNum.exec( value );
                return matches ?

                        // Guard against undefined "subtract", e.g., when used as in cssHooks
                Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
                        value;
            }

            function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
                var i = dimension === "width" ? 1 : 0,
                        extra = 0,
                        delta = 0;

                // Adjustment may not be necessary
                if ( box === ( isBorderBox ? "border" : "content" ) ) {
                    return 0;
                }

                for ( ; i < 4; i += 2 ) {

                    // Both box models exclude margin
                    if ( box === "margin" ) {
                        delta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
                    }

                    // If we get here with a content-box, we're seeking "padding" or "border" or "margin"
                    if ( !isBorderBox ) {

                        // Add padding
                        delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

                        // For "border" or "margin", add border
                        if ( box !== "padding" ) {
                            delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );

                            // But still keep track of it otherwise
                        } else {
                            extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
                        }

                        // If we get here with a border-box (content + padding + border), we're seeking "content" or
                        // "padding" or "margin"
                    } else {

                        // For "content", subtract padding
                        if ( box === "content" ) {
                            delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
                        }

                        // For "content" or "padding", subtract border
                        if ( box !== "margin" ) {
                            delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
                        }
                    }
                }

                // Account for positive content-box scroll gutter when requested by providing computedVal
                if ( !isBorderBox && computedVal >= 0 ) {

                    // offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
                    // Assuming integer scroll gutter, subtract the rest and round down
                    delta += Math.max( 0, Math.ceil(
                                    elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
                                    computedVal -
                                    delta -
                                    extra -
                                    0.5

                                    // If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
                                    // Use an explicit zero to avoid NaN (gh-3964)
                            ) ) || 0;
                }

                return delta;
            }

            function getWidthOrHeight( elem, dimension, extra ) {

                // Start with computed style
                var styles = getStyles( elem ),

                // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
                // Fake content-box until we know it's needed to know the true value.
                        boxSizingNeeded = !support.boxSizingReliable() || extra,
                        isBorderBox = boxSizingNeeded &&
                                jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
                        valueIsBorderBox = isBorderBox,

                        val = curCSS( elem, dimension, styles ),
                        offsetProp = "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 );

                // Support: Firefox <=54
                // Return a confounding non-pixel value or feign ignorance, as appropriate.
                if ( rnumnonpx.test( val ) ) {
                    if ( !extra ) {
                        return val;
                    }
                    val = "auto";
                }


                // Support: IE 9 - 11 only
                // Use offsetWidth/offsetHeight for when box sizing is unreliable.
                // In those cases, the computed value can be trusted to be border-box.
                if ( ( !support.boxSizingReliable() && isBorderBox ||

                        // Support: IE 10 - 11+, Edge 15 - 18+
                        // IE/Edge misreport `getComputedStyle` of table rows with width/height
                        // set in CSS while `offset*` properties report correct values.
                        // Interestingly, in some cases IE 9 doesn't suffer from this issue.
                        !support.reliableTrDimensions() && nodeName( elem, "tr" ) ||

                        // Fall back to offsetWidth/offsetHeight when value is "auto"
                        // This happens for inline elements with no explicit setting (gh-3571)
                        val === "auto" ||

                        // Support: Android <=4.1 - 4.3 only
                        // Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
                        !parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) &&

                        // Make sure the element is visible & connected
                        elem.getClientRects().length ) {

                    isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";

                    // Where available, offsetWidth/offsetHeight approximate border box dimensions.
                    // Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
                    // retrieved value as a content box dimension.
                    valueIsBorderBox = offsetProp in elem;
                    if ( valueIsBorderBox ) {
                        val = elem[ offsetProp ];
                    }
                }

                // Normalize "" and auto
                val = parseFloat( val ) || 0;

                // Adjust for the element's box model
                return ( val +
                                boxModelAdjustment(
                                        elem,
                                        dimension,
                                        extra || ( isBorderBox ? "border" : "content" ),
                                        valueIsBorderBox,
                                        styles,

                                        // Provide the current computed size to request scroll gutter calculation (gh-3589)
                                        val
                                )
                        ) + "px";
            }

            jQuery.extend( {

                // Add in style property hooks for overriding the default
                // behavior of getting and setting a style property
                cssHooks: {
                    opacity: {
                        get: function( elem, computed ) {
                            if ( computed ) {

                                // We should always get a number back from opacity
                                var ret = curCSS( elem, "opacity" );
                                return ret === "" ? "1" : ret;
                            }
                        }
                    }
                },

                // Don't automatically add "px" to these possibly-unitless properties
                cssNumber: {
                    "animationIterationCount": true,
                    "columnCount": true,
                    "fillOpacity": true,
                    "flexGrow": true,
                    "flexShrink": true,
                    "fontWeight": true,
                    "gridArea": true,
                    "gridColumn": true,
                    "gridColumnEnd": true,
                    "gridColumnStart": true,
                    "gridRow": true,
                    "gridRowEnd": true,
                    "gridRowStart": true,
                    "lineHeight": true,
                    "opacity": true,
                    "order": true,
                    "orphans": true,
                    "widows": true,
                    "zIndex": true,
                    "zoom": true
                },

                // Add in properties whose names you wish to fix before
                // setting or getting the value
                cssProps: {},

                // Get and set the style property on a DOM Node
                style: function( elem, name, value, extra ) {

                    // Don't set styles on text and comment nodes
                    if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
                        return;
                    }

                    // Make sure that we're working with the right name
                    var ret, type, hooks,
                            origName = camelCase( name ),
                            isCustomProp = rcustomProp.test( name ),
                            style = elem.style;

                    // Make sure that we're working with the right name. We don't
                    // want to query the value if it is a CSS custom property
                    // since they are user-defined.
                    if ( !isCustomProp ) {
                        name = finalPropName( origName );
                    }

                    // Gets hook for the prefixed version, then unprefixed version
                    hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

                    // Check if we're setting a value
                    if ( value !== undefined ) {
                        type = typeof value;

                        // Convert "+=" or "-=" to relative numbers (#7345)
                        if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
                            value = adjustCSS( elem, name, ret );

                            // Fixes bug #9237
                            type = "number";
                        }

                        // Make sure that null and NaN values aren't set (#7116)
                        if ( value == null || value !== value ) {
                            return;
                        }

                        // If a number was passed in, add the unit (except for certain CSS properties)
                        // The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
                        // "px" to a few hardcoded values.
                        if ( type === "number" && !isCustomProp ) {
                            value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
                        }

                        // background-* props affect original clone's values
                        if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
                            style[ name ] = "inherit";
                        }

                        // If a hook was provided, use that value, otherwise just set the specified value
                        if ( !hooks || !( "set" in hooks ) ||
                                ( value = hooks.set( elem, value, extra ) ) !== undefined ) {

                            if ( isCustomProp ) {
                                style.setProperty( name, value );
                            } else {
                                style[ name ] = value;
                            }
                        }

                    } else {

                        // If a hook was provided get the non-computed value from there
                        if ( hooks && "get" in hooks &&
                                ( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

                            return ret;
                        }

                        // Otherwise just get the value from the style object
                        return style[ name ];
                    }
                },

                css: function( elem, name, extra, styles ) {
                    var val, num, hooks,
                            origName = camelCase( name ),
                            isCustomProp = rcustomProp.test( name );

                    // Make sure that we're working with the right name. We don't
                    // want to modify the value if it is a CSS custom property
                    // since they are user-defined.
                    if ( !isCustomProp ) {
                        name = finalPropName( origName );
                    }

                    // Try prefixed name followed by the unprefixed name
                    hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

                    // If a hook was provided get the computed value from there
                    if ( hooks && "get" in hooks ) {
                        val = hooks.get( elem, true, extra );
                    }

                    // Otherwise, if a way to get the computed value exists, use that
                    if ( val === undefined ) {
                        val = curCSS( elem, name, styles );
                    }

                    // Convert "normal" to computed value
                    if ( val === "normal" && name in cssNormalTransform ) {
                        val = cssNormalTransform[ name ];
                    }

                    // Make numeric if forced or a qualifier was provided and val looks numeric
                    if ( extra === "" || extra ) {
                        num = parseFloat( val );
                        return extra === true || isFinite( num ) ? num || 0 : val;
                    }

                    return val;
                }
            } );

            jQuery.each( [ "height", "width" ], function( _i, dimension ) {
                jQuery.cssHooks[ dimension ] = {
                    get: function( elem, computed, extra ) {
                        if ( computed ) {

                            // Certain elements can have dimension info if we invisibly show them
                            // but it must have a current display style that would benefit
                            return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&

                            // Support: Safari 8+
                            // Table columns in Safari have non-zero offsetWidth & zero
                            // getBoundingClientRect().width unless display is changed.
                            // Support: IE <=11 only
                            // Running getBoundingClientRect on a disconnected node
                            // in IE throws an error.
                            ( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
                                    swap( elem, cssShow, function() {
                                        return getWidthOrHeight( elem, dimension, extra );
                                    } ) :
                                    getWidthOrHeight( elem, dimension, extra );
                        }
                    },

                    set: function( elem, value, extra ) {
                        var matches,
                                styles = getStyles( elem ),

                        // Only read styles.position if the test has a chance to fail
                        // to avoid forcing a reflow.
                                scrollboxSizeBuggy = !support.scrollboxSize() &&
                                        styles.position === "absolute",

                        // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
                                boxSizingNeeded = scrollboxSizeBuggy || extra,
                                isBorderBox = boxSizingNeeded &&
                                        jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
                                subtract = extra ?
                                        boxModelAdjustment(
                                                elem,
                                                dimension,
                                                extra,
                                                isBorderBox,
                                                styles
                                        ) :
                                        0;

                        // Account for unreliable border-box dimensions by comparing offset* to computed and
                        // faking a content-box to get border and padding (gh-3699)
                        if ( isBorderBox && scrollboxSizeBuggy ) {
                            subtract -= Math.ceil(
                                    elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
                                    parseFloat( styles[ dimension ] ) -
                                    boxModelAdjustment( elem, dimension, "border", false, styles ) -
                                    0.5
                            );
                        }

                        // Convert to pixels if value adjustment is needed
                        if ( subtract && ( matches = rcssNum.exec( value ) ) &&
                                ( matches[ 3 ] || "px" ) !== "px" ) {

                            elem.style[ dimension ] = value;
                            value = jQuery.css( elem, dimension );
                        }

                        return setPositiveNumber( elem, value, subtract );
                    }
                };
            } );

            jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
                    function( elem, computed ) {
                        if ( computed ) {
                            return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
                                            elem.getBoundingClientRect().left -
                                            swap( elem, { marginLeft: 0 }, function() {
                                                return elem.getBoundingClientRect().left;
                                            } )
                                    ) + "px";
                        }
                    }
            );

// These hooks are used by animate to expand properties
            jQuery.each( {
                margin: "",
                padding: "",
                border: "Width"
            }, function( prefix, suffix ) {
                jQuery.cssHooks[ prefix + suffix ] = {
                    expand: function( value ) {
                        var i = 0,
                                expanded = {},

                        // Assumes a single number if not a string
                                parts = typeof value === "string" ? value.split( " " ) : [ value ];

                        for ( ; i < 4; i++ ) {
                            expanded[ prefix + cssExpand[ i ] + suffix ] =
                                    parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
                        }

                        return expanded;
                    }
                };

                if ( prefix !== "margin" ) {
                    jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
                }
            } );

            jQuery.fn.extend( {
                css: function( name, value ) {
                    return access( this, function( elem, name, value ) {
                        var styles, len,
                                map = {},
                                i = 0;

                        if ( Array.isArray( name ) ) {
                            styles = getStyles( elem );
                            len = name.length;

                            for ( ; i < len; i++ ) {
                                map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
                            }

                            return map;
                        }

                        return value !== undefined ?
                                jQuery.style( elem, name, value ) :
                                jQuery.css( elem, name );
                    }, name, value, arguments.length > 1 );
                }
            } );


            function Tween( elem, options, prop, end, easing ) {
                return new Tween.prototype.init( elem, options, prop, end, easing );
            }
            jQuery.Tween = Tween;

            Tween.prototype = {
                constructor: Tween,
                init: function( elem, options, prop, end, easing, unit ) {
                    this.elem = elem;
                    this.prop = prop;
                    this.easing = easing || jQuery.easing._default;
                    this.options = options;
                    this.start = this.now = this.cur();
                    this.end = end;
                    this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
                },
                cur: function() {
                    var hooks = Tween.propHooks[ this.prop ];

                    return hooks && hooks.get ?
                            hooks.get( this ) :
                            Tween.propHooks._default.get( this );
                },
                run: function( percent ) {
                    var eased,
                            hooks = Tween.propHooks[ this.prop ];

                    if ( this.options.duration ) {
                        this.pos = eased = jQuery.easing[ this.easing ](
                                percent, this.options.duration * percent, 0, 1, this.options.duration
                        );
                    } else {
                        this.pos = eased = percent;
                    }
                    this.now = ( this.end - this.start ) * eased + this.start;

                    if ( this.options.step ) {
                        this.options.step.call( this.elem, this.now, this );
                    }

                    if ( hooks && hooks.set ) {
                        hooks.set( this );
                    } else {
                        Tween.propHooks._default.set( this );
                    }
                    return this;
                }
            };

            Tween.prototype.init.prototype = Tween.prototype;

            Tween.propHooks = {
                _default: {
                    get: function( tween ) {
                        var result;

                        // Use a property on the element directly when it is not a DOM element,
                        // or when there is no matching style property that exists.
                        if ( tween.elem.nodeType !== 1 ||
                                tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
                            return tween.elem[ tween.prop ];
                        }

                        // Passing an empty string as a 3rd parameter to .css will automatically
                        // attempt a parseFloat and fallback to a string if the parse fails.
                        // Simple values such as "10px" are parsed to Float;
                        // complex values such as "rotate(1rad)" are returned as-is.
                        result = jQuery.css( tween.elem, tween.prop, "" );

                        // Empty strings, null, undefined and "auto" are converted to 0.
                        return !result || result === "auto" ? 0 : result;
                    },
                    set: function( tween ) {

                        // Use step hook for back compat.
                        // Use cssHook if its there.
                        // Use .style if available and use plain properties where available.
                        if ( jQuery.fx.step[ tween.prop ] ) {
                            jQuery.fx.step[ tween.prop ]( tween );
                        } else if ( tween.elem.nodeType === 1 && (
                                jQuery.cssHooks[ tween.prop ] ||
                                tween.elem.style[ finalPropName( tween.prop ) ] != null ) ) {
                            jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
                        } else {
                            tween.elem[ tween.prop ] = tween.now;
                        }
                    }
                }
            };

// Support: IE <=9 only
// Panic based approach to setting things on disconnected nodes
            Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
                set: function( tween ) {
                    if ( tween.elem.nodeType && tween.elem.parentNode ) {
                        tween.elem[ tween.prop ] = tween.now;
                    }
                }
            };

            jQuery.easing = {
                linear: function( p ) {
                    return p;
                },
                swing: function( p ) {
                    return 0.5 - Math.cos( p * Math.PI ) / 2;
                },
                _default: "swing"
            };

            jQuery.fx = Tween.prototype.init;

// Back compat <1.8 extension point
            jQuery.fx.step = {};




            var
                    fxNow, inProgress,
                    rfxtypes = /^(?:toggle|show|hide)$/,
                    rrun = /queueHooks$/;

            function schedule() {
                if ( inProgress ) {
                    if ( document.hidden === false && window.requestAnimationFrame ) {
                        window.requestAnimationFrame( schedule );
                    } else {
                        window.setTimeout( schedule, jQuery.fx.interval );
                    }

                    jQuery.fx.tick();
                }
            }

// Animations created synchronously will run synchronously
            function createFxNow() {
                window.setTimeout( function() {
                    fxNow = undefined;
                } );
                return ( fxNow = Date.now() );
            }

// Generate parameters to create a standard animation
            function genFx( type, includeWidth ) {
                var which,
                        i = 0,
                        attrs = { height: type };

                // If we include width, step value is 1 to do all cssExpand values,
                // otherwise step value is 2 to skip over Left and Right
                includeWidth = includeWidth ? 1 : 0;
                for ( ; i < 4; i += 2 - includeWidth ) {
                    which = cssExpand[ i ];
                    attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
                }

                if ( includeWidth ) {
                    attrs.opacity = attrs.width = type;
                }

                return attrs;
            }

            function createTween( value, prop, animation ) {
                var tween,
                        collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
                        index = 0,
                        length = collection.length;
                for ( ; index < length; index++ ) {
                    if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

                        // We're done with this property
                        return tween;
                    }
                }
            }

            function defaultPrefilter( elem, props, opts ) {
                var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
                        isBox = "width" in props || "height" in props,
                        anim = this,
                        orig = {},
                        style = elem.style,
                        hidden = elem.nodeType && isHiddenWithinTree( elem ),
                        dataShow = dataPriv.get( elem, "fxshow" );

                // Queue-skipping animations hijack the fx hooks
                if ( !opts.queue ) {
                    hooks = jQuery._queueHooks( elem, "fx" );
                    if ( hooks.unqueued == null ) {
                        hooks.unqueued = 0;
                        oldfire = hooks.empty.fire;
                        hooks.empty.fire = function() {
                            if ( !hooks.unqueued ) {
                                oldfire();
                            }
                        };
                    }
                    hooks.unqueued++;

                    anim.always( function() {

                        // Ensure the complete handler is called before this completes
                        anim.always( function() {
                            hooks.unqueued--;
                            if ( !jQuery.queue( elem, "fx" ).length ) {
                                hooks.empty.fire();
                            }
                        } );
                    } );
                }

                // Detect show/hide animations
                for ( prop in props ) {
                    value = props[ prop ];
                    if ( rfxtypes.test( value ) ) {
                        delete props[ prop ];
                        toggle = toggle || value === "toggle";
                        if ( value === ( hidden ? "hide" : "show" ) ) {

                            // Pretend to be hidden if this is a "show" and
                            // there is still data from a stopped show/hide
                            if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
                                hidden = true;

                                // Ignore all other no-op show/hide data
                            } else {
                                continue;
                            }
                        }
                        orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
                    }
                }

                // Bail out if this is a no-op like .hide().hide()
                propTween = !jQuery.isEmptyObject( props );
                if ( !propTween && jQuery.isEmptyObject( orig ) ) {
                    return;
                }

                // Restrict "overflow" and "display" styles during box animations
                if ( isBox && elem.nodeType === 1 ) {

                    // Support: IE <=9 - 11, Edge 12 - 15
                    // Record all 3 overflow attributes because IE does not infer the shorthand
                    // from identically-valued overflowX and overflowY and Edge just mirrors
                    // the overflowX value there.
                    opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

                    // Identify a display type, preferring old show/hide data over the CSS cascade
                    restoreDisplay = dataShow && dataShow.display;
                    if ( restoreDisplay == null ) {
                        restoreDisplay = dataPriv.get( elem, "display" );
                    }
                    display = jQuery.css( elem, "display" );
                    if ( display === "none" ) {
                        if ( restoreDisplay ) {
                            display = restoreDisplay;
                        } else {

                            // Get nonempty value(s) by temporarily forcing visibility
                            showHide( [ elem ], true );
                            restoreDisplay = elem.style.display || restoreDisplay;
                            display = jQuery.css( elem, "display" );
                            showHide( [ elem ] );
                        }
                    }

                    // Animate inline elements as inline-block
                    if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
                        if ( jQuery.css( elem, "float" ) === "none" ) {

                            // Restore the original display value at the end of pure show/hide animations
                            if ( !propTween ) {
                                anim.done( function() {
                                    style.display = restoreDisplay;
                                } );
                                if ( restoreDisplay == null ) {
                                    display = style.display;
                                    restoreDisplay = display === "none" ? "" : display;
                                }
                            }
                            style.display = "inline-block";
                        }
                    }
                }

                if ( opts.overflow ) {
                    style.overflow = "hidden";
                    anim.always( function() {
                        style.overflow = opts.overflow[ 0 ];
                        style.overflowX = opts.overflow[ 1 ];
                        style.overflowY = opts.overflow[ 2 ];
                    } );
                }

                // Implement show/hide animations
                propTween = false;
                for ( prop in orig ) {

                    // General show/hide setup for this element animation
                    if ( !propTween ) {
                        if ( dataShow ) {
                            if ( "hidden" in dataShow ) {
                                hidden = dataShow.hidden;
                            }
                        } else {
                            dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
                        }

                        // Store hidden/visible for toggle so `.stop().toggle()` "reverses"
                        if ( toggle ) {
                            dataShow.hidden = !hidden;
                        }

                        // Show elements before animating them
                        if ( hidden ) {
                            showHide( [ elem ], true );
                        }

                        /* eslint-disable no-loop-func */

                        anim.done( function() {

                            /* eslint-enable no-loop-func */

                            // The final step of a "hide" animation is actually hiding the element
                            if ( !hidden ) {
                                showHide( [ elem ] );
                            }
                            dataPriv.remove( elem, "fxshow" );
                            for ( prop in orig ) {
                                jQuery.style( elem, prop, orig[ prop ] );
                            }
                        } );
                    }

                    // Per-property setup
                    propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
                    if ( !( prop in dataShow ) ) {
                        dataShow[ prop ] = propTween.start;
                        if ( hidden ) {
                            propTween.end = propTween.start;
                            propTween.start = 0;
                        }
                    }
                }
            }

            function propFilter( props, specialEasing ) {
                var index, name, easing, value, hooks;

                // camelCase, specialEasing and expand cssHook pass
                for ( index in props ) {
                    name = camelCase( index );
                    easing = specialEasing[ name ];
                    value = props[ index ];
                    if ( Array.isArray( value ) ) {
                        easing = value[ 1 ];
                        value = props[ index ] = value[ 0 ];
                    }

                    if ( index !== name ) {
                        props[ name ] = value;
                        delete props[ index ];
                    }

                    hooks = jQuery.cssHooks[ name ];
                    if ( hooks && "expand" in hooks ) {
                        value = hooks.expand( value );
                        delete props[ name ];

                        // Not quite $.extend, this won't overwrite existing keys.
                        // Reusing 'index' because we have the correct "name"
                        for ( index in value ) {
                            if ( !( index in props ) ) {
                                props[ index ] = value[ index ];
                                specialEasing[ index ] = easing;
                            }
                        }
                    } else {
                        specialEasing[ name ] = easing;
                    }
                }
            }

            function Animation( elem, properties, options ) {
                var result,
                        stopped,
                        index = 0,
                        length = Animation.prefilters.length,
                        deferred = jQuery.Deferred().always( function() {

                            // Don't match elem in the :animated selector
                            delete tick.elem;
                        } ),
                        tick = function() {
                            if ( stopped ) {
                                return false;
                            }
                            var currentTime = fxNow || createFxNow(),
                                    remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

                            // Support: Android 2.3 only
                            // Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
                                    temp = remaining / animation.duration || 0,
                                    percent = 1 - temp,
                                    index = 0,
                                    length = animation.tweens.length;

                            for ( ; index < length; index++ ) {
                                animation.tweens[ index ].run( percent );
                            }

                            deferred.notifyWith( elem, [ animation, percent, remaining ] );

                            // If there's more to do, yield
                            if ( percent < 1 && length ) {
                                return remaining;
                            }

                            // If this was an empty animation, synthesize a final progress notification
                            if ( !length ) {
                                deferred.notifyWith( elem, [ animation, 1, 0 ] );
                            }

                            // Resolve the animation and report its conclusion
                            deferred.resolveWith( elem, [ animation ] );
                            return false;
                        },
                        animation = deferred.promise( {
                            elem: elem,
                            props: jQuery.extend( {}, properties ),
                            opts: jQuery.extend( true, {
                                specialEasing: {},
                                easing: jQuery.easing._default
                            }, options ),
                            originalProperties: properties,
                            originalOptions: options,
                            startTime: fxNow || createFxNow(),
                            duration: options.duration,
                            tweens: [],
                            createTween: function( prop, end ) {
                                var tween = jQuery.Tween( elem, animation.opts, prop, end,
                                        animation.opts.specialEasing[ prop ] || animation.opts.easing );
                                animation.tweens.push( tween );
                                return tween;
                            },
                            stop: function( gotoEnd ) {
                                var index = 0,

                                // If we are going to the end, we want to run all the tweens
                                // otherwise we skip this part
                                        length = gotoEnd ? animation.tweens.length : 0;
                                if ( stopped ) {
                                    return this;
                                }
                                stopped = true;
                                for ( ; index < length; index++ ) {
                                    animation.tweens[ index ].run( 1 );
                                }

                                // Resolve when we played the last frame; otherwise, reject
                                if ( gotoEnd ) {
                                    deferred.notifyWith( elem, [ animation, 1, 0 ] );
                                    deferred.resolveWith( elem, [ animation, gotoEnd ] );
                                } else {
                                    deferred.rejectWith( elem, [ animation, gotoEnd ] );
                                }
                                return this;
                            }
                        } ),
                        props = animation.props;

                propFilter( props, animation.opts.specialEasing );

                for ( ; index < length; index++ ) {
                    result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
                    if ( result ) {
                        if ( isFunction( result.stop ) ) {
                            jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
                                    result.stop.bind( result );
                        }
                        return result;
                    }
                }

                jQuery.map( props, createTween, animation );

                if ( isFunction( animation.opts.start ) ) {
                    animation.opts.start.call( elem, animation );
                }

                // Attach callbacks from options
                animation
                        .progress( animation.opts.progress )
                        .done( animation.opts.done, animation.opts.complete )
                        .fail( animation.opts.fail )
                        .always( animation.opts.always );

                jQuery.fx.timer(
                        jQuery.extend( tick, {
                            elem: elem,
                            anim: animation,
                            queue: animation.opts.queue
                        } )
                );

                return animation;
            }

            jQuery.Animation = jQuery.extend( Animation, {

                tweeners: {
                    "*": [ function( prop, value ) {
                        var tween = this.createTween( prop, value );
                        adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
                        return tween;
                    } ]
                },

                tweener: function( props, callback ) {
                    if ( isFunction( props ) ) {
                        callback = props;
                        props = [ "*" ];
                    } else {
                        props = props.match( rnothtmlwhite );
                    }

                    var prop,
                            index = 0,
                            length = props.length;

                    for ( ; index < length; index++ ) {
                        prop = props[ index ];
                        Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
                        Animation.tweeners[ prop ].unshift( callback );
                    }
                },

                prefilters: [ defaultPrefilter ],

                prefilter: function( callback, prepend ) {
                    if ( prepend ) {
                        Animation.prefilters.unshift( callback );
                    } else {
                        Animation.prefilters.push( callback );
                    }
                }
            } );

            jQuery.speed = function( speed, easing, fn ) {
                var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
                    complete: fn || !fn && easing ||
                    isFunction( speed ) && speed,
                    duration: speed,
                    easing: fn && easing || easing && !isFunction( easing ) && easing
                };

                // Go to the end state if fx are off
                if ( jQuery.fx.off ) {
                    opt.duration = 0;

                } else {
                    if ( typeof opt.duration !== "number" ) {
                        if ( opt.duration in jQuery.fx.speeds ) {
                            opt.duration = jQuery.fx.speeds[ opt.duration ];

                        } else {
                            opt.duration = jQuery.fx.speeds._default;
                        }
                    }
                }

                // Normalize opt.queue - true/undefined/null -> "fx"
                if ( opt.queue == null || opt.queue === true ) {
                    opt.queue = "fx";
                }

                // Queueing
                opt.old = opt.complete;

                opt.complete = function() {
                    if ( isFunction( opt.old ) ) {
                        opt.old.call( this );
                    }

                    if ( opt.queue ) {
                        jQuery.dequeue( this, opt.queue );
                    }
                };

                return opt;
            };

            jQuery.fn.extend( {
                fadeTo: function( speed, to, easing, callback ) {

                    // Show any hidden elements after setting opacity to 0
                    return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()

                    // Animate to the value specified
                            .end().animate( { opacity: to }, speed, easing, callback );
                },
                animate: function( prop, speed, easing, callback ) {
                    var empty = jQuery.isEmptyObject( prop ),
                            optall = jQuery.speed( speed, easing, callback ),
                            doAnimation = function() {

                                // Operate on a copy of prop so per-property easing won't be lost
                                var anim = Animation( this, jQuery.extend( {}, prop ), optall );

                                // Empty animations, or finishing resolves immediately
                                if ( empty || dataPriv.get( this, "finish" ) ) {
                                    anim.stop( true );
                                }
                            };
                    doAnimation.finish = doAnimation;

                    return empty || optall.queue === false ?
                            this.each( doAnimation ) :
                            this.queue( optall.queue, doAnimation );
                },
                stop: function( type, clearQueue, gotoEnd ) {
                    var stopQueue = function( hooks ) {
                        var stop = hooks.stop;
                        delete hooks.stop;
                        stop( gotoEnd );
                    };

                    if ( typeof type !== "string" ) {
                        gotoEnd = clearQueue;
                        clearQueue = type;
                        type = undefined;
                    }
                    if ( clearQueue ) {
                        this.queue( type || "fx", [] );
                    }

                    return this.each( function() {
                        var dequeue = true,
                                index = type != null && type + "queueHooks",
                                timers = jQuery.timers,
                                data = dataPriv.get( this );

                        if ( index ) {
                            if ( data[ index ] && data[ index ].stop ) {
                                stopQueue( data[ index ] );
                            }
                        } else {
                            for ( index in data ) {
                                if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
                                    stopQueue( data[ index ] );
                                }
                            }
                        }

                        for ( index = timers.length; index--; ) {
                            if ( timers[ index ].elem === this &&
                                    ( type == null || timers[ index ].queue === type ) ) {

                                timers[ index ].anim.stop( gotoEnd );
                                dequeue = false;
                                timers.splice( index, 1 );
                            }
                        }

                        // Start the next in the queue if the last step wasn't forced.
                        // Timers currently will call their complete callbacks, which
                        // will dequeue but only if they were gotoEnd.
                        if ( dequeue || !gotoEnd ) {
                            jQuery.dequeue( this, type );
                        }
                    } );
                },
                finish: function( type ) {
                    if ( type !== false ) {
                        type = type || "fx";
                    }
                    return this.each( function() {
                        var index,
                                data = dataPriv.get( this ),
                                queue = data[ type + "queue" ],
                                hooks = data[ type + "queueHooks" ],
                                timers = jQuery.timers,
                                length = queue ? queue.length : 0;

                        // Enable finishing flag on private data
                        data.finish = true;

                        // Empty the queue first
                        jQuery.queue( this, type, [] );

                        if ( hooks && hooks.stop ) {
                            hooks.stop.call( this, true );
                        }

                        // Look for any active animations, and finish them
                        for ( index = timers.length; index--; ) {
                            if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
                                timers[ index ].anim.stop( true );
                                timers.splice( index, 1 );
                            }
                        }

                        // Look for any animations in the old queue and finish them
                        for ( index = 0; index < length; index++ ) {
                            if ( queue[ index ] && queue[ index ].finish ) {
                                queue[ index ].finish.call( this );
                            }
                        }

                        // Turn off finishing flag
                        delete data.finish;
                    } );
                }
            } );

            jQuery.each( [ "toggle", "show", "hide" ], function( _i, name ) {
                var cssFn = jQuery.fn[ name ];
                jQuery.fn[ name ] = function( speed, easing, callback ) {
                    return speed == null || typeof speed === "boolean" ?
                            cssFn.apply( this, arguments ) :
                            this.animate( genFx( name, true ), speed, easing, callback );
                };
            } );

// Generate shortcuts for custom animations
            jQuery.each( {
                slideDown: genFx( "show" ),
                slideUp: genFx( "hide" ),
                slideToggle: genFx( "toggle" ),
                fadeIn: { opacity: "show" },
                fadeOut: { opacity: "hide" },
                fadeToggle: { opacity: "toggle" }
            }, function( name, props ) {
                jQuery.fn[ name ] = function( speed, easing, callback ) {
                    return this.animate( props, speed, easing, callback );
                };
            } );

            jQuery.timers = [];
            jQuery.fx.tick = function() {
                var timer,
                        i = 0,
                        timers = jQuery.timers;

                fxNow = Date.now();

                for ( ; i < timers.length; i++ ) {
                    timer = timers[ i ];

                    // Run the timer and safely remove it when done (allowing for external removal)
                    if ( !timer() && timers[ i ] === timer ) {
                        timers.splice( i--, 1 );
                    }
                }

                if ( !timers.length ) {
                    jQuery.fx.stop();
                }
                fxNow = undefined;
            };

            jQuery.fx.timer = function( timer ) {
                jQuery.timers.push( timer );
                jQuery.fx.start();
            };

            jQuery.fx.interval = 13;
            jQuery.fx.start = function() {
                if ( inProgress ) {
                    return;
                }

                inProgress = true;
                schedule();
            };

            jQuery.fx.stop = function() {
                inProgress = null;
            };

            jQuery.fx.speeds = {
                slow: 600,
                fast: 200,

                // Default speed
                _default: 400
            };


// Based off of the plugin by Clint Helfers, with permission.
// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
            jQuery.fn.delay = function( time, type ) {
                time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
                type = type || "fx";

                return this.queue( type, function( next, hooks ) {
                    var timeout = window.setTimeout( next, time );
                    hooks.stop = function() {
                        window.clearTimeout( timeout );
                    };
                } );
            };


            ( function() {
                var input = document.createElement( "input" ),
                        select = document.createElement( "select" ),
                        opt = select.appendChild( document.createElement( "option" ) );

                input.type = "checkbox";

                // Support: Android <=4.3 only
                // Default value for a checkbox should be "on"
                support.checkOn = input.value !== "";

                // Support: IE <=11 only
                // Must access selectedIndex to make default options select
                support.optSelected = opt.selected;

                // Support: IE <=11 only
                // An input loses its value after becoming a radio
                input = document.createElement( "input" );
                input.value = "t";
                input.type = "radio";
                support.radioValue = input.value === "t";
            } )();


            var boolHook,
                    attrHandle = jQuery.expr.attrHandle;

            jQuery.fn.extend( {
                attr: function( name, value ) {
                    return access( this, jQuery.attr, name, value, arguments.length > 1 );
                },

                removeAttr: function( name ) {
                    return this.each( function() {
                        jQuery.removeAttr( this, name );
                    } );
                }
            } );

            jQuery.extend( {
                attr: function( elem, name, value ) {
                    var ret, hooks,
                            nType = elem.nodeType;

                    // Don't get/set attributes on text, comment and attribute nodes
                    if ( nType === 3 || nType === 8 || nType === 2 ) {
                        return;
                    }

                    // Fallback to prop when attributes are not supported
                    if ( typeof elem.getAttribute === "undefined" ) {
                        return jQuery.prop( elem, name, value );
                    }

                    // Attribute hooks are determined by the lowercase version
                    // Grab necessary hook if one is defined
                    if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
                        hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
                                ( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
                    }

                    if ( value !== undefined ) {
                        if ( value === null ) {
                            jQuery.removeAttr( elem, name );
                            return;
                        }

                        if ( hooks && "set" in hooks &&
                                ( ret = hooks.set( elem, value, name ) ) !== undefined ) {
                            return ret;
                        }

                        elem.setAttribute( name, value + "" );
                        return value;
                    }

                    if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
                        return ret;
                    }

                    ret = jQuery.find.attr( elem, name );

                    // Non-existent attributes return null, we normalize to undefined
                    return ret == null ? undefined : ret;
                },

                attrHooks: {
                    type: {
                        set: function( elem, value ) {
                            if ( !support.radioValue && value === "radio" &&
                                    nodeName( elem, "input" ) ) {
                                var val = elem.value;
                                elem.setAttribute( "type", value );
                                if ( val ) {
                                    elem.value = val;
                                }
                                return value;
                            }
                        }
                    }
                },

                removeAttr: function( elem, value ) {
                    var name,
                            i = 0,

                    // Attribute names can contain non-HTML whitespace characters
                    // https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
                            attrNames = value && value.match( rnothtmlwhite );

                    if ( attrNames && elem.nodeType === 1 ) {
                        while ( ( name = attrNames[ i++ ] ) ) {
                            elem.removeAttribute( name );
                        }
                    }
                }
            } );

// Hooks for boolean attributes
            boolHook = {
                set: function( elem, value, name ) {
                    if ( value === false ) {

                        // Remove boolean attributes when set to false
                        jQuery.removeAttr( elem, name );
                    } else {
                        elem.setAttribute( name, name );
                    }
                    return name;
                }
            };

            jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( _i, name ) {
                var getter = attrHandle[ name ] || jQuery.find.attr;

                attrHandle[ name ] = function( elem, name, isXML ) {
                    var ret, handle,
                            lowercaseName = name.toLowerCase();

                    if ( !isXML ) {

                        // Avoid an infinite loop by temporarily removing this function from the getter
                        handle = attrHandle[ lowercaseName ];
                        attrHandle[ lowercaseName ] = ret;
                        ret = getter( elem, name, isXML ) != null ?
                                lowercaseName :
                                null;
                        attrHandle[ lowercaseName ] = handle;
                    }
                    return ret;
                };
            } );




            var rfocusable = /^(?:input|select|textarea|button)$/i,
                    rclickable = /^(?:a|area)$/i;

            jQuery.fn.extend( {
                prop: function( name, value ) {
                    return access( this, jQuery.prop, name, value, arguments.length > 1 );
                },

                removeProp: function( name ) {
                    return this.each( function() {
                        delete this[ jQuery.propFix[ name ] || name ];
                    } );
                }
            } );

            jQuery.extend( {
                prop: function( elem, name, value ) {
                    var ret, hooks,
                            nType = elem.nodeType;

                    // Don't get/set properties on text, comment and attribute nodes
                    if ( nType === 3 || nType === 8 || nType === 2 ) {
                        return;
                    }

                    if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

                        // Fix name and attach hooks
                        name = jQuery.propFix[ name ] || name;
                        hooks = jQuery.propHooks[ name ];
                    }

                    if ( value !== undefined ) {
                        if ( hooks && "set" in hooks &&
                                ( ret = hooks.set( elem, value, name ) ) !== undefined ) {
                            return ret;
                        }

                        return ( elem[ name ] = value );
                    }

                    if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
                        return ret;
                    }

                    return elem[ name ];
                },

                propHooks: {
                    tabIndex: {
                        get: function( elem ) {

                            // Support: IE <=9 - 11 only
                            // elem.tabIndex doesn't always return the
                            // correct value when it hasn't been explicitly set
                            // https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
                            // Use proper attribute retrieval(#12072)
                            var tabindex = jQuery.find.attr( elem, "tabindex" );

                            if ( tabindex ) {
                                return parseInt( tabindex, 10 );
                            }

                            if (
                                    rfocusable.test( elem.nodeName ) ||
                                    rclickable.test( elem.nodeName ) &&
                                    elem.href
                            ) {
                                return 0;
                            }

                            return -1;
                        }
                    }
                },

                propFix: {
                    "for": "htmlFor",
                    "class": "className"
                }
            } );

// Support: IE <=11 only
// Accessing the selectedIndex property
// forces the browser to respect setting selected
// on the option
// The getter ensures a default option is selected
// when in an optgroup
// eslint rule "no-unused-expressions" is disabled for this code
// since it considers such accessions noop
            if ( !support.optSelected ) {
                jQuery.propHooks.selected = {
                    get: function( elem ) {

                        /* eslint no-unused-expressions: "off" */

                        var parent = elem.parentNode;
                        if ( parent && parent.parentNode ) {
                            parent.parentNode.selectedIndex;
                        }
                        return null;
                    },
                    set: function( elem ) {

                        /* eslint no-unused-expressions: "off" */

                        var parent = elem.parentNode;
                        if ( parent ) {
                            parent.selectedIndex;

                            if ( parent.parentNode ) {
                                parent.parentNode.selectedIndex;
                            }
                        }
                    }
                };
            }

            jQuery.each( [
                "tabIndex",
                "readOnly",
                "maxLength",
                "cellSpacing",
                "cellPadding",
                "rowSpan",
                "colSpan",
                "useMap",
                "frameBorder",
                "contentEditable"
            ], function() {
                jQuery.propFix[ this.toLowerCase() ] = this;
            } );




            // Strip and collapse whitespace according to HTML spec
            // https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
            function stripAndCollapse( value ) {
                var tokens = value.match( rnothtmlwhite ) || [];
                return tokens.join( " " );
            }


            function getClass( elem ) {
                return elem.getAttribute && elem.getAttribute( "class" ) || "";
            }

            function classesToArray( value ) {
                if ( Array.isArray( value ) ) {
                    return value;
                }
                if ( typeof value === "string" ) {
                    return value.match( rnothtmlwhite ) || [];
                }
                return [];
            }

            jQuery.fn.extend( {
                addClass: function( value ) {
                    var classes, elem, cur, curValue, clazz, j, finalValue,
                            i = 0;

                    if ( isFunction( value ) ) {
                        return this.each( function( j ) {
                            jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
                        } );
                    }

                    classes = classesToArray( value );

                    if ( classes.length ) {
                        while ( ( elem = this[ i++ ] ) ) {
                            curValue = getClass( elem );
                            cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

                            if ( cur ) {
                                j = 0;
                                while ( ( clazz = classes[ j++ ] ) ) {
                                    if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
                                        cur += clazz + " ";
                                    }
                                }

                                // Only assign if different to avoid unneeded rendering.
                                finalValue = stripAndCollapse( cur );
                                if ( curValue !== finalValue ) {
                                    elem.setAttribute( "class", finalValue );
                                }
                            }
                        }
                    }

                    return this;
                },

                removeClass: function( value ) {
                    var classes, elem, cur, curValue, clazz, j, finalValue,
                            i = 0;

                    if ( isFunction( value ) ) {
                        return this.each( function( j ) {
                            jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
                        } );
                    }

                    if ( !arguments.length ) {
                        return this.attr( "class", "" );
                    }

                    classes = classesToArray( value );

                    if ( classes.length ) {
                        while ( ( elem = this[ i++ ] ) ) {
                            curValue = getClass( elem );

                            // This expression is here for better compressibility (see addClass)
                            cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

                            if ( cur ) {
                                j = 0;
                                while ( ( clazz = classes[ j++ ] ) ) {

                                    // Remove *all* instances
                                    while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
                                        cur = cur.replace( " " + clazz + " ", " " );
                                    }
                                }

                                // Only assign if different to avoid unneeded rendering.
                                finalValue = stripAndCollapse( cur );
                                if ( curValue !== finalValue ) {
                                    elem.setAttribute( "class", finalValue );
                                }
                            }
                        }
                    }

                    return this;
                },

                toggleClass: function( value, stateVal ) {
                    var type = typeof value,
                            isValidValue = type === "string" || Array.isArray( value );

                    if ( typeof stateVal === "boolean" && isValidValue ) {
                        return stateVal ? this.addClass( value ) : this.removeClass( value );
                    }

                    if ( isFunction( value ) ) {
                        return this.each( function( i ) {
                            jQuery( this ).toggleClass(
                                    value.call( this, i, getClass( this ), stateVal ),
                                    stateVal
                            );
                        } );
                    }

                    return this.each( function() {
                        var className, i, self, classNames;

                        if ( isValidValue ) {

                            // Toggle individual class names
                            i = 0;
                            self = jQuery( this );
                            classNames = classesToArray( value );

                            while ( ( className = classNames[ i++ ] ) ) {

                                // Check each className given, space separated list
                                if ( self.hasClass( className ) ) {
                                    self.removeClass( className );
                                } else {
                                    self.addClass( className );
                                }
                            }

                            // Toggle whole class name
                        } else if ( value === undefined || type === "boolean" ) {
                            className = getClass( this );
                            if ( className ) {

                                // Store className if set
                                dataPriv.set( this, "__className__", className );
                            }

                            // If the element has a class name or if we're passed `false`,
                            // then remove the whole classname (if there was one, the above saved it).
                            // Otherwise bring back whatever was previously saved (if anything),
                            // falling back to the empty string if nothing was stored.
                            if ( this.setAttribute ) {
                                this.setAttribute( "class",
                                        className || value === false ?
                                                "" :
                                        dataPriv.get( this, "__className__" ) || ""
                                );
                            }
                        }
                    } );
                },

                hasClass: function( selector ) {
                    var className, elem,
                            i = 0;

                    className = " " + selector + " ";
                    while ( ( elem = this[ i++ ] ) ) {
                        if ( elem.nodeType === 1 &&
                                ( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
                            return true;
                        }
                    }

                    return false;
                }
            } );




            var rreturn = /\r/g;

            jQuery.fn.extend( {
                val: function( value ) {
                    var hooks, ret, valueIsFunction,
                            elem = this[ 0 ];

                    if ( !arguments.length ) {
                        if ( elem ) {
                            hooks = jQuery.valHooks[ elem.type ] ||
                                    jQuery.valHooks[ elem.nodeName.toLowerCase() ];

                            if ( hooks &&
                                    "get" in hooks &&
                                    ( ret = hooks.get( elem, "value" ) ) !== undefined
                            ) {
                                return ret;
                            }

                            ret = elem.value;

                            // Handle most common string cases
                            if ( typeof ret === "string" ) {
                                return ret.replace( rreturn, "" );
                            }

                            // Handle cases where value is null/undef or number
                            return ret == null ? "" : ret;
                        }

                        return;
                    }

                    valueIsFunction = isFunction( value );

                    return this.each( function( i ) {
                        var val;

                        if ( this.nodeType !== 1 ) {
                            return;
                        }

                        if ( valueIsFunction ) {
                            val = value.call( this, i, jQuery( this ).val() );
                        } else {
                            val = value;
                        }

                        // Treat null/undefined as ""; convert numbers to string
                        if ( val == null ) {
                            val = "";

                        } else if ( typeof val === "number" ) {
                            val += "";

                        } else if ( Array.isArray( val ) ) {
                            val = jQuery.map( val, function( value ) {
                                return value == null ? "" : value + "";
                            } );
                        }

                        hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

                        // If set returns undefined, fall back to normal setting
                        if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
                            this.value = val;
                        }
                    } );
                }
            } );

            jQuery.extend( {
                valHooks: {
                    option: {
                        get: function( elem ) {

                            var val = jQuery.find.attr( elem, "value" );
                            return val != null ?
                                    val :

                                    // Support: IE <=10 - 11 only
                                    // option.text throws exceptions (#14686, #14858)
                                    // Strip and collapse whitespace
                                    // https://html.spec.whatwg.org/#strip-and-collapse-whitespace
                                    stripAndCollapse( jQuery.text( elem ) );
                        }
                    },
                    select: {
                        get: function( elem ) {
                            var value, option, i,
                                    options = elem.options,
                                    index = elem.selectedIndex,
                                    one = elem.type === "select-one",
                                    values = one ? null : [],
                                    max = one ? index + 1 : options.length;

                            if ( index < 0 ) {
                                i = max;

                            } else {
                                i = one ? index : 0;
                            }

                            // Loop through all the selected options
                            for ( ; i < max; i++ ) {
                                option = options[ i ];

                                // Support: IE <=9 only
                                // IE8-9 doesn't update selected after form reset (#2551)
                                if ( ( option.selected || i === index ) &&

                                        // Don't return options that are disabled or in a disabled optgroup
                                        !option.disabled &&
                                        ( !option.parentNode.disabled ||
                                        !nodeName( option.parentNode, "optgroup" ) ) ) {

                                    // Get the specific value for the option
                                    value = jQuery( option ).val();

                                    // We don't need an array for one selects
                                    if ( one ) {
                                        return value;
                                    }

                                    // Multi-Selects return an array
                                    values.push( value );
                                }
                            }

                            return values;
                        },

                        set: function( elem, value ) {
                            var optionSet, option,
                                    options = elem.options,
                                    values = jQuery.makeArray( value ),
                                    i = options.length;

                            while ( i-- ) {
                                option = options[ i ];

                                /* eslint-disable no-cond-assign */

                                if ( option.selected =
                                                jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
                                ) {
                                    optionSet = true;
                                }

                                /* eslint-enable no-cond-assign */
                            }

                            // Force browsers to behave consistently when non-matching value is set
                            if ( !optionSet ) {
                                elem.selectedIndex = -1;
                            }
                            return values;
                        }
                    }
                }
            } );

// Radios and checkboxes getter/setter
            jQuery.each( [ "radio", "checkbox" ], function() {
                jQuery.valHooks[ this ] = {
                    set: function( elem, value ) {
                        if ( Array.isArray( value ) ) {
                            return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
                        }
                    }
                };
                if ( !support.checkOn ) {
                    jQuery.valHooks[ this ].get = function( elem ) {
                        return elem.getAttribute( "value" ) === null ? "on" : elem.value;
                    };
                }
            } );




// Return jQuery for attributes-only inclusion


            support.focusin = "onfocusin" in window;


            var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
                    stopPropagationCallback = function( e ) {
                        e.stopPropagation();
                    };

            jQuery.extend( jQuery.event, {

                trigger: function( event, data, elem, onlyHandlers ) {

                    var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
                            eventPath = [ elem || document ],
                            type = hasOwn.call( event, "type" ) ? event.type : event,
                            namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

                    cur = lastElement = tmp = elem = elem || document;

                    // Don't do events on text and comment nodes
                    if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
                        return;
                    }

                    // focus/blur morphs to focusin/out; ensure we're not firing them right now
                    if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
                        return;
                    }

                    if ( type.indexOf( "." ) > -1 ) {

                        // Namespaced trigger; create a regexp to match event type in handle()
                        namespaces = type.split( "." );
                        type = namespaces.shift();
                        namespaces.sort();
                    }
                    ontype = type.indexOf( ":" ) < 0 && "on" + type;

                    // Caller can pass in a jQuery.Event object, Object, or just an event type string
                    event = event[ jQuery.expando ] ?
                            event :
                            new jQuery.Event( type, typeof event === "object" && event );

                    // Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
                    event.isTrigger = onlyHandlers ? 2 : 3;
                    event.namespace = namespaces.join( "." );
                    event.rnamespace = event.namespace ?
                            new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
                            null;

                    // Clean up the event in case it is being reused
                    event.result = undefined;
                    if ( !event.target ) {
                        event.target = elem;
                    }

                    // Clone any incoming data and prepend the event, creating the handler arg list
                    data = data == null ?
                            [ event ] :
                            jQuery.makeArray( data, [ event ] );

                    // Allow special events to draw outside the lines
                    special = jQuery.event.special[ type ] || {};
                    if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
                        return;
                    }

                    // Determine event propagation path in advance, per W3C events spec (#9951)
                    // Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
                    if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {

                        bubbleType = special.delegateType || type;
                        if ( !rfocusMorph.test( bubbleType + type ) ) {
                            cur = cur.parentNode;
                        }
                        for ( ; cur; cur = cur.parentNode ) {
                            eventPath.push( cur );
                            tmp = cur;
                        }

                        // Only add window if we got to document (e.g., not plain obj or detached DOM)
                        if ( tmp === ( elem.ownerDocument || document ) ) {
                            eventPath.push( tmp.defaultView || tmp.parentWindow || window );
                        }
                    }

                    // Fire handlers on the event path
                    i = 0;
                    while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
                        lastElement = cur;
                        event.type = i > 1 ?
                                bubbleType :
                        special.bindType || type;

                        // jQuery handler
                        handle = (
                                        dataPriv.get( cur, "events" ) || Object.create( null )
                                )[ event.type ] &&
                                dataPriv.get( cur, "handle" );
                        if ( handle ) {
                            handle.apply( cur, data );
                        }

                        // Native handler
                        handle = ontype && cur[ ontype ];
                        if ( handle && handle.apply && acceptData( cur ) ) {
                            event.result = handle.apply( cur, data );
                            if ( event.result === false ) {
                                event.preventDefault();
                            }
                        }
                    }
                    event.type = type;

                    // If nobody prevented the default action, do it now
                    if ( !onlyHandlers && !event.isDefaultPrevented() ) {

                        if ( ( !special._default ||
                                special._default.apply( eventPath.pop(), data ) === false ) &&
                                acceptData( elem ) ) {

                            // Call a native DOM method on the target with the same name as the event.
                            // Don't do default actions on window, that's where global variables be (#6170)
                            if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {

                                // Don't re-trigger an onFOO event when we call its FOO() method
                                tmp = elem[ ontype ];

                                if ( tmp ) {
                                    elem[ ontype ] = null;
                                }

                                // Prevent re-triggering of the same event, since we already bubbled it above
                                jQuery.event.triggered = type;

                                if ( event.isPropagationStopped() ) {
                                    lastElement.addEventListener( type, stopPropagationCallback );
                                }

                                elem[ type ]();

                                if ( event.isPropagationStopped() ) {
                                    lastElement.removeEventListener( type, stopPropagationCallback );
                                }

                                jQuery.event.triggered = undefined;

                                if ( tmp ) {
                                    elem[ ontype ] = tmp;
                                }
                            }
                        }
                    }

                    return event.result;
                },

                // Piggyback on a donor event to simulate a different one
                // Used only for `focus(in | out)` events
                simulate: function( type, elem, event ) {
                    var e = jQuery.extend(
                            new jQuery.Event(),
                            event,
                            {
                                type: type,
                                isSimulated: true
                            }
                    );

                    jQuery.event.trigger( e, null, elem );
                }

            } );

            jQuery.fn.extend( {

                trigger: function( type, data ) {
                    return this.each( function() {
                        jQuery.event.trigger( type, data, this );
                    } );
                },
                triggerHandler: function( type, data ) {
                    var elem = this[ 0 ];
                    if ( elem ) {
                        return jQuery.event.trigger( type, data, elem, true );
                    }
                }
            } );


// Support: Firefox <=44
// Firefox doesn't have focus(in | out) events
// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
//
// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
// focus(in | out) events fire after focus & blur events,
// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
            if ( !support.focusin ) {
                jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {

                    // Attach a single capturing handler on the document while someone wants focusin/focusout
                    var handler = function( event ) {
                        jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
                    };

                    jQuery.event.special[ fix ] = {
                        setup: function() {

                            // Handle: regular nodes (via `this.ownerDocument`), window
                            // (via `this.document`) & document (via `this`).
                            var doc = this.ownerDocument || this.document || this,
                                    attaches = dataPriv.access( doc, fix );

                            if ( !attaches ) {
                                doc.addEventListener( orig, handler, true );
                            }
                            dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
                        },
                        teardown: function() {
                            var doc = this.ownerDocument || this.document || this,
                                    attaches = dataPriv.access( doc, fix ) - 1;

                            if ( !attaches ) {
                                doc.removeEventListener( orig, handler, true );
                                dataPriv.remove( doc, fix );

                            } else {
                                dataPriv.access( doc, fix, attaches );
                            }
                        }
                    };
                } );
            }
            var location = window.location;

            var nonce = { guid: Date.now() };

            var rquery = ( /\?/ );



// Cross-browser xml parsing
            jQuery.parseXML = function( data ) {
                var xml;
                if ( !data || typeof data !== "string" ) {
                    return null;
                }

                // Support: IE 9 - 11 only
                // IE throws on parseFromString with invalid input.
                try {
                    xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
                } catch ( e ) {
                    xml = undefined;
                }

                if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
                    jQuery.error( "Invalid XML: " + data );
                }
                return xml;
            };


            var
                    rbracket = /\[\]$/,
                    rCRLF = /\r?\n/g,
                    rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
                    rsubmittable = /^(?:input|select|textarea|keygen)/i;

            function buildParams( prefix, obj, traditional, add ) {
                var name;

                if ( Array.isArray( obj ) ) {

                    // Serialize array item.
                    jQuery.each( obj, function( i, v ) {
                        if ( traditional || rbracket.test( prefix ) ) {

                            // Treat each array item as a scalar.
                            add( prefix, v );

                        } else {

                            // Item is non-scalar (array or object), encode its numeric index.
                            buildParams(
                                    prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
                                    v,
                                    traditional,
                                    add
                            );
                        }
                    } );

                } else if ( !traditional && toType( obj ) === "object" ) {

                    // Serialize object item.
                    for ( name in obj ) {
                        buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
                    }

                } else {

                    // Serialize scalar item.
                    add( prefix, obj );
                }
            }

// Serialize an array of form elements or a set of
// key/values into a query string
            jQuery.param = function( a, traditional ) {
                var prefix,
                        s = [],
                        add = function( key, valueOrFunction ) {

                            // If value is a function, invoke it and use its return value
                            var value = isFunction( valueOrFunction ) ?
                                    valueOrFunction() :
                                    valueOrFunction;

                            s[ s.length ] = encodeURIComponent( key ) + "=" +
                                    encodeURIComponent( value == null ? "" : value );
                        };

                if ( a == null ) {
                    return "";
                }

                // If an array was passed in, assume that it is an array of form elements.
                if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

                    // Serialize the form elements
                    jQuery.each( a, function() {
                        add( this.name, this.value );
                    } );

                } else {

                    // If traditional, encode the "old" way (the way 1.3.2 or older
                    // did it), otherwise encode params recursively.
                    for ( prefix in a ) {
                        buildParams( prefix, a[ prefix ], traditional, add );
                    }
                }

                // Return the resulting serialization
                return s.join( "&" );
            };

            jQuery.fn.extend( {
                serialize: function() {
                    return jQuery.param( this.serializeArray() );
                },
                serializeArray: function() {
                    return this.map( function() {

                        // Can add propHook for "elements" to filter or add form elements
                        var elements = jQuery.prop( this, "elements" );
                        return elements ? jQuery.makeArray( elements ) : this;
                    } )
                            .filter( function() {
                                var type = this.type;

                                // Use .is( ":disabled" ) so that fieldset[disabled] works
                                return this.name && !jQuery( this ).is( ":disabled" ) &&
                                        rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
                                        ( this.checked || !rcheckableType.test( type ) );
                            } )
                            .map( function( _i, elem ) {
                                var val = jQuery( this ).val();

                                if ( val == null ) {
                                    return null;
                                }

                                if ( Array.isArray( val ) ) {
                                    return jQuery.map( val, function( val ) {
                                        return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
                                    } );
                                }

                                return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
                            } ).get();
                }
            } );


            var
                    r20 = /%20/g,
                    rhash = /#.*$/,
                    rantiCache = /([?&])_=[^&]*/,
                    rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

            // #7653, #8125, #8152: local protocol detection
                    rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
                    rnoContent = /^(?:GET|HEAD)$/,
                    rprotocol = /^\/\//,

            /* Prefilters
             * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
             * 2) These are called:
             *    - BEFORE asking for a transport
             *    - AFTER param serialization (s.data is a string if s.processData is true)
             * 3) key is the dataType
             * 4) the catchall symbol "*" can be used
             * 5) execution will start with transport dataType and THEN continue down to "*" if needed
             */
                    prefilters = {},

            /* Transports bindings
             * 1) key is the dataType
             * 2) the catchall symbol "*" can be used
             * 3) selection will start with transport dataType and THEN go to "*" if needed
             */
                    transports = {},

            // Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
                    allTypes = "*/".concat( "*" ),

            // Anchor tag for parsing the document origin
                    originAnchor = document.createElement( "a" );
            originAnchor.href = location.href;

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
            function addToPrefiltersOrTransports( structure ) {

                // dataTypeExpression is optional and defaults to "*"
                return function( dataTypeExpression, func ) {

                    if ( typeof dataTypeExpression !== "string" ) {
                        func = dataTypeExpression;
                        dataTypeExpression = "*";
                    }

                    var dataType,
                            i = 0,
                            dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];

                    if ( isFunction( func ) ) {

                        // For each dataType in the dataTypeExpression
                        while ( ( dataType = dataTypes[ i++ ] ) ) {

                            // Prepend if requested
                            if ( dataType[ 0 ] === "+" ) {
                                dataType = dataType.slice( 1 ) || "*";
                                ( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

                                // Otherwise append
                            } else {
                                ( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
                            }
                        }
                    }
                };
            }

// Base inspection function for prefilters and transports
            function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

                var inspected = {},
                        seekingTransport = ( structure === transports );

                function inspect( dataType ) {
                    var selected;
                    inspected[ dataType ] = true;
                    jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
                        var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
                        if ( typeof dataTypeOrTransport === "string" &&
                                !seekingTransport && !inspected[ dataTypeOrTransport ] ) {

                            options.dataTypes.unshift( dataTypeOrTransport );
                            inspect( dataTypeOrTransport );
                            return false;
                        } else if ( seekingTransport ) {
                            return !( selected = dataTypeOrTransport );
                        }
                    } );
                    return selected;
                }

                return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
            }

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes #9887
            function ajaxExtend( target, src ) {
                var key, deep,
                        flatOptions = jQuery.ajaxSettings.flatOptions || {};

                for ( key in src ) {
                    if ( src[ key ] !== undefined ) {
                        ( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
                    }
                }
                if ( deep ) {
                    jQuery.extend( true, target, deep );
                }

                return target;
            }

            /* Handles responses to an ajax request:
             * - finds the right dataType (mediates between content-type and expected dataType)
             * - returns the corresponding response
             */
            function ajaxHandleResponses( s, jqXHR, responses ) {

                var ct, type, finalDataType, firstDataType,
                        contents = s.contents,
                        dataTypes = s.dataTypes;

                // Remove auto dataType and get content-type in the process
                while ( dataTypes[ 0 ] === "*" ) {
                    dataTypes.shift();
                    if ( ct === undefined ) {
                        ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
                    }
                }

                // Check if we're dealing with a known content-type
                if ( ct ) {
                    for ( type in contents ) {
                        if ( contents[ type ] && contents[ type ].test( ct ) ) {
                            dataTypes.unshift( type );
                            break;
                        }
                    }
                }

                // Check to see if we have a response for the expected dataType
                if ( dataTypes[ 0 ] in responses ) {
                    finalDataType = dataTypes[ 0 ];
                } else {

                    // Try convertible dataTypes
                    for ( type in responses ) {
                        if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
                            finalDataType = type;
                            break;
                        }
                        if ( !firstDataType ) {
                            firstDataType = type;
                        }
                    }

                    // Or just use first one
                    finalDataType = finalDataType || firstDataType;
                }

                // If we found a dataType
                // We add the dataType to the list if needed
                // and return the corresponding response
                if ( finalDataType ) {
                    if ( finalDataType !== dataTypes[ 0 ] ) {
                        dataTypes.unshift( finalDataType );
                    }
                    return responses[ finalDataType ];
                }
            }

            /* Chain conversions given the request and the original response
             * Also sets the responseXXX fields on the jqXHR instance
             */
            function ajaxConvert( s, response, jqXHR, isSuccess ) {
                var conv2, current, conv, tmp, prev,
                        converters = {},

                // Work with a copy of dataTypes in case we need to modify it for conversion
                        dataTypes = s.dataTypes.slice();

                // Create converters map with lowercased keys
                if ( dataTypes[ 1 ] ) {
                    for ( conv in s.converters ) {
                        converters[ conv.toLowerCase() ] = s.converters[ conv ];
                    }
                }

                current = dataTypes.shift();

                // Convert to each sequential dataType
                while ( current ) {

                    if ( s.responseFields[ current ] ) {
                        jqXHR[ s.responseFields[ current ] ] = response;
                    }

                    // Apply the dataFilter if provided
                    if ( !prev && isSuccess && s.dataFilter ) {
                        response = s.dataFilter( response, s.dataType );
                    }

                    prev = current;
                    current = dataTypes.shift();

                    if ( current ) {

                        // There's only work to do if current dataType is non-auto
                        if ( current === "*" ) {

                            current = prev;

                            // Convert response if prev dataType is non-auto and differs from current
                        } else if ( prev !== "*" && prev !== current ) {

                            // Seek a direct converter
                            conv = converters[ prev + " " + current ] || converters[ "* " + current ];

                            // If none found, seek a pair
                            if ( !conv ) {
                                for ( conv2 in converters ) {

                                    // If conv2 outputs current
                                    tmp = conv2.split( " " );
                                    if ( tmp[ 1 ] === current ) {

                                        // If prev can be converted to accepted input
                                        conv = converters[ prev + " " + tmp[ 0 ] ] ||
                                                converters[ "* " + tmp[ 0 ] ];
                                        if ( conv ) {

                                            // Condense equivalence converters
                                            if ( conv === true ) {
                                                conv = converters[ conv2 ];

                                                // Otherwise, insert the intermediate dataType
                                            } else if ( converters[ conv2 ] !== true ) {
                                                current = tmp[ 0 ];
                                                dataTypes.unshift( tmp[ 1 ] );
                                            }
                                            break;
                                        }
                                    }
                                }
                            }

                            // Apply converter (if not an equivalence)
                            if ( conv !== true ) {

                                // Unless errors are allowed to bubble, catch and return them
                                if ( conv && s.throws ) {
                                    response = conv( response );
                                } else {
                                    try {
                                        response = conv( response );
                                    } catch ( e ) {
                                        return {
                                            state: "parsererror",
                                            error: conv ? e : "No conversion from " + prev + " to " + current
                                        };
                                    }
                                }
                            }
                        }
                    }
                }

                return { state: "success", data: response };
            }

            jQuery.extend( {

                // Counter for holding the number of active queries
                active: 0,

                // Last-Modified header cache for next request
                lastModified: {},
                etag: {},

                ajaxSettings: {
                    url: location.href,
                    type: "GET",
                    isLocal: rlocalProtocol.test( location.protocol ),
                    global: true,
                    processData: true,
                    async: true,
                    contentType: "application/x-www-form-urlencoded; charset=UTF-8",

                    /*
                     timeout: 0,
                     data: null,
                     dataType: null,
                     username: null,
                     password: null,
                     cache: null,
                     throws: false,
                     traditional: false,
                     headers: {},
                     */

                    accepts: {
                        "*": allTypes,
                        text: "text/plain",
                        html: "text/html",
                        xml: "application/xml, text/xml",
                        json: "application/json, text/javascript"
                    },

                    contents: {
                        xml: /\bxml\b/,
                        html: /\bhtml/,
                        json: /\bjson\b/
                    },

                    responseFields: {
                        xml: "responseXML",
                        text: "responseText",
                        json: "responseJSON"
                    },

                    // Data converters
                    // Keys separate source (or catchall "*") and destination types with a single space
                    converters: {

                        // Convert anything to text
                        "* text": String,

                        // Text to html (true = no transformation)
                        "text html": true,

                        // Evaluate text as a json expression
                        "text json": JSON.parse,

                        // Parse text as xml
                        "text xml": jQuery.parseXML
                    },

                    // For options that shouldn't be deep extended:
                    // you can add your own custom options here if
                    // and when you create one that shouldn't be
                    // deep extended (see ajaxExtend)
                    flatOptions: {
                        url: true,
                        context: true
                    }
                },

                // Creates a full fledged settings object into target
                // with both ajaxSettings and settings fields.
                // If target is omitted, writes into ajaxSettings.
                ajaxSetup: function( target, settings ) {
                    return settings ?

                            // Building a settings object
                            ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

                            // Extending ajaxSettings
                            ajaxExtend( jQuery.ajaxSettings, target );
                },

                ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
                ajaxTransport: addToPrefiltersOrTransports( transports ),

                // Main method
                ajax: function( url, options ) {

                    // If url is an object, simulate pre-1.5 signature
                    if ( typeof url === "object" ) {
                        options = url;
                        url = undefined;
                    }

                    // Force options to be an object
                    options = options || {};

                    var transport,

                    // URL without anti-cache param
                            cacheURL,

                    // Response headers
                            responseHeadersString,
                            responseHeaders,

                    // timeout handle
                            timeoutTimer,

                    // Url cleanup var
                            urlAnchor,

                    // Request state (becomes false upon send and true upon completion)
                            completed,

                    // To know if global events are to be dispatched
                            fireGlobals,

                    // Loop variable
                            i,

                    // uncached part of the url
                            uncached,

                    // Create the final options object
                            s = jQuery.ajaxSetup( {}, options ),

                    // Callbacks context
                            callbackContext = s.context || s,

                    // Context for global events is callbackContext if it is a DOM node or jQuery collection
                            globalEventContext = s.context &&
                            ( callbackContext.nodeType || callbackContext.jquery ) ?
                                    jQuery( callbackContext ) :
                                    jQuery.event,

                    // Deferreds
                            deferred = jQuery.Deferred(),
                            completeDeferred = jQuery.Callbacks( "once memory" ),

                    // Status-dependent callbacks
                            statusCode = s.statusCode || {},

                    // Headers (they are sent all at once)
                            requestHeaders = {},
                            requestHeadersNames = {},

                    // Default abort message
                            strAbort = "canceled",

                    // Fake xhr
                            jqXHR = {
                                readyState: 0,

                                // Builds headers hashtable if needed
                                getResponseHeader: function( key ) {
                                    var match;
                                    if ( completed ) {
                                        if ( !responseHeaders ) {
                                            responseHeaders = {};
                                            while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
                                                responseHeaders[ match[ 1 ].toLowerCase() + " " ] =
                                                        ( responseHeaders[ match[ 1 ].toLowerCase() + " " ] || [] )
                                                                .concat( match[ 2 ] );
                                            }
                                        }
                                        match = responseHeaders[ key.toLowerCase() + " " ];
                                    }
                                    return match == null ? null : match.join( ", " );
                                },

                                // Raw string
                                getAllResponseHeaders: function() {
                                    return completed ? responseHeadersString : null;
                                },

                                // Caches the header
                                setRequestHeader: function( name, value ) {
                                    if ( completed == null ) {
                                        name = requestHeadersNames[ name.toLowerCase() ] =
                                                requestHeadersNames[ name.toLowerCase() ] || name;
                                        requestHeaders[ name ] = value;
                                    }
                                    return this;
                                },

                                // Overrides response content-type header
                                overrideMimeType: function( type ) {
                                    if ( completed == null ) {
                                        s.mimeType = type;
                                    }
                                    return this;
                                },

                                // Status-dependent callbacks
                                statusCode: function( map ) {
                                    var code;
                                    if ( map ) {
                                        if ( completed ) {

                                            // Execute the appropriate callbacks
                                            jqXHR.always( map[ jqXHR.status ] );
                                        } else {

                                            // Lazy-add the new callbacks in a way that preserves old ones
                                            for ( code in map ) {
                                                statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
                                            }
                                        }
                                    }
                                    return this;
                                },

                                // Cancel the request
                                abort: function( statusText ) {
                                    var finalText = statusText || strAbort;
                                    if ( transport ) {
                                        transport.abort( finalText );
                                    }
                                    done( 0, finalText );
                                    return this;
                                }
                            };

                    // Attach deferreds
                    deferred.promise( jqXHR );

                    // Add protocol if not provided (prefilters might expect it)
                    // Handle falsy url in the settings object (#10093: consistency with old signature)
                    // We also use the url parameter if available
                    s.url = ( ( url || s.url || location.href ) + "" )
                            .replace( rprotocol, location.protocol + "//" );

                    // Alias method option to type as per ticket #12004
                    s.type = options.method || options.type || s.method || s.type;

                    // Extract dataTypes list
                    s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];

                    // A cross-domain request is in order when the origin doesn't match the current origin.
                    if ( s.crossDomain == null ) {
                        urlAnchor = document.createElement( "a" );

                        // Support: IE <=8 - 11, Edge 12 - 15
                        // IE throws exception on accessing the href property if url is malformed,
                        // e.g. http://example.com:80x/
                        try {
                            urlAnchor.href = s.url;

                            // Support: IE <=8 - 11 only
                            // Anchor's host property isn't correctly set when s.url is relative
                            urlAnchor.href = urlAnchor.href;
                            s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
                                    urlAnchor.protocol + "//" + urlAnchor.host;
                        } catch ( e ) {

                            // If there is an error parsing the URL, assume it is crossDomain,
                            // it can be rejected by the transport if it is invalid
                            s.crossDomain = true;
                        }
                    }

                    // Convert data if not already a string
                    if ( s.data && s.processData && typeof s.data !== "string" ) {
                        s.data = jQuery.param( s.data, s.traditional );
                    }

                    // Apply prefilters
                    inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

                    // If request was aborted inside a prefilter, stop there
                    if ( completed ) {
                        return jqXHR;
                    }

                    // We can fire global events as of now if asked to
                    // Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
                    fireGlobals = jQuery.event && s.global;

                    // Watch for a new set of requests
                    if ( fireGlobals && jQuery.active++ === 0 ) {
                        jQuery.event.trigger( "ajaxStart" );
                    }

                    // Uppercase the type
                    s.type = s.type.toUpperCase();

                    // Determine if request has content
                    s.hasContent = !rnoContent.test( s.type );

                    // Save the URL in case we're toying with the If-Modified-Since
                    // and/or If-None-Match header later on
                    // Remove hash to simplify url manipulation
                    cacheURL = s.url.replace( rhash, "" );

                    // More options handling for requests with no content
                    if ( !s.hasContent ) {

                        // Remember the hash so we can put it back
                        uncached = s.url.slice( cacheURL.length );

                        // If data is available and should be processed, append data to url
                        if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
                            cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;

                            // #9682: remove data so that it's not used in an eventual retry
                            delete s.data;
                        }

                        // Add or update anti-cache param if needed
                        if ( s.cache === false ) {
                            cacheURL = cacheURL.replace( rantiCache, "$1" );
                            uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce.guid++ ) +
                                    uncached;
                        }

                        // Put hash and anti-cache on the URL that will be requested (gh-1732)
                        s.url = cacheURL + uncached;

                        // Change '%20' to '+' if this is encoded form body content (gh-2658)
                    } else if ( s.data && s.processData &&
                            ( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
                        s.data = s.data.replace( r20, "+" );
                    }

                    // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
                    if ( s.ifModified ) {
                        if ( jQuery.lastModified[ cacheURL ] ) {
                            jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
                        }
                        if ( jQuery.etag[ cacheURL ] ) {
                            jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
                        }
                    }

                    // Set the correct header, if data is being sent
                    if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
                        jqXHR.setRequestHeader( "Content-Type", s.contentType );
                    }

                    // Set the Accepts header for the server, depending on the dataType
                    jqXHR.setRequestHeader(
                            "Accept",
                            s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
                            s.accepts[ s.dataTypes[ 0 ] ] +
                            ( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
                                    s.accepts[ "*" ]
                    );

                    // Check for headers option
                    for ( i in s.headers ) {
                        jqXHR.setRequestHeader( i, s.headers[ i ] );
                    }

                    // Allow custom headers/mimetypes and early abort
                    if ( s.beforeSend &&
                            ( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {

                        // Abort if not done already and return
                        return jqXHR.abort();
                    }

                    // Aborting is no longer a cancellation
                    strAbort = "abort";

                    // Install callbacks on deferreds
                    completeDeferred.add( s.complete );
                    jqXHR.done( s.success );
                    jqXHR.fail( s.error );

                    // Get transport
                    transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

                    // If no transport, we auto-abort
                    if ( !transport ) {
                        done( -1, "No Transport" );
                    } else {
                        jqXHR.readyState = 1;

                        // Send global event
                        if ( fireGlobals ) {
                            globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
                        }

                        // If request was aborted inside ajaxSend, stop there
                        if ( completed ) {
                            return jqXHR;
                        }

                        // Timeout
                        if ( s.async && s.timeout > 0 ) {
                            timeoutTimer = window.setTimeout( function() {
                                jqXHR.abort( "timeout" );
                            }, s.timeout );
                        }

                        try {
                            completed = false;
                            transport.send( requestHeaders, done );
                        } catch ( e ) {

                            // Rethrow post-completion exceptions
                            if ( completed ) {
                                throw e;
                            }

                            // Propagate others as results
                            done( -1, e );
                        }
                    }

                    // Callback for when everything is done
                    function done( status, nativeStatusText, responses, headers ) {
                        var isSuccess, success, error, response, modified,
                                statusText = nativeStatusText;

                        // Ignore repeat invocations
                        if ( completed ) {
                            return;
                        }

                        completed = true;

                        // Clear timeout if it exists
                        if ( timeoutTimer ) {
                            window.clearTimeout( timeoutTimer );
                        }

                        // Dereference transport for early garbage collection
                        // (no matter how long the jqXHR object will be used)
                        transport = undefined;

                        // Cache response headers
                        responseHeadersString = headers || "";

                        // Set readyState
                        jqXHR.readyState = status > 0 ? 4 : 0;

                        // Determine if successful
                        isSuccess = status >= 200 && status < 300 || status === 304;

                        // Get response data
                        if ( responses ) {
                            response = ajaxHandleResponses( s, jqXHR, responses );
                        }

                        // Use a noop converter for missing script
                        if ( !isSuccess && jQuery.inArray( "script", s.dataTypes ) > -1 ) {
                            s.converters[ "text script" ] = function() {};
                        }

                        // Convert no matter what (that way responseXXX fields are always set)
                        response = ajaxConvert( s, response, jqXHR, isSuccess );

                        // If successful, handle type chaining
                        if ( isSuccess ) {

                            // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
                            if ( s.ifModified ) {
                                modified = jqXHR.getResponseHeader( "Last-Modified" );
                                if ( modified ) {
                                    jQuery.lastModified[ cacheURL ] = modified;
                                }
                                modified = jqXHR.getResponseHeader( "etag" );
                                if ( modified ) {
                                    jQuery.etag[ cacheURL ] = modified;
                                }
                            }

                            // if no content
                            if ( status === 204 || s.type === "HEAD" ) {
                                statusText = "nocontent";

                                // if not modified
                            } else if ( status === 304 ) {
                                statusText = "notmodified";

                                // If we have data, let's convert it
                            } else {
                                statusText = response.state;
                                success = response.data;
                                error = response.error;
                                isSuccess = !error;
                            }
                        } else {

                            // Extract error from statusText and normalize for non-aborts
                            error = statusText;
                            if ( status || !statusText ) {
                                statusText = "error";
                                if ( status < 0 ) {
                                    status = 0;
                                }
                            }
                        }

                        // Set data for the fake xhr object
                        jqXHR.status = status;
                        jqXHR.statusText = ( nativeStatusText || statusText ) + "";

                        // Success/Error
                        if ( isSuccess ) {
                            deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
                        } else {
                            deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
                        }

                        // Status-dependent callbacks
                        jqXHR.statusCode( statusCode );
                        statusCode = undefined;

                        if ( fireGlobals ) {
                            globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
                                    [ jqXHR, s, isSuccess ? success : error ] );
                        }

                        // Complete
                        completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

                        if ( fireGlobals ) {
                            globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

                            // Handle the global AJAX counter
                            if ( !( --jQuery.active ) ) {
                                jQuery.event.trigger( "ajaxStop" );
                            }
                        }
                    }

                    return jqXHR;
                },

                getJSON: function( url, data, callback ) {
                    return jQuery.get( url, data, callback, "json" );
                },

                getScript: function( url, callback ) {
                    return jQuery.get( url, undefined, callback, "script" );
                }
            } );

            jQuery.each( [ "get", "post" ], function( _i, method ) {
                jQuery[ method ] = function( url, data, callback, type ) {

                    // Shift arguments if data argument was omitted
                    if ( isFunction( data ) ) {
                        type = type || callback;
                        callback = data;
                        data = undefined;
                    }

                    // The url can be an options object (which then must have .url)
                    return jQuery.ajax( jQuery.extend( {
                        url: url,
                        type: method,
                        dataType: type,
                        data: data,
                        success: callback
                    }, jQuery.isPlainObject( url ) && url ) );
                };
            } );

            jQuery.ajaxPrefilter( function( s ) {
                var i;
                for ( i in s.headers ) {
                    if ( i.toLowerCase() === "content-type" ) {
                        s.contentType = s.headers[ i ] || "";
                    }
                }
            } );


            jQuery._evalUrl = function( url, options, doc ) {
                return jQuery.ajax( {
                    url: url,

                    // Make this explicit, since user can override this through ajaxSetup (#11264)
                    type: "GET",
                    dataType: "script",
                    cache: true,
                    async: false,
                    global: false,

                    // Only evaluate the response if it is successful (gh-4126)
                    // dataFilter is not invoked for failure responses, so using it instead
                    // of the default converter is kludgy but it works.
                    converters: {
                        "text script": function() {}
                    },
                    dataFilter: function( response ) {
                        jQuery.globalEval( response, options, doc );
                    }
                } );
            };


            jQuery.fn.extend( {
                wrapAll: function( html ) {
                    var wrap;

                    if ( this[ 0 ] ) {
                        if ( isFunction( html ) ) {
                            html = html.call( this[ 0 ] );
                        }

                        // The elements to wrap the target around
                        wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

                        if ( this[ 0 ].parentNode ) {
                            wrap.insertBefore( this[ 0 ] );
                        }

                        wrap.map( function() {
                            var elem = this;

                            while ( elem.firstElementChild ) {
                                elem = elem.firstElementChild;
                            }

                            return elem;
                        } ).append( this );
                    }

                    return this;
                },

                wrapInner: function( html ) {
                    if ( isFunction( html ) ) {
                        return this.each( function( i ) {
                            jQuery( this ).wrapInner( html.call( this, i ) );
                        } );
                    }

                    return this.each( function() {
                        var self = jQuery( this ),
                                contents = self.contents();

                        if ( contents.length ) {
                            contents.wrapAll( html );

                        } else {
                            self.append( html );
                        }
                    } );
                },

                wrap: function( html ) {
                    var htmlIsFunction = isFunction( html );

                    return this.each( function( i ) {
                        jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
                    } );
                },

                unwrap: function( selector ) {
                    this.parent( selector ).not( "body" ).each( function() {
                        jQuery( this ).replaceWith( this.childNodes );
                    } );
                    return this;
                }
            } );


            jQuery.expr.pseudos.hidden = function( elem ) {
                return !jQuery.expr.pseudos.visible( elem );
            };
            jQuery.expr.pseudos.visible = function( elem ) {
                return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
            };




            jQuery.ajaxSettings.xhr = function() {
                try {
                    return new window.XMLHttpRequest();
                } catch ( e ) {}
            };

            var xhrSuccessStatus = {

                        // File protocol always yields status code 0, assume 200
                        0: 200,

                        // Support: IE <=9 only
                        // #1450: sometimes IE returns 1223 when it should be 204
                        1223: 204
                    },
                    xhrSupported = jQuery.ajaxSettings.xhr();

            support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
            support.ajax = xhrSupported = !!xhrSupported;

            jQuery.ajaxTransport( function( options ) {
                var callback, errorCallback;

                // Cross domain only allowed if supported through XMLHttpRequest
                if ( support.cors || xhrSupported && !options.crossDomain ) {
                    return {
                        send: function( headers, complete ) {
                            var i,
                                    xhr = options.xhr();

                            xhr.open(
                                    options.type,
                                    options.url,
                                    options.async,
                                    options.username,
                                    options.password
                            );

                            // Apply custom fields if provided
                            if ( options.xhrFields ) {
                                for ( i in options.xhrFields ) {
                                    xhr[ i ] = options.xhrFields[ i ];
                                }
                            }

                            // Override mime type if needed
                            if ( options.mimeType && xhr.overrideMimeType ) {
                                xhr.overrideMimeType( options.mimeType );
                            }

                            // X-Requested-With header
                            // For cross-domain requests, seeing as conditions for a preflight are
                            // akin to a jigsaw puzzle, we simply never set it to be sure.
                            // (it can always be set on a per-request basis or even using ajaxSetup)
                            // For same-domain requests, won't change header if already provided.
                            if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
                                headers[ "X-Requested-With" ] = "XMLHttpRequest";
                            }

                            // Set headers
                            for ( i in headers ) {
                                xhr.setRequestHeader( i, headers[ i ] );
                            }

                            // Callback
                            callback = function( type ) {
                                return function() {
                                    if ( callback ) {
                                        callback = errorCallback = xhr.onload =
                                                xhr.onerror = xhr.onabort = xhr.ontimeout =
                                                        xhr.onreadystatechange = null;

                                        if ( type === "abort" ) {
                                            xhr.abort();
                                        } else if ( type === "error" ) {

                                            // Support: IE <=9 only
                                            // On a manual native abort, IE9 throws
                                            // errors on any property access that is not readyState
                                            if ( typeof xhr.status !== "number" ) {
                                                complete( 0, "error" );
                                            } else {
                                                complete(

                                                        // File: protocol always yields status 0; see #8605, #14207
                                                        xhr.status,
                                                        xhr.statusText
                                                );
                                            }
                                        } else {
                                            complete(
                                                    xhrSuccessStatus[ xhr.status ] || xhr.status,
                                                    xhr.statusText,

                                                    // Support: IE <=9 only
                                                    // IE9 has no XHR2 but throws on binary (trac-11426)
                                                    // For XHR2 non-text, let the caller handle it (gh-2498)
                                                    ( xhr.responseType || "text" ) !== "text"  ||
                                                    typeof xhr.responseText !== "string" ?
                                                    { binary: xhr.response } :
                                                    { text: xhr.responseText },
                                                    xhr.getAllResponseHeaders()
                                            );
                                        }
                                    }
                                };
                            };

                            // Listen to events
                            xhr.onload = callback();
                            errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );

                            // Support: IE 9 only
                            // Use onreadystatechange to replace onabort
                            // to handle uncaught aborts
                            if ( xhr.onabort !== undefined ) {
                                xhr.onabort = errorCallback;
                            } else {
                                xhr.onreadystatechange = function() {

                                    // Check readyState before timeout as it changes
                                    if ( xhr.readyState === 4 ) {

                                        // Allow onerror to be called first,
                                        // but that will not handle a native abort
                                        // Also, save errorCallback to a variable
                                        // as xhr.onerror cannot be accessed
                                        window.setTimeout( function() {
                                            if ( callback ) {
                                                errorCallback();
                                            }
                                        } );
                                    }
                                };
                            }

                            // Create the abort callback
                            callback = callback( "abort" );

                            try {

                                // Do send the request (this may raise an exception)
                                xhr.send( options.hasContent && options.data || null );
                            } catch ( e ) {

                                // #14683: Only rethrow if this hasn't been notified as an error yet
                                if ( callback ) {
                                    throw e;
                                }
                            }
                        },

                        abort: function() {
                            if ( callback ) {
                                callback();
                            }
                        }
                    };
                }
            } );




// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
            jQuery.ajaxPrefilter( function( s ) {
                if ( s.crossDomain ) {
                    s.contents.script = false;
                }
            } );

// Install script dataType
            jQuery.ajaxSetup( {
                accepts: {
                    script: "text/javascript, application/javascript, " +
                    "application/ecmascript, application/x-ecmascript"
                },
                contents: {
                    script: /\b(?:java|ecma)script\b/
                },
                converters: {
                    "text script": function( text ) {
                        jQuery.globalEval( text );
                        return text;
                    }
                }
            } );

// Handle cache's special case and crossDomain
            jQuery.ajaxPrefilter( "script", function( s ) {
                if ( s.cache === undefined ) {
                    s.cache = false;
                }
                if ( s.crossDomain ) {
                    s.type = "GET";
                }
            } );

// Bind script tag hack transport
            jQuery.ajaxTransport( "script", function( s ) {

                // This transport only deals with cross domain or forced-by-attrs requests
                if ( s.crossDomain || s.scriptAttrs ) {
                    var script, callback;
                    return {
                        send: function( _, complete ) {
                            script = jQuery( "<script>" )
                                    .attr( s.scriptAttrs || {} )
                                    .prop( { charset: s.scriptCharset, src: s.url } )
                                    .on( "load error", callback = function( evt ) {
                                        script.remove();
                                        callback = null;
                                        if ( evt ) {
                                            complete( evt.type === "error" ? 404 : 200, evt.type );
                                        }
                                    } );

                            // Use native DOM manipulation to avoid our domManip AJAX trickery
                            document.head.appendChild( script[ 0 ] );
                        },
                        abort: function() {
                            if ( callback ) {
                                callback();
                            }
                        }
                    };
                }
            } );




            var oldCallbacks = [],
                    rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
            jQuery.ajaxSetup( {
                jsonp: "callback",
                jsonpCallback: function() {
                    var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce.guid++ ) );
                    this[ callback ] = true;
                    return callback;
                }
            } );

// Detect, normalize options and install callbacks for jsonp requests
            jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

                var callbackName, overwritten, responseContainer,
                        jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
                                                "url" :
                                        typeof s.data === "string" &&
                                        ( s.contentType || "" )
                                                .indexOf( "application/x-www-form-urlencoded" ) === 0 &&
                                        rjsonp.test( s.data ) && "data"
                                );

                // Handle iff the expected data type is "jsonp" or we have a parameter to set
                if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

                    // Get callback name, remembering preexisting value associated with it
                    callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
                            s.jsonpCallback() :
                            s.jsonpCallback;

                    // Insert callback into url or form data
                    if ( jsonProp ) {
                        s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
                    } else if ( s.jsonp !== false ) {
                        s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
                    }

                    // Use data converter to retrieve json after script execution
                    s.converters[ "script json" ] = function() {
                        if ( !responseContainer ) {
                            jQuery.error( callbackName + " was not called" );
                        }
                        return responseContainer[ 0 ];
                    };

                    // Force json dataType
                    s.dataTypes[ 0 ] = "json";

                    // Install callback
                    overwritten = window[ callbackName ];
                    window[ callbackName ] = function() {
                        responseContainer = arguments;
                    };

                    // Clean-up function (fires after converters)
                    jqXHR.always( function() {

                        // If previous value didn't exist - remove it
                        if ( overwritten === undefined ) {
                            jQuery( window ).removeProp( callbackName );

                            // Otherwise restore preexisting value
                        } else {
                            window[ callbackName ] = overwritten;
                        }

                        // Save back as free
                        if ( s[ callbackName ] ) {

                            // Make sure that re-using the options doesn't screw things around
                            s.jsonpCallback = originalSettings.jsonpCallback;

                            // Save the callback name for future use
                            oldCallbacks.push( callbackName );
                        }

                        // Call if it was a function and we have a response
                        if ( responseContainer && isFunction( overwritten ) ) {
                            overwritten( responseContainer[ 0 ] );
                        }

                        responseContainer = overwritten = undefined;
                    } );

                    // Delegate to script
                    return "script";
                }
            } );




// Support: Safari 8 only
// In Safari 8 documents created via document.implementation.createHTMLDocument
// collapse sibling forms: the second one becomes a child of the first one.
// Because of that, this security measure has to be disabled in Safari 8.
// https://bugs.webkit.org/show_bug.cgi?id=137337
            support.createHTMLDocument = ( function() {
                var body = document.implementation.createHTMLDocument( "" ).body;
                body.innerHTML = "<form></form><form></form>";
                return body.childNodes.length === 2;
            } )();


// Argument "data" should be string of html
// context (optional): If specified, the fragment will be created in this context,
// defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
            jQuery.parseHTML = function( data, context, keepScripts ) {
                if ( typeof data !== "string" ) {
                    return [];
                }
                if ( typeof context === "boolean" ) {
                    keepScripts = context;
                    context = false;
                }

                var base, parsed, scripts;

                if ( !context ) {

                    // Stop scripts or inline event handlers from being executed immediately
                    // by using document.implementation
                    if ( support.createHTMLDocument ) {
                        context = document.implementation.createHTMLDocument( "" );

                        // Set the base href for the created document
                        // so any parsed elements with URLs
                        // are based on the document's URL (gh-2965)
                        base = context.createElement( "base" );
                        base.href = document.location.href;
                        context.head.appendChild( base );
                    } else {
                        context = document;
                    }
                }

                parsed = rsingleTag.exec( data );
                scripts = !keepScripts && [];

                // Single tag
                if ( parsed ) {
                    return [ context.createElement( parsed[ 1 ] ) ];
                }

                parsed = buildFragment( [ data ], context, scripts );

                if ( scripts && scripts.length ) {
                    jQuery( scripts ).remove();
                }

                return jQuery.merge( [], parsed.childNodes );
            };


            /**
             * Load a url into a page
             */
            jQuery.fn.load = function( url, params, callback ) {
                var selector, type, response,
                        self = this,
                        off = url.indexOf( " " );

                if ( off > -1 ) {
                    selector = stripAndCollapse( url.slice( off ) );
                    url = url.slice( 0, off );
                }

                // If it's a function
                if ( isFunction( params ) ) {

                    // We assume that it's the callback
                    callback = params;
                    params = undefined;

                    // Otherwise, build a param string
                } else if ( params && typeof params === "object" ) {
                    type = "POST";
                }

                // If we have elements to modify, make the request
                if ( self.length > 0 ) {
                    jQuery.ajax( {
                        url: url,

                        // If "type" variable is undefined, then "GET" method will be used.
                        // Make value of this field explicit since
                        // user can override it through ajaxSetup method
                        type: type || "GET",
                        dataType: "html",
                        data: params
                    } ).done( function( responseText ) {

                        // Save response for use in complete callback
                        response = arguments;

                        self.html( selector ?

                                // If a selector was specified, locate the right elements in a dummy div
                                // Exclude scripts to avoid IE 'Permission Denied' errors
                                jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

                                // Otherwise use the full result
                                responseText );

                        // If the request succeeds, this function gets "data", "status", "jqXHR"
                        // but they are ignored because response was set above.
                        // If it fails, this function gets "jqXHR", "status", "error"
                    } ).always( callback && function( jqXHR, status ) {
                                self.each( function() {
                                    callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
                                } );
                            } );
                }

                return this;
            };


            jQuery.expr.pseudos.animated = function( elem ) {
                return jQuery.grep( jQuery.timers, function( fn ) {
                    return elem === fn.elem;
                } ).length;
            };




            jQuery.offset = {
                setOffset: function( elem, options, i ) {
                    var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
                            position = jQuery.css( elem, "position" ),
                            curElem = jQuery( elem ),
                            props = {};

                    // Set position first, in-case top/left are set even on static elem
                    if ( position === "static" ) {
                        elem.style.position = "relative";
                    }

                    curOffset = curElem.offset();
                    curCSSTop = jQuery.css( elem, "top" );
                    curCSSLeft = jQuery.css( elem, "left" );
                    calculatePosition = ( position === "absolute" || position === "fixed" ) &&
                            ( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;

                    // Need to be able to calculate position if either
                    // top or left is auto and position is either absolute or fixed
                    if ( calculatePosition ) {
                        curPosition = curElem.position();
                        curTop = curPosition.top;
                        curLeft = curPosition.left;

                    } else {
                        curTop = parseFloat( curCSSTop ) || 0;
                        curLeft = parseFloat( curCSSLeft ) || 0;
                    }

                    if ( isFunction( options ) ) {

                        // Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
                        options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
                    }

                    if ( options.top != null ) {
                        props.top = ( options.top - curOffset.top ) + curTop;
                    }
                    if ( options.left != null ) {
                        props.left = ( options.left - curOffset.left ) + curLeft;
                    }

                    if ( "using" in options ) {
                        options.using.call( elem, props );

                    } else {
                        if ( typeof props.top === "number" ) {
                            props.top += "px";
                        }
                        if ( typeof props.left === "number" ) {
                            props.left += "px";
                        }
                        curElem.css( props );
                    }
                }
            };

            jQuery.fn.extend( {

                // offset() relates an element's border box to the document origin
                offset: function( options ) {

                    // Preserve chaining for setter
                    if ( arguments.length ) {
                        return options === undefined ?
                                this :
                                this.each( function( i ) {
                                    jQuery.offset.setOffset( this, options, i );
                                } );
                    }

                    var rect, win,
                            elem = this[ 0 ];

                    if ( !elem ) {
                        return;
                    }

                    // Return zeros for disconnected and hidden (display: none) elements (gh-2310)
                    // Support: IE <=11 only
                    // Running getBoundingClientRect on a
                    // disconnected node in IE throws an error
                    if ( !elem.getClientRects().length ) {
                        return { top: 0, left: 0 };
                    }

                    // Get document-relative position by adding viewport scroll to viewport-relative gBCR
                    rect = elem.getBoundingClientRect();
                    win = elem.ownerDocument.defaultView;
                    return {
                        top: rect.top + win.pageYOffset,
                        left: rect.left + win.pageXOffset
                    };
                },

                // position() relates an element's margin box to its offset parent's padding box
                // This corresponds to the behavior of CSS absolute positioning
                position: function() {
                    if ( !this[ 0 ] ) {
                        return;
                    }

                    var offsetParent, offset, doc,
                            elem = this[ 0 ],
                            parentOffset = { top: 0, left: 0 };

                    // position:fixed elements are offset from the viewport, which itself always has zero offset
                    if ( jQuery.css( elem, "position" ) === "fixed" ) {

                        // Assume position:fixed implies availability of getBoundingClientRect
                        offset = elem.getBoundingClientRect();

                    } else {
                        offset = this.offset();

                        // Account for the *real* offset parent, which can be the document or its root element
                        // when a statically positioned element is identified
                        doc = elem.ownerDocument;
                        offsetParent = elem.offsetParent || doc.documentElement;
                        while ( offsetParent &&
                        ( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
                        jQuery.css( offsetParent, "position" ) === "static" ) {

                            offsetParent = offsetParent.parentNode;
                        }
                        if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {

                            // Incorporate borders into its offset, since they are outside its content origin
                            parentOffset = jQuery( offsetParent ).offset();
                            parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
                            parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
                        }
                    }

                    // Subtract parent offsets and element margins
                    return {
                        top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
                        left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
                    };
                },

                // This method will return documentElement in the following cases:
                // 1) For the element inside the iframe without offsetParent, this method will return
                //    documentElement of the parent window
                // 2) For the hidden or detached element
                // 3) For body or html element, i.e. in case of the html node - it will return itself
                //
                // but those exceptions were never presented as a real life use-cases
                // and might be considered as more preferable results.
                //
                // This logic, however, is not guaranteed and can change at any point in the future
                offsetParent: function() {
                    return this.map( function() {
                        var offsetParent = this.offsetParent;

                        while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
                            offsetParent = offsetParent.offsetParent;
                        }

                        return offsetParent || documentElement;
                    } );
                }
            } );

// Create scrollLeft and scrollTop methods
            jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
                var top = "pageYOffset" === prop;

                jQuery.fn[ method ] = function( val ) {
                    return access( this, function( elem, method, val ) {

                        // Coalesce documents and windows
                        var win;
                        if ( isWindow( elem ) ) {
                            win = elem;
                        } else if ( elem.nodeType === 9 ) {
                            win = elem.defaultView;
                        }

                        if ( val === undefined ) {
                            return win ? win[ prop ] : elem[ method ];
                        }

                        if ( win ) {
                            win.scrollTo(
                                    !top ? val : win.pageXOffset,
                                    top ? val : win.pageYOffset
                            );

                        } else {
                            elem[ method ] = val;
                        }
                    }, method, val, arguments.length );
                };
            } );

// Support: Safari <=7 - 9.1, Chrome <=37 - 49
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
// getComputedStyle returns percent when specified for top/left/bottom/right;
// rather than make the css module depend on the offset module, just check for it here
            jQuery.each( [ "top", "left" ], function( _i, prop ) {
                jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
                        function( elem, computed ) {
                            if ( computed ) {
                                computed = curCSS( elem, prop );

                                // If curCSS returns percentage, fallback to offset
                                return rnumnonpx.test( computed ) ?
                                jQuery( elem ).position()[ prop ] + "px" :
                                        computed;
                            }
                        }
                );
            } );


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
            jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
                jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
                        function( defaultExtra, funcName ) {

                            // Margin is only for outerHeight, outerWidth
                            jQuery.fn[ funcName ] = function( margin, value ) {
                                var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
                                        extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

                                return access( this, function( elem, type, value ) {
                                    var doc;

                                    if ( isWindow( elem ) ) {

                                        // $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
                                        return funcName.indexOf( "outer" ) === 0 ?
                                                elem[ "inner" + name ] :
                                                elem.document.documentElement[ "client" + name ];
                                    }

                                    // Get document width or height
                                    if ( elem.nodeType === 9 ) {
                                        doc = elem.documentElement;

                                        // Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
                                        // whichever is greatest
                                        return Math.max(
                                                elem.body[ "scroll" + name ], doc[ "scroll" + name ],
                                                elem.body[ "offset" + name ], doc[ "offset" + name ],
                                                doc[ "client" + name ]
                                        );
                                    }

                                    return value === undefined ?

                                            // Get width or height on the element, requesting but not forcing parseFloat
                                            jQuery.css( elem, type, extra ) :

                                            // Set width or height on the element
                                            jQuery.style( elem, type, value, extra );
                                }, type, chainable ? margin : undefined, chainable );
                            };
                        } );
            } );


            jQuery.each( [
                "ajaxStart",
                "ajaxStop",
                "ajaxComplete",
                "ajaxError",
                "ajaxSuccess",
                "ajaxSend"
            ], function( _i, type ) {
                jQuery.fn[ type ] = function( fn ) {
                    return this.on( type, fn );
                };
            } );




            jQuery.fn.extend( {

                bind: function( types, data, fn ) {
                    return this.on( types, null, data, fn );
                },
                unbind: function( types, fn ) {
                    return this.off( types, null, fn );
                },

                delegate: function( selector, types, data, fn ) {
                    return this.on( types, selector, data, fn );
                },
                undelegate: function( selector, types, fn ) {

                    // ( namespace ) or ( selector, types [, fn] )
                    return arguments.length === 1 ?
                            this.off( selector, "**" ) :
                            this.off( types, selector || "**", fn );
                },

                hover: function( fnOver, fnOut ) {
                    return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
                }
            } );

            jQuery.each( ( "blur focus focusin focusout resize scroll click dblclick " +
                    "mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
                    "change select submit keydown keypress keyup contextmenu" ).split( " " ),
                    function( _i, name ) {

                        // Handle event binding
                        jQuery.fn[ name ] = function( data, fn ) {
                            return arguments.length > 0 ?
                                    this.on( name, null, data, fn ) :
                                    this.trigger( name );
                        };
                    } );




// Support: Android <=4.0 only
// Make sure we trim BOM and NBSP
            var rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;

// Bind a function to a context, optionally partially applying any
// arguments.
// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
// However, it is not slated for removal any time soon
            jQuery.proxy = function( fn, context ) {
                var tmp, args, proxy;

                if ( typeof context === "string" ) {
                    tmp = fn[ context ];
                    context = fn;
                    fn = tmp;
                }

                // Quick check to determine if target is callable, in the spec
                // this throws a TypeError, but we will just return undefined.
                if ( !isFunction( fn ) ) {
                    return undefined;
                }

                // Simulated bind
                args = slice.call( arguments, 2 );
                proxy = function() {
                    return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
                };

                // Set the guid of unique handler to the same of original handler, so it can be removed
                proxy.guid = fn.guid = fn.guid || jQuery.guid++;

                return proxy;
            };

            jQuery.holdReady = function( hold ) {
                if ( hold ) {
                    jQuery.readyWait++;
                } else {
                    jQuery.ready( true );
                }
            };
            jQuery.isArray = Array.isArray;
            jQuery.parseJSON = JSON.parse;
            jQuery.nodeName = nodeName;
            jQuery.isFunction = isFunction;
            jQuery.isWindow = isWindow;
            jQuery.camelCase = camelCase;
            jQuery.type = toType;

            jQuery.now = Date.now;

            jQuery.isNumeric = function( obj ) {

                // As of jQuery 3.0, isNumeric is limited to
                // strings and numbers (primitives or objects)
                // that can be coerced to finite numbers (gh-2662)
                var type = jQuery.type( obj );
                return ( type === "number" || type === "string" ) &&

                        // parseFloat NaNs numeric-cast false positives ("")
                        // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
                        // subtraction forces infinities to NaN
                        !isNaN( obj - parseFloat( obj ) );
            };

            jQuery.trim = function( text ) {
                return text == null ?
                        "" :
                        ( text + "" ).replace( rtrim, "" );
            };



// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

            if ( true ) {
                !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function() {
                    return jQuery;
                }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
                __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
            }




            var

            // Map over jQuery in case of overwrite
                    _jQuery = window.jQuery,

            // Map over the $ in case of overwrite
                    _$ = window.$;

            jQuery.noConflict = function( deep ) {
                if ( window.$ === jQuery ) {
                    window.$ = _$;
                }

                if ( deep && window.jQuery === jQuery ) {
                    window.jQuery = _jQuery;
                }

                return jQuery;
            };

// Expose jQuery and $ identifiers, even in AMD
// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (#13566)
            if ( typeof noGlobal === "undefined" ) {
                window.jQuery = window.$ = jQuery;
            }




            return jQuery;
        } );


        /***/ }),
    /* 1 */
    /***/ (function(module, exports, __webpack_require__) {

        var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
         * $script.js JS loader & dependency manager
         * https://github.com/ded/script.js
         * (c) Dustin Diaz 2014 | License MIT
         */

        (function (name, definition) {
            if ( true && module.exports) module.exports = definition()
            else if (true) !(__WEBPACK_AMD_DEFINE_FACTORY__ = (definition),
                    __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
                            (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
                            __WEBPACK_AMD_DEFINE_FACTORY__),
            __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
            else {}
        })('$script', function () {
            var doc = document
                    , head = doc.getElementsByTagName('head')[0]
                    , s = 'string'
                    , f = false
                    , push = 'push'
                    , readyState = 'readyState'
                    , onreadystatechange = 'onreadystatechange'
                    , list = {}
                    , ids = {}
                    , delay = {}
                    , scripts = {}
                    , scriptpath
                    , urlArgs

            function every(ar, fn) {
                for (var i = 0, j = ar.length; i < j; ++i) if (!fn(ar[i])) return f
                return 1
            }
            function each(ar, fn) {
                every(ar, function (el) {
                    fn(el)
                    return 1
                })
            }

            function $script(paths, idOrDone, optDone) {
                paths = paths[push] ? paths : [paths]
                var idOrDoneIsDone = idOrDone && idOrDone.call
                        , done = idOrDoneIsDone ? idOrDone : optDone
                        , id = idOrDoneIsDone ? paths.join('') : idOrDone
                        , queue = paths.length
                function loopFn(item) {
                    return item.call ? item() : list[item]
                }
                function callback() {
                    if (!--queue) {
                        list[id] = 1
                        done && done()
                        for (var dset in delay) {
                            every(dset.split('|'), loopFn) && !each(delay[dset], loopFn) && (delay[dset] = [])
                        }
                    }
                }
                setTimeout(function () {
                    each(paths, function loading(path, force) {
                        if (path === null) return callback()

                        if (!force && !/^https?:\/\//.test(path) && scriptpath) {
                            path = (path.indexOf('.js') === -1) ? scriptpath + path + '.js' : scriptpath + path;
                        }

                        if (scripts[path]) {
                            if (id) ids[id] = 1
                            return (scripts[path] == 2) ? callback() : setTimeout(function () { loading(path, true) }, 0)
                        }

                        scripts[path] = 1
                        if (id) ids[id] = 1
                        create(path, callback)
                    })
                }, 0)
                return $script
            }

            function create(path, fn) {
                var el = doc.createElement('script'), loaded
                el.onload = el.onerror = el[onreadystatechange] = function () {
                    if ((el[readyState] && !(/^c|loade/.test(el[readyState]))) || loaded) return;
                    el.onload = el[onreadystatechange] = null
                    loaded = 1
                    scripts[path] = 2
                    fn()
                }
                el.async = 1
                el.src = urlArgs ? path + (path.indexOf('?') === -1 ? '?' : '&') + urlArgs : path;
                head.insertBefore(el, head.lastChild)
            }

            $script.get = create

            $script.order = function (scripts, id, done) {
                (function callback(s) {
                    s = scripts.shift()
                    !scripts.length ? $script(s, id, done) : $script(s, callback)
                }())
            }

            $script.path = function (p) {
                scriptpath = p
            }
            $script.urlArgs = function (str) {
                urlArgs = str;
            }
            $script.ready = function (deps, ready, req) {
                deps = deps[push] ? deps : [deps]
                var missing = [];
                !each(deps, function (dep) {
                    list[dep] || missing[push](dep);
                }) && every(deps, function (dep) {return list[dep]}) ?
                        ready() : !function (key) {
                    delay[key] = delay[key] || []
                    delay[key][push](ready)
                    req && req(missing)
                }(deps.join('|'))
                return $script
            }

            $script.done = function (idOrDone) {
                $script([null], idOrDone)
            }

            return $script
        });


        /***/ }),
    /* 2 */
    /***/ (function(module, exports, __webpack_require__) {

        "use strict";

        exports.__esModule = true;
        var EventHandler = /** @class */ (function () {
            function EventHandler() {
                this.events = [];
            }
            EventHandler.prototype.register = function (el, event, listener) {
                if (!el || !event || !listener)
                    return null;
                this.events.push({ el: el, event: event, listener: listener });
                el.addEventListener(event, listener);
                return { el: el, event: event, listener: listener };
            };
            EventHandler.prototype.unregister = function (_a) {
                var el = _a.el, event = _a.event, listener = _a.listener;
                if (!el || !event || !listener)
                    return null;
                this.events = this.events.filter(function (e) { return el !== e.el
                        || event !== e.event || listener !== e.listener; });
                el.removeEventListener(event, listener);
                return { el: el, event: event, listener: listener };
            };
            EventHandler.prototype.unregisterAll = function () {
                this.events.forEach(function (_a) {
                    var el = _a.el, event = _a.event, listener = _a.listener;
                    return el.removeEventListener(event, listener);
                });
                this.events = [];
            };
            return EventHandler;
        }());
        exports["default"] = EventHandler;


        /***/ }),
    /* 3 */
    /***/ (function(module, exports) {

        module.exports = debounce

        function debounce (fn, delay, at_start, guarantee) {
            var timeout
            var args
            var self

            return function debounced () {
                self = this
                args = Array.prototype.slice.call(arguments)

                if (timeout && (at_start || guarantee)) {
                    return
                } else if (!at_start) {
                    clear()

                    timeout = setTimeout(run, delay)
                    return timeout
                }

                timeout = setTimeout(clear, delay)
                fn.apply(self, args)

                function run () {
                    clear()
                    fn.apply(self, args)
                }

                function clear () {
                    clearTimeout(timeout)
                    timeout = null
                }
            }
        }


        /***/ }),
    /* 4 */
    /***/ (function(module, exports, __webpack_require__) {

        var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
         * Flickity v2.2.0
         * Touch, responsive, flickable carousels
         *
         * Licensed GPLv3 for open source use
         * or Flickity Commercial License for commercial use
         *
         * https://flickity.metafizzy.co
         * Copyright 2015-2018 Metafizzy
         */

        ( function( window, factory ) {
            // universal module definition
            /* jshint strict: false */
            if ( true ) {
                // AMD
                !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
                    __webpack_require__(7),
                    __webpack_require__(25),
                    __webpack_require__(27),
                    __webpack_require__(28),
                    __webpack_require__(29),
                    __webpack_require__(30),
                    __webpack_require__(31)
                ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
                        __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
                                (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
                __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
            } else {}

        })( window, function factory( Flickity ) {
            /*jshint strict: false*/
            return Flickity;
        });


        /***/ }),
    /* 5 */
    /***/ (function(module, exports, __webpack_require__) {

        "use strict";

        Object.defineProperty(exports, "__esModule", { value: true });
        /**
         * Reads the content property on the documentElement ::before pseudo element
         * for a string of ordered, comma-separated, breakpoint names.
         *
         * @returns An ordered array of strings representing the breakpoint names
         *
         */
        function readCSSBreakpoints() {
            return window
                    .getComputedStyle(document.documentElement, ':before')
                    .getPropertyValue('content')
                    .replace(/"/g, '')
                    .split(',');
        }
        /**
         * Reads the content property on the documentElement ::after pseudo element
         * for a string of the current breakpoint name. This value is updated using
         * dynamically using media queries and should match a value found in
         * the ::before pseudo element.
         *
         * @returns A string representing the current breakpoint name
         *
         */
        function readCSSCurrentBreakpoint() {
            return window
                    .getComputedStyle(document.documentElement, ':after')
                    .getPropertyValue('content')
                    .replace(/"/g, '');
        }
        var callbacks = [];
        var cssBreakpoints = readCSSBreakpoints();
        var CSSBreakpoint = /** @class */ (function () {
            function CSSBreakpoint(cssBreakpoint) {
                this.cssBreakpoint = cssBreakpoint;
            }
            Object.defineProperty(CSSBreakpoint.prototype, "value", {
                get: function () {
                    return this.cssBreakpoint;
                },
                enumerable: true,
                configurable: true
            });
            /**
             * Checks whether this breakpoint is at least the input breakpoint
             *
             * @param breakpointName - The input breakpoint name
             * @returns Whether this breakpoint is the same or greater than the input breakpoint
             *
             */
            CSSBreakpoint.prototype.min = function (breakpointName) {
                var comparison = cssBreakpoints.indexOf(this.value) - cssBreakpoints.indexOf(breakpointName);
                return comparison >= 0;
            };
            /**
             * Checks whether this breakpoint is at most the input breakpoint
             *
             * @param breakpointName - The input breakpoint name
             * @returns Whether this breakpoint is the same or less than the input breakpoint
             *
             */
            CSSBreakpoint.prototype.max = function (breakpointName) {
                var comparison = cssBreakpoints.indexOf(this.value) - cssBreakpoints.indexOf(breakpointName);
                return comparison <= 0;
            };
            /**
             * Checks whether this breakpoint is at within the input breakpoint start
             * and input breakpoint end, inclusive
             *
             * @param breakpointNameStart - The starting input breakpoint name
             * @param breakpointNameEnd - The ending input breakpoint name
             * @returns Whether this breakpoint is the same or greater than the starting input
             *          breakpoint and the same or less than the ending input breakpoint
             *
             */
            CSSBreakpoint.prototype.range = function (breakpointNameStart, breakpointNameEnd) {
                var indexCurrent = cssBreakpoints.indexOf(this.value);
                var indexStart = cssBreakpoints.indexOf(breakpointNameStart);
                var indexEnd = cssBreakpoints.indexOf(breakpointNameEnd);
                return indexStart <= indexCurrent && indexCurrent <= indexEnd;
            };
            /**
             * Checks whether this breakpoint is one of the input breakpoints
             *
             * @param breakpointNames - One or more input breakpoint names
             * @returns Whether this breakpoint is one of the input breakpoints
             *
             */
            CSSBreakpoint.prototype.is = function () {
                var _this = this;
                var breakpointNames = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    breakpointNames[_i] = arguments[_i];
                }
                return breakpointNames.some(function (breakpoint) { return breakpoint === _this.value; });
            };
            return CSSBreakpoint;
        }());
        var breakpoints = {
            previous: new CSSBreakpoint(readCSSCurrentBreakpoint()),
            current: new CSSBreakpoint(readCSSCurrentBreakpoint()),
        };
        /**
         * Gets the breakpoints
         *
         * @returns The current and previous breakpoint
         *
         */
        function get() {
            return breakpoints;
        }
        exports.get = get;
        /**
         * Adds an event listener to be called when a breakpoint changes
         *
         * @param callback - The function to be called when a breakpoint changes
         *
         */
        function onChange(callback) {
            if (callbacks.indexOf(callback) === -1) {
                callbacks.push(callback);
            }
        }
        exports.onChange = onChange;
        /**
         * Removes an event listener to be called when a breakpoint changes
         *
         * @param callback - The function to be removed from the set of event listeners
         *
         */
        function offChange(callback) {
            var index = callbacks.indexOf(callback);
            if (index !== -1) {
                callbacks.splice(index, 1);
            }
        }
        exports.offChange = offChange;
        var currentMin = function (breakpointName) { return breakpoints.current.min(breakpointName); };
        exports.min = currentMin;
        var currentMax = function (breakpointName) { return breakpoints.current.max(breakpointName); };
        exports.max = currentMax;
        var currentRange = function (breakpointNameStart, breakpointNameEnd) { return breakpoints.current.range(breakpointNameStart, breakpointNameEnd); };
        exports.range = currentRange;
        var currentIs = function () {
            var _a;
            var breakpointNames = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                breakpointNames[_i] = arguments[_i];
            }
            return (_a = breakpoints.current).is.apply(_a, breakpointNames);
        };
        exports.is = currentIs;
        /*
         * document.styleSheets is considered experimental technology; however,
         * the majority of current browsers implement this functionality.
         *
         * One drawback is under certain conditions, stylesheets may become
         * available due to security rules in the browser and we must be able to
         * fallback gracefully.
         */
        var styleSheetList = document.styleSheets;
        var mediaLists = Object.keys(styleSheetList).reduce(function (accumulator, key) {
            var stylesheet = styleSheetList[key];
            if (!stylesheet.href || stylesheet.href.indexOf('theme') === -1) {
                return accumulator;
            }
            try {
                var cssRules = stylesheet.cssRules;
                for (var i = 0; i < cssRules.length; i++) {
                    var cssRule = stylesheet.cssRules[i];
                    if (!(cssRule instanceof CSSMediaRule)) {
                        continue;
                    }
                    for (var j = 0; j < cssRules.length; j++) {
                        var cssMediaCssRule = cssRule.cssRules[j];
                        if (!(cssMediaCssRule instanceof CSSStyleRule)) {
                            continue;
                        }
                        if (cssMediaCssRule.selectorText && cssMediaCssRule.selectorText.indexOf('html::after') !== -1) {
                            accumulator.push(cssRule.media);
                        }
                    }
                }
            }
            catch (_a) {
                return accumulator;
            }
            return accumulator;
        }, []);
        /*
         * Use window.matchMedia when stylesheets are accessible in the browser.
         * matchMedia is theoretically more performant than listening to every resize
         * event because it only fires when a media query boundary is crossed.
         *
         * If stylesheets aren't available, revert back to using the resize event.
         */
        if (mediaLists.length > 0) {
            mediaLists.forEach(function (mediaList) {
                var mql = window.matchMedia(mediaList.mediaText);
                mql.addListener(function () {
                    var cssCurrentBreakpoint = readCSSCurrentBreakpoint();
                    if (breakpoints.current.value !== cssCurrentBreakpoint) {
                        breakpoints.previous = breakpoints.current;
                        breakpoints.current = new CSSBreakpoint(cssCurrentBreakpoint);
                        callbacks.forEach(function (callback) { return callback(breakpoints); });
                    }
                });
            });
        }
        else {
            window.addEventListener('resize', function () {
                var cssCurrentBreakpoint = readCSSCurrentBreakpoint();
                if (breakpoints.current.value !== cssCurrentBreakpoint) {
                    breakpoints.previous = breakpoints.current;
                    breakpoints.current = new CSSBreakpoint(cssCurrentBreakpoint);
                    callbacks.forEach(function (callback) { return callback(breakpoints); });
                }
            });
        }


        /***/ }),
    /* 6 */
    /***/ (function(module, exports, __webpack_require__) {

        var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
         * Fizzy UI utils v2.0.7
         * MIT license
         */

        /*jshint browser: true, undef: true, unused: true, strict: true */

        ( function( window, factory ) {
            // universal module definition
            /*jshint strict: false */ /*globals define, module, require */

            if ( true ) {
                // AMD
                !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
                    __webpack_require__(21)
                ], __WEBPACK_AMD_DEFINE_RESULT__ = (function( matchesSelector ) {
                    return factory( window, matchesSelector );
                }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
                __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
            } else {}

        }( window, function factory( window, matchesSelector ) {

            'use strict';

            var utils = {};

// ----- extend ----- //

// extends objects
            utils.extend = function( a, b ) {
                for ( var prop in b ) {
                    a[ prop ] = b[ prop ];
                }
                return a;
            };

// ----- modulo ----- //

            utils.modulo = function( num, div ) {
                return ( ( num % div ) + div ) % div;
            };

// ----- makeArray ----- //

            var arraySlice = Array.prototype.slice;

// turn element or nodeList into an array
            utils.makeArray = function( obj ) {
                if ( Array.isArray( obj ) ) {
                    // use object if already an array
                    return obj;
                }
                // return empty array if undefined or null. #6
                if ( obj === null || obj === undefined ) {
                    return [];
                }

                var isArrayLike = typeof obj == 'object' && typeof obj.length == 'number';
                if ( isArrayLike ) {
                    // convert nodeList to array
                    return arraySlice.call( obj );
                }

                // array of single index
                return [ obj ];
            };

// ----- removeFrom ----- //

            utils.removeFrom = function( ary, obj ) {
                var index = ary.indexOf( obj );
                if ( index != -1 ) {
                    ary.splice( index, 1 );
                }
            };

// ----- getParent ----- //

            utils.getParent = function( elem, selector ) {
                while ( elem.parentNode && elem != document.body ) {
                    elem = elem.parentNode;
                    if ( matchesSelector( elem, selector ) ) {
                        return elem;
                    }
                }
            };

// ----- getQueryElement ----- //

// use element as selector string
            utils.getQueryElement = function( elem ) {
                if ( typeof elem == 'string' ) {
                    return document.querySelector( elem );
                }
                return elem;
            };

// ----- handleEvent ----- //

// enable .ontype to trigger from .addEventListener( elem, 'type' )
            utils.handleEvent = function( event ) {
                var method = 'on' + event.type;
                if ( this[ method ] ) {
                    this[ method ]( event );
                }
            };

// ----- filterFindElements ----- //

            utils.filterFindElements = function( elems, selector ) {
                // make array of elems
                elems = utils.makeArray( elems );
                var ffElems = [];

                elems.forEach( function( elem ) {
                    // check that elem is an actual element
                    if ( !( elem instanceof HTMLElement ) ) {
                        return;
                    }
                    // add elem if no selector
                    if ( !selector ) {
                        ffElems.push( elem );
                        return;
                    }
                    // filter & find items if we have a selector
                    // filter
                    if ( matchesSelector( elem, selector ) ) {
                        ffElems.push( elem );
                    }
                    // find children
                    var childElems = elem.querySelectorAll( selector );
                    // concat childElems to filterFound array
                    for ( var i=0; i < childElems.length; i++ ) {
                        ffElems.push( childElems[i] );
                    }
                });

                return ffElems;
            };

// ----- debounceMethod ----- //

            utils.debounceMethod = function( _class, methodName, threshold ) {
                threshold = threshold || 100;
                // original method
                var method = _class.prototype[ methodName ];
                var timeoutName = methodName + 'Timeout';

                _class.prototype[ methodName ] = function() {
                    var timeout = this[ timeoutName ];
                    clearTimeout( timeout );

                    var args = arguments;
                    var _this = this;
                    this[ timeoutName ] = setTimeout( function() {
                        method.apply( _this, args );
                        delete _this[ timeoutName ];
                    }, threshold );
                };
            };

// ----- docReady ----- //

            utils.docReady = function( callback ) {
                var readyState = document.readyState;
                if ( readyState == 'complete' || readyState == 'interactive' ) {
                    // do async to allow for other scripts to run. metafizzy/flickity#441
                    setTimeout( callback );
                } else {
                    document.addEventListener( 'DOMContentLoaded', callback );
                }
            };

// ----- htmlInit ----- //

// http://jamesroberts.name/blog/2010/02/22/string-functions-for-javascript-trim-to-camel-case-to-dashed-and-to-underscore/
            utils.toDashed = function( str ) {
                return str.replace( /(.)([A-Z])/g, function( match, $1, $2 ) {
                    return $1 + '-' + $2;
                }).toLowerCase();
            };

            var console = window.console;
            /**
             * allow user to initialize classes via [data-namespace] or .js-namespace class
             * htmlInit( Widget, 'widgetName' )
             * options are parsed from data-namespace-options
             */
            utils.htmlInit = function( WidgetClass, namespace ) {
                utils.docReady( function() {
                    var dashedNamespace = utils.toDashed( namespace );
                    var dataAttr = 'data-' + dashedNamespace;
                    var dataAttrElems = document.querySelectorAll( '[' + dataAttr + ']' );
                    var jsDashElems = document.querySelectorAll( '.js-' + dashedNamespace );
                    var elems = utils.makeArray( dataAttrElems )
                            .concat( utils.makeArray( jsDashElems ) );
                    var dataOptionsAttr = dataAttr + '-options';
                    var jQuery = window.jQuery;

                    elems.forEach( function( elem ) {
                        var attr = elem.getAttribute( dataAttr ) ||
                                elem.getAttribute( dataOptionsAttr );
                        var options;
                        try {
                            options = attr && JSON.parse( attr );
                        } catch ( error ) {
                            // log error, do not initialize
                            if ( console ) {
                                console.error( 'Error parsing ' + dataAttr + ' on ' + elem.className +
                                        ': ' + error );
                            }
                            return;
                        }
                        // initialize
                        var instance = new WidgetClass( elem, options );
                        // make available via $().data('namespace')
                        if ( jQuery ) {
                            jQuery.data( elem, namespace, instance );
                        }
                    });

                });
            };

// -----  ----- //

            return utils;

        }));


        /***/ }),
    /* 7 */
    /***/ (function(module, exports, __webpack_require__) {

        var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// Flickity main
        ( function( window, factory ) {
            // universal module definition
            /* jshint strict: false */
            if ( true ) {
                // AMD
                !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
                    __webpack_require__(8),
                    __webpack_require__(10),
                    __webpack_require__(6),
                    __webpack_require__(22),
                    __webpack_require__(23),
                    __webpack_require__(24)
                ], __WEBPACK_AMD_DEFINE_RESULT__ = (function( EvEmitter, getSize, utils, Cell, Slide, animatePrototype ) {
                    return factory( window, EvEmitter, getSize, utils, Cell, Slide, animatePrototype );
                }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
                __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
            } else { var _Flickity; }

        }( window, function factory( window, EvEmitter, getSize,
                                     utils, Cell, Slide, animatePrototype ) {

            'use strict';

// vars
            var jQuery = window.jQuery;
            var getComputedStyle = window.getComputedStyle;
            var console = window.console;

            function moveElements( elems, toElem ) {
                elems = utils.makeArray( elems );
                while ( elems.length ) {
                    toElem.appendChild( elems.shift() );
                }
            }

// -------------------------- Flickity -------------------------- //

// globally unique identifiers
            var GUID = 0;
// internal store of all Flickity intances
            var instances = {};

            function Flickity( element, options ) {
                var queryElement = utils.getQueryElement( element );
                if ( !queryElement ) {
                    if ( console ) {
                        console.error( 'Bad element for Flickity: ' + ( queryElement || element ) );
                    }
                    return;
                }
                this.element = queryElement;
                // do not initialize twice on same element
                if ( this.element.flickityGUID ) {
                    var instance = instances[ this.element.flickityGUID ];
                    instance.option( options );
                    return instance;
                }

                // add jQuery
                if ( jQuery ) {
                    this.$element = jQuery( this.element );
                }
                // options
                this.options = utils.extend( {}, this.constructor.defaults );
                this.option( options );

                // kick things off
                this._create();
            }

            Flickity.defaults = {
                accessibility: true,
                // adaptiveHeight: false,
                cellAlign: 'center',
                // cellSelector: undefined,
                // contain: false,
                freeScrollFriction: 0.075, // friction when free-scrolling
                friction: 0.28, // friction when selecting
                namespaceJQueryEvents: true,
                // initialIndex: 0,
                percentPosition: true,
                resize: true,
                selectedAttraction: 0.025,
                setGallerySize: true
                // watchCSS: false,
                // wrapAround: false
            };

// hash of methods triggered on _create()
            Flickity.createMethods = [];

            var proto = Flickity.prototype;
// inherit EventEmitter
            utils.extend( proto, EvEmitter.prototype );

            proto._create = function() {
                // add id for Flickity.data
                var id = this.guid = ++GUID;
                this.element.flickityGUID = id; // expando
                instances[ id ] = this; // associate via id
                // initial properties
                this.selectedIndex = 0;
                // how many frames slider has been in same position
                this.restingFrames = 0;
                // initial physics properties
                this.x = 0;
                this.velocity = 0;
                this.originSide = this.options.rightToLeft ? 'right' : 'left';
                // create viewport & slider
                this.viewport = document.createElement('div');
                this.viewport.className = 'flickity-viewport';
                this._createSlider();

                if ( this.options.resize || this.options.watchCSS ) {
                    window.addEventListener( 'resize', this );
                }

                // add listeners from on option
                for ( var eventName in this.options.on ) {
                    var listener = this.options.on[ eventName ];
                    this.on( eventName, listener );
                }

                Flickity.createMethods.forEach( function( method ) {
                    this[ method ]();
                }, this );

                if ( this.options.watchCSS ) {
                    this.watchCSS();
                } else {
                    this.activate();
                }

            };

            /**
             * set options
             * @param {Object} opts
             */
            proto.option = function( opts ) {
                utils.extend( this.options, opts );
            };

            proto.activate = function() {
                if ( this.isActive ) {
                    return;
                }
                this.isActive = true;
                this.element.classList.add('flickity-enabled');
                if ( this.options.rightToLeft ) {
                    this.element.classList.add('flickity-rtl');
                }

                this.getSize();
                // move initial cell elements so they can be loaded as cells
                var cellElems = this._filterFindCellElements( this.element.children );
                moveElements( cellElems, this.slider );
                this.viewport.appendChild( this.slider );
                this.element.appendChild( this.viewport );
                // get cells from children
                this.reloadCells();

                if ( this.options.accessibility ) {
                    // allow element to focusable
                    this.element.tabIndex = 0;
                    // listen for key presses
                    this.element.addEventListener( 'keydown', this );
                }

                this.emitEvent('activate');
                this.selectInitialIndex();
                // flag for initial activation, for using initialIndex
                this.isInitActivated = true;
                // ready event. #493
                this.dispatchEvent('ready');
            };

// slider positions the cells
            proto._createSlider = function() {
                // slider element does all the positioning
                var slider = document.createElement('div');
                slider.className = 'flickity-slider';
                slider.style[ this.originSide ] = 0;
                this.slider = slider;
            };

            proto._filterFindCellElements = function( elems ) {
                return utils.filterFindElements( elems, this.options.cellSelector );
            };

// goes through all children
            proto.reloadCells = function() {
                // collection of item elements
                this.cells = this._makeCells( this.slider.children );
                this.positionCells();
                this._getWrapShiftCells();
                this.setGallerySize();
            };

            /**
             * turn elements into Flickity.Cells
             * @param {Array or NodeList or HTMLElement} elems
             * @returns {Array} items - collection of new Flickity Cells
             */
            proto._makeCells = function( elems ) {
                var cellElems = this._filterFindCellElements( elems );

                // create new Flickity for collection
                var cells = cellElems.map( function( cellElem ) {
                    return new Cell( cellElem, this );
                }, this );

                return cells;
            };

            proto.getLastCell = function() {
                return this.cells[ this.cells.length - 1 ];
            };

            proto.getLastSlide = function() {
                return this.slides[ this.slides.length - 1 ];
            };

// positions all cells
            proto.positionCells = function() {
                // size all cells
                this._sizeCells( this.cells );
                // position all cells
                this._positionCells( 0 );
            };

            /**
             * position certain cells
             * @param {Integer} index - which cell to start with
             */
            proto._positionCells = function( index ) {
                index = index || 0;
                // also measure maxCellHeight
                // start 0 if positioning all cells
                this.maxCellHeight = index ? this.maxCellHeight || 0 : 0;
                var cellX = 0;
                // get cellX
                if ( index > 0 ) {
                    var startCell = this.cells[ index - 1 ];
                    cellX = startCell.x + startCell.size.outerWidth;
                }
                var len = this.cells.length;
                for ( var i=index; i < len; i++ ) {
                    var cell = this.cells[i];
                    cell.setPosition( cellX );
                    cellX += cell.size.outerWidth;
                    this.maxCellHeight = Math.max( cell.size.outerHeight, this.maxCellHeight );
                }
                // keep track of cellX for wrap-around
                this.slideableWidth = cellX;
                // slides
                this.updateSlides();
                // contain slides target
                this._containSlides();
                // update slidesWidth
                this.slidesWidth = len ? this.getLastSlide().target - this.slides[0].target : 0;
            };

            /**
             * cell.getSize() on multiple cells
             * @param {Array} cells
             */
            proto._sizeCells = function( cells ) {
                cells.forEach( function( cell ) {
                    cell.getSize();
                });
            };

// --------------------------  -------------------------- //

            proto.updateSlides = function() {
                this.slides = [];
                if ( !this.cells.length ) {
                    return;
                }

                var slide = new Slide( this );
                this.slides.push( slide );
                var isOriginLeft = this.originSide == 'left';
                var nextMargin = isOriginLeft ? 'marginRight' : 'marginLeft';

                var canCellFit = this._getCanCellFit();

                this.cells.forEach( function( cell, i ) {
                    // just add cell if first cell in slide
                    if ( !slide.cells.length ) {
                        slide.addCell( cell );
                        return;
                    }

                    var slideWidth = ( slide.outerWidth - slide.firstMargin ) +
                            ( cell.size.outerWidth - cell.size[ nextMargin ] );

                    if ( canCellFit.call( this, i, slideWidth ) ) {
                        slide.addCell( cell );
                    } else {
                        // doesn't fit, new slide
                        slide.updateTarget();

                        slide = new Slide( this );
                        this.slides.push( slide );
                        slide.addCell( cell );
                    }
                }, this );
                // last slide
                slide.updateTarget();
                // update .selectedSlide
                this.updateSelectedSlide();
            };

            proto._getCanCellFit = function() {
                var groupCells = this.options.groupCells;
                if ( !groupCells ) {
                    return function() {
                        return false;
                    };
                } else if ( typeof groupCells == 'number' ) {
                    // group by number. 3 -> [0,1,2], [3,4,5], ...
                    var number = parseInt( groupCells, 10 );
                    return function( i ) {
                        return ( i % number ) !== 0;
                    };
                }
                // default, group by width of slide
                // parse '75%
                var percentMatch = typeof groupCells == 'string' &&
                        groupCells.match(/^(\d+)%$/);
                var percent = percentMatch ? parseInt( percentMatch[1], 10 ) / 100 : 1;
                return function( i, slideWidth ) {
                    return slideWidth <= ( this.size.innerWidth + 1 ) * percent;
                };
            };

// alias _init for jQuery plugin .flickity()
            proto._init =
                    proto.reposition = function() {
                        this.positionCells();
                        this.positionSliderAtSelected();
                    };

            proto.getSize = function() {
                this.size = getSize( this.element );
                this.setCellAlign();
                this.cursorPosition = this.size.innerWidth * this.cellAlign;
            };

            var cellAlignShorthands = {
                // cell align, then based on origin side
                center: {
                    left: 0.5,
                    right: 0.5
                },
                left: {
                    left: 0,
                    right: 1
                },
                right: {
                    right: 0,
                    left: 1
                }
            };

            proto.setCellAlign = function() {
                var shorthand = cellAlignShorthands[ this.options.cellAlign ];
                this.cellAlign = shorthand ? shorthand[ this.originSide ] : this.options.cellAlign;
            };

            proto.setGallerySize = function() {
                if ( this.options.setGallerySize ) {
                    var height = this.options.adaptiveHeight && this.selectedSlide ?
                            this.selectedSlide.height : this.maxCellHeight;
                    this.viewport.style.height = height + 'px';
                }
            };

            proto._getWrapShiftCells = function() {
                // only for wrap-around
                if ( !this.options.wrapAround ) {
                    return;
                }
                // unshift previous cells
                this._unshiftCells( this.beforeShiftCells );
                this._unshiftCells( this.afterShiftCells );
                // get before cells
                // initial gap
                var gapX = this.cursorPosition;
                var cellIndex = this.cells.length - 1;
                this.beforeShiftCells = this._getGapCells( gapX, cellIndex, -1 );
                // get after cells
                // ending gap between last cell and end of gallery viewport
                gapX = this.size.innerWidth - this.cursorPosition;
                // start cloning at first cell, working forwards
                this.afterShiftCells = this._getGapCells( gapX, 0, 1 );
            };

            proto._getGapCells = function( gapX, cellIndex, increment ) {
                // keep adding cells until the cover the initial gap
                var cells = [];
                while ( gapX > 0 ) {
                    var cell = this.cells[ cellIndex ];
                    if ( !cell ) {
                        break;
                    }
                    cells.push( cell );
                    cellIndex += increment;
                    gapX -= cell.size.outerWidth;
                }
                return cells;
            };

// ----- contain ----- //

// contain cell targets so no excess sliding
            proto._containSlides = function() {
                if ( !this.options.contain || this.options.wrapAround || !this.cells.length ) {
                    return;
                }
                var isRightToLeft = this.options.rightToLeft;
                var beginMargin = isRightToLeft ? 'marginRight' : 'marginLeft';
                var endMargin = isRightToLeft ? 'marginLeft' : 'marginRight';
                var contentWidth = this.slideableWidth - this.getLastCell().size[ endMargin ];
                // content is less than gallery size
                var isContentSmaller = contentWidth < this.size.innerWidth;
                // bounds
                var beginBound = this.cursorPosition + this.cells[0].size[ beginMargin ];
                var endBound = contentWidth - this.size.innerWidth * ( 1 - this.cellAlign );
                // contain each cell target
                this.slides.forEach( function( slide ) {
                    if ( isContentSmaller ) {
                        // all cells fit inside gallery
                        slide.target = contentWidth * this.cellAlign;
                    } else {
                        // contain to bounds
                        slide.target = Math.max( slide.target, beginBound );
                        slide.target = Math.min( slide.target, endBound );
                    }
                }, this );
            };

// -----  ----- //

            /**
             * emits events via eventEmitter and jQuery events
             * @param {String} type - name of event
             * @param {Event} event - original event
             * @param {Array} args - extra arguments
             */
            proto.dispatchEvent = function( type, event, args ) {
                var emitArgs = event ? [ event ].concat( args ) : args;
                this.emitEvent( type, emitArgs );

                if ( jQuery && this.$element ) {
                    // default trigger with type if no event
                    type += this.options.namespaceJQueryEvents ? '.flickity' : '';
                    var $event = type;
                    if ( event ) {
                        // create jQuery event
                        var jQEvent = jQuery.Event( event );
                        jQEvent.type = type;
                        $event = jQEvent;
                    }
                    this.$element.trigger( $event, args );
                }
            };

// -------------------------- select -------------------------- //

            /**
             * @param {Integer} index - index of the slide
             * @param {Boolean} isWrap - will wrap-around to last/first if at the end
             * @param {Boolean} isInstant - will immediately set position at selected cell
             */
            proto.select = function( index, isWrap, isInstant ) {
                if ( !this.isActive ) {
                    return;
                }
                index = parseInt( index, 10 );
                this._wrapSelect( index );

                if ( this.options.wrapAround || isWrap ) {
                    index = utils.modulo( index, this.slides.length );
                }
                // bail if invalid index
                if ( !this.slides[ index ] ) {
                    return;
                }
                var prevIndex = this.selectedIndex;
                this.selectedIndex = index;
                this.updateSelectedSlide();
                if ( isInstant ) {
                    this.positionSliderAtSelected();
                } else {
                    this.startAnimation();
                }
                if ( this.options.adaptiveHeight ) {
                    this.setGallerySize();
                }
                // events
                this.dispatchEvent( 'select', null, [ index ] );
                // change event if new index
                if ( index != prevIndex ) {
                    this.dispatchEvent( 'change', null, [ index ] );
                }
                // old v1 event name, remove in v3
                this.dispatchEvent('cellSelect');
            };

// wraps position for wrapAround, to move to closest slide. #113
            proto._wrapSelect = function( index ) {
                var len = this.slides.length;
                var isWrapping = this.options.wrapAround && len > 1;
                if ( !isWrapping ) {
                    return index;
                }
                var wrapIndex = utils.modulo( index, len );
                // go to shortest
                var delta = Math.abs( wrapIndex - this.selectedIndex );
                var backWrapDelta = Math.abs( ( wrapIndex + len ) - this.selectedIndex );
                var forewardWrapDelta = Math.abs( ( wrapIndex - len ) - this.selectedIndex );
                if ( !this.isDragSelect && backWrapDelta < delta ) {
                    index += len;
                } else if ( !this.isDragSelect && forewardWrapDelta < delta ) {
                    index -= len;
                }
                // wrap position so slider is within normal area
                if ( index < 0 ) {
                    this.x -= this.slideableWidth;
                } else if ( index >= len ) {
                    this.x += this.slideableWidth;
                }
            };

            proto.previous = function( isWrap, isInstant ) {
                this.select( this.selectedIndex - 1, isWrap, isInstant );
            };

            proto.next = function( isWrap, isInstant ) {
                this.select( this.selectedIndex + 1, isWrap, isInstant );
            };

            proto.updateSelectedSlide = function() {
                var slide = this.slides[ this.selectedIndex ];
                // selectedIndex could be outside of slides, if triggered before resize()
                if ( !slide ) {
                    return;
                }
                // unselect previous selected slide
                this.unselectSelectedSlide();
                // update new selected slide
                this.selectedSlide = slide;
                slide.select();
                this.selectedCells = slide.cells;
                this.selectedElements = slide.getCellElements();
                // HACK: selectedCell & selectedElement is first cell in slide, backwards compatibility
                // Remove in v3?
                this.selectedCell = slide.cells[0];
                this.selectedElement = this.selectedElements[0];
            };

            proto.unselectSelectedSlide = function() {
                if ( this.selectedSlide ) {
                    this.selectedSlide.unselect();
                }
            };

            proto.selectInitialIndex = function() {
                var initialIndex = this.options.initialIndex;
                // already activated, select previous selectedIndex
                if ( this.isInitActivated ) {
                    this.select( this.selectedIndex, false, true );
                    return;
                }
                // select with selector string
                if ( initialIndex && typeof initialIndex == 'string' ) {
                    var cell = this.queryCell( initialIndex );
                    if ( cell ) {
                        this.selectCell( initialIndex, false, true );
                        return;
                    }
                }

                var index = 0;
                // select with number
                if ( initialIndex && this.slides[ initialIndex ] ) {
                    index = initialIndex;
                }
                // select instantly
                this.select( index, false, true );
            };

            /**
             * select slide from number or cell element
             * @param {Element or Number} elem
             */
            proto.selectCell = function( value, isWrap, isInstant ) {
                // get cell
                var cell = this.queryCell( value );
                if ( !cell ) {
                    return;
                }

                var index = this.getCellSlideIndex( cell );
                this.select( index, isWrap, isInstant );
            };

            proto.getCellSlideIndex = function( cell ) {
                // get index of slides that has cell
                for ( var i=0; i < this.slides.length; i++ ) {
                    var slide = this.slides[i];
                    var index = slide.cells.indexOf( cell );
                    if ( index != -1 ) {
                        return i;
                    }
                }
            };

// -------------------------- get cells -------------------------- //

            /**
             * get Flickity.Cell, given an Element
             * @param {Element} elem
             * @returns {Flickity.Cell} item
             */
            proto.getCell = function( elem ) {
                // loop through cells to get the one that matches
                for ( var i=0; i < this.cells.length; i++ ) {
                    var cell = this.cells[i];
                    if ( cell.element == elem ) {
                        return cell;
                    }
                }
            };

            /**
             * get collection of Flickity.Cells, given Elements
             * @param {Element, Array, NodeList} elems
             * @returns {Array} cells - Flickity.Cells
             */
            proto.getCells = function( elems ) {
                elems = utils.makeArray( elems );
                var cells = [];
                elems.forEach( function( elem ) {
                    var cell = this.getCell( elem );
                    if ( cell ) {
                        cells.push( cell );
                    }
                }, this );
                return cells;
            };

            /**
             * get cell elements
             * @returns {Array} cellElems
             */
            proto.getCellElements = function() {
                return this.cells.map( function( cell ) {
                    return cell.element;
                });
            };

            /**
             * get parent cell from an element
             * @param {Element} elem
             * @returns {Flickit.Cell} cell
             */
            proto.getParentCell = function( elem ) {
                // first check if elem is cell
                var cell = this.getCell( elem );
                if ( cell ) {
                    return cell;
                }
                // try to get parent cell elem
                elem = utils.getParent( elem, '.flickity-slider > *' );
                return this.getCell( elem );
            };

            /**
             * get cells adjacent to a slide
             * @param {Integer} adjCount - number of adjacent slides
             * @param {Integer} index - index of slide to start
             * @returns {Array} cells - array of Flickity.Cells
             */
            proto.getAdjacentCellElements = function( adjCount, index ) {
                if ( !adjCount ) {
                    return this.selectedSlide.getCellElements();
                }
                index = index === undefined ? this.selectedIndex : index;

                var len = this.slides.length;
                if ( 1 + ( adjCount * 2 ) >= len ) {
                    return this.getCellElements();
                }

                var cellElems = [];
                for ( var i = index - adjCount; i <= index + adjCount ; i++ ) {
                    var slideIndex = this.options.wrapAround ? utils.modulo( i, len ) : i;
                    var slide = this.slides[ slideIndex ];
                    if ( slide ) {
                        cellElems = cellElems.concat( slide.getCellElements() );
                    }
                }
                return cellElems;
            };

            /**
             * select slide from number or cell element
             * @param {Element, Selector String, or Number} selector
             */
            proto.queryCell = function( selector ) {
                if ( typeof selector == 'number' ) {
                    // use number as index
                    return this.cells[ selector ];
                }
                if ( typeof selector == 'string' ) {
                    // do not select invalid selectors from hash: #123, #/. #791
                    if ( selector.match(/^[#\.]?[\d\/]/) ) {
                        return;
                    }
                    // use string as selector, get element
                    selector = this.element.querySelector( selector );
                }
                // get cell from element
                return this.getCell( selector );
            };

// -------------------------- events -------------------------- //

            proto.uiChange = function() {
                this.emitEvent('uiChange');
            };

// keep focus on element when child UI elements are clicked
            proto.childUIPointerDown = function( event ) {
                // HACK iOS does not allow touch events to bubble up?!
                if ( event.type != 'touchstart' ) {
                    event.preventDefault();
                }
                this.focus();
            };

// ----- resize ----- //

            proto.onresize = function() {
                this.watchCSS();
                this.resize();
            };

            utils.debounceMethod( Flickity, 'onresize', 150 );

            proto.resize = function() {
                if ( !this.isActive ) {
                    return;
                }
                this.getSize();
                // wrap values
                if ( this.options.wrapAround ) {
                    this.x = utils.modulo( this.x, this.slideableWidth );
                }
                this.positionCells();
                this._getWrapShiftCells();
                this.setGallerySize();
                this.emitEvent('resize');
                // update selected index for group slides, instant
                // TODO: position can be lost between groups of various numbers
                var selectedElement = this.selectedElements && this.selectedElements[0];
                this.selectCell( selectedElement, false, true );
            };

// watches the :after property, activates/deactivates
            proto.watchCSS = function() {
                var watchOption = this.options.watchCSS;
                if ( !watchOption ) {
                    return;
                }

                var afterContent = getComputedStyle( this.element, ':after' ).content;
                // activate if :after { content: 'flickity' }
                if ( afterContent.indexOf('flickity') != -1 ) {
                    this.activate();
                } else {
                    this.deactivate();
                }
            };

// ----- keydown ----- //

// go previous/next if left/right keys pressed
            proto.onkeydown = function( event ) {
                // only work if element is in focus
                var isNotFocused = document.activeElement && document.activeElement != this.element;
                if ( !this.options.accessibility ||isNotFocused ) {
                    return;
                }

                var handler = Flickity.keyboardHandlers[ event.keyCode ];
                if ( handler ) {
                    handler.call( this );
                }
            };

            Flickity.keyboardHandlers = {
                // left arrow
                37: function() {
                    var leftMethod = this.options.rightToLeft ? 'next' : 'previous';
                    this.uiChange();
                    this[ leftMethod ]();
                },
                // right arrow
                39: function() {
                    var rightMethod = this.options.rightToLeft ? 'previous' : 'next';
                    this.uiChange();
                    this[ rightMethod ]();
                },
            };

// ----- focus ----- //

            proto.focus = function() {
                // TODO remove scrollTo once focus options gets more support
                // https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/focus#Browser_compatibility
                var prevScrollY = window.pageYOffset;
                this.element.focus({ preventScroll: true });
                // hack to fix scroll jump after focus, #76
                if ( window.pageYOffset != prevScrollY ) {
                    window.scrollTo( window.pageXOffset, prevScrollY );
                }
            };

// -------------------------- destroy -------------------------- //

// deactivate all Flickity functionality, but keep stuff available
            proto.deactivate = function() {
                if ( !this.isActive ) {
                    return;
                }
                this.element.classList.remove('flickity-enabled');
                this.element.classList.remove('flickity-rtl');
                this.unselectSelectedSlide();
                // destroy cells
                this.cells.forEach( function( cell ) {
                    cell.destroy();
                });
                this.element.removeChild( this.viewport );
                // move child elements back into element
                moveElements( this.slider.children, this.element );
                if ( this.options.accessibility ) {
                    this.element.removeAttribute('tabIndex');
                    this.element.removeEventListener( 'keydown', this );
                }
                // set flags
                this.isActive = false;
                this.emitEvent('deactivate');
            };

            proto.destroy = function() {
                this.deactivate();
                window.removeEventListener( 'resize', this );
                this.allOff();
                this.emitEvent('destroy');
                if ( jQuery && this.$element ) {
                    jQuery.removeData( this.element, 'flickity' );
                }
                delete this.element.flickityGUID;
                delete instances[ this.guid ];
            };

// -------------------------- prototype -------------------------- //

            utils.extend( proto, animatePrototype );

// -------------------------- extras -------------------------- //

            /**
             * get Flickity instance from element
             * @param {Element} elem
             * @returns {Flickity}
             */
            Flickity.data = function( elem ) {
                elem = utils.getQueryElement( elem );
                var id = elem && elem.flickityGUID;
                return id && instances[ id ];
            };

            utils.htmlInit( Flickity, 'flickity' );

            if ( jQuery && jQuery.bridget ) {
                jQuery.bridget( 'flickity', Flickity );
            }

// set internal jQuery, for Webpack + jQuery v3, #478
            Flickity.setJQuery = function( jq ) {
                jQuery = jq;
            };

            Flickity.Cell = Cell;
            Flickity.Slide = Slide;

            return Flickity;

        }));


        /***/ }),
    /* 8 */
    /***/ (function(module, exports, __webpack_require__) {

        var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
         * EvEmitter v1.1.0
         * Lil' event emitter
         * MIT License
         */

        /* jshint unused: true, undef: true, strict: true */

        ( function( global, factory ) {
            // universal module definition
            /* jshint strict: false */ /* globals define, module, window */
            if ( true ) {
                // AMD - RequireJS
                !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
                        __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
                                (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
                                __WEBPACK_AMD_DEFINE_FACTORY__),
                __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
            } else {}

        }( typeof window != 'undefined' ? window : this, function() {

            "use strict";

            function EvEmitter() {}

            var proto = EvEmitter.prototype;

            proto.on = function( eventName, listener ) {
                if ( !eventName || !listener ) {
                    return;
                }
                // set events hash
                var events = this._events = this._events || {};
                // set listeners array
                var listeners = events[ eventName ] = events[ eventName ] || [];
                // only add once
                if ( listeners.indexOf( listener ) == -1 ) {
                    listeners.push( listener );
                }

                return this;
            };

            proto.once = function( eventName, listener ) {
                if ( !eventName || !listener ) {
                    return;
                }
                // add event
                this.on( eventName, listener );
                // set once flag
                // set onceEvents hash
                var onceEvents = this._onceEvents = this._onceEvents || {};
                // set onceListeners object
                var onceListeners = onceEvents[ eventName ] = onceEvents[ eventName ] || {};
                // set flag
                onceListeners[ listener ] = true;

                return this;
            };

            proto.off = function( eventName, listener ) {
                var listeners = this._events && this._events[ eventName ];
                if ( !listeners || !listeners.length ) {
                    return;
                }
                var index = listeners.indexOf( listener );
                if ( index != -1 ) {
                    listeners.splice( index, 1 );
                }

                return this;
            };

            proto.emitEvent = function( eventName, args ) {
                var listeners = this._events && this._events[ eventName ];
                if ( !listeners || !listeners.length ) {
                    return;
                }
                // copy over to avoid interference if .off() in listener
                listeners = listeners.slice(0);
                args = args || [];
                // once stuff
                var onceListeners = this._onceEvents && this._onceEvents[ eventName ];

                for ( var i=0; i < listeners.length; i++ ) {
                    var listener = listeners[i]
                    var isOnce = onceListeners && onceListeners[ listener ];
                    if ( isOnce ) {
                        // remove listener
                        // remove before trigger to prevent recursion
                        this.off( eventName, listener );
                        // unset once flag
                        delete onceListeners[ listener ];
                    }
                    // trigger listener
                    listener.apply( this, args );
                }

                return this;
            };

            proto.allOff = function() {
                delete this._events;
                delete this._onceEvents;
            };

            return EvEmitter;

        }));


        /***/ }),
    /* 9 */
    /***/ (function(module, exports, __webpack_require__) {

        var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
         * Unipointer v2.3.0
         * base class for doing one thing with pointer event
         * MIT license
         */

        /*jshint browser: true, undef: true, unused: true, strict: true */

        ( function( window, factory ) {
            // universal module definition
            /* jshint strict: false */ /*global define, module, require */
            if ( true ) {
                // AMD
                !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
                    __webpack_require__(8)
                ], __WEBPACK_AMD_DEFINE_RESULT__ = (function( EvEmitter ) {
                    return factory( window, EvEmitter );
                }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
                __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
            } else {}

        }( window, function factory( window, EvEmitter ) {

            'use strict';

            function noop() {}

            function Unipointer() {}

// inherit EvEmitter
            var proto = Unipointer.prototype = Object.create( EvEmitter.prototype );

            proto.bindStartEvent = function( elem ) {
                this._bindStartEvent( elem, true );
            };

            proto.unbindStartEvent = function( elem ) {
                this._bindStartEvent( elem, false );
            };

            /**
             * Add or remove start event
             * @param {Boolean} isAdd - remove if falsey
             */
            proto._bindStartEvent = function( elem, isAdd ) {
                // munge isAdd, default to true
                isAdd = isAdd === undefined ? true : isAdd;
                var bindMethod = isAdd ? 'addEventListener' : 'removeEventListener';

                // default to mouse events
                var startEvent = 'mousedown';
                if ( window.PointerEvent ) {
                    // Pointer Events
                    startEvent = 'pointerdown';
                } else if ( 'ontouchstart' in window ) {
                    // Touch Events. iOS Safari
                    startEvent = 'touchstart';
                }
                elem[ bindMethod ]( startEvent, this );
            };

// trigger handler methods for events
            proto.handleEvent = function( event ) {
                var method = 'on' + event.type;
                if ( this[ method ] ) {
                    this[ method ]( event );
                }
            };

// returns the touch that we're keeping track of
            proto.getTouch = function( touches ) {
                for ( var i=0; i < touches.length; i++ ) {
                    var touch = touches[i];
                    if ( touch.identifier == this.pointerIdentifier ) {
                        return touch;
                    }
                }
            };

// ----- start event ----- //

            proto.onmousedown = function( event ) {
                // dismiss clicks from right or middle buttons
                var button = event.button;
                if ( button && ( button !== 0 && button !== 1 ) ) {
                    return;
                }
                this._pointerDown( event, event );
            };

            proto.ontouchstart = function( event ) {
                this._pointerDown( event, event.changedTouches[0] );
            };

            proto.onpointerdown = function( event ) {
                this._pointerDown( event, event );
            };

            /**
             * pointer start
             * @param {Event} event
             * @param {Event or Touch} pointer
             */
            proto._pointerDown = function( event, pointer ) {
                // dismiss right click and other pointers
                // button = 0 is okay, 1-4 not
                if ( event.button || this.isPointerDown ) {
                    return;
                }

                this.isPointerDown = true;
                // save pointer identifier to match up touch events
                this.pointerIdentifier = pointer.pointerId !== undefined ?
                        // pointerId for pointer events, touch.indentifier for touch events
                        pointer.pointerId : pointer.identifier;

                this.pointerDown( event, pointer );
            };

            proto.pointerDown = function( event, pointer ) {
                this._bindPostStartEvents( event );
                this.emitEvent( 'pointerDown', [ event, pointer ] );
            };

// hash of events to be bound after start event
            var postStartEvents = {
                mousedown: [ 'mousemove', 'mouseup' ],
                touchstart: [ 'touchmove', 'touchend', 'touchcancel' ],
                pointerdown: [ 'pointermove', 'pointerup', 'pointercancel' ],
            };

            proto._bindPostStartEvents = function( event ) {
                if ( !event ) {
                    return;
                }
                // get proper events to match start event
                var events = postStartEvents[ event.type ];
                // bind events to node
                events.forEach( function( eventName ) {
                    window.addEventListener( eventName, this );
                }, this );
                // save these arguments
                this._boundPointerEvents = events;
            };

            proto._unbindPostStartEvents = function() {
                // check for _boundEvents, in case dragEnd triggered twice (old IE8 bug)
                if ( !this._boundPointerEvents ) {
                    return;
                }
                this._boundPointerEvents.forEach( function( eventName ) {
                    window.removeEventListener( eventName, this );
                }, this );

                delete this._boundPointerEvents;
            };

// ----- move event ----- //

            proto.onmousemove = function( event ) {
                this._pointerMove( event, event );
            };

            proto.onpointermove = function( event ) {
                if ( event.pointerId == this.pointerIdentifier ) {
                    this._pointerMove( event, event );
                }
            };

            proto.ontouchmove = function( event ) {
                var touch = this.getTouch( event.changedTouches );
                if ( touch ) {
                    this._pointerMove( event, touch );
                }
            };

            /**
             * pointer move
             * @param {Event} event
             * @param {Event or Touch} pointer
             * @private
             */
            proto._pointerMove = function( event, pointer ) {
                this.pointerMove( event, pointer );
            };

// public
            proto.pointerMove = function( event, pointer ) {
                this.emitEvent( 'pointerMove', [ event, pointer ] );
            };

// ----- end event ----- //


            proto.onmouseup = function( event ) {
                this._pointerUp( event, event );
            };

            proto.onpointerup = function( event ) {
                if ( event.pointerId == this.pointerIdentifier ) {
                    this._pointerUp( event, event );
                }
            };

            proto.ontouchend = function( event ) {
                var touch = this.getTouch( event.changedTouches );
                if ( touch ) {
                    this._pointerUp( event, touch );
                }
            };

            /**
             * pointer up
             * @param {Event} event
             * @param {Event or Touch} pointer
             * @private
             */
            proto._pointerUp = function( event, pointer ) {
                this._pointerDone();
                this.pointerUp( event, pointer );
            };

// public
            proto.pointerUp = function( event, pointer ) {
                this.emitEvent( 'pointerUp', [ event, pointer ] );
            };

// ----- pointer done ----- //

// triggered on pointer up & pointer cancel
            proto._pointerDone = function() {
                this._pointerReset();
                this._unbindPostStartEvents();
                this.pointerDone();
            };

            proto._pointerReset = function() {
                // reset properties
                this.isPointerDown = false;
                delete this.pointerIdentifier;
            };

            proto.pointerDone = noop;

// ----- pointer cancel ----- //

            proto.onpointercancel = function( event ) {
                if ( event.pointerId == this.pointerIdentifier ) {
                    this._pointerCancel( event, event );
                }
            };

            proto.ontouchcancel = function( event ) {
                var touch = this.getTouch( event.changedTouches );
                if ( touch ) {
                    this._pointerCancel( event, touch );
                }
            };

            /**
             * pointer cancel
             * @param {Event} event
             * @param {Event or Touch} pointer
             * @private
             */
            proto._pointerCancel = function( event, pointer ) {
                this._pointerDone();
                this.pointerCancel( event, pointer );
            };

// public
            proto.pointerCancel = function( event, pointer ) {
                this.emitEvent( 'pointerCancel', [ event, pointer ] );
            };

// -----  ----- //

// utility function for getting x/y coords from event
            Unipointer.getPointerPoint = function( pointer ) {
                return {
                    x: pointer.pageX,
                    y: pointer.pageY
                };
            };

// -----  ----- //

            return Unipointer;

        }));


        /***/ }),
    /* 10 */
    /***/ (function(module, exports, __webpack_require__) {

        var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
         * getSize v2.0.3
         * measure size of elements
         * MIT license
         */

        /* jshint browser: true, strict: true, undef: true, unused: true */
        /* globals console: false */

        ( function( window, factory ) {
            /* jshint strict: false */ /* globals define, module */
            if ( true ) {
                // AMD
                !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
                        __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
                                (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
                                __WEBPACK_AMD_DEFINE_FACTORY__),
                __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
            } else {}

        })( window, function factory() {
            'use strict';

// -------------------------- helpers -------------------------- //

// get a number from a string, not a percentage
            function getStyleSize( value ) {
                var num = parseFloat( value );
                // not a percent like '100%', and a number
                var isValid = value.indexOf('%') == -1 && !isNaN( num );
                return isValid && num;
            }

            function noop() {}

            var logError = typeof console == 'undefined' ? noop :
                    function( message ) {
                        console.error( message );
                    };

// -------------------------- measurements -------------------------- //

            var measurements = [
                'paddingLeft',
                'paddingRight',
                'paddingTop',
                'paddingBottom',
                'marginLeft',
                'marginRight',
                'marginTop',
                'marginBottom',
                'borderLeftWidth',
                'borderRightWidth',
                'borderTopWidth',
                'borderBottomWidth'
            ];

            var measurementsLength = measurements.length;

            function getZeroSize() {
                var size = {
                    width: 0,
                    height: 0,
                    innerWidth: 0,
                    innerHeight: 0,
                    outerWidth: 0,
                    outerHeight: 0
                };
                for ( var i=0; i < measurementsLength; i++ ) {
                    var measurement = measurements[i];
                    size[ measurement ] = 0;
                }
                return size;
            }

// -------------------------- getStyle -------------------------- //

            /**
             * getStyle, get style of element, check for Firefox bug
             * https://bugzilla.mozilla.org/show_bug.cgi?id=548397
             */
            function getStyle( elem ) {
                var style = getComputedStyle( elem );
                if ( !style ) {
                    logError( 'Style returned ' + style +
                            '. Are you running this code in a hidden iframe on Firefox? ' +
                            'See https://bit.ly/getsizebug1' );
                }
                return style;
            }

// -------------------------- setup -------------------------- //

            var isSetup = false;

            var isBoxSizeOuter;

            /**
             * setup
             * check isBoxSizerOuter
             * do on first getSize() rather than on page load for Firefox bug
             */
            function setup() {
                // setup once
                if ( isSetup ) {
                    return;
                }
                isSetup = true;

                // -------------------------- box sizing -------------------------- //

                /**
                 * Chrome & Safari measure the outer-width on style.width on border-box elems
                 * IE11 & Firefox<29 measures the inner-width
                 */
                var div = document.createElement('div');
                div.style.width = '200px';
                div.style.padding = '1px 2px 3px 4px';
                div.style.borderStyle = 'solid';
                div.style.borderWidth = '1px 2px 3px 4px';
                div.style.boxSizing = 'border-box';

                var body = document.body || document.documentElement;
                body.appendChild( div );
                var style = getStyle( div );
                // round value for browser zoom. desandro/masonry#928
                isBoxSizeOuter = Math.round( getStyleSize( style.width ) ) == 200;
                getSize.isBoxSizeOuter = isBoxSizeOuter;

                body.removeChild( div );
            }

// -------------------------- getSize -------------------------- //

            function getSize( elem ) {
                setup();

                // use querySeletor if elem is string
                if ( typeof elem == 'string' ) {
                    elem = document.querySelector( elem );
                }

                // do not proceed on non-objects
                if ( !elem || typeof elem != 'object' || !elem.nodeType ) {
                    return;
                }

                var style = getStyle( elem );

                // if hidden, everything is 0
                if ( style.display == 'none' ) {
                    return getZeroSize();
                }

                var size = {};
                size.width = elem.offsetWidth;
                size.height = elem.offsetHeight;

                var isBorderBox = size.isBorderBox = style.boxSizing == 'border-box';

                // get all measurements
                for ( var i=0; i < measurementsLength; i++ ) {
                    var measurement = measurements[i];
                    var value = style[ measurement ];
                    var num = parseFloat( value );
                    // any 'auto', 'medium' value will be 0
                    size[ measurement ] = !isNaN( num ) ? num : 0;
                }

                var paddingWidth = size.paddingLeft + size.paddingRight;
                var paddingHeight = size.paddingTop + size.paddingBottom;
                var marginWidth = size.marginLeft + size.marginRight;
                var marginHeight = size.marginTop + size.marginBottom;
                var borderWidth = size.borderLeftWidth + size.borderRightWidth;
                var borderHeight = size.borderTopWidth + size.borderBottomWidth;

                var isBorderBoxSizeOuter = isBorderBox && isBoxSizeOuter;

                // overwrite width and height if we can get it from style
                var styleWidth = getStyleSize( style.width );
                if ( styleWidth !== false ) {
                    size.width = styleWidth +
                            // add padding and border unless it's already including it
                            ( isBorderBoxSizeOuter ? 0 : paddingWidth + borderWidth );
                }

                var styleHeight = getStyleSize( style.height );
                if ( styleHeight !== false ) {
                    size.height = styleHeight +
                            // add padding and border unless it's already including it
                            ( isBorderBoxSizeOuter ? 0 : paddingHeight + borderHeight );
                }

                size.innerWidth = size.width - ( paddingWidth + borderWidth );
                size.innerHeight = size.height - ( paddingHeight + borderHeight );

                size.outerWidth = size.width + marginWidth;
                size.outerHeight = size.height + marginHeight;

                return size;
            }

            return getSize;

        });


        /***/ }),
    /* 11 */
    /***/ (function(module, exports, __webpack_require__) {

        "use strict";



        var selectors = [
            'iframe[src*="player.vimeo.com"]',
            'iframe[src*="youtube.com"]',
            'iframe[src*="youtube-nocookie.com"]',
            'iframe[src*="kickstarter.com"][src*="video.html"]',
            'object'
        ]

        var css = '.fluid-width-video-wrapper{width:100%;position:relative;padding:0;}.fluid-width-video-wrapper iframe,.fluid-width-video-wrapper object,.fluid-width-video-wrapper embed {position:absolute;top:0;left:0;width:100%;height:100%;}'

        module.exports = function (parentSelector, opts) {
            parentSelector = parentSelector || 'body'
            opts = opts || {}

            if (isObject(parentSelector)) {
                opts = parentSelector
                parentSelector = 'body'
            }

            opts.ignore = opts.ignore || ''
            opts.players = opts.players || ''

            var containers = queryAll(parentSelector)
            if (!hasLength(containers)) return

            if (!document.getElementById('fit-vids-style')) {
                var head = document.head || document.getElementsByTagName('head')[0]
                head.appendChild(styles())
            }

            var custom = toSelectorArray(opts.players) || []
            var ignored = toSelectorArray(opts.ignore) || []
            var selector = selectors
                    .filter(notIgnored(ignored))
                    .concat(custom)
                    .join()

            if (!hasLength(selector)) return

            containers.forEach(function (container) {
                var videos = queryAll(container, selector)
                videos.forEach(function (video) {
                    wrap(video)
                })
            })
        }

        function queryAll (el, selector) {
            if (typeof el === 'string') {
                selector = el
                el = document
            }
            return Array.prototype.slice.call(el.querySelectorAll(selector))
        }

        function toSelectorArray (input) {
            if (typeof input === 'string') {
                return input.split(',').map(trim).filter(hasLength)
            } else if (isArray(input)) {
                return flatten(input.map(toSelectorArray).filter(hasLength))
            }
            return input || []
        }

        function wrap (el) {
            if (/fluid-width-video-wrapper/.test(el.parentNode.className)) return

            var widthAttr = parseInt(el.getAttribute('width'), 10)
            var heightAttr = parseInt(el.getAttribute('height'), 10)

            var width = !isNaN(widthAttr) ? widthAttr : el.clientWidth
            var height = !isNaN(heightAttr) ? heightAttr : el.clientHeight
            var aspect = height / width

            el.removeAttribute('width')
            el.removeAttribute('height')

            var wrapper = document.createElement('div')
            el.parentNode.insertBefore(wrapper, el)
            wrapper.className = 'fluid-width-video-wrapper'
            wrapper.style.paddingTop = (aspect * 100) + '%'
            wrapper.appendChild(el)
        }

        function styles () {
            var div = document.createElement('div')
            div.innerHTML = '<p>x</p><style id="fit-vids-style">' + css + '</style>'
            return div.childNodes[1]
        }

        function notIgnored (ignored) {
            if (ignored.length < 1) {
                return function () {
                    return true
                }
            }
            return function (selector) {
                return ignored.indexOf(selector) === -1
            }
        }

        function hasLength (input) {
            return input.length > 0
        }

        function trim (str) {
            return str.replace(/^\s+|\s+$/g, '')
        }

        function flatten (input) {
            return [].concat.apply([], input)
        }

        function isObject (input) {
            return Object.prototype.toString.call(input) === '[object Object]'
        }

        function isArray (input) {
            return Object.prototype.toString.call(input) === '[object Array]'
        }


        /***/ }),
    /* 12 */
    /***/ (function(module, exports, __webpack_require__) {

        "use strict";


// forEach method, could be shipped as part of an Object Literal/Module
        function forEach(array, callback, scope) {
            var index = 0;

            for (index = 0; index < array.length; index += 1) {
                callback.call(scope, array[index], index); // passes back stuff we need
            }
        }

        function hasClass(el, className) {
            var regex = new RegExp('^' + className + '| +' + className, 'g');

            return el.className.match(regex);
        }

        function addClass(el, className) {
            // Return if it already has the className
            if (hasClass(el, className)) return;

            el.className += ' ' + className;
        }

        function removeClass(el, className) {
            // Return if it doesn't already have the className
            if (!hasClass(el, className)) return;

            var regex = new RegExp('^' + className + '| +' + className, 'g');

            el.className = el.className.replace(regex, '');
        }

        function toggleClass(el, className) {
            if (hasClass(el, className)) {
                removeClass(el, className);
            } else {
                addClass(el, className);
            }
        }

        function findPairingFromPairingTrigger(pairings, pairingTrigger) {
            var foundPairing = null;

            forEach(pairings, function (pairing) {
                if (pairing.trigger === pairingTrigger) {
                    foundPairing = pairing;
                }
            });

            return foundPairing;
        }

        /**
         * See {@link https://stackoverflow.com/revisions/2117523/11 Stack Overflow}
         * An RFC4122 v4 compliant uuid solution
         */
        function uuidv4() {
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                var r = Math.random() * 16 | 0;
                var v = c === 'x' ? r : r & 0x3 | 0x8;

                return v.toString(16);
            });
        }

        function init(groupedContent) {
            var triggers = groupedContent.triggers;
            var pairings = groupedContent.pairings;

            triggers.setAttribute('role', 'tablist');

            forEach(pairings, function (pairing, index) {
                pairing.trigger.setAttribute('role', 'tab');
                pairing.trigger.setAttribute('aria-controls', groupedContent.namespace + '-' + groupedContent.id + '-' + index + '-content');

                if (pairing.trigger.children.length > 0) {
                    forEach(pairing.trigger.children, function (child) {
                        child.setAttribute('tabIndex', '-1');
                    });
                }

                if (hasClass(pairing.trigger, 'active')) {
                    pairing.trigger.setAttribute('aria-selected', 'true');
                    pairing.trigger.setAttribute('tabIndex', '0');
                } else {
                    pairing.trigger.setAttribute('tabIndex', '-1');
                }

                pairing.content.id = groupedContent.namespace + '-' + groupedContent.id + '-' + index + '-content';
                pairing.content.setAttribute('role', 'tabpanel');

                if (!hasClass(pairing.content, 'active')) {
                    pairing.content.setAttribute('aria-hidden', 'true');
                }
            });
        }

        function update(groupedContent) {
            var pairings = groupedContent.pairings;

            forEach(pairings, function (pairing) {
                pairing.trigger.removeAttribute('aria-selected');
                pairing.content.removeAttribute('aria-hidden');

                if (hasClass(pairing.trigger, 'active')) {
                    pairing.trigger.setAttribute('aria-selected', 'true');
                    pairing.trigger.setAttribute('tabIndex', '0');
                } else {
                    pairing.trigger.setAttribute('tabIndex', '-1');
                }

                if (!hasClass(pairing.content, 'active')) {
                    pairing.content.setAttribute('aria-hidden', 'true');
                }
            });
        }

        var a11y = {
            init: init,
            update: update
        };

        var asyncGenerator = function () {
            function AwaitValue(value) {
                this.value = value;
            }

            function AsyncGenerator(gen) {
                var front, back;

                function send(key, arg) {
                    return new Promise(function (resolve, reject) {
                        var request = {
                            key: key,
                            arg: arg,
                            resolve: resolve,
                            reject: reject,
                            next: null
                        };

                        if (back) {
                            back = back.next = request;
                        } else {
                            front = back = request;
                            resume(key, arg);
                        }
                    });
                }

                function resume(key, arg) {
                    try {
                        var result = gen[key](arg);
                        var value = result.value;

                        if (value instanceof AwaitValue) {
                            Promise.resolve(value.value).then(function (arg) {
                                resume("next", arg);
                            }, function (arg) {
                                resume("throw", arg);
                            });
                        } else {
                            settle(result.done ? "return" : "normal", result.value);
                        }
                    } catch (err) {
                        settle("throw", err);
                    }
                }

                function settle(type, value) {
                    switch (type) {
                        case "return":
                            front.resolve({
                                value: value,
                                done: true
                            });
                            break;

                        case "throw":
                            front.reject(value);
                            break;

                        default:
                            front.resolve({
                                value: value,
                                done: false
                            });
                            break;
                    }

                    front = front.next;

                    if (front) {
                        resume(front.key, front.arg);
                    } else {
                        back = null;
                    }
                }

                this._invoke = send;

                if (typeof gen.return !== "function") {
                    this.return = undefined;
                }
            }

            if (typeof Symbol === "function" && Symbol.asyncIterator) {
                AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
                    return this;
                };
            }

            AsyncGenerator.prototype.next = function (arg) {
                return this._invoke("next", arg);
            };

            AsyncGenerator.prototype.throw = function (arg) {
                return this._invoke("throw", arg);
            };

            AsyncGenerator.prototype.return = function (arg) {
                return this._invoke("return", arg);
            };

            return {
                wrap: function (fn) {
                    return function () {
                        return new AsyncGenerator(fn.apply(this, arguments));
                    };
                },
                await: function (value) {
                    return new AwaitValue(value);
                }
            };
        }();





        var classCallCheck = function (instance, Constructor) {
            if (!(instance instanceof Constructor)) {
                throw new TypeError("Cannot call a class as a function");
            }
        };

        var createClass = function () {
            function defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, descriptor.key, descriptor);
                }
            }

            return function (Constructor, protoProps, staticProps) {
                if (protoProps) defineProperties(Constructor.prototype, protoProps);
                if (staticProps) defineProperties(Constructor, staticProps);
                return Constructor;
            };
        }();

        /** A class for creating, managing, and destroying groupable content as tabs. */

        var TabsLayout = function () {
            function TabsLayout(groupedContent) {
                classCallCheck(this, TabsLayout);

                this.groupedContent = groupedContent;
                this.pairings = groupedContent.pairings;
                this.events = [];

                this._handleKeydown = this._handleKeydown.bind(this);
                this._handleClick = this._handleClick.bind(this);

                this._init();
                a11y.init(this.groupedContent);
            }

            createClass(TabsLayout, [{
                key: 'unload',
                value: function unload() {
                    forEach(this.events, function (event) {
                        event.trigger.removeEventListener(event.type, event.fn);
                    });
                }
            }, {
                key: '_init',
                value: function _init() {
                    var _this = this;

                    var existingActive = false;

                    forEach(this.pairings, function (pairing) {
                        var trigger = pairing.trigger;

                        if (hasClass(trigger, 'active')) {
                            existingActive = true;
                        }

                        trigger.addEventListener('keydown', _this._handleKeydown);
                        trigger.addEventListener('click', _this._handleClick);

                        _this.events.push({
                            trigger: trigger,
                            type: 'keydown',
                            fn: _this._handleKeydown
                        });

                        _this.events.push({
                            trigger: trigger,
                            type: 'click',
                            fn: _this._handleClick
                        });
                    });

                    if (!existingActive) {
                        addClass(this.pairings[0].trigger, 'active');
                        addClass(this.pairings[0].content, 'active');
                    }
                }
            }, {
                key: '_handleKeydown',
                value: function _handleKeydown(event) {
                    var trigger = event.currentTarget;
                    var pairing = findPairingFromPairingTrigger(this.pairings, trigger);
                    var pairingIndex = this.pairings.indexOf(pairing);
                    var prevIndex = pairingIndex - 1 < 0 ? this.pairings.length - 1 : pairingIndex - 1;
                    var nextIndex = pairingIndex + 1 >= this.pairings.length ? 0 : pairingIndex + 1;

                    var nextPairing = null;

                    switch (event.key) {
                        case 'ArrowLeft':
                            nextPairing = this.pairings[prevIndex];
                            break;
                        case 'ArrowRight':
                            nextPairing = this.pairings[nextIndex];
                            break;
                        default:
                            nextPairing = null;
                            break;
                    }

                    // Fast exit if we can't find the tab or tabs
                    if (nextPairing === null) return;

                    event.preventDefault();

                    forEach(this.pairings, function (inactivePairing) {
                        removeClass(inactivePairing.trigger, 'active');
                        removeClass(inactivePairing.content, 'active');
                    });

                    addClass(nextPairing.trigger, 'active');
                    addClass(nextPairing.content, 'active');

                    nextPairing.trigger.focus();

                    a11y.update(this.groupedContent);
                }
            }, {
                key: '_handleClick',
                value: function _handleClick(event) {
                    var trigger = event.currentTarget;
                    var pairing = findPairingFromPairingTrigger(this.pairings, trigger);

                    // Fast exit if we can't find the tab or tabs
                    if (pairing === null) return;

                    event.preventDefault();

                    forEach(this.pairings, function (inactivePairing) {
                        removeClass(inactivePairing.trigger, 'active');
                        removeClass(inactivePairing.content, 'active');
                    });

                    addClass(pairing.trigger, 'active');
                    addClass(pairing.content, 'active');

                    a11y.update(this.groupedContent);
                }
            }]);
            return TabsLayout;
        }();

        function init$1(groupedContent) {
            var pairings = groupedContent.pairings;

            forEach(pairings, function (pairing, index) {
                pairing.trigger.setAttribute('role', 'button');
                pairing.trigger.setAttribute('aria-controls', groupedContent.namespace + '-' + groupedContent.id + '-' + index + '-content');
                pairing.trigger.setAttribute('tabIndex', '0');

                if (pairing.trigger.children.length > 0) {
                    forEach(pairing.trigger.children, function (child) {
                        child.setAttribute('tabIndex', '-1');
                    });
                }

                if (hasClass(pairing.trigger, 'active')) {
                    pairing.trigger.setAttribute('aria-expanded', 'true');
                } else {
                    pairing.trigger.setAttribute('aria-expanded', 'false');
                }

                pairing.content.id = groupedContent.namespace + '-' + groupedContent.id + '-' + index + '-content';

                if (!hasClass(pairing.content, 'active')) {
                    pairing.content.setAttribute('aria-hidden', 'true');
                }
            });
        }

        function update$1(groupedContent) {
            var pairings = groupedContent.pairings;

            forEach(pairings, function (pairing) {
                pairing.content.removeAttribute('aria-hidden');

                if (hasClass(pairing.trigger, 'active')) {
                    pairing.trigger.setAttribute('aria-expanded', 'true');
                } else {
                    pairing.trigger.setAttribute('aria-expanded', 'false');
                }

                if (!hasClass(pairing.content, 'active')) {
                    pairing.content.setAttribute('aria-hidden', 'true');
                }
            });
        }

        var a11y$1 = {
            init: init$1,
            update: update$1
        };

        /** A class for creating, managing, and destroying groupable content as an accordion. */

        var AccordionLayout = function () {
            function AccordionLayout(groupedContent) {
                classCallCheck(this, AccordionLayout);

                this.groupedContent = groupedContent;
                this.pairings = groupedContent.pairings;
                this.events = [];

                this._handleKeydown = this._handleKeydown.bind(this);
                this._handleClick = this._handleClick.bind(this);

                this._init(this.pairings);
                a11y$1.init(this.groupedContent);
            }

            createClass(AccordionLayout, [{
                key: 'unload',
                value: function unload() {
                    forEach(this.events, function (event) {
                        event.trigger.removeEventListener(event.type, event.fn);
                    });
                }
            }, {
                key: '_init',
                value: function _init() {
                    var _this = this;

                    forEach(this.pairings, function (pairing) {
                        var trigger = pairing.trigger;
                        var content = pairing.content;

                        trigger.parentNode.insertBefore(content, trigger.nextSibling);

                        trigger.addEventListener('keydown', _this._handleKeydown);
                        trigger.addEventListener('click', _this._handleClick);

                        _this.events.push({
                            trigger: trigger,
                            type: 'keydown',
                            fn: _this._handleKeydown
                        });

                        _this.events.push({
                            trigger: trigger,
                            type: 'click',
                            fn: _this._handleClick
                        });
                    });

                    this.groupedContent.contents.remove();
                }
            }, {
                key: '_handleKeydown',
                value: function _handleKeydown(event) {
                    var trigger = event.currentTarget;
                    var pairing = findPairingFromPairingTrigger(this.pairings, trigger);

                    // Fast exit if enter isn't pressed or we can't find the group
                    if (event.key !== 'Enter' || pairing === null) return;

                    event.preventDefault();

                    toggleClass(pairing.trigger, 'active');
                    toggleClass(pairing.content, 'active');
                    a11y$1.update(this.groupedContent);
                }
            }, {
                key: '_handleClick',
                value: function _handleClick(event) {
                    var trigger = event.currentTarget;
                    var pairing = findPairingFromPairingTrigger(this.pairings, trigger);

                    // Fast exit if we can't find the group
                    if (pairing === null) return;

                    event.preventDefault();

                    toggleClass(pairing.trigger, 'active');
                    toggleClass(pairing.content, 'active');
                    a11y$1.update(this.groupedContent);
                }
            }]);
            return AccordionLayout;
        }();

        /**
         * Returns an array of nodes related to the heading node.
         * @param {node} heading - The heading node to search for content from.
         * @returns {node[]}
         */
        function getHeadingContent(heading) {
            var headingTagNames = ['H1', 'H2', 'H3', 'H4', 'H5', 'H6'];
            var tagNameIndex = headingTagNames.indexOf(heading.tagName);
            var content = [];

            var sibling = heading.nextElementSibling;

            while (sibling !== null && (headingTagNames.indexOf(sibling.tagName) === -1 || headingTagNames.indexOf(sibling.tagName) > tagNameIndex)) {
                content.push(sibling);

                sibling = sibling.nextElementSibling;
            }

            return content;
        }

        /**
         * Returns an object array representing the heading tree from a given node.
         * Root nodes are evaluated differently, and requires the evaluatingRoot flag
         * to be true.
         * @param {node} el - The node being evaluated.
         * @param {node[]} children - The children of the evaluated node.
         * @param {boolean} [evaluatingRoot] - Whether to evaluate as root node.
         * @returns {Object[]}
         */
        function getHeadingTree(el, children) {
            var evaluatingRoot = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

            var headingTagNames = ['H1', 'H2', 'H3', 'H4', 'H5', 'H6'];
            var tagNameIndex = headingTagNames.indexOf(el.tagName);
            var headings = [];

            var currentLowestTagNameIndex = 5;

            for (var i = 0; i < children.length; i += 1) {
                var child = children[i];
                var childTagNameIndex = headingTagNames.indexOf(child.tagName);

                if (childTagNameIndex !== -1 && childTagNameIndex < currentLowestTagNameIndex) {
                    currentLowestTagNameIndex = childTagNameIndex;
                }

                if (evaluatingRoot && childTagNameIndex !== -1 && childTagNameIndex <= currentLowestTagNameIndex || !evaluatingRoot && childTagNameIndex !== -1 && childTagNameIndex === tagNameIndex + 1) {
                    var siblings = getHeadingContent(child);

                    var childNode = {
                        el: child,
                        content: siblings,
                        children: getHeadingTree(child, siblings)
                    };

                    headings.push(childNode);
                }
            }

            return headings;
        }

        /**
         * Returns groupings of headings that meet the minimum sequence value
         * and don't contain any invalid headings.
         * @param {Object[]} headings - An array of heading objects.
         * @param {int[]} invalidHeadings - An array of invalid heading integers,
         *                                  representing indexes of headings.
         * @param {*} minInSequence - Minimum headings in sequence before being considered
         *                            as a grouping.
         * @returns {Object[][]}
         */
        function getHeadingGroupsInSequence(headings, invalidHeadings, minInSequence) {
            var headingGroupsInSequence = [];
            var currentHeadingGroupInSequence = [];
            var currentSequence = 0;

            for (var i = 0; i < headings.length; i += 1) {
                if (invalidHeadings.indexOf(i) === -1) {
                    currentHeadingGroupInSequence.push(headings[i]);
                    currentSequence += 1;

                    if (i !== headings.length - 1 && headings[i].el.tagName !== headings[i + 1].el.tagName && invalidHeadings.indexOf(i + 1)) {
                        currentHeadingGroupInSequence = [];
                        currentSequence = 0;
                    } else if (i !== 0 && headings[i].el.tagName !== headings[i - 1].el.tagName) {
                        currentHeadingGroupInSequence.pop();
                        currentSequence -= 1;

                        if (currentSequence >= minInSequence) {
                            headingGroupsInSequence.push(currentHeadingGroupInSequence);
                        }

                        currentHeadingGroupInSequence = [headings[i]];
                        currentSequence = 1;
                    }
                }
            }

            if (currentSequence >= minInSequence) {
                headingGroupsInSequence.push(currentHeadingGroupInSequence);
            }

            return headingGroupsInSequence;
        }

        /**
         * Generates necessary DOM elements to group related content.
         * Returns a object array representing the grouped content.
         * @param {Object[]} children - An array of objects.
         * @returns {Object[]}
         */
        function createGroupedContent(children) {
            var pairings = [];

            var firstChild = children[0].el;
            var triggers = document.createElement('div');
            var contents = document.createElement('div');

            contents = firstChild.parentNode.insertBefore(contents, firstChild.nextSibling);
            triggers = firstChild.parentNode.insertBefore(triggers, firstChild.nextSibling);

            for (var i = 0; i < children.length; i += 1) {
                var child = children[i];
                var trigger = child.el;
                var content = document.createElement('div');

                trigger = triggers.appendChild(trigger);
                content = contents.appendChild(content);

                for (var j = 0; j < child.content.length; j += 1) {
                    content.appendChild(child.content[j]);
                }

                pairings.push({
                    trigger: trigger,
                    content: content
                });
            }

            return {
                triggers: triggers,
                contents: contents,
                pairings: pairings
            };
        }

        /**
         * Returns all groupable content within the supplied node.
         * @param {node} node - A node to traverse for groupable content.
         * @returns {Object[][]}
         */
        /*
         * Recursive function:
         *  Returns all groups of headings that
         *  are elegible to become grouped content.
         */
        function getGroupedContentSet(node) {
            var children = node.children;
            var childrenWithGroupableContent = [];
            var groupedContentSet = [];

            if (children.length === 0) {
                return [];
            }

            for (var i = 0; i < children.length; i += 1) {
                var childGroupableContent = getGroupedContentSet(children[i]);

                if (childGroupableContent.length > 0) {
                    childrenWithGroupableContent.push(i);
                    groupedContentSet = groupedContentSet.concat(childGroupableContent);
                }
            }

            var headingGroupsInSequence = getHeadingGroupsInSequence(children, childrenWithGroupableContent, 3);

            for (var _i = 0; _i < headingGroupsInSequence.length; _i += 1) {
                groupedContentSet.push(createGroupedContent(headingGroupsInSequence[_i]));
            }

            return groupedContentSet;
        }

        /**
         * When static parsing isn't enough, there's intelliparse™!
         * Searches through dom content to find heading groupings that
         * are elegible to become tab groups.
         * Assumes that content is in a flattened hierarchy in the dom
         * and interprets increasing heading values as a deeper level of nesting.
         * Returns all groupable content as an array of object arrays.
         * @param {node} el - The node who's content will be searched for groupable content.
         * @returns {Object[][]}
         */
        function intelliParse(el) {
            var children = el.children;
            var heading = el.querySelector('h1, h2, h3, h4, h5, h6');

            // Fast return if there's no headings
            if (children.length === 0) return [];

            var rootNode = {
                el: el,
                content: null,
                children: getHeadingTree(heading, children, true)
            };

            return getGroupedContentSet(rootNode);
        }

        /**
         * Parses content from a given node based on a static structure.
         * The structure is as follows:
         * <ul class="tabs">
         *   <li class="active">Tab 1</li>
         *   <li>Tab 2</li>
         *   <li>Tab 3</li>
         * </ul>
         *
         * <ul class="tabs-content">
         *   <li class="active">
         *     <p>Tab 1 content goes here.</p>
         *   </li>
         *   <li>
         *     <p>Tab 2 content goes here.</p>
         *   </li>
         *   <li>
         *     <p>Tab 3 content goes here.</p>
         *   </li>
         * </ul>
         * Returns all groupable content as an array of object arrays.
         * @param {node} el - The node who's content will be searched for groupable content.
         * @returns {Object[][]}
         */
        function staticParse(el) {
            var groupedContentSet = [];

            var tabs = el.querySelectorAll('.tabs');

            for (var i = 0; i < tabs.length; i += 1) {
                var triggers = tabs[i].children;
                var contents = tabs[i].nextElementSibling.children;

                // Only add a tab group if equal triggers to contents
                if (triggers.length === contents.length) {
                    var length = groupedContentSet.push({
                        triggers: tabs[i],
                        contents: tabs[i].nextElementSibling,
                        pairings: []
                    });
                    var index = length - 1;

                    for (var j = 0; j < triggers.length; j += 1) {
                        var trigger = triggers[j];
                        var content = contents[j];

                        var pairing = {
                            trigger: trigger,
                            content: content
                        };

                        groupedContentSet[index].pairings.push(pairing);
                    }
                }
            }

            return groupedContentSet;
        }

        /**
         * Returns all groupable content as an array of object arrays.
         * @param {node} content - The node to parse for groupable content.
         * @param {boolean} intelliparse - Whether to use intelligent parsing.
         * @returns {Object[][]}
         */
        function parse(content) {
            var intelliparse = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            var groupedContentSet = intelliparse ? intelliParse(content) : staticParse(content);

            return groupedContentSet;
        }

        /** A class for creating, managing, and destroying groupable content. */

        var GroupedContent = function () {
            /**
             * Create grouped content
             * @param {node} el - The element to search for groupable content in.
             * @param {Object}  [options] - Additional options
             * @param {string}  [options.layout] - The layout to display groupable content in.
             * @param {boolean} [options.intelliparse] - The parsing algorithm used to find content with.
             */
            function GroupedContent(el) {
                var _this = this;

                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                classCallCheck(this, GroupedContent);

                this.namespace = 'grouped-content';
                this.el = el;
                this.groupedContentInstances = [];

                var layout = options.layout || 'tabs';
                var intelliparse = !!options.intelliparse;

                forEach(parse(el, intelliparse), function (groupedContent) {
                    var id = uuidv4();
                    var instance = null;
                    var groupedContentWrapper = document.createElement('div');

                    groupedContentWrapper = groupedContent.triggers.parentNode.insertBefore(groupedContentWrapper, groupedContent.triggers.nextSibling);

                    addClass(groupedContentWrapper, _this.namespace);
                    addClass(groupedContentWrapper, _this.namespace + '-layout-' + layout);

                    groupedContentWrapper.appendChild(groupedContent.triggers);
                    groupedContentWrapper.appendChild(groupedContent.contents);

                    groupedContent.namespace = _this.namespace;
                    groupedContent.id = id;
                    groupedContent.triggers.id = _this.namespace + '-' + id + '-triggers';
                    groupedContent.contents.id = _this.namespace + '-' + id + '-contents';

                    addClass(groupedContent.triggers, _this.namespace + '-triggers');
                    addClass(groupedContent.contents, _this.namespace + '-contents');

                    forEach(groupedContent.pairings, function (pairing) {
                        addClass(pairing.trigger, _this.namespace + '-trigger');
                        addClass(pairing.content, _this.namespace + '-content');
                    });

                    switch (layout) {
                        case 'accordion':
                            instance = new AccordionLayout(groupedContent);
                            break;
                        case 'tabs':
                        default:
                            instance = new TabsLayout(groupedContent);
                            break;
                    }

                    _this.groupedContentInstances.push({
                        groupedContent: groupedContent,
                        instance: instance
                    });
                });
            }

            /** Unload all grouped content instances */


            createClass(GroupedContent, [{
                key: 'unload',
                value: function unload() {
                    forEach(this.groupedContentInstances, function (groupedContentInstance) {
                        groupedContentInstance.instance.unload();
                    });
                }
            }]);
            return GroupedContent;
        }();

        module.exports = GroupedContent;


        /***/ }),
    /* 13 */
    /***/ (function(module, exports, __webpack_require__) {

        var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
            if (true) {
                !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
                        __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
                                (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
                __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
            } else { var mod; }
        })(this, function (exports) {
            'use strict';

            Object.defineProperty(exports, "__esModule", {
                value: true
            });

            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }

            var _createClass = function () {
                function defineProperties(target, props) {
                    for (var i = 0; i < props.length; i++) {
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }

                return function (Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();

            var _extends = Object.assign || function (target) {
                        for (var i = 1; i < arguments.length; i++) {
                            var source = arguments[i];

                            for (var key in source) {
                                if (Object.prototype.hasOwnProperty.call(source, key)) {
                                    target[key] = source[key];
                                }
                            }
                        }

                        return target;
                    };

            var defaults = {
                modal: '.modal',
                modalInner: '.modal-inner',
                modalContent: '.modal-content',
                open: '[data-modal-open]',
                close: '[data-modal-close]',
                page: 'body',
                class: 'modal-visible',
                loadClass: 'vanilla-modal',
                clickOutside: true,
                closeKeys: [27],
                transitions: true,
                transitionEnd: null,
                onBeforeOpen: null,
                onBeforeClose: null,
                onOpen: null,
                onClose: null
            };

            function throwError(message) {
                // eslint-disable-next-line no-console
                console.error('VanillaModal: ' + message);
            }

            function find(arr, callback) {
                return function (key) {
                    var filteredArray = arr.filter(callback);
                    return filteredArray[0] ? filteredArray[0][key] : undefined;
                };
            }

            function transitionEndVendorSniff() {
                var el = document.createElement('div');
                var transitions = [{ key: 'transition', value: 'transitionend' }, { key: 'OTransition', value: 'otransitionend' }, { key: 'MozTransition', value: 'transitionend' }, { key: 'WebkitTransition', value: 'webkitTransitionEnd' }];
                return find(transitions, function (_ref) {
                    var key = _ref.key;
                    return typeof el.style[key] !== 'undefined';
                })('value');
            }

            function isPopulatedArray(arr) {
                return Object.prototype.toString.call(arr) === '[object Array]' && arr.length;
            }

            function getNode(selector, parent) {
                var targetNode = parent || document;
                var node = targetNode.querySelector(selector);
                if (!node) {
                    throwError(selector + ' not found in document.');
                }
                return node;
            }

            function addClass(el, className) {
                if (!(el instanceof HTMLElement)) {
                    throwError('Not a valid HTML element.');
                }
                el.setAttribute('class', el.className.split(' ').filter(function (cn) {
                    return cn !== className;
                }).concat(className).join(' '));
            }

            function removeClass(el, className) {
                if (!(el instanceof HTMLElement)) {
                    throwError('Not a valid HTML element.');
                }
                el.setAttribute('class', el.className.split(' ').filter(function (cn) {
                    return cn !== className;
                }).join(' '));
            }

            function getElementContext(e) {
                if (e && typeof e.hash === 'string') {
                    return document.querySelector(e.hash);
                } else if (typeof e === 'string') {
                    return document.querySelector(e);
                }
                throwError('No selector supplied to open()');
                return null;
            }

            function applyUserSettings(settings) {
                return _extends({}, defaults, settings, {
                    transitionEnd: transitionEndVendorSniff()
                });
            }

            function matches(e, selector) {
                var allMatches = (e.target.document || e.target.ownerDocument).querySelectorAll(selector);
                for (var i = 0; i < allMatches.length; i += 1) {
                    var node = e.target;
                    while (node && node !== document.body) {
                        if (node === allMatches[i]) {
                            return node;
                        }
                        node = node.parentNode;
                    }
                }
                return null;
            }

            var VanillaModal = function () {
                function VanillaModal(settings) {
                    _classCallCheck(this, VanillaModal);

                    this.isOpen = false;
                    this.current = null;
                    this.isListening = false;

                    this.settings = applyUserSettings(settings);
                    this.dom = this.getDomNodes();

                    this.open = this.open.bind(this);
                    this.close = this.close.bind(this);
                    this.closeKeyHandler = this.closeKeyHandler.bind(this);
                    this.outsideClickHandler = this.outsideClickHandler.bind(this);
                    this.delegateOpen = this.delegateOpen.bind(this);
                    this.delegateClose = this.delegateClose.bind(this);
                    this.listen = this.listen.bind(this);
                    this.destroy = this.destroy.bind(this);

                    this.addLoadedCssClass();
                    this.listen();
                }

                _createClass(VanillaModal, [{
                    key: 'getDomNodes',
                    value: function getDomNodes() {
                        var _settings = this.settings,
                                modal = _settings.modal,
                                page = _settings.page,
                                modalInner = _settings.modalInner,
                                modalContent = _settings.modalContent;

                        return {
                            modal: getNode(modal),
                            page: getNode(page),
                            modalInner: getNode(modalInner, getNode(modal)),
                            modalContent: getNode(modalContent, getNode(modal))
                        };
                    }
                }, {
                    key: 'addLoadedCssClass',
                    value: function addLoadedCssClass() {
                        addClass(this.dom.page, this.settings.loadClass);
                    }
                }, {
                    key: 'setOpenId',
                    value: function setOpenId(id) {
                        var page = this.dom.page;

                        page.setAttribute('data-current-modal', id || 'anonymous');
                    }
                }, {
                    key: 'removeOpenId',
                    value: function removeOpenId() {
                        var page = this.dom.page;

                        page.removeAttribute('data-current-modal');
                    }
                }, {
                    key: 'open',
                    value: function open(allMatches, e) {
                        var page = this.dom.page;
                        var _settings2 = this.settings,
                                onBeforeOpen = _settings2.onBeforeOpen,
                                onOpen = _settings2.onOpen;

                        if (!(this.current instanceof HTMLElement === false)) {
                            throwError('VanillaModal target must exist on page.');
                            return;
                        }
                        this.releaseNode(this.current);
                        this.current = getElementContext(allMatches);
                        if (typeof onBeforeOpen === 'function') {
                            onBeforeOpen.call(this, e);
                        }
                        this.captureNode(this.current);
                        addClass(page, this.settings.class);
                        this.setOpenId(this.current.id);
                        this.isOpen = true;
                        if (typeof onOpen === 'function') {
                            onOpen.call(this, e);
                        }
                    }
                }, {
                    key: 'detectTransition',
                    value: function detectTransition() {
                        var modal = this.dom.modal;

                        var css = window.getComputedStyle(modal, null);
                        return Boolean(['transitionDuration', 'oTransitionDuration', 'MozTransitionDuration', 'webkitTransitionDuration'].filter(function (i) {
                            return typeof css[i] === 'string' && parseFloat(css[i]) > 0;
                        }).length);
                    }
                }, {
                    key: 'close',
                    value: function close(e) {
                        var _settings3 = this.settings,
                                transitions = _settings3.transitions,
                                transitionEnd = _settings3.transitionEnd,
                                onBeforeClose = _settings3.onBeforeClose;

                        var hasTransition = this.detectTransition();
                        if (this.isOpen) {
                            this.isOpen = false;
                            if (typeof onBeforeClose === 'function') {
                                onBeforeClose.call(this, e);
                            }
                            removeClass(this.dom.page, this.settings.class);
                            if (transitions && transitionEnd && hasTransition) {
                                this.closeModalWithTransition(e);
                            } else {
                                this.closeModal(e);
                            }
                        }
                    }
                }, {
                    key: 'closeModal',
                    value: function closeModal(e) {
                        var onClose = this.settings.onClose;

                        this.removeOpenId(this.dom.page);
                        this.releaseNode(this.current);
                        this.isOpen = false;
                        this.current = null;
                        if (typeof onClose === 'function') {
                            onClose.call(this, e);
                        }
                    }
                }, {
                    key: 'closeModalWithTransition',
                    value: function closeModalWithTransition(e) {
                        var _this = this;

                        var modal = this.dom.modal;
                        var transitionEnd = this.settings.transitionEnd;

                        var closeTransitionHandler = function closeTransitionHandler() {
                            modal.removeEventListener(transitionEnd, closeTransitionHandler);
                            _this.closeModal(e);
                        };
                        modal.addEventListener(transitionEnd, closeTransitionHandler);
                    }
                }, {
                    key: 'captureNode',
                    value: function captureNode(node) {
                        var modalContent = this.dom.modalContent;

                        while (node.childNodes.length) {
                            modalContent.appendChild(node.childNodes[0]);
                        }
                    }
                }, {
                    key: 'releaseNode',
                    value: function releaseNode(node) {
                        var modalContent = this.dom.modalContent;

                        while (modalContent.childNodes.length) {
                            node.appendChild(modalContent.childNodes[0]);
                        }
                    }
                }, {
                    key: 'closeKeyHandler',
                    value: function closeKeyHandler(e) {
                        var closeKeys = this.settings.closeKeys;

                        if (isPopulatedArray(closeKeys) && closeKeys.indexOf(e.which) > -1 && this.isOpen === true) {
                            e.preventDefault();
                            this.close(e);
                        }
                    }
                }, {
                    key: 'outsideClickHandler',
                    value: function outsideClickHandler(e) {
                        var clickOutside = this.settings.clickOutside;
                        var modalInner = this.dom.modalInner;

                        if (clickOutside) {
                            var node = e.target;
                            while (node && node !== document.body) {
                                if (node === modalInner) {
                                    return;
                                }
                                node = node.parentNode;
                            }
                            this.close(e);
                        }
                    }
                }, {
                    key: 'delegateOpen',
                    value: function delegateOpen(e) {
                        var open = this.settings.open;

                        var matchedNode = matches(e, open);
                        if (matchedNode) {
                            e.preventDefault();
                            this.open(matchedNode, e);
                        }
                    }
                }, {
                    key: 'delegateClose',
                    value: function delegateClose(e) {
                        var close = this.settings.close;

                        if (matches(e, close)) {
                            e.preventDefault();
                            this.close(e);
                        }
                    }
                }, {
                    key: 'listen',
                    value: function listen() {
                        var modal = this.dom.modal;

                        if (!this.isListening) {
                            modal.addEventListener('click', this.outsideClickHandler, false);
                            document.addEventListener('keydown', this.closeKeyHandler, false);
                            document.addEventListener('click', this.delegateOpen, false);
                            document.addEventListener('click', this.delegateClose, false);
                            this.isListening = true;
                        } else {
                            throwError('Event listeners already applied.');
                        }
                    }
                }, {
                    key: 'destroy',
                    value: function destroy() {
                        var modal = this.dom.modal;

                        if (this.isListening) {
                            this.close();
                            modal.removeEventListener('click', this.outsideClickHandler);
                            document.removeEventListener('keydown', this.closeKeyHandler);
                            document.removeEventListener('click', this.delegateOpen);
                            document.removeEventListener('click', this.delegateClose);
                            this.isListening = false;
                        } else {
                            throwError('Event listeners already removed.');
                        }
                    }
                }]);

                return VanillaModal;
            }();

            exports.default = VanillaModal;
        });


        /***/ }),
    /* 14 */
    /***/ (function(module, exports, __webpack_require__) {

        var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! PhotoSwipe - v4.1.3 - 2019-01-08
         * http://photoswipe.com
         * Copyright (c) 2019 Dmitry Semenov; */
        (function (root, factory) {
            if (true) {
                !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
                        __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
                                (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
                                __WEBPACK_AMD_DEFINE_FACTORY__),
                __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
            } else {}
        })(this, function () {

            'use strict';
            var PhotoSwipe = function(template, UiClass, items, options){

                /*>>framework-bridge*/
                /**
                 *
                 * Set of generic functions used by gallery.
                 *
                 * You're free to modify anything here as long as functionality is kept.
                 *
                 */
                var framework = {
                    features: null,
                    bind: function(target, type, listener, unbind) {
                        var methodName = (unbind ? 'remove' : 'add') + 'EventListener';
                        type = type.split(' ');
                        for(var i = 0; i < type.length; i++) {
                            if(type[i]) {
                                target[methodName]( type[i], listener, false);
                            }
                        }
                    },
                    isArray: function(obj) {
                        return (obj instanceof Array);
                    },
                    createEl: function(classes, tag) {
                        var el = document.createElement(tag || 'div');
                        if(classes) {
                            el.className = classes;
                        }
                        return el;
                    },
                    getScrollY: function() {
                        var yOffset = window.pageYOffset;
                        return yOffset !== undefined ? yOffset : document.documentElement.scrollTop;
                    },
                    unbind: function(target, type, listener) {
                        framework.bind(target,type,listener,true);
                    },
                    removeClass: function(el, className) {
                        var reg = new RegExp('(\\s|^)' + className + '(\\s|$)');
                        el.className = el.className.replace(reg, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
                    },
                    addClass: function(el, className) {
                        if( !framework.hasClass(el,className) ) {
                            el.className += (el.className ? ' ' : '') + className;
                        }
                    },
                    hasClass: function(el, className) {
                        return el.className && new RegExp('(^|\\s)' + className + '(\\s|$)').test(el.className);
                    },
                    getChildByClass: function(parentEl, childClassName) {
                        var node = parentEl.firstChild;
                        while(node) {
                            if( framework.hasClass(node, childClassName) ) {
                                return node;
                            }
                            node = node.nextSibling;
                        }
                    },
                    arraySearch: function(array, value, key) {
                        var i = array.length;
                        while(i--) {
                            if(array[i][key] === value) {
                                return i;
                            }
                        }
                        return -1;
                    },
                    extend: function(o1, o2, preventOverwrite) {
                        for (var prop in o2) {
                            if (o2.hasOwnProperty(prop)) {
                                if(preventOverwrite && o1.hasOwnProperty(prop)) {
                                    continue;
                                }
                                o1[prop] = o2[prop];
                            }
                        }
                    },
                    easing: {
                        sine: {
                            out: function(k) {
                                return Math.sin(k * (Math.PI / 2));
                            },
                            inOut: function(k) {
                                return - (Math.cos(Math.PI * k) - 1) / 2;
                            }
                        },
                        cubic: {
                            out: function(k) {
                                return --k * k * k + 1;
                            }
                        }
                        /*
                         elastic: {
                         out: function ( k ) {

                         var s, a = 0.1, p = 0.4;
                         if ( k === 0 ) return 0;
                         if ( k === 1 ) return 1;
                         if ( !a || a < 1 ) { a = 1; s = p / 4; }
                         else s = p * Math.asin( 1 / a ) / ( 2 * Math.PI );
                         return ( a * Math.pow( 2, - 10 * k) * Math.sin( ( k - s ) * ( 2 * Math.PI ) / p ) + 1 );

                         },
                         },
                         back: {
                         out: function ( k ) {
                         var s = 1.70158;
                         return --k * k * ( ( s + 1 ) * k + s ) + 1;
                         }
                         }
                         */
                    },

                    /**
                     *
                     * @return {object}
                     *
                     * {
	 *  raf : request animation frame function
	 *  caf : cancel animation frame function
	 *  transfrom : transform property key (with vendor), or null if not supported
	 *  oldIE : IE8 or below
	 * }
                     *
                     */
                    detectFeatures: function() {
                        if(framework.features) {
                            return framework.features;
                        }
                        var helperEl = framework.createEl(),
                                helperStyle = helperEl.style,
                                vendor = '',
                                features = {};

                        // IE8 and below
                        features.oldIE = document.all && !document.addEventListener;

                        features.touch = 'ontouchstart' in window;

                        if(window.requestAnimationFrame) {
                            features.raf = window.requestAnimationFrame;
                            features.caf = window.cancelAnimationFrame;
                        }

                        features.pointerEvent = !!(window.PointerEvent) || navigator.msPointerEnabled;

                        // fix false-positive detection of old Android in new IE
                        // (IE11 ua string contains "Android 4.0")

                        if(!features.pointerEvent) {

                            var ua = navigator.userAgent;

                            // Detect if device is iPhone or iPod and if it's older than iOS 8
                            // http://stackoverflow.com/a/14223920
                            //
                            // This detection is made because of buggy top/bottom toolbars
                            // that don't trigger window.resize event.
                            // For more info refer to _isFixedPosition variable in core.js

                            if (/iP(hone|od)/.test(navigator.platform)) {
                                var v = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/);
                                if(v && v.length > 0) {
                                    v = parseInt(v[1], 10);
                                    if(v >= 1 && v < 8 ) {
                                        features.isOldIOSPhone = true;
                                    }
                                }
                            }

                            // Detect old Android (before KitKat)
                            // due to bugs related to position:fixed
                            // http://stackoverflow.com/questions/7184573/pick-up-the-android-version-in-the-browser-by-javascript

                            var match = ua.match(/Android\s([0-9\.]*)/);
                            var androidversion =  match ? match[1] : 0;
                            androidversion = parseFloat(androidversion);
                            if(androidversion >= 1 ) {
                                if(androidversion < 4.4) {
                                    features.isOldAndroid = true; // for fixed position bug & performance
                                }
                                features.androidVersion = androidversion; // for touchend bug
                            }
                            features.isMobileOpera = /opera mini|opera mobi/i.test(ua);

                            // p.s. yes, yes, UA sniffing is bad, propose your solution for above bugs.
                        }

                        var styleChecks = ['transform', 'perspective', 'animationName'],
                                vendors = ['', 'webkit','Moz','ms','O'],
                                styleCheckItem,
                                styleName;

                        for(var i = 0; i < 4; i++) {
                            vendor = vendors[i];

                            for(var a = 0; a < 3; a++) {
                                styleCheckItem = styleChecks[a];

                                // uppercase first letter of property name, if vendor is present
                                styleName = vendor + (vendor ?
                                        styleCheckItem.charAt(0).toUpperCase() + styleCheckItem.slice(1) :
                                                styleCheckItem);

                                if(!features[styleCheckItem] && styleName in helperStyle ) {
                                    features[styleCheckItem] = styleName;
                                }
                            }

                            if(vendor && !features.raf) {
                                vendor = vendor.toLowerCase();
                                features.raf = window[vendor+'RequestAnimationFrame'];
                                if(features.raf) {
                                    features.caf = window[vendor+'CancelAnimationFrame'] ||
                                            window[vendor+'CancelRequestAnimationFrame'];
                                }
                            }
                        }

                        if(!features.raf) {
                            var lastTime = 0;
                            features.raf = function(fn) {
                                var currTime = new Date().getTime();
                                var timeToCall = Math.max(0, 16 - (currTime - lastTime));
                                var id = window.setTimeout(function() { fn(currTime + timeToCall); }, timeToCall);
                                lastTime = currTime + timeToCall;
                                return id;
                            };
                            features.caf = function(id) { clearTimeout(id); };
                        }

                        // Detect SVG support
                        features.svg = !!document.createElementNS &&
                                !!document.createElementNS('http://www.w3.org/2000/svg', 'svg').createSVGRect;

                        framework.features = features;

                        return features;
                    }
                };

                framework.detectFeatures();

// Override addEventListener for old versions of IE
                if(framework.features.oldIE) {

                    framework.bind = function(target, type, listener, unbind) {

                        type = type.split(' ');

                        var methodName = (unbind ? 'detach' : 'attach') + 'Event',
                                evName,
                                _handleEv = function() {
                                    listener.handleEvent.call(listener);
                                };

                        for(var i = 0; i < type.length; i++) {
                            evName = type[i];
                            if(evName) {

                                if(typeof listener === 'object' && listener.handleEvent) {
                                    if(!unbind) {
                                        listener['oldIE' + evName] = _handleEv;
                                    } else {
                                        if(!listener['oldIE' + evName]) {
                                            return false;
                                        }
                                    }

                                    target[methodName]( 'on' + evName, listener['oldIE' + evName]);
                                } else {
                                    target[methodName]( 'on' + evName, listener);
                                }

                            }
                        }
                    };

                }

                /*>>framework-bridge*/

                /*>>core*/
//function(template, UiClass, items, options)

                var self = this;

                /**
                 * Static vars, don't change unless you know what you're doing.
                 */
                var DOUBLE_TAP_RADIUS = 25,
                        NUM_HOLDERS = 3;

                /**
                 * Options
                 */
                var _options = {
                    allowPanToNext:true,
                    spacing: 0.12,
                    bgOpacity: 1,
                    mouseUsed: false,
                    loop: true,
                    pinchToClose: true,
                    closeOnScroll: true,
                    closeOnVerticalDrag: true,
                    verticalDragRange: 0.75,
                    hideAnimationDuration: 333,
                    showAnimationDuration: 333,
                    showHideOpacity: false,
                    focus: true,
                    escKey: true,
                    arrowKeys: true,
                    mainScrollEndFriction: 0.35,
                    panEndFriction: 0.35,
                    isClickableElement: function(el) {
                        return el.tagName === 'A';
                    },
                    getDoubleTapZoom: function(isMouseClick, item) {
                        if(isMouseClick) {
                            return 1;
                        } else {
                            return item.initialZoomLevel < 0.7 ? 1 : 1.33;
                        }
                    },
                    maxSpreadZoom: 1.33,
                    modal: true,

                    // not fully implemented yet
                    scaleMode: 'fit' // TODO
                };
                framework.extend(_options, options);


                /**
                 * Private helper variables & functions
                 */

                var _getEmptyPoint = function() {
                    return {x:0,y:0};
                };

                var _isOpen,
                        _isDestroying,
                        _closedByScroll,
                        _currentItemIndex,
                        _containerStyle,
                        _containerShiftIndex,
                        _currPanDist = _getEmptyPoint(),
                        _startPanOffset = _getEmptyPoint(),
                        _panOffset = _getEmptyPoint(),
                        _upMoveEvents, // drag move, drag end & drag cancel events array
                        _downEvents, // drag start events array
                        _globalEventHandlers,
                        _viewportSize = {},
                        _currZoomLevel,
                        _startZoomLevel,
                        _translatePrefix,
                        _translateSufix,
                        _updateSizeInterval,
                        _itemsNeedUpdate,
                        _currPositionIndex = 0,
                        _offset = {},
                        _slideSize = _getEmptyPoint(), // size of slide area, including spacing
                        _itemHolders,
                        _prevItemIndex,
                        _indexDiff = 0, // difference of indexes since last content update
                        _dragStartEvent,
                        _dragMoveEvent,
                        _dragEndEvent,
                        _dragCancelEvent,
                        _transformKey,
                        _pointerEventEnabled,
                        _isFixedPosition = true,
                        _likelyTouchDevice,
                        _modules = [],
                        _requestAF,
                        _cancelAF,
                        _initalClassName,
                        _initalWindowScrollY,
                        _oldIE,
                        _currentWindowScrollY,
                        _features,
                        _windowVisibleSize = {},
                        _renderMaxResolution = false,
                        _orientationChangeTimeout,


                // Registers PhotoSWipe module (History, Controller ...)
                        _registerModule = function(name, module) {
                            framework.extend(self, module.publicMethods);
                            _modules.push(name);
                        },

                        _getLoopedId = function(index) {
                            var numSlides = _getNumItems();
                            if(index > numSlides - 1) {
                                return index - numSlides;
                            } else  if(index < 0) {
                                return numSlides + index;
                            }
                            return index;
                        },

                // Micro bind/trigger
                        _listeners = {},
                        _listen = function(name, fn) {
                            if(!_listeners[name]) {
                                _listeners[name] = [];
                            }
                            return _listeners[name].push(fn);
                        },
                        _shout = function(name) {
                            var listeners = _listeners[name];

                            if(listeners) {
                                var args = Array.prototype.slice.call(arguments);
                                args.shift();

                                for(var i = 0; i < listeners.length; i++) {
                                    listeners[i].apply(self, args);
                                }
                            }
                        },

                        _getCurrentTime = function() {
                            return new Date().getTime();
                        },
                        _applyBgOpacity = function(opacity) {
                            _bgOpacity = opacity;
                            self.bg.style.opacity = opacity * _options.bgOpacity;
                        },

                        _applyZoomTransform = function(styleObj,x,y,zoom,item) {
                            if(!_renderMaxResolution || (item && item !== self.currItem) ) {
                                zoom = zoom / (item ? item.fitRatio : self.currItem.fitRatio);
                            }

                            styleObj[_transformKey] = _translatePrefix + x + 'px, ' + y + 'px' + _translateSufix + ' scale(' + zoom + ')';
                        },
                        _applyCurrentZoomPan = function( allowRenderResolution ) {
                            if(_currZoomElementStyle) {

                                if(allowRenderResolution) {
                                    if(_currZoomLevel > self.currItem.fitRatio) {
                                        if(!_renderMaxResolution) {
                                            _setImageSize(self.currItem, false, true);
                                            _renderMaxResolution = true;
                                        }
                                    } else {
                                        if(_renderMaxResolution) {
                                            _setImageSize(self.currItem);
                                            _renderMaxResolution = false;
                                        }
                                    }
                                }


                                _applyZoomTransform(_currZoomElementStyle, _panOffset.x, _panOffset.y, _currZoomLevel);
                            }
                        },
                        _applyZoomPanToItem = function(item) {
                            if(item.container) {

                                _applyZoomTransform(item.container.style,
                                        item.initialPosition.x,
                                        item.initialPosition.y,
                                        item.initialZoomLevel,
                                        item);
                            }
                        },
                        _setTranslateX = function(x, elStyle) {
                            elStyle[_transformKey] = _translatePrefix + x + 'px, 0px' + _translateSufix;
                        },
                        _moveMainScroll = function(x, dragging) {

                            if(!_options.loop && dragging) {
                                var newSlideIndexOffset = _currentItemIndex + (_slideSize.x * _currPositionIndex - x) / _slideSize.x,
                                        delta = Math.round(x - _mainScrollPos.x);

                                if( (newSlideIndexOffset < 0 && delta > 0) ||
                                        (newSlideIndexOffset >= _getNumItems() - 1 && delta < 0) ) {
                                    x = _mainScrollPos.x + delta * _options.mainScrollEndFriction;
                                }
                            }

                            _mainScrollPos.x = x;
                            _setTranslateX(x, _containerStyle);
                        },
                        _calculatePanOffset = function(axis, zoomLevel) {
                            var m = _midZoomPoint[axis] - _offset[axis];
                            return _startPanOffset[axis] + _currPanDist[axis] + m - m * ( zoomLevel / _startZoomLevel );
                        },

                        _equalizePoints = function(p1, p2) {
                            p1.x = p2.x;
                            p1.y = p2.y;
                            if(p2.id) {
                                p1.id = p2.id;
                            }
                        },
                        _roundPoint = function(p) {
                            p.x = Math.round(p.x);
                            p.y = Math.round(p.y);
                        },

                        _mouseMoveTimeout = null,
                        _onFirstMouseMove = function() {
                            // Wait until mouse move event is fired at least twice during 100ms
                            // We do this, because some mobile browsers trigger it on touchstart
                            if(_mouseMoveTimeout ) {
                                framework.unbind(document, 'mousemove', _onFirstMouseMove);
                                framework.addClass(template, 'pswp--has_mouse');
                                _options.mouseUsed = true;
                                _shout('mouseUsed');
                            }
                            _mouseMoveTimeout = setTimeout(function() {
                                _mouseMoveTimeout = null;
                            }, 100);
                        },

                        _bindEvents = function() {
                            framework.bind(document, 'keydown', self);

                            if(_features.transform) {
                                // don't bind click event in browsers that don't support transform (mostly IE8)
                                framework.bind(self.scrollWrap, 'click', self);
                            }


                            if(!_options.mouseUsed) {
                                framework.bind(document, 'mousemove', _onFirstMouseMove);
                            }

                            framework.bind(window, 'resize scroll orientationchange', self);

                            _shout('bindEvents');
                        },

                        _unbindEvents = function() {
                            framework.unbind(window, 'resize scroll orientationchange', self);
                            framework.unbind(window, 'scroll', _globalEventHandlers.scroll);
                            framework.unbind(document, 'keydown', self);
                            framework.unbind(document, 'mousemove', _onFirstMouseMove);

                            if(_features.transform) {
                                framework.unbind(self.scrollWrap, 'click', self);
                            }

                            if(_isDragging) {
                                framework.unbind(window, _upMoveEvents, self);
                            }

                            clearTimeout(_orientationChangeTimeout);

                            _shout('unbindEvents');
                        },

                        _calculatePanBounds = function(zoomLevel, update) {
                            var bounds = _calculateItemSize( self.currItem, _viewportSize, zoomLevel );
                            if(update) {
                                _currPanBounds = bounds;
                            }
                            return bounds;
                        },

                        _getMinZoomLevel = function(item) {
                            if(!item) {
                                item = self.currItem;
                            }
                            return item.initialZoomLevel;
                        },
                        _getMaxZoomLevel = function(item) {
                            if(!item) {
                                item = self.currItem;
                            }
                            return item.w > 0 ? _options.maxSpreadZoom : 1;
                        },

                // Return true if offset is out of the bounds
                        _modifyDestPanOffset = function(axis, destPanBounds, destPanOffset, destZoomLevel) {
                            if(destZoomLevel === self.currItem.initialZoomLevel) {
                                destPanOffset[axis] = self.currItem.initialPosition[axis];
                                return true;
                            } else {
                                destPanOffset[axis] = _calculatePanOffset(axis, destZoomLevel);

                                if(destPanOffset[axis] > destPanBounds.min[axis]) {
                                    destPanOffset[axis] = destPanBounds.min[axis];
                                    return true;
                                } else if(destPanOffset[axis] < destPanBounds.max[axis] ) {
                                    destPanOffset[axis] = destPanBounds.max[axis];
                                    return true;
                                }
                            }
                            return false;
                        },

                        _setupTransforms = function() {

                            if(_transformKey) {
                                // setup 3d transforms
                                var allow3dTransform = _features.perspective && !_likelyTouchDevice;
                                _translatePrefix = 'translate' + (allow3dTransform ? '3d(' : '(');
                                _translateSufix = _features.perspective ? ', 0px)' : ')';
                                return;
                            }

                            // Override zoom/pan/move functions in case old browser is used (most likely IE)
                            // (so they use left/top/width/height, instead of CSS transform)

                            _transformKey = 'left';
                            framework.addClass(template, 'pswp--ie');

                            _setTranslateX = function(x, elStyle) {
                                elStyle.left = x + 'px';
                            };
                            _applyZoomPanToItem = function(item) {

                                var zoomRatio = item.fitRatio > 1 ? 1 : item.fitRatio,
                                        s = item.container.style,
                                        w = zoomRatio * item.w,
                                        h = zoomRatio * item.h;

                                s.width = w + 'px';
                                s.height = h + 'px';
                                s.left = item.initialPosition.x + 'px';
                                s.top = item.initialPosition.y + 'px';

                            };
                            _applyCurrentZoomPan = function() {
                                if(_currZoomElementStyle) {

                                    var s = _currZoomElementStyle,
                                            item = self.currItem,
                                            zoomRatio = item.fitRatio > 1 ? 1 : item.fitRatio,
                                            w = zoomRatio * item.w,
                                            h = zoomRatio * item.h;

                                    s.width = w + 'px';
                                    s.height = h + 'px';


                                    s.left = _panOffset.x + 'px';
                                    s.top = _panOffset.y + 'px';
                                }

                            };
                        },

                        _onKeyDown = function(e) {
                            var keydownAction = '';
                            if(_options.escKey && e.keyCode === 27) {
                                keydownAction = 'close';
                            } else if(_options.arrowKeys) {
                                if(e.keyCode === 37) {
                                    keydownAction = 'prev';
                                } else if(e.keyCode === 39) {
                                    keydownAction = 'next';
                                }
                            }

                            if(keydownAction) {
                                // don't do anything if special key pressed to prevent from overriding default browser actions
                                // e.g. in Chrome on Mac cmd+arrow-left returns to previous page
                                if( !e.ctrlKey && !e.altKey && !e.shiftKey && !e.metaKey ) {
                                    if(e.preventDefault) {
                                        e.preventDefault();
                                    } else {
                                        e.returnValue = false;
                                    }
                                    self[keydownAction]();
                                }
                            }
                        },

                        _onGlobalClick = function(e) {
                            if(!e) {
                                return;
                            }

                            // don't allow click event to pass through when triggering after drag or some other gesture
                            if(_moved || _zoomStarted || _mainScrollAnimating || _verticalDragInitiated) {
                                e.preventDefault();
                                e.stopPropagation();
                            }
                        },

                        _updatePageScrollOffset = function() {
                            self.setScrollOffset(0, framework.getScrollY());
                        };







// Micro animation engine
                var _animations = {},
                        _numAnimations = 0,
                        _stopAnimation = function(name) {
                            if(_animations[name]) {
                                if(_animations[name].raf) {
                                    _cancelAF( _animations[name].raf );
                                }
                                _numAnimations--;
                                delete _animations[name];
                            }
                        },
                        _registerStartAnimation = function(name) {
                            if(_animations[name]) {
                                _stopAnimation(name);
                            }
                            if(!_animations[name]) {
                                _numAnimations++;
                                _animations[name] = {};
                            }
                        },
                        _stopAllAnimations = function() {
                            for (var prop in _animations) {

                                if( _animations.hasOwnProperty( prop ) ) {
                                    _stopAnimation(prop);
                                }

                            }
                        },
                        _animateProp = function(name, b, endProp, d, easingFn, onUpdate, onComplete) {
                            var startAnimTime = _getCurrentTime(), t;
                            _registerStartAnimation(name);

                            var animloop = function(){
                                if ( _animations[name] ) {

                                    t = _getCurrentTime() - startAnimTime; // time diff
                                    //b - beginning (start prop)
                                    //d - anim duration

                                    if ( t >= d ) {
                                        _stopAnimation(name);
                                        onUpdate(endProp);
                                        if(onComplete) {
                                            onComplete();
                                        }
                                        return;
                                    }
                                    onUpdate( (endProp - b) * easingFn(t/d) + b );

                                    _animations[name].raf = _requestAF(animloop);
                                }
                            };
                            animloop();
                        };



                var publicMethods = {

                    // make a few local variables and functions public
                    shout: _shout,
                    listen: _listen,
                    viewportSize: _viewportSize,
                    options: _options,

                    isMainScrollAnimating: function() {
                        return _mainScrollAnimating;
                    },
                    getZoomLevel: function() {
                        return _currZoomLevel;
                    },
                    getCurrentIndex: function() {
                        return _currentItemIndex;
                    },
                    isDragging: function() {
                        return _isDragging;
                    },
                    isZooming: function() {
                        return _isZooming;
                    },
                    setScrollOffset: function(x,y) {
                        _offset.x = x;
                        _currentWindowScrollY = _offset.y = y;
                        _shout('updateScrollOffset', _offset);
                    },
                    applyZoomPan: function(zoomLevel,panX,panY,allowRenderResolution) {
                        _panOffset.x = panX;
                        _panOffset.y = panY;
                        _currZoomLevel = zoomLevel;
                        _applyCurrentZoomPan( allowRenderResolution );
                    },

                    init: function() {

                        if(_isOpen || _isDestroying) {
                            return;
                        }

                        var i;

                        self.framework = framework; // basic functionality
                        self.template = template; // root DOM element of PhotoSwipe
                        self.bg = framework.getChildByClass(template, 'pswp__bg');

                        _initalClassName = template.className;
                        _isOpen = true;

                        _features = framework.detectFeatures();
                        _requestAF = _features.raf;
                        _cancelAF = _features.caf;
                        _transformKey = _features.transform;
                        _oldIE = _features.oldIE;

                        self.scrollWrap = framework.getChildByClass(template, 'pswp__scroll-wrap');
                        self.container = framework.getChildByClass(self.scrollWrap, 'pswp__container');

                        _containerStyle = self.container.style; // for fast access

                        // Objects that hold slides (there are only 3 in DOM)
                        self.itemHolders = _itemHolders = [
                            {el:self.container.children[0] , wrap:0, index: -1},
                            {el:self.container.children[1] , wrap:0, index: -1},
                            {el:self.container.children[2] , wrap:0, index: -1}
                        ];

                        // hide nearby item holders until initial zoom animation finishes (to avoid extra Paints)
                        _itemHolders[0].el.style.display = _itemHolders[2].el.style.display = 'none';

                        _setupTransforms();

                        // Setup global events
                        _globalEventHandlers = {
                            resize: self.updateSize,

                            // Fixes: iOS 10.3 resize event
                            // does not update scrollWrap.clientWidth instantly after resize
                            // https://github.com/dimsemenov/PhotoSwipe/issues/1315
                            orientationchange: function() {
                                clearTimeout(_orientationChangeTimeout);
                                _orientationChangeTimeout = setTimeout(function() {
                                    if(_viewportSize.x !== self.scrollWrap.clientWidth) {
                                        self.updateSize();
                                    }
                                }, 500);
                            },
                            scroll: _updatePageScrollOffset,
                            keydown: _onKeyDown,
                            click: _onGlobalClick
                        };

                        // disable show/hide effects on old browsers that don't support CSS animations or transforms,
                        // old IOS, Android and Opera mobile. Blackberry seems to work fine, even older models.
                        var oldPhone = _features.isOldIOSPhone || _features.isOldAndroid || _features.isMobileOpera;
                        if(!_features.animationName || !_features.transform || oldPhone) {
                            _options.showAnimationDuration = _options.hideAnimationDuration = 0;
                        }

                        // init modules
                        for(i = 0; i < _modules.length; i++) {
                            self['init' + _modules[i]]();
                        }

                        // init
                        if(UiClass) {
                            var ui = self.ui = new UiClass(self, framework);
                            ui.init();
                        }

                        _shout('firstUpdate');
                        _currentItemIndex = _currentItemIndex || _options.index || 0;
                        // validate index
                        if( isNaN(_currentItemIndex) || _currentItemIndex < 0 || _currentItemIndex >= _getNumItems() ) {
                            _currentItemIndex = 0;
                        }
                        self.currItem = _getItemAt( _currentItemIndex );


                        if(_features.isOldIOSPhone || _features.isOldAndroid) {
                            _isFixedPosition = false;
                        }

                        template.setAttribute('aria-hidden', 'false');
                        if(_options.modal) {
                            if(!_isFixedPosition) {
                                template.style.position = 'absolute';
                                template.style.top = framework.getScrollY() + 'px';
                            } else {
                                template.style.position = 'fixed';
                            }
                        }

                        if(_currentWindowScrollY === undefined) {
                            _shout('initialLayout');
                            _currentWindowScrollY = _initalWindowScrollY = framework.getScrollY();
                        }

                        // add classes to root element of PhotoSwipe
                        var rootClasses = 'pswp--open ';
                        if(_options.mainClass) {
                            rootClasses += _options.mainClass + ' ';
                        }
                        if(_options.showHideOpacity) {
                            rootClasses += 'pswp--animate_opacity ';
                        }
                        rootClasses += _likelyTouchDevice ? 'pswp--touch' : 'pswp--notouch';
                        rootClasses += _features.animationName ? ' pswp--css_animation' : '';
                        rootClasses += _features.svg ? ' pswp--svg' : '';
                        framework.addClass(template, rootClasses);

                        self.updateSize();

                        // initial update
                        _containerShiftIndex = -1;
                        _indexDiff = null;
                        for(i = 0; i < NUM_HOLDERS; i++) {
                            _setTranslateX( (i+_containerShiftIndex) * _slideSize.x, _itemHolders[i].el.style);
                        }

                        if(!_oldIE) {
                            framework.bind(self.scrollWrap, _downEvents, self); // no dragging for old IE
                        }

                        _listen('initialZoomInEnd', function() {
                            self.setContent(_itemHolders[0], _currentItemIndex-1);
                            self.setContent(_itemHolders[2], _currentItemIndex+1);

                            _itemHolders[0].el.style.display = _itemHolders[2].el.style.display = 'block';

                            if(_options.focus) {
                                // focus causes layout,
                                // which causes lag during the animation,
                                // that's why we delay it untill the initial zoom transition ends
                                template.focus();
                            }


                            _bindEvents();
                        });

                        // set content for center slide (first time)
                        self.setContent(_itemHolders[1], _currentItemIndex);

                        self.updateCurrItem();

                        _shout('afterInit');

                        if(!_isFixedPosition) {

                            // On all versions of iOS lower than 8.0, we check size of viewport every second.
                            //
                            // This is done to detect when Safari top & bottom bars appear,
                            // as this action doesn't trigger any events (like resize).
                            //
                            // On iOS8 they fixed this.
                            //
                            // 10 Nov 2014: iOS 7 usage ~40%. iOS 8 usage 56%.

                            _updateSizeInterval = setInterval(function() {
                                if(!_numAnimations && !_isDragging && !_isZooming && (_currZoomLevel === self.currItem.initialZoomLevel)  ) {
                                    self.updateSize();
                                }
                            }, 1000);
                        }

                        framework.addClass(template, 'pswp--visible');
                    },

                    // Close the gallery, then destroy it
                    close: function() {
                        if(!_isOpen) {
                            return;
                        }

                        _isOpen = false;
                        _isDestroying = true;
                        _shout('close');
                        _unbindEvents();

                        _showOrHide(self.currItem, null, true, self.destroy);
                    },

                    // destroys the gallery (unbinds events, cleans up intervals and timeouts to avoid memory leaks)
                    destroy: function() {
                        _shout('destroy');

                        if(_showOrHideTimeout) {
                            clearTimeout(_showOrHideTimeout);
                        }

                        template.setAttribute('aria-hidden', 'true');
                        template.className = _initalClassName;

                        if(_updateSizeInterval) {
                            clearInterval(_updateSizeInterval);
                        }

                        framework.unbind(self.scrollWrap, _downEvents, self);

                        // we unbind scroll event at the end, as closing animation may depend on it
                        framework.unbind(window, 'scroll', self);

                        _stopDragUpdateLoop();

                        _stopAllAnimations();

                        _listeners = null;
                    },

                    /**
                     * Pan image to position
                     * @param {Number} x
                     * @param {Number} y
                     * @param {Boolean} force Will ignore bounds if set to true.
                     */
                    panTo: function(x,y,force) {
                        if(!force) {
                            if(x > _currPanBounds.min.x) {
                                x = _currPanBounds.min.x;
                            } else if(x < _currPanBounds.max.x) {
                                x = _currPanBounds.max.x;
                            }

                            if(y > _currPanBounds.min.y) {
                                y = _currPanBounds.min.y;
                            } else if(y < _currPanBounds.max.y) {
                                y = _currPanBounds.max.y;
                            }
                        }

                        _panOffset.x = x;
                        _panOffset.y = y;
                        _applyCurrentZoomPan();
                    },

                    handleEvent: function (e) {
                        e = e || window.event;
                        if(_globalEventHandlers[e.type]) {
                            _globalEventHandlers[e.type](e);
                        }
                    },


                    goTo: function(index) {

                        index = _getLoopedId(index);

                        var diff = index - _currentItemIndex;
                        _indexDiff = diff;

                        _currentItemIndex = index;
                        self.currItem = _getItemAt( _currentItemIndex );
                        _currPositionIndex -= diff;

                        _moveMainScroll(_slideSize.x * _currPositionIndex);


                        _stopAllAnimations();
                        _mainScrollAnimating = false;

                        self.updateCurrItem();
                    },
                    next: function() {
                        self.goTo( _currentItemIndex + 1);
                    },
                    prev: function() {
                        self.goTo( _currentItemIndex - 1);
                    },

                    // update current zoom/pan objects
                    updateCurrZoomItem: function(emulateSetContent) {
                        if(emulateSetContent) {
                            _shout('beforeChange', 0);
                        }

                        // itemHolder[1] is middle (current) item
                        if(_itemHolders[1].el.children.length) {
                            var zoomElement = _itemHolders[1].el.children[0];
                            if( framework.hasClass(zoomElement, 'pswp__zoom-wrap') ) {
                                _currZoomElementStyle = zoomElement.style;
                            } else {
                                _currZoomElementStyle = null;
                            }
                        } else {
                            _currZoomElementStyle = null;
                        }

                        _currPanBounds = self.currItem.bounds;
                        _startZoomLevel = _currZoomLevel = self.currItem.initialZoomLevel;

                        _panOffset.x = _currPanBounds.center.x;
                        _panOffset.y = _currPanBounds.center.y;

                        if(emulateSetContent) {
                            _shout('afterChange');
                        }
                    },


                    invalidateCurrItems: function() {
                        _itemsNeedUpdate = true;
                        for(var i = 0; i < NUM_HOLDERS; i++) {
                            if( _itemHolders[i].item ) {
                                _itemHolders[i].item.needsUpdate = true;
                            }
                        }
                    },

                    updateCurrItem: function(beforeAnimation) {

                        if(_indexDiff === 0) {
                            return;
                        }

                        var diffAbs = Math.abs(_indexDiff),
                                tempHolder;

                        if(beforeAnimation && diffAbs < 2) {
                            return;
                        }


                        self.currItem = _getItemAt( _currentItemIndex );
                        _renderMaxResolution = false;

                        _shout('beforeChange', _indexDiff);

                        if(diffAbs >= NUM_HOLDERS) {
                            _containerShiftIndex += _indexDiff + (_indexDiff > 0 ? -NUM_HOLDERS : NUM_HOLDERS);
                            diffAbs = NUM_HOLDERS;
                        }
                        for(var i = 0; i < diffAbs; i++) {
                            if(_indexDiff > 0) {
                                tempHolder = _itemHolders.shift();
                                _itemHolders[NUM_HOLDERS-1] = tempHolder; // move first to last

                                _containerShiftIndex++;
                                _setTranslateX( (_containerShiftIndex+2) * _slideSize.x, tempHolder.el.style);
                                self.setContent(tempHolder, _currentItemIndex - diffAbs + i + 1 + 1);
                            } else {
                                tempHolder = _itemHolders.pop();
                                _itemHolders.unshift( tempHolder ); // move last to first

                                _containerShiftIndex--;
                                _setTranslateX( _containerShiftIndex * _slideSize.x, tempHolder.el.style);
                                self.setContent(tempHolder, _currentItemIndex + diffAbs - i - 1 - 1);
                            }

                        }

                        // reset zoom/pan on previous item
                        if(_currZoomElementStyle && Math.abs(_indexDiff) === 1) {

                            var prevItem = _getItemAt(_prevItemIndex);
                            if(prevItem.initialZoomLevel !== _currZoomLevel) {
                                _calculateItemSize(prevItem , _viewportSize );
                                _setImageSize(prevItem);
                                _applyZoomPanToItem( prevItem );
                            }

                        }

                        // reset diff after update
                        _indexDiff = 0;

                        self.updateCurrZoomItem();

                        _prevItemIndex = _currentItemIndex;

                        _shout('afterChange');

                    },



                    updateSize: function(force) {

                        if(!_isFixedPosition && _options.modal) {
                            var windowScrollY = framework.getScrollY();
                            if(_currentWindowScrollY !== windowScrollY) {
                                template.style.top = windowScrollY + 'px';
                                _currentWindowScrollY = windowScrollY;
                            }
                            if(!force && _windowVisibleSize.x === window.innerWidth && _windowVisibleSize.y === window.innerHeight) {
                                return;
                            }
                            _windowVisibleSize.x = window.innerWidth;
                            _windowVisibleSize.y = window.innerHeight;

                            //template.style.width = _windowVisibleSize.x + 'px';
                            template.style.height = _windowVisibleSize.y + 'px';
                        }



                        _viewportSize.x = self.scrollWrap.clientWidth;
                        _viewportSize.y = self.scrollWrap.clientHeight;

                        _updatePageScrollOffset();

                        _slideSize.x = _viewportSize.x + Math.round(_viewportSize.x * _options.spacing);
                        _slideSize.y = _viewportSize.y;

                        _moveMainScroll(_slideSize.x * _currPositionIndex);

                        _shout('beforeResize'); // even may be used for example to switch image sources


                        // don't re-calculate size on inital size update
                        if(_containerShiftIndex !== undefined) {

                            var holder,
                                    item,
                                    hIndex;

                            for(var i = 0; i < NUM_HOLDERS; i++) {
                                holder = _itemHolders[i];
                                _setTranslateX( (i+_containerShiftIndex) * _slideSize.x, holder.el.style);

                                hIndex = _currentItemIndex+i-1;

                                if(_options.loop && _getNumItems() > 2) {
                                    hIndex = _getLoopedId(hIndex);
                                }

                                // update zoom level on items and refresh source (if needsUpdate)
                                item = _getItemAt( hIndex );

                                // re-render gallery item if `needsUpdate`,
                                // or doesn't have `bounds` (entirely new slide object)
                                if( item && (_itemsNeedUpdate || item.needsUpdate || !item.bounds) ) {

                                    self.cleanSlide( item );

                                    self.setContent( holder, hIndex );

                                    // if "center" slide
                                    if(i === 1) {
                                        self.currItem = item;
                                        self.updateCurrZoomItem(true);
                                    }

                                    item.needsUpdate = false;

                                } else if(holder.index === -1 && hIndex >= 0) {
                                    // add content first time
                                    self.setContent( holder, hIndex );
                                }
                                if(item && item.container) {
                                    _calculateItemSize(item, _viewportSize);
                                    _setImageSize(item);
                                    _applyZoomPanToItem( item );
                                }

                            }
                            _itemsNeedUpdate = false;
                        }

                        _startZoomLevel = _currZoomLevel = self.currItem.initialZoomLevel;
                        _currPanBounds = self.currItem.bounds;

                        if(_currPanBounds) {
                            _panOffset.x = _currPanBounds.center.x;
                            _panOffset.y = _currPanBounds.center.y;
                            _applyCurrentZoomPan( true );
                        }

                        _shout('resize');
                    },

                    // Zoom current item to
                    zoomTo: function(destZoomLevel, centerPoint, speed, easingFn, updateFn) {
                        /*
                         if(destZoomLevel === 'fit') {
                         destZoomLevel = self.currItem.fitRatio;
                         } else if(destZoomLevel === 'fill') {
                         destZoomLevel = self.currItem.fillRatio;
                         }
                         */

                        if(centerPoint) {
                            _startZoomLevel = _currZoomLevel;
                            _midZoomPoint.x = Math.abs(centerPoint.x) - _panOffset.x ;
                            _midZoomPoint.y = Math.abs(centerPoint.y) - _panOffset.y ;
                            _equalizePoints(_startPanOffset, _panOffset);
                        }

                        var destPanBounds = _calculatePanBounds(destZoomLevel, false),
                                destPanOffset = {};

                        _modifyDestPanOffset('x', destPanBounds, destPanOffset, destZoomLevel);
                        _modifyDestPanOffset('y', destPanBounds, destPanOffset, destZoomLevel);

                        var initialZoomLevel = _currZoomLevel;
                        var initialPanOffset = {
                            x: _panOffset.x,
                            y: _panOffset.y
                        };

                        _roundPoint(destPanOffset);

                        var onUpdate = function(now) {
                            if(now === 1) {
                                _currZoomLevel = destZoomLevel;
                                _panOffset.x = destPanOffset.x;
                                _panOffset.y = destPanOffset.y;
                            } else {
                                _currZoomLevel = (destZoomLevel - initialZoomLevel) * now + initialZoomLevel;
                                _panOffset.x = (destPanOffset.x - initialPanOffset.x) * now + initialPanOffset.x;
                                _panOffset.y = (destPanOffset.y - initialPanOffset.y) * now + initialPanOffset.y;
                            }

                            if(updateFn) {
                                updateFn(now);
                            }

                            _applyCurrentZoomPan( now === 1 );
                        };

                        if(speed) {
                            _animateProp('customZoomTo', 0, 1, speed, easingFn || framework.easing.sine.inOut, onUpdate);
                        } else {
                            onUpdate(1);
                        }
                    }


                };


                /*>>core*/

                /*>>gestures*/
                /**
                 * Mouse/touch/pointer event handlers.
                 *
                 * separated from @core.js for readability
                 */

                var MIN_SWIPE_DISTANCE = 30,
                        DIRECTION_CHECK_OFFSET = 10; // amount of pixels to drag to determine direction of swipe

                var _gestureStartTime,
                        _gestureCheckSpeedTime,

                // pool of objects that are used during dragging of zooming
                        p = {}, // first point
                        p2 = {}, // second point (for zoom gesture)
                        delta = {},
                        _currPoint = {},
                        _startPoint = {},
                        _currPointers = [],
                        _startMainScrollPos = {},
                        _releaseAnimData,
                        _posPoints = [], // array of points during dragging, used to determine type of gesture
                        _tempPoint = {},

                        _isZoomingIn,
                        _verticalDragInitiated,
                        _oldAndroidTouchEndTimeout,
                        _currZoomedItemIndex = 0,
                        _centerPoint = _getEmptyPoint(),
                        _lastReleaseTime = 0,
                        _isDragging, // at least one pointer is down
                        _isMultitouch, // at least two _pointers are down
                        _zoomStarted, // zoom level changed during zoom gesture
                        _moved,
                        _dragAnimFrame,
                        _mainScrollShifted,
                        _currentPoints, // array of current touch points
                        _isZooming,
                        _currPointsDistance,
                        _startPointsDistance,
                        _currPanBounds,
                        _mainScrollPos = _getEmptyPoint(),
                        _currZoomElementStyle,
                        _mainScrollAnimating, // true, if animation after swipe gesture is running
                        _midZoomPoint = _getEmptyPoint(),
                        _currCenterPoint = _getEmptyPoint(),
                        _direction,
                        _isFirstMove,
                        _opacityChanged,
                        _bgOpacity,
                        _wasOverInitialZoom,

                        _isEqualPoints = function(p1, p2) {
                            return p1.x === p2.x && p1.y === p2.y;
                        },
                        _isNearbyPoints = function(touch0, touch1) {
                            return Math.abs(touch0.x - touch1.x) < DOUBLE_TAP_RADIUS && Math.abs(touch0.y - touch1.y) < DOUBLE_TAP_RADIUS;
                        },
                        _calculatePointsDistance = function(p1, p2) {
                            _tempPoint.x = Math.abs( p1.x - p2.x );
                            _tempPoint.y = Math.abs( p1.y - p2.y );
                            return Math.sqrt(_tempPoint.x * _tempPoint.x + _tempPoint.y * _tempPoint.y);
                        },
                        _stopDragUpdateLoop = function() {
                            if(_dragAnimFrame) {
                                _cancelAF(_dragAnimFrame);
                                _dragAnimFrame = null;
                            }
                        },
                        _dragUpdateLoop = function() {
                            if(_isDragging) {
                                _dragAnimFrame = _requestAF(_dragUpdateLoop);
                                _renderMovement();
                            }
                        },
                        _canPan = function() {
                            return !(_options.scaleMode === 'fit' && _currZoomLevel ===  self.currItem.initialZoomLevel);
                        },

                // find the closest parent DOM element
                        _closestElement = function(el, fn) {
                            if(!el || el === document) {
                                return false;
                            }

                            // don't search elements above pswp__scroll-wrap
                            if(el.getAttribute('class') && el.getAttribute('class').indexOf('pswp__scroll-wrap') > -1 ) {
                                return false;
                            }

                            if( fn(el) ) {
                                return el;
                            }

                            return _closestElement(el.parentNode, fn);
                        },

                        _preventObj = {},
                        _preventDefaultEventBehaviour = function(e, isDown) {
                            _preventObj.prevent = !_closestElement(e.target, _options.isClickableElement);

                            _shout('preventDragEvent', e, isDown, _preventObj);
                            return _preventObj.prevent;

                        },
                        _convertTouchToPoint = function(touch, p) {
                            p.x = touch.pageX;
                            p.y = touch.pageY;
                            p.id = touch.identifier;
                            return p;
                        },
                        _findCenterOfPoints = function(p1, p2, pCenter) {
                            pCenter.x = (p1.x + p2.x) * 0.5;
                            pCenter.y = (p1.y + p2.y) * 0.5;
                        },
                        _pushPosPoint = function(time, x, y) {
                            if(time - _gestureCheckSpeedTime > 50) {
                                var o = _posPoints.length > 2 ? _posPoints.shift() : {};
                                o.x = x;
                                o.y = y;
                                _posPoints.push(o);
                                _gestureCheckSpeedTime = time;
                            }
                        },

                        _calculateVerticalDragOpacityRatio = function() {
                            var yOffset = _panOffset.y - self.currItem.initialPosition.y; // difference between initial and current position
                            return 1 -  Math.abs( yOffset / (_viewportSize.y / 2)  );
                        },


                // points pool, reused during touch events
                        _ePoint1 = {},
                        _ePoint2 = {},
                        _tempPointsArr = [],
                        _tempCounter,
                        _getTouchPoints = function(e) {
                            // clean up previous points, without recreating array
                            while(_tempPointsArr.length > 0) {
                                _tempPointsArr.pop();
                            }

                            if(!_pointerEventEnabled) {
                                if(e.type.indexOf('touch') > -1) {

                                    if(e.touches && e.touches.length > 0) {
                                        _tempPointsArr[0] = _convertTouchToPoint(e.touches[0], _ePoint1);
                                        if(e.touches.length > 1) {
                                            _tempPointsArr[1] = _convertTouchToPoint(e.touches[1], _ePoint2);
                                        }
                                    }

                                } else {
                                    _ePoint1.x = e.pageX;
                                    _ePoint1.y = e.pageY;
                                    _ePoint1.id = '';
                                    _tempPointsArr[0] = _ePoint1;//_ePoint1;
                                }
                            } else {
                                _tempCounter = 0;
                                // we can use forEach, as pointer events are supported only in modern browsers
                                _currPointers.forEach(function(p) {
                                    if(_tempCounter === 0) {
                                        _tempPointsArr[0] = p;
                                    } else if(_tempCounter === 1) {
                                        _tempPointsArr[1] = p;
                                    }
                                    _tempCounter++;

                                });
                            }
                            return _tempPointsArr;
                        },

                        _panOrMoveMainScroll = function(axis, delta) {

                            var panFriction,
                                    overDiff = 0,
                                    newOffset = _panOffset[axis] + delta[axis],
                                    startOverDiff,
                                    dir = delta[axis] > 0,
                                    newMainScrollPosition = _mainScrollPos.x + delta.x,
                                    mainScrollDiff = _mainScrollPos.x - _startMainScrollPos.x,
                                    newPanPos,
                                    newMainScrollPos;

                            // calculate fdistance over the bounds and friction
                            if(newOffset > _currPanBounds.min[axis] || newOffset < _currPanBounds.max[axis]) {
                                panFriction = _options.panEndFriction;
                                // Linear increasing of friction, so at 1/4 of viewport it's at max value.
                                // Looks not as nice as was expected. Left for history.
                                // panFriction = (1 - (_panOffset[axis] + delta[axis] + panBounds.min[axis]) / (_viewportSize[axis] / 4) );
                            } else {
                                panFriction = 1;
                            }

                            newOffset = _panOffset[axis] + delta[axis] * panFriction;

                            // move main scroll or start panning
                            if(_options.allowPanToNext || _currZoomLevel === self.currItem.initialZoomLevel) {


                                if(!_currZoomElementStyle) {

                                    newMainScrollPos = newMainScrollPosition;

                                } else if(_direction === 'h' && axis === 'x' && !_zoomStarted ) {

                                    if(dir) {
                                        if(newOffset > _currPanBounds.min[axis]) {
                                            panFriction = _options.panEndFriction;
                                            overDiff = _currPanBounds.min[axis] - newOffset;
                                            startOverDiff = _currPanBounds.min[axis] - _startPanOffset[axis];
                                        }

                                        // drag right
                                        if( (startOverDiff <= 0 || mainScrollDiff < 0) && _getNumItems() > 1 ) {
                                            newMainScrollPos = newMainScrollPosition;
                                            if(mainScrollDiff < 0 && newMainScrollPosition > _startMainScrollPos.x) {
                                                newMainScrollPos = _startMainScrollPos.x;
                                            }
                                        } else {
                                            if(_currPanBounds.min.x !== _currPanBounds.max.x) {
                                                newPanPos = newOffset;
                                            }

                                        }

                                    } else {

                                        if(newOffset < _currPanBounds.max[axis] ) {
                                            panFriction =_options.panEndFriction;
                                            overDiff = newOffset - _currPanBounds.max[axis];
                                            startOverDiff = _startPanOffset[axis] - _currPanBounds.max[axis];
                                        }

                                        if( (startOverDiff <= 0 || mainScrollDiff > 0) && _getNumItems() > 1 ) {
                                            newMainScrollPos = newMainScrollPosition;

                                            if(mainScrollDiff > 0 && newMainScrollPosition < _startMainScrollPos.x) {
                                                newMainScrollPos = _startMainScrollPos.x;
                                            }

                                        } else {
                                            if(_currPanBounds.min.x !== _currPanBounds.max.x) {
                                                newPanPos = newOffset;
                                            }
                                        }

                                    }


                                    //
                                }

                                if(axis === 'x') {

                                    if(newMainScrollPos !== undefined) {
                                        _moveMainScroll(newMainScrollPos, true);
                                        if(newMainScrollPos === _startMainScrollPos.x) {
                                            _mainScrollShifted = false;
                                        } else {
                                            _mainScrollShifted = true;
                                        }
                                    }

                                    if(_currPanBounds.min.x !== _currPanBounds.max.x) {
                                        if(newPanPos !== undefined) {
                                            _panOffset.x = newPanPos;
                                        } else if(!_mainScrollShifted) {
                                            _panOffset.x += delta.x * panFriction;
                                        }
                                    }

                                    return newMainScrollPos !== undefined;
                                }

                            }

                            if(!_mainScrollAnimating) {

                                if(!_mainScrollShifted) {
                                    if(_currZoomLevel > self.currItem.fitRatio) {
                                        _panOffset[axis] += delta[axis] * panFriction;

                                    }
                                }


                            }

                        },

                // Pointerdown/touchstart/mousedown handler
                        _onDragStart = function(e) {

                            // Allow dragging only via left mouse button.
                            // As this handler is not added in IE8 - we ignore e.which
                            //
                            // http://www.quirksmode.org/js/events_properties.html
                            // https://developer.mozilla.org/en-US/docs/Web/API/event.button
                            if(e.type === 'mousedown' && e.button > 0  ) {
                                return;
                            }

                            if(_initialZoomRunning) {
                                e.preventDefault();
                                return;
                            }

                            if(_oldAndroidTouchEndTimeout && e.type === 'mousedown') {
                                return;
                            }

                            if(_preventDefaultEventBehaviour(e, true)) {
                                e.preventDefault();
                            }



                            _shout('pointerDown');

                            if(_pointerEventEnabled) {
                                var pointerIndex = framework.arraySearch(_currPointers, e.pointerId, 'id');
                                if(pointerIndex < 0) {
                                    pointerIndex = _currPointers.length;
                                }
                                _currPointers[pointerIndex] = {x:e.pageX, y:e.pageY, id: e.pointerId};
                            }



                            var startPointsList = _getTouchPoints(e),
                                    numPoints = startPointsList.length;

                            _currentPoints = null;

                            _stopAllAnimations();

                            // init drag
                            if(!_isDragging || numPoints === 1) {



                                _isDragging = _isFirstMove = true;
                                framework.bind(window, _upMoveEvents, self);

                                _isZoomingIn =
                                        _wasOverInitialZoom =
                                                _opacityChanged =
                                                        _verticalDragInitiated =
                                                                _mainScrollShifted =
                                                                        _moved =
                                                                                _isMultitouch =
                                                                                        _zoomStarted = false;

                                _direction = null;

                                _shout('firstTouchStart', startPointsList);

                                _equalizePoints(_startPanOffset, _panOffset);

                                _currPanDist.x = _currPanDist.y = 0;
                                _equalizePoints(_currPoint, startPointsList[0]);
                                _equalizePoints(_startPoint, _currPoint);

                                //_equalizePoints(_startMainScrollPos, _mainScrollPos);
                                _startMainScrollPos.x = _slideSize.x * _currPositionIndex;

                                _posPoints = [{
                                    x: _currPoint.x,
                                    y: _currPoint.y
                                }];

                                _gestureCheckSpeedTime = _gestureStartTime = _getCurrentTime();

                                //_mainScrollAnimationEnd(true);
                                _calculatePanBounds( _currZoomLevel, true );

                                // Start rendering
                                _stopDragUpdateLoop();
                                _dragUpdateLoop();

                            }

                            // init zoom
                            if(!_isZooming && numPoints > 1 && !_mainScrollAnimating && !_mainScrollShifted) {
                                _startZoomLevel = _currZoomLevel;
                                _zoomStarted = false; // true if zoom changed at least once

                                _isZooming = _isMultitouch = true;
                                _currPanDist.y = _currPanDist.x = 0;

                                _equalizePoints(_startPanOffset, _panOffset);

                                _equalizePoints(p, startPointsList[0]);
                                _equalizePoints(p2, startPointsList[1]);

                                _findCenterOfPoints(p, p2, _currCenterPoint);

                                _midZoomPoint.x = Math.abs(_currCenterPoint.x) - _panOffset.x;
                                _midZoomPoint.y = Math.abs(_currCenterPoint.y) - _panOffset.y;
                                _currPointsDistance = _startPointsDistance = _calculatePointsDistance(p, p2);
                            }


                        },

                // Pointermove/touchmove/mousemove handler
                        _onDragMove = function(e) {

                            e.preventDefault();

                            if(_pointerEventEnabled) {
                                var pointerIndex = framework.arraySearch(_currPointers, e.pointerId, 'id');
                                if(pointerIndex > -1) {
                                    var p = _currPointers[pointerIndex];
                                    p.x = e.pageX;
                                    p.y = e.pageY;
                                }
                            }

                            if(_isDragging) {
                                var touchesList = _getTouchPoints(e);
                                if(!_direction && !_moved && !_isZooming) {

                                    if(_mainScrollPos.x !== _slideSize.x * _currPositionIndex) {
                                        // if main scroll position is shifted – direction is always horizontal
                                        _direction = 'h';
                                    } else {
                                        var diff = Math.abs(touchesList[0].x - _currPoint.x) - Math.abs(touchesList[0].y - _currPoint.y);
                                        // check the direction of movement
                                        if(Math.abs(diff) >= DIRECTION_CHECK_OFFSET) {
                                            _direction = diff > 0 ? 'h' : 'v';
                                            _currentPoints = touchesList;
                                        }
                                    }

                                } else {
                                    _currentPoints = touchesList;
                                }
                            }
                        },
                //
                        _renderMovement =  function() {

                            if(!_currentPoints) {
                                return;
                            }

                            var numPoints = _currentPoints.length;

                            if(numPoints === 0) {
                                return;
                            }

                            _equalizePoints(p, _currentPoints[0]);

                            delta.x = p.x - _currPoint.x;
                            delta.y = p.y - _currPoint.y;

                            if(_isZooming && numPoints > 1) {
                                // Handle behaviour for more than 1 point

                                _currPoint.x = p.x;
                                _currPoint.y = p.y;

                                // check if one of two points changed
                                if( !delta.x && !delta.y && _isEqualPoints(_currentPoints[1], p2) ) {
                                    return;
                                }

                                _equalizePoints(p2, _currentPoints[1]);


                                if(!_zoomStarted) {
                                    _zoomStarted = true;
                                    _shout('zoomGestureStarted');
                                }

                                // Distance between two points
                                var pointsDistance = _calculatePointsDistance(p,p2);

                                var zoomLevel = _calculateZoomLevel(pointsDistance);

                                // slightly over the of initial zoom level
                                if(zoomLevel > self.currItem.initialZoomLevel + self.currItem.initialZoomLevel / 15) {
                                    _wasOverInitialZoom = true;
                                }

                                // Apply the friction if zoom level is out of the bounds
                                var zoomFriction = 1,
                                        minZoomLevel = _getMinZoomLevel(),
                                        maxZoomLevel = _getMaxZoomLevel();

                                if ( zoomLevel < minZoomLevel ) {

                                    if(_options.pinchToClose && !_wasOverInitialZoom && _startZoomLevel <= self.currItem.initialZoomLevel) {
                                        // fade out background if zooming out
                                        var minusDiff = minZoomLevel - zoomLevel;
                                        var percent = 1 - minusDiff / (minZoomLevel / 1.2);

                                        _applyBgOpacity(percent);
                                        _shout('onPinchClose', percent);
                                        _opacityChanged = true;
                                    } else {
                                        zoomFriction = (minZoomLevel - zoomLevel) / minZoomLevel;
                                        if(zoomFriction > 1) {
                                            zoomFriction = 1;
                                        }
                                        zoomLevel = minZoomLevel - zoomFriction * (minZoomLevel / 3);
                                    }

                                } else if ( zoomLevel > maxZoomLevel ) {
                                    // 1.5 - extra zoom level above the max. E.g. if max is x6, real max 6 + 1.5 = 7.5
                                    zoomFriction = (zoomLevel - maxZoomLevel) / ( minZoomLevel * 6 );
                                    if(zoomFriction > 1) {
                                        zoomFriction = 1;
                                    }
                                    zoomLevel = maxZoomLevel + zoomFriction * minZoomLevel;
                                }

                                if(zoomFriction < 0) {
                                    zoomFriction = 0;
                                }

                                // distance between touch points after friction is applied
                                _currPointsDistance = pointsDistance;

                                // _centerPoint - The point in the middle of two pointers
                                _findCenterOfPoints(p, p2, _centerPoint);

                                // paning with two pointers pressed
                                _currPanDist.x += _centerPoint.x - _currCenterPoint.x;
                                _currPanDist.y += _centerPoint.y - _currCenterPoint.y;
                                _equalizePoints(_currCenterPoint, _centerPoint);

                                _panOffset.x = _calculatePanOffset('x', zoomLevel);
                                _panOffset.y = _calculatePanOffset('y', zoomLevel);

                                _isZoomingIn = zoomLevel > _currZoomLevel;
                                _currZoomLevel = zoomLevel;
                                _applyCurrentZoomPan();

                            } else {

                                // handle behaviour for one point (dragging or panning)

                                if(!_direction) {
                                    return;
                                }

                                if(_isFirstMove) {
                                    _isFirstMove = false;

                                    // subtract drag distance that was used during the detection direction

                                    if( Math.abs(delta.x) >= DIRECTION_CHECK_OFFSET) {
                                        delta.x -= _currentPoints[0].x - _startPoint.x;
                                    }

                                    if( Math.abs(delta.y) >= DIRECTION_CHECK_OFFSET) {
                                        delta.y -= _currentPoints[0].y - _startPoint.y;
                                    }
                                }

                                _currPoint.x = p.x;
                                _currPoint.y = p.y;

                                // do nothing if pointers position hasn't changed
                                if(delta.x === 0 && delta.y === 0) {
                                    return;
                                }

                                if(_direction === 'v' && _options.closeOnVerticalDrag) {
                                    if(!_canPan()) {
                                        _currPanDist.y += delta.y;
                                        _panOffset.y += delta.y;

                                        var opacityRatio = _calculateVerticalDragOpacityRatio();

                                        _verticalDragInitiated = true;
                                        _shout('onVerticalDrag', opacityRatio);

                                        _applyBgOpacity(opacityRatio);
                                        _applyCurrentZoomPan();
                                        return ;
                                    }
                                }

                                _pushPosPoint(_getCurrentTime(), p.x, p.y);

                                _moved = true;
                                _currPanBounds = self.currItem.bounds;

                                var mainScrollChanged = _panOrMoveMainScroll('x', delta);
                                if(!mainScrollChanged) {
                                    _panOrMoveMainScroll('y', delta);

                                    _roundPoint(_panOffset);
                                    _applyCurrentZoomPan();
                                }

                            }

                        },

                // Pointerup/pointercancel/touchend/touchcancel/mouseup event handler
                        _onDragRelease = function(e) {

                            if(_features.isOldAndroid ) {

                                if(_oldAndroidTouchEndTimeout && e.type === 'mouseup') {
                                    return;
                                }

                                // on Android (v4.1, 4.2, 4.3 & possibly older)
                                // ghost mousedown/up event isn't preventable via e.preventDefault,
                                // which causes fake mousedown event
                                // so we block mousedown/up for 600ms
                                if( e.type.indexOf('touch') > -1 ) {
                                    clearTimeout(_oldAndroidTouchEndTimeout);
                                    _oldAndroidTouchEndTimeout = setTimeout(function() {
                                        _oldAndroidTouchEndTimeout = 0;
                                    }, 600);
                                }

                            }

                            _shout('pointerUp');

                            if(_preventDefaultEventBehaviour(e, false)) {
                                e.preventDefault();
                            }

                            var releasePoint;

                            if(_pointerEventEnabled) {
                                var pointerIndex = framework.arraySearch(_currPointers, e.pointerId, 'id');

                                if(pointerIndex > -1) {
                                    releasePoint = _currPointers.splice(pointerIndex, 1)[0];

                                    if(navigator.msPointerEnabled) {
                                        var MSPOINTER_TYPES = {
                                            4: 'mouse', // event.MSPOINTER_TYPE_MOUSE
                                            2: 'touch', // event.MSPOINTER_TYPE_TOUCH
                                            3: 'pen' // event.MSPOINTER_TYPE_PEN
                                        };
                                        releasePoint.type = MSPOINTER_TYPES[e.pointerType];

                                        if(!releasePoint.type) {
                                            releasePoint.type = e.pointerType || 'mouse';
                                        }
                                    } else {
                                        releasePoint.type = e.pointerType || 'mouse';
                                    }

                                }
                            }

                            var touchList = _getTouchPoints(e),
                                    gestureType,
                                    numPoints = touchList.length;

                            if(e.type === 'mouseup') {
                                numPoints = 0;
                            }

                            // Do nothing if there were 3 touch points or more
                            if(numPoints === 2) {
                                _currentPoints = null;
                                return true;
                            }

                            // if second pointer released
                            if(numPoints === 1) {
                                _equalizePoints(_startPoint, touchList[0]);
                            }


                            // pointer hasn't moved, send "tap release" point
                            if(numPoints === 0 && !_direction && !_mainScrollAnimating) {
                                if(!releasePoint) {
                                    if(e.type === 'mouseup') {
                                        releasePoint = {x: e.pageX, y: e.pageY, type:'mouse'};
                                    } else if(e.changedTouches && e.changedTouches[0]) {
                                        releasePoint = {x: e.changedTouches[0].pageX, y: e.changedTouches[0].pageY, type:'touch'};
                                    }
                                }

                                _shout('touchRelease', e, releasePoint);
                            }

                            // Difference in time between releasing of two last touch points (zoom gesture)
                            var releaseTimeDiff = -1;

                            // Gesture completed, no pointers left
                            if(numPoints === 0) {
                                _isDragging = false;
                                framework.unbind(window, _upMoveEvents, self);

                                _stopDragUpdateLoop();

                                if(_isZooming) {
                                    // Two points released at the same time
                                    releaseTimeDiff = 0;
                                } else if(_lastReleaseTime !== -1) {
                                    releaseTimeDiff = _getCurrentTime() - _lastReleaseTime;
                                }
                            }
                            _lastReleaseTime = numPoints === 1 ? _getCurrentTime() : -1;

                            if(releaseTimeDiff !== -1 && releaseTimeDiff < 150) {
                                gestureType = 'zoom';
                            } else {
                                gestureType = 'swipe';
                            }

                            if(_isZooming && numPoints < 2) {
                                _isZooming = false;

                                // Only second point released
                                if(numPoints === 1) {
                                    gestureType = 'zoomPointerUp';
                                }
                                _shout('zoomGestureEnded');
                            }

                            _currentPoints = null;
                            if(!_moved && !_zoomStarted && !_mainScrollAnimating && !_verticalDragInitiated) {
                                // nothing to animate
                                return;
                            }

                            _stopAllAnimations();


                            if(!_releaseAnimData) {
                                _releaseAnimData = _initDragReleaseAnimationData();
                            }

                            _releaseAnimData.calculateSwipeSpeed('x');


                            if(_verticalDragInitiated) {

                                var opacityRatio = _calculateVerticalDragOpacityRatio();

                                if(opacityRatio < _options.verticalDragRange) {
                                    self.close();
                                } else {
                                    var initalPanY = _panOffset.y,
                                            initialBgOpacity = _bgOpacity;

                                    _animateProp('verticalDrag', 0, 1, 300, framework.easing.cubic.out, function(now) {

                                        _panOffset.y = (self.currItem.initialPosition.y - initalPanY) * now + initalPanY;

                                        _applyBgOpacity(  (1 - initialBgOpacity) * now + initialBgOpacity );
                                        _applyCurrentZoomPan();
                                    });

                                    _shout('onVerticalDrag', 1);
                                }

                                return;
                            }


                            // main scroll
                            if(  (_mainScrollShifted || _mainScrollAnimating) && numPoints === 0) {
                                var itemChanged = _finishSwipeMainScrollGesture(gestureType, _releaseAnimData);
                                if(itemChanged) {
                                    return;
                                }
                                gestureType = 'zoomPointerUp';
                            }

                            // prevent zoom/pan animation when main scroll animation runs
                            if(_mainScrollAnimating) {
                                return;
                            }

                            // Complete simple zoom gesture (reset zoom level if it's out of the bounds)
                            if(gestureType !== 'swipe') {
                                _completeZoomGesture();
                                return;
                            }

                            // Complete pan gesture if main scroll is not shifted, and it's possible to pan current image
                            if(!_mainScrollShifted && _currZoomLevel > self.currItem.fitRatio) {
                                _completePanGesture(_releaseAnimData);
                            }
                        },


                // Returns object with data about gesture
                // It's created only once and then reused
                        _initDragReleaseAnimationData  = function() {
                            // temp local vars
                            var lastFlickDuration,
                                    tempReleasePos;

                            // s = this
                            var s = {
                                lastFlickOffset: {},
                                lastFlickDist: {},
                                lastFlickSpeed: {},
                                slowDownRatio:  {},
                                slowDownRatioReverse:  {},
                                speedDecelerationRatio:  {},
                                speedDecelerationRatioAbs:  {},
                                distanceOffset:  {},
                                backAnimDestination: {},
                                backAnimStarted: {},
                                calculateSwipeSpeed: function(axis) {


                                    if( _posPoints.length > 1) {
                                        lastFlickDuration = _getCurrentTime() - _gestureCheckSpeedTime + 50;
                                        tempReleasePos = _posPoints[_posPoints.length-2][axis];
                                    } else {
                                        lastFlickDuration = _getCurrentTime() - _gestureStartTime; // total gesture duration
                                        tempReleasePos = _startPoint[axis];
                                    }
                                    s.lastFlickOffset[axis] = _currPoint[axis] - tempReleasePos;
                                    s.lastFlickDist[axis] = Math.abs(s.lastFlickOffset[axis]);
                                    if(s.lastFlickDist[axis] > 20) {
                                        s.lastFlickSpeed[axis] = s.lastFlickOffset[axis] / lastFlickDuration;
                                    } else {
                                        s.lastFlickSpeed[axis] = 0;
                                    }
                                    if( Math.abs(s.lastFlickSpeed[axis]) < 0.1 ) {
                                        s.lastFlickSpeed[axis] = 0;
                                    }

                                    s.slowDownRatio[axis] = 0.95;
                                    s.slowDownRatioReverse[axis] = 1 - s.slowDownRatio[axis];
                                    s.speedDecelerationRatio[axis] = 1;
                                },

                                calculateOverBoundsAnimOffset: function(axis, speed) {
                                    if(!s.backAnimStarted[axis]) {

                                        if(_panOffset[axis] > _currPanBounds.min[axis]) {
                                            s.backAnimDestination[axis] = _currPanBounds.min[axis];

                                        } else if(_panOffset[axis] < _currPanBounds.max[axis]) {
                                            s.backAnimDestination[axis] = _currPanBounds.max[axis];
                                        }

                                        if(s.backAnimDestination[axis] !== undefined) {
                                            s.slowDownRatio[axis] = 0.7;
                                            s.slowDownRatioReverse[axis] = 1 - s.slowDownRatio[axis];
                                            if(s.speedDecelerationRatioAbs[axis] < 0.05) {

                                                s.lastFlickSpeed[axis] = 0;
                                                s.backAnimStarted[axis] = true;

                                                _animateProp('bounceZoomPan'+axis,_panOffset[axis],
                                                        s.backAnimDestination[axis],
                                                        speed || 300,
                                                        framework.easing.sine.out,
                                                        function(pos) {
                                                            _panOffset[axis] = pos;
                                                            _applyCurrentZoomPan();
                                                        }
                                                );

                                            }
                                        }
                                    }
                                },

                                // Reduces the speed by slowDownRatio (per 10ms)
                                calculateAnimOffset: function(axis) {
                                    if(!s.backAnimStarted[axis]) {
                                        s.speedDecelerationRatio[axis] = s.speedDecelerationRatio[axis] * (s.slowDownRatio[axis] +
                                                s.slowDownRatioReverse[axis] -
                                                s.slowDownRatioReverse[axis] * s.timeDiff / 10);

                                        s.speedDecelerationRatioAbs[axis] = Math.abs(s.lastFlickSpeed[axis] * s.speedDecelerationRatio[axis]);
                                        s.distanceOffset[axis] = s.lastFlickSpeed[axis] * s.speedDecelerationRatio[axis] * s.timeDiff;
                                        _panOffset[axis] += s.distanceOffset[axis];

                                    }
                                },

                                panAnimLoop: function() {
                                    if ( _animations.zoomPan ) {
                                        _animations.zoomPan.raf = _requestAF(s.panAnimLoop);

                                        s.now = _getCurrentTime();
                                        s.timeDiff = s.now - s.lastNow;
                                        s.lastNow = s.now;

                                        s.calculateAnimOffset('x');
                                        s.calculateAnimOffset('y');

                                        _applyCurrentZoomPan();

                                        s.calculateOverBoundsAnimOffset('x');
                                        s.calculateOverBoundsAnimOffset('y');


                                        if (s.speedDecelerationRatioAbs.x < 0.05 && s.speedDecelerationRatioAbs.y < 0.05) {

                                            // round pan position
                                            _panOffset.x = Math.round(_panOffset.x);
                                            _panOffset.y = Math.round(_panOffset.y);
                                            _applyCurrentZoomPan();

                                            _stopAnimation('zoomPan');
                                            return;
                                        }
                                    }

                                }
                            };
                            return s;
                        },

                        _completePanGesture = function(animData) {
                            // calculate swipe speed for Y axis (paanning)
                            animData.calculateSwipeSpeed('y');

                            _currPanBounds = self.currItem.bounds;

                            animData.backAnimDestination = {};
                            animData.backAnimStarted = {};

                            // Avoid acceleration animation if speed is too low
                            if(Math.abs(animData.lastFlickSpeed.x) <= 0.05 && Math.abs(animData.lastFlickSpeed.y) <= 0.05 ) {
                                animData.speedDecelerationRatioAbs.x = animData.speedDecelerationRatioAbs.y = 0;

                                // Run pan drag release animation. E.g. if you drag image and release finger without momentum.
                                animData.calculateOverBoundsAnimOffset('x');
                                animData.calculateOverBoundsAnimOffset('y');
                                return true;
                            }

                            // Animation loop that controls the acceleration after pan gesture ends
                            _registerStartAnimation('zoomPan');
                            animData.lastNow = _getCurrentTime();
                            animData.panAnimLoop();
                        },


                        _finishSwipeMainScrollGesture = function(gestureType, _releaseAnimData) {
                            var itemChanged;
                            if(!_mainScrollAnimating) {
                                _currZoomedItemIndex = _currentItemIndex;
                            }



                            var itemsDiff;

                            if(gestureType === 'swipe') {
                                var totalShiftDist = _currPoint.x - _startPoint.x,
                                        isFastLastFlick = _releaseAnimData.lastFlickDist.x < 10;

                                // if container is shifted for more than MIN_SWIPE_DISTANCE,
                                // and last flick gesture was in right direction
                                if(totalShiftDist > MIN_SWIPE_DISTANCE &&
                                        (isFastLastFlick || _releaseAnimData.lastFlickOffset.x > 20) ) {
                                    // go to prev item
                                    itemsDiff = -1;
                                } else if(totalShiftDist < -MIN_SWIPE_DISTANCE &&
                                        (isFastLastFlick || _releaseAnimData.lastFlickOffset.x < -20) ) {
                                    // go to next item
                                    itemsDiff = 1;
                                }
                            }

                            var nextCircle;

                            if(itemsDiff) {

                                _currentItemIndex += itemsDiff;

                                if(_currentItemIndex < 0) {
                                    _currentItemIndex = _options.loop ? _getNumItems()-1 : 0;
                                    nextCircle = true;
                                } else if(_currentItemIndex >= _getNumItems()) {
                                    _currentItemIndex = _options.loop ? 0 : _getNumItems()-1;
                                    nextCircle = true;
                                }

                                if(!nextCircle || _options.loop) {
                                    _indexDiff += itemsDiff;
                                    _currPositionIndex -= itemsDiff;
                                    itemChanged = true;
                                }



                            }

                            var animateToX = _slideSize.x * _currPositionIndex;
                            var animateToDist = Math.abs( animateToX - _mainScrollPos.x );
                            var finishAnimDuration;


                            if(!itemChanged && animateToX > _mainScrollPos.x !== _releaseAnimData.lastFlickSpeed.x > 0) {
                                // "return to current" duration, e.g. when dragging from slide 0 to -1
                                finishAnimDuration = 333;
                            } else {
                                finishAnimDuration = Math.abs(_releaseAnimData.lastFlickSpeed.x) > 0 ?
                                animateToDist / Math.abs(_releaseAnimData.lastFlickSpeed.x) :
                                        333;

                                finishAnimDuration = Math.min(finishAnimDuration, 400);
                                finishAnimDuration = Math.max(finishAnimDuration, 250);
                            }

                            if(_currZoomedItemIndex === _currentItemIndex) {
                                itemChanged = false;
                            }

                            _mainScrollAnimating = true;

                            _shout('mainScrollAnimStart');

                            _animateProp('mainScroll', _mainScrollPos.x, animateToX, finishAnimDuration, framework.easing.cubic.out,
                                    _moveMainScroll,
                                    function() {
                                        _stopAllAnimations();
                                        _mainScrollAnimating = false;
                                        _currZoomedItemIndex = -1;

                                        if(itemChanged || _currZoomedItemIndex !== _currentItemIndex) {
                                            self.updateCurrItem();
                                        }

                                        _shout('mainScrollAnimComplete');
                                    }
                            );

                            if(itemChanged) {
                                self.updateCurrItem(true);
                            }

                            return itemChanged;
                        },

                        _calculateZoomLevel = function(touchesDistance) {
                            return  1 / _startPointsDistance * touchesDistance * _startZoomLevel;
                        },

                // Resets zoom if it's out of bounds
                        _completeZoomGesture = function() {
                            var destZoomLevel = _currZoomLevel,
                                    minZoomLevel = _getMinZoomLevel(),
                                    maxZoomLevel = _getMaxZoomLevel();

                            if ( _currZoomLevel < minZoomLevel ) {
                                destZoomLevel = minZoomLevel;
                            } else if ( _currZoomLevel > maxZoomLevel ) {
                                destZoomLevel = maxZoomLevel;
                            }

                            var destOpacity = 1,
                                    onUpdate,
                                    initialOpacity = _bgOpacity;

                            if(_opacityChanged && !_isZoomingIn && !_wasOverInitialZoom && _currZoomLevel < minZoomLevel) {
                                //_closedByScroll = true;
                                self.close();
                                return true;
                            }

                            if(_opacityChanged) {
                                onUpdate = function(now) {
                                    _applyBgOpacity(  (destOpacity - initialOpacity) * now + initialOpacity );
                                };
                            }

                            self.zoomTo(destZoomLevel, 0, 200,  framework.easing.cubic.out, onUpdate);
                            return true;
                        };


                _registerModule('Gestures', {
                    publicMethods: {

                        initGestures: function() {

                            // helper function that builds touch/pointer/mouse events
                            var addEventNames = function(pref, down, move, up, cancel) {
                                _dragStartEvent = pref + down;
                                _dragMoveEvent = pref + move;
                                _dragEndEvent = pref + up;
                                if(cancel) {
                                    _dragCancelEvent = pref + cancel;
                                } else {
                                    _dragCancelEvent = '';
                                }
                            };

                            _pointerEventEnabled = _features.pointerEvent;
                            if(_pointerEventEnabled && _features.touch) {
                                // we don't need touch events, if browser supports pointer events
                                _features.touch = false;
                            }

                            if(_pointerEventEnabled) {
                                if(navigator.msPointerEnabled) {
                                    // IE10 pointer events are case-sensitive
                                    addEventNames('MSPointer', 'Down', 'Move', 'Up', 'Cancel');
                                } else {
                                    addEventNames('pointer', 'down', 'move', 'up', 'cancel');
                                }
                            } else if(_features.touch) {
                                addEventNames('touch', 'start', 'move', 'end', 'cancel');
                                _likelyTouchDevice = true;
                            } else {
                                addEventNames('mouse', 'down', 'move', 'up');
                            }

                            _upMoveEvents = _dragMoveEvent + ' ' + _dragEndEvent  + ' ' +  _dragCancelEvent;
                            _downEvents = _dragStartEvent;

                            if(_pointerEventEnabled && !_likelyTouchDevice) {
                                _likelyTouchDevice = (navigator.maxTouchPoints > 1) || (navigator.msMaxTouchPoints > 1);
                            }
                            // make variable public
                            self.likelyTouchDevice = _likelyTouchDevice;

                            _globalEventHandlers[_dragStartEvent] = _onDragStart;
                            _globalEventHandlers[_dragMoveEvent] = _onDragMove;
                            _globalEventHandlers[_dragEndEvent] = _onDragRelease; // the Kraken

                            if(_dragCancelEvent) {
                                _globalEventHandlers[_dragCancelEvent] = _globalEventHandlers[_dragEndEvent];
                            }

                            // Bind mouse events on device with detected hardware touch support, in case it supports multiple types of input.
                            if(_features.touch) {
                                _downEvents += ' mousedown';
                                _upMoveEvents += ' mousemove mouseup';
                                _globalEventHandlers.mousedown = _globalEventHandlers[_dragStartEvent];
                                _globalEventHandlers.mousemove = _globalEventHandlers[_dragMoveEvent];
                                _globalEventHandlers.mouseup = _globalEventHandlers[_dragEndEvent];
                            }

                            if(!_likelyTouchDevice) {
                                // don't allow pan to next slide from zoomed state on Desktop
                                _options.allowPanToNext = false;
                            }
                        }

                    }
                });


                /*>>gestures*/

                /*>>show-hide-transition*/
                /**
                 * show-hide-transition.js:
                 *
                 * Manages initial opening or closing transition.
                 *
                 * If you're not planning to use transition for gallery at all,
                 * you may set options hideAnimationDuration and showAnimationDuration to 0,
                 * and just delete startAnimation function.
                 *
                 */


                var _showOrHideTimeout,
                        _showOrHide = function(item, img, out, completeFn) {

                            if(_showOrHideTimeout) {
                                clearTimeout(_showOrHideTimeout);
                            }

                            _initialZoomRunning = true;
                            _initialContentSet = true;

                            // dimensions of small thumbnail {x:,y:,w:}.
                            // Height is optional, as calculated based on large image.
                            var thumbBounds;
                            if(item.initialLayout) {
                                thumbBounds = item.initialLayout;
                                item.initialLayout = null;
                            } else {
                                thumbBounds = _options.getThumbBoundsFn && _options.getThumbBoundsFn(_currentItemIndex);
                            }

                            var duration = out ? _options.hideAnimationDuration : _options.showAnimationDuration;

                            var onComplete = function() {
                                _stopAnimation('initialZoom');
                                if(!out) {
                                    _applyBgOpacity(1);
                                    if(img) {
                                        img.style.display = 'block';
                                    }
                                    framework.addClass(template, 'pswp--animated-in');
                                    _shout('initialZoom' + (out ? 'OutEnd' : 'InEnd'));
                                } else {
                                    self.template.removeAttribute('style');
                                    self.bg.removeAttribute('style');
                                }

                                if(completeFn) {
                                    completeFn();
                                }
                                _initialZoomRunning = false;
                            };

                            // if bounds aren't provided, just open gallery without animation
                            if(!duration || !thumbBounds || thumbBounds.x === undefined) {

                                _shout('initialZoom' + (out ? 'Out' : 'In') );

                                _currZoomLevel = item.initialZoomLevel;
                                _equalizePoints(_panOffset,  item.initialPosition );
                                _applyCurrentZoomPan();

                                template.style.opacity = out ? 0 : 1;
                                _applyBgOpacity(1);

                                if(duration) {
                                    setTimeout(function() {
                                        onComplete();
                                    }, duration);
                                } else {
                                    onComplete();
                                }

                                return;
                            }

                            var startAnimation = function() {
                                var closeWithRaf = _closedByScroll,
                                        fadeEverything = !self.currItem.src || self.currItem.loadError || _options.showHideOpacity;

                                // apply hw-acceleration to image
                                if(item.miniImg) {
                                    item.miniImg.style.webkitBackfaceVisibility = 'hidden';
                                }

                                if(!out) {
                                    _currZoomLevel = thumbBounds.w / item.w;
                                    _panOffset.x = thumbBounds.x;
                                    _panOffset.y = thumbBounds.y - _initalWindowScrollY;

                                    self[fadeEverything ? 'template' : 'bg'].style.opacity = 0.001;
                                    _applyCurrentZoomPan();
                                }

                                _registerStartAnimation('initialZoom');

                                if(out && !closeWithRaf) {
                                    framework.removeClass(template, 'pswp--animated-in');
                                }

                                if(fadeEverything) {
                                    if(out) {
                                        framework[ (closeWithRaf ? 'remove' : 'add') + 'Class' ](template, 'pswp--animate_opacity');
                                    } else {
                                        setTimeout(function() {
                                            framework.addClass(template, 'pswp--animate_opacity');
                                        }, 30);
                                    }
                                }

                                _showOrHideTimeout = setTimeout(function() {

                                    _shout('initialZoom' + (out ? 'Out' : 'In') );


                                    if(!out) {

                                        // "in" animation always uses CSS transitions (instead of rAF).
                                        // CSS transition work faster here,
                                        // as developer may also want to animate other things,
                                        // like ui on top of sliding area, which can be animated just via CSS

                                        _currZoomLevel = item.initialZoomLevel;
                                        _equalizePoints(_panOffset,  item.initialPosition );
                                        _applyCurrentZoomPan();
                                        _applyBgOpacity(1);

                                        if(fadeEverything) {
                                            template.style.opacity = 1;
                                        } else {
                                            _applyBgOpacity(1);
                                        }

                                        _showOrHideTimeout = setTimeout(onComplete, duration + 20);
                                    } else {

                                        // "out" animation uses rAF only when PhotoSwipe is closed by browser scroll, to recalculate position
                                        var destZoomLevel = thumbBounds.w / item.w,
                                                initialPanOffset = {
                                                    x: _panOffset.x,
                                                    y: _panOffset.y
                                                },
                                                initialZoomLevel = _currZoomLevel,
                                                initalBgOpacity = _bgOpacity,
                                                onUpdate = function(now) {

                                                    if(now === 1) {
                                                        _currZoomLevel = destZoomLevel;
                                                        _panOffset.x = thumbBounds.x;
                                                        _panOffset.y = thumbBounds.y  - _currentWindowScrollY;
                                                    } else {
                                                        _currZoomLevel = (destZoomLevel - initialZoomLevel) * now + initialZoomLevel;
                                                        _panOffset.x = (thumbBounds.x - initialPanOffset.x) * now + initialPanOffset.x;
                                                        _panOffset.y = (thumbBounds.y - _currentWindowScrollY - initialPanOffset.y) * now + initialPanOffset.y;
                                                    }

                                                    _applyCurrentZoomPan();
                                                    if(fadeEverything) {
                                                        template.style.opacity = 1 - now;
                                                    } else {
                                                        _applyBgOpacity( initalBgOpacity - now * initalBgOpacity );
                                                    }
                                                };

                                        if(closeWithRaf) {
                                            _animateProp('initialZoom', 0, 1, duration, framework.easing.cubic.out, onUpdate, onComplete);
                                        } else {
                                            onUpdate(1);
                                            _showOrHideTimeout = setTimeout(onComplete, duration + 20);
                                        }
                                    }

                                }, out ? 25 : 90); // Main purpose of this delay is to give browser time to paint and
                                // create composite layers of PhotoSwipe UI parts (background, controls, caption, arrows).
                                // Which avoids lag at the beginning of scale transition.
                            };
                            startAnimation();


                        };

                /*>>show-hide-transition*/

                /*>>items-controller*/
                /**
                 *
                 * Controller manages gallery items, their dimensions, and their content.
                 *
                 */

                var _items,
                        _tempPanAreaSize = {},
                        _imagesToAppendPool = [],
                        _initialContentSet,
                        _initialZoomRunning,
                        _controllerDefaultOptions = {
                            index: 0,
                            errorMsg: '<div class="pswp__error-msg"><a href="%url%" target="_blank">The image</a> could not be loaded.</div>',
                            forceProgressiveLoading: false, // TODO
                            preload: [1,1],
                            getNumItemsFn: function() {
                                return _items.length;
                            }
                        };


                var _getItemAt,
                        _getNumItems,
                        _initialIsLoop,
                        _getZeroBounds = function() {
                            return {
                                center:{x:0,y:0},
                                max:{x:0,y:0},
                                min:{x:0,y:0}
                            };
                        },
                        _calculateSingleItemPanBounds = function(item, realPanElementW, realPanElementH ) {
                            var bounds = item.bounds;

                            // position of element when it's centered
                            bounds.center.x = Math.round((_tempPanAreaSize.x - realPanElementW) / 2);
                            bounds.center.y = Math.round((_tempPanAreaSize.y - realPanElementH) / 2) + item.vGap.top;

                            // maximum pan position
                            bounds.max.x = (realPanElementW > _tempPanAreaSize.x) ?
                                    Math.round(_tempPanAreaSize.x - realPanElementW) :
                                    bounds.center.x;

                            bounds.max.y = (realPanElementH > _tempPanAreaSize.y) ?
                            Math.round(_tempPanAreaSize.y - realPanElementH) + item.vGap.top :
                                    bounds.center.y;

                            // minimum pan position
                            bounds.min.x = (realPanElementW > _tempPanAreaSize.x) ? 0 : bounds.center.x;
                            bounds.min.y = (realPanElementH > _tempPanAreaSize.y) ? item.vGap.top : bounds.center.y;
                        },
                        _calculateItemSize = function(item, viewportSize, zoomLevel) {

                            if (item.src && !item.loadError) {
                                var isInitial = !zoomLevel;

                                if(isInitial) {
                                    if(!item.vGap) {
                                        item.vGap = {top:0,bottom:0};
                                    }
                                    // allows overriding vertical margin for individual items
                                    _shout('parseVerticalMargin', item);
                                }


                                _tempPanAreaSize.x = viewportSize.x;
                                _tempPanAreaSize.y = viewportSize.y - item.vGap.top - item.vGap.bottom;

                                if (isInitial) {
                                    var hRatio = _tempPanAreaSize.x / item.w;
                                    var vRatio = _tempPanAreaSize.y / item.h;

                                    item.fitRatio = hRatio < vRatio ? hRatio : vRatio;
                                    //item.fillRatio = hRatio > vRatio ? hRatio : vRatio;

                                    var scaleMode = _options.scaleMode;

                                    if (scaleMode === 'orig') {
                                        zoomLevel = 1;
                                    } else if (scaleMode === 'fit') {
                                        zoomLevel = item.fitRatio;
                                    }

                                    if (zoomLevel > 1) {
                                        zoomLevel = 1;
                                    }

                                    item.initialZoomLevel = zoomLevel;

                                    if(!item.bounds) {
                                        // reuse bounds object
                                        item.bounds = _getZeroBounds();
                                    }
                                }

                                if(!zoomLevel) {
                                    return;
                                }

                                _calculateSingleItemPanBounds(item, item.w * zoomLevel, item.h * zoomLevel);

                                if (isInitial && zoomLevel === item.initialZoomLevel) {
                                    item.initialPosition = item.bounds.center;
                                }

                                return item.bounds;
                            } else {
                                item.w = item.h = 0;
                                item.initialZoomLevel = item.fitRatio = 1;
                                item.bounds = _getZeroBounds();
                                item.initialPosition = item.bounds.center;

                                // if it's not image, we return zero bounds (content is not zoomable)
                                return item.bounds;
                            }

                        },




                        _appendImage = function(index, item, baseDiv, img, preventAnimation, keepPlaceholder) {


                            if(item.loadError) {
                                return;
                            }

                            if(img) {

                                item.imageAppended = true;
                                _setImageSize(item, img, (item === self.currItem && _renderMaxResolution) );

                                baseDiv.appendChild(img);

                                if(keepPlaceholder) {
                                    setTimeout(function() {
                                        if(item && item.loaded && item.placeholder) {
                                            item.placeholder.style.display = 'none';
                                            item.placeholder = null;
                                        }
                                    }, 500);
                                }
                            }
                        },



                        _preloadImage = function(item) {
                            item.loading = true;
                            item.loaded = false;
                            var img = item.img = framework.createEl('pswp__img', 'img');
                            var onComplete = function() {
                                item.loading = false;
                                item.loaded = true;

                                if(item.loadComplete) {
                                    item.loadComplete(item);
                                } else {
                                    item.img = null; // no need to store image object
                                }
                                img.onload = img.onerror = null;
                                img = null;
                            };
                            img.onload = onComplete;
                            img.onerror = function() {
                                item.loadError = true;
                                onComplete();
                            };

                            img.src = item.src;// + '?a=' + Math.random();

                            return img;
                        },
                        _checkForError = function(item, cleanUp) {
                            if(item.src && item.loadError && item.container) {

                                if(cleanUp) {
                                    item.container.innerHTML = '';
                                }

                                item.container.innerHTML = _options.errorMsg.replace('%url%',  item.src );
                                return true;

                            }
                        },
                        _setImageSize = function(item, img, maxRes) {
                            if(!item.src) {
                                return;
                            }

                            if(!img) {
                                img = item.container.lastChild;
                            }

                            var w = maxRes ? item.w : Math.round(item.w * item.fitRatio),
                                    h = maxRes ? item.h : Math.round(item.h * item.fitRatio);

                            if(item.placeholder && !item.loaded) {
                                item.placeholder.style.width = w + 'px';
                                item.placeholder.style.height = h + 'px';
                            }

                            img.style.width = w + 'px';
                            img.style.height = h + 'px';
                        },
                        _appendImagesPool = function() {

                            if(_imagesToAppendPool.length) {
                                var poolItem;

                                for(var i = 0; i < _imagesToAppendPool.length; i++) {
                                    poolItem = _imagesToAppendPool[i];
                                    if( poolItem.holder.index === poolItem.index ) {
                                        _appendImage(poolItem.index, poolItem.item, poolItem.baseDiv, poolItem.img, false, poolItem.clearPlaceholder);
                                    }
                                }
                                _imagesToAppendPool = [];
                            }
                        };



                _registerModule('Controller', {

                    publicMethods: {

                        lazyLoadItem: function(index) {
                            index = _getLoopedId(index);
                            var item = _getItemAt(index);

                            if(!item || ((item.loaded || item.loading) && !_itemsNeedUpdate)) {
                                return;
                            }

                            _shout('gettingData', index, item);

                            if (!item.src) {
                                return;
                            }

                            _preloadImage(item);
                        },
                        initController: function() {
                            framework.extend(_options, _controllerDefaultOptions, true);
                            self.items = _items = items;
                            _getItemAt = self.getItemAt;
                            _getNumItems = _options.getNumItemsFn; //self.getNumItems;



                            _initialIsLoop = _options.loop;
                            if(_getNumItems() < 3) {
                                _options.loop = false; // disable loop if less then 3 items
                            }

                            _listen('beforeChange', function(diff) {

                                var p = _options.preload,
                                        isNext = diff === null ? true : (diff >= 0),
                                        preloadBefore = Math.min(p[0], _getNumItems() ),
                                        preloadAfter = Math.min(p[1], _getNumItems() ),
                                        i;


                                for(i = 1; i <= (isNext ? preloadAfter : preloadBefore); i++) {
                                    self.lazyLoadItem(_currentItemIndex+i);
                                }
                                for(i = 1; i <= (isNext ? preloadBefore : preloadAfter); i++) {
                                    self.lazyLoadItem(_currentItemIndex-i);
                                }
                            });

                            _listen('initialLayout', function() {
                                self.currItem.initialLayout = _options.getThumbBoundsFn && _options.getThumbBoundsFn(_currentItemIndex);
                            });

                            _listen('mainScrollAnimComplete', _appendImagesPool);
                            _listen('initialZoomInEnd', _appendImagesPool);



                            _listen('destroy', function() {
                                var item;
                                for(var i = 0; i < _items.length; i++) {
                                    item = _items[i];
                                    // remove reference to DOM elements, for GC
                                    if(item.container) {
                                        item.container = null;
                                    }
                                    if(item.placeholder) {
                                        item.placeholder = null;
                                    }
                                    if(item.img) {
                                        item.img = null;
                                    }
                                    if(item.preloader) {
                                        item.preloader = null;
                                    }
                                    if(item.loadError) {
                                        item.loaded = item.loadError = false;
                                    }
                                }
                                _imagesToAppendPool = null;
                            });
                        },


                        getItemAt: function(index) {
                            if (index >= 0) {
                                return _items[index] !== undefined ? _items[index] : false;
                            }
                            return false;
                        },

                        allowProgressiveImg: function() {
                            // 1. Progressive image loading isn't working on webkit/blink
                            //    when hw-acceleration (e.g. translateZ) is applied to IMG element.
                            //    That's why in PhotoSwipe parent element gets zoom transform, not image itself.
                            //
                            // 2. Progressive image loading sometimes blinks in webkit/blink when applying animation to parent element.
                            //    That's why it's disabled on touch devices (mainly because of swipe transition)
                            //
                            // 3. Progressive image loading sometimes doesn't work in IE (up to 11).

                            // Don't allow progressive loading on non-large touch devices
                            return _options.forceProgressiveLoading || !_likelyTouchDevice || _options.mouseUsed || screen.width > 1200;
                            // 1200 - to eliminate touch devices with large screen (like Chromebook Pixel)
                        },

                        setContent: function(holder, index) {

                            if(_options.loop) {
                                index = _getLoopedId(index);
                            }

                            var prevItem = self.getItemAt(holder.index);
                            if(prevItem) {
                                prevItem.container = null;
                            }

                            var item = self.getItemAt(index),
                                    img;

                            if(!item) {
                                holder.el.innerHTML = '';
                                return;
                            }

                            // allow to override data
                            _shout('gettingData', index, item);

                            holder.index = index;
                            holder.item = item;

                            // base container DIV is created only once for each of 3 holders
                            var baseDiv = item.container = framework.createEl('pswp__zoom-wrap');



                            if(!item.src && item.html) {
                                if(item.html.tagName) {
                                    baseDiv.appendChild(item.html);
                                } else {
                                    baseDiv.innerHTML = item.html;
                                }
                            }

                            _checkForError(item);

                            _calculateItemSize(item, _viewportSize);

                            if(item.src && !item.loadError && !item.loaded) {

                                item.loadComplete = function(item) {

                                    // gallery closed before image finished loading
                                    if(!_isOpen) {
                                        return;
                                    }

                                    // check if holder hasn't changed while image was loading
                                    if(holder && holder.index === index ) {
                                        if( _checkForError(item, true) ) {
                                            item.loadComplete = item.img = null;
                                            _calculateItemSize(item, _viewportSize);
                                            _applyZoomPanToItem(item);

                                            if(holder.index === _currentItemIndex) {
                                                // recalculate dimensions
                                                self.updateCurrZoomItem();
                                            }
                                            return;
                                        }
                                        if( !item.imageAppended ) {
                                            if(_features.transform && (_mainScrollAnimating || _initialZoomRunning) ) {
                                                _imagesToAppendPool.push({
                                                    item:item,
                                                    baseDiv:baseDiv,
                                                    img:item.img,
                                                    index:index,
                                                    holder:holder,
                                                    clearPlaceholder:true
                                                });
                                            } else {
                                                _appendImage(index, item, baseDiv, item.img, _mainScrollAnimating || _initialZoomRunning, true);
                                            }
                                        } else {
                                            // remove preloader & mini-img
                                            if(!_initialZoomRunning && item.placeholder) {
                                                item.placeholder.style.display = 'none';
                                                item.placeholder = null;
                                            }
                                        }
                                    }

                                    item.loadComplete = null;
                                    item.img = null; // no need to store image element after it's added

                                    _shout('imageLoadComplete', index, item);
                                };

                                if(framework.features.transform) {

                                    var placeholderClassName = 'pswp__img pswp__img--placeholder';
                                    placeholderClassName += (item.msrc ? '' : ' pswp__img--placeholder--blank');

                                    var placeholder = framework.createEl(placeholderClassName, item.msrc ? 'img' : '');
                                    if(item.msrc) {
                                        placeholder.src = item.msrc;
                                    }

                                    _setImageSize(item, placeholder);

                                    baseDiv.appendChild(placeholder);
                                    item.placeholder = placeholder;

                                }




                                if(!item.loading) {
                                    _preloadImage(item);
                                }


                                if( self.allowProgressiveImg() ) {
                                    // just append image
                                    if(!_initialContentSet && _features.transform) {
                                        _imagesToAppendPool.push({
                                            item:item,
                                            baseDiv:baseDiv,
                                            img:item.img,
                                            index:index,
                                            holder:holder
                                        });
                                    } else {
                                        _appendImage(index, item, baseDiv, item.img, true, true);
                                    }
                                }

                            } else if(item.src && !item.loadError) {
                                // image object is created every time, due to bugs of image loading & delay when switching images
                                img = framework.createEl('pswp__img', 'img');
                                img.style.opacity = 1;
                                img.src = item.src;
                                _setImageSize(item, img);
                                _appendImage(index, item, baseDiv, img, true);
                            }


                            if(!_initialContentSet && index === _currentItemIndex) {
                                _currZoomElementStyle = baseDiv.style;
                                _showOrHide(item, (img ||item.img) );
                            } else {
                                _applyZoomPanToItem(item);
                            }

                            holder.el.innerHTML = '';
                            holder.el.appendChild(baseDiv);
                        },

                        cleanSlide: function( item ) {
                            if(item.img ) {
                                item.img.onload = item.img.onerror = null;
                            }
                            item.loaded = item.loading = item.img = item.imageAppended = false;
                        }

                    }
                });

                /*>>items-controller*/

                /*>>tap*/
                /**
                 * tap.js:
                 *
                 * Displatches tap and double-tap events.
                 *
                 */

                var tapTimer,
                        tapReleasePoint = {},
                        _dispatchTapEvent = function(origEvent, releasePoint, pointerType) {
                            var e = document.createEvent( 'CustomEvent' ),
                                    eDetail = {
                                        origEvent:origEvent,
                                        target:origEvent.target,
                                        releasePoint: releasePoint,
                                        pointerType:pointerType || 'touch'
                                    };

                            e.initCustomEvent( 'pswpTap', true, true, eDetail );
                            origEvent.target.dispatchEvent(e);
                        };

                _registerModule('Tap', {
                    publicMethods: {
                        initTap: function() {
                            _listen('firstTouchStart', self.onTapStart);
                            _listen('touchRelease', self.onTapRelease);
                            _listen('destroy', function() {
                                tapReleasePoint = {};
                                tapTimer = null;
                            });
                        },
                        onTapStart: function(touchList) {
                            if(touchList.length > 1) {
                                clearTimeout(tapTimer);
                                tapTimer = null;
                            }
                        },
                        onTapRelease: function(e, releasePoint) {
                            if(!releasePoint) {
                                return;
                            }

                            if(!_moved && !_isMultitouch && !_numAnimations) {
                                var p0 = releasePoint;
                                if(tapTimer) {
                                    clearTimeout(tapTimer);
                                    tapTimer = null;

                                    // Check if taped on the same place
                                    if ( _isNearbyPoints(p0, tapReleasePoint) ) {
                                        _shout('doubleTap', p0);
                                        return;
                                    }
                                }

                                if(releasePoint.type === 'mouse') {
                                    _dispatchTapEvent(e, releasePoint, 'mouse');
                                    return;
                                }

                                var clickedTagName = e.target.tagName.toUpperCase();
                                // avoid double tap delay on buttons and elements that have class pswp__single-tap
                                if(clickedTagName === 'BUTTON' || framework.hasClass(e.target, 'pswp__single-tap') ) {
                                    _dispatchTapEvent(e, releasePoint);
                                    return;
                                }

                                _equalizePoints(tapReleasePoint, p0);

                                tapTimer = setTimeout(function() {
                                    _dispatchTapEvent(e, releasePoint);
                                    tapTimer = null;
                                }, 300);
                            }
                        }
                    }
                });

                /*>>tap*/

                /*>>desktop-zoom*/
                /**
                 *
                 * desktop-zoom.js:
                 *
                 * - Binds mousewheel event for paning zoomed image.
                 * - Manages "dragging", "zoomed-in", "zoom-out" classes.
                 *   (which are used for cursors and zoom icon)
                 * - Adds toggleDesktopZoom function.
                 *
                 */

                var _wheelDelta;

                _registerModule('DesktopZoom', {

                    publicMethods: {

                        initDesktopZoom: function() {

                            if(_oldIE) {
                                // no zoom for old IE (<=8)
                                return;
                            }

                            if(_likelyTouchDevice) {
                                // if detected hardware touch support, we wait until mouse is used,
                                // and only then apply desktop-zoom features
                                _listen('mouseUsed', function() {
                                    self.setupDesktopZoom();
                                });
                            } else {
                                self.setupDesktopZoom(true);
                            }

                        },

                        setupDesktopZoom: function(onInit) {

                            _wheelDelta = {};

                            var events = 'wheel mousewheel DOMMouseScroll';

                            _listen('bindEvents', function() {
                                framework.bind(template, events,  self.handleMouseWheel);
                            });

                            _listen('unbindEvents', function() {
                                if(_wheelDelta) {
                                    framework.unbind(template, events, self.handleMouseWheel);
                                }
                            });

                            self.mouseZoomedIn = false;

                            var hasDraggingClass,
                                    updateZoomable = function() {
                                        if(self.mouseZoomedIn) {
                                            framework.removeClass(template, 'pswp--zoomed-in');
                                            self.mouseZoomedIn = false;
                                        }
                                        if(_currZoomLevel < 1) {
                                            framework.addClass(template, 'pswp--zoom-allowed');
                                        } else {
                                            framework.removeClass(template, 'pswp--zoom-allowed');
                                        }
                                        removeDraggingClass();
                                    },
                                    removeDraggingClass = function() {
                                        if(hasDraggingClass) {
                                            framework.removeClass(template, 'pswp--dragging');
                                            hasDraggingClass = false;
                                        }
                                    };

                            _listen('resize' , updateZoomable);
                            _listen('afterChange' , updateZoomable);
                            _listen('pointerDown', function() {
                                if(self.mouseZoomedIn) {
                                    hasDraggingClass = true;
                                    framework.addClass(template, 'pswp--dragging');
                                }
                            });
                            _listen('pointerUp', removeDraggingClass);

                            if(!onInit) {
                                updateZoomable();
                            }

                        },

                        handleMouseWheel: function(e) {

                            if(_currZoomLevel <= self.currItem.fitRatio) {
                                if( _options.modal ) {

                                    if (!_options.closeOnScroll || _numAnimations || _isDragging) {
                                        e.preventDefault();
                                    } else if(_transformKey && Math.abs(e.deltaY) > 2) {
                                        // close PhotoSwipe
                                        // if browser supports transforms & scroll changed enough
                                        _closedByScroll = true;
                                        self.close();
                                    }

                                }
                                return true;
                            }

                            // allow just one event to fire
                            e.stopPropagation();

                            // https://developer.mozilla.org/en-US/docs/Web/Events/wheel
                            _wheelDelta.x = 0;

                            if('deltaX' in e) {
                                if(e.deltaMode === 1 /* DOM_DELTA_LINE */) {
                                    // 18 - average line height
                                    _wheelDelta.x = e.deltaX * 18;
                                    _wheelDelta.y = e.deltaY * 18;
                                } else {
                                    _wheelDelta.x = e.deltaX;
                                    _wheelDelta.y = e.deltaY;
                                }
                            } else if('wheelDelta' in e) {
                                if(e.wheelDeltaX) {
                                    _wheelDelta.x = -0.16 * e.wheelDeltaX;
                                }
                                if(e.wheelDeltaY) {
                                    _wheelDelta.y = -0.16 * e.wheelDeltaY;
                                } else {
                                    _wheelDelta.y = -0.16 * e.wheelDelta;
                                }
                            } else if('detail' in e) {
                                _wheelDelta.y = e.detail;
                            } else {
                                return;
                            }

                            _calculatePanBounds(_currZoomLevel, true);

                            var newPanX = _panOffset.x - _wheelDelta.x,
                                    newPanY = _panOffset.y - _wheelDelta.y;

                            // only prevent scrolling in nonmodal mode when not at edges
                            if (_options.modal ||
                                    (
                                            newPanX <= _currPanBounds.min.x && newPanX >= _currPanBounds.max.x &&
                                            newPanY <= _currPanBounds.min.y && newPanY >= _currPanBounds.max.y
                                    ) ) {
                                e.preventDefault();
                            }

                            // TODO: use rAF instead of mousewheel?
                            self.panTo(newPanX, newPanY);
                        },

                        toggleDesktopZoom: function(centerPoint) {
                            centerPoint = centerPoint || {x:_viewportSize.x/2 + _offset.x, y:_viewportSize.y/2 + _offset.y };

                            var doubleTapZoomLevel = _options.getDoubleTapZoom(true, self.currItem);
                            var zoomOut = _currZoomLevel === doubleTapZoomLevel;

                            self.mouseZoomedIn = !zoomOut;

                            self.zoomTo(zoomOut ? self.currItem.initialZoomLevel : doubleTapZoomLevel, centerPoint, 333);
                            framework[ (!zoomOut ? 'add' : 'remove') + 'Class'](template, 'pswp--zoomed-in');
                        }

                    }
                });


                /*>>desktop-zoom*/

                /*>>history*/
                /**
                 *
                 * history.js:
                 *
                 * - Back button to close gallery.
                 *
                 * - Unique URL for each slide: example.com/&pid=1&gid=3
                 *   (where PID is picture index, and GID and gallery index)
                 *
                 * - Switch URL when slides change.
                 *
                 */


                var _historyDefaultOptions = {
                    history: true,
                    galleryUID: 1
                };

                var _historyUpdateTimeout,
                        _hashChangeTimeout,
                        _hashAnimCheckTimeout,
                        _hashChangedByScript,
                        _hashChangedByHistory,
                        _hashReseted,
                        _initialHash,
                        _historyChanged,
                        _closedFromURL,
                        _urlChangedOnce,
                        _windowLoc,

                        _supportsPushState,

                        _getHash = function() {
                            return _windowLoc.hash.substring(1);
                        },
                        _cleanHistoryTimeouts = function() {

                            if(_historyUpdateTimeout) {
                                clearTimeout(_historyUpdateTimeout);
                            }

                            if(_hashAnimCheckTimeout) {
                                clearTimeout(_hashAnimCheckTimeout);
                            }
                        },

                // pid - Picture index
                // gid - Gallery index
                        _parseItemIndexFromURL = function() {
                            var hash = _getHash(),
                                    params = {};

                            if(hash.length < 5) { // pid=1
                                return params;
                            }

                            var i, vars = hash.split('&');
                            for (i = 0; i < vars.length; i++) {
                                if(!vars[i]) {
                                    continue;
                                }
                                var pair = vars[i].split('=');
                                if(pair.length < 2) {
                                    continue;
                                }
                                params[pair[0]] = pair[1];
                            }
                            if(_options.galleryPIDs) {
                                // detect custom pid in hash and search for it among the items collection
                                var searchfor = params.pid;
                                params.pid = 0; // if custom pid cannot be found, fallback to the first item
                                for(i = 0; i < _items.length; i++) {
                                    if(_items[i].pid === searchfor) {
                                        params.pid = i;
                                        break;
                                    }
                                }
                            } else {
                                params.pid = parseInt(params.pid,10)-1;
                            }
                            if( params.pid < 0 ) {
                                params.pid = 0;
                            }
                            return params;
                        },
                        _updateHash = function() {

                            if(_hashAnimCheckTimeout) {
                                clearTimeout(_hashAnimCheckTimeout);
                            }


                            if(_numAnimations || _isDragging) {
                                // changing browser URL forces layout/paint in some browsers, which causes noticable lag during animation
                                // that's why we update hash only when no animations running
                                _hashAnimCheckTimeout = setTimeout(_updateHash, 500);
                                return;
                            }

                            if(_hashChangedByScript) {
                                clearTimeout(_hashChangeTimeout);
                            } else {
                                _hashChangedByScript = true;
                            }


                            var pid = (_currentItemIndex + 1);
                            var item = _getItemAt( _currentItemIndex );
                            if(item.hasOwnProperty('pid')) {
                                // carry forward any custom pid assigned to the item
                                pid = item.pid;
                            }
                            var newHash = _initialHash + '&'  +  'gid=' + _options.galleryUID + '&' + 'pid=' + pid;

                            if(!_historyChanged) {
                                if(_windowLoc.hash.indexOf(newHash) === -1) {
                                    _urlChangedOnce = true;
                                }
                                // first time - add new hisory record, then just replace
                            }

                            var newURL = _windowLoc.href.split('#')[0] + '#' +  newHash;

                            if( _supportsPushState ) {

                                if('#' + newHash !== window.location.hash) {
                                    history[_historyChanged ? 'replaceState' : 'pushState']('', document.title, newURL);
                                }

                            } else {
                                if(_historyChanged) {
                                    _windowLoc.replace( newURL );
                                } else {
                                    _windowLoc.hash = newHash;
                                }
                            }



                            _historyChanged = true;
                            _hashChangeTimeout = setTimeout(function() {
                                _hashChangedByScript = false;
                            }, 60);
                        };





                _registerModule('History', {



                    publicMethods: {
                        initHistory: function() {

                            framework.extend(_options, _historyDefaultOptions, true);

                            if( !_options.history ) {
                                return;
                            }


                            _windowLoc = window.location;
                            _urlChangedOnce = false;
                            _closedFromURL = false;
                            _historyChanged = false;
                            _initialHash = _getHash();
                            _supportsPushState = ('pushState' in history);


                            if(_initialHash.indexOf('gid=') > -1) {
                                _initialHash = _initialHash.split('&gid=')[0];
                                _initialHash = _initialHash.split('?gid=')[0];
                            }


                            _listen('afterChange', self.updateURL);
                            _listen('unbindEvents', function() {
                                framework.unbind(window, 'hashchange', self.onHashChange);
                            });


                            var returnToOriginal = function() {
                                _hashReseted = true;
                                if(!_closedFromURL) {

                                    if(_urlChangedOnce) {
                                        history.back();
                                    } else {

                                        if(_initialHash) {
                                            _windowLoc.hash = _initialHash;
                                        } else {
                                            if (_supportsPushState) {

                                                // remove hash from url without refreshing it or scrolling to top
                                                history.pushState('', document.title,  _windowLoc.pathname + _windowLoc.search );
                                            } else {
                                                _windowLoc.hash = '';
                                            }
                                        }
                                    }

                                }

                                _cleanHistoryTimeouts();
                            };


                            _listen('unbindEvents', function() {
                                if(_closedByScroll) {
                                    // if PhotoSwipe is closed by scroll, we go "back" before the closing animation starts
                                    // this is done to keep the scroll position
                                    returnToOriginal();
                                }
                            });
                            _listen('destroy', function() {
                                if(!_hashReseted) {
                                    returnToOriginal();
                                }
                            });
                            _listen('firstUpdate', function() {
                                _currentItemIndex = _parseItemIndexFromURL().pid;
                            });




                            var index = _initialHash.indexOf('pid=');
                            if(index > -1) {
                                _initialHash = _initialHash.substring(0, index);
                                if(_initialHash.slice(-1) === '&') {
                                    _initialHash = _initialHash.slice(0, -1);
                                }
                            }


                            setTimeout(function() {
                                if(_isOpen) { // hasn't destroyed yet
                                    framework.bind(window, 'hashchange', self.onHashChange);
                                }
                            }, 40);

                        },
                        onHashChange: function() {

                            if(_getHash() === _initialHash) {

                                _closedFromURL = true;
                                self.close();
                                return;
                            }
                            if(!_hashChangedByScript) {

                                _hashChangedByHistory = true;
                                self.goTo( _parseItemIndexFromURL().pid );
                                _hashChangedByHistory = false;
                            }

                        },
                        updateURL: function() {

                            // Delay the update of URL, to avoid lag during transition,
                            // and to not to trigger actions like "refresh page sound" or "blinking favicon" to often

                            _cleanHistoryTimeouts();


                            if(_hashChangedByHistory) {
                                return;
                            }

                            if(!_historyChanged) {
                                _updateHash(); // first time
                            } else {
                                _historyUpdateTimeout = setTimeout(_updateHash, 800);
                            }
                        }

                    }
                });


                /*>>history*/
                framework.extend(self, publicMethods); };
            return PhotoSwipe;
        });

        /***/ }),
    /* 15 */
    /***/ (function(module, exports, __webpack_require__) {

        var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! PhotoSwipe Default UI - 4.1.3 - 2019-01-08
         * http://photoswipe.com
         * Copyright (c) 2019 Dmitry Semenov; */
        /**
         *
         * UI on top of main sliding area (caption, arrows, close button, etc.).
         * Built just using public methods/properties of PhotoSwipe.
         *
         */
        (function (root, factory) {
            if (true) {
                !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
                        __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
                                (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
                                __WEBPACK_AMD_DEFINE_FACTORY__),
                __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
            } else {}
        })(this, function () {

            'use strict';



            var PhotoSwipeUI_Default =
                    function(pswp, framework) {

                        var ui = this;
                        var _overlayUIUpdated = false,
                                _controlsVisible = true,
                                _fullscrenAPI,
                                _controls,
                                _captionContainer,
                                _fakeCaptionContainer,
                                _indexIndicator,
                                _shareButton,
                                _shareModal,
                                _shareModalHidden = true,
                                _initalCloseOnScrollValue,
                                _isIdle,
                                _listen,

                                _loadingIndicator,
                                _loadingIndicatorHidden,
                                _loadingIndicatorTimeout,

                                _galleryHasOneSlide,

                                _options,
                                _defaultUIOptions = {
                                    barsSize: {top:44, bottom:'auto'},
                                    closeElClasses: ['item', 'caption', 'zoom-wrap', 'ui', 'top-bar'],
                                    timeToIdle: 4000,
                                    timeToIdleOutside: 1000,
                                    loadingIndicatorDelay: 1000, // 2s

                                    addCaptionHTMLFn: function(item, captionEl /*, isFake */) {
                                        if(!item.title) {
                                            captionEl.children[0].innerHTML = '';
                                            return false;
                                        }
                                        captionEl.children[0].innerHTML = item.title;
                                        return true;
                                    },

                                    closeEl:true,
                                    captionEl: true,
                                    fullscreenEl: true,
                                    zoomEl: true,
                                    shareEl: true,
                                    counterEl: true,
                                    arrowEl: true,
                                    preloaderEl: true,

                                    tapToClose: false,
                                    tapToToggleControls: true,

                                    clickToCloseNonZoomable: true,

                                    shareButtons: [
                                        {id:'facebook', label:'Share on Facebook', url:'https://www.facebook.com/sharer/sharer.php?u='},
                                        {id:'twitter', label:'Tweet', url:'https://twitter.com/intent/tweet?text=&url='},
                                        {id:'pinterest', label:'Pin it', url:'http://www.pinterest.com/pin/create/button/'+
                                        '?url=&media=&description='},
                                        {id:'download', label:'Download image', url:'', download:true}
                                    ],
                                    getImageURLForShare: function( /* shareButtonData */ ) {
                                        return pswp.currItem.src || '';
                                    },
                                    getPageURLForShare: function( /* shareButtonData */ ) {
                                        return window.location.href;
                                    },
                                    getTextForShare: function( /* shareButtonData */ ) {
                                        return pswp.currItem.title || '';
                                    },

                                    indexIndicatorSep: ' / ',
                                    fitControlsWidth: 1200

                                },
                                _blockControlsTap,
                                _blockControlsTapTimeout;



                        var _onControlsTap = function(e) {
                                    if(_blockControlsTap) {
                                        return true;
                                    }


                                    e = e || window.event;

                                    if(_options.timeToIdle && _options.mouseUsed && !_isIdle) {
                                        // reset idle timer
                                        _onIdleMouseMove();
                                    }


                                    var target = e.target || e.srcElement,
                                            uiElement,
                                            clickedClass = target.getAttribute('class') || '',
                                            found;

                                    for(var i = 0; i < _uiElements.length; i++) {
                                        uiElement = _uiElements[i];
                                        if(uiElement.onTap && clickedClass.indexOf('pswp__' + uiElement.name ) > -1 ) {
                                            uiElement.onTap();
                                            found = true;

                                        }
                                    }

                                    if(found) {
                                        if(e.stopPropagation) {
                                            e.stopPropagation();
                                        }
                                        _blockControlsTap = true;

                                        // Some versions of Android don't prevent ghost click event
                                        // when preventDefault() was called on touchstart and/or touchend.
                                        //
                                        // This happens on v4.3, 4.2, 4.1,
                                        // older versions strangely work correctly,
                                        // but just in case we add delay on all of them)
                                        var tapDelay = framework.features.isOldAndroid ? 600 : 30;
                                        _blockControlsTapTimeout = setTimeout(function() {
                                            _blockControlsTap = false;
                                        }, tapDelay);
                                    }

                                },
                                _fitControlsInViewport = function() {
                                    return !pswp.likelyTouchDevice || _options.mouseUsed || screen.width > _options.fitControlsWidth;
                                },
                                _togglePswpClass = function(el, cName, add) {
                                    framework[ (add ? 'add' : 'remove') + 'Class' ](el, 'pswp__' + cName);
                                },

                        // add class when there is just one item in the gallery
                        // (by default it hides left/right arrows and 1ofX counter)
                                _countNumItems = function() {
                                    var hasOneSlide = (_options.getNumItemsFn() === 1);

                                    if(hasOneSlide !== _galleryHasOneSlide) {
                                        _togglePswpClass(_controls, 'ui--one-slide', hasOneSlide);
                                        _galleryHasOneSlide = hasOneSlide;
                                    }
                                },
                                _toggleShareModalClass = function() {
                                    _togglePswpClass(_shareModal, 'share-modal--hidden', _shareModalHidden);
                                },
                                _toggleShareModal = function() {

                                    _shareModalHidden = !_shareModalHidden;


                                    if(!_shareModalHidden) {
                                        _toggleShareModalClass();
                                        setTimeout(function() {
                                            if(!_shareModalHidden) {
                                                framework.addClass(_shareModal, 'pswp__share-modal--fade-in');
                                            }
                                        }, 30);
                                    } else {
                                        framework.removeClass(_shareModal, 'pswp__share-modal--fade-in');
                                        setTimeout(function() {
                                            if(_shareModalHidden) {
                                                _toggleShareModalClass();
                                            }
                                        }, 300);
                                    }

                                    if(!_shareModalHidden) {
                                        _updateShareURLs();
                                    }
                                    return false;
                                },

                                _openWindowPopup = function(e) {
                                    e = e || window.event;
                                    var target = e.target || e.srcElement;

                                    pswp.shout('shareLinkClick', e, target);

                                    if(!target.href) {
                                        return false;
                                    }

                                    if( target.hasAttribute('download') ) {
                                        return true;
                                    }

                                    window.open(target.href, 'pswp_share', 'scrollbars=yes,resizable=yes,toolbar=no,'+
                                            'location=yes,width=550,height=420,top=100,left=' +
                                            (window.screen ? Math.round(screen.width / 2 - 275) : 100)  );

                                    if(!_shareModalHidden) {
                                        _toggleShareModal();
                                    }

                                    return false;
                                },
                                _updateShareURLs = function() {
                                    var shareButtonOut = '',
                                            shareButtonData,
                                            shareURL,
                                            image_url,
                                            page_url,
                                            share_text;

                                    for(var i = 0; i < _options.shareButtons.length; i++) {
                                        shareButtonData = _options.shareButtons[i];

                                        image_url = _options.getImageURLForShare(shareButtonData);
                                        page_url = _options.getPageURLForShare(shareButtonData);
                                        share_text = _options.getTextForShare(shareButtonData);

                                        shareURL = shareButtonData.url.replace('', encodeURIComponent(page_url) )
                                                .replace('', encodeURIComponent(image_url) )
                                                .replace('', image_url )
                                                .replace('', encodeURIComponent(share_text) );

                                        shareButtonOut += '<a href="' + shareURL + '" target="_blank" '+
                                                'class="pswp__share--' + shareButtonData.id + '"' +
                                                (shareButtonData.download ? 'download' : '') + '>' +
                                                shareButtonData.label + '</a>';

                                        if(_options.parseShareButtonOut) {
                                            shareButtonOut = _options.parseShareButtonOut(shareButtonData, shareButtonOut);
                                        }
                                    }
                                    _shareModal.children[0].innerHTML = shareButtonOut;
                                    _shareModal.children[0].onclick = _openWindowPopup;

                                },
                                _hasCloseClass = function(target) {
                                    for(var  i = 0; i < _options.closeElClasses.length; i++) {
                                        if( framework.hasClass(target, 'pswp__' + _options.closeElClasses[i]) ) {
                                            return true;
                                        }
                                    }
                                },
                                _idleInterval,
                                _idleTimer,
                                _idleIncrement = 0,
                                _onIdleMouseMove = function() {
                                    clearTimeout(_idleTimer);
                                    _idleIncrement = 0;
                                    if(_isIdle) {
                                        ui.setIdle(false);
                                    }
                                },
                                _onMouseLeaveWindow = function(e) {
                                    e = e ? e : window.event;
                                    var from = e.relatedTarget || e.toElement;
                                    if (!from || from.nodeName === 'HTML') {
                                        clearTimeout(_idleTimer);
                                        _idleTimer = setTimeout(function() {
                                            ui.setIdle(true);
                                        }, _options.timeToIdleOutside);
                                    }
                                },
                                _setupFullscreenAPI = function() {
                                    if(_options.fullscreenEl && !framework.features.isOldAndroid) {
                                        if(!_fullscrenAPI) {
                                            _fullscrenAPI = ui.getFullscreenAPI();
                                        }
                                        if(_fullscrenAPI) {
                                            framework.bind(document, _fullscrenAPI.eventK, ui.updateFullscreen);
                                            ui.updateFullscreen();
                                            framework.addClass(pswp.template, 'pswp--supports-fs');
                                        } else {
                                            framework.removeClass(pswp.template, 'pswp--supports-fs');
                                        }
                                    }
                                },
                                _setupLoadingIndicator = function() {
                                    // Setup loading indicator
                                    if(_options.preloaderEl) {

                                        _toggleLoadingIndicator(true);

                                        _listen('beforeChange', function() {

                                            clearTimeout(_loadingIndicatorTimeout);

                                            // display loading indicator with delay
                                            _loadingIndicatorTimeout = setTimeout(function() {

                                                if(pswp.currItem && pswp.currItem.loading) {

                                                    if( !pswp.allowProgressiveImg() || (pswp.currItem.img && !pswp.currItem.img.naturalWidth)  ) {
                                                        // show preloader if progressive loading is not enabled,
                                                        // or image width is not defined yet (because of slow connection)
                                                        _toggleLoadingIndicator(false);
                                                        // items-controller.js function allowProgressiveImg
                                                    }

                                                } else {
                                                    _toggleLoadingIndicator(true); // hide preloader
                                                }

                                            }, _options.loadingIndicatorDelay);

                                        });
                                        _listen('imageLoadComplete', function(index, item) {
                                            if(pswp.currItem === item) {
                                                _toggleLoadingIndicator(true);
                                            }
                                        });

                                    }
                                },
                                _toggleLoadingIndicator = function(hide) {
                                    if( _loadingIndicatorHidden !== hide ) {
                                        _togglePswpClass(_loadingIndicator, 'preloader--active', !hide);
                                        _loadingIndicatorHidden = hide;
                                    }
                                },
                                _applyNavBarGaps = function(item) {
                                    var gap = item.vGap;

                                    if( _fitControlsInViewport() ) {

                                        var bars = _options.barsSize;
                                        if(_options.captionEl && bars.bottom === 'auto') {
                                            if(!_fakeCaptionContainer) {
                                                _fakeCaptionContainer = framework.createEl('pswp__caption pswp__caption--fake');
                                                _fakeCaptionContainer.appendChild( framework.createEl('pswp__caption__center') );
                                                _controls.insertBefore(_fakeCaptionContainer, _captionContainer);
                                                framework.addClass(_controls, 'pswp__ui--fit');
                                            }
                                            if( _options.addCaptionHTMLFn(item, _fakeCaptionContainer, true) ) {

                                                var captionSize = _fakeCaptionContainer.clientHeight;
                                                gap.bottom = parseInt(captionSize,10) || 44;
                                            } else {
                                                gap.bottom = bars.top; // if no caption, set size of bottom gap to size of top
                                            }
                                        } else {
                                            gap.bottom = bars.bottom === 'auto' ? 0 : bars.bottom;
                                        }

                                        // height of top bar is static, no need to calculate it
                                        gap.top = bars.top;
                                    } else {
                                        gap.top = gap.bottom = 0;
                                    }
                                },
                                _setupIdle = function() {
                                    // Hide controls when mouse is used
                                    if(_options.timeToIdle) {
                                        _listen('mouseUsed', function() {

                                            framework.bind(document, 'mousemove', _onIdleMouseMove);
                                            framework.bind(document, 'mouseout', _onMouseLeaveWindow);

                                            _idleInterval = setInterval(function() {
                                                _idleIncrement++;
                                                if(_idleIncrement === 2) {
                                                    ui.setIdle(true);
                                                }
                                            }, _options.timeToIdle / 2);
                                        });
                                    }
                                },
                                _setupHidingControlsDuringGestures = function() {

                                    // Hide controls on vertical drag
                                    _listen('onVerticalDrag', function(now) {
                                        if(_controlsVisible && now < 0.95) {
                                            ui.hideControls();
                                        } else if(!_controlsVisible && now >= 0.95) {
                                            ui.showControls();
                                        }
                                    });

                                    // Hide controls when pinching to close
                                    var pinchControlsHidden;
                                    _listen('onPinchClose' , function(now) {
                                        if(_controlsVisible && now < 0.9) {
                                            ui.hideControls();
                                            pinchControlsHidden = true;
                                        } else if(pinchControlsHidden && !_controlsVisible && now > 0.9) {
                                            ui.showControls();
                                        }
                                    });

                                    _listen('zoomGestureEnded', function() {
                                        pinchControlsHidden = false;
                                        if(pinchControlsHidden && !_controlsVisible) {
                                            ui.showControls();
                                        }
                                    });

                                };



                        var _uiElements = [
                            {
                                name: 'caption',
                                option: 'captionEl',
                                onInit: function(el) {
                                    _captionContainer = el;
                                }
                            },
                            {
                                name: 'share-modal',
                                option: 'shareEl',
                                onInit: function(el) {
                                    _shareModal = el;
                                },
                                onTap: function() {
                                    _toggleShareModal();
                                }
                            },
                            {
                                name: 'button--share',
                                option: 'shareEl',
                                onInit: function(el) {
                                    _shareButton = el;
                                },
                                onTap: function() {
                                    _toggleShareModal();
                                }
                            },
                            {
                                name: 'button--zoom',
                                option: 'zoomEl',
                                onTap: pswp.toggleDesktopZoom
                            },
                            {
                                name: 'counter',
                                option: 'counterEl',
                                onInit: function(el) {
                                    _indexIndicator = el;
                                }
                            },
                            {
                                name: 'button--close',
                                option: 'closeEl',
                                onTap: pswp.close
                            },
                            {
                                name: 'button--arrow--left',
                                option: 'arrowEl',
                                onTap: pswp.prev
                            },
                            {
                                name: 'button--arrow--right',
                                option: 'arrowEl',
                                onTap: pswp.next
                            },
                            {
                                name: 'button--fs',
                                option: 'fullscreenEl',
                                onTap: function() {
                                    if(_fullscrenAPI.isFullscreen()) {
                                        _fullscrenAPI.exit();
                                    } else {
                                        _fullscrenAPI.enter();
                                    }
                                }
                            },
                            {
                                name: 'preloader',
                                option: 'preloaderEl',
                                onInit: function(el) {
                                    _loadingIndicator = el;
                                }
                            }

                        ];

                        var _setupUIElements = function() {
                            var item,
                                    classAttr,
                                    uiElement;

                            var loopThroughChildElements = function(sChildren) {
                                if(!sChildren) {
                                    return;
                                }

                                var l = sChildren.length;
                                for(var i = 0; i < l; i++) {
                                    item = sChildren[i];
                                    classAttr = item.className;

                                    for(var a = 0; a < _uiElements.length; a++) {
                                        uiElement = _uiElements[a];

                                        if(classAttr.indexOf('pswp__' + uiElement.name) > -1  ) {

                                            if( _options[uiElement.option] ) { // if element is not disabled from options

                                                framework.removeClass(item, 'pswp__element--disabled');
                                                if(uiElement.onInit) {
                                                    uiElement.onInit(item);
                                                }

                                                //item.style.display = 'block';
                                            } else {
                                                framework.addClass(item, 'pswp__element--disabled');
                                                //item.style.display = 'none';
                                            }
                                        }
                                    }
                                }
                            };
                            loopThroughChildElements(_controls.children);

                            var topBar =  framework.getChildByClass(_controls, 'pswp__top-bar');
                            if(topBar) {
                                loopThroughChildElements( topBar.children );
                            }
                        };




                        ui.init = function() {

                            // extend options
                            framework.extend(pswp.options, _defaultUIOptions, true);

                            // create local link for fast access
                            _options = pswp.options;

                            // find pswp__ui element
                            _controls = framework.getChildByClass(pswp.scrollWrap, 'pswp__ui');

                            // create local link
                            _listen = pswp.listen;


                            _setupHidingControlsDuringGestures();

                            // update controls when slides change
                            _listen('beforeChange', ui.update);

                            // toggle zoom on double-tap
                            _listen('doubleTap', function(point) {
                                var initialZoomLevel = pswp.currItem.initialZoomLevel;
                                if(pswp.getZoomLevel() !== initialZoomLevel) {
                                    pswp.zoomTo(initialZoomLevel, point, 333);
                                } else {
                                    pswp.zoomTo(_options.getDoubleTapZoom(false, pswp.currItem), point, 333);
                                }
                            });

                            // Allow text selection in caption
                            _listen('preventDragEvent', function(e, isDown, preventObj) {
                                var t = e.target || e.srcElement;
                                if(
                                        t &&
                                        t.getAttribute('class') && e.type.indexOf('mouse') > -1 &&
                                        ( t.getAttribute('class').indexOf('__caption') > 0 || (/(SMALL|STRONG|EM)/i).test(t.tagName) )
                                ) {
                                    preventObj.prevent = false;
                                }
                            });

                            // bind events for UI
                            _listen('bindEvents', function() {
                                framework.bind(_controls, 'pswpTap click', _onControlsTap);
                                framework.bind(pswp.scrollWrap, 'pswpTap', ui.onGlobalTap);

                                if(!pswp.likelyTouchDevice) {
                                    framework.bind(pswp.scrollWrap, 'mouseover', ui.onMouseOver);
                                }
                            });

                            // unbind events for UI
                            _listen('unbindEvents', function() {
                                if(!_shareModalHidden) {
                                    _toggleShareModal();
                                }

                                if(_idleInterval) {
                                    clearInterval(_idleInterval);
                                }
                                framework.unbind(document, 'mouseout', _onMouseLeaveWindow);
                                framework.unbind(document, 'mousemove', _onIdleMouseMove);
                                framework.unbind(_controls, 'pswpTap click', _onControlsTap);
                                framework.unbind(pswp.scrollWrap, 'pswpTap', ui.onGlobalTap);
                                framework.unbind(pswp.scrollWrap, 'mouseover', ui.onMouseOver);

                                if(_fullscrenAPI) {
                                    framework.unbind(document, _fullscrenAPI.eventK, ui.updateFullscreen);
                                    if(_fullscrenAPI.isFullscreen()) {
                                        _options.hideAnimationDuration = 0;
                                        _fullscrenAPI.exit();
                                    }
                                    _fullscrenAPI = null;
                                }
                            });


                            // clean up things when gallery is destroyed
                            _listen('destroy', function() {
                                if(_options.captionEl) {
                                    if(_fakeCaptionContainer) {
                                        _controls.removeChild(_fakeCaptionContainer);
                                    }
                                    framework.removeClass(_captionContainer, 'pswp__caption--empty');
                                }

                                if(_shareModal) {
                                    _shareModal.children[0].onclick = null;
                                }
                                framework.removeClass(_controls, 'pswp__ui--over-close');
                                framework.addClass( _controls, 'pswp__ui--hidden');
                                ui.setIdle(false);
                            });


                            if(!_options.showAnimationDuration) {
                                framework.removeClass( _controls, 'pswp__ui--hidden');
                            }
                            _listen('initialZoomIn', function() {
                                if(_options.showAnimationDuration) {
                                    framework.removeClass( _controls, 'pswp__ui--hidden');
                                }
                            });
                            _listen('initialZoomOut', function() {
                                framework.addClass( _controls, 'pswp__ui--hidden');
                            });

                            _listen('parseVerticalMargin', _applyNavBarGaps);

                            _setupUIElements();

                            if(_options.shareEl && _shareButton && _shareModal) {
                                _shareModalHidden = true;
                            }

                            _countNumItems();

                            _setupIdle();

                            _setupFullscreenAPI();

                            _setupLoadingIndicator();
                        };

                        ui.setIdle = function(isIdle) {
                            _isIdle = isIdle;
                            _togglePswpClass(_controls, 'ui--idle', isIdle);
                        };

                        ui.update = function() {
                            // Don't update UI if it's hidden
                            if(_controlsVisible && pswp.currItem) {

                                ui.updateIndexIndicator();

                                if(_options.captionEl) {
                                    _options.addCaptionHTMLFn(pswp.currItem, _captionContainer);

                                    _togglePswpClass(_captionContainer, 'caption--empty', !pswp.currItem.title);
                                }

                                _overlayUIUpdated = true;

                            } else {
                                _overlayUIUpdated = false;
                            }

                            if(!_shareModalHidden) {
                                _toggleShareModal();
                            }

                            _countNumItems();
                        };

                        ui.updateFullscreen = function(e) {

                            if(e) {
                                // some browsers change window scroll position during the fullscreen
                                // so PhotoSwipe updates it just in case
                                setTimeout(function() {
                                    pswp.setScrollOffset( 0, framework.getScrollY() );
                                }, 50);
                            }

                            // toogle pswp--fs class on root element
                            framework[ (_fullscrenAPI.isFullscreen() ? 'add' : 'remove') + 'Class' ](pswp.template, 'pswp--fs');
                        };

                        ui.updateIndexIndicator = function() {
                            if(_options.counterEl) {
                                _indexIndicator.innerHTML = (pswp.getCurrentIndex()+1) +
                                        _options.indexIndicatorSep +
                                        _options.getNumItemsFn();
                            }
                        };

                        ui.onGlobalTap = function(e) {
                            e = e || window.event;
                            var target = e.target || e.srcElement;

                            if(_blockControlsTap) {
                                return;
                            }

                            if(e.detail && e.detail.pointerType === 'mouse') {

                                // close gallery if clicked outside of the image
                                if(_hasCloseClass(target)) {
                                    pswp.close();
                                    return;
                                }

                                if(framework.hasClass(target, 'pswp__img')) {
                                    if(pswp.getZoomLevel() === 1 && pswp.getZoomLevel() <= pswp.currItem.fitRatio) {
                                        if(_options.clickToCloseNonZoomable) {
                                            pswp.close();
                                        }
                                    } else {
                                        pswp.toggleDesktopZoom(e.detail.releasePoint);
                                    }
                                }

                            } else {

                                // tap anywhere (except buttons) to toggle visibility of controls
                                if(_options.tapToToggleControls) {
                                    if(_controlsVisible) {
                                        ui.hideControls();
                                    } else {
                                        ui.showControls();
                                    }
                                }

                                // tap to close gallery
                                if(_options.tapToClose && (framework.hasClass(target, 'pswp__img') || _hasCloseClass(target)) ) {
                                    pswp.close();
                                    return;
                                }

                            }
                        };
                        ui.onMouseOver = function(e) {
                            e = e || window.event;
                            var target = e.target || e.srcElement;

                            // add class when mouse is over an element that should close the gallery
                            _togglePswpClass(_controls, 'ui--over-close', _hasCloseClass(target));
                        };

                        ui.hideControls = function() {
                            framework.addClass(_controls,'pswp__ui--hidden');
                            _controlsVisible = false;
                        };

                        ui.showControls = function() {
                            _controlsVisible = true;
                            if(!_overlayUIUpdated) {
                                ui.update();
                            }
                            framework.removeClass(_controls,'pswp__ui--hidden');
                        };

                        ui.supportsFullscreen = function() {
                            var d = document;
                            return !!(d.exitFullscreen || d.mozCancelFullScreen || d.webkitExitFullscreen || d.msExitFullscreen);
                        };

                        ui.getFullscreenAPI = function() {
                            var dE = document.documentElement,
                                    api,
                                    tF = 'fullscreenchange';

                            if (dE.requestFullscreen) {
                                api = {
                                    enterK: 'requestFullscreen',
                                    exitK: 'exitFullscreen',
                                    elementK: 'fullscreenElement',
                                    eventK: tF
                                };

                            } else if(dE.mozRequestFullScreen ) {
                                api = {
                                    enterK: 'mozRequestFullScreen',
                                    exitK: 'mozCancelFullScreen',
                                    elementK: 'mozFullScreenElement',
                                    eventK: 'moz' + tF
                                };



                            } else if(dE.webkitRequestFullscreen) {
                                api = {
                                    enterK: 'webkitRequestFullscreen',
                                    exitK: 'webkitExitFullscreen',
                                    elementK: 'webkitFullscreenElement',
                                    eventK: 'webkit' + tF
                                };

                            } else if(dE.msRequestFullscreen) {
                                api = {
                                    enterK: 'msRequestFullscreen',
                                    exitK: 'msExitFullscreen',
                                    elementK: 'msFullscreenElement',
                                    eventK: 'MSFullscreenChange'
                                };
                            }

                            if(api) {
                                api.enter = function() {
                                    // disable close-on-scroll in fullscreen
                                    _initalCloseOnScrollValue = _options.closeOnScroll;
                                    _options.closeOnScroll = false;

                                    if(this.enterK === 'webkitRequestFullscreen') {
                                        pswp.template[this.enterK]( Element.ALLOW_KEYBOARD_INPUT );
                                    } else {
                                        return pswp.template[this.enterK]();
                                    }
                                };
                                api.exit = function() {
                                    _options.closeOnScroll = _initalCloseOnScrollValue;

                                    return document[this.exitK]();

                                };
                                api.isFullscreen = function() { return document[this.elementK]; };
                            }

                            return api;
                        };



                    };
            return PhotoSwipeUI_Default;


        });


        /***/ }),
    /* 16 */
    /***/ (function(module, exports, __webpack_require__) {

        var __WEBPACK_AMD_DEFINE_RESULT__;/*!
         * EventEmitter2
         * https://github.com/hij1nx/EventEmitter2
         *
         * Copyright (c) 2013 hij1nx
         * Licensed under the MIT license.
         */
        ;!function(undefined) {

            var isArray = Array.isArray ? Array.isArray : function _isArray(obj) {
                return Object.prototype.toString.call(obj) === "[object Array]";
            };
            var defaultMaxListeners = 10;

            function init() {
                this._events = {};
                if (this._conf) {
                    configure.call(this, this._conf);
                }
            }

            function configure(conf) {
                if (conf) {
                    this._conf = conf;

                    conf.delimiter && (this.delimiter = conf.delimiter);
                    this._events.maxListeners = conf.maxListeners !== undefined ? conf.maxListeners : defaultMaxListeners;
                    conf.wildcard && (this.wildcard = conf.wildcard);
                    conf.newListener && (this.newListener = conf.newListener);
                    conf.verboseMemoryLeak && (this.verboseMemoryLeak = conf.verboseMemoryLeak);

                    if (this.wildcard) {
                        this.listenerTree = {};
                    }
                } else {
                    this._events.maxListeners = defaultMaxListeners;
                }
            }

            function logPossibleMemoryLeak(count, eventName) {
                var errorMsg = '(node) warning: possible EventEmitter memory ' +
                        'leak detected. %d listeners added. ' +
                        'Use emitter.setMaxListeners() to increase limit.';

                if(this.verboseMemoryLeak){
                    errorMsg += ' Event name: %s.';
                    console.error(errorMsg, count, eventName);
                } else {
                    console.error(errorMsg, count);
                }

                if (console.trace){
                    console.trace();
                }
            }

            function EventEmitter(conf) {
                this._events = {};
                this.newListener = false;
                this.verboseMemoryLeak = false;
                configure.call(this, conf);
            }
            EventEmitter.EventEmitter2 = EventEmitter; // backwards compatibility for exporting EventEmitter property

            //
            // Attention, function return type now is array, always !
            // It has zero elements if no any matches found and one or more
            // elements (leafs) if there are matches
            //
            function searchListenerTree(handlers, type, tree, i) {
                if (!tree) {
                    return [];
                }
                var listeners=[], leaf, len, branch, xTree, xxTree, isolatedBranch, endReached,
                        typeLength = type.length, currentType = type[i], nextType = type[i+1];
                if (i === typeLength && tree._listeners) {
                    //
                    // If at the end of the event(s) list and the tree has listeners
                    // invoke those listeners.
                    //
                    if (typeof tree._listeners === 'function') {
                        handlers && handlers.push(tree._listeners);
                        return [tree];
                    } else {
                        for (leaf = 0, len = tree._listeners.length; leaf < len; leaf++) {
                            handlers && handlers.push(tree._listeners[leaf]);
                        }
                        return [tree];
                    }
                }

                if ((currentType === '*' || currentType === '**') || tree[currentType]) {
                    //
                    // If the event emitted is '*' at this part
                    // or there is a concrete match at this patch
                    //
                    if (currentType === '*') {
                        for (branch in tree) {
                            if (branch !== '_listeners' && tree.hasOwnProperty(branch)) {
                                listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i+1));
                            }
                        }
                        return listeners;
                    } else if(currentType === '**') {
                        endReached = (i+1 === typeLength || (i+2 === typeLength && nextType === '*'));
                        if(endReached && tree._listeners) {
                            // The next element has a _listeners, add it to the handlers.
                            listeners = listeners.concat(searchListenerTree(handlers, type, tree, typeLength));
                        }

                        for (branch in tree) {
                            if (branch !== '_listeners' && tree.hasOwnProperty(branch)) {
                                if(branch === '*' || branch === '**') {
                                    if(tree[branch]._listeners && !endReached) {
                                        listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], typeLength));
                                    }
                                    listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i));
                                } else if(branch === nextType) {
                                    listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i+2));
                                } else {
                                    // No match on this one, shift into the tree but not in the type array.
                                    listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i));
                                }
                            }
                        }
                        return listeners;
                    }

                    listeners = listeners.concat(searchListenerTree(handlers, type, tree[currentType], i+1));
                }

                xTree = tree['*'];
                if (xTree) {
                    //
                    // If the listener tree will allow any match for this part,
                    // then recursively explore all branches of the tree
                    //
                    searchListenerTree(handlers, type, xTree, i+1);
                }

                xxTree = tree['**'];
                if(xxTree) {
                    if(i < typeLength) {
                        if(xxTree._listeners) {
                            // If we have a listener on a '**', it will catch all, so add its handler.
                            searchListenerTree(handlers, type, xxTree, typeLength);
                        }

                        // Build arrays of matching next branches and others.
                        for(branch in xxTree) {
                            if(branch !== '_listeners' && xxTree.hasOwnProperty(branch)) {
                                if(branch === nextType) {
                                    // We know the next element will match, so jump twice.
                                    searchListenerTree(handlers, type, xxTree[branch], i+2);
                                } else if(branch === currentType) {
                                    // Current node matches, move into the tree.
                                    searchListenerTree(handlers, type, xxTree[branch], i+1);
                                } else {
                                    isolatedBranch = {};
                                    isolatedBranch[branch] = xxTree[branch];
                                    searchListenerTree(handlers, type, { '**': isolatedBranch }, i+1);
                                }
                            }
                        }
                    } else if(xxTree._listeners) {
                        // We have reached the end and still on a '**'
                        searchListenerTree(handlers, type, xxTree, typeLength);
                    } else if(xxTree['*'] && xxTree['*']._listeners) {
                        searchListenerTree(handlers, type, xxTree['*'], typeLength);
                    }
                }

                return listeners;
            }

            function growListenerTree(type, listener) {

                type = typeof type === 'string' ? type.split(this.delimiter) : type.slice();

                //
                // Looks for two consecutive '**', if so, don't add the event at all.
                //
                for(var i = 0, len = type.length; i+1 < len; i++) {
                    if(type[i] === '**' && type[i+1] === '**') {
                        return;
                    }
                }

                var tree = this.listenerTree;
                var name = type.shift();

                while (name !== undefined) {

                    if (!tree[name]) {
                        tree[name] = {};
                    }

                    tree = tree[name];

                    if (type.length === 0) {

                        if (!tree._listeners) {
                            tree._listeners = listener;
                        }
                        else {
                            if (typeof tree._listeners === 'function') {
                                tree._listeners = [tree._listeners];
                            }

                            tree._listeners.push(listener);

                            if (
                                    !tree._listeners.warned &&
                                    this._events.maxListeners > 0 &&
                                    tree._listeners.length > this._events.maxListeners
                            ) {
                                tree._listeners.warned = true;
                                logPossibleMemoryLeak.call(this, tree._listeners.length, name);
                            }
                        }
                        return true;
                    }
                    name = type.shift();
                }
                return true;
            }

            // By default EventEmitters will print a warning if more than
            // 10 listeners are added to it. This is a useful default which
            // helps finding memory leaks.
            //
            // Obviously not all Emitters should be limited to 10. This function allows
            // that to be increased. Set to zero for unlimited.

            EventEmitter.prototype.delimiter = '.';

            EventEmitter.prototype.setMaxListeners = function(n) {
                if (n !== undefined) {
                    this._events || init.call(this);
                    this._events.maxListeners = n;
                    if (!this._conf) this._conf = {};
                    this._conf.maxListeners = n;
                }
            };

            EventEmitter.prototype.event = '';

            EventEmitter.prototype.once = function(event, fn) {
                this.many(event, 1, fn);
                return this;
            };

            EventEmitter.prototype.many = function(event, ttl, fn) {
                var self = this;

                if (typeof fn !== 'function') {
                    throw new Error('many only accepts instances of Function');
                }

                function listener() {
                    if (--ttl === 0) {
                        self.off(event, listener);
                    }
                    return fn.apply(this, arguments);
                }

                listener._origin = fn;

                this.on(event, listener);

                return self;
            };

            EventEmitter.prototype.emit = function() {

                this._events || init.call(this);

                var type = arguments[0];

                if (type === 'newListener' && !this.newListener) {
                    if (!this._events.newListener) {
                        return false;
                    }
                }

                var al = arguments.length;
                var args,l,i,j;
                var handler;

                if (this._all && this._all.length) {
                    handler = this._all.slice();
                    if (al > 3) {
                        args = new Array(al);
                        for (j = 0; j < al; j++) args[j] = arguments[j];
                    }

                    for (i = 0, l = handler.length; i < l; i++) {
                        this.event = type;
                        switch (al) {
                            case 1:
                                handler[i].call(this, type);
                                break;
                            case 2:
                                handler[i].call(this, type, arguments[1]);
                                break;
                            case 3:
                                handler[i].call(this, type, arguments[1], arguments[2]);
                                break;
                            default:
                                handler[i].apply(this, args);
                        }
                    }
                }

                if (this.wildcard) {
                    handler = [];
                    var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
                    searchListenerTree.call(this, handler, ns, this.listenerTree, 0);
                } else {
                    handler = this._events[type];
                    if (typeof handler === 'function') {
                        this.event = type;
                        switch (al) {
                            case 1:
                                handler.call(this);
                                break;
                            case 2:
                                handler.call(this, arguments[1]);
                                break;
                            case 3:
                                handler.call(this, arguments[1], arguments[2]);
                                break;
                            default:
                                args = new Array(al - 1);
                                for (j = 1; j < al; j++) args[j - 1] = arguments[j];
                                handler.apply(this, args);
                        }
                        return true;
                    } else if (handler) {
                        // need to make copy of handlers because list can change in the middle
                        // of emit call
                        handler = handler.slice();
                    }
                }

                if (handler && handler.length) {
                    if (al > 3) {
                        args = new Array(al - 1);
                        for (j = 1; j < al; j++) args[j - 1] = arguments[j];
                    }
                    for (i = 0, l = handler.length; i < l; i++) {
                        this.event = type;
                        switch (al) {
                            case 1:
                                handler[i].call(this);
                                break;
                            case 2:
                                handler[i].call(this, arguments[1]);
                                break;
                            case 3:
                                handler[i].call(this, arguments[1], arguments[2]);
                                break;
                            default:
                                handler[i].apply(this, args);
                        }
                    }
                    return true;
                } else if (!this._all && type === 'error') {
                    if (arguments[1] instanceof Error) {
                        throw arguments[1]; // Unhandled 'error' event
                    } else {
                        throw new Error("Uncaught, unspecified 'error' event.");
                    }
                    return false;
                }

                return !!this._all;
            };

            EventEmitter.prototype.emitAsync = function() {

                this._events || init.call(this);

                var type = arguments[0];

                if (type === 'newListener' && !this.newListener) {
                    if (!this._events.newListener) { return Promise.resolve([false]); }
                }

                var promises= [];

                var al = arguments.length;
                var args,l,i,j;
                var handler;

                if (this._all) {
                    if (al > 3) {
                        args = new Array(al);
                        for (j = 1; j < al; j++) args[j] = arguments[j];
                    }
                    for (i = 0, l = this._all.length; i < l; i++) {
                        this.event = type;
                        switch (al) {
                            case 1:
                                promises.push(this._all[i].call(this, type));
                                break;
                            case 2:
                                promises.push(this._all[i].call(this, type, arguments[1]));
                                break;
                            case 3:
                                promises.push(this._all[i].call(this, type, arguments[1], arguments[2]));
                                break;
                            default:
                                promises.push(this._all[i].apply(this, args));
                        }
                    }
                }

                if (this.wildcard) {
                    handler = [];
                    var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
                    searchListenerTree.call(this, handler, ns, this.listenerTree, 0);
                } else {
                    handler = this._events[type];
                }

                if (typeof handler === 'function') {
                    this.event = type;
                    switch (al) {
                        case 1:
                            promises.push(handler.call(this));
                            break;
                        case 2:
                            promises.push(handler.call(this, arguments[1]));
                            break;
                        case 3:
                            promises.push(handler.call(this, arguments[1], arguments[2]));
                            break;
                        default:
                            args = new Array(al - 1);
                            for (j = 1; j < al; j++) args[j - 1] = arguments[j];
                            promises.push(handler.apply(this, args));
                    }
                } else if (handler && handler.length) {
                    handler = handler.slice();
                    if (al > 3) {
                        args = new Array(al - 1);
                        for (j = 1; j < al; j++) args[j - 1] = arguments[j];
                    }
                    for (i = 0, l = handler.length; i < l; i++) {
                        this.event = type;
                        switch (al) {
                            case 1:
                                promises.push(handler[i].call(this));
                                break;
                            case 2:
                                promises.push(handler[i].call(this, arguments[1]));
                                break;
                            case 3:
                                promises.push(handler[i].call(this, arguments[1], arguments[2]));
                                break;
                            default:
                                promises.push(handler[i].apply(this, args));
                        }
                    }
                } else if (!this._all && type === 'error') {
                    if (arguments[1] instanceof Error) {
                        return Promise.reject(arguments[1]); // Unhandled 'error' event
                    } else {
                        return Promise.reject("Uncaught, unspecified 'error' event.");
                    }
                }

                return Promise.all(promises);
            };

            EventEmitter.prototype.on = function(type, listener) {
                if (typeof type === 'function') {
                    this.onAny(type);
                    return this;
                }

                if (typeof listener !== 'function') {
                    throw new Error('on only accepts instances of Function');
                }
                this._events || init.call(this);

                // To avoid recursion in the case that type == "newListeners"! Before
                // adding it to the listeners, first emit "newListeners".
                this.emit('newListener', type, listener);

                if (this.wildcard) {
                    growListenerTree.call(this, type, listener);
                    return this;
                }

                if (!this._events[type]) {
                    // Optimize the case of one listener. Don't need the extra array object.
                    this._events[type] = listener;
                }
                else {
                    if (typeof this._events[type] === 'function') {
                        // Change to array.
                        this._events[type] = [this._events[type]];
                    }

                    // If we've already got an array, just append.
                    this._events[type].push(listener);

                    // Check for listener leak
                    if (
                            !this._events[type].warned &&
                            this._events.maxListeners > 0 &&
                            this._events[type].length > this._events.maxListeners
                    ) {
                        this._events[type].warned = true;
                        logPossibleMemoryLeak.call(this, this._events[type].length, type);
                    }
                }

                return this;
            };

            EventEmitter.prototype.onAny = function(fn) {
                if (typeof fn !== 'function') {
                    throw new Error('onAny only accepts instances of Function');
                }

                if (!this._all) {
                    this._all = [];
                }

                // Add the function to the event listener collection.
                this._all.push(fn);
                return this;
            };

            EventEmitter.prototype.addListener = EventEmitter.prototype.on;

            EventEmitter.prototype.off = function(type, listener) {
                if (typeof listener !== 'function') {
                    throw new Error('removeListener only takes instances of Function');
                }

                var handlers,leafs=[];

                if(this.wildcard) {
                    var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
                    leafs = searchListenerTree.call(this, null, ns, this.listenerTree, 0);
                }
                else {
                    // does not use listeners(), so no side effect of creating _events[type]
                    if (!this._events[type]) return this;
                    handlers = this._events[type];
                    leafs.push({_listeners:handlers});
                }

                for (var iLeaf=0; iLeaf<leafs.length; iLeaf++) {
                    var leaf = leafs[iLeaf];
                    handlers = leaf._listeners;
                    if (isArray(handlers)) {

                        var position = -1;

                        for (var i = 0, length = handlers.length; i < length; i++) {
                            if (handlers[i] === listener ||
                                    (handlers[i].listener && handlers[i].listener === listener) ||
                                    (handlers[i]._origin && handlers[i]._origin === listener)) {
                                position = i;
                                break;
                            }
                        }

                        if (position < 0) {
                            continue;
                        }

                        if(this.wildcard) {
                            leaf._listeners.splice(position, 1);
                        }
                        else {
                            this._events[type].splice(position, 1);
                        }

                        if (handlers.length === 0) {
                            if(this.wildcard) {
                                delete leaf._listeners;
                            }
                            else {
                                delete this._events[type];
                            }
                        }

                        this.emit("removeListener", type, listener);

                        return this;
                    }
                    else if (handlers === listener ||
                            (handlers.listener && handlers.listener === listener) ||
                            (handlers._origin && handlers._origin === listener)) {
                        if(this.wildcard) {
                            delete leaf._listeners;
                        }
                        else {
                            delete this._events[type];
                        }

                        this.emit("removeListener", type, listener);
                    }
                }

                function recursivelyGarbageCollect(root) {
                    if (root === undefined) {
                        return;
                    }
                    var keys = Object.keys(root);
                    for (var i in keys) {
                        var key = keys[i];
                        var obj = root[key];
                        if ((obj instanceof Function) || (typeof obj !== "object") || (obj === null))
                            continue;
                        if (Object.keys(obj).length > 0) {
                            recursivelyGarbageCollect(root[key]);
                        }
                        if (Object.keys(obj).length === 0) {
                            delete root[key];
                        }
                    }
                }
                recursivelyGarbageCollect(this.listenerTree);

                return this;
            };

            EventEmitter.prototype.offAny = function(fn) {
                var i = 0, l = 0, fns;
                if (fn && this._all && this._all.length > 0) {
                    fns = this._all;
                    for(i = 0, l = fns.length; i < l; i++) {
                        if(fn === fns[i]) {
                            fns.splice(i, 1);
                            this.emit("removeListenerAny", fn);
                            return this;
                        }
                    }
                } else {
                    fns = this._all;
                    for(i = 0, l = fns.length; i < l; i++)
                        this.emit("removeListenerAny", fns[i]);
                    this._all = [];
                }
                return this;
            };

            EventEmitter.prototype.removeListener = EventEmitter.prototype.off;

            EventEmitter.prototype.removeAllListeners = function(type) {
                if (arguments.length === 0) {
                    !this._events || init.call(this);
                    return this;
                }

                if (this.wildcard) {
                    var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
                    var leafs = searchListenerTree.call(this, null, ns, this.listenerTree, 0);

                    for (var iLeaf=0; iLeaf<leafs.length; iLeaf++) {
                        var leaf = leafs[iLeaf];
                        leaf._listeners = null;
                    }
                }
                else if (this._events) {
                    this._events[type] = null;
                }
                return this;
            };

            EventEmitter.prototype.listeners = function(type) {
                if (this.wildcard) {
                    var handlers = [];
                    var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
                    searchListenerTree.call(this, handlers, ns, this.listenerTree, 0);
                    return handlers;
                }

                this._events || init.call(this);

                if (!this._events[type]) this._events[type] = [];
                if (!isArray(this._events[type])) {
                    this._events[type] = [this._events[type]];
                }
                return this._events[type];
            };

            EventEmitter.prototype.listenerCount = function(type) {
                return this.listeners(type).length;
            };

            EventEmitter.prototype.listenersAny = function() {

                if(this._all) {
                    return this._all;
                }
                else {
                    return [];
                }

            };

            if (true) {
                // AMD. Register as an anonymous module.
                !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
                    return EventEmitter;
                }).call(exports, __webpack_require__, exports, module),
                __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
            } else {}
        }();


        /***/ }),
    /* 17 */
    /***/ (function(module, exports, __webpack_require__) {

        var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*********************************************************************
         *  #### Twitter Post Fetcher v17.0.3 ####
         *  Coded by Jason Mayes 2015. A present to all the developers out there.
         *  www.jasonmayes.com
         *  Please keep this disclaimer with my code if you use it. Thanks. :-)
         *  Got feedback or questions, ask here:
         *  http://www.jasonmayes.com/projects/twitterApi/
         *  Github: https://github.com/jasonmayes/Twitter-Post-Fetcher
         *  Updates will be posted to this site.
         *********************************************************************/
        !function(e,t){ true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (t),
                __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
                        (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
        __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):undefined}(0,function(){var e="",t=20,a=!0,i=[],n=!1,s=!0,l=!0,r=null,o=!0,c=!0,d=null,m=!0,u=!1,p=!1,g=!0,h="en",w=!0,f=!1,v=null;function b(e){return e.replace(/<b[^>]*>(.*?)<\/b>/gi,function(e,t){return t}).replace(/class="(?!(tco-hidden|tco-display|tco-ellipsis))+.*?"|data-query-source=".*?"|dir=".*?"|rel=".*?"/gi,"")}function _(e){for(var t=e.getElementsByTagName("a"),a=t.length-1;a>=0;a--)t[a].setAttribute("target","_blank")}function y(e,t){for(var a=[],i=new RegExp("(^| )"+t+"( |$)"),n=e.getElementsByTagName("*"),s=0,l=n.length;s<l;s++)i.test(n[s].className)&&a.push(n[s]);return a}function T(e){if(void 0!==e&&e.innerHTML.indexOf("data-image")>=0){var t=e.innerHTML.split('data-image="')[1].split('"')[0];return decodeURIComponent(t)+".jpg"}}var k={fetch:function(o){if(void 0===o.maxTweets&&(o.maxTweets=20),void 0===o.enableLinks&&(o.enableLinks=!0),void 0===o.showUser&&(o.showUser=!0),void 0===o.showTime&&(o.showTime=!0),void 0===o.dateFunction&&(o.dateFunction="default"),void 0===o.showRetweet&&(o.showRetweet=!0),void 0===o.customCallback&&(o.customCallback=null),void 0===o.showInteraction&&(o.showInteraction=!0),void 0===o.showImages&&(o.showImages=!1),void 0===o.useEmoji&&(o.useEmoji=!1),void 0===o.linksInNewWindow&&(o.linksInNewWindow=!0),void 0===o.showPermalinks&&(o.showPermalinks=!0),void 0===o.dataOnly&&(o.dataOnly=!1),n)i.push(o);else{n=!0,e=o.domId,t=o.maxTweets,a=o.enableLinks,l=o.showUser,s=o.showTime,c=o.showRetweet,r=o.dateFunction,d=o.customCallback,m=o.showInteraction,u=o.showImages,p=o.useEmoji,g=o.linksInNewWindow,w=o.showPermalinks,f=o.dataOnly;var b=document.getElementsByTagName("head")[0];null!==v&&b.removeChild(v),(v=document.createElement("script")).type="text/javascript",void 0!==o.list?v.src="https://syndication.twitter.com/timeline/list?callback=__twttrf.callback&dnt=false&list_slug="+o.list.listSlug+"&screen_name="+o.list.screenName+"&suppress_response_codes=true&lang="+(o.lang||h)+"&rnd="+Math.random():void 0!==o.profile?v.src="https://syndication.twitter.com/timeline/profile?callback=__twttrf.callback&dnt=false&screen_name="+o.profile.screenName+"&suppress_response_codes=true&lang="+(o.lang||h)+"&rnd="+Math.random():void 0!==o.likes?v.src="https://syndication.twitter.com/timeline/likes?callback=__twttrf.callback&dnt=false&screen_name="+o.likes.screenName+"&suppress_response_codes=true&lang="+(o.lang||h)+"&rnd="+Math.random():v.src="https://cdn.syndication.twimg.com/widgets/timelines/"+o.id+"?&lang="+(o.lang||h)+"&callback=__twttrf.callback&suppress_response_codes=true&rnd="+Math.random(),b.appendChild(v)}},callback:function(h){if(void 0===h||void 0===h.body)return n=!1,void(i.length>0&&(k.fetch(i[0]),i.splice(0,1)));p||(h.body=h.body.replace(/(<img[^c]*class="Emoji[^>]*>)|(<img[^c]*class="u-block[^>]*>)/g,"")),u||(h.body=h.body.replace(/(<img[^c]*class="NaturalImage-image[^>]*>|(<img[^c]*class="CroppedImage-image[^>]*>))/g,"")),l||(h.body=h.body.replace(/(<img[^c]*class="Avatar"[^>]*>)/g,""));var v=document.createElement("div");function C(e){var t=e.getElementsByTagName("img")[0];return t&&t.length&&(t.src=t.getAttribute("data-src-2x")),e}v.innerHTML=h.body,void 0===v.getElementsByClassName&&(o=!1);var x=[],E=[],N=[],A=[],I=[],B=[],L=[],M=0;if(o)for(var H=v.getElementsByClassName("timeline-Tweet");M<H.length;)H[M].getElementsByClassName("timeline-Tweet-retweetCredit").length>0?I.push(!0):I.push(!1),(!I[M]||I[M]&&c)&&(x.push(H[M].getElementsByClassName("timeline-Tweet-text")[0]),B.push(H[M].getAttribute("data-tweet-id")),l&&E.push(C(H[M].getElementsByClassName("timeline-Tweet-author")[0])),N.push(H[M].getElementsByClassName("dt-updated")[0]),L.push(H[M].getElementsByClassName("timeline-Tweet-timestamp")[0]),void 0!==H[M].getElementsByClassName("timeline-Tweet-media")[0]?A.push(H[M].getElementsByClassName("timeline-Tweet-media")[0]):A.push(void 0)),M++;else for(H=y(v,"timeline-Tweet");M<H.length;)y(H[M],"timeline-Tweet-retweetCredit").length>0?I.push(!0):I.push(!1),(!I[M]||I[M]&&c)&&(x.push(y(H[M],"timeline-Tweet-text")[0]),B.push(H[M].getAttribute("data-tweet-id")),l&&E.push(C(y(H[M],"timeline-Tweet-author")[0])),N.push(y(H[M],"dt-updated")[0]),L.push(y(H[M],"timeline-Tweet-timestamp")[0]),void 0!==y(H[M],"timeline-Tweet-media")[0]?A.push(y(H[M],"timeline-Tweet-media")[0]):A.push(void 0)),M++;x.length>t&&(x.splice(t,x.length-t),E.splice(t,E.length-t),N.splice(t,N.length-t),I.splice(t,I.length-t),A.splice(t,A.length-t),L.splice(t,L.length-t));var R=[],j=(M=x.length,0);if(f)for(;j<M;)R.push({tweet:x[j].innerHTML,author:E[j]?E[j].innerHTML:"Unknown Author",author_data:{profile_url:E[j]?E[j].querySelector('[data-scribe="element:user_link"]').href:null,profile_image:E[j]?E[j].querySelector('[data-scribe="element:avatar"]').getAttribute("data-src-1x"):null,profile_image_2x:E[j]?E[j].querySelector('[data-scribe="element:avatar"]').getAttribute("data-src-2x"):null,screen_name:E[j]?E[j].querySelector('[data-scribe="element:screen_name"]').title:null,name:E[j]?E[j].querySelector('[data-scribe="element:name"]').title:null},time:N[j].textContent,timestamp:N[j].getAttribute("datetime").replace("+0000","Z").replace(/([\+\-])(\d\d)(\d\d)/,"$1$2:$3"),image:T(A[j]),rt:I[j],tid:B[j],permalinkURL:void 0===L[j]?"":L[j].href}),j++;else for(;j<M;){if("string"!=typeof r){var q=N[j].getAttribute("datetime"),P=new Date(N[j].getAttribute("datetime").replace(/-/g,"/").replace("T"," ").split("+")[0]),S=r(P,q);if(N[j].setAttribute("aria-label",S),x[j].textContent)if(o)N[j].textContent=S;else{var U=document.createElement("p"),F=document.createTextNode(S);U.appendChild(F),U.setAttribute("aria-label",S),N[j]=U}else N[j].textContent=S}var O="";a?(g&&(_(x[j]),l&&_(E[j])),l&&(O+='<div class="user">'+b(E[j].innerHTML)+"</div>"),O+='<p class="tweet">'+b(x[j].innerHTML)+"</p>",s&&(O+=w?'<p class="timePosted"><a href="'+L[j]+'">'+N[j].getAttribute("aria-label")+"</a></p>":'<p class="timePosted">'+N[j].getAttribute("aria-label")+"</p>")):(x[j].textContent,l&&(O+='<p class="user">'+E[j].textContent+"</p>"),O+='<p class="tweet">'+x[j].textContent+"</p>",s&&(O+='<p class="timePosted">'+N[j].textContent+"</p>")),m&&(O+='<p class="interact"><a href="https://twitter.com/intent/tweet?in_reply_to='+B[j]+'" class="twitter_reply_icon"'+(g?' target="_blank">':">")+'Reply</a><a href="https://twitter.com/intent/retweet?tweet_id='+B[j]+'" class="twitter_retweet_icon"'+(g?' target="_blank">':">")+'Retweet</a><a href="https://twitter.com/intent/favorite?tweet_id='+B[j]+'" class="twitter_fav_icon"'+(g?' target="_blank">':">")+"Favorite</a></p>"),u&&void 0!==A[j]&&void 0!==T(A[j])&&(O+='<div class="media"><img src="'+T(A[j])+'" alt="Image from tweet" /></div>'),u?R.push(O):!u&&x[j].textContent.length&&R.push(O),j++}!function(t){if(null===d){for(var a=t.length,i=0,n=document.getElementById(e),s="<ul>";i<a;)s+="<li>"+t[i]+"</li>",i++;s+="</ul>",n.innerHTML=s}else d(t)}(R),n=!1,i.length>0&&(k.fetch(i[0]),i.splice(0,1))}};return window.__twttrf=k,window.twitterFetcher=k,k});


        /***/ }),
    /* 18 */
    /***/ (function(module, __webpack_exports__, __webpack_require__) {

        "use strict";
        /* WEBPACK VAR INJECTION */(function(global) {
            /*!
             * @pixelunion/pxs-slideshow v1.0.6
             * (c) 2020 Pixel Union
             */

            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }

            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, descriptor.key, descriptor);
                }
            }

            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                return Constructor;
            }

            var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

            function unwrapExports (x) {
                return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
            }

            function createCommonjsModule(fn, module) {
                return module = { exports: {} }, fn(module, module.exports), module.exports;
            }

            var evEmitter = createCommonjsModule(function (module) {
                /**
                 * EvEmitter v1.1.0
                 * Lil' event emitter
                 * MIT License
                 */

                /* jshint unused: true, undef: true, strict: true */

                ( function( global, factory ) {
                    // universal module definition
                    /* jshint strict: false */ /* globals define, module, window */
                    if (  module.exports ) {
                        // CommonJS - Browserify, Webpack
                        module.exports = factory();
                    } else {
                        // Browser globals
                        global.EvEmitter = factory();
                    }

                }( typeof window != 'undefined' ? window : commonjsGlobal, function() {

                    function EvEmitter() {}

                    var proto = EvEmitter.prototype;

                    proto.on = function( eventName, listener ) {
                        if ( !eventName || !listener ) {
                            return;
                        }
                        // set events hash
                        var events = this._events = this._events || {};
                        // set listeners array
                        var listeners = events[ eventName ] = events[ eventName ] || [];
                        // only add once
                        if ( listeners.indexOf( listener ) == -1 ) {
                            listeners.push( listener );
                        }

                        return this;
                    };

                    proto.once = function( eventName, listener ) {
                        if ( !eventName || !listener ) {
                            return;
                        }
                        // add event
                        this.on( eventName, listener );
                        // set once flag
                        // set onceEvents hash
                        var onceEvents = this._onceEvents = this._onceEvents || {};
                        // set onceListeners object
                        var onceListeners = onceEvents[ eventName ] = onceEvents[ eventName ] || {};
                        // set flag
                        onceListeners[ listener ] = true;

                        return this;
                    };

                    proto.off = function( eventName, listener ) {
                        var listeners = this._events && this._events[ eventName ];
                        if ( !listeners || !listeners.length ) {
                            return;
                        }
                        var index = listeners.indexOf( listener );
                        if ( index != -1 ) {
                            listeners.splice( index, 1 );
                        }

                        return this;
                    };

                    proto.emitEvent = function( eventName, args ) {
                        var listeners = this._events && this._events[ eventName ];
                        if ( !listeners || !listeners.length ) {
                            return;
                        }
                        // copy over to avoid interference if .off() in listener
                        listeners = listeners.slice(0);
                        args = args || [];
                        // once stuff
                        var onceListeners = this._onceEvents && this._onceEvents[ eventName ];

                        for ( var i=0; i < listeners.length; i++ ) {
                            var listener = listeners[i];
                            var isOnce = onceListeners && onceListeners[ listener ];
                            if ( isOnce ) {
                                // remove listener
                                // remove before trigger to prevent recursion
                                this.off( eventName, listener );
                                // unset once flag
                                delete onceListeners[ listener ];
                            }
                            // trigger listener
                            listener.apply( this, args );
                        }

                        return this;
                    };

                    proto.allOff = function() {
                        delete this._events;
                        delete this._onceEvents;
                    };

                    return EvEmitter;

                }));
            });

            var getSize = createCommonjsModule(function (module) {
                /*!
                 * getSize v2.0.3
                 * measure size of elements
                 * MIT license
                 */

                /* jshint browser: true, strict: true, undef: true, unused: true */
                /* globals console: false */

                ( function( window, factory ) {
                    /* jshint strict: false */ /* globals define, module */
                    if (  module.exports ) {
                        // CommonJS
                        module.exports = factory();
                    } else {
                        // browser global
                        window.getSize = factory();
                    }

                })( window, function factory() {

// -------------------------- helpers -------------------------- //

// get a number from a string, not a percentage
                    function getStyleSize( value ) {
                        var num = parseFloat( value );
                        // not a percent like '100%', and a number
                        var isValid = value.indexOf('%') == -1 && !isNaN( num );
                        return isValid && num;
                    }

                    function noop() {}

                    var logError = typeof console == 'undefined' ? noop :
                            function( message ) {
                                console.error( message );
                            };

// -------------------------- measurements -------------------------- //

                    var measurements = [
                        'paddingLeft',
                        'paddingRight',
                        'paddingTop',
                        'paddingBottom',
                        'marginLeft',
                        'marginRight',
                        'marginTop',
                        'marginBottom',
                        'borderLeftWidth',
                        'borderRightWidth',
                        'borderTopWidth',
                        'borderBottomWidth'
                    ];

                    var measurementsLength = measurements.length;

                    function getZeroSize() {
                        var size = {
                            width: 0,
                            height: 0,
                            innerWidth: 0,
                            innerHeight: 0,
                            outerWidth: 0,
                            outerHeight: 0
                        };
                        for ( var i=0; i < measurementsLength; i++ ) {
                            var measurement = measurements[i];
                            size[ measurement ] = 0;
                        }
                        return size;
                    }

// -------------------------- getStyle -------------------------- //

                    /**
                     * getStyle, get style of element, check for Firefox bug
                     * https://bugzilla.mozilla.org/show_bug.cgi?id=548397
                     */
                    function getStyle( elem ) {
                        var style = getComputedStyle( elem );
                        if ( !style ) {
                            logError( 'Style returned ' + style +
                                    '. Are you running this code in a hidden iframe on Firefox? ' +
                                    'See https://bit.ly/getsizebug1' );
                        }
                        return style;
                    }

// -------------------------- setup -------------------------- //

                    var isSetup = false;

                    var isBoxSizeOuter;

                    /**
                     * setup
                     * check isBoxSizerOuter
                     * do on first getSize() rather than on page load for Firefox bug
                     */
                    function setup() {
                        // setup once
                        if ( isSetup ) {
                            return;
                        }
                        isSetup = true;

                        // -------------------------- box sizing -------------------------- //

                        /**
                         * Chrome & Safari measure the outer-width on style.width on border-box elems
                         * IE11 & Firefox<29 measures the inner-width
                         */
                        var div = document.createElement('div');
                        div.style.width = '200px';
                        div.style.padding = '1px 2px 3px 4px';
                        div.style.borderStyle = 'solid';
                        div.style.borderWidth = '1px 2px 3px 4px';
                        div.style.boxSizing = 'border-box';

                        var body = document.body || document.documentElement;
                        body.appendChild( div );
                        var style = getStyle( div );
                        // round value for browser zoom. desandro/masonry#928
                        isBoxSizeOuter = Math.round( getStyleSize( style.width ) ) == 200;
                        getSize.isBoxSizeOuter = isBoxSizeOuter;

                        body.removeChild( div );
                    }

// -------------------------- getSize -------------------------- //

                    function getSize( elem ) {
                        setup();

                        // use querySeletor if elem is string
                        if ( typeof elem == 'string' ) {
                            elem = document.querySelector( elem );
                        }

                        // do not proceed on non-objects
                        if ( !elem || typeof elem != 'object' || !elem.nodeType ) {
                            return;
                        }

                        var style = getStyle( elem );

                        // if hidden, everything is 0
                        if ( style.display == 'none' ) {
                            return getZeroSize();
                        }

                        var size = {};
                        size.width = elem.offsetWidth;
                        size.height = elem.offsetHeight;

                        var isBorderBox = size.isBorderBox = style.boxSizing == 'border-box';

                        // get all measurements
                        for ( var i=0; i < measurementsLength; i++ ) {
                            var measurement = measurements[i];
                            var value = style[ measurement ];
                            var num = parseFloat( value );
                            // any 'auto', 'medium' value will be 0
                            size[ measurement ] = !isNaN( num ) ? num : 0;
                        }

                        var paddingWidth = size.paddingLeft + size.paddingRight;
                        var paddingHeight = size.paddingTop + size.paddingBottom;
                        var marginWidth = size.marginLeft + size.marginRight;
                        var marginHeight = size.marginTop + size.marginBottom;
                        var borderWidth = size.borderLeftWidth + size.borderRightWidth;
                        var borderHeight = size.borderTopWidth + size.borderBottomWidth;

                        var isBorderBoxSizeOuter = isBorderBox && isBoxSizeOuter;

                        // overwrite width and height if we can get it from style
                        var styleWidth = getStyleSize( style.width );
                        if ( styleWidth !== false ) {
                            size.width = styleWidth +
                                    // add padding and border unless it's already including it
                                    ( isBorderBoxSizeOuter ? 0 : paddingWidth + borderWidth );
                        }

                        var styleHeight = getStyleSize( style.height );
                        if ( styleHeight !== false ) {
                            size.height = styleHeight +
                                    // add padding and border unless it's already including it
                                    ( isBorderBoxSizeOuter ? 0 : paddingHeight + borderHeight );
                        }

                        size.innerWidth = size.width - ( paddingWidth + borderWidth );
                        size.innerHeight = size.height - ( paddingHeight + borderHeight );

                        size.outerWidth = size.width + marginWidth;
                        size.outerHeight = size.height + marginHeight;

                        return size;
                    }

                    return getSize;

                });
            });

            var matchesSelector = createCommonjsModule(function (module) {
                /**
                 * matchesSelector v2.0.2
                 * matchesSelector( element, '.selector' )
                 * MIT license
                 */

                /*jshint browser: true, strict: true, undef: true, unused: true */

                ( function( window, factory ) {
                    // universal module definition
                    if (  module.exports ) {
                        // CommonJS
                        module.exports = factory();
                    } else {
                        // browser global
                        window.matchesSelector = factory();
                    }

                }( window, function factory() {

                    var matchesMethod = ( function() {
                        var ElemProto = window.Element.prototype;
                        // check for the standard method name first
                        if ( ElemProto.matches ) {
                            return 'matches';
                        }
                        // check un-prefixed
                        if ( ElemProto.matchesSelector ) {
                            return 'matchesSelector';
                        }
                        // check vendor prefixes
                        var prefixes = [ 'webkit', 'moz', 'ms', 'o' ];

                        for ( var i=0; i < prefixes.length; i++ ) {
                            var prefix = prefixes[i];
                            var method = prefix + 'MatchesSelector';
                            if ( ElemProto[ method ] ) {
                                return method;
                            }
                        }
                    })();

                    return function matchesSelector( elem, selector ) {
                        return elem[ matchesMethod ]( selector );
                    };

                }));
            });

            var utils = createCommonjsModule(function (module) {
                /**
                 * Fizzy UI utils v2.0.7
                 * MIT license
                 */

                /*jshint browser: true, undef: true, unused: true, strict: true */

                ( function( window, factory ) {
                    // universal module definition
                    /*jshint strict: false */ /*globals define, module, require */

                    if (  module.exports ) {
                        // CommonJS
                        module.exports = factory(
                                window,
                                matchesSelector
                        );
                    } else {
                        // browser global
                        window.fizzyUIUtils = factory(
                                window,
                                window.matchesSelector
                        );
                    }

                }( window, function factory( window, matchesSelector ) {

                    var utils = {};

// ----- extend ----- //

// extends objects
                    utils.extend = function( a, b ) {
                        for ( var prop in b ) {
                            a[ prop ] = b[ prop ];
                        }
                        return a;
                    };

// ----- modulo ----- //

                    utils.modulo = function( num, div ) {
                        return ( ( num % div ) + div ) % div;
                    };

// ----- makeArray ----- //

                    var arraySlice = Array.prototype.slice;

// turn element or nodeList into an array
                    utils.makeArray = function( obj ) {
                        if ( Array.isArray( obj ) ) {
                            // use object if already an array
                            return obj;
                        }
                        // return empty array if undefined or null. #6
                        if ( obj === null || obj === undefined ) {
                            return [];
                        }

                        var isArrayLike = typeof obj == 'object' && typeof obj.length == 'number';
                        if ( isArrayLike ) {
                            // convert nodeList to array
                            return arraySlice.call( obj );
                        }

                        // array of single index
                        return [ obj ];
                    };

// ----- removeFrom ----- //

                    utils.removeFrom = function( ary, obj ) {
                        var index = ary.indexOf( obj );
                        if ( index != -1 ) {
                            ary.splice( index, 1 );
                        }
                    };

// ----- getParent ----- //

                    utils.getParent = function( elem, selector ) {
                        while ( elem.parentNode && elem != document.body ) {
                            elem = elem.parentNode;
                            if ( matchesSelector( elem, selector ) ) {
                                return elem;
                            }
                        }
                    };

// ----- getQueryElement ----- //

// use element as selector string
                    utils.getQueryElement = function( elem ) {
                        if ( typeof elem == 'string' ) {
                            return document.querySelector( elem );
                        }
                        return elem;
                    };

// ----- handleEvent ----- //

// enable .ontype to trigger from .addEventListener( elem, 'type' )
                    utils.handleEvent = function( event ) {
                        var method = 'on' + event.type;
                        if ( this[ method ] ) {
                            this[ method ]( event );
                        }
                    };

// ----- filterFindElements ----- //

                    utils.filterFindElements = function( elems, selector ) {
                        // make array of elems
                        elems = utils.makeArray( elems );
                        var ffElems = [];

                        elems.forEach( function( elem ) {
                            // check that elem is an actual element
                            if ( !( elem instanceof HTMLElement ) ) {
                                return;
                            }
                            // add elem if no selector
                            if ( !selector ) {
                                ffElems.push( elem );
                                return;
                            }
                            // filter & find items if we have a selector
                            // filter
                            if ( matchesSelector( elem, selector ) ) {
                                ffElems.push( elem );
                            }
                            // find children
                            var childElems = elem.querySelectorAll( selector );
                            // concat childElems to filterFound array
                            for ( var i=0; i < childElems.length; i++ ) {
                                ffElems.push( childElems[i] );
                            }
                        });

                        return ffElems;
                    };

// ----- debounceMethod ----- //

                    utils.debounceMethod = function( _class, methodName, threshold ) {
                        threshold = threshold || 100;
                        // original method
                        var method = _class.prototype[ methodName ];
                        var timeoutName = methodName + 'Timeout';

                        _class.prototype[ methodName ] = function() {
                            var timeout = this[ timeoutName ];
                            clearTimeout( timeout );

                            var args = arguments;
                            var _this = this;
                            this[ timeoutName ] = setTimeout( function() {
                                method.apply( _this, args );
                                delete _this[ timeoutName ];
                            }, threshold );
                        };
                    };

// ----- docReady ----- //

                    utils.docReady = function( callback ) {
                        var readyState = document.readyState;
                        if ( readyState == 'complete' || readyState == 'interactive' ) {
                            // do async to allow for other scripts to run. metafizzy/flickity#441
                            setTimeout( callback );
                        } else {
                            document.addEventListener( 'DOMContentLoaded', callback );
                        }
                    };

// ----- htmlInit ----- //

// http://jamesroberts.name/blog/2010/02/22/string-functions-for-javascript-trim-to-camel-case-to-dashed-and-to-underscore/
                    utils.toDashed = function( str ) {
                        return str.replace( /(.)([A-Z])/g, function( match, $1, $2 ) {
                            return $1 + '-' + $2;
                        }).toLowerCase();
                    };

                    var console = window.console;
                    /**
                     * allow user to initialize classes via [data-namespace] or .js-namespace class
                     * htmlInit( Widget, 'widgetName' )
                     * options are parsed from data-namespace-options
                     */
                    utils.htmlInit = function( WidgetClass, namespace ) {
                        utils.docReady( function() {
                            var dashedNamespace = utils.toDashed( namespace );
                            var dataAttr = 'data-' + dashedNamespace;
                            var dataAttrElems = document.querySelectorAll( '[' + dataAttr + ']' );
                            var jsDashElems = document.querySelectorAll( '.js-' + dashedNamespace );
                            var elems = utils.makeArray( dataAttrElems )
                                    .concat( utils.makeArray( jsDashElems ) );
                            var dataOptionsAttr = dataAttr + '-options';
                            var jQuery = window.jQuery;

                            elems.forEach( function( elem ) {
                                var attr = elem.getAttribute( dataAttr ) ||
                                        elem.getAttribute( dataOptionsAttr );
                                var options;
                                try {
                                    options = attr && JSON.parse( attr );
                                } catch ( error ) {
                                    // log error, do not initialize
                                    if ( console ) {
                                        console.error( 'Error parsing ' + dataAttr + ' on ' + elem.className +
                                                ': ' + error );
                                    }
                                    return;
                                }
                                // initialize
                                var instance = new WidgetClass( elem, options );
                                // make available via $().data('namespace')
                                if ( jQuery ) {
                                    jQuery.data( elem, namespace, instance );
                                }
                            });

                        });
                    };

// -----  ----- //

                    return utils;

                }));
            });

            var cell = createCommonjsModule(function (module) {
// Flickity.Cell
                ( function( window, factory ) {
                    // universal module definition
                    /* jshint strict: false */
                    if (  module.exports ) {
                        // CommonJS
                        module.exports = factory(
                                window,
                                getSize
                        );
                    } else {
                        // browser global
                        window.Flickity = window.Flickity || {};
                        window.Flickity.Cell = factory(
                                window,
                                window.getSize
                        );
                    }

                }( window, function factory( window, getSize ) {

                    function Cell( elem, parent ) {
                        this.element = elem;
                        this.parent = parent;

                        this.create();
                    }

                    var proto = Cell.prototype;

                    proto.create = function() {
                        this.element.style.position = 'absolute';
                        this.element.setAttribute( 'aria-hidden', 'true' );
                        this.x = 0;
                        this.shift = 0;
                    };

                    proto.destroy = function() {
                        // reset style
                        this.unselect();
                        this.element.style.position = '';
                        var side = this.parent.originSide;
                        this.element.style[ side ] = '';
                    };

                    proto.getSize = function() {
                        this.size = getSize( this.element );
                    };

                    proto.setPosition = function( x ) {
                        this.x = x;
                        this.updateTarget();
                        this.renderPosition( x );
                    };

// setDefaultTarget v1 method, backwards compatibility, remove in v3
                    proto.updateTarget = proto.setDefaultTarget = function() {
                        var marginProperty = this.parent.originSide == 'left' ? 'marginLeft' : 'marginRight';
                        this.target = this.x + this.size[ marginProperty ] +
                                this.size.width * this.parent.cellAlign;
                    };

                    proto.renderPosition = function( x ) {
                        // render position of cell with in slider
                        var side = this.parent.originSide;
                        this.element.style[ side ] = this.parent.getPositionValue( x );
                    };

                    proto.select = function() {
                        this.element.classList.add('is-selected');
                        this.element.removeAttribute('aria-hidden');
                    };

                    proto.unselect = function() {
                        this.element.classList.remove('is-selected');
                        this.element.setAttribute( 'aria-hidden', 'true' );
                    };

                    /**
                     * @param {Integer} factor - 0, 1, or -1
                     **/
                    proto.wrapShift = function( shift ) {
                        this.shift = shift;
                        this.renderPosition( this.x + this.parent.slideableWidth * shift );
                    };

                    proto.remove = function() {
                        this.element.parentNode.removeChild( this.element );
                    };

                    return Cell;

                }));
            });

            var slide = createCommonjsModule(function (module) {
// slide
                ( function( window, factory ) {
                    // universal module definition
                    /* jshint strict: false */
                    if (  module.exports ) {
                        // CommonJS
                        module.exports = factory();
                    } else {
                        // browser global
                        window.Flickity = window.Flickity || {};
                        window.Flickity.Slide = factory();
                    }

                }( window, function factory() {

                    function Slide( parent ) {
                        this.parent = parent;
                        this.isOriginLeft = parent.originSide == 'left';
                        this.cells = [];
                        this.outerWidth = 0;
                        this.height = 0;
                    }

                    var proto = Slide.prototype;

                    proto.addCell = function( cell ) {
                        this.cells.push( cell );
                        this.outerWidth += cell.size.outerWidth;
                        this.height = Math.max( cell.size.outerHeight, this.height );
                        // first cell stuff
                        if ( this.cells.length == 1 ) {
                            this.x = cell.x; // x comes from first cell
                            var beginMargin = this.isOriginLeft ? 'marginLeft' : 'marginRight';
                            this.firstMargin = cell.size[ beginMargin ];
                        }
                    };

                    proto.updateTarget = function() {
                        var endMargin = this.isOriginLeft ? 'marginRight' : 'marginLeft';
                        var lastCell = this.getLastCell();
                        var lastMargin = lastCell ? lastCell.size[ endMargin ] : 0;
                        var slideWidth = this.outerWidth - ( this.firstMargin + lastMargin );
                        this.target = this.x + this.firstMargin + slideWidth * this.parent.cellAlign;
                    };

                    proto.getLastCell = function() {
                        return this.cells[ this.cells.length - 1 ];
                    };

                    proto.select = function() {
                        this.cells.forEach( function( cell ) {
                            cell.select();
                        });
                    };

                    proto.unselect = function() {
                        this.cells.forEach( function( cell ) {
                            cell.unselect();
                        });
                    };

                    proto.getCellElements = function() {
                        return this.cells.map( function( cell ) {
                            return cell.element;
                        });
                    };

                    return Slide;

                }));
            });

            var animate = createCommonjsModule(function (module) {
// animate
                ( function( window, factory ) {
                    // universal module definition
                    /* jshint strict: false */
                    if (  module.exports ) {
                        // CommonJS
                        module.exports = factory(
                                window,
                                utils
                        );
                    } else {
                        // browser global
                        window.Flickity = window.Flickity || {};
                        window.Flickity.animatePrototype = factory(
                                window,
                                window.fizzyUIUtils
                        );
                    }

                }( window, function factory( window, utils ) {

// -------------------------- animate -------------------------- //

                    var proto = {};

                    proto.startAnimation = function() {
                        if ( this.isAnimating ) {
                            return;
                        }

                        this.isAnimating = true;
                        this.restingFrames = 0;
                        this.animate();
                    };

                    proto.animate = function() {
                        this.applyDragForce();
                        this.applySelectedAttraction();

                        var previousX = this.x;

                        this.integratePhysics();
                        this.positionSlider();
                        this.settle( previousX );
                        // animate next frame
                        if ( this.isAnimating ) {
                            var _this = this;
                            requestAnimationFrame( function animateFrame() {
                                _this.animate();
                            });
                        }
                    };

                    proto.positionSlider = function() {
                        var x = this.x;
                        // wrap position around
                        if ( this.options.wrapAround && this.cells.length > 1 ) {
                            x = utils.modulo( x, this.slideableWidth );
                            x = x - this.slideableWidth;
                            this.shiftWrapCells( x );
                        }

                        this.setTranslateX( x, this.isAnimating );
                        this.dispatchScrollEvent();
                    };

                    proto.setTranslateX = function( x, is3d ) {
                        x += this.cursorPosition;
                        // reverse if right-to-left and using transform
                        x = this.options.rightToLeft ? -x : x;
                        var translateX = this.getPositionValue( x );
                        // use 3D tranforms for hardware acceleration on iOS
                        // but use 2D when settled, for better font-rendering
                        this.slider.style.transform = is3d ?
                        'translate3d(' + translateX + ',0,0)' : 'translateX(' + translateX + ')';
                    };

                    proto.dispatchScrollEvent = function() {
                        var firstSlide = this.slides[0];
                        if ( !firstSlide ) {
                            return;
                        }
                        var positionX = -this.x - firstSlide.target;
                        var progress = positionX / this.slidesWidth;
                        this.dispatchEvent( 'scroll', null, [ progress, positionX ] );
                    };

                    proto.positionSliderAtSelected = function() {
                        if ( !this.cells.length ) {
                            return;
                        }
                        this.x = -this.selectedSlide.target;
                        this.velocity = 0; // stop wobble
                        this.positionSlider();
                    };

                    proto.getPositionValue = function( position ) {
                        if ( this.options.percentPosition ) {
                            // percent position, round to 2 digits, like 12.34%
                            return ( Math.round( ( position / this.size.innerWidth ) * 10000 ) * 0.01 )+ '%';
                        } else {
                            // pixel positioning
                            return Math.round( position ) + 'px';
                        }
                    };

                    proto.settle = function( previousX ) {
                        // keep track of frames where x hasn't moved
                        if ( !this.isPointerDown && Math.round( this.x * 100 ) == Math.round( previousX * 100 ) ) {
                            this.restingFrames++;
                        }
                        // stop animating if resting for 3 or more frames
                        if ( this.restingFrames > 2 ) {
                            this.isAnimating = false;
                            delete this.isFreeScrolling;
                            // render position with translateX when settled
                            this.positionSlider();
                            this.dispatchEvent( 'settle', null, [ this.selectedIndex ] );
                        }
                    };

                    proto.shiftWrapCells = function( x ) {
                        // shift before cells
                        var beforeGap = this.cursorPosition + x;
                        this._shiftCells( this.beforeShiftCells, beforeGap, -1 );
                        // shift after cells
                        var afterGap = this.size.innerWidth - ( x + this.slideableWidth + this.cursorPosition );
                        this._shiftCells( this.afterShiftCells, afterGap, 1 );
                    };

                    proto._shiftCells = function( cells, gap, shift ) {
                        for ( var i=0; i < cells.length; i++ ) {
                            var cell = cells[i];
                            var cellShift = gap > 0 ? shift : 0;
                            cell.wrapShift( cellShift );
                            gap -= cell.size.outerWidth;
                        }
                    };

                    proto._unshiftCells = function( cells ) {
                        if ( !cells || !cells.length ) {
                            return;
                        }
                        for ( var i=0; i < cells.length; i++ ) {
                            cells[i].wrapShift( 0 );
                        }
                    };

// -------------------------- physics -------------------------- //

                    proto.integratePhysics = function() {
                        this.x += this.velocity;
                        this.velocity *= this.getFrictionFactor();
                    };

                    proto.applyForce = function( force ) {
                        this.velocity += force;
                    };

                    proto.getFrictionFactor = function() {
                        return 1 - this.options[ this.isFreeScrolling ? 'freeScrollFriction' : 'friction' ];
                    };

                    proto.getRestingPosition = function() {
                        // my thanks to Steven Wittens, who simplified this math greatly
                        return this.x + this.velocity / ( 1 - this.getFrictionFactor() );
                    };

                    proto.applyDragForce = function() {
                        if ( !this.isDraggable || !this.isPointerDown ) {
                            return;
                        }
                        // change the position to drag position by applying force
                        var dragVelocity = this.dragX - this.x;
                        var dragForce = dragVelocity - this.velocity;
                        this.applyForce( dragForce );
                    };

                    proto.applySelectedAttraction = function() {
                        // do not attract if pointer down or no slides
                        var dragDown = this.isDraggable && this.isPointerDown;
                        if ( dragDown || this.isFreeScrolling || !this.slides.length ) {
                            return;
                        }
                        var distance = this.selectedSlide.target * -1 - this.x;
                        var force = distance * this.options.selectedAttraction;
                        this.applyForce( force );
                    };

                    return proto;

                }));
            });

            var flickity = createCommonjsModule(function (module) {
// Flickity main
                ( function( window, factory ) {
                    // universal module definition
                    /* jshint strict: false */
                    if (  module.exports ) {
                        // CommonJS
                        module.exports = factory(
                                window,
                                evEmitter,
                                getSize,
                                utils,
                                cell,
                                slide,
                                animate
                        );
                    } else {
                        // browser global
                        var _Flickity = window.Flickity;

                        window.Flickity = factory(
                                window,
                                window.EvEmitter,
                                window.getSize,
                                window.fizzyUIUtils,
                                _Flickity.Cell,
                                _Flickity.Slide,
                                _Flickity.animatePrototype
                        );
                    }

                }( window, function factory( window, EvEmitter, getSize,
                                             utils, Cell, Slide, animatePrototype ) {

// vars
                    var jQuery = window.jQuery;
                    var getComputedStyle = window.getComputedStyle;
                    var console = window.console;

                    function moveElements( elems, toElem ) {
                        elems = utils.makeArray( elems );
                        while ( elems.length ) {
                            toElem.appendChild( elems.shift() );
                        }
                    }

// -------------------------- Flickity -------------------------- //

// globally unique identifiers
                    var GUID = 0;
// internal store of all Flickity intances
                    var instances = {};

                    function Flickity( element, options ) {
                        var queryElement = utils.getQueryElement( element );
                        if ( !queryElement ) {
                            if ( console ) {
                                console.error( 'Bad element for Flickity: ' + ( queryElement || element ) );
                            }
                            return;
                        }
                        this.element = queryElement;
                        // do not initialize twice on same element
                        if ( this.element.flickityGUID ) {
                            var instance = instances[ this.element.flickityGUID ];
                            instance.option( options );
                            return instance;
                        }

                        // add jQuery
                        if ( jQuery ) {
                            this.$element = jQuery( this.element );
                        }
                        // options
                        this.options = utils.extend( {}, this.constructor.defaults );
                        this.option( options );

                        // kick things off
                        this._create();
                    }

                    Flickity.defaults = {
                        accessibility: true,
                        // adaptiveHeight: false,
                        cellAlign: 'center',
                        // cellSelector: undefined,
                        // contain: false,
                        freeScrollFriction: 0.075, // friction when free-scrolling
                        friction: 0.28, // friction when selecting
                        namespaceJQueryEvents: true,
                        // initialIndex: 0,
                        percentPosition: true,
                        resize: true,
                        selectedAttraction: 0.025,
                        setGallerySize: true
                        // watchCSS: false,
                        // wrapAround: false
                    };

// hash of methods triggered on _create()
                    Flickity.createMethods = [];

                    var proto = Flickity.prototype;
// inherit EventEmitter
                    utils.extend( proto, EvEmitter.prototype );

                    proto._create = function() {
                        // add id for Flickity.data
                        var id = this.guid = ++GUID;
                        this.element.flickityGUID = id; // expando
                        instances[ id ] = this; // associate via id
                        // initial properties
                        this.selectedIndex = 0;
                        // how many frames slider has been in same position
                        this.restingFrames = 0;
                        // initial physics properties
                        this.x = 0;
                        this.velocity = 0;
                        this.originSide = this.options.rightToLeft ? 'right' : 'left';
                        // create viewport & slider
                        this.viewport = document.createElement('div');
                        this.viewport.className = 'flickity-viewport';
                        this._createSlider();

                        if ( this.options.resize || this.options.watchCSS ) {
                            window.addEventListener( 'resize', this );
                        }

                        // add listeners from on option
                        for ( var eventName in this.options.on ) {
                            var listener = this.options.on[ eventName ];
                            this.on( eventName, listener );
                        }

                        Flickity.createMethods.forEach( function( method ) {
                            this[ method ]();
                        }, this );

                        if ( this.options.watchCSS ) {
                            this.watchCSS();
                        } else {
                            this.activate();
                        }

                    };

                    /**
                     * set options
                     * @param {Object} opts
                     */
                    proto.option = function( opts ) {
                        utils.extend( this.options, opts );
                    };

                    proto.activate = function() {
                        if ( this.isActive ) {
                            return;
                        }
                        this.isActive = true;
                        this.element.classList.add('flickity-enabled');
                        if ( this.options.rightToLeft ) {
                            this.element.classList.add('flickity-rtl');
                        }

                        this.getSize();
                        // move initial cell elements so they can be loaded as cells
                        var cellElems = this._filterFindCellElements( this.element.children );
                        moveElements( cellElems, this.slider );
                        this.viewport.appendChild( this.slider );
                        this.element.appendChild( this.viewport );
                        // get cells from children
                        this.reloadCells();

                        if ( this.options.accessibility ) {
                            // allow element to focusable
                            this.element.tabIndex = 0;
                            // listen for key presses
                            this.element.addEventListener( 'keydown', this );
                        }

                        this.emitEvent('activate');
                        this.selectInitialIndex();
                        // flag for initial activation, for using initialIndex
                        this.isInitActivated = true;
                        // ready event. #493
                        this.dispatchEvent('ready');
                    };

// slider positions the cells
                    proto._createSlider = function() {
                        // slider element does all the positioning
                        var slider = document.createElement('div');
                        slider.className = 'flickity-slider';
                        slider.style[ this.originSide ] = 0;
                        this.slider = slider;
                    };

                    proto._filterFindCellElements = function( elems ) {
                        return utils.filterFindElements( elems, this.options.cellSelector );
                    };

// goes through all children
                    proto.reloadCells = function() {
                        // collection of item elements
                        this.cells = this._makeCells( this.slider.children );
                        this.positionCells();
                        this._getWrapShiftCells();
                        this.setGallerySize();
                    };

                    /**
                     * turn elements into Flickity.Cells
                     * @param {Array or NodeList or HTMLElement} elems
                     * @returns {Array} items - collection of new Flickity Cells
                     */
                    proto._makeCells = function( elems ) {
                        var cellElems = this._filterFindCellElements( elems );

                        // create new Flickity for collection
                        var cells = cellElems.map( function( cellElem ) {
                            return new Cell( cellElem, this );
                        }, this );

                        return cells;
                    };

                    proto.getLastCell = function() {
                        return this.cells[ this.cells.length - 1 ];
                    };

                    proto.getLastSlide = function() {
                        return this.slides[ this.slides.length - 1 ];
                    };

// positions all cells
                    proto.positionCells = function() {
                        // size all cells
                        this._sizeCells( this.cells );
                        // position all cells
                        this._positionCells( 0 );
                    };

                    /**
                     * position certain cells
                     * @param {Integer} index - which cell to start with
                     */
                    proto._positionCells = function( index ) {
                        index = index || 0;
                        // also measure maxCellHeight
                        // start 0 if positioning all cells
                        this.maxCellHeight = index ? this.maxCellHeight || 0 : 0;
                        var cellX = 0;
                        // get cellX
                        if ( index > 0 ) {
                            var startCell = this.cells[ index - 1 ];
                            cellX = startCell.x + startCell.size.outerWidth;
                        }
                        var len = this.cells.length;
                        for ( var i=index; i < len; i++ ) {
                            var cell = this.cells[i];
                            cell.setPosition( cellX );
                            cellX += cell.size.outerWidth;
                            this.maxCellHeight = Math.max( cell.size.outerHeight, this.maxCellHeight );
                        }
                        // keep track of cellX for wrap-around
                        this.slideableWidth = cellX;
                        // slides
                        this.updateSlides();
                        // contain slides target
                        this._containSlides();
                        // update slidesWidth
                        this.slidesWidth = len ? this.getLastSlide().target - this.slides[0].target : 0;
                    };

                    /**
                     * cell.getSize() on multiple cells
                     * @param {Array} cells
                     */
                    proto._sizeCells = function( cells ) {
                        cells.forEach( function( cell ) {
                            cell.getSize();
                        });
                    };

// --------------------------  -------------------------- //

                    proto.updateSlides = function() {
                        this.slides = [];
                        if ( !this.cells.length ) {
                            return;
                        }

                        var slide = new Slide( this );
                        this.slides.push( slide );
                        var isOriginLeft = this.originSide == 'left';
                        var nextMargin = isOriginLeft ? 'marginRight' : 'marginLeft';

                        var canCellFit = this._getCanCellFit();

                        this.cells.forEach( function( cell, i ) {
                            // just add cell if first cell in slide
                            if ( !slide.cells.length ) {
                                slide.addCell( cell );
                                return;
                            }

                            var slideWidth = ( slide.outerWidth - slide.firstMargin ) +
                                    ( cell.size.outerWidth - cell.size[ nextMargin ] );

                            if ( canCellFit.call( this, i, slideWidth ) ) {
                                slide.addCell( cell );
                            } else {
                                // doesn't fit, new slide
                                slide.updateTarget();

                                slide = new Slide( this );
                                this.slides.push( slide );
                                slide.addCell( cell );
                            }
                        }, this );
                        // last slide
                        slide.updateTarget();
                        // update .selectedSlide
                        this.updateSelectedSlide();
                    };

                    proto._getCanCellFit = function() {
                        var groupCells = this.options.groupCells;
                        if ( !groupCells ) {
                            return function() {
                                return false;
                            };
                        } else if ( typeof groupCells == 'number' ) {
                            // group by number. 3 -> [0,1,2], [3,4,5], ...
                            var number = parseInt( groupCells, 10 );
                            return function( i ) {
                                return ( i % number ) !== 0;
                            };
                        }
                        // default, group by width of slide
                        // parse '75%
                        var percentMatch = typeof groupCells == 'string' &&
                                groupCells.match(/^(\d+)%$/);
                        var percent = percentMatch ? parseInt( percentMatch[1], 10 ) / 100 : 1;
                        return function( i, slideWidth ) {
                            return slideWidth <= ( this.size.innerWidth + 1 ) * percent;
                        };
                    };

// alias _init for jQuery plugin .flickity()
                    proto._init =
                            proto.reposition = function() {
                                this.positionCells();
                                this.positionSliderAtSelected();
                            };

                    proto.getSize = function() {
                        this.size = getSize( this.element );
                        this.setCellAlign();
                        this.cursorPosition = this.size.innerWidth * this.cellAlign;
                    };

                    var cellAlignShorthands = {
                        // cell align, then based on origin side
                        center: {
                            left: 0.5,
                            right: 0.5
                        },
                        left: {
                            left: 0,
                            right: 1
                        },
                        right: {
                            right: 0,
                            left: 1
                        }
                    };

                    proto.setCellAlign = function() {
                        var shorthand = cellAlignShorthands[ this.options.cellAlign ];
                        this.cellAlign = shorthand ? shorthand[ this.originSide ] : this.options.cellAlign;
                    };

                    proto.setGallerySize = function() {
                        if ( this.options.setGallerySize ) {
                            var height = this.options.adaptiveHeight && this.selectedSlide ?
                                    this.selectedSlide.height : this.maxCellHeight;
                            this.viewport.style.height = height + 'px';
                        }
                    };

                    proto._getWrapShiftCells = function() {
                        // only for wrap-around
                        if ( !this.options.wrapAround ) {
                            return;
                        }
                        // unshift previous cells
                        this._unshiftCells( this.beforeShiftCells );
                        this._unshiftCells( this.afterShiftCells );
                        // get before cells
                        // initial gap
                        var gapX = this.cursorPosition;
                        var cellIndex = this.cells.length - 1;
                        this.beforeShiftCells = this._getGapCells( gapX, cellIndex, -1 );
                        // get after cells
                        // ending gap between last cell and end of gallery viewport
                        gapX = this.size.innerWidth - this.cursorPosition;
                        // start cloning at first cell, working forwards
                        this.afterShiftCells = this._getGapCells( gapX, 0, 1 );
                    };

                    proto._getGapCells = function( gapX, cellIndex, increment ) {
                        // keep adding cells until the cover the initial gap
                        var cells = [];
                        while ( gapX > 0 ) {
                            var cell = this.cells[ cellIndex ];
                            if ( !cell ) {
                                break;
                            }
                            cells.push( cell );
                            cellIndex += increment;
                            gapX -= cell.size.outerWidth;
                        }
                        return cells;
                    };

// ----- contain ----- //

// contain cell targets so no excess sliding
                    proto._containSlides = function() {
                        if ( !this.options.contain || this.options.wrapAround || !this.cells.length ) {
                            return;
                        }
                        var isRightToLeft = this.options.rightToLeft;
                        var beginMargin = isRightToLeft ? 'marginRight' : 'marginLeft';
                        var endMargin = isRightToLeft ? 'marginLeft' : 'marginRight';
                        var contentWidth = this.slideableWidth - this.getLastCell().size[ endMargin ];
                        // content is less than gallery size
                        var isContentSmaller = contentWidth < this.size.innerWidth;
                        // bounds
                        var beginBound = this.cursorPosition + this.cells[0].size[ beginMargin ];
                        var endBound = contentWidth - this.size.innerWidth * ( 1 - this.cellAlign );
                        // contain each cell target
                        this.slides.forEach( function( slide ) {
                            if ( isContentSmaller ) {
                                // all cells fit inside gallery
                                slide.target = contentWidth * this.cellAlign;
                            } else {
                                // contain to bounds
                                slide.target = Math.max( slide.target, beginBound );
                                slide.target = Math.min( slide.target, endBound );
                            }
                        }, this );
                    };

// -----  ----- //

                    /**
                     * emits events via eventEmitter and jQuery events
                     * @param {String} type - name of event
                     * @param {Event} event - original event
                     * @param {Array} args - extra arguments
                     */
                    proto.dispatchEvent = function( type, event, args ) {
                        var emitArgs = event ? [ event ].concat( args ) : args;
                        this.emitEvent( type, emitArgs );

                        if ( jQuery && this.$element ) {
                            // default trigger with type if no event
                            type += this.options.namespaceJQueryEvents ? '.flickity' : '';
                            var $event = type;
                            if ( event ) {
                                // create jQuery event
                                var jQEvent = jQuery.Event( event );
                                jQEvent.type = type;
                                $event = jQEvent;
                            }
                            this.$element.trigger( $event, args );
                        }
                    };

// -------------------------- select -------------------------- //

                    /**
                     * @param {Integer} index - index of the slide
                     * @param {Boolean} isWrap - will wrap-around to last/first if at the end
                     * @param {Boolean} isInstant - will immediately set position at selected cell
                     */
                    proto.select = function( index, isWrap, isInstant ) {
                        if ( !this.isActive ) {
                            return;
                        }
                        index = parseInt( index, 10 );
                        this._wrapSelect( index );

                        if ( this.options.wrapAround || isWrap ) {
                            index = utils.modulo( index, this.slides.length );
                        }
                        // bail if invalid index
                        if ( !this.slides[ index ] ) {
                            return;
                        }
                        var prevIndex = this.selectedIndex;
                        this.selectedIndex = index;
                        this.updateSelectedSlide();
                        if ( isInstant ) {
                            this.positionSliderAtSelected();
                        } else {
                            this.startAnimation();
                        }
                        if ( this.options.adaptiveHeight ) {
                            this.setGallerySize();
                        }
                        // events
                        this.dispatchEvent( 'select', null, [ index ] );
                        // change event if new index
                        if ( index != prevIndex ) {
                            this.dispatchEvent( 'change', null, [ index ] );
                        }
                        // old v1 event name, remove in v3
                        this.dispatchEvent('cellSelect');
                    };

// wraps position for wrapAround, to move to closest slide. #113
                    proto._wrapSelect = function( index ) {
                        var len = this.slides.length;
                        var isWrapping = this.options.wrapAround && len > 1;
                        if ( !isWrapping ) {
                            return index;
                        }
                        var wrapIndex = utils.modulo( index, len );
                        // go to shortest
                        var delta = Math.abs( wrapIndex - this.selectedIndex );
                        var backWrapDelta = Math.abs( ( wrapIndex + len ) - this.selectedIndex );
                        var forewardWrapDelta = Math.abs( ( wrapIndex - len ) - this.selectedIndex );
                        if ( !this.isDragSelect && backWrapDelta < delta ) {
                            index += len;
                        } else if ( !this.isDragSelect && forewardWrapDelta < delta ) {
                            index -= len;
                        }
                        // wrap position so slider is within normal area
                        if ( index < 0 ) {
                            this.x -= this.slideableWidth;
                        } else if ( index >= len ) {
                            this.x += this.slideableWidth;
                        }
                    };

                    proto.previous = function( isWrap, isInstant ) {
                        this.select( this.selectedIndex - 1, isWrap, isInstant );
                    };

                    proto.next = function( isWrap, isInstant ) {
                        this.select( this.selectedIndex + 1, isWrap, isInstant );
                    };

                    proto.updateSelectedSlide = function() {
                        var slide = this.slides[ this.selectedIndex ];
                        // selectedIndex could be outside of slides, if triggered before resize()
                        if ( !slide ) {
                            return;
                        }
                        // unselect previous selected slide
                        this.unselectSelectedSlide();
                        // update new selected slide
                        this.selectedSlide = slide;
                        slide.select();
                        this.selectedCells = slide.cells;
                        this.selectedElements = slide.getCellElements();
                        // HACK: selectedCell & selectedElement is first cell in slide, backwards compatibility
                        // Remove in v3?
                        this.selectedCell = slide.cells[0];
                        this.selectedElement = this.selectedElements[0];
                    };

                    proto.unselectSelectedSlide = function() {
                        if ( this.selectedSlide ) {
                            this.selectedSlide.unselect();
                        }
                    };

                    proto.selectInitialIndex = function() {
                        var initialIndex = this.options.initialIndex;
                        // already activated, select previous selectedIndex
                        if ( this.isInitActivated ) {
                            this.select( this.selectedIndex, false, true );
                            return;
                        }
                        // select with selector string
                        if ( initialIndex && typeof initialIndex == 'string' ) {
                            var cell = this.queryCell( initialIndex );
                            if ( cell ) {
                                this.selectCell( initialIndex, false, true );
                                return;
                            }
                        }

                        var index = 0;
                        // select with number
                        if ( initialIndex && this.slides[ initialIndex ] ) {
                            index = initialIndex;
                        }
                        // select instantly
                        this.select( index, false, true );
                    };

                    /**
                     * select slide from number or cell element
                     * @param {Element or Number} elem
                     */
                    proto.selectCell = function( value, isWrap, isInstant ) {
                        // get cell
                        var cell = this.queryCell( value );
                        if ( !cell ) {
                            return;
                        }

                        var index = this.getCellSlideIndex( cell );
                        this.select( index, isWrap, isInstant );
                    };

                    proto.getCellSlideIndex = function( cell ) {
                        // get index of slides that has cell
                        for ( var i=0; i < this.slides.length; i++ ) {
                            var slide = this.slides[i];
                            var index = slide.cells.indexOf( cell );
                            if ( index != -1 ) {
                                return i;
                            }
                        }
                    };

// -------------------------- get cells -------------------------- //

                    /**
                     * get Flickity.Cell, given an Element
                     * @param {Element} elem
                     * @returns {Flickity.Cell} item
                     */
                    proto.getCell = function( elem ) {
                        // loop through cells to get the one that matches
                        for ( var i=0; i < this.cells.length; i++ ) {
                            var cell = this.cells[i];
                            if ( cell.element == elem ) {
                                return cell;
                            }
                        }
                    };

                    /**
                     * get collection of Flickity.Cells, given Elements
                     * @param {Element, Array, NodeList} elems
                     * @returns {Array} cells - Flickity.Cells
                     */
                    proto.getCells = function( elems ) {
                        elems = utils.makeArray( elems );
                        var cells = [];
                        elems.forEach( function( elem ) {
                            var cell = this.getCell( elem );
                            if ( cell ) {
                                cells.push( cell );
                            }
                        }, this );
                        return cells;
                    };

                    /**
                     * get cell elements
                     * @returns {Array} cellElems
                     */
                    proto.getCellElements = function() {
                        return this.cells.map( function( cell ) {
                            return cell.element;
                        });
                    };

                    /**
                     * get parent cell from an element
                     * @param {Element} elem
                     * @returns {Flickit.Cell} cell
                     */
                    proto.getParentCell = function( elem ) {
                        // first check if elem is cell
                        var cell = this.getCell( elem );
                        if ( cell ) {
                            return cell;
                        }
                        // try to get parent cell elem
                        elem = utils.getParent( elem, '.flickity-slider > *' );
                        return this.getCell( elem );
                    };

                    /**
                     * get cells adjacent to a slide
                     * @param {Integer} adjCount - number of adjacent slides
                     * @param {Integer} index - index of slide to start
                     * @returns {Array} cells - array of Flickity.Cells
                     */
                    proto.getAdjacentCellElements = function( adjCount, index ) {
                        if ( !adjCount ) {
                            return this.selectedSlide.getCellElements();
                        }
                        index = index === undefined ? this.selectedIndex : index;

                        var len = this.slides.length;
                        if ( 1 + ( adjCount * 2 ) >= len ) {
                            return this.getCellElements();
                        }

                        var cellElems = [];
                        for ( var i = index - adjCount; i <= index + adjCount ; i++ ) {
                            var slideIndex = this.options.wrapAround ? utils.modulo( i, len ) : i;
                            var slide = this.slides[ slideIndex ];
                            if ( slide ) {
                                cellElems = cellElems.concat( slide.getCellElements() );
                            }
                        }
                        return cellElems;
                    };

                    /**
                     * select slide from number or cell element
                     * @param {Element, Selector String, or Number} selector
                     */
                    proto.queryCell = function( selector ) {
                        if ( typeof selector == 'number' ) {
                            // use number as index
                            return this.cells[ selector ];
                        }
                        if ( typeof selector == 'string' ) {
                            // do not select invalid selectors from hash: #123, #/. #791
                            if ( selector.match(/^[#\.]?[\d\/]/) ) {
                                return;
                            }
                            // use string as selector, get element
                            selector = this.element.querySelector( selector );
                        }
                        // get cell from element
                        return this.getCell( selector );
                    };

// -------------------------- events -------------------------- //

                    proto.uiChange = function() {
                        this.emitEvent('uiChange');
                    };

// keep focus on element when child UI elements are clicked
                    proto.childUIPointerDown = function( event ) {
                        // HACK iOS does not allow touch events to bubble up?!
                        if ( event.type != 'touchstart' ) {
                            event.preventDefault();
                        }
                        this.focus();
                    };

// ----- resize ----- //

                    proto.onresize = function() {
                        this.watchCSS();
                        this.resize();
                    };

                    utils.debounceMethod( Flickity, 'onresize', 150 );

                    proto.resize = function() {
                        if ( !this.isActive ) {
                            return;
                        }
                        this.getSize();
                        // wrap values
                        if ( this.options.wrapAround ) {
                            this.x = utils.modulo( this.x, this.slideableWidth );
                        }
                        this.positionCells();
                        this._getWrapShiftCells();
                        this.setGallerySize();
                        this.emitEvent('resize');
                        // update selected index for group slides, instant
                        // TODO: position can be lost between groups of various numbers
                        var selectedElement = this.selectedElements && this.selectedElements[0];
                        this.selectCell( selectedElement, false, true );
                    };

// watches the :after property, activates/deactivates
                    proto.watchCSS = function() {
                        var watchOption = this.options.watchCSS;
                        if ( !watchOption ) {
                            return;
                        }

                        var afterContent = getComputedStyle( this.element, ':after' ).content;
                        // activate if :after { content: 'flickity' }
                        if ( afterContent.indexOf('flickity') != -1 ) {
                            this.activate();
                        } else {
                            this.deactivate();
                        }
                    };

// ----- keydown ----- //

// go previous/next if left/right keys pressed
                    proto.onkeydown = function( event ) {
                        // only work if element is in focus
                        var isNotFocused = document.activeElement && document.activeElement != this.element;
                        if ( !this.options.accessibility ||isNotFocused ) {
                            return;
                        }

                        var handler = Flickity.keyboardHandlers[ event.keyCode ];
                        if ( handler ) {
                            handler.call( this );
                        }
                    };

                    Flickity.keyboardHandlers = {
                        // left arrow
                        37: function() {
                            var leftMethod = this.options.rightToLeft ? 'next' : 'previous';
                            this.uiChange();
                            this[ leftMethod ]();
                        },
                        // right arrow
                        39: function() {
                            var rightMethod = this.options.rightToLeft ? 'previous' : 'next';
                            this.uiChange();
                            this[ rightMethod ]();
                        },
                    };

// ----- focus ----- //

                    proto.focus = function() {
                        // TODO remove scrollTo once focus options gets more support
                        // https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/focus#Browser_compatibility
                        var prevScrollY = window.pageYOffset;
                        this.element.focus({ preventScroll: true });
                        // hack to fix scroll jump after focus, #76
                        if ( window.pageYOffset != prevScrollY ) {
                            window.scrollTo( window.pageXOffset, prevScrollY );
                        }
                    };

// -------------------------- destroy -------------------------- //

// deactivate all Flickity functionality, but keep stuff available
                    proto.deactivate = function() {
                        if ( !this.isActive ) {
                            return;
                        }
                        this.element.classList.remove('flickity-enabled');
                        this.element.classList.remove('flickity-rtl');
                        this.unselectSelectedSlide();
                        // destroy cells
                        this.cells.forEach( function( cell ) {
                            cell.destroy();
                        });
                        this.element.removeChild( this.viewport );
                        // move child elements back into element
                        moveElements( this.slider.children, this.element );
                        if ( this.options.accessibility ) {
                            this.element.removeAttribute('tabIndex');
                            this.element.removeEventListener( 'keydown', this );
                        }
                        // set flags
                        this.isActive = false;
                        this.emitEvent('deactivate');
                    };

                    proto.destroy = function() {
                        this.deactivate();
                        window.removeEventListener( 'resize', this );
                        this.allOff();
                        this.emitEvent('destroy');
                        if ( jQuery && this.$element ) {
                            jQuery.removeData( this.element, 'flickity' );
                        }
                        delete this.element.flickityGUID;
                        delete instances[ this.guid ];
                    };

// -------------------------- prototype -------------------------- //

                    utils.extend( proto, animatePrototype );

// -------------------------- extras -------------------------- //

                    /**
                     * get Flickity instance from element
                     * @param {Element} elem
                     * @returns {Flickity}
                     */
                    Flickity.data = function( elem ) {
                        elem = utils.getQueryElement( elem );
                        var id = elem && elem.flickityGUID;
                        return id && instances[ id ];
                    };

                    utils.htmlInit( Flickity, 'flickity' );

                    if ( jQuery && jQuery.bridget ) {
                        jQuery.bridget( 'flickity', Flickity );
                    }

// set internal jQuery, for Webpack + jQuery v3, #478
                    Flickity.setJQuery = function( jq ) {
                        jQuery = jq;
                    };

                    Flickity.Cell = Cell;
                    Flickity.Slide = Slide;

                    return Flickity;

                }));
            });

            var unipointer = createCommonjsModule(function (module) {
                /*!
                 * Unipointer v2.3.0
                 * base class for doing one thing with pointer event
                 * MIT license
                 */

                /*jshint browser: true, undef: true, unused: true, strict: true */

                ( function( window, factory ) {
                    // universal module definition
                    /* jshint strict: false */ /*global define, module, require */
                    if (  module.exports ) {
                        // CommonJS
                        module.exports = factory(
                                window,
                                evEmitter
                        );
                    } else {
                        // browser global
                        window.Unipointer = factory(
                                window,
                                window.EvEmitter
                        );
                    }

                }( window, function factory( window, EvEmitter ) {

                    function noop() {}

                    function Unipointer() {}

// inherit EvEmitter
                    var proto = Unipointer.prototype = Object.create( EvEmitter.prototype );

                    proto.bindStartEvent = function( elem ) {
                        this._bindStartEvent( elem, true );
                    };

                    proto.unbindStartEvent = function( elem ) {
                        this._bindStartEvent( elem, false );
                    };

                    /**
                     * Add or remove start event
                     * @param {Boolean} isAdd - remove if falsey
                     */
                    proto._bindStartEvent = function( elem, isAdd ) {
                        // munge isAdd, default to true
                        isAdd = isAdd === undefined ? true : isAdd;
                        var bindMethod = isAdd ? 'addEventListener' : 'removeEventListener';

                        // default to mouse events
                        var startEvent = 'mousedown';
                        if ( window.PointerEvent ) {
                            // Pointer Events
                            startEvent = 'pointerdown';
                        } else if ( 'ontouchstart' in window ) {
                            // Touch Events. iOS Safari
                            startEvent = 'touchstart';
                        }
                        elem[ bindMethod ]( startEvent, this );
                    };

// trigger handler methods for events
                    proto.handleEvent = function( event ) {
                        var method = 'on' + event.type;
                        if ( this[ method ] ) {
                            this[ method ]( event );
                        }
                    };

// returns the touch that we're keeping track of
                    proto.getTouch = function( touches ) {
                        for ( var i=0; i < touches.length; i++ ) {
                            var touch = touches[i];
                            if ( touch.identifier == this.pointerIdentifier ) {
                                return touch;
                            }
                        }
                    };

// ----- start event ----- //

                    proto.onmousedown = function( event ) {
                        // dismiss clicks from right or middle buttons
                        var button = event.button;
                        if ( button && ( button !== 0 && button !== 1 ) ) {
                            return;
                        }
                        this._pointerDown( event, event );
                    };

                    proto.ontouchstart = function( event ) {
                        this._pointerDown( event, event.changedTouches[0] );
                    };

                    proto.onpointerdown = function( event ) {
                        this._pointerDown( event, event );
                    };

                    /**
                     * pointer start
                     * @param {Event} event
                     * @param {Event or Touch} pointer
                     */
                    proto._pointerDown = function( event, pointer ) {
                        // dismiss right click and other pointers
                        // button = 0 is okay, 1-4 not
                        if ( event.button || this.isPointerDown ) {
                            return;
                        }

                        this.isPointerDown = true;
                        // save pointer identifier to match up touch events
                        this.pointerIdentifier = pointer.pointerId !== undefined ?
                                // pointerId for pointer events, touch.indentifier for touch events
                                pointer.pointerId : pointer.identifier;

                        this.pointerDown( event, pointer );
                    };

                    proto.pointerDown = function( event, pointer ) {
                        this._bindPostStartEvents( event );
                        this.emitEvent( 'pointerDown', [ event, pointer ] );
                    };

// hash of events to be bound after start event
                    var postStartEvents = {
                        mousedown: [ 'mousemove', 'mouseup' ],
                        touchstart: [ 'touchmove', 'touchend', 'touchcancel' ],
                        pointerdown: [ 'pointermove', 'pointerup', 'pointercancel' ],
                    };

                    proto._bindPostStartEvents = function( event ) {
                        if ( !event ) {
                            return;
                        }
                        // get proper events to match start event
                        var events = postStartEvents[ event.type ];
                        // bind events to node
                        events.forEach( function( eventName ) {
                            window.addEventListener( eventName, this );
                        }, this );
                        // save these arguments
                        this._boundPointerEvents = events;
                    };

                    proto._unbindPostStartEvents = function() {
                        // check for _boundEvents, in case dragEnd triggered twice (old IE8 bug)
                        if ( !this._boundPointerEvents ) {
                            return;
                        }
                        this._boundPointerEvents.forEach( function( eventName ) {
                            window.removeEventListener( eventName, this );
                        }, this );

                        delete this._boundPointerEvents;
                    };

// ----- move event ----- //

                    proto.onmousemove = function( event ) {
                        this._pointerMove( event, event );
                    };

                    proto.onpointermove = function( event ) {
                        if ( event.pointerId == this.pointerIdentifier ) {
                            this._pointerMove( event, event );
                        }
                    };

                    proto.ontouchmove = function( event ) {
                        var touch = this.getTouch( event.changedTouches );
                        if ( touch ) {
                            this._pointerMove( event, touch );
                        }
                    };

                    /**
                     * pointer move
                     * @param {Event} event
                     * @param {Event or Touch} pointer
                     * @private
                     */
                    proto._pointerMove = function( event, pointer ) {
                        this.pointerMove( event, pointer );
                    };

// public
                    proto.pointerMove = function( event, pointer ) {
                        this.emitEvent( 'pointerMove', [ event, pointer ] );
                    };

// ----- end event ----- //


                    proto.onmouseup = function( event ) {
                        this._pointerUp( event, event );
                    };

                    proto.onpointerup = function( event ) {
                        if ( event.pointerId == this.pointerIdentifier ) {
                            this._pointerUp( event, event );
                        }
                    };

                    proto.ontouchend = function( event ) {
                        var touch = this.getTouch( event.changedTouches );
                        if ( touch ) {
                            this._pointerUp( event, touch );
                        }
                    };

                    /**
                     * pointer up
                     * @param {Event} event
                     * @param {Event or Touch} pointer
                     * @private
                     */
                    proto._pointerUp = function( event, pointer ) {
                        this._pointerDone();
                        this.pointerUp( event, pointer );
                    };

// public
                    proto.pointerUp = function( event, pointer ) {
                        this.emitEvent( 'pointerUp', [ event, pointer ] );
                    };

// ----- pointer done ----- //

// triggered on pointer up & pointer cancel
                    proto._pointerDone = function() {
                        this._pointerReset();
                        this._unbindPostStartEvents();
                        this.pointerDone();
                    };

                    proto._pointerReset = function() {
                        // reset properties
                        this.isPointerDown = false;
                        delete this.pointerIdentifier;
                    };

                    proto.pointerDone = noop;

// ----- pointer cancel ----- //

                    proto.onpointercancel = function( event ) {
                        if ( event.pointerId == this.pointerIdentifier ) {
                            this._pointerCancel( event, event );
                        }
                    };

                    proto.ontouchcancel = function( event ) {
                        var touch = this.getTouch( event.changedTouches );
                        if ( touch ) {
                            this._pointerCancel( event, touch );
                        }
                    };

                    /**
                     * pointer cancel
                     * @param {Event} event
                     * @param {Event or Touch} pointer
                     * @private
                     */
                    proto._pointerCancel = function( event, pointer ) {
                        this._pointerDone();
                        this.pointerCancel( event, pointer );
                    };

// public
                    proto.pointerCancel = function( event, pointer ) {
                        this.emitEvent( 'pointerCancel', [ event, pointer ] );
                    };

// -----  ----- //

// utility function for getting x/y coords from event
                    Unipointer.getPointerPoint = function( pointer ) {
                        return {
                            x: pointer.pageX,
                            y: pointer.pageY
                        };
                    };

// -----  ----- //

                    return Unipointer;

                }));
            });

            var unidragger = createCommonjsModule(function (module) {
                /*!
                 * Unidragger v2.3.0
                 * Draggable base class
                 * MIT license
                 */

                /*jshint browser: true, unused: true, undef: true, strict: true */

                ( function( window, factory ) {
                    // universal module definition
                    /*jshint strict: false */ /*globals define, module, require */

                    if (  module.exports ) {
                        // CommonJS
                        module.exports = factory(
                                window,
                                unipointer
                        );
                    } else {
                        // browser global
                        window.Unidragger = factory(
                                window,
                                window.Unipointer
                        );
                    }

                }( window, function factory( window, Unipointer ) {

// -------------------------- Unidragger -------------------------- //

                    function Unidragger() {}

// inherit Unipointer & EvEmitter
                    var proto = Unidragger.prototype = Object.create( Unipointer.prototype );

// ----- bind start ----- //

                    proto.bindHandles = function() {
                        this._bindHandles( true );
                    };

                    proto.unbindHandles = function() {
                        this._bindHandles( false );
                    };

                    /**
                     * Add or remove start event
                     * @param {Boolean} isAdd
                     */
                    proto._bindHandles = function( isAdd ) {
                        // munge isAdd, default to true
                        isAdd = isAdd === undefined ? true : isAdd;
                        // bind each handle
                        var bindMethod = isAdd ? 'addEventListener' : 'removeEventListener';
                        var touchAction = isAdd ? this._touchActionValue : '';
                        for ( var i=0; i < this.handles.length; i++ ) {
                            var handle = this.handles[i];
                            this._bindStartEvent( handle, isAdd );
                            handle[ bindMethod ]( 'click', this );
                            // touch-action: none to override browser touch gestures. metafizzy/flickity#540
                            if ( window.PointerEvent ) {
                                handle.style.touchAction = touchAction;
                            }
                        }
                    };

// prototype so it can be overwriteable by Flickity
                    proto._touchActionValue = 'none';

// ----- start event ----- //

                    /**
                     * pointer start
                     * @param {Event} event
                     * @param {Event or Touch} pointer
                     */
                    proto.pointerDown = function( event, pointer ) {
                        var isOkay = this.okayPointerDown( event );
                        if ( !isOkay ) {
                            return;
                        }
                        // track start event position
                        this.pointerDownPointer = pointer;

                        event.preventDefault();
                        this.pointerDownBlur();
                        // bind move and end events
                        this._bindPostStartEvents( event );
                        this.emitEvent( 'pointerDown', [ event, pointer ] );
                    };

// nodes that have text fields
                    var cursorNodes = {
                        TEXTAREA: true,
                        INPUT: true,
                        SELECT: true,
                        OPTION: true,
                    };

// input types that do not have text fields
                    var clickTypes = {
                        radio: true,
                        checkbox: true,
                        button: true,
                        submit: true,
                        image: true,
                        file: true,
                    };

// dismiss inputs with text fields. flickity#403, flickity#404
                    proto.okayPointerDown = function( event ) {
                        var isCursorNode = cursorNodes[ event.target.nodeName ];
                        var isClickType = clickTypes[ event.target.type ];
                        var isOkay = !isCursorNode || isClickType;
                        if ( !isOkay ) {
                            this._pointerReset();
                        }
                        return isOkay;
                    };

// kludge to blur previously focused input
                    proto.pointerDownBlur = function() {
                        var focused = document.activeElement;
                        // do not blur body for IE10, metafizzy/flickity#117
                        var canBlur = focused && focused.blur && focused != document.body;
                        if ( canBlur ) {
                            focused.blur();
                        }
                    };

// ----- move event ----- //

                    /**
                     * drag move
                     * @param {Event} event
                     * @param {Event or Touch} pointer
                     */
                    proto.pointerMove = function( event, pointer ) {
                        var moveVector = this._dragPointerMove( event, pointer );
                        this.emitEvent( 'pointerMove', [ event, pointer, moveVector ] );
                        this._dragMove( event, pointer, moveVector );
                    };

// base pointer move logic
                    proto._dragPointerMove = function( event, pointer ) {
                        var moveVector = {
                            x: pointer.pageX - this.pointerDownPointer.pageX,
                            y: pointer.pageY - this.pointerDownPointer.pageY
                        };
                        // start drag if pointer has moved far enough to start drag
                        if ( !this.isDragging && this.hasDragStarted( moveVector ) ) {
                            this._dragStart( event, pointer );
                        }
                        return moveVector;
                    };

// condition if pointer has moved far enough to start drag
                    proto.hasDragStarted = function( moveVector ) {
                        return Math.abs( moveVector.x ) > 3 || Math.abs( moveVector.y ) > 3;
                    };

// ----- end event ----- //

                    /**
                     * pointer up
                     * @param {Event} event
                     * @param {Event or Touch} pointer
                     */
                    proto.pointerUp = function( event, pointer ) {
                        this.emitEvent( 'pointerUp', [ event, pointer ] );
                        this._dragPointerUp( event, pointer );
                    };

                    proto._dragPointerUp = function( event, pointer ) {
                        if ( this.isDragging ) {
                            this._dragEnd( event, pointer );
                        } else {
                            // pointer didn't move enough for drag to start
                            this._staticClick( event, pointer );
                        }
                    };

// -------------------------- drag -------------------------- //

// dragStart
                    proto._dragStart = function( event, pointer ) {
                        this.isDragging = true;
                        // prevent clicks
                        this.isPreventingClicks = true;
                        this.dragStart( event, pointer );
                    };

                    proto.dragStart = function( event, pointer ) {
                        this.emitEvent( 'dragStart', [ event, pointer ] );
                    };

// dragMove
                    proto._dragMove = function( event, pointer, moveVector ) {
                        // do not drag if not dragging yet
                        if ( !this.isDragging ) {
                            return;
                        }

                        this.dragMove( event, pointer, moveVector );
                    };

                    proto.dragMove = function( event, pointer, moveVector ) {
                        event.preventDefault();
                        this.emitEvent( 'dragMove', [ event, pointer, moveVector ] );
                    };

// dragEnd
                    proto._dragEnd = function( event, pointer ) {
                        // set flags
                        this.isDragging = false;
                        // re-enable clicking async
                        setTimeout( function() {
                            delete this.isPreventingClicks;
                        }.bind( this ) );

                        this.dragEnd( event, pointer );
                    };

                    proto.dragEnd = function( event, pointer ) {
                        this.emitEvent( 'dragEnd', [ event, pointer ] );
                    };

// ----- onclick ----- //

// handle all clicks and prevent clicks when dragging
                    proto.onclick = function( event ) {
                        if ( this.isPreventingClicks ) {
                            event.preventDefault();
                        }
                    };

// ----- staticClick ----- //

// triggered after pointer down & up with no/tiny movement
                    proto._staticClick = function( event, pointer ) {
                        // ignore emulated mouse up clicks
                        if ( this.isIgnoringMouseUp && event.type == 'mouseup' ) {
                            return;
                        }

                        this.staticClick( event, pointer );

                        // set flag for emulated clicks 300ms after touchend
                        if ( event.type != 'mouseup' ) {
                            this.isIgnoringMouseUp = true;
                            // reset flag after 300ms
                            setTimeout( function() {
                                delete this.isIgnoringMouseUp;
                            }.bind( this ), 400 );
                        }
                    };

                    proto.staticClick = function( event, pointer ) {
                        this.emitEvent( 'staticClick', [ event, pointer ] );
                    };

// ----- utils ----- //

                    Unidragger.getPointerPoint = Unipointer.getPointerPoint;

// -----  ----- //

                    return Unidragger;

                }));
            });

            var drag = createCommonjsModule(function (module) {
// drag
                ( function( window, factory ) {
                    // universal module definition
                    /* jshint strict: false */
                    if (  module.exports ) {
                        // CommonJS
                        module.exports = factory(
                                window,
                                flickity,
                                unidragger,
                                utils
                        );
                    } else {
                        // browser global
                        window.Flickity = factory(
                                window,
                                window.Flickity,
                                window.Unidragger,
                                window.fizzyUIUtils
                        );
                    }

                }( window, function factory( window, Flickity, Unidragger, utils ) {

// ----- defaults ----- //

                    utils.extend( Flickity.defaults, {
                        draggable: '>1',
                        dragThreshold: 3,
                    });

// ----- create ----- //

                    Flickity.createMethods.push('_createDrag');

// -------------------------- drag prototype -------------------------- //

                    var proto = Flickity.prototype;
                    utils.extend( proto, Unidragger.prototype );
                    proto._touchActionValue = 'pan-y';

// --------------------------  -------------------------- //

                    var isTouch = 'createTouch' in document;
                    var isTouchmoveScrollCanceled = false;

                    proto._createDrag = function() {
                        this.on( 'activate', this.onActivateDrag );
                        this.on( 'uiChange', this._uiChangeDrag );
                        this.on( 'deactivate', this.onDeactivateDrag );
                        this.on( 'cellChange', this.updateDraggable );
                        // TODO updateDraggable on resize? if groupCells & slides change
                        // HACK - add seemingly innocuous handler to fix iOS 10 scroll behavior
                        // #457, RubaXa/Sortable#973
                        if ( isTouch && !isTouchmoveScrollCanceled ) {
                            window.addEventListener( 'touchmove', function() {});
                            isTouchmoveScrollCanceled = true;
                        }
                    };

                    proto.onActivateDrag = function() {
                        this.handles = [ this.viewport ];
                        this.bindHandles();
                        this.updateDraggable();
                    };

                    proto.onDeactivateDrag = function() {
                        this.unbindHandles();
                        this.element.classList.remove('is-draggable');
                    };

                    proto.updateDraggable = function() {
                        // disable dragging if less than 2 slides. #278
                        if ( this.options.draggable == '>1' ) {
                            this.isDraggable = this.slides.length > 1;
                        } else {
                            this.isDraggable = this.options.draggable;
                        }
                        if ( this.isDraggable ) {
                            this.element.classList.add('is-draggable');
                        } else {
                            this.element.classList.remove('is-draggable');
                        }
                    };

// backwards compatibility
                    proto.bindDrag = function() {
                        this.options.draggable = true;
                        this.updateDraggable();
                    };

                    proto.unbindDrag = function() {
                        this.options.draggable = false;
                        this.updateDraggable();
                    };

                    proto._uiChangeDrag = function() {
                        delete this.isFreeScrolling;
                    };

// -------------------------- pointer events -------------------------- //

                    proto.pointerDown = function( event, pointer ) {
                        if ( !this.isDraggable ) {
                            this._pointerDownDefault( event, pointer );
                            return;
                        }
                        var isOkay = this.okayPointerDown( event );
                        if ( !isOkay ) {
                            return;
                        }

                        this._pointerDownPreventDefault( event );
                        this.pointerDownFocus( event );
                        // blur
                        if ( document.activeElement != this.element ) {
                            // do not blur if already focused
                            this.pointerDownBlur();
                        }

                        // stop if it was moving
                        this.dragX = this.x;
                        this.viewport.classList.add('is-pointer-down');
                        // track scrolling
                        this.pointerDownScroll = getScrollPosition();
                        window.addEventListener( 'scroll', this );

                        this._pointerDownDefault( event, pointer );
                    };

// default pointerDown logic, used for staticClick
                    proto._pointerDownDefault = function( event, pointer ) {
                        // track start event position
                        // Safari 9 overrides pageX and pageY. These values needs to be copied. #779
                        this.pointerDownPointer = {
                            pageX: pointer.pageX,
                            pageY: pointer.pageY,
                        };
                        // bind move and end events
                        this._bindPostStartEvents( event );
                        this.dispatchEvent( 'pointerDown', event, [ pointer ] );
                    };

                    var focusNodes = {
                        INPUT: true,
                        TEXTAREA: true,
                        SELECT: true,
                    };

                    proto.pointerDownFocus = function( event ) {
                        var isFocusNode = focusNodes[ event.target.nodeName ];
                        if ( !isFocusNode ) {
                            this.focus();
                        }
                    };

                    proto._pointerDownPreventDefault = function( event ) {
                        var isTouchStart = event.type == 'touchstart';
                        var isTouchPointer = event.pointerType == 'touch';
                        var isFocusNode = focusNodes[ event.target.nodeName ];
                        if ( !isTouchStart && !isTouchPointer && !isFocusNode ) {
                            event.preventDefault();
                        }
                    };

// ----- move ----- //

                    proto.hasDragStarted = function( moveVector ) {
                        return Math.abs( moveVector.x ) > this.options.dragThreshold;
                    };

// ----- up ----- //

                    proto.pointerUp = function( event, pointer ) {
                        delete this.isTouchScrolling;
                        this.viewport.classList.remove('is-pointer-down');
                        this.dispatchEvent( 'pointerUp', event, [ pointer ] );
                        this._dragPointerUp( event, pointer );
                    };

                    proto.pointerDone = function() {
                        window.removeEventListener( 'scroll', this );
                        delete this.pointerDownScroll;
                    };

// -------------------------- dragging -------------------------- //

                    proto.dragStart = function( event, pointer ) {
                        if ( !this.isDraggable ) {
                            return;
                        }
                        this.dragStartPosition = this.x;
                        this.startAnimation();
                        window.removeEventListener( 'scroll', this );
                        this.dispatchEvent( 'dragStart', event, [ pointer ] );
                    };

                    proto.pointerMove = function( event, pointer ) {
                        var moveVector = this._dragPointerMove( event, pointer );
                        this.dispatchEvent( 'pointerMove', event, [ pointer, moveVector ] );
                        this._dragMove( event, pointer, moveVector );
                    };

                    proto.dragMove = function( event, pointer, moveVector ) {
                        if ( !this.isDraggable ) {
                            return;
                        }
                        event.preventDefault();

                        this.previousDragX = this.dragX;
                        // reverse if right-to-left
                        var direction = this.options.rightToLeft ? -1 : 1;
                        if ( this.options.wrapAround ) {
                            // wrap around move. #589
                            moveVector.x = moveVector.x % this.slideableWidth;
                        }
                        var dragX = this.dragStartPosition + moveVector.x * direction;

                        if ( !this.options.wrapAround && this.slides.length ) {
                            // slow drag
                            var originBound = Math.max( -this.slides[0].target, this.dragStartPosition );
                            dragX = dragX > originBound ? ( dragX + originBound ) * 0.5 : dragX;
                            var endBound = Math.min( -this.getLastSlide().target, this.dragStartPosition );
                            dragX = dragX < endBound ? ( dragX + endBound ) * 0.5 : dragX;
                        }

                        this.dragX = dragX;

                        this.dragMoveTime = new Date();
                        this.dispatchEvent( 'dragMove', event, [ pointer, moveVector ] );
                    };

                    proto.dragEnd = function( event, pointer ) {
                        if ( !this.isDraggable ) {
                            return;
                        }
                        if ( this.options.freeScroll ) {
                            this.isFreeScrolling = true;
                        }
                        // set selectedIndex based on where flick will end up
                        var index = this.dragEndRestingSelect();

                        if ( this.options.freeScroll && !this.options.wrapAround ) {
                            // if free-scroll & not wrap around
                            // do not free-scroll if going outside of bounding slides
                            // so bounding slides can attract slider, and keep it in bounds
                            var restingX = this.getRestingPosition();
                            this.isFreeScrolling = -restingX > this.slides[0].target &&
                                    -restingX < this.getLastSlide().target;
                        } else if ( !this.options.freeScroll && index == this.selectedIndex ) {
                            // boost selection if selected index has not changed
                            index += this.dragEndBoostSelect();
                        }
                        delete this.previousDragX;
                        // apply selection
                        // TODO refactor this, selecting here feels weird
                        // HACK, set flag so dragging stays in correct direction
                        this.isDragSelect = this.options.wrapAround;
                        this.select( index );
                        delete this.isDragSelect;
                        this.dispatchEvent( 'dragEnd', event, [ pointer ] );
                    };

                    proto.dragEndRestingSelect = function() {
                        var restingX = this.getRestingPosition();
                        // how far away from selected slide
                        var distance = Math.abs( this.getSlideDistance( -restingX, this.selectedIndex ) );
                        // get closet resting going up and going down
                        var positiveResting = this._getClosestResting( restingX, distance, 1 );
                        var negativeResting = this._getClosestResting( restingX, distance, -1 );
                        // use closer resting for wrap-around
                        var index = positiveResting.distance < negativeResting.distance ?
                                positiveResting.index : negativeResting.index;
                        return index;
                    };

                    /**
                     * given resting X and distance to selected cell
                     * get the distance and index of the closest cell
                     * @param {Number} restingX - estimated post-flick resting position
                     * @param {Number} distance - distance to selected cell
                     * @param {Integer} increment - +1 or -1, going up or down
                     * @returns {Object} - { distance: {Number}, index: {Integer} }
                     */
                    proto._getClosestResting = function( restingX, distance, increment ) {
                        var index = this.selectedIndex;
                        var minDistance = Infinity;
                        var condition = this.options.contain && !this.options.wrapAround ?
                                // if contain, keep going if distance is equal to minDistance
                                function( d, md ) { return d <= md; } : function( d, md ) { return d < md; };
                        while ( condition( distance, minDistance ) ) {
                            // measure distance to next cell
                            index += increment;
                            minDistance = distance;
                            distance = this.getSlideDistance( -restingX, index );
                            if ( distance === null ) {
                                break;
                            }
                            distance = Math.abs( distance );
                        }
                        return {
                            distance: minDistance,
                            // selected was previous index
                            index: index - increment
                        };
                    };

                    /**
                     * measure distance between x and a slide target
                     * @param {Number} x
                     * @param {Integer} index - slide index
                     */
                    proto.getSlideDistance = function( x, index ) {
                        var len = this.slides.length;
                        // wrap around if at least 2 slides
                        var isWrapAround = this.options.wrapAround && len > 1;
                        var slideIndex = isWrapAround ? utils.modulo( index, len ) : index;
                        var slide = this.slides[ slideIndex ];
                        if ( !slide ) {
                            return null;
                        }
                        // add distance for wrap-around slides
                        var wrap = isWrapAround ? this.slideableWidth * Math.floor( index / len ) : 0;
                        return x - ( slide.target + wrap );
                    };

                    proto.dragEndBoostSelect = function() {
                        // do not boost if no previousDragX or dragMoveTime
                        if ( this.previousDragX === undefined || !this.dragMoveTime ||
                                // or if drag was held for 100 ms
                                new Date() - this.dragMoveTime > 100 ) {
                            return 0;
                        }

                        var distance = this.getSlideDistance( -this.dragX, this.selectedIndex );
                        var delta = this.previousDragX - this.dragX;
                        if ( distance > 0 && delta > 0 ) {
                            // boost to next if moving towards the right, and positive velocity
                            return 1;
                        } else if ( distance < 0 && delta < 0 ) {
                            // boost to previous if moving towards the left, and negative velocity
                            return -1;
                        }
                        return 0;
                    };

// ----- staticClick ----- //

                    proto.staticClick = function( event, pointer ) {
                        // get clickedCell, if cell was clicked
                        var clickedCell = this.getParentCell( event.target );
                        var cellElem = clickedCell && clickedCell.element;
                        var cellIndex = clickedCell && this.cells.indexOf( clickedCell );
                        this.dispatchEvent( 'staticClick', event, [ pointer, cellElem, cellIndex ] );
                    };

// ----- scroll ----- //

                    proto.onscroll = function() {
                        var scroll = getScrollPosition();
                        var scrollMoveX = this.pointerDownScroll.x - scroll.x;
                        var scrollMoveY = this.pointerDownScroll.y - scroll.y;
                        // cancel click/tap if scroll is too much
                        if ( Math.abs( scrollMoveX ) > 3 || Math.abs( scrollMoveY ) > 3 ) {
                            this._pointerDone();
                        }
                    };

// ----- utils ----- //

                    function getScrollPosition() {
                        return {
                            x: window.pageXOffset,
                            y: window.pageYOffset
                        };
                    }

// -----  ----- //

                    return Flickity;

                }));
            });

            var prevNextButton = createCommonjsModule(function (module) {
// prev/next buttons
                ( function( window, factory ) {
                    // universal module definition
                    /* jshint strict: false */
                    if (  module.exports ) {
                        // CommonJS
                        module.exports = factory(
                                window,
                                flickity,
                                unipointer,
                                utils
                        );
                    } else {
                        // browser global
                        factory(
                                window,
                                window.Flickity,
                                window.Unipointer,
                                window.fizzyUIUtils
                        );
                    }

                }( window, function factory( window, Flickity, Unipointer, utils ) {

                    var svgURI = 'http://www.w3.org/2000/svg';

// -------------------------- PrevNextButton -------------------------- //

                    function PrevNextButton( direction, parent ) {
                        this.direction = direction;
                        this.parent = parent;
                        this._create();
                    }

                    PrevNextButton.prototype = Object.create( Unipointer.prototype );

                    PrevNextButton.prototype._create = function() {
                        // properties
                        this.isEnabled = true;
                        this.isPrevious = this.direction == -1;
                        var leftDirection = this.parent.options.rightToLeft ? 1 : -1;
                        this.isLeft = this.direction == leftDirection;

                        var element = this.element = document.createElement('button');
                        element.className = 'flickity-button flickity-prev-next-button';
                        element.className += this.isPrevious ? ' previous' : ' next';
                        // prevent button from submitting form http://stackoverflow.com/a/10836076/182183
                        element.setAttribute( 'type', 'button' );
                        // init as disabled
                        this.disable();

                        element.setAttribute( 'aria-label', this.isPrevious ? 'Previous' : 'Next' );

                        // create arrow
                        var svg = this.createSVG();
                        element.appendChild( svg );
                        // events
                        this.parent.on( 'select', this.update.bind( this ) );
                        this.on( 'pointerDown', this.parent.childUIPointerDown.bind( this.parent ) );
                    };

                    PrevNextButton.prototype.activate = function() {
                        this.bindStartEvent( this.element );
                        this.element.addEventListener( 'click', this );
                        // add to DOM
                        this.parent.element.appendChild( this.element );
                    };

                    PrevNextButton.prototype.deactivate = function() {
                        // remove from DOM
                        this.parent.element.removeChild( this.element );
                        // click events
                        this.unbindStartEvent( this.element );
                        this.element.removeEventListener( 'click', this );
                    };

                    PrevNextButton.prototype.createSVG = function() {
                        var svg = document.createElementNS( svgURI, 'svg');
                        svg.setAttribute( 'class', 'flickity-button-icon' );
                        svg.setAttribute( 'viewBox', '0 0 100 100' );
                        var path = document.createElementNS( svgURI, 'path');
                        var pathMovements = getArrowMovements( this.parent.options.arrowShape );
                        path.setAttribute( 'd', pathMovements );
                        path.setAttribute( 'class', 'arrow' );
                        // rotate arrow
                        if ( !this.isLeft ) {
                            path.setAttribute( 'transform', 'translate(100, 100) rotate(180) ' );
                        }
                        svg.appendChild( path );
                        return svg;
                    };

// get SVG path movmement
                    function getArrowMovements( shape ) {
                        // use shape as movement if string
                        if ( typeof shape == 'string' ) {
                            return shape;
                        }
                        // create movement string
                        return 'M ' + shape.x0 + ',50' +
                                ' L ' + shape.x1 + ',' + ( shape.y1 + 50 ) +
                                ' L ' + shape.x2 + ',' + ( shape.y2 + 50 ) +
                                ' L ' + shape.x3 + ',50 ' +
                                ' L ' + shape.x2 + ',' + ( 50 - shape.y2 ) +
                                ' L ' + shape.x1 + ',' + ( 50 - shape.y1 ) +
                                ' Z';
                    }

                    PrevNextButton.prototype.handleEvent = utils.handleEvent;

                    PrevNextButton.prototype.onclick = function() {
                        if ( !this.isEnabled ) {
                            return;
                        }
                        this.parent.uiChange();
                        var method = this.isPrevious ? 'previous' : 'next';
                        this.parent[ method ]();
                    };

// -----  ----- //

                    PrevNextButton.prototype.enable = function() {
                        if ( this.isEnabled ) {
                            return;
                        }
                        this.element.disabled = false;
                        this.isEnabled = true;
                    };

                    PrevNextButton.prototype.disable = function() {
                        if ( !this.isEnabled ) {
                            return;
                        }
                        this.element.disabled = true;
                        this.isEnabled = false;
                    };

                    PrevNextButton.prototype.update = function() {
                        // index of first or last slide, if previous or next
                        var slides = this.parent.slides;
                        // enable is wrapAround and at least 2 slides
                        if ( this.parent.options.wrapAround && slides.length > 1 ) {
                            this.enable();
                            return;
                        }
                        var lastIndex = slides.length ? slides.length - 1 : 0;
                        var boundIndex = this.isPrevious ? 0 : lastIndex;
                        var method = this.parent.selectedIndex == boundIndex ? 'disable' : 'enable';
                        this[ method ]();
                    };

                    PrevNextButton.prototype.destroy = function() {
                        this.deactivate();
                        this.allOff();
                    };

// -------------------------- Flickity prototype -------------------------- //

                    utils.extend( Flickity.defaults, {
                        prevNextButtons: true,
                        arrowShape: {
                            x0: 10,
                            x1: 60, y1: 50,
                            x2: 70, y2: 40,
                            x3: 30
                        }
                    });

                    Flickity.createMethods.push('_createPrevNextButtons');
                    var proto = Flickity.prototype;

                    proto._createPrevNextButtons = function() {
                        if ( !this.options.prevNextButtons ) {
                            return;
                        }

                        this.prevButton = new PrevNextButton( -1, this );
                        this.nextButton = new PrevNextButton( 1, this );

                        this.on( 'activate', this.activatePrevNextButtons );
                    };

                    proto.activatePrevNextButtons = function() {
                        this.prevButton.activate();
                        this.nextButton.activate();
                        this.on( 'deactivate', this.deactivatePrevNextButtons );
                    };

                    proto.deactivatePrevNextButtons = function() {
                        this.prevButton.deactivate();
                        this.nextButton.deactivate();
                        this.off( 'deactivate', this.deactivatePrevNextButtons );
                    };

// --------------------------  -------------------------- //

                    Flickity.PrevNextButton = PrevNextButton;

                    return Flickity;

                }));
            });

            var pageDots = createCommonjsModule(function (module) {
// page dots
                ( function( window, factory ) {
                    // universal module definition
                    /* jshint strict: false */
                    if (  module.exports ) {
                        // CommonJS
                        module.exports = factory(
                                window,
                                flickity,
                                unipointer,
                                utils
                        );
                    } else {
                        // browser global
                        factory(
                                window,
                                window.Flickity,
                                window.Unipointer,
                                window.fizzyUIUtils
                        );
                    }

                }( window, function factory( window, Flickity, Unipointer, utils ) {

                    function PageDots( parent ) {
                        this.parent = parent;
                        this._create();
                    }

                    PageDots.prototype = Object.create( Unipointer.prototype );

                    PageDots.prototype._create = function() {
                        // create holder element
                        this.holder = document.createElement('ol');
                        this.holder.className = 'flickity-page-dots';
                        // create dots, array of elements
                        this.dots = [];
                        // events
                        this.handleClick = this.onClick.bind( this );
                        this.on( 'pointerDown', this.parent.childUIPointerDown.bind( this.parent ) );
                    };

                    PageDots.prototype.activate = function() {
                        this.setDots();
                        this.holder.addEventListener( 'click', this.handleClick );
                        this.bindStartEvent( this.holder );
                        // add to DOM
                        this.parent.element.appendChild( this.holder );
                    };

                    PageDots.prototype.deactivate = function() {
                        this.holder.removeEventListener( 'click', this.handleClick );
                        this.unbindStartEvent( this.holder );
                        // remove from DOM
                        this.parent.element.removeChild( this.holder );
                    };

                    PageDots.prototype.setDots = function() {
                        // get difference between number of slides and number of dots
                        var delta = this.parent.slides.length - this.dots.length;
                        if ( delta > 0 ) {
                            this.addDots( delta );
                        } else if ( delta < 0 ) {
                            this.removeDots( -delta );
                        }
                    };

                    PageDots.prototype.addDots = function( count ) {
                        var fragment = document.createDocumentFragment();
                        var newDots = [];
                        var length = this.dots.length;
                        var max = length + count;

                        for ( var i = length; i < max; i++ ) {
                            var dot = document.createElement('li');
                            dot.className = 'dot';
                            dot.setAttribute( 'aria-label', 'Page dot ' + ( i + 1 ) );
                            fragment.appendChild( dot );
                            newDots.push( dot );
                        }

                        this.holder.appendChild( fragment );
                        this.dots = this.dots.concat( newDots );
                    };

                    PageDots.prototype.removeDots = function( count ) {
                        // remove from this.dots collection
                        var removeDots = this.dots.splice( this.dots.length - count, count );
                        // remove from DOM
                        removeDots.forEach( function( dot ) {
                            this.holder.removeChild( dot );
                        }, this );
                    };

                    PageDots.prototype.updateSelected = function() {
                        // remove selected class on previous
                        if ( this.selectedDot ) {
                            this.selectedDot.className = 'dot';
                            this.selectedDot.removeAttribute('aria-current');
                        }
                        // don't proceed if no dots
                        if ( !this.dots.length ) {
                            return;
                        }
                        this.selectedDot = this.dots[ this.parent.selectedIndex ];
                        this.selectedDot.className = 'dot is-selected';
                        this.selectedDot.setAttribute( 'aria-current', 'step' );
                    };

                    PageDots.prototype.onTap = // old method name, backwards-compatible
                            PageDots.prototype.onClick = function( event ) {
                                var target = event.target;
                                // only care about dot clicks
                                if ( target.nodeName != 'LI' ) {
                                    return;
                                }

                                this.parent.uiChange();
                                var index = this.dots.indexOf( target );
                                this.parent.select( index );
                            };

                    PageDots.prototype.destroy = function() {
                        this.deactivate();
                        this.allOff();
                    };

                    Flickity.PageDots = PageDots;

// -------------------------- Flickity -------------------------- //

                    utils.extend( Flickity.defaults, {
                        pageDots: true
                    });

                    Flickity.createMethods.push('_createPageDots');

                    var proto = Flickity.prototype;

                    proto._createPageDots = function() {
                        if ( !this.options.pageDots ) {
                            return;
                        }
                        this.pageDots = new PageDots( this );
                        // events
                        this.on( 'activate', this.activatePageDots );
                        this.on( 'select', this.updateSelectedPageDots );
                        this.on( 'cellChange', this.updatePageDots );
                        this.on( 'resize', this.updatePageDots );
                        this.on( 'deactivate', this.deactivatePageDots );
                    };

                    proto.activatePageDots = function() {
                        this.pageDots.activate();
                    };

                    proto.updateSelectedPageDots = function() {
                        this.pageDots.updateSelected();
                    };

                    proto.updatePageDots = function() {
                        this.pageDots.setDots();
                    };

                    proto.deactivatePageDots = function() {
                        this.pageDots.deactivate();
                    };

// -----  ----- //

                    Flickity.PageDots = PageDots;

                    return Flickity;

                }));
            });

            var player = createCommonjsModule(function (module) {
// player & autoPlay
                ( function( window, factory ) {
                    // universal module definition
                    /* jshint strict: false */
                    if (  module.exports ) {
                        // CommonJS
                        module.exports = factory(
                                evEmitter,
                                utils,
                                flickity
                        );
                    } else {
                        // browser global
                        factory(
                                window.EvEmitter,
                                window.fizzyUIUtils,
                                window.Flickity
                        );
                    }

                }( window, function factory( EvEmitter, utils, Flickity ) {

// -------------------------- Player -------------------------- //

                    function Player( parent ) {
                        this.parent = parent;
                        this.state = 'stopped';
                        // visibility change event handler
                        this.onVisibilityChange = this.visibilityChange.bind( this );
                        this.onVisibilityPlay = this.visibilityPlay.bind( this );
                    }

                    Player.prototype = Object.create( EvEmitter.prototype );

// start play
                    Player.prototype.play = function() {
                        if ( this.state == 'playing' ) {
                            return;
                        }
                        // do not play if page is hidden, start playing when page is visible
                        var isPageHidden = document.hidden;
                        if ( isPageHidden ) {
                            document.addEventListener( 'visibilitychange', this.onVisibilityPlay );
                            return;
                        }

                        this.state = 'playing';
                        // listen to visibility change
                        document.addEventListener( 'visibilitychange', this.onVisibilityChange );
                        // start ticking
                        this.tick();
                    };

                    Player.prototype.tick = function() {
                        // do not tick if not playing
                        if ( this.state != 'playing' ) {
                            return;
                        }

                        var time = this.parent.options.autoPlay;
                        // default to 3 seconds
                        time = typeof time == 'number' ? time : 3000;
                        var _this = this;
                        // HACK: reset ticks if stopped and started within interval
                        this.clear();
                        this.timeout = setTimeout( function() {
                            _this.parent.next( true );
                            _this.tick();
                        }, time );
                    };

                    Player.prototype.stop = function() {
                        this.state = 'stopped';
                        this.clear();
                        // remove visibility change event
                        document.removeEventListener( 'visibilitychange', this.onVisibilityChange );
                    };

                    Player.prototype.clear = function() {
                        clearTimeout( this.timeout );
                    };

                    Player.prototype.pause = function() {
                        if ( this.state == 'playing' ) {
                            this.state = 'paused';
                            this.clear();
                        }
                    };

                    Player.prototype.unpause = function() {
                        // re-start play if paused
                        if ( this.state == 'paused' ) {
                            this.play();
                        }
                    };

// pause if page visibility is hidden, unpause if visible
                    Player.prototype.visibilityChange = function() {
                        var isPageHidden = document.hidden;
                        this[ isPageHidden ? 'pause' : 'unpause' ]();
                    };

                    Player.prototype.visibilityPlay = function() {
                        this.play();
                        document.removeEventListener( 'visibilitychange', this.onVisibilityPlay );
                    };

// -------------------------- Flickity -------------------------- //

                    utils.extend( Flickity.defaults, {
                        pauseAutoPlayOnHover: true
                    });

                    Flickity.createMethods.push('_createPlayer');
                    var proto = Flickity.prototype;

                    proto._createPlayer = function() {
                        this.player = new Player( this );

                        this.on( 'activate', this.activatePlayer );
                        this.on( 'uiChange', this.stopPlayer );
                        this.on( 'pointerDown', this.stopPlayer );
                        this.on( 'deactivate', this.deactivatePlayer );
                    };

                    proto.activatePlayer = function() {
                        if ( !this.options.autoPlay ) {
                            return;
                        }
                        this.player.play();
                        this.element.addEventListener( 'mouseenter', this );
                    };

// Player API, don't hate the ... thanks I know where the door is

                    proto.playPlayer = function() {
                        this.player.play();
                    };

                    proto.stopPlayer = function() {
                        this.player.stop();
                    };

                    proto.pausePlayer = function() {
                        this.player.pause();
                    };

                    proto.unpausePlayer = function() {
                        this.player.unpause();
                    };

                    proto.deactivatePlayer = function() {
                        this.player.stop();
                        this.element.removeEventListener( 'mouseenter', this );
                    };

// ----- mouseenter/leave ----- //

// pause auto-play on hover
                    proto.onmouseenter = function() {
                        if ( !this.options.pauseAutoPlayOnHover ) {
                            return;
                        }
                        this.player.pause();
                        this.element.addEventListener( 'mouseleave', this );
                    };

// resume auto-play on hover off
                    proto.onmouseleave = function() {
                        this.player.unpause();
                        this.element.removeEventListener( 'mouseleave', this );
                    };

// -----  ----- //

                    Flickity.Player = Player;

                    return Flickity;

                }));
            });

            var addRemoveCell = createCommonjsModule(function (module) {
// add, remove cell
                ( function( window, factory ) {
                    // universal module definition
                    /* jshint strict: false */
                    if (  module.exports ) {
                        // CommonJS
                        module.exports = factory(
                                window,
                                flickity,
                                utils
                        );
                    } else {
                        // browser global
                        factory(
                                window,
                                window.Flickity,
                                window.fizzyUIUtils
                        );
                    }

                }( window, function factory( window, Flickity, utils ) {

// append cells to a document fragment
                    function getCellsFragment( cells ) {
                        var fragment = document.createDocumentFragment();
                        cells.forEach( function( cell ) {
                            fragment.appendChild( cell.element );
                        });
                        return fragment;
                    }

// -------------------------- add/remove cell prototype -------------------------- //

                    var proto = Flickity.prototype;

                    /**
                     * Insert, prepend, or append cells
                     * @param {Element, Array, NodeList} elems
                     * @param {Integer} index
                     */
                    proto.insert = function( elems, index ) {
                        var cells = this._makeCells( elems );
                        if ( !cells || !cells.length ) {
                            return;
                        }
                        var len = this.cells.length;
                        // default to append
                        index = index === undefined ? len : index;
                        // add cells with document fragment
                        var fragment = getCellsFragment( cells );
                        // append to slider
                        var isAppend = index == len;
                        if ( isAppend ) {
                            this.slider.appendChild( fragment );
                        } else {
                            var insertCellElement = this.cells[ index ].element;
                            this.slider.insertBefore( fragment, insertCellElement );
                        }
                        // add to this.cells
                        if ( index === 0 ) {
                            // prepend, add to start
                            this.cells = cells.concat( this.cells );
                        } else if ( isAppend ) {
                            // append, add to end
                            this.cells = this.cells.concat( cells );
                        } else {
                            // insert in this.cells
                            var endCells = this.cells.splice( index, len - index );
                            this.cells = this.cells.concat( cells ).concat( endCells );
                        }

                        this._sizeCells( cells );
                        this.cellChange( index, true );
                    };

                    proto.append = function( elems ) {
                        this.insert( elems, this.cells.length );
                    };

                    proto.prepend = function( elems ) {
                        this.insert( elems, 0 );
                    };

                    /**
                     * Remove cells
                     * @param {Element, Array, NodeList} elems
                     */
                    proto.remove = function( elems ) {
                        var cells = this.getCells( elems );
                        if ( !cells || !cells.length ) {
                            return;
                        }

                        var minCellIndex = this.cells.length - 1;
                        // remove cells from collection & DOM
                        cells.forEach( function( cell ) {
                            cell.remove();
                            var index = this.cells.indexOf( cell );
                            minCellIndex = Math.min( index, minCellIndex );
                            utils.removeFrom( this.cells, cell );
                        }, this );

                        this.cellChange( minCellIndex, true );
                    };

                    /**
                     * logic to be run after a cell's size changes
                     * @param {Element} elem - cell's element
                     */
                    proto.cellSizeChange = function( elem ) {
                        var cell = this.getCell( elem );
                        if ( !cell ) {
                            return;
                        }
                        cell.getSize();

                        var index = this.cells.indexOf( cell );
                        this.cellChange( index );
                    };

                    /**
                     * logic any time a cell is changed: added, removed, or size changed
                     * @param {Integer} changedCellIndex - index of the changed cell, optional
                     */
                    proto.cellChange = function( changedCellIndex, isPositioningSlider ) {
                        var prevSelectedElem = this.selectedElement;
                        this._positionCells( changedCellIndex );
                        this._getWrapShiftCells();
                        this.setGallerySize();
                        // update selectedIndex
                        // try to maintain position & select previous selected element
                        var cell = this.getCell( prevSelectedElem );
                        if ( cell ) {
                            this.selectedIndex = this.getCellSlideIndex( cell );
                        }
                        this.selectedIndex = Math.min( this.slides.length - 1, this.selectedIndex );

                        this.emitEvent( 'cellChange', [ changedCellIndex ] );
                        // position slider
                        this.select( this.selectedIndex );
                        // do not position slider after lazy load
                        if ( isPositioningSlider ) {
                            this.positionSliderAtSelected();
                        }
                    };

// -----  ----- //

                    return Flickity;

                }));
            });

            var lazyload = createCommonjsModule(function (module) {
// lazyload
                ( function( window, factory ) {
                    // universal module definition
                    /* jshint strict: false */
                    if (  module.exports ) {
                        // CommonJS
                        module.exports = factory(
                                window,
                                flickity,
                                utils
                        );
                    } else {
                        // browser global
                        factory(
                                window,
                                window.Flickity,
                                window.fizzyUIUtils
                        );
                    }

                }( window, function factory( window, Flickity, utils ) {

                    Flickity.createMethods.push('_createLazyload');
                    var proto = Flickity.prototype;

                    proto._createLazyload = function() {
                        this.on( 'select', this.lazyLoad );
                    };

                    proto.lazyLoad = function() {
                        var lazyLoad = this.options.lazyLoad;
                        if ( !lazyLoad ) {
                            return;
                        }
                        // get adjacent cells, use lazyLoad option for adjacent count
                        var adjCount = typeof lazyLoad == 'number' ? lazyLoad : 0;
                        var cellElems = this.getAdjacentCellElements( adjCount );
                        // get lazy images in those cells
                        var lazyImages = [];
                        cellElems.forEach( function( cellElem ) {
                            var lazyCellImages = getCellLazyImages( cellElem );
                            lazyImages = lazyImages.concat( lazyCellImages );
                        });
                        // load lazy images
                        lazyImages.forEach( function( img ) {
                            new LazyLoader( img, this );
                        }, this );
                    };

                    function getCellLazyImages( cellElem ) {
                        // check if cell element is lazy image
                        if ( cellElem.nodeName == 'IMG' ) {
                            var lazyloadAttr = cellElem.getAttribute('data-flickity-lazyload');
                            var srcAttr = cellElem.getAttribute('data-flickity-lazyload-src');
                            var srcsetAttr = cellElem.getAttribute('data-flickity-lazyload-srcset');
                            if ( lazyloadAttr || srcAttr || srcsetAttr ) {
                                return [ cellElem ];
                            }
                        }
                        // select lazy images in cell
                        var lazySelector = 'img[data-flickity-lazyload], ' +
                                'img[data-flickity-lazyload-src], img[data-flickity-lazyload-srcset]';
                        var imgs = cellElem.querySelectorAll( lazySelector );
                        return utils.makeArray( imgs );
                    }

// -------------------------- LazyLoader -------------------------- //

                    /**
                     * class to handle loading images
                     */
                    function LazyLoader( img, flickity ) {
                        this.img = img;
                        this.flickity = flickity;
                        this.load();
                    }

                    LazyLoader.prototype.handleEvent = utils.handleEvent;

                    LazyLoader.prototype.load = function() {
                        this.img.addEventListener( 'load', this );
                        this.img.addEventListener( 'error', this );
                        // get src & srcset
                        var src = this.img.getAttribute('data-flickity-lazyload') ||
                                this.img.getAttribute('data-flickity-lazyload-src');
                        var srcset = this.img.getAttribute('data-flickity-lazyload-srcset');
                        // set src & serset
                        this.img.src = src;
                        if ( srcset ) {
                            this.img.setAttribute( 'srcset', srcset );
                        }
                        // remove attr
                        this.img.removeAttribute('data-flickity-lazyload');
                        this.img.removeAttribute('data-flickity-lazyload-src');
                        this.img.removeAttribute('data-flickity-lazyload-srcset');
                    };

                    LazyLoader.prototype.onload = function( event ) {
                        this.complete( event, 'flickity-lazyloaded' );
                    };

                    LazyLoader.prototype.onerror = function( event ) {
                        this.complete( event, 'flickity-lazyerror' );
                    };

                    LazyLoader.prototype.complete = function( event, className ) {
                        // unbind events
                        this.img.removeEventListener( 'load', this );
                        this.img.removeEventListener( 'error', this );

                        var cell = this.flickity.getParentCell( this.img );
                        var cellElem = cell && cell.element;
                        this.flickity.cellSizeChange( cellElem );

                        this.img.classList.add( className );
                        this.flickity.dispatchEvent( 'lazyLoad', event, cellElem );
                    };

// -----  ----- //

                    Flickity.LazyLoader = LazyLoader;

                    return Flickity;

                }));
            });

            var js = createCommonjsModule(function (module) {
                /*!
                 * Flickity v2.2.1
                 * Touch, responsive, flickable carousels
                 *
                 * Licensed GPLv3 for open source use
                 * or Flickity Commercial License for commercial use
                 *
                 * https://flickity.metafizzy.co
                 * Copyright 2015-2019 Metafizzy
                 */

                ( function( window, factory ) {
                    // universal module definition
                    /* jshint strict: false */
                    if (  module.exports ) {
                        // CommonJS
                        module.exports = factory(
                                flickity,
                                drag,
                                prevNextButton,
                                pageDots,
                                player,
                                addRemoveCell,
                                lazyload
                        );
                    }

                })( window, function factory( Flickity ) {
                    /*jshint strict: false*/
                    return Flickity;
                });
            });

            var flickityFade = createCommonjsModule(function (module) {
                /**
                 * Flickity fade v1.0.0
                 * Fade between Flickity slides
                 */

                /* jshint browser: true, undef: true, unused: true */

                ( function( window, factory ) {
                    // universal module definition
                    /*globals define, module, require */
                    if (  module.exports ) {
                        // CommonJS
                        module.exports = factory(
                                js,
                                utils
                        );
                    } else {
                        // browser global
                        factory(
                                window.Flickity,
                                window.fizzyUIUtils
                        );
                    }

                }( commonjsGlobal, function factory( Flickity, utils ) {

// ---- Slide ---- //

                    var Slide = Flickity.Slide;

                    var slideUpdateTarget = Slide.prototype.updateTarget;
                    Slide.prototype.updateTarget = function() {
                        slideUpdateTarget.apply( this, arguments );
                        if ( !this.parent.options.fade ) {
                            return;
                        }
                        // position cells at selected target
                        var slideTargetX = this.target - this.x;
                        var firstCellX = this.cells[0].x;
                        this.cells.forEach( function( cell ) {
                            var targetX = cell.x - firstCellX - slideTargetX;
                            cell.renderPosition( targetX );
                        });
                    };

                    Slide.prototype.setOpacity = function( alpha ) {
                        this.cells.forEach( function( cell ) {
                            cell.element.style.opacity = alpha;
                        });
                    };

// ---- Flickity ---- //

                    var proto = Flickity.prototype;

                    Flickity.createMethods.push('_createFade');

                    proto._createFade = function() {
                        this.fadeIndex = this.selectedIndex;
                        this.prevSelectedIndex = this.selectedIndex;
                        this.on( 'select', this.onSelectFade );
                        this.on( 'dragEnd', this.onDragEndFade );
                        this.on( 'settle', this.onSettleFade );
                        this.on( 'activate', this.onActivateFade );
                        this.on( 'deactivate', this.onDeactivateFade );
                    };

                    var updateSlides = proto.updateSlides;
                    proto.updateSlides = function() {
                        updateSlides.apply( this, arguments );
                        if ( !this.options.fade ) {
                            return;
                        }
                        // set initial opacity
                        this.slides.forEach( function( slide, i ) {
                            var alpha = i == this.selectedIndex ? 1 : 0;
                            slide.setOpacity( alpha );
                        }, this );
                    };

                    /* ---- events ---- */

                    proto.onSelectFade = function() {
                        // in case of resize, keep fadeIndex within current count
                        this.fadeIndex = Math.min( this.prevSelectedIndex, this.slides.length - 1 );
                        this.prevSelectedIndex = this.selectedIndex;
                    };

                    proto.onSettleFade = function() {
                        delete this.didDragEnd;
                        if ( !this.options.fade ) {
                            return;
                        }
                        // set full and 0 opacity on selected & faded slides
                        this.selectedSlide.setOpacity( 1 );
                        var fadedSlide = this.slides[ this.fadeIndex ];
                        if ( fadedSlide && this.fadeIndex != this.selectedIndex ) {
                            this.slides[ this.fadeIndex ].setOpacity( 0 );
                        }
                    };

                    proto.onDragEndFade = function() {
                        // set flag
                        this.didDragEnd = true;
                    };

                    proto.onActivateFade = function() {
                        if ( this.options.fade ) {
                            this.element.classList.add('is-fade');
                        }
                    };

                    proto.onDeactivateFade = function() {
                        if ( !this.options.fade ) {
                            return;
                        }
                        this.element.classList.remove('is-fade');
                        // reset opacity
                        this.slides.forEach( function( slide ) {
                            slide.setOpacity('');
                        });
                    };

                    /* ---- position & fading ---- */

                    var positionSlider = proto.positionSlider;
                    proto.positionSlider = function() {
                        if ( !this.options.fade ) {
                            positionSlider.apply( this, arguments );
                            return;
                        }

                        this.fadeSlides();
                        this.dispatchScrollEvent();
                    };

                    var positionSliderAtSelected = proto.positionSliderAtSelected;
                    proto.positionSliderAtSelected = function() {
                        if ( this.options.fade ) {
                            // position fade slider at origin
                            this.setTranslateX( 0 );
                        }
                        positionSliderAtSelected.apply( this, arguments );
                    };

                    proto.fadeSlides = function() {
                        if ( this.slides.length < 2 ) {
                            return;
                        }
                        // get slides to fade-in & fade-out
                        var indexes = this.getFadeIndexes();
                        var fadeSlideA = this.slides[ indexes.a ];
                        var fadeSlideB = this.slides[ indexes.b ];
                        var distance = this.wrapDifference( fadeSlideA.target, fadeSlideB.target );
                        var progress = this.wrapDifference( fadeSlideA.target, -this.x );
                        progress = progress / distance;

                        fadeSlideA.setOpacity( 1 - progress );
                        fadeSlideB.setOpacity( progress );

                        // hide previous slide
                        var fadeHideIndex = indexes.a;
                        if ( this.isDragging ) {
                            fadeHideIndex = progress > 0.5 ? indexes.a : indexes.b;
                        }
                        var isNewHideIndex = this.fadeHideIndex != undefined &&
                                this.fadeHideIndex != fadeHideIndex &&
                                this.fadeHideIndex != indexes.a &&
                                this.fadeHideIndex != indexes.b;
                        if ( isNewHideIndex ) {
                            // new fadeHideSlide set, hide previous
                            this.slides[ this.fadeHideIndex ].setOpacity( 0 );
                        }
                        this.fadeHideIndex = fadeHideIndex;
                    };

                    proto.getFadeIndexes = function() {
                        if ( !this.isDragging && !this.didDragEnd ) {
                            return {
                                a: this.fadeIndex,
                                b: this.selectedIndex,
                            };
                        }
                        if ( this.options.wrapAround ) {
                            return this.getFadeDragWrapIndexes();
                        } else {
                            return this.getFadeDragLimitIndexes();
                        }
                    };

                    proto.getFadeDragWrapIndexes = function() {
                        var distances = this.slides.map( function( slide, i ) {
                            return this.getSlideDistance( -this.x, i );
                        }, this );
                        var absDistances = distances.map( function( distance ) {
                            return Math.abs( distance );
                        });
                        var minDistance = Math.min.apply( Math, absDistances );
                        var closestIndex = absDistances.indexOf( minDistance );
                        var distance = distances[ closestIndex ];
                        var len = this.slides.length;

                        var delta = distance >= 0 ? 1 : -1;
                        return {
                            a: closestIndex,
                            b: utils.modulo( closestIndex + delta, len ),
                        };
                    };

                    proto.getFadeDragLimitIndexes = function() {
                        // calculate closest previous slide
                        var dragIndex = 0;
                        for ( var i=0; i < this.slides.length - 1; i++ ) {
                            var slide = this.slides[i];
                            if ( -this.x < slide.target ) {
                                break;
                            }
                            dragIndex = i;
                        }
                        return {
                            a: dragIndex,
                            b: dragIndex + 1,
                        };
                    };

                    proto.wrapDifference = function( a, b ) {
                        var diff = b - a;

                        if ( !this.options.wrapAround ) {
                            return diff;
                        }

                        var diffPlus = diff + this.slideableWidth;
                        var diffMinus = diff - this.slideableWidth;
                        if ( Math.abs( diffPlus ) < Math.abs( diff ) ) {
                            diff = diffPlus;
                        }
                        if ( Math.abs( diffMinus ) < Math.abs( diff ) ) {
                            diff = diffMinus;
                        }
                        return diff;
                    };

// ---- wrapAround ---- //

                    var _getWrapShiftCells = proto._getWrapShiftCells;
                    proto._getWrapShiftCells = function() {
                        if ( !this.options.fade ) {
                            _getWrapShiftCells.apply( this, arguments );
                        }
                    };

                    var shiftWrapCells = proto.shiftWrapCells;
                    proto.shiftWrapCells = function() {
                        if ( !this.options.fade ) {
                            shiftWrapCells.apply( this, arguments );
                        }
                    };

                    return Flickity;

                }));
            });

            var EventHandler_1 = createCommonjsModule(function (module, exports) {
                exports.__esModule = true;
                var EventHandler = /** @class */ (function () {
                    function EventHandler() {
                        this.events = [];
                    }
                    EventHandler.prototype.register = function (el, event, listener) {
                        if (!el || !event || !listener)
                            return null;
                        this.events.push({ el: el, event: event, listener: listener });
                        el.addEventListener(event, listener);
                        return { el: el, event: event, listener: listener };
                    };
                    EventHandler.prototype.unregister = function (_a) {
                        var el = _a.el, event = _a.event, listener = _a.listener;
                        if (!el || !event || !listener)
                            return null;
                        this.events = this.events.filter(function (e) { return el !== e.el
                                || event !== e.event || listener !== e.listener; });
                        el.removeEventListener(event, listener);
                        return { el: el, event: event, listener: listener };
                    };
                    EventHandler.prototype.unregisterAll = function () {
                        this.events.forEach(function (_a) {
                            var el = _a.el, event = _a.event, listener = _a.listener;
                            return el.removeEventListener(event, listener);
                        });
                        this.events = [];
                    };
                    return EventHandler;
                }());
                exports["default"] = EventHandler;
            });

            var EventHandler = unwrapExports(EventHandler_1);

            var Slideshow = /*#__PURE__*/function () {
                function Slideshow(section) {
                    var _this = this;

                    _classCallCheck(this, Slideshow);

                    this.el = section.el;
                    this.settings = section.data;
                    this.paginationClicked = false;
                    this.events = new EventHandler();
                    this.carousel = this.el.querySelector('[data-slideshow-wrapper]');
                    this.slides = this.el.querySelectorAll('[data-slideshow-slide]');
                    this.pagination = this.el.querySelector('[data-slideshow-pagination]');
                    this.paginationButtons = this.pagination ? this.pagination.querySelectorAll('[data-slide-button]') : null;
                    this.counter = this.el.querySelector('[data-slide-counter]');
                    this.el.style.setProperty('--slide-text-color', "".concat(this.slides[0].dataset.textColor));

                    if (this.carousel && this.slides.length > 1) {
                        this.flickity = new flickityFade(this.carousel, {
                            accessibility: false,
                            // Flickity's inherent "accessibility" actually makes it worse
                            adaptiveHeight: true,
                            autoPlay: this.settings.enable_autoplay ? this.settings.autoplay_interval * 1000 : false,
                            cellAlign: 'left',
                            cellSelector: '[data-slideshow-slide]',
                            contain: true,
                            fade: this.settings.transition_fade,
                            pageDots: this.settings.show_pagination,
                            pauseAutoPlayOnHover: true,
                            selectedAttraction: this.settings.slide_attraction ? parseFloat(this.settings.slide_attraction) : 0.03,
                            friction: this.settings.slide_friction ? parseFloat(this.settings.slide_friction) : 0.3,
                            wrapAround: true,
                            arrowShape: {
                                x0: 10,
                                x1: 60,
                                y1: 50,
                                x2: 65,
                                y2: 45,
                                x3: 20
                            }
                        });
                        this.prevNextButtons = this.el.querySelectorAll('.flickity-prev-next-button');

                        if (this.prevNextButtons.length === 2) {
                            this.prevNextButtons[0].setAttribute('aria-label', this.settings.previous_text);
                            this.prevNextButtons[1].setAttribute('aria-label', this.settings.next_text);
                        }

                        this._updateTabindex();

                        this._positionNavigation();

                        this._updateCounter(1);

                        this.flickity.on('change', function (index) {
                            _this.el.style.setProperty('--slide-text-color', "".concat(_this.slides[index].dataset.textColor));

                            _this._updatePagination();

                            _this._positionNavigation();

                            _this._updateTabindex();

                            _this._updateCounter(index + 1);
                        }); // On any interaction on the slideshow, we want it to pause

                        this.flickity.on('pointerDown', function () {
                            return _this.flickity.pausePlayer();
                        });
                        this.events.register(this.carousel, 'rimg:load', function () {
                            _this.flickity.resize();

                            _this._positionNavigation();
                        }); // As soon as the slideshow receives keyboard or mouse focus, we want it to pause

                        this.events.register(this.carousel, 'focusin', function () {
                            return _this.flickity.pausePlayer();
                        });
                        this.events.register(window, 'resize', function () {
                            _this._positionNavigation();
                        }); // We want to focus on the new slide if the pagination buttons were clicked
                        // If we don't wait until "settle" then the slideshow experiences a weird jump issue

                        this.flickity.on('settle', function (index) {
                            if (_this.paginationClicked) {
                                _this.slides[index].focus();

                                _this.paginationClicked = false;
                            }
                        }); // We had to add in our own pagination buttons since the flickity ones
                        // are not elements that can be tabbed to. This replicates their behaviour.

                        if (this.pagination) {
                            var _loop = function _loop(i) {
                                _this.events.register(_this.paginationButtons[i], 'click', function () {
                                    var index = parseInt(_this.paginationButtons[i].dataset.slideButton, 10);

                                    _this.flickity.pausePlayer();

                                    _this.flickity.select(index, true, false);

                                    _this.paginationClicked = true;
                                });
                            };

                            for (var i = 0; i < this.paginationButtons.length; i++) {
                                _loop(i);
                            }
                        }
                    }
                }

                _createClass(Slideshow, [{
                    key: "_updatePagination",
                    value: function _updatePagination() {
                        if (this.pagination) {
                            for (var i = 0; i < this.paginationButtons.length; i++) {
                                this.paginationButtons[i].dataset.selected = 'false';
                                this.paginationButtons[i].setAttribute('aria-selected', 'false');
                            }

                            this.paginationButtons[this.flickity.selectedIndex].dataset.selected = 'true';
                            this.paginationButtons[this.flickity.selectedIndex].setAttribute('aria-selected', 'true');
                        }
                    }
                }, {
                    key: "_positionNavigation",
                    value: function _positionNavigation() {
                        if (this.settings.mobile_navigation_adjust) {
                            var arrowButtons = this.el.querySelectorAll('.flickity-prev-next-button');
                            var currentSlideheight = this.flickity.selectedElement.querySelector('[data-slide-image-wrapper]').offsetHeight;

                            if (arrowButtons) {
                                var top = '50%';

                                if (this.viewportIsMobile()) {
                                    top = "".concat(currentSlideheight / 2, "px");
                                }

                                arrowButtons[0].style.top = top;
                                arrowButtons[1].style.top = top;
                            }

                            if (this.pagination) {
                                var _top = 'auto';

                                if (this.viewportIsMobile()) {
                                    var content = this.flickity.selectedElement.querySelector('[data-slide-content]');

                                    if (content) {
                                        _top = "".concat(currentSlideheight, "px");
                                    } else {
                                        var paginationHeight = this.pagination.offsetHeight; // If no content, and mobile, offset by height of dots, and the bottom gutter

                                        _top = "".concat(currentSlideheight - paginationHeight, "px");
                                    }
                                }

                                this.pagination.style.top = _top;
                            }
                        }
                    }
                }, {
                    key: "_updateTabindex",
                    value: function _updateTabindex() {
                        // We need to remove tabindex from the slides that are not currently
                        // selected, so that slides not currently shown cannot receive keyboard focus.
                        for (var i = 0; i < this.slides.length; i++) {
                            var links = this.slides[i].querySelectorAll('a');

                            for (var j = 0; j < links.length; j++) {
                                links[j].setAttribute('tabindex', i === this.flickity.selectedIndex ? '0' : '-1');
                            }
                        }
                    } // This updates the counter which is used for accessibility. This gets read out to a user
                    // who uses a screen reader every time the slide changes.

                }, {
                    key: "_updateCounter",
                    value: function _updateCounter(index) {
                        var counterText = this.counter.dataset.counterTemplate.replace("\{\{ count \}\}", index).replace("\{\{ total \}\}", this.slides.length);
                        this.counter.innerHTML = counterText;
                    } // This method can be overridden by the theme if the breakpoint is different than 720.

                }, {
                    key: "viewportIsMobile",
                    value: function viewportIsMobile() {
                        return window.innerWidth < 720;
                    }
                }, {
                    key: "onSectionUnload",
                    value: function onSectionUnload() {
                        this.events.unregisterAll();
                        this.flickity.destroy();
                    }
                }, {
                    key: "onSectionBlockSelect",
                    value: function onSectionBlockSelect(e) {
                        var slideIndex = e.el.dataset.slideIndex;
                        this.flickity.select(slideIndex);
                        this.flickity.pausePlayer();
                    }
                }, {
                    key: "onSectionBlockDeselect",
                    value: function onSectionBlockDeselect() {
                        if (this.settings.enable_autoplay) {
                            this.flickity.playPlayer();
                        }
                    }
                }]);

                return Slideshow;
            }();

            /* harmony default export */ __webpack_exports__["a"] = (Slideshow);

            /* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(32)))

        /***/ }),
    /* 19 */
    /***/ (function(module, exports) {

        /*!
         * Trend 0.2.0
         *
         * Fail-safe TransitionEnd event for jQuery.
         *
         * Adds a new "trend" event that can be used in browsers that don't
         * support "transitionend".
         *
         * NOTE: Only supports being bound with "jQuery.one".
         *
         * Copyright 2014, Pixel Union - http://pixelunion.net
         * Released under the MIT license
         */
        ;(function($){

            // Prefixed transitionend event names
            var transitionEndEvents =
                    "webkitTransitionEnd " +
                    "otransitionend " +
                    "oTransitionEnd " +
                    "msTransitionEnd " +
                    "transitionend";

            // Prefixed transition duration property names
            var transitionDurationProperties = [
                "transition-duration",
                "-moz-transition-duration",
                "-webkit-transition-duration",
                "-ms-transition-duration",
                "-o-transition-duration",
                "-khtml-transition-duration"
            ];

            // Prefixed transition delay property names
            var transitionDelayProperties = [
                "transition-delay",
                "-moz-transition-delay",
                "-webkit-transition-delay",
                "-ms-transition-delay",
                "-o-transition-delay",
                "-khtml-transition-delay"
            ];

            // Parses a CSS time value into milliseconds.
            var parseTime = function(s) {
                s = s.replace(/\s/, "");
                var v = window.parseFloat(s);

                return s.match(/[^m]s$/i)
                        ? v * 1000
                        : v;
            };

            // Parses the longest time unit found in a series of CSS properties.
            // Returns a value in milliseconds.
            var parseProperties = function(el, properties) {
                var duration = 0;

                for (var i = 0; i < properties.length; i++) {
                    // Get raw CSS value
                    var value = el.css(properties[i]);
                    if (!value) continue;

                    // Multiple transitions--pick the longest
                    if (value.indexOf(",") !== -1) {
                        var values = value.split(",");
                        var durations = (function(){
                            var results = [];
                            for (var i = 0; i < values.length; i++) {
                                var duration = parseTime(values[i]);
                                results.push(duration);
                            }
                            return results;
                        })();

                        duration = Math.max.apply(Math, durations);
                    }

                    // Single transition
                    else {
                        duration = parseTime(value);
                    }

                    // Accept first vaue
                    break;
                }

                return duration;
            };

            $.event.special.trend = {
                // Triggers an event handler when an element is done transitioning.
                //
                // Handles browsers that don't support transitionend by adding a
                // timeout with the transition duration.
                add: function(handleObj) {
                    var el = $(this);
                    var fired = false;

                    // Mark element as being in transition
                    el.data("trend", true);

                    // Calculate a fallback duration. + 20 because some browsers fire
                    // timeouts faster than transitionend.
                    var time =
                            parseProperties(el, transitionDurationProperties) +
                            parseProperties(el, transitionDelayProperties) +
                            20;

                    var cb = function(e) {
                        // transitionend events can be sent for each property. Let's just
                        // skip all but the first. Also handles the timeout callback.
                        if (fired) return;

                        // Child elements that also have transitions can be fired before we
                        // complete. This will catch and ignore those. Unfortunately, we'll
                        // have to rely on the timeout in these cases.
                        if (e && e.srcElement !== el[0]) return;

                        // Mark element has not being in transition
                        el.data("trend", false);

                        // Callback
                        fired = true;
                        if (handleObj.handler) handleObj.handler();
                    };

                    el.one(transitionEndEvents, cb);
                    el.data("trend-timeout", window.setTimeout(cb, time));
                },

                remove: function(handleObj) {
                    var el = $(this);
                    el.off(transitionEndEvents);
                    window.clearTimeout(el.data("trend-timeout"));
                }
            };

        })(jQuery);


        /***/ }),
    /* 20 */
    /***/ (function(module, exports) {

        /*!
         * Revealer 2.0.1
         *
         * Copyright 2015, Pixel Union - http://pixelunion.net
         * Released under the MIT license
         */
        (function($){
            // check for trend event (make sure jquery.trend is included)
            if (typeof $.event.special.trend !== "object") {
                console.warn("Please make sure jquery.trend is included! Otherwise revealer won't work.");
            }

            // Simple requestAnimationFrame polyfill
            var raf = window.requestAnimationFrame ||
                    window.mozRequestAnimationFrame ||
                    window.webkitRequestAnimationFrame ||
                    function(fn) { window.setTimeout(fn, 1000/60); }


            // Public API
            var methods = {
                isVisible: function(el) {
                    return !!el.data("revealer-visible");
                },

                show: function(el, force) {
                    // Check state
                    if (methods.isVisible(el)) {
                        el.removeClass("animating animating-in");
                        el.off("revealer-animating revealer-show");
                        return;
                    }

                    // Remove previous event listeners
                    el.data("revealer-visible", true);
                    el.off("trend");

                    if (force) {
                        el.addClass("visible");
                        raf(function(){
                            el.trigger("revealer-animating");
                            el.trigger("revealer-show");
                        });
                        return;
                    }

                    raf(function(){
                        // Start animation state transition
                        el.addClass("animating animating-in");
                        el.trigger("revealer-animating");

                        raf(function(){
                            el.addClass("visible");

                            el.one("trend", function(){
                                el.removeClass("animating animating-in");
                                el.trigger("revealer-show");
                            });
                        });
                    });
                },

                hide: function(el, force) {
                    // Check state
                    if (!methods.isVisible(el)) {
                        el.removeClass("animating animating-out visible");
                        el.off("revealer-animating revealer-hide");
                        return;
                    }

                    // Remove previous event listeners
                    el.data("revealer-visible", false);
                    el.off("trend");

                    if (force) {
                        el.removeClass("visible");
                        raf(function(){
                            el.trigger("revealer-animating");
                            el.trigger("revealer-hide");
                        });
                        return;
                    }

                    raf(function(){
                        el.addClass("animating animating-out");
                        el.trigger("revealer-animating");

                        raf(function(){
                            el.removeClass("visible");

                            el.one("trend", function(){
                                el.removeClass("animating animating-in animating-out");
                                el.trigger("revealer-hide");
                            });
                        });
                    });
                },

                toggle: function(el, force) {
                    if (methods.isVisible(el)) {
                        methods.hide(el, force);
                    } else {
                        methods.show(el, force);
                    }
                }
            };

            // jQuery plugin
            $.fn.revealer = function(method, force) {
                // Get action
                var action = methods[method || "toggle"];
                if (!action) return this;

                // Run action
                if (method === "isVisible") {
                    return action(this);
                }

                return this.each(function(){
                    action($(this), force);
                });
            };
        })(jQuery);


        /***/ }),
    /* 21 */
    /***/ (function(module, exports, __webpack_require__) {

        var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
         * matchesSelector v2.0.2
         * matchesSelector( element, '.selector' )
         * MIT license
         */

        /*jshint browser: true, strict: true, undef: true, unused: true */

        ( function( window, factory ) {
            /*global define: false, module: false */
            'use strict';
            // universal module definition
            if ( true ) {
                // AMD
                !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
                        __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
                                (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
                                __WEBPACK_AMD_DEFINE_FACTORY__),
                __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
            } else {}

        }( window, function factory() {
            'use strict';

            var matchesMethod = ( function() {
                var ElemProto = window.Element.prototype;
                // check for the standard method name first
                if ( ElemProto.matches ) {
                    return 'matches';
                }
                // check un-prefixed
                if ( ElemProto.matchesSelector ) {
                    return 'matchesSelector';
                }
                // check vendor prefixes
                var prefixes = [ 'webkit', 'moz', 'ms', 'o' ];

                for ( var i=0; i < prefixes.length; i++ ) {
                    var prefix = prefixes[i];
                    var method = prefix + 'MatchesSelector';
                    if ( ElemProto[ method ] ) {
                        return method;
                    }
                }
            })();

            return function matchesSelector( elem, selector ) {
                return elem[ matchesMethod ]( selector );
            };

        }));


        /***/ }),
    /* 22 */
    /***/ (function(module, exports, __webpack_require__) {

        var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// Flickity.Cell
        ( function( window, factory ) {
            // universal module definition
            /* jshint strict: false */
            if ( true ) {
                // AMD
                !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
                    __webpack_require__(10)
                ], __WEBPACK_AMD_DEFINE_RESULT__ = (function( getSize ) {
                    return factory( window, getSize );
                }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
                __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
            } else {}

        }( window, function factory( window, getSize ) {

            'use strict';

            function Cell( elem, parent ) {
                this.element = elem;
                this.parent = parent;

                this.create();
            }

            var proto = Cell.prototype;

            proto.create = function() {
                this.element.style.position = 'absolute';
                this.element.setAttribute( 'aria-hidden', 'true' );
                this.x = 0;
                this.shift = 0;
            };

            proto.destroy = function() {
                // reset style
                this.unselect();
                this.element.style.position = '';
                var side = this.parent.originSide;
                this.element.style[ side ] = '';
            };

            proto.getSize = function() {
                this.size = getSize( this.element );
            };

            proto.setPosition = function( x ) {
                this.x = x;
                this.updateTarget();
                this.renderPosition( x );
            };

// setDefaultTarget v1 method, backwards compatibility, remove in v3
            proto.updateTarget = proto.setDefaultTarget = function() {
                var marginProperty = this.parent.originSide == 'left' ? 'marginLeft' : 'marginRight';
                this.target = this.x + this.size[ marginProperty ] +
                        this.size.width * this.parent.cellAlign;
            };

            proto.renderPosition = function( x ) {
                // render position of cell with in slider
                var side = this.parent.originSide;
                this.element.style[ side ] = this.parent.getPositionValue( x );
            };

            proto.select = function() {
                this.element.classList.add('is-selected');
                this.element.removeAttribute('aria-hidden');
            };

            proto.unselect = function() {
                this.element.classList.remove('is-selected');
                this.element.setAttribute( 'aria-hidden', 'true' );
            };

            /**
             * @param {Integer} factor - 0, 1, or -1
             **/
            proto.wrapShift = function( shift ) {
                this.shift = shift;
                this.renderPosition( this.x + this.parent.slideableWidth * shift );
            };

            proto.remove = function() {
                this.element.parentNode.removeChild( this.element );
            };

            return Cell;

        }));


        /***/ }),
    /* 23 */
    /***/ (function(module, exports, __webpack_require__) {

        var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;// slide
        ( function( window, factory ) {
            // universal module definition
            /* jshint strict: false */
            if ( true ) {
                // AMD
                !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
                        __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
                                (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
                                __WEBPACK_AMD_DEFINE_FACTORY__),
                __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
            } else {}

        }( window, function factory() {
            'use strict';

            function Slide( parent ) {
                this.parent = parent;
                this.isOriginLeft = parent.originSide == 'left';
                this.cells = [];
                this.outerWidth = 0;
                this.height = 0;
            }

            var proto = Slide.prototype;

            proto.addCell = function( cell ) {
                this.cells.push( cell );
                this.outerWidth += cell.size.outerWidth;
                this.height = Math.max( cell.size.outerHeight, this.height );
                // first cell stuff
                if ( this.cells.length == 1 ) {
                    this.x = cell.x; // x comes from first cell
                    var beginMargin = this.isOriginLeft ? 'marginLeft' : 'marginRight';
                    this.firstMargin = cell.size[ beginMargin ];
                }
            };

            proto.updateTarget = function() {
                var endMargin = this.isOriginLeft ? 'marginRight' : 'marginLeft';
                var lastCell = this.getLastCell();
                var lastMargin = lastCell ? lastCell.size[ endMargin ] : 0;
                var slideWidth = this.outerWidth - ( this.firstMargin + lastMargin );
                this.target = this.x + this.firstMargin + slideWidth * this.parent.cellAlign;
            };

            proto.getLastCell = function() {
                return this.cells[ this.cells.length - 1 ];
            };

            proto.select = function() {
                this.cells.forEach( function( cell ) {
                    cell.select();
                });
            };

            proto.unselect = function() {
                this.cells.forEach( function( cell ) {
                    cell.unselect();
                });
            };

            proto.getCellElements = function() {
                return this.cells.map( function( cell ) {
                    return cell.element;
                });
            };

            return Slide;

        }));


        /***/ }),
    /* 24 */
    /***/ (function(module, exports, __webpack_require__) {

        var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// animate
        ( function( window, factory ) {
            // universal module definition
            /* jshint strict: false */
            if ( true ) {
                // AMD
                !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
                    __webpack_require__(6)
                ], __WEBPACK_AMD_DEFINE_RESULT__ = (function( utils ) {
                    return factory( window, utils );
                }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
                __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
            } else {}

        }( window, function factory( window, utils ) {

            'use strict';

// -------------------------- animate -------------------------- //

            var proto = {};

            proto.startAnimation = function() {
                if ( this.isAnimating ) {
                    return;
                }

                this.isAnimating = true;
                this.restingFrames = 0;
                this.animate();
            };

            proto.animate = function() {
                this.applyDragForce();
                this.applySelectedAttraction();

                var previousX = this.x;

                this.integratePhysics();
                this.positionSlider();
                this.settle( previousX );
                // animate next frame
                if ( this.isAnimating ) {
                    var _this = this;
                    requestAnimationFrame( function animateFrame() {
                        _this.animate();
                    });
                }
            };

            proto.positionSlider = function() {
                var x = this.x;
                // wrap position around
                if ( this.options.wrapAround && this.cells.length > 1 ) {
                    x = utils.modulo( x, this.slideableWidth );
                    x = x - this.slideableWidth;
                    this.shiftWrapCells( x );
                }

                this.setTranslateX( x, this.isAnimating );
                this.dispatchScrollEvent();
            };

            proto.setTranslateX = function( x, is3d ) {
                x += this.cursorPosition;
                // reverse if right-to-left and using transform
                x = this.options.rightToLeft ? -x : x;
                var translateX = this.getPositionValue( x );
                // use 3D tranforms for hardware acceleration on iOS
                // but use 2D when settled, for better font-rendering
                this.slider.style.transform = is3d ?
                'translate3d(' + translateX + ',0,0)' : 'translateX(' + translateX + ')';
            };

            proto.dispatchScrollEvent = function() {
                var firstSlide = this.slides[0];
                if ( !firstSlide ) {
                    return;
                }
                var positionX = -this.x - firstSlide.target;
                var progress = positionX / this.slidesWidth;
                this.dispatchEvent( 'scroll', null, [ progress, positionX ] );
            };

            proto.positionSliderAtSelected = function() {
                if ( !this.cells.length ) {
                    return;
                }
                this.x = -this.selectedSlide.target;
                this.velocity = 0; // stop wobble
                this.positionSlider();
            };

            proto.getPositionValue = function( position ) {
                if ( this.options.percentPosition ) {
                    // percent position, round to 2 digits, like 12.34%
                    return ( Math.round( ( position / this.size.innerWidth ) * 10000 ) * 0.01 )+ '%';
                } else {
                    // pixel positioning
                    return Math.round( position ) + 'px';
                }
            };

            proto.settle = function( previousX ) {
                // keep track of frames where x hasn't moved
                if ( !this.isPointerDown && Math.round( this.x * 100 ) == Math.round( previousX * 100 ) ) {
                    this.restingFrames++;
                }
                // stop animating if resting for 3 or more frames
                if ( this.restingFrames > 2 ) {
                    this.isAnimating = false;
                    delete this.isFreeScrolling;
                    // render position with translateX when settled
                    this.positionSlider();
                    this.dispatchEvent( 'settle', null, [ this.selectedIndex ] );
                }
            };

            proto.shiftWrapCells = function( x ) {
                // shift before cells
                var beforeGap = this.cursorPosition + x;
                this._shiftCells( this.beforeShiftCells, beforeGap, -1 );
                // shift after cells
                var afterGap = this.size.innerWidth - ( x + this.slideableWidth + this.cursorPosition );
                this._shiftCells( this.afterShiftCells, afterGap, 1 );
            };

            proto._shiftCells = function( cells, gap, shift ) {
                for ( var i=0; i < cells.length; i++ ) {
                    var cell = cells[i];
                    var cellShift = gap > 0 ? shift : 0;
                    cell.wrapShift( cellShift );
                    gap -= cell.size.outerWidth;
                }
            };

            proto._unshiftCells = function( cells ) {
                if ( !cells || !cells.length ) {
                    return;
                }
                for ( var i=0; i < cells.length; i++ ) {
                    cells[i].wrapShift( 0 );
                }
            };

// -------------------------- physics -------------------------- //

            proto.integratePhysics = function() {
                this.x += this.velocity;
                this.velocity *= this.getFrictionFactor();
            };

            proto.applyForce = function( force ) {
                this.velocity += force;
            };

            proto.getFrictionFactor = function() {
                return 1 - this.options[ this.isFreeScrolling ? 'freeScrollFriction' : 'friction' ];
            };

            proto.getRestingPosition = function() {
                // my thanks to Steven Wittens, who simplified this math greatly
                return this.x + this.velocity / ( 1 - this.getFrictionFactor() );
            };

            proto.applyDragForce = function() {
                if ( !this.isDraggable || !this.isPointerDown ) {
                    return;
                }
                // change the position to drag position by applying force
                var dragVelocity = this.dragX - this.x;
                var dragForce = dragVelocity - this.velocity;
                this.applyForce( dragForce );
            };

            proto.applySelectedAttraction = function() {
                // do not attract if pointer down or no slides
                var dragDown = this.isDraggable && this.isPointerDown;
                if ( dragDown || this.isFreeScrolling || !this.slides.length ) {
                    return;
                }
                var distance = this.selectedSlide.target * -1 - this.x;
                var force = distance * this.options.selectedAttraction;
                this.applyForce( force );
            };

            return proto;

        }));


        /***/ }),
    /* 25 */
    /***/ (function(module, exports, __webpack_require__) {

        var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// drag
        ( function( window, factory ) {
            // universal module definition
            /* jshint strict: false */
            if ( true ) {
                // AMD
                !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
                    __webpack_require__(7),
                    __webpack_require__(26),
                    __webpack_require__(6)
                ], __WEBPACK_AMD_DEFINE_RESULT__ = (function( Flickity, Unidragger, utils ) {
                    return factory( window, Flickity, Unidragger, utils );
                }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
                __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
            } else {}

        }( window, function factory( window, Flickity, Unidragger, utils ) {

            'use strict';

// ----- defaults ----- //

            utils.extend( Flickity.defaults, {
                draggable: '>1',
                dragThreshold: 3,
            });

// ----- create ----- //

            Flickity.createMethods.push('_createDrag');

// -------------------------- drag prototype -------------------------- //

            var proto = Flickity.prototype;
            utils.extend( proto, Unidragger.prototype );
            proto._touchActionValue = 'pan-y';

// --------------------------  -------------------------- //

            var isTouch = 'createTouch' in document;
            var isTouchmoveScrollCanceled = false;

            proto._createDrag = function() {
                this.on( 'activate', this.onActivateDrag );
                this.on( 'uiChange', this._uiChangeDrag );
                this.on( 'deactivate', this.onDeactivateDrag );
                this.on( 'cellChange', this.updateDraggable );
                // TODO updateDraggable on resize? if groupCells & slides change
                // HACK - add seemingly innocuous handler to fix iOS 10 scroll behavior
                // #457, RubaXa/Sortable#973
                if ( isTouch && !isTouchmoveScrollCanceled ) {
                    window.addEventListener( 'touchmove', function() {});
                    isTouchmoveScrollCanceled = true;
                }
            };

            proto.onActivateDrag = function() {
                this.handles = [ this.viewport ];
                this.bindHandles();
                this.updateDraggable();
            };

            proto.onDeactivateDrag = function() {
                this.unbindHandles();
                this.element.classList.remove('is-draggable');
            };

            proto.updateDraggable = function() {
                // disable dragging if less than 2 slides. #278
                if ( this.options.draggable == '>1' ) {
                    this.isDraggable = this.slides.length > 1;
                } else {
                    this.isDraggable = this.options.draggable;
                }
                if ( this.isDraggable ) {
                    this.element.classList.add('is-draggable');
                } else {
                    this.element.classList.remove('is-draggable');
                }
            };

// backwards compatibility
            proto.bindDrag = function() {
                this.options.draggable = true;
                this.updateDraggable();
            };

            proto.unbindDrag = function() {
                this.options.draggable = false;
                this.updateDraggable();
            };

            proto._uiChangeDrag = function() {
                delete this.isFreeScrolling;
            };

// -------------------------- pointer events -------------------------- //

            proto.pointerDown = function( event, pointer ) {
                if ( !this.isDraggable ) {
                    this._pointerDownDefault( event, pointer );
                    return;
                }
                var isOkay = this.okayPointerDown( event );
                if ( !isOkay ) {
                    return;
                }

                this._pointerDownPreventDefault( event );
                this.pointerDownFocus( event );
                // blur
                if ( document.activeElement != this.element ) {
                    // do not blur if already focused
                    this.pointerDownBlur();
                }

                // stop if it was moving
                this.dragX = this.x;
                this.viewport.classList.add('is-pointer-down');
                // track scrolling
                this.pointerDownScroll = getScrollPosition();
                window.addEventListener( 'scroll', this );

                this._pointerDownDefault( event, pointer );
            };

// default pointerDown logic, used for staticClick
            proto._pointerDownDefault = function( event, pointer ) {
                // track start event position
                // Safari 9 overrides pageX and pageY. These values needs to be copied. #779
                this.pointerDownPointer = {
                    pageX: pointer.pageX,
                    pageY: pointer.pageY,
                };
                // bind move and end events
                this._bindPostStartEvents( event );
                this.dispatchEvent( 'pointerDown', event, [ pointer ] );
            };

            var focusNodes = {
                INPUT: true,
                TEXTAREA: true,
                SELECT: true,
            };

            proto.pointerDownFocus = function( event ) {
                var isFocusNode = focusNodes[ event.target.nodeName ];
                if ( !isFocusNode ) {
                    this.focus();
                }
            };

            proto._pointerDownPreventDefault = function( event ) {
                var isTouchStart = event.type == 'touchstart';
                var isTouchPointer = event.pointerType == 'touch';
                var isFocusNode = focusNodes[ event.target.nodeName ];
                if ( !isTouchStart && !isTouchPointer && !isFocusNode ) {
                    event.preventDefault();
                }
            };

// ----- move ----- //

            proto.hasDragStarted = function( moveVector ) {
                return Math.abs( moveVector.x ) > this.options.dragThreshold;
            };

// ----- up ----- //

            proto.pointerUp = function( event, pointer ) {
                delete this.isTouchScrolling;
                this.viewport.classList.remove('is-pointer-down');
                this.dispatchEvent( 'pointerUp', event, [ pointer ] );
                this._dragPointerUp( event, pointer );
            };

            proto.pointerDone = function() {
                window.removeEventListener( 'scroll', this );
                delete this.pointerDownScroll;
            };

// -------------------------- dragging -------------------------- //

            proto.dragStart = function( event, pointer ) {
                if ( !this.isDraggable ) {
                    return;
                }
                this.dragStartPosition = this.x;
                this.startAnimation();
                window.removeEventListener( 'scroll', this );
                this.dispatchEvent( 'dragStart', event, [ pointer ] );
            };

            proto.pointerMove = function( event, pointer ) {
                var moveVector = this._dragPointerMove( event, pointer );
                this.dispatchEvent( 'pointerMove', event, [ pointer, moveVector ] );
                this._dragMove( event, pointer, moveVector );
            };

            proto.dragMove = function( event, pointer, moveVector ) {
                if ( !this.isDraggable ) {
                    return;
                }
                event.preventDefault();

                this.previousDragX = this.dragX;
                // reverse if right-to-left
                var direction = this.options.rightToLeft ? -1 : 1;
                if ( this.options.wrapAround ) {
                    // wrap around move. #589
                    moveVector.x = moveVector.x % this.slideableWidth;
                }
                var dragX = this.dragStartPosition + moveVector.x * direction;

                if ( !this.options.wrapAround && this.slides.length ) {
                    // slow drag
                    var originBound = Math.max( -this.slides[0].target, this.dragStartPosition );
                    dragX = dragX > originBound ? ( dragX + originBound ) * 0.5 : dragX;
                    var endBound = Math.min( -this.getLastSlide().target, this.dragStartPosition );
                    dragX = dragX < endBound ? ( dragX + endBound ) * 0.5 : dragX;
                }

                this.dragX = dragX;

                this.dragMoveTime = new Date();
                this.dispatchEvent( 'dragMove', event, [ pointer, moveVector ] );
            };

            proto.dragEnd = function( event, pointer ) {
                if ( !this.isDraggable ) {
                    return;
                }
                if ( this.options.freeScroll ) {
                    this.isFreeScrolling = true;
                }
                // set selectedIndex based on where flick will end up
                var index = this.dragEndRestingSelect();

                if ( this.options.freeScroll && !this.options.wrapAround ) {
                    // if free-scroll & not wrap around
                    // do not free-scroll if going outside of bounding slides
                    // so bounding slides can attract slider, and keep it in bounds
                    var restingX = this.getRestingPosition();
                    this.isFreeScrolling = -restingX > this.slides[0].target &&
                            -restingX < this.getLastSlide().target;
                } else if ( !this.options.freeScroll && index == this.selectedIndex ) {
                    // boost selection if selected index has not changed
                    index += this.dragEndBoostSelect();
                }
                delete this.previousDragX;
                // apply selection
                // TODO refactor this, selecting here feels weird
                // HACK, set flag so dragging stays in correct direction
                this.isDragSelect = this.options.wrapAround;
                this.select( index );
                delete this.isDragSelect;
                this.dispatchEvent( 'dragEnd', event, [ pointer ] );
            };

            proto.dragEndRestingSelect = function() {
                var restingX = this.getRestingPosition();
                // how far away from selected slide
                var distance = Math.abs( this.getSlideDistance( -restingX, this.selectedIndex ) );
                // get closet resting going up and going down
                var positiveResting = this._getClosestResting( restingX, distance, 1 );
                var negativeResting = this._getClosestResting( restingX, distance, -1 );
                // use closer resting for wrap-around
                var index = positiveResting.distance < negativeResting.distance ?
                        positiveResting.index : negativeResting.index;
                return index;
            };

            /**
             * given resting X and distance to selected cell
             * get the distance and index of the closest cell
             * @param {Number} restingX - estimated post-flick resting position
             * @param {Number} distance - distance to selected cell
             * @param {Integer} increment - +1 or -1, going up or down
             * @returns {Object} - { distance: {Number}, index: {Integer} }
             */
            proto._getClosestResting = function( restingX, distance, increment ) {
                var index = this.selectedIndex;
                var minDistance = Infinity;
                var condition = this.options.contain && !this.options.wrapAround ?
                        // if contain, keep going if distance is equal to minDistance
                        function( d, md ) { return d <= md; } : function( d, md ) { return d < md; };
                while ( condition( distance, minDistance ) ) {
                    // measure distance to next cell
                    index += increment;
                    minDistance = distance;
                    distance = this.getSlideDistance( -restingX, index );
                    if ( distance === null ) {
                        break;
                    }
                    distance = Math.abs( distance );
                }
                return {
                    distance: minDistance,
                    // selected was previous index
                    index: index - increment
                };
            };

            /**
             * measure distance between x and a slide target
             * @param {Number} x
             * @param {Integer} index - slide index
             */
            proto.getSlideDistance = function( x, index ) {
                var len = this.slides.length;
                // wrap around if at least 2 slides
                var isWrapAround = this.options.wrapAround && len > 1;
                var slideIndex = isWrapAround ? utils.modulo( index, len ) : index;
                var slide = this.slides[ slideIndex ];
                if ( !slide ) {
                    return null;
                }
                // add distance for wrap-around slides
                var wrap = isWrapAround ? this.slideableWidth * Math.floor( index / len ) : 0;
                return x - ( slide.target + wrap );
            };

            proto.dragEndBoostSelect = function() {
                // do not boost if no previousDragX or dragMoveTime
                if ( this.previousDragX === undefined || !this.dragMoveTime ||
                        // or if drag was held for 100 ms
                        new Date() - this.dragMoveTime > 100 ) {
                    return 0;
                }

                var distance = this.getSlideDistance( -this.dragX, this.selectedIndex );
                var delta = this.previousDragX - this.dragX;
                if ( distance > 0 && delta > 0 ) {
                    // boost to next if moving towards the right, and positive velocity
                    return 1;
                } else if ( distance < 0 && delta < 0 ) {
                    // boost to previous if moving towards the left, and negative velocity
                    return -1;
                }
                return 0;
            };

// ----- staticClick ----- //

            proto.staticClick = function( event, pointer ) {
                // get clickedCell, if cell was clicked
                var clickedCell = this.getParentCell( event.target );
                var cellElem = clickedCell && clickedCell.element;
                var cellIndex = clickedCell && this.cells.indexOf( clickedCell );
                this.dispatchEvent( 'staticClick', event, [ pointer, cellElem, cellIndex ] );
            };

// ----- scroll ----- //

            proto.onscroll = function() {
                var scroll = getScrollPosition();
                var scrollMoveX = this.pointerDownScroll.x - scroll.x;
                var scrollMoveY = this.pointerDownScroll.y - scroll.y;
                // cancel click/tap if scroll is too much
                if ( Math.abs( scrollMoveX ) > 3 || Math.abs( scrollMoveY ) > 3 ) {
                    this._pointerDone();
                }
            };

// ----- utils ----- //

            function getScrollPosition() {
                return {
                    x: window.pageXOffset,
                    y: window.pageYOffset
                };
            }

// -----  ----- //

            return Flickity;

        }));


        /***/ }),
    /* 26 */
    /***/ (function(module, exports, __webpack_require__) {

        var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
         * Unidragger v2.3.0
         * Draggable base class
         * MIT license
         */

        /*jshint browser: true, unused: true, undef: true, strict: true */

        ( function( window, factory ) {
            // universal module definition
            /*jshint strict: false */ /*globals define, module, require */

            if ( true ) {
                // AMD
                !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
                    __webpack_require__(9)
                ], __WEBPACK_AMD_DEFINE_RESULT__ = (function( Unipointer ) {
                    return factory( window, Unipointer );
                }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
                __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
            } else {}

        }( window, function factory( window, Unipointer ) {

            'use strict';

// -------------------------- Unidragger -------------------------- //

            function Unidragger() {}

// inherit Unipointer & EvEmitter
            var proto = Unidragger.prototype = Object.create( Unipointer.prototype );

// ----- bind start ----- //

            proto.bindHandles = function() {
                this._bindHandles( true );
            };

            proto.unbindHandles = function() {
                this._bindHandles( false );
            };

            /**
             * Add or remove start event
             * @param {Boolean} isAdd
             */
            proto._bindHandles = function( isAdd ) {
                // munge isAdd, default to true
                isAdd = isAdd === undefined ? true : isAdd;
                // bind each handle
                var bindMethod = isAdd ? 'addEventListener' : 'removeEventListener';
                var touchAction = isAdd ? this._touchActionValue : '';
                for ( var i=0; i < this.handles.length; i++ ) {
                    var handle = this.handles[i];
                    this._bindStartEvent( handle, isAdd );
                    handle[ bindMethod ]( 'click', this );
                    // touch-action: none to override browser touch gestures. metafizzy/flickity#540
                    if ( window.PointerEvent ) {
                        handle.style.touchAction = touchAction;
                    }
                }
            };

// prototype so it can be overwriteable by Flickity
            proto._touchActionValue = 'none';

// ----- start event ----- //

            /**
             * pointer start
             * @param {Event} event
             * @param {Event or Touch} pointer
             */
            proto.pointerDown = function( event, pointer ) {
                var isOkay = this.okayPointerDown( event );
                if ( !isOkay ) {
                    return;
                }
                // track start event position
                this.pointerDownPointer = pointer;

                event.preventDefault();
                this.pointerDownBlur();
                // bind move and end events
                this._bindPostStartEvents( event );
                this.emitEvent( 'pointerDown', [ event, pointer ] );
            };

// nodes that have text fields
            var cursorNodes = {
                TEXTAREA: true,
                INPUT: true,
                SELECT: true,
                OPTION: true,
            };

// input types that do not have text fields
            var clickTypes = {
                radio: true,
                checkbox: true,
                button: true,
                submit: true,
                image: true,
                file: true,
            };

// dismiss inputs with text fields. flickity#403, flickity#404
            proto.okayPointerDown = function( event ) {
                var isCursorNode = cursorNodes[ event.target.nodeName ];
                var isClickType = clickTypes[ event.target.type ];
                var isOkay = !isCursorNode || isClickType;
                if ( !isOkay ) {
                    this._pointerReset();
                }
                return isOkay;
            };

// kludge to blur previously focused input
            proto.pointerDownBlur = function() {
                var focused = document.activeElement;
                // do not blur body for IE10, metafizzy/flickity#117
                var canBlur = focused && focused.blur && focused != document.body;
                if ( canBlur ) {
                    focused.blur();
                }
            };

// ----- move event ----- //

            /**
             * drag move
             * @param {Event} event
             * @param {Event or Touch} pointer
             */
            proto.pointerMove = function( event, pointer ) {
                var moveVector = this._dragPointerMove( event, pointer );
                this.emitEvent( 'pointerMove', [ event, pointer, moveVector ] );
                this._dragMove( event, pointer, moveVector );
            };

// base pointer move logic
            proto._dragPointerMove = function( event, pointer ) {
                var moveVector = {
                    x: pointer.pageX - this.pointerDownPointer.pageX,
                    y: pointer.pageY - this.pointerDownPointer.pageY
                };
                // start drag if pointer has moved far enough to start drag
                if ( !this.isDragging && this.hasDragStarted( moveVector ) ) {
                    this._dragStart( event, pointer );
                }
                return moveVector;
            };

// condition if pointer has moved far enough to start drag
            proto.hasDragStarted = function( moveVector ) {
                return Math.abs( moveVector.x ) > 3 || Math.abs( moveVector.y ) > 3;
            };

// ----- end event ----- //

            /**
             * pointer up
             * @param {Event} event
             * @param {Event or Touch} pointer
             */
            proto.pointerUp = function( event, pointer ) {
                this.emitEvent( 'pointerUp', [ event, pointer ] );
                this._dragPointerUp( event, pointer );
            };

            proto._dragPointerUp = function( event, pointer ) {
                if ( this.isDragging ) {
                    this._dragEnd( event, pointer );
                } else {
                    // pointer didn't move enough for drag to start
                    this._staticClick( event, pointer );
                }
            };

// -------------------------- drag -------------------------- //

// dragStart
            proto._dragStart = function( event, pointer ) {
                this.isDragging = true;
                // prevent clicks
                this.isPreventingClicks = true;
                this.dragStart( event, pointer );
            };

            proto.dragStart = function( event, pointer ) {
                this.emitEvent( 'dragStart', [ event, pointer ] );
            };

// dragMove
            proto._dragMove = function( event, pointer, moveVector ) {
                // do not drag if not dragging yet
                if ( !this.isDragging ) {
                    return;
                }

                this.dragMove( event, pointer, moveVector );
            };

            proto.dragMove = function( event, pointer, moveVector ) {
                event.preventDefault();
                this.emitEvent( 'dragMove', [ event, pointer, moveVector ] );
            };

// dragEnd
            proto._dragEnd = function( event, pointer ) {
                // set flags
                this.isDragging = false;
                // re-enable clicking async
                setTimeout( function() {
                    delete this.isPreventingClicks;
                }.bind( this ) );

                this.dragEnd( event, pointer );
            };

            proto.dragEnd = function( event, pointer ) {
                this.emitEvent( 'dragEnd', [ event, pointer ] );
            };

// ----- onclick ----- //

// handle all clicks and prevent clicks when dragging
            proto.onclick = function( event ) {
                if ( this.isPreventingClicks ) {
                    event.preventDefault();
                }
            };

// ----- staticClick ----- //

// triggered after pointer down & up with no/tiny movement
            proto._staticClick = function( event, pointer ) {
                // ignore emulated mouse up clicks
                if ( this.isIgnoringMouseUp && event.type == 'mouseup' ) {
                    return;
                }

                this.staticClick( event, pointer );

                // set flag for emulated clicks 300ms after touchend
                if ( event.type != 'mouseup' ) {
                    this.isIgnoringMouseUp = true;
                    // reset flag after 300ms
                    setTimeout( function() {
                        delete this.isIgnoringMouseUp;
                    }.bind( this ), 400 );
                }
            };

            proto.staticClick = function( event, pointer ) {
                this.emitEvent( 'staticClick', [ event, pointer ] );
            };

// ----- utils ----- //

            Unidragger.getPointerPoint = Unipointer.getPointerPoint;

// -----  ----- //

            return Unidragger;

        }));


        /***/ }),
    /* 27 */
    /***/ (function(module, exports, __webpack_require__) {

        var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// prev/next buttons
        ( function( window, factory ) {
            // universal module definition
            /* jshint strict: false */
            if ( true ) {
                // AMD
                !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
                    __webpack_require__(7),
                    __webpack_require__(9),
                    __webpack_require__(6)
                ], __WEBPACK_AMD_DEFINE_RESULT__ = (function( Flickity, Unipointer, utils ) {
                    return factory( window, Flickity, Unipointer, utils );
                }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
                __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
            } else {}

        }( window, function factory( window, Flickity, Unipointer, utils ) {
            'use strict';

            var svgURI = 'http://www.w3.org/2000/svg';

// -------------------------- PrevNextButton -------------------------- //

            function PrevNextButton( direction, parent ) {
                this.direction = direction;
                this.parent = parent;
                this._create();
            }

            PrevNextButton.prototype = Object.create( Unipointer.prototype );

            PrevNextButton.prototype._create = function() {
                // properties
                this.isEnabled = true;
                this.isPrevious = this.direction == -1;
                var leftDirection = this.parent.options.rightToLeft ? 1 : -1;
                this.isLeft = this.direction == leftDirection;

                var element = this.element = document.createElement('button');
                element.className = 'flickity-button flickity-prev-next-button';
                element.className += this.isPrevious ? ' previous' : ' next';
                // prevent button from submitting form http://stackoverflow.com/a/10836076/182183
                element.setAttribute( 'type', 'button' );
                // init as disabled
                this.disable();

                element.setAttribute( 'aria-label', this.isPrevious ? 'Previous' : 'Next' );

                // create arrow
                var svg = this.createSVG();
                element.appendChild( svg );
                // events
                this.parent.on( 'select', this.update.bind( this ) );
                this.on( 'pointerDown', this.parent.childUIPointerDown.bind( this.parent ) );
            };

            PrevNextButton.prototype.activate = function() {
                this.bindStartEvent( this.element );
                this.element.addEventListener( 'click', this );
                // add to DOM
                this.parent.element.appendChild( this.element );
            };

            PrevNextButton.prototype.deactivate = function() {
                // remove from DOM
                this.parent.element.removeChild( this.element );
                // click events
                this.unbindStartEvent( this.element );
                this.element.removeEventListener( 'click', this );
            };

            PrevNextButton.prototype.createSVG = function() {
                var svg = document.createElementNS( svgURI, 'svg');
                svg.setAttribute( 'class', 'flickity-button-icon' );
                svg.setAttribute( 'viewBox', '0 0 100 100' );
                var path = document.createElementNS( svgURI, 'path');
                var pathMovements = getArrowMovements( this.parent.options.arrowShape );
                path.setAttribute( 'd', pathMovements );
                path.setAttribute( 'class', 'arrow' );
                // rotate arrow
                if ( !this.isLeft ) {
                    path.setAttribute( 'transform', 'translate(100, 100) rotate(180) ' );
                }
                svg.appendChild( path );
                return svg;
            };

// get SVG path movmement
            function getArrowMovements( shape ) {
                // use shape as movement if string
                if ( typeof shape == 'string' ) {
                    return shape;
                }
                // create movement string
                return 'M ' + shape.x0 + ',50' +
                        ' L ' + shape.x1 + ',' + ( shape.y1 + 50 ) +
                        ' L ' + shape.x2 + ',' + ( shape.y2 + 50 ) +
                        ' L ' + shape.x3 + ',50 ' +
                        ' L ' + shape.x2 + ',' + ( 50 - shape.y2 ) +
                        ' L ' + shape.x1 + ',' + ( 50 - shape.y1 ) +
                        ' Z';
            }

            PrevNextButton.prototype.handleEvent = utils.handleEvent;

            PrevNextButton.prototype.onclick = function() {
                if ( !this.isEnabled ) {
                    return;
                }
                this.parent.uiChange();
                var method = this.isPrevious ? 'previous' : 'next';
                this.parent[ method ]();
            };

// -----  ----- //

            PrevNextButton.prototype.enable = function() {
                if ( this.isEnabled ) {
                    return;
                }
                this.element.disabled = false;
                this.isEnabled = true;
            };

            PrevNextButton.prototype.disable = function() {
                if ( !this.isEnabled ) {
                    return;
                }
                this.element.disabled = true;
                this.isEnabled = false;
            };

            PrevNextButton.prototype.update = function() {
                // index of first or last slide, if previous or next
                var slides = this.parent.slides;
                // enable is wrapAround and at least 2 slides
                if ( this.parent.options.wrapAround && slides.length > 1 ) {
                    this.enable();
                    return;
                }
                var lastIndex = slides.length ? slides.length - 1 : 0;
                var boundIndex = this.isPrevious ? 0 : lastIndex;
                var method = this.parent.selectedIndex == boundIndex ? 'disable' : 'enable';
                this[ method ]();
            };

            PrevNextButton.prototype.destroy = function() {
                this.deactivate();
                this.allOff();
            };

// -------------------------- Flickity prototype -------------------------- //

            utils.extend( Flickity.defaults, {
                prevNextButtons: true,
                arrowShape: {
                    x0: 10,
                    x1: 60, y1: 50,
                    x2: 70, y2: 40,
                    x3: 30
                }
            });

            Flickity.createMethods.push('_createPrevNextButtons');
            var proto = Flickity.prototype;

            proto._createPrevNextButtons = function() {
                if ( !this.options.prevNextButtons ) {
                    return;
                }

                this.prevButton = new PrevNextButton( -1, this );
                this.nextButton = new PrevNextButton( 1, this );

                this.on( 'activate', this.activatePrevNextButtons );
            };

            proto.activatePrevNextButtons = function() {
                this.prevButton.activate();
                this.nextButton.activate();
                this.on( 'deactivate', this.deactivatePrevNextButtons );
            };

            proto.deactivatePrevNextButtons = function() {
                this.prevButton.deactivate();
                this.nextButton.deactivate();
                this.off( 'deactivate', this.deactivatePrevNextButtons );
            };

// --------------------------  -------------------------- //

            Flickity.PrevNextButton = PrevNextButton;

            return Flickity;

        }));


        /***/ }),
    /* 28 */
    /***/ (function(module, exports, __webpack_require__) {

        var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// page dots
        ( function( window, factory ) {
            // universal module definition
            /* jshint strict: false */
            if ( true ) {
                // AMD
                !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
                    __webpack_require__(7),
                    __webpack_require__(9),
                    __webpack_require__(6)
                ], __WEBPACK_AMD_DEFINE_RESULT__ = (function( Flickity, Unipointer, utils ) {
                    return factory( window, Flickity, Unipointer, utils );
                }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
                __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
            } else {}

        }( window, function factory( window, Flickity, Unipointer, utils ) {

// -------------------------- PageDots -------------------------- //

            'use strict';

            function PageDots( parent ) {
                this.parent = parent;
                this._create();
            }

            PageDots.prototype = Object.create( Unipointer.prototype );

            PageDots.prototype._create = function() {
                // create holder element
                this.holder = document.createElement('ol');
                this.holder.className = 'flickity-page-dots';
                // create dots, array of elements
                this.dots = [];
                // events
                this.handleClick = this.onClick.bind( this );
                this.on( 'pointerDown', this.parent.childUIPointerDown.bind( this.parent ) );
            };

            PageDots.prototype.activate = function() {
                this.setDots();
                this.holder.addEventListener( 'click', this.handleClick );
                this.bindStartEvent( this.holder );
                // add to DOM
                this.parent.element.appendChild( this.holder );
            };

            PageDots.prototype.deactivate = function() {
                this.holder.removeEventListener( 'click', this.handleClick );
                this.unbindStartEvent( this.holder );
                // remove from DOM
                this.parent.element.removeChild( this.holder );
            };

            PageDots.prototype.setDots = function() {
                // get difference between number of slides and number of dots
                var delta = this.parent.slides.length - this.dots.length;
                if ( delta > 0 ) {
                    this.addDots( delta );
                } else if ( delta < 0 ) {
                    this.removeDots( -delta );
                }
            };

            PageDots.prototype.addDots = function( count ) {
                var fragment = document.createDocumentFragment();
                var newDots = [];
                var length = this.dots.length;
                var max = length + count;

                for ( var i = length; i < max; i++ ) {
                    var dot = document.createElement('li');
                    dot.className = 'dot';
                    dot.setAttribute( 'aria-label', 'Page dot ' + ( i + 1 ) );
                    fragment.appendChild( dot );
                    newDots.push( dot );
                }

                this.holder.appendChild( fragment );
                this.dots = this.dots.concat( newDots );
            };

            PageDots.prototype.removeDots = function( count ) {
                // remove from this.dots collection
                var removeDots = this.dots.splice( this.dots.length - count, count );
                // remove from DOM
                removeDots.forEach( function( dot ) {
                    this.holder.removeChild( dot );
                }, this );
            };

            PageDots.prototype.updateSelected = function() {
                // remove selected class on previous
                if ( this.selectedDot ) {
                    this.selectedDot.className = 'dot';
                    this.selectedDot.removeAttribute('aria-current');
                }
                // don't proceed if no dots
                if ( !this.dots.length ) {
                    return;
                }
                this.selectedDot = this.dots[ this.parent.selectedIndex ];
                this.selectedDot.className = 'dot is-selected';
                this.selectedDot.setAttribute( 'aria-current', 'step' );
            };

            PageDots.prototype.onTap = // old method name, backwards-compatible
                    PageDots.prototype.onClick = function( event ) {
                        var target = event.target;
                        // only care about dot clicks
                        if ( target.nodeName != 'LI' ) {
                            return;
                        }

                        this.parent.uiChange();
                        var index = this.dots.indexOf( target );
                        this.parent.select( index );
                    };

            PageDots.prototype.destroy = function() {
                this.deactivate();
                this.allOff();
            };

            Flickity.PageDots = PageDots;

// -------------------------- Flickity -------------------------- //

            utils.extend( Flickity.defaults, {
                pageDots: true
            });

            Flickity.createMethods.push('_createPageDots');

            var proto = Flickity.prototype;

            proto._createPageDots = function() {
                if ( !this.options.pageDots ) {
                    return;
                }
                this.pageDots = new PageDots( this );
                // events
                this.on( 'activate', this.activatePageDots );
                this.on( 'select', this.updateSelectedPageDots );
                this.on( 'cellChange', this.updatePageDots );
                this.on( 'resize', this.updatePageDots );
                this.on( 'deactivate', this.deactivatePageDots );
            };

            proto.activatePageDots = function() {
                this.pageDots.activate();
            };

            proto.updateSelectedPageDots = function() {
                this.pageDots.updateSelected();
            };

            proto.updatePageDots = function() {
                this.pageDots.setDots();
            };

            proto.deactivatePageDots = function() {
                this.pageDots.deactivate();
            };

// -----  ----- //

            Flickity.PageDots = PageDots;

            return Flickity;

        }));


        /***/ }),
    /* 29 */
    /***/ (function(module, exports, __webpack_require__) {

        var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// player & autoPlay
        ( function( window, factory ) {
            // universal module definition
            /* jshint strict: false */
            if ( true ) {
                // AMD
                !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
                    __webpack_require__(8),
                    __webpack_require__(6),
                    __webpack_require__(7)
                ], __WEBPACK_AMD_DEFINE_RESULT__ = (function( EvEmitter, utils, Flickity ) {
                    return factory( EvEmitter, utils, Flickity );
                }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
                __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
            } else {}

        }( window, function factory( EvEmitter, utils, Flickity ) {

            'use strict';

// -------------------------- Player -------------------------- //

            function Player( parent ) {
                this.parent = parent;
                this.state = 'stopped';
                // visibility change event handler
                this.onVisibilityChange = this.visibilityChange.bind( this );
                this.onVisibilityPlay = this.visibilityPlay.bind( this );
            }

            Player.prototype = Object.create( EvEmitter.prototype );

// start play
            Player.prototype.play = function() {
                if ( this.state == 'playing' ) {
                    return;
                }
                // do not play if page is hidden, start playing when page is visible
                var isPageHidden = document.hidden;
                if ( isPageHidden ) {
                    document.addEventListener( 'visibilitychange', this.onVisibilityPlay );
                    return;
                }

                this.state = 'playing';
                // listen to visibility change
                document.addEventListener( 'visibilitychange', this.onVisibilityChange );
                // start ticking
                this.tick();
            };

            Player.prototype.tick = function() {
                // do not tick if not playing
                if ( this.state != 'playing' ) {
                    return;
                }

                var time = this.parent.options.autoPlay;
                // default to 3 seconds
                time = typeof time == 'number' ? time : 3000;
                var _this = this;
                // HACK: reset ticks if stopped and started within interval
                this.clear();
                this.timeout = setTimeout( function() {
                    _this.parent.next( true );
                    _this.tick();
                }, time );
            };

            Player.prototype.stop = function() {
                this.state = 'stopped';
                this.clear();
                // remove visibility change event
                document.removeEventListener( 'visibilitychange', this.onVisibilityChange );
            };

            Player.prototype.clear = function() {
                clearTimeout( this.timeout );
            };

            Player.prototype.pause = function() {
                if ( this.state == 'playing' ) {
                    this.state = 'paused';
                    this.clear();
                }
            };

            Player.prototype.unpause = function() {
                // re-start play if paused
                if ( this.state == 'paused' ) {
                    this.play();
                }
            };

// pause if page visibility is hidden, unpause if visible
            Player.prototype.visibilityChange = function() {
                var isPageHidden = document.hidden;
                this[ isPageHidden ? 'pause' : 'unpause' ]();
            };

            Player.prototype.visibilityPlay = function() {
                this.play();
                document.removeEventListener( 'visibilitychange', this.onVisibilityPlay );
            };

// -------------------------- Flickity -------------------------- //

            utils.extend( Flickity.defaults, {
                pauseAutoPlayOnHover: true
            });

            Flickity.createMethods.push('_createPlayer');
            var proto = Flickity.prototype;

            proto._createPlayer = function() {
                this.player = new Player( this );

                this.on( 'activate', this.activatePlayer );
                this.on( 'uiChange', this.stopPlayer );
                this.on( 'pointerDown', this.stopPlayer );
                this.on( 'deactivate', this.deactivatePlayer );
            };

            proto.activatePlayer = function() {
                if ( !this.options.autoPlay ) {
                    return;
                }
                this.player.play();
                this.element.addEventListener( 'mouseenter', this );
            };

// Player API, don't hate the ... thanks I know where the door is

            proto.playPlayer = function() {
                this.player.play();
            };

            proto.stopPlayer = function() {
                this.player.stop();
            };

            proto.pausePlayer = function() {
                this.player.pause();
            };

            proto.unpausePlayer = function() {
                this.player.unpause();
            };

            proto.deactivatePlayer = function() {
                this.player.stop();
                this.element.removeEventListener( 'mouseenter', this );
            };

// ----- mouseenter/leave ----- //

// pause auto-play on hover
            proto.onmouseenter = function() {
                if ( !this.options.pauseAutoPlayOnHover ) {
                    return;
                }
                this.player.pause();
                this.element.addEventListener( 'mouseleave', this );
            };

// resume auto-play on hover off
            proto.onmouseleave = function() {
                this.player.unpause();
                this.element.removeEventListener( 'mouseleave', this );
            };

// -----  ----- //

            Flickity.Player = Player;

            return Flickity;

        }));


        /***/ }),
    /* 30 */
    /***/ (function(module, exports, __webpack_require__) {

        var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// add, remove cell
        ( function( window, factory ) {
            // universal module definition
            /* jshint strict: false */
            if ( true ) {
                // AMD
                !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
                    __webpack_require__(7),
                    __webpack_require__(6)
                ], __WEBPACK_AMD_DEFINE_RESULT__ = (function( Flickity, utils ) {
                    return factory( window, Flickity, utils );
                }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
                __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
            } else {}

        }( window, function factory( window, Flickity, utils ) {

            'use strict';

// append cells to a document fragment
            function getCellsFragment( cells ) {
                var fragment = document.createDocumentFragment();
                cells.forEach( function( cell ) {
                    fragment.appendChild( cell.element );
                });
                return fragment;
            }

// -------------------------- add/remove cell prototype -------------------------- //

            var proto = Flickity.prototype;

            /**
             * Insert, prepend, or append cells
             * @param {Element, Array, NodeList} elems
             * @param {Integer} index
             */
            proto.insert = function( elems, index ) {
                var cells = this._makeCells( elems );
                if ( !cells || !cells.length ) {
                    return;
                }
                var len = this.cells.length;
                // default to append
                index = index === undefined ? len : index;
                // add cells with document fragment
                var fragment = getCellsFragment( cells );
                // append to slider
                var isAppend = index == len;
                if ( isAppend ) {
                    this.slider.appendChild( fragment );
                } else {
                    var insertCellElement = this.cells[ index ].element;
                    this.slider.insertBefore( fragment, insertCellElement );
                }
                // add to this.cells
                if ( index === 0 ) {
                    // prepend, add to start
                    this.cells = cells.concat( this.cells );
                } else if ( isAppend ) {
                    // append, add to end
                    this.cells = this.cells.concat( cells );
                } else {
                    // insert in this.cells
                    var endCells = this.cells.splice( index, len - index );
                    this.cells = this.cells.concat( cells ).concat( endCells );
                }

                this._sizeCells( cells );
                this.cellChange( index, true );
            };

            proto.append = function( elems ) {
                this.insert( elems, this.cells.length );
            };

            proto.prepend = function( elems ) {
                this.insert( elems, 0 );
            };

            /**
             * Remove cells
             * @param {Element, Array, NodeList} elems
             */
            proto.remove = function( elems ) {
                var cells = this.getCells( elems );
                if ( !cells || !cells.length ) {
                    return;
                }

                var minCellIndex = this.cells.length - 1;
                // remove cells from collection & DOM
                cells.forEach( function( cell ) {
                    cell.remove();
                    var index = this.cells.indexOf( cell );
                    minCellIndex = Math.min( index, minCellIndex );
                    utils.removeFrom( this.cells, cell );
                }, this );

                this.cellChange( minCellIndex, true );
            };

            /**
             * logic to be run after a cell's size changes
             * @param {Element} elem - cell's element
             */
            proto.cellSizeChange = function( elem ) {
                var cell = this.getCell( elem );
                if ( !cell ) {
                    return;
                }
                cell.getSize();

                var index = this.cells.indexOf( cell );
                this.cellChange( index );
            };

            /**
             * logic any time a cell is changed: added, removed, or size changed
             * @param {Integer} changedCellIndex - index of the changed cell, optional
             */
            proto.cellChange = function( changedCellIndex, isPositioningSlider ) {
                var prevSelectedElem = this.selectedElement;
                this._positionCells( changedCellIndex );
                this._getWrapShiftCells();
                this.setGallerySize();
                // update selectedIndex
                // try to maintain position & select previous selected element
                var cell = this.getCell( prevSelectedElem );
                if ( cell ) {
                    this.selectedIndex = this.getCellSlideIndex( cell );
                }
                this.selectedIndex = Math.min( this.slides.length - 1, this.selectedIndex );

                this.emitEvent( 'cellChange', [ changedCellIndex ] );
                // position slider
                this.select( this.selectedIndex );
                // do not position slider after lazy load
                if ( isPositioningSlider ) {
                    this.positionSliderAtSelected();
                }
            };

// -----  ----- //

            return Flickity;

        }));


        /***/ }),
    /* 31 */
    /***/ (function(module, exports, __webpack_require__) {

        var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// lazyload
        ( function( window, factory ) {
            // universal module definition
            /* jshint strict: false */
            if ( true ) {
                // AMD
                !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
                    __webpack_require__(7),
                    __webpack_require__(6)
                ], __WEBPACK_AMD_DEFINE_RESULT__ = (function( Flickity, utils ) {
                    return factory( window, Flickity, utils );
                }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
                __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
            } else {}

        }( window, function factory( window, Flickity, utils ) {
            'use strict';

            Flickity.createMethods.push('_createLazyload');
            var proto = Flickity.prototype;

            proto._createLazyload = function() {
                this.on( 'select', this.lazyLoad );
            };

            proto.lazyLoad = function() {
                var lazyLoad = this.options.lazyLoad;
                if ( !lazyLoad ) {
                    return;
                }
                // get adjacent cells, use lazyLoad option for adjacent count
                var adjCount = typeof lazyLoad == 'number' ? lazyLoad : 0;
                var cellElems = this.getAdjacentCellElements( adjCount );
                // get lazy images in those cells
                var lazyImages = [];
                cellElems.forEach( function( cellElem ) {
                    var lazyCellImages = getCellLazyImages( cellElem );
                    lazyImages = lazyImages.concat( lazyCellImages );
                });
                // load lazy images
                lazyImages.forEach( function( img ) {
                    new LazyLoader( img, this );
                }, this );
            };

            function getCellLazyImages( cellElem ) {
                // check if cell element is lazy image
                if ( cellElem.nodeName == 'IMG' ) {
                    var lazyloadAttr = cellElem.getAttribute('data-flickity-lazyload');
                    var srcAttr = cellElem.getAttribute('data-flickity-lazyload-src');
                    var srcsetAttr = cellElem.getAttribute('data-flickity-lazyload-srcset');
                    if ( lazyloadAttr || srcAttr || srcsetAttr ) {
                        return [ cellElem ];
                    }
                }
                // select lazy images in cell
                var lazySelector = 'img[data-flickity-lazyload], ' +
                        'img[data-flickity-lazyload-src], img[data-flickity-lazyload-srcset]';
                var imgs = cellElem.querySelectorAll( lazySelector );
                return utils.makeArray( imgs );
            }

// -------------------------- LazyLoader -------------------------- //

            /**
             * class to handle loading images
             */
            function LazyLoader( img, flickity ) {
                this.img = img;
                this.flickity = flickity;
                this.load();
            }

            LazyLoader.prototype.handleEvent = utils.handleEvent;

            LazyLoader.prototype.load = function() {
                this.img.addEventListener( 'load', this );
                this.img.addEventListener( 'error', this );
                // get src & srcset
                var src = this.img.getAttribute('data-flickity-lazyload') ||
                        this.img.getAttribute('data-flickity-lazyload-src');
                var srcset = this.img.getAttribute('data-flickity-lazyload-srcset');
                // set src & serset
                this.img.src = src;
                if ( srcset ) {
                    this.img.setAttribute( 'srcset', srcset );
                }
                // remove attr
                this.img.removeAttribute('data-flickity-lazyload');
                this.img.removeAttribute('data-flickity-lazyload-src');
                this.img.removeAttribute('data-flickity-lazyload-srcset');
            };

            LazyLoader.prototype.onload = function( event ) {
                this.complete( event, 'flickity-lazyloaded' );
            };

            LazyLoader.prototype.onerror = function( event ) {
                this.complete( event, 'flickity-lazyerror' );
            };

            LazyLoader.prototype.complete = function( event, className ) {
                // unbind events
                this.img.removeEventListener( 'load', this );
                this.img.removeEventListener( 'error', this );

                var cell = this.flickity.getParentCell( this.img );
                var cellElem = cell && cell.element;
                this.flickity.cellSizeChange( cellElem );

                this.img.classList.add( className );
                this.flickity.dispatchEvent( 'lazyLoad', event, cellElem );
            };

// -----  ----- //

            Flickity.LazyLoader = LazyLoader;

            return Flickity;

        }));


        /***/ }),
    /* 32 */
    /***/ (function(module, exports) {

        var g;

// This works in non-strict mode
        g = (function() {
            return this;
        })();

        try {
            // This works if eval is allowed (see CSP)
            g = g || new Function("return this")();
        } catch (e) {
            // This works if the window reference is available
            if (typeof window === "object") g = window;
        }

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

        module.exports = g;


        /***/ }),
    /* 33 */
    /***/ (function(module, __webpack_exports__, __webpack_require__) {

        "use strict";
// ESM COMPAT FLAG
        __webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/jquery/dist/jquery.js
        var jquery = __webpack_require__(0);
        var jquery_default = /*#__PURE__*/__webpack_require__.n(jquery);

// CONCATENATED MODULE: ./source/scripts/globals/jquery.js
// jQuery plugins expect to find a global `jQuery` object, so we
// need to attach it to the window.
//
// This is in its own file because we have to attach it before any
// other imports happen, but with ES6 modules, all `import`s have
// to be at the top.

        window.jQuery = jquery_default.a;
        window.$ = jquery_default.a;
// EXTERNAL MODULE: ./node_modules/jquery-trend/jquery.trend.js
        var jquery_trend = __webpack_require__(19);

// EXTERNAL MODULE: ./node_modules/jquery-revealer/jquery.revealer.js
        var jquery_revealer = __webpack_require__(20);

// EXTERNAL MODULE: ./node_modules/scriptjs/dist/script.js
        var script = __webpack_require__(1);
        var script_default = /*#__PURE__*/__webpack_require__.n(script);

// CONCATENATED MODULE: ./node_modules/@pixelunion/pxs-map/dist/index.es.js

        /*!
         * @pixelunion/pxs-map v2.0.7
         * (c) 2021 Pixel Union
         */



        function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
                throw new TypeError("Cannot call a class as a function");
            }
        }

        function _toConsumableArray(arr) {
            return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
        }

        function _arrayWithoutHoles(arr) {
            if (Array.isArray(arr)) return _arrayLikeToArray(arr);
        }

        function _iterableToArray(iter) {
            if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
        }

        function _unsupportedIterableToArray(o, minLen) {
            if (!o) return;
            if (typeof o === "string") return _arrayLikeToArray(o, minLen);
            var n = Object.prototype.toString.call(o).slice(8, -1);
            if (n === "Object" && o.constructor) n = o.constructor.name;
            if (n === "Map" || n === "Set") return Array.from(n);
            if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
        }

        function _arrayLikeToArray(arr, len) {
            if (len == null || len > arr.length) len = arr.length;

            for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

            return arr2;
        }

        function _nonIterableSpread() {
            throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }

        /*
         * Function to convert any given latitude and longitude format to decimal degrees
         */
        function getDecimalDegrees() {
            var firstComponent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
            var secondComponent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
            var thirdComponent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
            var fourthComponent = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
            var directions = {
                N: 1,
                E: 1,
                S: -1,
                W: -1
            };
            var decimalDegrees = 0.0;
            var components = [firstComponent, secondComponent, thirdComponent, fourthComponent];

            for (var i = 0; i < components.length; i++) {
                var component = components[i];

                if (component) {
                    if (Number.isNaN(parseFloat(component))) {
                        decimalDegrees *= directions[component];
                    } else {
                        decimalDegrees += parseFloat(component) / Math.pow(60, i);
                    }
                }
            }

            return decimalDegrees;
        }
        /*
         * By providing the ability to use a place name, or latitude and longitude coordinates
         * we give merchants, and our demo stores the option to bypass the Geocoding API.
         * The Geocoding API (https://developers.google.com/maps/documentation/geocoding/usage-and-billing) allows us
         * to take a place name and convert it to latitude and longitude expressed in decimal degrees.
         */


        function getLatitudeLongitude(address) {
            // Degrees, Minutes and Seconds: DDD° MM' SS.S"
            var latLongDegreesMinutesSeconds = /^([0-9]{1,3})(?:°[ ]?| )([0-9]{1,2})(?:'[ ]?| )([0-9]{1,2}(?:\.[0-9]+)?)(?:"[ ]?| )?(N|E|S|W) ?([0-9]{1,3})(?:°[ ]?| )([0-9]{1,2})(?:'[ ]?| )([0-9]{1,2}(?:\.[0-9]+)?)(?:"[ ]?| )?(N|E|S|W)$/g; // Degrees and Decimal Minutes: DDD° MM.MMM'

            var latLongDegreesMinutes = /^([0-9]{1,3})(?:°[ ]?| )([0-9]{1,2}(?:\.[0-9]+)?)(?:'[ ]?| )?(N|E|S|W) ?([0-9]{1,3})(?:°[ ]?| )([0-9]{1,2}(?:\.[0-9]+)?)(?:'[ ]?| )?(N|E|S|W)$/g; // Decimal Degrees: DDD.DDDDD°

            var latLongDegrees = /^([-|+]?[0-9]{1,3}(?:\.[0-9]+)?)(?:°[ ]?| )?(N|E|S|W)?,? ?([-|+]?[0-9]{1,3}(?:\.[0-9]+)?)(?:°[ ]?| )?(N|E|S|W)?$/g;
            var latLongFormats = [latLongDegreesMinutesSeconds, latLongDegreesMinutes, latLongDegrees];
            var latLongMatches = latLongFormats.map(function (latLongFormat) {
                return address.match(latLongFormat);
            });
            /*
             * Select the first latitude and longitude format that is matched.
             * Ordering:
             *   1. Degrees, minutes, and seconds,
             *   2. Degrees, and decimal minutes,
             *   3. Decimal degrees.
             */

            var latLongMatch = latLongMatches.reduce(function (accumulator, value, index) {
                if (!accumulator && value) {
                    var latLongResult = latLongFormats[index].exec(address);
                    var lat = latLongResult.slice(1, latLongResult.length / 2 + 1);
                    var lng = latLongResult.slice(latLongResult.length / 2 + 1, latLongResult.length);
                    return {
                        lat: lat,
                        lng: lng
                    };
                }

                return accumulator;
            }, null);
            return new Promise(function (resolve, reject) {
                // If we've got a match on latitude and longitude, use that and avoid geocoding
                if (latLongMatch) {
                    var latDecimalDegrees = getDecimalDegrees.apply(void 0, _toConsumableArray(latLongMatch.lat));
                    var longDecimalDegrees = getDecimalDegrees.apply(void 0, _toConsumableArray(latLongMatch.lng));
                    resolve({
                        lat: latDecimalDegrees,
                        lng: longDecimalDegrees
                    });
                } else {
                    // Otherwise, geocode the assumed address
                    var geocoder = new google.maps.Geocoder();
                    geocoder.geocode({
                        address: address
                    }, function (results, status) {
                        if (status !== google.maps.GeocoderStatus.OK || !results[0]) {
                            reject(status);
                        } else {
                            resolve(results[0].geometry.location);
                        }
                    });
                }
            });
        }

        function getMapStyles(colors) {
            if (!colors) {
                return [];
            }

            return [{
                elementType: 'geometry',
                stylers: [{
                    color: colors.e
                }]
            }, {
                elementType: 'labels.icon',
                stylers: [{
                    visibility: 'off'
                }]
            }, {
                elementType: 'labels.text.fill',
                stylers: [{
                    color: colors.a
                }]
            }, {
                elementType: 'labels.text.stroke',
                stylers: [{
                    color: colors.e
                }]
            }, {
                featureType: 'administrative',
                elementType: 'geometry',
                stylers: [{
                    visibility: 'off'
                }]
            }, {
                featureType: 'administrative.country',
                stylers: [{
                    visibility: 'off'
                }]
            }, {
                featureType: 'administrative.land_parcel',
                stylers: [{
                    visibility: 'off'
                }]
            }, {
                featureType: 'administrative.neighborhood',
                stylers: [{
                    visibility: 'off'
                }]
            }, {
                featureType: 'administrative.locality',
                stylers: [{
                    visibility: 'off'
                }]
            }, {
                featureType: 'poi',
                stylers: [{
                    visibility: 'off'
                }]
            }, {
                featureType: 'road',
                elementType: 'geometry.fill',
                stylers: [{
                    color: colors.d
                }]
            }, {
                featureType: 'road',
                elementType: 'labels.icon',
                stylers: [{
                    visibility: 'off'
                }]
            }, {
                featureType: 'road.arterial',
                elementType: 'geometry',
                stylers: [{
                    color: colors.c
                }]
            }, {
                featureType: 'road.highway',
                elementType: 'geometry',
                stylers: [{
                    color: colors.b
                }]
            }, {
                featureType: 'road.highway.controlled_access',
                stylers: [{
                    visibility: 'off'
                }]
            }, {
                featureType: 'road.local',
                elementType: 'labels.text.fill',
                stylers: [{
                    color: colors.b
                }]
            }, {
                featureType: 'road.local',
                elementType: 'labels.text.stroke',
                stylers: [{
                    color: colors.e
                }]
            }, {
                featureType: 'transit',
                stylers: [{
                    visibility: 'off'
                }]
            }, {
                featureType: 'water',
                elementType: 'geometry',
                stylers: [{
                    color: colors.f
                }]
            }];
        }

        function createMap(options) {
            var container = options.container,
                    address = options.address,
                    zoom = options.zoom,
                    colors = options.colors;
            return getLatitudeLongitude(address).then(function (latLong) {
                var map = new google.maps.Map(container, {
                    center: latLong,
                    clickableIcons: false,
                    disableDefaultUI: true,
                    disableDoubleClickZoom: true,
                    gestureHandling: 'none',
                    keyboardShortcuts: false,
                    maxZoom: zoom,
                    minZoom: zoom,
                    scrollWheel: false,
                    styles: getMapStyles(colors),
                    zoom: zoom,
                    zoomControl: false
                });
                new google.maps.Marker({
                    clickable: false,
                    map: map,
                    position: map.getCenter()
                });
                map.panBy(0, 0);
            })["catch"](function (status) {
                var usageLimits = 'https://developers.google.com/maps/faq#usagelimits';
                var errorMessage;

                switch (status) {
                    case 'ZERO_RESULTS':
                        errorMessage = "<p>Unable to find the address:</p> ".concat(address);
                        break;

                    case 'OVER_QUERY_LIMIT':
                        errorMessage = "\n            <p>Unable to load Google Maps, you have reached your usage limit.</p>\n            <p>\n              Please visit\n              <a href=\"".concat(usageLimits, "\" target=\"_blank\">").concat(usageLimits, "</a>\n              for more details.\n            </p>\n          ");
                        break;

                    default:
                        errorMessage = 'Unable to load Google Maps.';
                        break;
                }

                throw errorMessage;
            });
        }

        function displayErrorInThemeEditor(container, errorMessage) {
            var isThemeEditor = window.Shopify && window.Shopify.designMode;

            if (!isThemeEditor) {
                return;
            }

            container.innerHTML = "<div class=\"map-error-message\">".concat(errorMessage, "</div>");
        }

        var index_es_PxsMap = function PxsMap(section) {
            var _this = this;

            _classCallCheck(this, PxsMap);

            this.map = null;
            var el = section.el.querySelector('[data-map]');
            var container = el.querySelector('[data-map-container]');
            var settings = section.data;
            var address = settings.address,
                    colors = settings.colors;
            var apiKey = settings.api_key; // Scale so range is 12 ~ 17, rather than 1 to 6

            var zoom = Number.isNaN(settings.zoom) ? 13 : 11 + parseInt(settings.zoom, 10);

            if (apiKey) {
                if (window.googleMaps === undefined) {
                    script_default()("https://maps.googleapis.com/maps/api/js?key=".concat(apiKey), function () {
                        window.googleMaps = true;
                        createMap({
                            container: container,
                            address: address,
                            zoom: zoom,
                            colors: colors
                        }).then(function (map) {
                            _this.map = map;
                        })["catch"](function (error) {
                            return displayErrorInThemeEditor(container, error);
                        });
                    });
                } else {
                    createMap({
                        container: container,
                        address: address,
                        zoom: zoom,
                        colors: colors
                    }).then(function (map) {
                        _this.map = map;
                    })["catch"](function (error) {
                        return displayErrorInThemeEditor(container, error);
                    });
                }
            }
        };

        /* harmony default export */ var index_es = (index_es_PxsMap);

// CONCATENATED MODULE: ./node_modules/@pixelunion/rimg/dist/index.es.js
        /*!
         * @pixelunion/rimg v2.2.0
         * (c) 2019 Pixel Union
         */
        /**
         * The default template render function. Turns a template string into an image
         * URL.
         *
         * @param {String} template
         * @param {Size} size
         * @returns {String}
         */
        function defaultTemplateRender(template, size) {
            return template.replace('{size}', size.width + 'x' + size.height);
        }

        /**
         * @type Settings
         */
        var defaults = {
            scale: 1,
            template: false,
            templateRender: defaultTemplateRender,
            max: { width: Infinity, height: Infinity },
            round: 32,
            placeholder: false,
            crop: null
        };

        /**
         * Get a data attribute value from an element, with a default fallback and
         * sanitization step.
         *
         * @param {Element} el
         *
         * @param {String} name
         *        The data attribute name.
         *
         * @param {Object} options
         *        An object holding fallback values if the data attribute does not
         *        exist. If this object doesn't have the property, we further fallback
         *        to our defaults.
         *
         * @param {Function} [sanitize]
         *        A function to sanitize the data attribute value with.
         *
         * @returns {String|*}
         */
        function getData(el, name, options, sanitize) {
            var attr = 'data-rimg-' + name;
            if (!el.hasAttribute(attr)) return options[name] || defaults[name];

            var value = el.getAttribute(attr);

            return sanitize ? sanitize(value) : value;
        }

        /**
         * Sanitize data attributes that represent a size (in the form of `10x10`).
         *
         * @param {String} value
         * @returns {Object} An object with `width` and `height` properties.
         */
        function parseSize(value) {
            value = value.split('x');
            return { width: parseInt(value[0], 10), height: parseInt(value[1], 10) };
        }

        /**
         * Sanitize crop values to ensure they are valid, or null
         *
         * @param {String} value
         * @returns {Object} Shopify crop parameter ('top', 'center', 'bottom', 'left', 'right') or null, if an unsupported value is found
         */
        function processCropValue(value) {
            switch (value) {
                case 'top':
                case 'center':
                case 'bottom':
                case 'left':
                case 'right':
                    return value;
                default:
                    return null;
            }
        }

        /**
         * Loads information about an element.
         *
         * Options can be set on the element itself using data attributes, or through
         * the `options` parameter. Data attributes take priority.
         *
         * @param {HTMLElement} el
         * @param {Settings} options
         * @returns {Item}
         */
        function parseItem(el) {
            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            var isImage = el.hasAttribute('data-rimg-template');

            /**
             * @typedef {Settings} Item
             */
            return {
                el: el,

                // Type of element
                isImage: isImage,
                isBackgroundImage: isImage && el.tagName !== 'IMG',

                // Image scale
                scale: getData(el, 'scale', options),

                // Device density
                density: window.devicePixelRatio || 1,

                // Image template URL
                template: getData(el, 'template', options),
                templateRender: options.templateRender || defaults.templateRender,

                // Maximum image dimensions
                max: getData(el, 'max', options, parseSize),

                // Round image dimensions to the nearest multiple
                round: getData(el, 'round', options),

                // Placeholder image dimensions
                placeholder: getData(el, 'placeholder', options, parseSize),

                // Crop value; null if image is uncropped, otherwise equal to the Shopify crop parameter ('center', 'top', etc.)
                crop: getData(el, 'crop', options, processCropValue)
            };
        }

        /**
         * Round to the nearest multiple.
         *
         * This is so we don't tax the image server too much.
         *
         * @param {Number} size The size, in pixels.
         * @param {Number} [multiple] The multiple to round to the nearest.
         * @param {Number} [maxLimit] Maximum allowed value - value to return if rounded multiple is above this limit
         * @returns {Number}
         */
        function roundSize(size) {
            var multiple = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 32;
            var maxLimit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Infinity;

            return size === 0 ? multiple : Math.min(Math.ceil(size / multiple) * multiple, maxLimit);
        }

        /**
         * Get the size of an element.
         *
         * If it is too small, it's parent element is checked, and so on. This helps
         * avoid the situation where an element doesn't have a size yet or is positioned
         * out of the layout.
         *
         * @param {HTMLElement} el
         * @return {Object} size
         * @return {Number} size.width The width, in pixels.
         * @return {Number} size.height The height, in pixels.
         */
        function getElementSize(el) {
            var size = { width: 0, height: 0 };

            while (el) {
                size.width = el.offsetWidth;
                size.height = el.offsetHeight;
                if (size.width > 20 && size.height > 20) break;
                el = el.parentNode;
            }

            return size;
        }

        /**
         * Trigger a custom event.
         *
         * Note: this approach is deprecated, but still required to support older
         * browsers such as IE 10.
         *
         * @see https://developer.mozilla.org/en-US/docs/Web/Guide/Events/Creating_and_triggering_events
         *
         * @param {HTMLElement} el
         *        The element to trigger the event on.
         *
         * @param {String} name
         *        The event name.
         *
         * @returns {Boolean}
         *          True if the event was canceled.
         */
        function trigger(el, name) {
            var event = document.createEvent('Event');
            event.initEvent(name, true, true);
            return !el.dispatchEvent(event);
        }

        /**
         * Return the maximum supported density of the image, given the container.
         *
         * @param {Item} item
         * @param {Size} size
         */
        function supportedDensity(item, size) {
            return Math.min(Math.min(Math.max(item.max.width / size.width, 1), item.density), Math.min(Math.max(item.max.height / size.height, 1), item.density)).toFixed(2);
        }

        /**
         * Set the image URL on the element. Supports background images and `srcset`.
         *
         * @param {Item} item
         * @param {Size} size
         * @param {Boolean} isPlaceholder
         */
        function setImage(item, size, isPlaceholder, onLoad) {
            var render = item.templateRender;
            var density = isPlaceholder ? 1 : supportedDensity(item, size);
            var round = isPlaceholder ? 1 : item.round;

            // Calculate the final display size, taking into account the image's
            // maximum dimensions.
            var targetWidth = size.width * density;
            var targetHeight = size.height * density;

            var displaySize = void 0;

            if (item.crop) {
                displaySize = {
                    width: roundSize(targetWidth, round, item.max.width),
                    height: roundSize(targetHeight, round, item.max.height)
                };
            } else {
                // Shopify serves images clamped by the requested dimensions (fitted to the smallest dimension).
                // To get the desired and expected pixel density we need to request cover dimensions (fitted to largest dimension).
                // This isn't a problem with cropped images which are served at the exact dimension requested.
                var containerAspectRatio = size.width / size.height;
                var imageAspectRatio = item.max.width / item.max.height;

                if (containerAspectRatio > imageAspectRatio) {
                    // fit width
                    displaySize = {
                        width: roundSize(targetWidth, round, item.max.width),
                        height: roundSize(targetWidth / imageAspectRatio, round, item.max.height)
                    };
                } else {
                    // fit height
                    displaySize = {
                        width: roundSize(targetHeight * imageAspectRatio, round, item.max.width),
                        height: roundSize(targetHeight, round, item.max.height)
                    };
                }
            }

            var url = render(item.template, displaySize);

            // On load callback
            var image = new Image();
            image.onload = onLoad;
            image.src = url;

            // Set image
            if (item.isBackgroundImage) {
                item.el.style.backgroundImage = 'url(\'' + url + '\')';
            } else {
                item.el.setAttribute('srcset', url + ' ' + density + 'x');
            }
        }

        /**
         * Load the image, set loaded status, and trigger the load event.
         *
         * @fires rimg:load
         * @fires rimg:error
         * @param {Item} item
         * @param {Size} size
         */
        function loadFullImage(item, size) {
            var el = item.el;

            setImage(item, size, false, function (event) {
                if (event.type === 'load') {
                    el.setAttribute('data-rimg', 'loaded');
                } else {
                    el.setAttribute('data-rimg', 'error');
                    trigger(el, 'rimg:error');
                }

                trigger(el, 'rimg:load');
            });
        }

        /**
         * Load in a responsive image.
         *
         * Sets the image's `srcset` attribute to the final image URLs, calculated based
         * on the actual size the image is being shown at.
         *
         * @fires rimg:loading
         *        The image URLs have been set and we are waiting for them to load.
         *
         * @fires rimg:loaded
         *        The final image has loaded.
         *
         * @fires rimg:error
         *        The final image failed loading.
         *
         * @param {Item} item
         */
        function loadImage(item) {
            var el = item.el;

            // Already loaded?
            var status = el.getAttribute('data-rimg');
            if (status === 'loading' || status === 'loaded') return;

            // Is the SVG loaded?
            // In Firefox, el.complete always returns true so we also check el.naturalWidth,
            // which equals 0 until the image loads
            if (el.naturalWidth == 0 && el.complete && !item.isBackgroundImage) {
                // Wait for the load event, then call load image
                el.addEventListener('load', function cb() {
                    el.removeEventListener('load', cb);
                    loadImage(item);
                });

                return;
            }

            // Trigger loading event, and stop if cancelled
            if (trigger(el, 'rimg:loading')) return;

            // Mark as loading
            el.setAttribute('data-rimg', 'loading');

            // Get element size. This is used as the ideal display size.
            var size = getElementSize(item.el);

            size.width *= item.scale;
            size.height *= item.scale;

            if (item.placeholder) {
                // Load a placeholder image first, followed by the full image. Force the
                // element to keep its dimensions while it loads. If the image is smaller
                // than the element size, use the image's size. Density is taken into account
                // for HiDPI devices to avoid blurry images.
                if (!item.isBackgroundImage) {
                    el.setAttribute('width', Math.min(Math.floor(item.max.width / item.density), size.width));
                    el.setAttribute('height', Math.min(Math.floor(item.max.height / item.density), size.height));
                }

                setImage(item, item.placeholder, true, function () {
                    return loadFullImage(item, size);
                });
            } else {
                loadFullImage(item, size);
            }
        }

        /**
         * Prepare an element to be displayed on the screen.
         *
         * Images have special logic applied to them to swap out the different sources.
         *
         * @fires rimg:enter
         *        The element is entering the viewport.
         *
         * @param {HTMLElement} el
         * @param {Settings} options
         */
        function load(el, options) {
            if (!el) return;
            trigger(el, 'rimg:enter');

            var item = parseItem(el, options);

            if (item.isImage) {
                if (!item.isBackgroundImage) {
                    el.setAttribute('data-rimg-template-svg', el.getAttribute('srcset'));
                }

                loadImage(item);
            }
        }

        /**
         * Reset an element's state so that its image can be recalculated.
         *
         * @fires rimg:update
         *        The element is being updated.
         *
         * @param {HTMLElement} el
         * @param {Settings} options
         */
        function update(el, options) {
            if (!el) return;
            trigger(el, 'rimg:update');

            var item = parseItem(el, options);

            if (item.isImage) {
                if (!item.isBackgroundImage) {
                    el.setAttribute('data-rimg', 'lazy');
                    el.setAttribute('srcset', el.getAttribute('data-rimg-template-svg'));
                }

                loadImage(item);
            }
        }

        /**
         * Returns true if the element is within the viewport.
         * @param {HTMLElement} el
         * @returns {Boolean}
         */
        function inViewport(el) {
            if (!el.offsetWidth || !el.offsetHeight || !el.getClientRects().length) {
                return false;
            }

            var root = document.documentElement;
            var width = Math.min(root.clientWidth, window.innerWidth);
            var height = Math.min(root.clientHeight, window.innerHeight);
            var rect = el.getBoundingClientRect();

            return rect.bottom >= 0 && rect.right >= 0 && rect.top <= height && rect.left <= width;
        }

        /**
         * @typedef {Object} Size
         * @property {Number} width
         * @property {Number} height
         */

        /**
         * A function to turn a template string into a URL.
         *
         * @callback TemplateRenderer
         * @param {String} template
         * @param {Size} size
         * @returns {String}
         */

        /**
         * @typedef {Object} Settings
         *
         * @property {String} [template]
         *           A template string used to generate URLs for an image. This allows us to
         *           dynamically load images with sizes to match the container's size.
         *
         * @property {TemplateRenderer} [templateRender]
         *           A function to turn a template string into a URL.
         *
         * @property {Size} [max]
         *           The maximum available size for the image. This ensures we don't
         *           try to load an image larger than is possible.
         *
         * @property {Number} [scale]
         *           A number to scale the final image dimensions by.
         *           Only applies to lazy-loaded images. Defaults to 1.
         *
         * @property {Number} [round]
         *           Round image dimensions to the nearest multiple. This is intended to
         *           tax the image server less by lowering the number of possible image
         *           sizes requested.
         *
         * @property {Size} [placeholder]
         *           The size of the lo-fi image to load before the full image.
         *
         * @property {String} [crop]
         *           Crop value; null if image is uncropped, otherwise equal
         *           to the Shopify crop parameter ('center', 'top', etc.).
         */

        /**
         * Initialize the responsive image handler.
         *
         * @param {String|HTMLElement|NodeList} selector
         *        The CSS selector, element, or elements to track for lazy-loading.
         *
         * @param {Settings} options
         *
         * @returns {PublicApi}
         */
        function rimg() {
            var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '[data-rimg="lazy"]';
            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            // Intersections
            var io = new IntersectionObserver(function (entries) {
                entries.forEach(function (entry) {
                    if (entry.isIntersecting || entry.intersectionRatio > 0) {
                        io.unobserve(entry.target);
                        load(entry.target, options);
                    }
                });
            }, {
                // Watch the viewport, with 20% vertical margins
                rootMargin: '20% 0px'
            });

            /**
             * @typedef {Object} PublicApi
             */
            var api = {
                /**
                 * Track a new selector, element, or nodelist for lazy-loading.
                 * @type Function
                 * @param {String|HTMLElement|NodeList} selector
                 */
                track: function track() {
                    var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '[data-rimg="lazy"]';

                    var els = querySelector(selector);

                    for (var i = 0; i < els.length; i++) {
                        // If an element is already in the viewport, load it right away. This
                        // fixes a race-condition with dynamically added elements.
                        if (inViewport(els[i])) {
                            load(els[i], options);
                        } else {
                            io.observe(els[i]);
                        }
                    }
                },


                /**
                 * Update element(s) that have already been loaded to force their images
                 * to be recalculated.
                 * @type Function
                 * @param {String|HTMLElement|NodeList} selector
                 */
                update: function update$$1() {
                    var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '[data-rimg="loaded"]';

                    var els = querySelector(selector);
                    for (var i = 0; i < els.length; i++) {
                        update(els[i], options);
                    }
                },


                /**
                 * Stop tracking element(s) for lazy-loading.
                 * @type Function
                 * @param {String|HTMLElement|NodeList} selector
                 */
                untrack: function untrack() {
                    var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '[data-rimg]';

                    var els = querySelector(selector);
                    for (var i = 0; i < els.length; i++) {
                        io.unobserve(els[i]);
                    }
                },


                /**
                 * Manually load images.
                 * @type Function
                 * @param {String|HTMLElement|NodeList} selector
                 */
                load: function load$$1() {
                    var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '[data-rimg]';

                    var els = querySelector(selector);
                    for (var i = 0; i < els.length; i++) {
                        load(els[i], options);
                    }
                },


                /**
                 * Unload all event handlers and observers.
                 * @type Function
                 */
                unload: function unload() {
                    io.disconnect();
                }
            };

            // Add initial elements
            api.track(selector);

            return api;
        }

        /**
         * Finds a group of elements on the page.
         *
         * @param {String|HTMLElement|NodeList} selector
         * @returns {Object} An array-like object.
         */
        function querySelector(selector) {
            if (typeof selector === 'string') {
                return document.querySelectorAll(selector);
            }

            if (selector instanceof HTMLElement) {
                return [selector];
            }

            if (selector instanceof NodeList) {
                return selector;
            }

            return [];
        }

        /* harmony default export */ var dist_index_es = (rimg);

// CONCATENATED MODULE: ./node_modules/@pixelunion/rimg-shopify/dist/index.es.js
        /*!
         * @pixelunion/rimg-shopify v2.5.2
         * (c) 2020 Pixel Union
         */


        /**
         * Polyfill for Element.matches().
         *
         * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/matches
         */
        if (!Element.prototype.matches) {
            Element.prototype.matches = Element.prototype.matchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector || Element.prototype.oMatchesSelector || Element.prototype.webkitMatchesSelector || function (s) {
                        var matches = (this.document || this.ownerDocument).querySelectorAll(s),
                                i = matches.length;

                        while (--i >= 0 && matches.item(i) !== this) {}

                        return i > -1;
                    };
        }

        var index_es_state = {
            init: index_es_init,
            watch: watch,
            unwatch: unwatch,
            load: index_es_load
        };

        function index_es_init() {
            var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '[data-rimg="lazy"]';
            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            index_es_state.selector = selector;
            index_es_state.instance = dist_index_es(selector, options);
            index_es_state.loadedWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0); // Listen for Shopify theme editor events

            document.addEventListener('shopify:section:load', function (event) {
                return watch(event.target);
            });
            window.addEventListener('resize', function () {
                return _update();
            });
            document.addEventListener('shopify:section:unload', function (event) {
                return unwatch(event.target);
            }); // Listen for custom events to allow themes to hook into rimg

            document.addEventListener('theme:rimg:watch', function (event) {
                return watch(event.target);
            });
            document.addEventListener('theme:rimg:unwatch', function (event) {
                return unwatch(event.target);
            }); // Support custom events triggered through jQuery
            // See: https://github.com/jquery/jquery/issues/3347

            if (window.jQuery) {
                jQuery(document).on({
                    'theme:rimg:watch': function themeRimgWatch(event) {
                        return watch(event.target);
                    },
                    'theme:rimg:unwatch': function themeRimgUnwatch(event) {
                        return unwatch(event.target);
                    }
                });
            }
        }
        /**
         * Track an element, and its children.
         *
         * @param {HTMLElement} el
         */


        function watch(el) {
            // Track element
            if (typeof el.matches === 'function' && el.matches(index_es_state.selector)) {
                index_es_state.instance.track(el);
            } // Track element's children


            index_es_state.instance.track(el.querySelectorAll(index_es_state.selector));
        }
        /**
         * Untrack an element, and its children
         *
         * @param {HTMLElement} el
         * @private
         */


        function unwatch(el) {
            // Untrack element's children
            index_es_state.instance.untrack(el.querySelectorAll(index_es_state.selector)); // Untrack element

            if (typeof el.matches === 'function' && el.matches(index_es_state.selector)) {
                index_es_state.instance.untrack(el);
            }
        }
        /**
         * Manually load an image
         *
         * @param {HTMLElement} el
         */


        function index_es_load(el) {
            // Load element
            if (typeof el.matches === 'function' && el.matches(index_es_state.selector)) {
                index_es_state.instance.load(el);
            } // Load element's children


            index_es_state.instance.load(el.querySelectorAll(index_es_state.selector));
        }
        /**
         * Update an element, and its children.
         *
         * @param {HTMLElement} el
         */


        function _update() {
            var currentWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0); // Return if we're not 2x smaller, or larger than the existing loading size

            if (currentWidth / index_es_state.loadedWidth > 0.5 && currentWidth / index_es_state.loadedWidth < 2) {
                return;
            }

            index_es_state.loadedWidth = currentWidth;
            index_es_state.instance.update();
        }

        /* harmony default export */ var rimg_shopify_dist_index_es = (index_es_state);

// CONCATENATED MODULE: ./source/scripts/Sections.js
        function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

        function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

        function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

        function Sections_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

        function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

        function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

        /* eslint-disable max-classes-per-file */

        /**
         * Allows a callback to be run once, when a target intersects the viewport.
         * @constructor
         * @param {Object} [options] options with which to construct the IntersectionObserver
         * @param {string} [options.rootMargin='30%'] A string which specifies a set of offsets to add to
         *                                          the root's bounding_box when calculating intersections.
         * @param {number} [options.threshold=0] Ratio of intersection required to trigger callback
         */
        var LazyLoader = /*#__PURE__*/function () {
            function LazyLoader(options) {
                Sections_classCallCheck(this, LazyLoader);

                var defaultOptions = {
                    rootMargin: '30%',
                    threshold: 0
                };
                this.callbacks = new WeakMap();
                this._observerCallback = this._observerCallback.bind(this);
                this.observer = new IntersectionObserver(this._observerCallback, _objectSpread(_objectSpread({}, defaultOptions), options));
            }
            /**
             * Add target and callback. Callback is only run once.
             * @add
             * @param {HTMLElement} target Target element
             * @param {function} callback Callback to run when target begins intersecting
             */


            _createClass(LazyLoader, [{
                key: "add",
                value: function add(target, callback) {
                    this.callbacks.set(target, callback);
                    this.observer.observe(target);
                }
                /**
                 * Remove target. Associated callback is also removed.
                 * @remove
                 * @param {HTMLElement} target Target element
                 */

            }, {
                key: "remove",
                value: function remove(target) {
                    this.observer.unobserve(target);
                    this.callbacks.delete(target);
                }
                /**
                 * Disconnects IntersectionObserver if active
                 * @unload
                 */

            }, {
                key: "unload",
                value: function unload() {
                    this.observer.disconnect();
                }
                /**
                 * Runs associated callbacks for each entry, then removes that entry and callback
                 * @_observerCallback
                 * @param {IntersectionObserverEntry[]} entries Entries to check
                 * @param {InterserctionObserver} observer IntersectionObserver instance
                 */

            }, {
                key: "_observerCallback",
                value: function _observerCallback(entries, observer) {
                    var _this = this;

                    entries.forEach(function (_ref) {
                        var isIntersecting = _ref.isIntersecting,
                                target = _ref.target;

                        // do nothing unless target moved into state of intersection
                        if (isIntersecting === true) {
                            // make sure we stop observing before running the callback, so we don't
                            // somehow run the callback twice if element intersects twice quickly
                            observer.unobserve(target);

                            var callback = _this.callbacks.get(target);

                            if (typeof callback === 'function') {
                                callback();
                            }

                            _this.callbacks.delete(target);
                        }
                    });
                }
            }]);

            return LazyLoader;
        }();

        var Sections = /*#__PURE__*/function () {
            function Sections() {
                Sections_classCallCheck(this, Sections);

                this.handlers = {};
                this.instances = {};
                this.options = {};
                this.imports = {};
                this.lazyLoader = null;
                this._onSectionEvent = this._onSectionEvent.bind(this);
                document.addEventListener('shopify:section:load', this._onSectionEvent);
                document.addEventListener('shopify:section:unload', this._onSectionEvent);
                document.addEventListener('shopify:section:select', this._onSectionEvent);
                document.addEventListener('shopify:section:deselect', this._onSectionEvent);
                document.addEventListener('shopify:block:select', this._onSectionEvent);
                document.addEventListener('shopify:block:deselect', this._onSectionEvent);
            }
            /**
             * Stop listening for section events, and unbind all handlers.
             */


            _createClass(Sections, [{
                key: "unbind",
                value: function unbind() {
                    document.removeEventListener('shopify:section:load', this._onSectionEvent);
                    document.removeEventListener('shopify:section:unload', this._onSectionEvent);
                    document.removeEventListener('shopify:section:select', this._onSectionEvent);
                    document.removeEventListener('shopify:section:deselect', this._onSectionEvent);
                    document.removeEventListener('shopify:block:select', this._onSectionEvent);
                    document.removeEventListener('shopify:block:deselect', this._onSectionEvent); // Unload all instances

                    for (var i = 0; i < this.instances.length; i++) {
                        this._triggerInstanceEvent(this.instances[i], 'onSectionUnload');
                    }

                    this.handlers = {};
                    this.options = {};
                    this.lazyLoader.unload();
                    this.lazyLoader = null;
                    this.instances = {};
                }
                /**
                 * Register a section handler.
                 *
                 * @param {string} type
                 *        The section type to handle. The handler will be called for all
                 *        sections with this type.
                 *
                 * @param {function} handler
                 *        The handler function is passed information about a specific section
                 *        instance. The handler is expected to return an object that will be
                 *        associated with the section instance.
                 *
                 *        Section handlers are passed an object with the following parameters:
                 *          {string} id
                 *          An ID that maps to a specific section instance. Typically the
                 *          section's filename for static sections, or a generated ID for
                 *          dynamic sections.
                 *
                 *          {string} type
                 *          The section type, as supplied when registered.
                 *
                 *          {Element} el
                 *          The root DOM element for the section instance.
                 *
                 *          {Object} data
                 *          Data loaded from the section script element. Defaults to an
                 *          empty object.
                 *
                 *          {Function} postMessage
                 *          A function that can be called to pass messages between sections.
                 *          The function should be called with a message "name", and
                 *          optionally some data.
                 *
                 * @param {object} options
                 *
                 * @param {boolean} options.lazy
                 *     If true, sections will only be initialized after they intersect the viewport + 30% margin
                 */

            }, {
                key: "register",
                value: function register(type, handler) {
                    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

                    if (this.handlers[type]) {
                        console.warn("Sections: section handler already exists of type '".concat(type, "'."));
                    } // Store the section handler


                    this.handlers[type] = handler; // Store options

                    this.options[type] = options; // Init sections for this type

                    this._initSections(type);
                }
                /**
                 * Initialize sections already on the page.
                 */

            }, {
                key: "_initSections",
                value: function _initSections(type) {
                    var _this2 = this;

                    // Fetch all existing sections of our type on the page
                    var dataEls = document.querySelectorAll("[data-section-type=\"".concat(type, "\"]"));
                    if (!dataEls) return; // Create an instance for each section

                    var _loop = function _loop(i) {
                        var dataEl = dataEls[i];
                        var el = dataEl.parentNode; // Get instance ID

                        var idEl = el.querySelector('[data-section-id]');

                        if (!idEl) {
                            console.warn("Sections: unable to find section id for '".concat(type, "'."), el);
                            return "continue"; // eslint-disable-line no-continue
                        }

                        var sectionId = idEl.getAttribute('data-section-id');

                        if (!sectionId) {
                            console.warn("Sections: unable to find section id for '".concat(type, "'."), el);
                            return "continue"; // eslint-disable-line no-continue
                        }

                        if (_this2.options[type] && _this2.options[type].lazy) {
                            if (_this2.lazyLoader === null) {
                                _this2.lazyLoader = new LazyLoader();
                            }

                            _this2.lazyLoader.add(el, function () {
                                return _this2._createInstance(sectionId, el);
                            });
                        } else {
                            _this2._createInstance(sectionId, el);
                        }
                    };

                    for (var i = 0; i < dataEls.length; i++) {
                        var _ret = _loop(i);

                        if (_ret === "continue") continue;
                    }
                }
            }, {
                key: "_onSectionEvent",
                value: function _onSectionEvent(event) {
                    var el = event.target;
                    var _event$detail = event.detail,
                            sectionId = _event$detail.sectionId,
                            blockId = _event$detail.blockId;
                    var instance = this.instances[sectionId];

                    switch (event.type) {
                        case 'shopify:section:load':
                            this._createInstance(sectionId, el);

                            break;

                        case 'shopify:section:unload':
                            this._triggerInstanceEvent(instance, 'onSectionUnload', {
                                el: el,
                                id: sectionId
                            });

                            if (this.lazyLoader) {
                                this.lazyLoader.remove(el);
                            }

                            delete this.instances[sectionId];
                            break;

                        case 'shopify:section:select':
                            this._triggerInstanceEvent(instance, 'onSectionSelect', {
                                el: el,
                                id: sectionId
                            });

                            break;

                        case 'shopify:section:deselect':
                            this._triggerInstanceEvent(instance, 'onSectionDeselect', {
                                el: el,
                                id: sectionId
                            });

                            break;

                        case 'shopify:block:select':
                            this._triggerInstanceEvent(instance, 'onSectionBlockSelect', {
                                el: el,
                                id: blockId
                            });

                            break;

                        case 'shopify:block:deselect':
                            this._triggerInstanceEvent(instance, 'onSectionBlockDeselect', {
                                el: el,
                                id: blockId
                            });

                            break;

                        default:
                            break;
                    }
                }
            }, {
                key: "_triggerInstanceEvent",
                value: function _triggerInstanceEvent(instance, eventName) {
                    if (instance && instance[eventName]) {
                        for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
                            args[_key - 2] = arguments[_key];
                        }

                        instance[eventName].apply(instance, args);
                    }
                }
            }, {
                key: "_postMessage",
                value: function _postMessage(name, data) {
                    var _this3 = this;

                    Object.keys(this.instances).forEach(function (id) {
                        _this3._triggerInstanceEvent(_this3.instances[id], 'onSectionMessage', name, data);
                    });
                }
            }, {
                key: "_createInstance",
                value: function _createInstance(id, el) {
                    var _this4 = this;

                    var typeEl = el.querySelector('[data-section-type]');
                    if (!typeEl) return;
                    var type = typeEl.getAttribute('data-section-type');
                    if (!type) return;
                    var handler = this.handlers[type];

                    if (!handler) {
                        console.warn("Sections: unable to find section handler for type '".concat(type, "'."));
                        return;
                    }

                    var data = this._loadData(el);

                    var postMessage = this._postMessage.bind(this);

                    var handlerParams = {
                        id: id,
                        type: type,
                        el: el,
                        data: data,
                        postMessage: postMessage
                    };

                    if (!this.imports[type]) {
                        // Try to create the instance
                        var handlerReturn = handler(handlerParams);

                        if (handlerReturn instanceof Promise) {
                            // Handler is a dynamic import so we need to resolve the import before
                            // creating the instance
                            handlerReturn.then(function (_ref2) {
                                var Component = _ref2.default;
                                _this4.imports[type] = Component;
                                _this4.instances[id] = new Component(handlerParams);
                            });
                        } else {
                            // Handler returned an instance class - we can create directly.
                            this.imports[type] = handler;
                            this.instances[id] = handlerReturn;
                        }
                    } else {
                        this.instances[id] = new this.imports[type](handlerParams);
                    }
                }
            }, {
                key: "_loadData",
                value: function _loadData(el) {
                    var dataEl = el.querySelector('[data-section-data]');
                    if (!dataEl) return {}; // Load data from attribute, or innerHTML

                    var data = dataEl.getAttribute('data-section-data') || dataEl.innerHTML;

                    try {
                        return JSON.parse(data);
                    } catch (error) {
                        console.warn("Sections: invalid section data found. ".concat(error.message));
                        return {};
                    }
                }
            }]);

            return Sections;
        }();


// CONCATENATED MODULE: ./source/scripts/checkPolyfills.js
        var polyfillUrls = []; // Checks if all IntersectionObserver and IntersectionObserverEntry
// features are natively supported.

        if (!('IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype)) {
            polyfillUrls.push(document.querySelector('[data-scripts]').dataset.pxuPolyfills);
        } // Polyfill NodeList.forEach if required.
// Polyfill is so small it doesn't need to load any external code.


        if (window.NodeList && !NodeList.prototype.forEach) {
            NodeList.prototype.forEach = Array.prototype.forEach;
        }

        if (!Element.prototype.closest) {
            Element.prototype.closest = function (s) {
                var el = this;

                do {
                    if (Element.prototype.matches.call(el, s)) return el;
                    el = el.parentElement || el.parentNode;
                } while (el !== null && el.nodeType === 1);

                return null;
            };
        }

        /* harmony default export */ var checkPolyfills = (polyfillUrls);
// CONCATENATED MODULE: ./source/scripts/sections/StaticAnnouncement.js
        function StaticAnnouncement_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

        var StaticAnnouncement = function StaticAnnouncement(section) {
            StaticAnnouncement_classCallCheck(this, StaticAnnouncement);

            // Since the announcement bar positioning is actually handled by the
            // StaticSectionHeader and StickyHeader classes, we need to let them know
            // when the announcement element is refreshed within the editor.
            if (window.Shopify && window.Shopify.designMode) {
                section.postMessage('announcement:load');
            }
        };


// EXTERNAL MODULE: ./node_modules/fitvids/index.js
        var fitvids = __webpack_require__(11);
        var fitvids_default = /*#__PURE__*/__webpack_require__.n(fitvids);

// EXTERNAL MODULE: ./node_modules/grouped-content/dist/index.js
        var dist = __webpack_require__(12);
        var dist_default = /*#__PURE__*/__webpack_require__.n(dist);

// CONCATENATED MODULE: ./source/scripts/components/RichText.js
        function RichText_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

        function RichText_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

        function RichText_createClass(Constructor, protoProps, staticProps) { if (protoProps) RichText_defineProperties(Constructor.prototype, protoProps); if (staticProps) RichText_defineProperties(Constructor, staticProps); return Constructor; }




        var RichText_RichText = /*#__PURE__*/function () {
            function RichText($el) {
                RichText_classCallCheck(this, RichText);

                this.$el = $el;

                this._initExternalLinks();

                this.groupedContent = null;

                if (this.$el.length) {
                    this.groupedContent = new dist_default.a($el.get(0), {
                        layout: 'tabs',
                        intelliparse: false
                    });
                    fitvids_default()('.rte');
                }
            }

            RichText_createClass(RichText, [{
                key: "unload",
                value: function unload() {
                    if (this.groupedContent) {
                        this.groupedContent.unload();
                    }
                }
                /**
                 * Open links within an RTE field in a new window if they point to external domains
                 *
                 * @private
                 */

            }, {
                key: "_initExternalLinks",
                value: function _initExternalLinks() {
                    var anchors = this.$el.find('a[href^="http"]').filter(function (i, el) {
                        return el.href.indexOf(location.hostname) === -1;
                    });
                    anchors.attr('target', '_blank');
                }
            }]);

            return RichText;
        }();


// CONCATENATED MODULE: ./source/scripts/helpers/Quantity.js
        function Quantity_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

        function Quantity_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

        function Quantity_createClass(Constructor, protoProps, staticProps) { if (protoProps) Quantity_defineProperties(Constructor.prototype, protoProps); if (staticProps) Quantity_defineProperties(Constructor, staticProps); return Constructor; }

        var Quantity = /*#__PURE__*/function () {
            function Quantity(el) {
                Quantity_classCallCheck(this, Quantity);

                this.$el = $(el);
                this.$inputParent = this.$el.find('.form-field--qty-input');
                this.$input = this.$el.find('[data-quantity-input]');
                this.$selectParent = this.$el.find('.form-field--qty-select');
                this.$select = this.$el.find('[data-quantity-select]');
                this._watchSelect = this._watchSelect.bind(this);
                this._watchInput = this._watchInput.bind(this);
                this.$select.on('change.quantity', this._watchSelect);
                this.$input.on('change.quantity', this._watchInput);
            }

            Quantity_createClass(Quantity, [{
                key: "unload",
                value: function unload() {
                    this.$el.off('.quantity');
                }
            }, {
                key: "_validateValue",
                value: function _validateValue(event) {
                    var baseValue = parseInt(event.currentTarget.value, 10);
                    return isNaN(baseValue) ? 1 : baseValue;
                }
            }, {
                key: "_watchSelect",
                value: function _watchSelect(event) {
                    var value = this._validateValue(event); // Update input to match select


                    this.$input.val(value).trigger('change'); // Switch to quantity input when 10 or more

                    if (value >= 10) {
                        this.$inputParent.removeClass('hidden').addClass('visible');
                        this.$input.focus().removeAttr('tabindex').select();
                        this.$selectParent.removeClass('visible').addClass('hidden');
                        this.$select.attr('tabindex', '-1');
                    }
                }
            }, {
                key: "_watchInput",
                value: function _watchInput(event) {
                    this.$input.val(this._validateValue(event));
                }
            }]);

            return Quantity;
        }();


// CONCATENATED MODULE: ./source/scripts/Forms.js
        function Forms_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

        function Forms_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

        function Forms_createClass(Constructor, protoProps, staticProps) { if (protoProps) Forms_defineProperties(Constructor.prototype, protoProps); if (staticProps) Forms_defineProperties(Constructor, staticProps); return Constructor; }




        var Forms_Forms = /*#__PURE__*/function () {
            function Forms(el) {
                var _this = this;

                var selector = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '.form-field-input';

                Forms_classCallCheck(this, Forms);

                this.$el = jquery_default()(el);
                this.filledClass = 'form-field-filled';
                this.fieldSelector = selector;
                this.quantityItems = [];
                this.$quantityWrapper = this.$el.find('[data-quantity-wrapper]');
                this._toggleFilled = this._toggleFilled.bind(this);
                this.$el.on('focus.forms', this.fieldSelector, this._toggleFilled);
                this.$el.on('blur.forms', this.fieldSelector, this._toggleFilled);

                this._checkFilled();

                if (this.$quantityWrapper.length) {
                    this.$quantityWrapper.each(function (i, el) {
                        _this.quantityItems.push(new Quantity(el));
                    });
                }
            }

            Forms_createClass(Forms, [{
                key: "unload",
                value: function unload() {
                    this.$el.off('.forms');
                    this.quantityItems.forEach(function (quantityItem) {
                        quantityItem.unload();
                    });
                }
            }, {
                key: "_checkFilled",
                value: function _checkFilled() {
                    var _this2 = this;

                    this.$el.find(this.fieldSelector).each(function (i, el) {
                        if (jquery_default()(el).hasClass(_this2.filledClass)) return;

                        _this2._toggleFilled(null, el);
                    });
                }
            }, {
                key: "_toggleFilled",
                value: function _toggleFilled() {
                    var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
                    var el = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                    var target = event ? event.currentTarget : el;
                    var $target = jquery_default()(target);
                    var value = target.value;
                    var isFilled = value.length > 0;

                    try {
                        isFilled = isFilled || $target.is(':-webkit-autofill');
                        $target.toggleClass(this.filledClass, isFilled);
                    } catch (e) {
                        $target.toggleClass(this.filledClass, isFilled);
                    }
                }
            }]);

            return Forms;
        }();


// CONCATENATED MODULE: ./source/scripts/sections/StaticArticle.js
        function StaticArticle_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

        function StaticArticle_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

        function StaticArticle_createClass(Constructor, protoProps, staticProps) { if (protoProps) StaticArticle_defineProperties(Constructor.prototype, protoProps); if (staticProps) StaticArticle_defineProperties(Constructor, staticProps); return Constructor; }





        var StaticArticle_StaticArticle = /*#__PURE__*/function () {
            function StaticArticle(section) {
                StaticArticle_classCallCheck(this, StaticArticle);

                this.$el = jquery_default()(section.el);
                this.$commentForm = this.$el.find('[data-articlecomments-form]');
                this.richText = new RichText_RichText(this.$el);

                if (this.$commentForm.length) {
                    this.commentForm = new Forms_Forms(this.$commentForm);
                }
            }

            StaticArticle_createClass(StaticArticle, [{
                key: "onSectionUnload",
                value: function onSectionUnload() {
                    this.richText.unload();

                    if (this.commentForm) {
                        this.commentForm.unload();
                    }
                }
            }]);

            return StaticArticle;
        }();


// CONCATENATED MODULE: ./source/scripts/sections/StaticBlog.js
        function StaticBlog_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

        function StaticBlog_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

        function StaticBlog_createClass(Constructor, protoProps, staticProps) { if (protoProps) StaticBlog_defineProperties(Constructor.prototype, protoProps); if (staticProps) StaticBlog_defineProperties(Constructor, staticProps); return Constructor; }




        var StaticBlog_StaticBlog = /*#__PURE__*/function () {
            function StaticBlog(section) {
                StaticBlog_classCallCheck(this, StaticBlog);

                this.$el = jquery_default()(section.el);
                this.richText = new RichText_RichText(this.$el);
            }

            StaticBlog_createClass(StaticBlog, [{
                key: "onSectionUnload",
                value: function onSectionUnload() {
                    this.richText.unload();
                }
            }]);

            return StaticBlog;
        }();


// EXTERNAL MODULE: ./node_modules/just-debounce/index.js
        var just_debounce = __webpack_require__(3);
        var just_debounce_default = /*#__PURE__*/__webpack_require__.n(just_debounce);

// CONCATENATED MODULE: ./node_modules/morphdom/dist/morphdom-esm.js
        function morphAttrs(fromNode, toNode) {
            var attrs = toNode.attributes;
            var i;
            var attr;
            var attrName;
            var attrNamespaceURI;
            var attrValue;
            var fromValue;

            // update attributes on original DOM element
            for (i = attrs.length - 1; i >= 0; --i) {
                attr = attrs[i];
                attrName = attr.name;
                attrNamespaceURI = attr.namespaceURI;
                attrValue = attr.value;

                if (attrNamespaceURI) {
                    attrName = attr.localName || attrName;
                    fromValue = fromNode.getAttributeNS(attrNamespaceURI, attrName);

                    if (fromValue !== attrValue) {
                        fromNode.setAttributeNS(attrNamespaceURI, attrName, attrValue);
                    }
                } else {
                    fromValue = fromNode.getAttribute(attrName);

                    if (fromValue !== attrValue) {
                        fromNode.setAttribute(attrName, attrValue);
                    }
                }
            }

            // Remove any extra attributes found on the original DOM element that
            // weren't found on the target element.
            attrs = fromNode.attributes;

            for (i = attrs.length - 1; i >= 0; --i) {
                attr = attrs[i];
                if (attr.specified !== false) {
                    attrName = attr.name;
                    attrNamespaceURI = attr.namespaceURI;

                    if (attrNamespaceURI) {
                        attrName = attr.localName || attrName;

                        if (!toNode.hasAttributeNS(attrNamespaceURI, attrName)) {
                            fromNode.removeAttributeNS(attrNamespaceURI, attrName);
                        }
                    } else {
                        if (!toNode.hasAttribute(attrName)) {
                            fromNode.removeAttribute(attrName);
                        }
                    }
                }
            }
        }

        var range; // Create a range object for efficently rendering strings to elements.
        var NS_XHTML = 'http://www.w3.org/1999/xhtml';

        var doc = typeof document === 'undefined' ? undefined : document;

        /**
         * This is about the same
         * var html = new DOMParser().parseFromString(str, 'text/html');
         * return html.body.firstChild;
         *
         * @method toElement
         * @param {String} str
         */
        function toElement(str) {
            if (!range && doc.createRange) {
                range = doc.createRange();
                range.selectNode(doc.body);
            }

            var fragment;
            if (range && range.createContextualFragment) {
                fragment = range.createContextualFragment(str);
            } else {
                fragment = doc.createElement('body');
                fragment.innerHTML = str;
            }
            return fragment.childNodes[0];
        }

        /**
         * Returns true if two node's names are the same.
         *
         * NOTE: We don't bother checking `namespaceURI` because you will never find two HTML elements with the same
         *       nodeName and different namespace URIs.
         *
         * @param {Element} a
         * @param {Element} b The target element
         * @return {boolean}
         */
        function compareNodeNames(fromEl, toEl) {
            var fromNodeName = fromEl.nodeName;
            var toNodeName = toEl.nodeName;

            if (fromNodeName === toNodeName) {
                return true;
            }

            if (toEl.actualize &&
                    fromNodeName.charCodeAt(0) < 91 && /* from tag name is upper case */
                    toNodeName.charCodeAt(0) > 90 /* target tag name is lower case */) {
                // If the target element is a virtual DOM node then we may need to normalize the tag name
                // before comparing. Normal HTML elements that are in the "http://www.w3.org/1999/xhtml"
                // are converted to upper case
                return fromNodeName === toNodeName.toUpperCase();
            } else {
                return false;
            }
        }

        /**
         * Create an element, optionally with a known namespace URI.
         *
         * @param {string} name the element name, e.g. 'div' or 'svg'
         * @param {string} [namespaceURI] the element's namespace URI, i.e. the value of
         * its `xmlns` attribute or its inferred namespace.
         *
         * @return {Element}
         */
        function createElementNS(name, namespaceURI) {
            return !namespaceURI || namespaceURI === NS_XHTML ?
                    doc.createElement(name) :
                    doc.createElementNS(namespaceURI, name);
        }

        /**
         * Copies the children of one DOM element to another DOM element
         */
        function moveChildren(fromEl, toEl) {
            var curChild = fromEl.firstChild;
            while (curChild) {
                var nextChild = curChild.nextSibling;
                toEl.appendChild(curChild);
                curChild = nextChild;
            }
            return toEl;
        }

        function syncBooleanAttrProp(fromEl, toEl, name) {
            if (fromEl[name] !== toEl[name]) {
                fromEl[name] = toEl[name];
                if (fromEl[name]) {
                    fromEl.setAttribute(name, '');
                } else {
                    fromEl.removeAttribute(name);
                }
            }
        }

        var specialElHandlers = {
            OPTION: function(fromEl, toEl) {
                var parentNode = fromEl.parentNode;
                if (parentNode) {
                    var parentName = parentNode.nodeName.toUpperCase();
                    if (parentName === 'OPTGROUP') {
                        parentNode = parentNode.parentNode;
                        parentName = parentNode && parentNode.nodeName.toUpperCase();
                    }
                    if (parentName === 'SELECT' && !parentNode.hasAttribute('multiple')) {
                        if (fromEl.hasAttribute('selected') && !toEl.selected) {
                            // Workaround for MS Edge bug where the 'selected' attribute can only be
                            // removed if set to a non-empty value:
                            // https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/12087679/
                            fromEl.setAttribute('selected', 'selected');
                            fromEl.removeAttribute('selected');
                        }
                        // We have to reset select element's selectedIndex to -1, otherwise setting
                        // fromEl.selected using the syncBooleanAttrProp below has no effect.
                        // The correct selectedIndex will be set in the SELECT special handler below.
                        parentNode.selectedIndex = -1;
                    }
                }
                syncBooleanAttrProp(fromEl, toEl, 'selected');
            },
            /**
             * The "value" attribute is special for the <input> element since it sets
             * the initial value. Changing the "value" attribute without changing the
             * "value" property will have no effect since it is only used to the set the
             * initial value.  Similar for the "checked" attribute, and "disabled".
             */
            INPUT: function(fromEl, toEl) {
                syncBooleanAttrProp(fromEl, toEl, 'checked');
                syncBooleanAttrProp(fromEl, toEl, 'disabled');

                if (fromEl.value !== toEl.value) {
                    fromEl.value = toEl.value;
                }

                if (!toEl.hasAttribute('value')) {
                    fromEl.removeAttribute('value');
                }
            },

            TEXTAREA: function(fromEl, toEl) {
                var newValue = toEl.value;
                if (fromEl.value !== newValue) {
                    fromEl.value = newValue;
                }

                var firstChild = fromEl.firstChild;
                if (firstChild) {
                    // Needed for IE. Apparently IE sets the placeholder as the
                    // node value and vise versa. This ignores an empty update.
                    var oldValue = firstChild.nodeValue;

                    if (oldValue == newValue || (!newValue && oldValue == fromEl.placeholder)) {
                        return;
                    }

                    firstChild.nodeValue = newValue;
                }
            },
            SELECT: function(fromEl, toEl) {
                if (!toEl.hasAttribute('multiple')) {
                    var selectedIndex = -1;
                    var i = 0;
                    // We have to loop through children of fromEl, not toEl since nodes can be moved
                    // from toEl to fromEl directly when morphing.
                    // At the time this special handler is invoked, all children have already been morphed
                    // and appended to / removed from fromEl, so using fromEl here is safe and correct.
                    var curChild = fromEl.firstChild;
                    var optgroup;
                    var nodeName;
                    while(curChild) {
                        nodeName = curChild.nodeName && curChild.nodeName.toUpperCase();
                        if (nodeName === 'OPTGROUP') {
                            optgroup = curChild;
                            curChild = optgroup.firstChild;
                        } else {
                            if (nodeName === 'OPTION') {
                                if (curChild.hasAttribute('selected')) {
                                    selectedIndex = i;
                                    break;
                                }
                                i++;
                            }
                            curChild = curChild.nextSibling;
                            if (!curChild && optgroup) {
                                curChild = optgroup.nextSibling;
                                optgroup = null;
                            }
                        }
                    }

                    fromEl.selectedIndex = selectedIndex;
                }
            }
        };

        var ELEMENT_NODE = 1;
        var DOCUMENT_FRAGMENT_NODE = 11;
        var TEXT_NODE = 3;
        var COMMENT_NODE = 8;

        function noop() {}

        function defaultGetNodeKey(node) {
            return node.id;
        }

        function morphdomFactory(morphAttrs) {

            return function morphdom(fromNode, toNode, options) {
                if (!options) {
                    options = {};
                }

                if (typeof toNode === 'string') {
                    if (fromNode.nodeName === '#document' || fromNode.nodeName === 'HTML') {
                        var toNodeHtml = toNode;
                        toNode = doc.createElement('html');
                        toNode.innerHTML = toNodeHtml;
                    } else {
                        toNode = toElement(toNode);
                    }
                }

                var getNodeKey = options.getNodeKey || defaultGetNodeKey;
                var onBeforeNodeAdded = options.onBeforeNodeAdded || noop;
                var onNodeAdded = options.onNodeAdded || noop;
                var onBeforeElUpdated = options.onBeforeElUpdated || noop;
                var onElUpdated = options.onElUpdated || noop;
                var onBeforeNodeDiscarded = options.onBeforeNodeDiscarded || noop;
                var onNodeDiscarded = options.onNodeDiscarded || noop;
                var onBeforeElChildrenUpdated = options.onBeforeElChildrenUpdated || noop;
                var childrenOnly = options.childrenOnly === true;

                // This object is used as a lookup to quickly find all keyed elements in the original DOM tree.
                var fromNodesLookup = {};
                var keyedRemovalList;

                function addKeyedRemoval(key) {
                    if (keyedRemovalList) {
                        keyedRemovalList.push(key);
                    } else {
                        keyedRemovalList = [key];
                    }
                }

                function walkDiscardedChildNodes(node, skipKeyedNodes) {
                    if (node.nodeType === ELEMENT_NODE) {
                        var curChild = node.firstChild;
                        while (curChild) {

                            var key = undefined;

                            if (skipKeyedNodes && (key = getNodeKey(curChild))) {
                                // If we are skipping keyed nodes then we add the key
                                // to a list so that it can be handled at the very end.
                                addKeyedRemoval(key);
                            } else {
                                // Only report the node as discarded if it is not keyed. We do this because
                                // at the end we loop through all keyed elements that were unmatched
                                // and then discard them in one final pass.
                                onNodeDiscarded(curChild);
                                if (curChild.firstChild) {
                                    walkDiscardedChildNodes(curChild, skipKeyedNodes);
                                }
                            }

                            curChild = curChild.nextSibling;
                        }
                    }
                }

                /**
                 * Removes a DOM node out of the original DOM
                 *
                 * @param  {Node} node The node to remove
                 * @param  {Node} parentNode The nodes parent
                 * @param  {Boolean} skipKeyedNodes If true then elements with keys will be skipped and not discarded.
                 * @return {undefined}
                 */
                function removeNode(node, parentNode, skipKeyedNodes) {
                    if (onBeforeNodeDiscarded(node) === false) {
                        return;
                    }

                    if (parentNode) {
                        parentNode.removeChild(node);
                    }

                    onNodeDiscarded(node);
                    walkDiscardedChildNodes(node, skipKeyedNodes);
                }

                // // TreeWalker implementation is no faster, but keeping this around in case this changes in the future
                // function indexTree(root) {
                //     var treeWalker = document.createTreeWalker(
                //         root,
                //         NodeFilter.SHOW_ELEMENT);
                //
                //     var el;
                //     while((el = treeWalker.nextNode())) {
                //         var key = getNodeKey(el);
                //         if (key) {
                //             fromNodesLookup[key] = el;
                //         }
                //     }
                // }

                // // NodeIterator implementation is no faster, but keeping this around in case this changes in the future
                //
                // function indexTree(node) {
                //     var nodeIterator = document.createNodeIterator(node, NodeFilter.SHOW_ELEMENT);
                //     var el;
                //     while((el = nodeIterator.nextNode())) {
                //         var key = getNodeKey(el);
                //         if (key) {
                //             fromNodesLookup[key] = el;
                //         }
                //     }
                // }

                function indexTree(node) {
                    if (node.nodeType === ELEMENT_NODE || node.nodeType === DOCUMENT_FRAGMENT_NODE) {
                        var curChild = node.firstChild;
                        while (curChild) {
                            var key = getNodeKey(curChild);
                            if (key) {
                                fromNodesLookup[key] = curChild;
                            }

                            // Walk recursively
                            indexTree(curChild);

                            curChild = curChild.nextSibling;
                        }
                    }
                }

                indexTree(fromNode);

                function handleNodeAdded(el) {
                    onNodeAdded(el);

                    var curChild = el.firstChild;
                    while (curChild) {
                        var nextSibling = curChild.nextSibling;

                        var key = getNodeKey(curChild);
                        if (key) {
                            var unmatchedFromEl = fromNodesLookup[key];
                            if (unmatchedFromEl && compareNodeNames(curChild, unmatchedFromEl)) {
                                curChild.parentNode.replaceChild(unmatchedFromEl, curChild);
                                morphEl(unmatchedFromEl, curChild);
                            }
                        }

                        handleNodeAdded(curChild);
                        curChild = nextSibling;
                    }
                }

                function cleanupFromEl(fromEl, curFromNodeChild, curFromNodeKey) {
                    // We have processed all of the "to nodes". If curFromNodeChild is
                    // non-null then we still have some from nodes left over that need
                    // to be removed
                    while (curFromNodeChild) {
                        var fromNextSibling = curFromNodeChild.nextSibling;
                        if ((curFromNodeKey = getNodeKey(curFromNodeChild))) {
                            // Since the node is keyed it might be matched up later so we defer
                            // the actual removal to later
                            addKeyedRemoval(curFromNodeKey);
                        } else {
                            // NOTE: we skip nested keyed nodes from being removed since there is
                            //       still a chance they will be matched up later
                            removeNode(curFromNodeChild, fromEl, true /* skip keyed nodes */);
                        }
                        curFromNodeChild = fromNextSibling;
                    }
                }

                function morphEl(fromEl, toEl, childrenOnly) {
                    var toElKey = getNodeKey(toEl);

                    if (toElKey) {
                        // If an element with an ID is being morphed then it will be in the final
                        // DOM so clear it out of the saved elements collection
                        delete fromNodesLookup[toElKey];
                    }

                    if (toNode.isSameNode && toNode.isSameNode(fromNode)) {
                        return;
                    }

                    if (!childrenOnly) {
                        // optional
                        if (onBeforeElUpdated(fromEl, toEl) === false) {
                            return;
                        }

                        // update attributes on original DOM element first
                        morphAttrs(fromEl, toEl);
                        // optional
                        onElUpdated(fromEl);

                        if (onBeforeElChildrenUpdated(fromEl, toEl) === false) {
                            return;
                        }
                    }
                    if (fromEl.nodeName !== 'TEXTAREA') {
                        morphChildren(fromEl, toEl);
                    } else {
                        specialElHandlers.TEXTAREA(fromEl, toEl);
                    }
                }

                function morphChildren(fromEl, toEl) {
                    var curToNodeChild = toEl.firstChild;
                    var curFromNodeChild = fromEl.firstChild;
                    var curToNodeKey;
                    var curFromNodeKey;

                    var fromNextSibling;
                    var toNextSibling;
                    var matchingFromEl;

                    // walk the children
                    outer: while (curToNodeChild) {
                        toNextSibling = curToNodeChild.nextSibling;
                        curToNodeKey = getNodeKey(curToNodeChild);

                        // walk the fromNode children all the way through
                        while (curFromNodeChild) {
                            fromNextSibling = curFromNodeChild.nextSibling;

                            if (curToNodeChild.isSameNode && curToNodeChild.isSameNode(curFromNodeChild)) {
                                curToNodeChild = toNextSibling;
                                curFromNodeChild = fromNextSibling;
                                continue outer;
                            }

                            curFromNodeKey = getNodeKey(curFromNodeChild);

                            var curFromNodeType = curFromNodeChild.nodeType;

                            // this means if the curFromNodeChild doesnt have a match with the curToNodeChild
                            var isCompatible = undefined;

                            if (curFromNodeType === curToNodeChild.nodeType) {
                                if (curFromNodeType === ELEMENT_NODE) {
                                    // Both nodes being compared are Element nodes

                                    if (curToNodeKey) {
                                        // The target node has a key so we want to match it up with the correct element
                                        // in the original DOM tree
                                        if (curToNodeKey !== curFromNodeKey) {
                                            // The current element in the original DOM tree does not have a matching key so
                                            // let's check our lookup to see if there is a matching element in the original
                                            // DOM tree
                                            if ((matchingFromEl = fromNodesLookup[curToNodeKey])) {
                                                if (fromNextSibling === matchingFromEl) {
                                                    // Special case for single element removals. To avoid removing the original
                                                    // DOM node out of the tree (since that can break CSS transitions, etc.),
                                                    // we will instead discard the current node and wait until the next
                                                    // iteration to properly match up the keyed target element with its matching
                                                    // element in the original tree
                                                    isCompatible = false;
                                                } else {
                                                    // We found a matching keyed element somewhere in the original DOM tree.
                                                    // Let's move the original DOM node into the current position and morph
                                                    // it.

                                                    // NOTE: We use insertBefore instead of replaceChild because we want to go through
                                                    // the `removeNode()` function for the node that is being discarded so that
                                                    // all lifecycle hooks are correctly invoked
                                                    fromEl.insertBefore(matchingFromEl, curFromNodeChild);

                                                    // fromNextSibling = curFromNodeChild.nextSibling;

                                                    if (curFromNodeKey) {
                                                        // Since the node is keyed it might be matched up later so we defer
                                                        // the actual removal to later
                                                        addKeyedRemoval(curFromNodeKey);
                                                    } else {
                                                        // NOTE: we skip nested keyed nodes from being removed since there is
                                                        //       still a chance they will be matched up later
                                                        removeNode(curFromNodeChild, fromEl, true /* skip keyed nodes */);
                                                    }

                                                    curFromNodeChild = matchingFromEl;
                                                }
                                            } else {
                                                // The nodes are not compatible since the "to" node has a key and there
                                                // is no matching keyed node in the source tree
                                                isCompatible = false;
                                            }
                                        }
                                    } else if (curFromNodeKey) {
                                        // The original has a key
                                        isCompatible = false;
                                    }

                                    isCompatible = isCompatible !== false && compareNodeNames(curFromNodeChild, curToNodeChild);
                                    if (isCompatible) {
                                        // We found compatible DOM elements so transform
                                        // the current "from" node to match the current
                                        // target DOM node.
                                        // MORPH
                                        morphEl(curFromNodeChild, curToNodeChild);
                                    }

                                } else if (curFromNodeType === TEXT_NODE || curFromNodeType == COMMENT_NODE) {
                                    // Both nodes being compared are Text or Comment nodes
                                    isCompatible = true;
                                    // Simply update nodeValue on the original node to
                                    // change the text value
                                    if (curFromNodeChild.nodeValue !== curToNodeChild.nodeValue) {
                                        curFromNodeChild.nodeValue = curToNodeChild.nodeValue;
                                    }

                                }
                            }

                            if (isCompatible) {
                                // Advance both the "to" child and the "from" child since we found a match
                                // Nothing else to do as we already recursively called morphChildren above
                                curToNodeChild = toNextSibling;
                                curFromNodeChild = fromNextSibling;
                                continue outer;
                            }

                            // No compatible match so remove the old node from the DOM and continue trying to find a
                            // match in the original DOM. However, we only do this if the from node is not keyed
                            // since it is possible that a keyed node might match up with a node somewhere else in the
                            // target tree and we don't want to discard it just yet since it still might find a
                            // home in the final DOM tree. After everything is done we will remove any keyed nodes
                            // that didn't find a home
                            if (curFromNodeKey) {
                                // Since the node is keyed it might be matched up later so we defer
                                // the actual removal to later
                                addKeyedRemoval(curFromNodeKey);
                            } else {
                                // NOTE: we skip nested keyed nodes from being removed since there is
                                //       still a chance they will be matched up later
                                removeNode(curFromNodeChild, fromEl, true /* skip keyed nodes */);
                            }

                            curFromNodeChild = fromNextSibling;
                        } // END: while(curFromNodeChild) {}

                        // If we got this far then we did not find a candidate match for
                        // our "to node" and we exhausted all of the children "from"
                        // nodes. Therefore, we will just append the current "to" node
                        // to the end
                        if (curToNodeKey && (matchingFromEl = fromNodesLookup[curToNodeKey]) && compareNodeNames(matchingFromEl, curToNodeChild)) {
                            fromEl.appendChild(matchingFromEl);
                            // MORPH
                            morphEl(matchingFromEl, curToNodeChild);
                        } else {
                            var onBeforeNodeAddedResult = onBeforeNodeAdded(curToNodeChild);
                            if (onBeforeNodeAddedResult !== false) {
                                if (onBeforeNodeAddedResult) {
                                    curToNodeChild = onBeforeNodeAddedResult;
                                }

                                if (curToNodeChild.actualize) {
                                    curToNodeChild = curToNodeChild.actualize(fromEl.ownerDocument || doc);
                                }
                                fromEl.appendChild(curToNodeChild);
                                handleNodeAdded(curToNodeChild);
                            }
                        }

                        curToNodeChild = toNextSibling;
                        curFromNodeChild = fromNextSibling;
                    }

                    cleanupFromEl(fromEl, curFromNodeChild, curFromNodeKey);

                    var specialElHandler = specialElHandlers[fromEl.nodeName];
                    if (specialElHandler) {
                        specialElHandler(fromEl, toEl);
                    }
                } // END: morphChildren(...)

                var morphedNode = fromNode;
                var morphedNodeType = morphedNode.nodeType;
                var toNodeType = toNode.nodeType;

                if (!childrenOnly) {
                    // Handle the case where we are given two DOM nodes that are not
                    // compatible (e.g. <div> --> <span> or <div> --> TEXT)
                    if (morphedNodeType === ELEMENT_NODE) {
                        if (toNodeType === ELEMENT_NODE) {
                            if (!compareNodeNames(fromNode, toNode)) {
                                onNodeDiscarded(fromNode);
                                morphedNode = moveChildren(fromNode, createElementNS(toNode.nodeName, toNode.namespaceURI));
                            }
                        } else {
                            // Going from an element node to a text node
                            morphedNode = toNode;
                        }
                    } else if (morphedNodeType === TEXT_NODE || morphedNodeType === COMMENT_NODE) { // Text or comment node
                        if (toNodeType === morphedNodeType) {
                            if (morphedNode.nodeValue !== toNode.nodeValue) {
                                morphedNode.nodeValue = toNode.nodeValue;
                            }

                            return morphedNode;
                        } else {
                            // Text node to something else
                            morphedNode = toNode;
                        }
                    }
                }

                if (morphedNode === toNode) {
                    // The "to node" was not compatible with the "from node" so we had to
                    // toss out the "from node" and use the "to node"
                    onNodeDiscarded(fromNode);
                } else {
                    morphEl(morphedNode, toNode, childrenOnly);

                    // We now need to loop over any keyed nodes that might need to be
                    // removed. We only do the removal if we know that the keyed node
                    // never found a match. When a keyed node is matched up we remove
                    // it out of fromNodesLookup and we use fromNodesLookup to determine
                    // if a keyed node has been matched up or not
                    if (keyedRemovalList) {
                        for (var i=0, len=keyedRemovalList.length; i<len; i++) {
                            var elToRemove = fromNodesLookup[keyedRemovalList[i]];
                            if (elToRemove) {
                                removeNode(elToRemove, elToRemove.parentNode, false);
                            }
                        }
                    }
                }

                if (!childrenOnly && morphedNode !== fromNode && fromNode.parentNode) {
                    if (morphedNode.actualize) {
                        morphedNode = morphedNode.actualize(fromNode.ownerDocument || doc);
                    }
                    // If we had to swap out the from node with a new node because the old
                    // node was not compatible with the target node then we need to
                    // replace the old DOM node in the original DOM tree. This is only
                    // possible if the original DOM node was part of a DOM tree which
                    // we know is the case if it has a parent node.
                    fromNode.parentNode.replaceChild(morphedNode, fromNode);
                }

                return morphedNode;
            };
        }

        var morphdom = morphdomFactory(morphAttrs);

        /* harmony default export */ var morphdom_esm = (morphdom);

// CONCATENATED MODULE: ./node_modules/shopify-asyncview/dist/index.es.js

        /*!
         * shopify-asyncview v2.0.3
         * (c) 2019 Pixel Union
         */

        function index_es_classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
                throw new TypeError("Cannot call a class as a function");
            }
        }

        function index_es_defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }

        function index_es_createClass(Constructor, protoProps, staticProps) {
            if (protoProps) index_es_defineProperties(Constructor.prototype, protoProps);
            if (staticProps) index_es_defineProperties(Constructor, staticProps);
            return Constructor;
        }

        function index_es_defineProperty(obj, key, value) {
            if (key in obj) {
                Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                });
            } else {
                obj[key] = value;
            }

            return obj;
        }

        function index_es_ownKeys(object, enumerableOnly) {
            var keys = Object.keys(object);

            if (Object.getOwnPropertySymbols) {
                var symbols = Object.getOwnPropertySymbols(object);
                if (enumerableOnly) symbols = symbols.filter(function (sym) {
                    return Object.getOwnPropertyDescriptor(object, sym).enumerable;
                });
                keys.push.apply(keys, symbols);
            }

            return keys;
        }

        function _objectSpread2(target) {
            for (var i = 1; i < arguments.length; i++) {
                var source = arguments[i] != null ? arguments[i] : {};

                if (i % 2) {
                    index_es_ownKeys(source, true).forEach(function (key) {
                        index_es_defineProperty(target, key, source[key]);
                    });
                } else if (Object.getOwnPropertyDescriptors) {
                    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
                } else {
                    index_es_ownKeys(source).forEach(function (key) {
                        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
                    });
                }
            }

            return target;
        }

        function _slicedToArray(arr, i) {
            return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
        }

        function _arrayWithHoles(arr) {
            if (Array.isArray(arr)) return arr;
        }

        function _iterableToArrayLimit(arr, i) {
            var _arr = [];
            var _n = true;
            var _d = false;
            var _e = undefined;

            try {
                for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
                    _arr.push(_s.value);

                    if (i && _arr.length === i) break;
                }
            } catch (err) {
                _d = true;
                _e = err;
            } finally {
                try {
                    if (!_n && _i["return"] != null) _i["return"]();
                } finally {
                    if (_d) throw _e;
                }
            }

            return _arr;
        }

        function _nonIterableRest() {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }

        var deferred = {};

        var AsyncView =
                /*#__PURE__*/
                function () {
                    function AsyncView() {
                        index_es_classCallCheck(this, AsyncView);
                    }

                    index_es_createClass(AsyncView, null, [{
                        key: "load",

                        /**
                         * Load the template given by the provided URL into the provided
                         * view
                         *
                         * @param {string} url - The url to load
                         * @param {object} query - An object containing additional query parameters of the URL
                         * @param {string} query.view - A required query parameter indicating which view to load
                         * @param {object} [options] - Config options
                         * @param {string} [options.hash] - A hash of the current page content
                         */
                        value: function load(url) {
                            var query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                            var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

                            if (!('view' in query)) {
                                return Promise.reject(new Error('\'view\' not found in \'query\' parameter'));
                            }

                            var querylessUrl = url.replace(/\?[^#]+/, '');
                            var queryParamsString = new RegExp(/.+\?([^#]+)/).exec(url);
                            var queryParams = query;

                            if (queryParamsString && queryParamsString.length >= 2) {
                                queryParamsString[1].split('&').forEach(function (param) {
                                    var _param$split = param.split('='),
                                            _param$split2 = _slicedToArray(_param$split, 2),
                                            key = _param$split2[0],
                                            value = _param$split2[1];

                                    queryParams[key] = value;
                                });
                            } // NOTE: We're adding an additional timestamp to the query.
                            // This is to prevent certain browsers from returning cached
                            // versions of the url we are requesting.
                            // See this PR for more info: https://github.com/pixelunion/shopify-asyncview/pull/4


                            var cachebustingParams = _objectSpread2({}, queryParams, {
                                _: new Date().getTime()
                            });

                            var hashUrl = querylessUrl.replace(/([^#]+)(.*)/, function (match, address, hash) {
                                return "".concat(address, "?").concat(Object.keys(queryParams).sort().map(function (key) {
                                    return "".concat(key, "=").concat(encodeURIComponent(queryParams[key]));
                                }).join('&')).concat(hash);
                            });
                            var requestUrl = querylessUrl.replace(/([^#]+)(.*)/, function (match, address, hash) {
                                return "".concat(address, "?").concat(Object.keys(cachebustingParams).sort().map(function (key) {
                                    return "".concat(key, "=").concat(encodeURIComponent(cachebustingParams[key]));
                                }).join('&')).concat(hash);
                            });
                            var promise = new Promise(function (resolve, reject) {
                                var data;

                                if (hashUrl in deferred) {
                                    resolve(deferred[hashUrl]);
                                    return;
                                }

                                deferred[hashUrl] = promise;

                                if (options.hash) {
                                    data = sessionStorage.getItem(hashUrl);

                                    if (data) {
                                        var deserialized = JSON.parse(data);

                                        if (options.hash === deserialized.options.hash) {
                                            delete deferred[hashUrl];
                                            resolve(deserialized);
                                            return;
                                        }
                                    }
                                }

                                var xhr = new XMLHttpRequest();
                                xhr.open('GET', requestUrl, true);

                                xhr.onload = function () {
                                    var el = xhr.response;
                                    var newOptions = {};
                                    var optionsEl = el.querySelector('[data-options]');

                                    if (optionsEl && optionsEl.innerHTML) {
                                        newOptions = JSON.parse(el.querySelector('[data-options]').innerHTML);
                                    }

                                    var htmlEls = el.querySelectorAll('[data-html]');
                                    var newHtml = {};

                                    if (htmlEls.length === 1 && htmlEls[0].getAttribute('data-html') === '') {
                                        newHtml = htmlEls[0].innerHTML;
                                    } else {
                                        for (var i = 0; i < htmlEls.length; i++) {
                                            newHtml[htmlEls[i].getAttribute('data-html')] = htmlEls[i].innerHTML;
                                        }
                                    }

                                    var dataEls = el.querySelectorAll('[data-data]');
                                    var newData = {};

                                    if (dataEls.length === 1 && dataEls[0].getAttribute('data-data') === '') {
                                        newData = JSON.parse(dataEls[0].innerHTML);
                                    } else {
                                        for (var _i = 0; _i < dataEls.length; _i++) {
                                            newData[dataEls[_i].getAttribute('data-data')] = JSON.parse(dataEls[_i].innerHTML);
                                        }
                                    }

                                    if (options.hash) {
                                        try {
                                            sessionStorage.setItem(hashUrl, JSON.stringify({
                                                options: newOptions,
                                                data: newData,
                                                html: newHtml
                                            }));
                                        } catch (error) {
                                            console.error(error);
                                        }
                                    }

                                    delete deferred[hashUrl];
                                    resolve({
                                        data: newData,
                                        html: newHtml
                                    });
                                };

                                xhr.onerror = function () {
                                    delete deferred[hashUrl];
                                    reject();
                                };

                                xhr.responseType = 'document';
                                xhr.send();
                            });
                            return promise;
                        }
                    }]);

                    return AsyncView;
                }();

        /* harmony default export */ var shopify_asyncview_dist_index_es = (AsyncView);

// CONCATENATED MODULE: ./node_modules/@shopify/theme-addresses/theme-addresses.js
        /**
         * CountryProvinceSelector Constructor
         * @param {String} countryOptions the country options in html string
         */
        function CountryProvinceSelector(countryOptions) {
            if (typeof countryOptions !== 'string') {
                throw new TypeError(countryOptions + ' is not a string.');
            }
            this.countryOptions = countryOptions;
        }

        /**
         * Builds the country and province selector with the given node element
         * @param {Node} countryNodeElement The <select> element for country
         * @param {Node} provinceNodeElement The <select> element for province
         * @param {Object} options Additional settings available
         * @param {CountryProvinceSelector~onCountryChange} options.onCountryChange callback after a country `change` event
         * @param {CountryProvinceSelector~onProvinceChange} options.onProvinceChange callback after a province `change` event
         */
        CountryProvinceSelector.prototype.build = function (countryNodeElement, provinceNodeElement, options) {
            if (typeof countryNodeElement !== 'object') {
                throw new TypeError(countryNodeElement + ' is not a object.');
            }

            if (typeof provinceNodeElement !== 'object') {
                throw new TypeError(provinceNodeElement + ' is not a object.');
            }

            var defaultValue = countryNodeElement.getAttribute('data-default');
            options = options || {}

            countryNodeElement.innerHTML = this.countryOptions;
            countryNodeElement.value = defaultValue;

            if (defaultValue && getOption(countryNodeElement, defaultValue)) {
                var provinces = buildProvince(countryNodeElement, provinceNodeElement, defaultValue);
                options.onCountryChange && options.onCountryChange(provinces, provinceNodeElement, countryNodeElement);
            }

            // Listen for value change on the country select
            countryNodeElement.addEventListener('change', function (event) {
                var target = event.target;
                var selectedValue = target.value;

                var provinces = buildProvince(target, provinceNodeElement, selectedValue);
                options.onCountryChange && options.onCountryChange(provinces, provinceNodeElement, countryNodeElement);
            });

            options.onProvinceChange && provinceNodeElement.addEventListener('change', options.onProvinceChange);
        }

        /**
         * This callback is called after a user interacted with a country `<select>`
         * @callback CountryProvinceSelector~onCountryChange
         * @param {array} provinces the parsed provinces
         * @param {Node} provinceNodeElement province `<select>` element
         * @param {Node} countryNodeElement country `<select>` element
         */

        /**
         * This callback is called after a user interacted with a province `<select>`
         * @callback CountryProvinceSelector~onProvinceChange
         * @param {Event} event the province selector `change` event object
         */

        /**
         * Returns the <option> with the specified value from the
         * given node element
         * A null is returned if no such <option> is found
         */
        function getOption(nodeElement, value) {
            return nodeElement.querySelector('option[value="' + value +'"]')
        }

        /**
         * Builds the options for province selector
         */
        function buildOptions (provinceNodeElement, provinces) {
            var defaultValue = provinceNodeElement.getAttribute('data-default');

            provinces.forEach(function (option) {
                var optionElement = document.createElement('option');
                optionElement.value = option[0];
                optionElement.textContent = option[1];

                provinceNodeElement.appendChild(optionElement);
            })

            if (defaultValue && getOption(provinceNodeElement, defaultValue)) {
                provinceNodeElement.value = defaultValue;
            }
        }

        /**
         * Builds the province selector
         */
        function buildProvince (countryNodeElement, provinceNodeElement, selectedValue) {
            var selectedOption = getOption(countryNodeElement, selectedValue);
            var provinces = JSON.parse(selectedOption.getAttribute('data-provinces'));

            provinceNodeElement.options.length = 0;

            if (provinces.length) {
                buildOptions(provinceNodeElement, provinces)
            }

            return provinces;
        }

// CONCATENATED MODULE: ./source/scripts/sections/StaticCart.js
        function StaticCart_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

        function StaticCart_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

        function StaticCart_createClass(Constructor, protoProps, staticProps) { if (protoProps) StaticCart_defineProperties(Constructor.prototype, protoProps); if (staticProps) StaticCart_defineProperties(Constructor, staticProps); return Constructor; }




        function ageVerificationMessageDisplay(variant){

            jQuery.getJSON('/cart.js', function(cart) {

                //default action is to always attempt to hide the age verification message
                var show = false;
                var promises = [];

                $.each(cart.items , function(index, val){
                    promises.push( $.getJSON('/products/'+val.handle+'.js') );
                });

                // Combine all promises and run a callback
                $.when.apply($, promises).then(function(){

                    // This callback will be passed the result of each AJAX call as a parameter
                    for(var i = 0; i < arguments.length; i++){

                        var product = arguments[i][0];
                        var match = false;

                        //seems like the cart json still contains the information for the product
                        //at this point so we need to manually exclude it
                        $.each(product.variants , function(index, val) {
                            if(val.id == variant){
                                match = true;
                            }
                        });

                        if(!match) {
                            if (product.tags.indexOf('alcohol') != -1) {
                                show = true;
                            }
                        }
                    }

                    if(!show){
                        $('#agree').prop('required',false);
                        $('#cart-age-verifier').hide();
                        $('#checkout-button').addClass('checkout-button--enabled');
                        $('#additional-buttons-c').addClass('div-enabled');
                    }
                });

            } );
        }


        var StaticCart_StaticCart = /*#__PURE__*/function () {
            function StaticCart(section) {
                var _this = this;

                StaticCart_classCallCheck(this, StaticCart);

                this.settings = section.data.settings;
                this.shipping = section.data.shipping;
                this.updateTimeout = null;
                this.$window = jquery_default()(window);
                this.$el = jquery_default()(section.el);
                this.el = section.el;
                this.$total = this.$el.find('[data-cart-total]');
                this.$shipping = this.$el.find('[data-cartshipping]'); // Product form containers

                this.$titleTotalSmall = this.$el.find('.cart-title-total--small');
                this.$titleTotalLarge = this.$el.find('.cart-title-total--large');
                this.$titleTotalContents = this.$el.find('[data-cart-title-total]'); // Cart list

                this.cartItemList = this.$el[0].querySelector('[data-cart-item-list]');
                this.cartDiscounts = this.$el[0].querySelector('[data-cart-discounts]'); // Shipping calculator elements

                this.$shippingToggle = this.$el.find('[data-cartshipping-toggle]');
                this.$shippingResponse = this.$shipping.find('[data-cartshipping-response]');
                this.$shippingResponseMessage = this.$shippingResponse.find('[data-cartshipping-message]');
                this.$shippingResponseRates = this.$shippingResponse.find('[data-cartshipping-rates]');
                this.$shippingSubmit = this.$shipping.find('[data-cartshipping-submit]');

                this._moveTitleTotal();

                var $scripts = jquery_default()('[data-scripts]');
                this._quantityKeyUp = this._quantityKeyUp.bind(this);
                this._editItemQuantity = this._editItemQuantity.bind(this);
                script_default()($scripts.data('shopify-api-url'), function () {
                    _this._bindEvents();

                    window.Shopify.onError = _this._handleErrors.bind(_this);
                });
                this.forms = new Forms_Forms(this.$el);

                if (this.settings.shipping && this.$shipping.length) {
                    script_default()($scripts.data('shopify-countries'), function () {
                        script_default()($scripts.data('shopify-common'), function () {
                            _this._initShippingCalc();
                        });
                    });
                }
            }

            StaticCart_createClass(StaticCart, [{
                key: "onSectionUnload",
                value: function onSectionUnload() {
                    this.$el.off('.cart-page');
                    this.$window.off('.cart-page');
                    this.forms.unload();
                }
            }, {
                key: "_bindEvents",
                value: function _bindEvents() {
                    var _this2 = this;

                    this.$el.on('keyup.cart-page', '[data-cartitem-quantity]', this._quantityKeyUp);
                    this.$el.on('keydown.cart-page', '[data-cartitem-quantity]', this._quantityKeyDown);
                    /*
                     * There are two [data-cartitem-quantity] selectors.
                     * Use the input as the source of truth rather than the select
                     * because the input has an infinite value range whereas the select
                     * has a finite range.
                     */

                    this.$el.on('change.cart-page', '[data-cartitem-quantity][data-quantity-input]', this._editItemQuantity);
                    this.$el.on('click.cart-page', '[data-cartitem-remove]', function (event) {
                        event.preventDefault();

                        _this2._editItemQuantity(event, true);
                    });
                    this.$window.on('resize.cart-page', just_debounce_default()(function () {
                        return _this2._moveTitleTotal();
                    }, 20));
                }
                /**
                 * Gets the current value of the quantity input box for a given line item key
                 *
                 * @param {string} key
                 */

            }, {
                key: "_getItemQuantity",
                value: function _getItemQuantity(key) {
                    return parseInt(this.el.querySelector("[data-cartitem-key=\"".concat(key, "\"] [data-quantity-input]")).value, 10);
                }
            }, {
                key: "_moveTitleTotal",
                value: function _moveTitleTotal() {
                    if (!this.$titleTotalContents.length) {
                        return;
                    }

                    if (this.$window.outerWidth() >= 480) {
                        if (!jquery_default.a.contains(this.$titleTotalLarge[0], this.$titleTotalContents[0])) {
                            var $form = this.$titleTotalContents.detach();
                            this.$titleTotalLarge.append($form);
                        }
                    } else if (!jquery_default.a.contains(this.$titleTotalSmall[0], this.$titleTotalContents[0])) {
                        var _$form = this.$titleTotalContents.detach();

                        this.$titleTotalSmall.append(_$form);
                    }
                }
                /**
                 * Update form depending on key input
                 *
                 * @param event
                 * @private
                 */

            }, {
                key: "_quantityKeyUp",
                value: function _quantityKeyUp(event) {
                    if (event.key === 'Backspace') {
                        // We block update on backspace so UI doesn't revert to select dropdown
                        // when user is trying to edit quantities with the text input.
                        if (this.updateTimeout !== null) {
                            clearTimeout(this.updateTimeout);
                            this.updateTimeout = null;
                        }

                        return;
                    }

                    this._editItemQuantity(event);
                }
                /**
                 * Prevent form submission when pressing `enter` within a quantity selector
                 *
                 * @param event
                 * @private
                 */

            }, {
                key: "_quantityKeyDown",
                value: function _quantityKeyDown(event) {
                    if (event.key === 'Enter') {
                        event.preventDefault();
                    }
                }
                /**
                 * Handle an item quantity change
                 *
                 * @param event
                 * @param {Boolean} remove - Set as true to remove cart item
                 * @private
                 */

            }, {
                key: "_editItemQuantity",
                value: function _editItemQuantity(event) {
                    var remove = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                    var $target = jquery_default()(event.currentTarget);
                    var cartItemRow = $target.closest('[data-cartitem-id]')[0];

                    if (remove) {
                        cartItemRow.classList.add('removing');

                        ageVerificationMessageDisplay(cartItemRow.getAttribute('data-cartitem-id'));
                    }

                    var quantity = remove ? 0 : parseInt(cartItemRow.querySelector('.form-field.visible [data-cartitem-quantity]').value, 10);
                    var key = cartItemRow.getAttribute('data-cartitem-key');

                    this._updateCart(key, quantity);
                }
                /**
                 * Update cart with a valid quantity
                 *
                 * @param $cartItem
                 * @param quantity
                 * @private
                 */

            }, {
                key: "_updateCart",
                value: function _updateCart(key, quantity) {
                    var _this3 = this;

                    // cancel any pending requests
                    if (this.updateTimeout !== null) {
                        clearTimeout(this.updateTimeout);
                    }

                    this.updateTimeout = setTimeout(function () {
                        if (quantity > 0 && _this3._getItemQuantity(key) !== quantity) {
                            _this3.updateTimeout = null;
                            return;
                        }

                        var thisTimeoutId = _this3.updateTimeout; // Notify Shopify updated item

                        window.Shopify.changeItem(key, quantity, function (response) {
                            if (_this3.updateTimeout !== thisTimeoutId) {
                                return;
                            }

                            _this3._didUpdate(response, thisTimeoutId);
                        });
                    }, 300);
                }
                /**
                 * Fetches new cart contents and swaps into page
                 *
                 * @param response
                 * @param {integer} thisTimeoutId Id of timeout for this request. If no longer current, update is cancelled.
                 * @returns {*}
                 * @private
                 */

            }, {
                key: "_didUpdate",
                value: function _didUpdate(response, thisTimeoutId) {
                    var _this4 = this;

                    // Reload page if all items are removed from cart
                    if (!response.items.length) {
                        window.location = window.Theme.routes.cart_url;
                        return;
                    } // Reload the cart-item-list and the discounts snippets


                    shopify_asyncview_dist_index_es.load(window.Theme.routes.cart_url, {
                        view: '_ajax'
                    }).then(function (_ref) {
                        var html = _ref.html;

                        // If another request is in progress, discard this update
                        if (_this4.updateTimeout !== thisTimeoutId) {
                            return;
                        }

                        var countEvent = new CustomEvent('cartcount:update', {
                            detail: response
                        });
                        window.dispatchEvent(countEvent);

                        _this4.$total.each(function (i, el) {
                            el.innerHTML = Shopify.formatMoney( // eslint-disable-line no-param-reassign
                                    response.total_price, _this4.settings.money_format);
                        }); // Inject new cart list contents


                        var newListContainer = document.createElement('div');
                        newListContainer.innerHTML = html.list;
                        morphdom_esm(_this4.cartItemList, newListContainer.querySelector('ul'), {
                            onBeforeElUpdated: function onBeforeElUpdated(fromEl, toEl) {
                                // Skip images if src matches
                                // - we don't want to reload lazy loaded images
                                if (fromEl.tagName === 'IMG' && fromEl.src === toEl.src) {
                                    return false;
                                }

                                return true;
                            }
                        });
                        rimg_shopify_dist_index_es.watch(_this4.cartItemList);

                        _this4.forms.unload();

                        _this4.forms = new Forms_Forms(_this4.$el);

                        _this4.$el.off('keyup.cart-page', '[data-cartitem-quantity]');

                        _this4.$el.on('keyup.cart-page', '[data-cartitem-quantity]', _this4._quantityKeyUp);

                        _this4.$el.off('keydown.cart-page', '[data-cartitem-quantity]');

                        _this4.$el.on('keydown.cart-page', '[data-cartitem-quantity]', _this4._quantityKeyDown);

                        _this4.$el.off('change.cart-page', '[data-cartitem-quantity][data-quantity-input]');

                        _this4.$el.on('change.cart-page', '[data-cartitem-quantity][data-quantity-input]', _this4._editItemQuantity);

                        _this4.$el.off('click.cart-page', '[data-cartitem-remove]');

                        _this4.$el.on('click.cart-page', '[data-cartitem-remove]', function (event) {
                            event.preventDefault();

                            _this4._editItemQuantity(event, true);
                        }); // Inject new cart level discounts


                        _this4.cartDiscounts.innerHTML = html.discounts;
                    }).catch(function () {
                        return window.location.reload();
                    });
                }
                /**
                 * Handle Errors returned from Shopify
                 *
                 * @param errors
                 * @private
                 */

            }, {
                key: "_handleErrors",
                value: function _handleErrors() {
                    var errors = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

                    if (!errors) {
                        return;
                    }

                    var shippingResponse = {
                        message: this.shipping.error_general
                    };

                    if (errors.zip && errors.zip.length > 0) {
                        if (errors.zip[0].indexOf('is not valid') !== -1 || errors.zip[0].indexOf('can\'t be blank') !== -1) {
                            shippingResponse.message = "".concat(this.shipping.zip, " ").concat(errors.zip);
                        }
                    }

                    if (errors.error && errors.error.length > 0) {
                        if (errors.error[0].indexOf('shipment_too_heavy') !== -1) {
                            shippingResponse.message = this.shipping.shipment_too_heavy;
                        }
                    }

                    this._handleShippingResponse(shippingResponse);
                }
            }, {
                key: "_initShippingCalc",
                value: function _initShippingCalc() {
                    var _this5 = this;

                    this._bindShippingCalcEvents();

                    var countrySelect = document.getElementById('address_country');
                    var provinceSelect = document.getElementById('address_province');
                    var provinceContainer = document.getElementById('address_province_container');
                    this.shippingCountryProvinceSelector = new CountryProvinceSelector(countrySelect.innerHTML);
                    this.shippingCountryProvinceSelector.build(countrySelect, provinceSelect, {
                        onCountryChange: function onCountryChange(provinces) {
                            if (provinces.length) {
                                provinceContainer.style.display = 'block';
                            } else {
                                provinceContainer.style.display = 'none';
                            } // "Province", "State", "Region", etc. and "Postal Code", "ZIP Code", etc.
                            // Even countries without provinces include a label.


                            var _window$Countries$cou = window.Countries[countrySelect.value],
                                    label = _window$Countries$cou.label,
                                    zipLabel = _window$Countries$cou.zip_label;
                            provinceContainer.querySelector('label[for="address_province"]').innerHTML = label;
                            _this5.el.querySelector('#address_zip ~ label[for="address_zip"]').innerHTML = zipLabel;
                        }
                    });
                }
            }, {
                key: "_bindShippingCalcEvents",
                value: function _bindShippingCalcEvents() {
                    var _this6 = this;

                    this.$el.on('click.cart-page', '[data-cartshipping-toggle]', function () {
                        _this6._toggleShippingCalc();
                    });
                    this.$el.on('click.cart-page', '[data-cartshipping-submit]', function () {
                        _this6._getShippingRates();
                    });
                    this.$el.on('keypress.cart-page', '#address_zip', function (event) {
                        if (event.keyCode === 10 || event.keyCode === 13) {
                            event.preventDefault();

                            _this6.$shippingSubmit.trigger('click');
                        }
                    });
                }
            }, {
                key: "_toggleShippingCalc",
                value: function _toggleShippingCalc() {
                    var oldText = this.$shippingToggle.text();
                    var newText = this.$shippingToggle.data('cartshipping-toggle');
                    this.$shippingToggle.text(newText).data('cartshipping-toggle', oldText);
                    this.$shipping.toggleClass('open');
                }
            }, {
                key: "_getShippingRates",
                value: function _getShippingRates() {
                    var _this7 = this;

                    this._disableShippingButton();

                    var shippingAddress = {};
                    shippingAddress.country = jquery_default()('#address_country').val() || '';
                    shippingAddress.province = jquery_default()('#address_province').val() || '';
                    shippingAddress.zip = jquery_default()('#address_zip').val() || '';
                    var queryString = Object.keys(shippingAddress).map(function (key) {
                        return "".concat(encodeURIComponent("shipping_address[".concat(key, "]")), "=").concat(encodeURIComponent(shippingAddress[key]));
                    }).join('&');
                    jquery_default.a.ajax("".concat(window.Theme.routes.cart_url, "/shipping_rates.json?").concat(queryString), {
                        dataType: 'json'
                    }).fail(function (error) {
                        return _this7._handleErrors(error.responseJSON || {});
                    }).done(function (response) {
                        var rates = response.shipping_rates;
                        var addressBase = [];

                        if (shippingAddress.zip.length) {
                            addressBase.push(shippingAddress.zip.trim());
                        }

                        if (shippingAddress.province.length) {
                            addressBase.push(shippingAddress.province);
                        }

                        if (shippingAddress.country.length) {
                            addressBase.push(shippingAddress.country);
                        }

                        var address = addressBase.join(', ');
                        var message = '';

                        if (rates.length > 1) {
                            var firstRate = window.Shopify.formatMoney(rates[0].price, _this7.settings.money_format);
                            message = _this7.shipping.multiple_rates.replace('*address*', address).replace('*number_of_rates*', rates.length).replace('*rate*', "<span class=\"money\">".concat(firstRate, "</span>"));
                        } else if (rates.length === 1) {
                            message = _this7.shipping.one_rate.replace('*address*', address);
                        } else {
                            message = _this7.shipping.no_rates;
                        }

                        var ratesList = rates.map(function (rate) {
                            var price = window.Shopify.formatMoney(rate.price, _this7.settings.money_format);

                            var rateValue = _this7.shipping.rate_value.replace('*rate_title*', rate.name).replace('*rate*', "<span class=\"money\">".concat(price, "</span>"));

                            return "<li>".concat(rateValue, "</li>");
                        });

                        _this7._handleShippingResponse({
                            message: message,
                            rates: ratesList
                        });
                    });
                }
            }, {
                key: "_enableShippingButton",
                value: function _enableShippingButton() {
                    this.$shippingSubmit.text(this.shipping.calculate_shipping).attr('disabled', false);
                }
            }, {
                key: "_disableShippingButton",
                value: function _disableShippingButton() {
                    this.$shippingSubmit.text(this.shipping.calculating).attr('disabled', true);
                }
            }, {
                key: "_showShippingResponse",
                value: function _showShippingResponse() {
                    this.$shippingResponse.addClass('visible');
                }
            }, {
                key: "_hideShippingResponse",
                value: function _hideShippingResponse() {
                    this.$shippingResponse.removeClass('visible');
                }
                /**
                 * Handle shipping responses
                 *
                 * @param {object} shippingResponse
                 * @property {String} shippingResponse.messages - Error / Success message
                 * @property {Array|String} shippingResponse.rates - Shipping rates
                 * @private
                 */

            }, {
                key: "_handleShippingResponse",
                value: function _handleShippingResponse() {
                    var shippingResponse = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                    // Hide the response so that it can be populated smoothly
                    this._hideShippingResponse();

                    var message = shippingResponse.message || null;
                    var rates = shippingResponse.rates || null; // Empty out contents

                    this.$shippingResponseMessage.empty();
                    this.$shippingResponseRates.empty();

                    if (message) {
                        this.$shippingResponseMessage.html(message);
                    }

                    if (rates) {
                        this.$shippingResponseRates.html(rates);
                    } // Reset the calculating button so it can be used again


                    this._enableShippingButton(); // No error provided


                    if (!message && !rates) {
                        return;
                    } // Show the response


                    this._showShippingResponse();
                }
            }]);

            return StaticCart;
        }();


// CONCATENATED MODULE: ./node_modules/@pixelunion/animations/dist/animations.es.js

        /*!
         * @pixelunion/animations v0.1.0
         * (c) 2019 Pixel Union
         * Released under the UNLICENSED license.
         */

        function animations_es_classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
                throw new TypeError("Cannot call a class as a function");
            }
        }

        function animations_es_defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }

        function animations_es_createClass(Constructor, protoProps, staticProps) {
            if (protoProps) animations_es_defineProperties(Constructor.prototype, protoProps);
            if (staticProps) animations_es_defineProperties(Constructor, staticProps);
            return Constructor;
        }

        function animations_es_defineProperty(obj, key, value) {
            if (key in obj) {
                Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                });
            } else {
                obj[key] = value;
            }

            return obj;
        }

        function animations_es_ownKeys(object, enumerableOnly) {
            var keys = Object.keys(object);

            if (Object.getOwnPropertySymbols) {
                var symbols = Object.getOwnPropertySymbols(object);
                if (enumerableOnly) symbols = symbols.filter(function (sym) {
                    return Object.getOwnPropertyDescriptor(object, sym).enumerable;
                });
                keys.push.apply(keys, symbols);
            }

            return keys;
        }

        function animations_es_objectSpread2(target) {
            for (var i = 1; i < arguments.length; i++) {
                var source = arguments[i] != null ? arguments[i] : {};

                if (i % 2) {
                    animations_es_ownKeys(source, true).forEach(function (key) {
                        animations_es_defineProperty(target, key, source[key]);
                    });
                } else if (Object.getOwnPropertyDescriptors) {
                    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
                } else {
                    animations_es_ownKeys(source).forEach(function (key) {
                        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
                    });
                }
            }

            return target;
        }

        /**
         * Promisified version of window.requestAnimationFrame.
         * @returns {Promise} Promise will resolve when requestAnimationFrame callback is run.
         */
        function raf() {
            return new Promise(function (resolve) {
                window.requestAnimationFrame(resolve);
            });
        }
        /**
         * Represents an HTML element with associate states
         */


        var Animation =
                /*#__PURE__*/
                function () {
                    /**
                     * @param {Object} options
                     * @param {HTMLElement}  options.el Target element
                     * @param {String} [options.state=initial] Initial state. This is also the default state.
                     * @param {String} [options.stateAttribute=data-revealer] Attribute name to update with state.
                     * @param {String} [options.stateChangeAttribute=data-revealer-transition] Attribute name to
                     * update with change of state.
                     * @param {String} [options.endEvent=transitionend] Event to listen for at end of state change.
                     * @param {Boolean} [options.hold=false] If true, changeAttribute will not be removed until the
                     * next state change.
                     * @param {Function} [options.onStart] Callback to execute immediate after
                     * applying stateChangeAttribute.
                     */
                    function Animation(options) {
                        animations_es_classCallCheck(this, Animation);

                        this._el = options.el;
                        this.cancelRunning = null;
                        this._state = options.state || 'initial';
                        this.initialState = this._state;
                        this.stateAttribute = options.stateAttribute || 'data-animation-state';
                        this.stateChangeAttribute = options.stateChangeAttribute || 'data-animation';
                        this.endEvent = options.endEvent || 'transitionend';
                        this.hold = !!options.hold;

                        this.onStart = options.onStart || function () {
                                    /* do nothing */
                                };

                        this.activeEventHandler = null;
                    }
                    /**
                     * Returns target element
                     *
                     * @return {HTMLElement} Target element
                     */


                    animations_es_createClass(Animation, [{
                        key: "isState",

                        /**
                         * Check if a state is active
                         * @param {String} state State to compare
                         *
                         * @return {Boolean}
                         */
                        value: function isState(state) {
                            return state === this._state;
                        }
                        /**
                         * Sequences a change to a new state.
                         * @param {String} state Target state
                         *
                         * @param {Boolean} options.force Switch to final state immediately
                         *
                         * @param {Function} options.onStart Callback to execute immediately after
                         * applying stateChangeAttribute for this state change only.
                         *
                         * @param {Boolean} [options.hold=false] If true, changeAttribute will not be removed until the
                         * next state change.
                         *
                         * @return {Promise} Resolves when endEvent triggered
                         */

                    }, {
                        key: "animateTo",
                        value: function animateTo(state) {
                            var _this = this;

                            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                            var from = this._el.dataset[this.stateAttribute] || this._state;
                            var to = state || this.initialState;
                            var force = options.force;
                            var hold = 'hold' in options ? options.hold : this.hold;
                            return new Promise(function (resolve) {
                                if (_this.cancelRunning) {
                                    _this.cancelRunning();
                                }

                                if (from === to) {
                                    // Removing this here fixes some lingering attributes. But why?
                                    _this._el.removeAttribute(_this.stateChangeAttribute);

                                    resolve(from, null);
                                    return;
                                }

                                var running = true;

                                _this.cancelRunning = function () {
                                    running = false;
                                    resolve(null, null);
                                };

                                _this._el.removeEventListener(_this.endEvent, _this.activeEventHandler);

                                _this.activeEventHandler = null;

                                if (force) {
                                    _this._el.setAttribute(_this.stateChangeAttribute, "".concat(from, "=>").concat(to));

                                    _this.onStart({
                                        el: _this._el,
                                        from: from,
                                        to: to
                                    });

                                    if (typeof options.onStart === 'function') {
                                        options.onStart({
                                            el: _this._el,
                                            from: from,
                                            to: to
                                        });
                                    }

                                    _this._el.setAttribute(_this.stateAttribute, to);

                                    _this._state = to;

                                    if (!hold) {
                                        _this._el.removeAttribute(_this.stateChangeAttribute);
                                    }

                                    resolve(to, null);
                                    return;
                                }

                                raf().then(function () {
                                    if (!running) throw new Error('cancelled');

                                    _this._el.setAttribute(_this.stateChangeAttribute, "".concat(from, "=>").concat(to));

                                    _this.onStart({
                                        el: _this._el,
                                        from: from,
                                        to: to
                                    });

                                    if (typeof options.onStart === 'function') {
                                        options.onStart({
                                            el: _this._el,
                                            from: from,
                                            to: to
                                        });
                                    }

                                    return raf();
                                }).then(function () {
                                    if (!running) throw new Error('cancelled');

                                    _this._el.removeEventListener(_this.endEvent, _this.activeEventHandler);

                                    _this.activeEventHandler = function (e) {
                                        // Ignore any events bubbling up
                                        if (e.target !== _this._el || !running) return;

                                        _this._el.removeEventListener(_this.endEvent, _this.activeEventHandler);

                                        if (!hold) {
                                            _this._el.removeAttribute(_this.stateChangeAttribute);
                                        }

                                        resolve(to, e);
                                    };

                                    _this._el.addEventListener(_this.endEvent, _this.activeEventHandler);

                                    _this._el.setAttribute(_this.stateAttribute, to);

                                    _this._state = to;
                                })["catch"](function (error) {
                                    // Only catch 'cancelled' errors.
                                    if (error.message !== 'cancelled') throw error;
                                });
                            });
                        }
                        /**
                         * Remove any event listeners
                         */

                    }, {
                        key: "unload",
                        value: function unload() {
                            this._el.removeEventListener(this.endEvent, this.activeEventHandler);

                            this.activeEventHandler = null;
                        }
                    }, {
                        key: "el",
                        get: function get() {
                            return this._el;
                        }
                        /**
                         * Returns current state
                         *
                         * @return {String} Current state
                         */

                    }, {
                        key: "state",
                        get: function get() {
                            return this._state;
                        }
                    }]);

                    return Animation;
                }();

        /**
         * Manage state changes for a set of elements
         */

        var AnimationsManager =
                /*#__PURE__*/
                function () {
                    function AnimationsManager() {
                        animations_es_classCallCheck(this, AnimationsManager);

                        this.animations = new Map();
                    }
                    /**
                     * Add a new element and return an animation for that element. If element already has an associated animation, return that animation.
                     * @param {Object} options
                     * @param {HTMLElement}  options.el Target element
                     * @param {String} [options.state=initial] Initial state. This is also the default state.
                     * @param {String} [options.stateAttribute=data-revealer] Attribute name to update with state.
                     * @param {String} [options.stateChangeAttribute=data-revealer-transition] Attribute name to update with change of state.
                     * @param {String} [options.endEvent=transitionend] Event name to listen for at end of state change.
                     * @param {Boolean} [options.hold=false] If true, changeAttribute will not be removed until the next state change.
                     * @param {Function} [options.onStart] Callback to execute immediate after applying stateChangeAttribute.
                     *
                     * @return {Animation}
                     */


                    animations_es_createClass(AnimationsManager, [{
                        key: "add",
                        value: function add(options) {
                            if (this.animations.has(options.el)) return this.animations.get(options.el);
                            var animation = new Animation(options);
                            this.animations.set(options.el, animation);
                            return animation;
                        }
                        /**
                         * Remove a single animation
                         * @param {Animation} animation Animation to remove. Any event listeners will also be removed.
                         */

                    }, {
                        key: "remove",
                        value: function remove(animation) {
                            this.animations["delete"](animation.el);
                            animation.unload();
                        }
                        /**
                         * Remove all animations, including all event listeners.
                         */

                    }, {
                        key: "removeAll",
                        value: function removeAll() {
                            this.animations.forEach(function (animation) {
                                return animation.unload();
                            });
                        }
                    }]);

                    return AnimationsManager;
                }();

        function animation(options) {
            var setOptions = {
                endEvent: 'animationend',
                hold: true
            };
            return new Animation(animations_es_objectSpread2({
                options: options
            }, setOptions));
        }

        function transition(options) {
            return new Animation(options);
        }



// EXTERNAL MODULE: ./node_modules/@pixelunion/events/dist/EventHandler.js
        var EventHandler = __webpack_require__(2);
        var EventHandler_default = /*#__PURE__*/__webpack_require__.n(EventHandler);

// CONCATENATED MODULE: ./source/scripts/Layout.js

        var eventHandlers = [];
        var previousBreakpoint = null;

        function getBreakpoints() {
            return window.getComputedStyle(document.documentElement, ':before').getPropertyValue('content').replace(/"/g, '').split(',');
        }

        function getBreakpoint() {
            return window.getComputedStyle(document.documentElement, ':after').getPropertyValue('content').replace(/"/g, '');
        }

        jquery_default()(window).on('resize', function (event) {
            var currentBreakpoint = getBreakpoint();

            if (previousBreakpoint !== currentBreakpoint) {
                eventHandlers.forEach(function (eventHandler) {
                    eventHandler(event, {
                        previous: previousBreakpoint,
                        current: currentBreakpoint
                    });
                });
            }

            previousBreakpoint = currentBreakpoint;
        });

        function isLessThanBreakpoint(breakpoint) {
            var inclusive = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            var breakpoints = getBreakpoints();
            var currentBreakpoint = getBreakpoint();
            var comparison = breakpoints.indexOf(currentBreakpoint) - breakpoints.indexOf(breakpoint);
            return inclusive ? comparison <= 0 : comparison < 0;
        }

        function isGreaterThanBreakpoint(breakpoint) {
            var inclusive = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            var breakpoints = getBreakpoints();
            var currentBreakpoint = getBreakpoint();
            var comparison = breakpoints.indexOf(currentBreakpoint) - breakpoints.indexOf(breakpoint);
            return inclusive ? comparison >= 0 : comparison > 0;
        }

        function isBreakpoint() {
            var currentBreakpoint = getBreakpoint();

            for (var _len = arguments.length, breakpoints = new Array(_len), _key = 0; _key < _len; _key++) {
                breakpoints[_key] = arguments[_key];
            }

            return breakpoints.some(function (breakpoint) {
                return breakpoint === currentBreakpoint;
            });
        }

        function Layout_onBreakpointChange(eventHandler) {
            if (eventHandlers.indexOf(eventHandler) === -1) {
                eventHandlers.push(eventHandler);
            }
        }

        function offBreakpointChange(eventHandler) {
            var index = eventHandlers.indexOf(eventHandler);

            if (index !== -1) {
                eventHandlers.splice(index, 1);
            }
        }

        /* harmony default export */ var Layout = ({
            isLessThanBreakpoint: isLessThanBreakpoint,
            isGreaterThanBreakpoint: isGreaterThanBreakpoint,
            isBreakpoint: isBreakpoint,
            onBreakpointChange: Layout_onBreakpointChange,
            offBreakpointChange: offBreakpointChange
        });
// CONCATENATED MODULE: ./source/scripts/helpers/LazyLoader.js
        function LazyLoader_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

        function LazyLoader_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { LazyLoader_ownKeys(Object(source), true).forEach(function (key) { LazyLoader_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { LazyLoader_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

        function LazyLoader_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

        function LazyLoader_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

        function LazyLoader_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

        function LazyLoader_createClass(Constructor, protoProps, staticProps) { if (protoProps) LazyLoader_defineProperties(Constructor.prototype, protoProps); if (staticProps) LazyLoader_defineProperties(Constructor, staticProps); return Constructor; }

        /**
         * Allows a callback to be run once, when a target intersects the viewport.
         * @constructor
         * @param {HTMLElement} target Element to track
         * @param {Function} callback Function to execute when target enters viewport (only executed once)
         * @param {Object} [options] options with which to construct the IntersectionObserver
         * @param {string} [options.rootMargin='30%'] A string which specifies a set of offsets to add to the root's bounding_box when calculating intersections.
         * @param {number} [options.threshold=0] Ratio of intersection required to trigger callback
         */
        var LazyLoader_LazyLoader = /*#__PURE__*/function () {
            function LazyLoader(target, callback, options) {
                LazyLoader_classCallCheck(this, LazyLoader);

                var defaultOptions = {
                    rootMargin: '30%',
                    threshold: 0
                };
                this.callback = callback;
                this._runCallback = this._runCallback.bind(this);
                this.observer = new IntersectionObserver(this._runCallback, LazyLoader_objectSpread(LazyLoader_objectSpread({}, defaultOptions), options));
                this.observer.observe(target);
            }
            /**
             * Runs the callback if first entry becomes intersecting, then unloads the LazyLoader
             * @_runCallback
             * @param {IntersectionObserverEntry[]} entries Entry to check - all but the
             * first element will be ignored.
             */


            LazyLoader_createClass(LazyLoader, [{
                key: "_runCallback",
                value: function _runCallback(entries) {
                    // do nothing unless target moved into state of intersection
                    if (entries[0].isIntersecting === true) {
                        this.unload();
                        this.callback();
                    }
                }
                /**
                 * Disconnects IntersectionObserver if active
                 * @unload
                 */

            }, {
                key: "unload",
                value: function unload() {
                    this.observer.disconnect();
                }
            }]);

            return LazyLoader;
        }();


// EXTERNAL MODULE: ./node_modules/vanilla-modal/dist/index.js
        var vanilla_modal_dist = __webpack_require__(13);
        var vanilla_modal_dist_default = /*#__PURE__*/__webpack_require__.n(vanilla_modal_dist);

// CONCATENATED MODULE: ./node_modules/@shopify/theme-a11y/theme-a11y.js
        /**
         * A11y Helpers
         * -----------------------------------------------------------------------------
         * A collection of useful functions that help make your theme more accessible
         */

        /**
         * Moves focus to an HTML element
         * eg for In-page links, after scroll, focus shifts to content area so that
         * next `tab` is where user expects. Used in bindInPageLinks()
         * eg move focus to a modal that is opened. Used in trapFocus()
         *
         * @param {Element} container - Container DOM element to trap focus inside of
         * @param {Object} options - Settings unique to your theme
         * @param {string} options.className - Class name to apply to element on focus.
         */
        function forceFocus(element, options) {
            options = options || {};

            var savedTabIndex = element.tabIndex;

            element.tabIndex = -1;
            element.dataset.tabIndex = savedTabIndex;
            element.focus();
            if (typeof options.className !== 'undefined') {
                element.classList.add(options.className);
            }
            element.addEventListener('blur', callback);

            function callback(event) {
                event.target.removeEventListener(event.type, callback);

                element.tabIndex = savedTabIndex;
                delete element.dataset.tabIndex;
                if (typeof options.className !== 'undefined') {
                    element.classList.remove(options.className);
                }
            }
        }

        /**
         * If there's a hash in the url, focus the appropriate element
         * This compensates for older browsers that do not move keyboard focus to anchor links.
         * Recommendation: To be called once the page in loaded.
         *
         * @param {Object} options - Settings unique to your theme
         * @param {string} options.className - Class name to apply to element on focus.
         * @param {string} options.ignore - Selector for elements to not include.
         */

        function focusHash(options) {
            options = options || {};
            var hash = window.location.hash;
            var element = document.getElementById(hash.slice(1));

            // if we are to ignore this element, early return
            if (element && options.ignore && element.matches(options.ignore)) {
                return false;
            }

            if (hash && element) {
                forceFocus(element, options);
            }
        }

        /**
         * When an in-page (url w/hash) link is clicked, focus the appropriate element
         * This compensates for older browsers that do not move keyboard focus to anchor links.
         * Recommendation: To be called once the page in loaded.
         *
         * @param {Object} options - Settings unique to your theme
         * @param {string} options.className - Class name to apply to element on focus.
         * @param {string} options.ignore - CSS selector for elements to not include.
         */

        function bindInPageLinks(options) {
            options = options || {};
            var links = Array.prototype.slice.call(
                    document.querySelectorAll('a[href^="#"]')
            );

            return links.filter(function(link) {
                if (link.hash === '#' || link.hash === '') {
                    return false;
                }

                if (options.ignore && link.matches(options.ignore)) {
                    return false;
                }

                var element = document.querySelector(link.hash);

                if (!element) {
                    return false;
                }

                link.addEventListener('click', function() {
                    forceFocus(element, options);
                });

                return true;
            });
        }

        function focusable(container) {
            var elements = Array.prototype.slice.call(
                    container.querySelectorAll(
                            '[tabindex],' +
                            '[draggable],' +
                            'a[href],' +
                            'area,' +
                            'button:enabled,' +
                            'input:not([type=hidden]):enabled,' +
                            'object,' +
                            'select:enabled,' +
                            'textarea:enabled'
                    )
            );

            // Filter out elements that are not visible.
            // Copied from jQuery https://github.com/jquery/jquery/blob/2d4f53416e5f74fa98e0c1d66b6f3c285a12f0ce/src/css/hiddenVisibleSelectors.js
            return elements.filter(function(element) {
                return !!(
                        element.offsetWidth ||
                        element.offsetHeight ||
                        element.getClientRects().length
                );
            });
        }

        /**
         * Traps the focus in a particular container
         *
         * @param {Element} container - Container DOM element to trap focus inside of
         * @param {Element} elementToFocus - Element to be focused on first
         * @param {Object} options - Settings unique to your theme
         * @param {string} options.className - Class name to apply to element on focus.
         */

        var trapFocusHandlers = {};

        function trapFocus(container, options) {
            options = options || {};
            var elements = focusable(container);
            var elementToFocus = options.elementToFocus || container;
            var first = elements[0];
            var last = elements[elements.length - 1];

            removeTrapFocus();

            trapFocusHandlers.focusin = function(event) {
                if (container !== event.target && !container.contains(event.target)) {
                    first.focus();
                }

                if (
                        event.target !== container &&
                        event.target !== last &&
                        event.target !== first
                )
                    return;
                document.addEventListener('keydown', trapFocusHandlers.keydown);
            };

            trapFocusHandlers.focusout = function() {
                document.removeEventListener('keydown', trapFocusHandlers.keydown);
            };

            trapFocusHandlers.keydown = function(event) {
                if (event.keyCode !== 9) return; // If not TAB key

                // On the last focusable element and tab forward, focus the first element.
                if (event.target === last && !event.shiftKey) {
                    event.preventDefault();
                    first.focus();
                }

                //  On the first focusable element and tab backward, focus the last element.
                if (
                        (event.target === container || event.target === first) &&
                        event.shiftKey
                ) {
                    event.preventDefault();
                    last.focus();
                }
            };

            document.addEventListener('focusout', trapFocusHandlers.focusout);
            document.addEventListener('focusin', trapFocusHandlers.focusin);

            forceFocus(elementToFocus, options);
        }

        /**
         * Removes the trap of focus from the page
         */
        function removeTrapFocus() {
            document.removeEventListener('focusin', trapFocusHandlers.focusin);
            document.removeEventListener('focusout', trapFocusHandlers.focusout);
            document.removeEventListener('keydown', trapFocusHandlers.keydown);
        }

        /**
         * Add a preventive message to external links and links that open to a new window.
         * @param {string} elements - Specific elements to be targeted
         * @param {object} options.messages - Custom messages to overwrite with keys: newWindow, external, newWindowExternal
         * @param {string} options.messages.newWindow - When the link opens in a new window (e.g. target="_blank")
         * @param {string} options.messages.external - When the link is to a different host domain.
         * @param {string} options.messages.newWindowExternal - When the link is to a different host domain and opens in a new window.
         * @param {object} options.prefix - Prefix to namespace "id" of the messages
         */
        function accessibleLinks(elements, options) {
            if (typeof elements !== 'string') {
                throw new TypeError(elements + ' is not a String.');
            }

            elements = document.querySelectorAll(elements);

            if (elements.length === 0) {
                return;
            }

            options = options || {};
            options.messages = options.messages || {};

            var messages = {
                newWindow: options.messages.newWindow || 'Opens in a new window.',
                external: options.messages.external || 'Opens external website.',
                newWindowExternal:
                options.messages.newWindowExternal ||
                'Opens external website in a new window.'
            };

            var prefix = options.prefix || 'a11y';

            var messageSelectors = {
                newWindow: prefix + '-new-window-message',
                external: prefix + '-external-message',
                newWindowExternal: prefix + '-new-window-external-message'
            };

            function generateHTML(messages) {
                var container = document.createElement('ul');
                var htmlMessages = Object.keys(messages).reduce(function(html, key) {
                    return (html +=
                            '<li id=' + messageSelectors[key] + '>' + messages[key] + '</li>');
                }, '');

                container.setAttribute('hidden', true);
                container.innerHTML = htmlMessages;

                document.body.appendChild(container);
            }

            function externalSite(link) {
                return link.hostname !== window.location.hostname;
            }

            elements.forEach(function(link) {
                var target = link.getAttribute('target');
                var rel = link.getAttribute('rel');
                var isExternal = externalSite(link);
                var isTargetBlank = target === '_blank';
                var isRelNoopenerEmpty = rel === null || rel.indexOf('noopener') === -1;

                if (isTargetBlank && isRelNoopenerEmpty) {
                    link.setAttribute('rel', 'noopener');
                }

                if (isExternal && isTargetBlank) {
                    link.setAttribute('aria-describedby', messageSelectors.newWindowExternal);
                } else if (isExternal) {
                    link.setAttribute('aria-describedby', messageSelectors.external);
                } else if (isTargetBlank) {
                    link.setAttribute('aria-describedby', messageSelectors.newWindow);
                }
            });

            generateHTML(messages);
        }
// CONCATENATED MODULE: ./source/scripts/helpers/ScrollLock.js
        function ScrollLock_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

        function ScrollLock_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

        function ScrollLock_createClass(Constructor, protoProps, staticProps) { if (protoProps) ScrollLock_defineProperties(Constructor.prototype, protoProps); if (staticProps) ScrollLock_defineProperties(Constructor, staticProps); return Constructor; }

        var _document = document,
                body = _document.body;
        var ScrollLock_html = document.querySelector('html');

        function _blockScroll(event) {
            // Only block events that occur outside the modal
            if (event.target.closest('.allow-scroll-while-locked')) return;
            event.preventDefault();
            event.stopPropagation();
        }

        var ScrollLock = /*#__PURE__*/function () {
            function ScrollLock() {
                ScrollLock_classCallCheck(this, ScrollLock);
            }

            ScrollLock_createClass(ScrollLock, null, [{
                key: "lock",

                /**
                 * Prevents all scrolling of the document
                 * @param {HTMLElement} modal Element within which scrolling is allowed
                 */
                value: function lock(modal) {
                    if (modal) {
                        modal.classList.add('allow-scroll-while-locked');
                    }

                    ScrollLock_html.classList.add('scroll-locked');
                    body.style.top = -1 * window.pageYOffset;
                    body.addEventListener('scroll', _blockScroll, false);
                    body.addEventListener('touchmove', _blockScroll, {
                        passive: false
                    });
                }
                /**
                 * Removes scroll lock
                 */

            }, {
                key: "unlock",
                value: function unlock() {
                    document.querySelectorAll('.allow-scroll-while-locked').forEach(function (modal) {
                        return modal.classList.remove('allow-scroll-while-locked');
                    });
                    ScrollLock_html.classList.remove('scroll-locked');
                    body.style.top = '';
                    body.removeEventListener('scroll', _blockScroll, false);
                    body.removeEventListener('touchmove', _blockScroll, {
                        passive: false
                    });
                }
            }, {
                key: "isLocked",
                get: function get() {
                    return ScrollLock_html.classList.contains('scroll-locked');
                }
            }]);

            return ScrollLock;
        }();


// CONCATENATED MODULE: ./source/scripts/components/Modal.js
        function Modal_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

        function Modal_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Modal_ownKeys(Object(source), true).forEach(function (key) { Modal_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Modal_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

        function Modal_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

        function Modal_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

        function Modal_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

        function Modal_createClass(Constructor, protoProps, staticProps) { if (protoProps) Modal_defineProperties(Constructor.prototype, protoProps); if (staticProps) Modal_defineProperties(Constructor, staticProps); return Constructor; }






        var openModals = [];

        var Modal_unlockScrollLock = function unlockScrollLock() {
            if (openModals.length === 0) {
                ScrollLock.unlock();
            }
        };

        var Modal_Modal = /*#__PURE__*/function () {
            function Modal() {
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                Modal_classCallCheck(this, Modal);

                this.$body = jquery_default()(document.body);
                this.$window = jquery_default()(window); // Extend default vanilla-modal callbacks back to instantiator of Modal

                var defaultOptions = {
                    onOpen: function onOpen() {},
                    onClose: function onClose() {},
                    onBeforeOpen: function onBeforeOpen() {},
                    onBeforeClose: function onBeforeClose() {},
                    modalId: null
                };
                this.options = Modal_objectSpread(Modal_objectSpread({}, defaultOptions), options);
                var modalSelector = this.options.modalId ? "[data-modal-container-".concat(this.options.modalId, "]") : '[data-modal-container]';
                var closeSelector = this.options.modalId ? "[data-modal-".concat(this.options.modalId, "-close") : '[data-modal-close]';
                this.loadedClass = this.options.modalId ? "modal-".concat(this.options.modalId, "-loaded") : 'modal-loaded';
                this.visibleClass = this.options.modalId ? "modal-".concat(this.options.modalId, "-visible") : 'modal-visible';
                this.modal = null;
                this.$modal = jquery_default()(modalSelector);
                this.$modalInner = this.$modal.find('[data-modal-inner]');
                this.finishedLoading = this.finishedLoading.bind(this);
                this._onOpen = this._onOpen.bind(this);
                this._onBeforeOpen = this._onBeforeOpen.bind(this);
                this._onClose = this._onClose.bind(this);
                this._onBeforeClose = this._onBeforeClose.bind(this);
                this._closeEsc = this._closeEsc.bind(this);
                this.position = this.position.bind(this);
                this.modalOptions = {
                    modal: modalSelector,
                    loadClass: '',
                    class: this.loadedClass,
                    close: closeSelector,
                    onOpen: this._onOpen,
                    onClose: this._onClose,
                    onBeforeOpen: this._onBeforeOpen,
                    onBeforeClose: this._onBeforeClose,
                    transitions: false,
                    closeKeys: [] // Override default "close on esc" so we have control

                };
            }

            Modal_createClass(Modal, [{
                key: "unload",
                value: function unload() {
                    var _this = this;

                    if (!this.modal) return;
                    this.modal.destroy();
                    openModals = openModals.filter(function (modal) {
                        return modal !== _this;
                    });
                    Modal_unlockScrollLock();
                }
                /**
                 * Open a modal with contents from selector
                 *
                 * @param selector
                 * @param handle
                 */

            }, {
                key: "open",
                value: function open(selector) {
                    var handle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'general';

                    this._addModalClass(handle);

                    this.modal = new vanilla_modal_dist_default.a(this.modalOptions);
                    this.modal.open(selector);
                    openModals.push(this);
                    window.addEventListener('keydown', this._closeEsc);
                }
            }, {
                key: "close",
                value: function close() {
                    this.modal.close();
                    window.removeEventListener('keydown', this._closeEsc);
                }
            }, {
                key: "finishedLoading",
                value: function finishedLoading() {
                    trapFocus(this.$modal[0]);
                }
            }, {
                key: "_closeEsc",
                value: function _closeEsc(e) {
                    if (e.key === 'Escape' && openModals[openModals.length - 1] === this) {
                        this.close();
                    }
                }
            }, {
                key: "isOpen",
                value: function isOpen() {
                    return this.modal && this.modal.isOpen;
                }
                /**
                 * Update the vertical positioning of modal
                 */

            }, {
                key: "position",
                value: function position() {
                    var windowHeight = window.innerHeight;
                    var modalHeight = this.$modalInner.outerHeight();
                    var modalPadding = parseInt(this.$modal.css('padding-top'), 10) * 2;
                    var offset = (windowHeight - modalPadding - modalHeight) / 2;
                    var marginTop = offset > 0 ? offset : 0;
                    this.$modalInner.css({
                        marginTop: marginTop
                    });
                }
                /**
                 * Add a class to the modal for individual styling
                 * @param handle
                 * @private
                 */

            }, {
                key: "_addModalClass",
                value: function _addModalClass(handle) {
                    this.$modal.addClass("modal--".concat(handle));
                }
                /**
                 * Remove modal class based on the handle
                 * @private
                 */

            }, {
                key: "_removeModalClass",
                value: function _removeModalClass() {
                    var modalClass = this.$modal.attr('class').match(/modal--[\w-]*\b/);

                    if (!modalClass) {
                        return;
                    }

                    this.$modal.removeClass(modalClass[0]);
                }
            }, {
                key: "_onClose",
                value: function _onClose() {
                    var _this2 = this;

                    this._removeModalClass();

                    this.$body.removeClass(this.visibleClass);
                    this.$window.off('resize.modal');
                    this.$modalInner.css({
                        marginTop: ''
                    });
                    this.options.onClose();
                    removeTrapFocus(this.$modal[0]);

                    if (this.activeElement) {
                        // Ensure focus is properly re-trapped in the case when modal was
                        // opened from another modal
                        var focusTrap = this.activeElement.closest('[data-trap-focus]');

                        if (focusTrap) {
                            trapFocus(focusTrap);
                        }

                        this.activeElement.focus();
                    }

                    openModals = openModals.filter(function (modal) {
                        return modal !== _this2;
                    });
                    Modal_unlockScrollLock();
                }
            }, {
                key: "_onOpen",
                value: function _onOpen() {
                    var _this3 = this;

                    this.activeElement = document.activeElement;
                    this.position();
                    ScrollLock.lock(this.$modal[0]);
                    this.$body.addClass(this.visibleClass);
                    this.$window.on('resize.modal', just_debounce_default()(function () {
                        return _this3.position();
                    }, 16, true, true));
                    this.options.onOpen();
                    trapFocus(this.$modal[0]);
                }
            }, {
                key: "_onBeforeClose",
                value: function _onBeforeClose() {
                    this.options.onBeforeClose();
                }
            }, {
                key: "_onBeforeOpen",
                value: function _onBeforeOpen() {
                    this.options.onBeforeOpen();
                }
            }]);

            return Modal;
        }();


// CONCATENATED MODULE: ./node_modules/shopify-variants/dist/shopify-variants.es.js

        /*!
         * shopify-variants v1.4.1
         * (c) 2019 Pixel Union
         */



        function shopify_variants_es_classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
                throw new TypeError("Cannot call a class as a function");
            }
        }

        function shopify_variants_es_defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }

        function shopify_variants_es_createClass(Constructor, protoProps, staticProps) {
            if (protoProps) shopify_variants_es_defineProperties(Constructor.prototype, protoProps);
            if (staticProps) shopify_variants_es_defineProperties(Constructor, staticProps);
            return Constructor;
        }

        function shopify_variants_es_toConsumableArray(arr) {
            return shopify_variants_es_arrayWithoutHoles(arr) || shopify_variants_es_iterableToArray(arr) || shopify_variants_es_nonIterableSpread();
        }

        function shopify_variants_es_arrayWithoutHoles(arr) {
            if (Array.isArray(arr)) {
                for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

                return arr2;
            }
        }

        function shopify_variants_es_iterableToArray(iter) {
            if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
        }

        function shopify_variants_es_nonIterableSpread() {
            throw new TypeError("Invalid attempt to spread non-iterable instance");
        }

        var Node =
                /*#__PURE__*/
                function () {
                    function Node(variant) {
                        shopify_variants_es_classCallCheck(this, Node);

                        this.variant = variant;
                        this.optionsCount = this.variant.options.length;
                        this.neighbors = [];

                        for (var i = 0; i < this.optionsCount; i++) {
                            this.neighbors.push([]);
                        }
                    }

                    shopify_variants_es_createClass(Node, [{
                        key: "addNeighbor",
                        value: function addNeighbor(variant) {
                            for (var i = 0; i < this.optionsCount; i++) {
                                if (this.variant.options[i] !== variant.options[i]) {
                                    this.neighbors[i].push(variant);
                                    break;
                                }
                            }
                        }
                    }, {
                        key: "getValidOptions",
                        value: function getValidOptions() {
                            var _this = this;

                            var options = [];

                            var _loop = function _loop(i) {
                                var variants = [_this.variant].concat(shopify_variants_es_toConsumableArray(_this.neighbors[i]));
                                options[i] = {};
                                variants.forEach(function (item) {
                                    var variant = item;
                                    var option = variant.options[i];
                                    options[i][option] = {
                                        available: options[i][option] && options[i][option].available || variant.available
                                    };
                                });
                            };

                            for (var i = 0; i < this.optionsCount; i++) {
                                _loop(i);
                            }

                            return options;
                        }
                    }]);

                    return Node;
                }();

        function getVariantFromOptions(variants, options) {
            var variant = null;
            variants.forEach(function (potentialVariant) {
                var found = true;

                for (var i = 0; i < potentialVariant.options.length; i++) {
                    if (options[i] !== potentialVariant.options[i]) {
                        found = false;
                    }
                }

                if (found) {
                    variant = potentialVariant;
                }
            });
            return variant || false;
        }

        function getClosestVariantFromOptions(variants, options) {
            var closestVariant = null;
            var matchingValues = 0;
            variants.forEach(function (variant) {
                var tempMatchingValues = 0;

                for (var i = 0; i < variant.options.length; i++) {
                    if (options[i] === variant.options[i]) {
                        tempMatchingValues++;
                    } else {
                        break;
                    }
                }

                if (tempMatchingValues >= matchingValues) {
                    closestVariant = variant;
                    matchingValues = tempMatchingValues;
                }
            });
            return closestVariant || false;
        }

        function getVariantOrClosestFromOptions(variants, options) {
            return getVariantFromOptions(variants, options) || getClosestVariantFromOptions(variants, options);
        }

        function getAvailableOptionsFromVariant(variants, variant) {
            var nodeMap = {};
            variants.forEach(function (v) {
                nodeMap[v.id] = new Node(v);
                variants.forEach(function (v2) {
                    nodeMap[v.id].addNeighbor(v2);
                });
            });
            return nodeMap[variant.id].getValidOptions();
        }

        var shopify_variants_es_Variants =
                /*#__PURE__*/
                function () {
                    function Variants(product, $variants, $options, config) {
                        var _this = this;

                        shopify_variants_es_classCallCheck(this, Variants);

                        var defaultConfig = {
                            disableUnavailableVariants: true,
                            switchCallback: function switchCallback() {},
                            mixedControls: false,
                            optionDataAttribute: 'data-product-option'
                        };
                        this.optionsTypes = {
                            select: 'select',
                            radio: 'input[type="radio"]'
                        };
                        this.events = [];
                        this.product = product;
                        this.optionsCount = this.product.options.length;
                        this.variants = $variants.get(0);
                        this.options = $options.get();
                        this.selectOptions = this.options.filter(function (option) {
                            return option.matches(_this.optionsTypes.select);
                        });
                        this.radioOptions = this.options.filter(function (option) {
                            return option.matches(_this.optionsTypes.radio);
                        });
                        this.config = jquery_default.a.extend(defaultConfig, config);

                        if (this.selectOptions.length === 0 && this.radioOptions.length === 0) {
                            console.warn('Shopify Variants: Option set is not a valid type');
                        }

                        this._bindEvents();

                        this._switchVariant(this._getSelectedOptions(), true);
                    }

                    shopify_variants_es_createClass(Variants, [{
                        key: "isDefault",
                        value: function isDefault() {
                            return this.product.variants[0].public_title === null;
                        }
                    }, {
                        key: "getSelectedVariant",
                        value: function getSelectedVariant() {
                            if (this.isDefault()) {
                                return this.product.variants[0];
                            }

                            return getVariantFromOptions(this.product.variants, this._getSelectedOptions());
                        }
                    }, {
                        key: "unload",
                        value: function unload() {
                            this._unbindEvents();
                        }
                    }, {
                        key: "_bindEvents",
                        value: function _bindEvents() {
                            var _this2 = this;

                            for (var i = 0; i < this.options.length; i++) {
                                var option = this.options[i];

                                var fn = function fn(event) {
                                    var target = event.target;

                                    if (_this2.config.mixedControls) {
                                        _this2._switchVariant(_this2._getSelectedOptionsMixed());
                                    } else if (target.matches(_this2.optionsTypes.select)) {
                                        _this2._switchVariant(_this2._getSelectedOptionsSelect());
                                    } else if (target.matches(_this2.optionsTypes.radio)) {
                                        _this2._switchVariant(_this2._getSelectedOptionsRadio());
                                    }
                                };

                                option.addEventListener('change', fn);
                                this.events.push({
                                    el: option,
                                    fn: fn
                                });
                            }
                        }
                    }, {
                        key: "_unbindEvents",
                        value: function _unbindEvents() {
                            this.events.forEach(function (_ref) {
                                var el = _ref.el,
                                        fn = _ref.fn;
                                return el.removeEventListener('change', fn);
                            });
                        }
                    }, {
                        key: "_getSelectedOptions",
                        value: function _getSelectedOptions() {
                            // Note that we only support 1 mixed set of controls, or multiple complete sets
                            // of selects and/or radios but not multiple mixed sets.
                            if (this.config.mixedControls) {
                                return this._getSelectedOptionsMixed();
                            } // If multiple complete sets are present, we can can/do assume that all controls
                            // are in sync, because shopify-variants keeps them that way.


                            if (this.selectOptions.length > 0) {
                                return this._getSelectedOptionsSelect();
                            }

                            if (this.radioOptions.length > 0) {
                                return this._getSelectedOptionsRadio();
                            }

                            return [];
                        }
                    }, {
                        key: "_getSelectedOptionsMixed",
                        value: function _getSelectedOptionsMixed() {
                            var options = [];
                            this.selectOptions.forEach(function (option) {
                                var optionNumber = parseInt(option.dataset.productOption, 10);
                                options[optionNumber] = option.value;
                            });
                            this.radioOptions.forEach(function (option) {
                                if (jquery_default()(option).is(':checked')) {
                                    var optionNumber = parseInt(option.dataset.productOption, 10);
                                    options[optionNumber] = option.value;
                                }
                            });
                            return options;
                        }
                    }, {
                        key: "_getSelectedOptionsSelect",
                        value: function _getSelectedOptionsSelect() {
                            var options = [];

                            for (var i = 0; i < this.selectOptions.length; i++) {
                                var option = this.selectOptions[i];
                                options.push(option.value);
                            }

                            return options;
                        }
                    }, {
                        key: "_getSelectedOptionsRadio",
                        value: function _getSelectedOptionsRadio() {
                            var options = [];

                            for (var i = 0; i < this.radioOptions.length; i++) {
                                var option = this.radioOptions[i];

                                if (option.checked) {
                                    options.push(option.value);
                                }
                            }

                            return options;
                        }
                    }, {
                        key: "selectVariant",
                        value: function selectVariant(id) {
                            var targetVariant = this.product.variants.filter(function (variant) {
                                return variant.id === id;
                            })[0];

                            if (targetVariant) {
                                this._switchVariant(targetVariant.options);
                            }
                        }
                    }, {
                        key: "_switchVariant",
                        value: function _switchVariant() {
                            var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this._getSelectedOptions();
                            var firstLoad = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                            var product = this.product;
                            var variant = null;
                            var availableOptions = null;
                            variant = getVariantOrClosestFromOptions(product.variants, options);

                            if (!variant) {
                                return;
                            }

                            availableOptions = getAvailableOptionsFromVariant(product.variants, variant);

                            this._switchVariantSelect(variant, availableOptions);

                            this._switchVariantRadio(variant, availableOptions);

                            this.variants.value = variant.id; // Trigger event, IE11 compatible but could be deprecated in the future

                            var event = document.createEvent('Event');
                            event.initEvent('change', true, false);
                            this.variants.dispatchEvent(event);
                            var data = {
                                product: product,
                                variant: variant,
                                firstLoad: firstLoad
                            };
                            this.config.switchCallback(data);
                            jquery_default()(window).trigger('shopify-variants:switch-variant', data);
                        }
                    }, {
                        key: "_switchVariantSelect",
                        value: function _switchVariantSelect(variant, availableOptions) {
                            if (this.selectOptions.length === 0) {
                                return;
                            } // Iterate over each option type


                            for (var i = 0; i < this.product.options.length; i++) {
                                // Corresponding select dropdown, if it exists
                                var input = null;

                                if (this.config.mixedControls) {
                                    for (var j = 0; j < this.selectOptions.length; j++) {
                                        var option = this.selectOptions[j];

                                        if (option.matches("[".concat(this.config.optionDataAttribute, "=\"").concat(i, "\"]"))) {
                                            input = option;
                                            break;
                                        }
                                    }
                                } else {
                                    // For non-mixed controls, we assume select elements match the order and number of options
                                    input = this.selectOptions[i];
                                }

                                if (input) {
                                    // Iterate over each option on dropdown
                                    var options = input.querySelectorAll('option');

                                    for (var _j = 0; _j < options.length; _j++) {
                                        var _option = options[_j];
                                        var value = _option.value; // Not an available option

                                        _option.disabled = !availableOptions[i][value] || !availableOptions[i][value].available && this.config.disableUnavailableVariants;
                                        _option.selected = false; // Dropdown option matches variant option

                                        if (variant.options[i] === value) {
                                            _option.disabled = false;
                                            _option.selected = true;
                                        }
                                    }
                                }
                            }
                        }
                    }, {
                        key: "_switchVariantRadio",
                        value: function _switchVariantRadio(variant, availableOptions) {
                            var _this3 = this;

                            if (this.radioOptions.length === 0) {
                                return;
                            }

                            for (var i = 0; i < this.radioOptions.length; i++) {
                                var option = this.radioOptions[i];
                                option.disabled = true;
                                option.checked = false;
                                option.setAttribute('data-soldout', false);
                            }

                            var _loop = function _loop(_i) {
                                var selector = encodeURIComponent(_this3.product.options[_i]).replace(/%20/g, '+').replace(/[!'()*]/g, function (_char) {
                                    return "%".concat(_char.charCodeAt(0).toString(16).toUpperCase());
                                });

                                var options = _this3.radioOptions.filter(function (option) {
                                    return option.matches("[name=\"".concat(selector, "\"]"));
                                });

                                for (var j = 0; j < options.length; j++) {
                                    var _option2 = options[j];

                                    if (variant.options[_i] === _option2.value) {
                                        _option2.checked = true;
                                    }

                                    if (availableOptions[_i][_option2.value]) {
                                        _option2.disabled = false;

                                        if (!availableOptions[_i][_option2.value].available && _this3.config.disableUnavailableVariants) {
                                            _option2.disabled = true;

                                            _option2.setAttribute('data-soldout', true);
                                        }
                                    }
                                }
                            };

                            for (var _i = 0; _i < this.product.options.length; _i++) {
                                _loop(_i);
                            }
                        }
                    }]);

                    return Variants;
                }();

        /* harmony default export */ var shopify_variants_es = (shopify_variants_es_Variants);

// CONCATENATED MODULE: ./node_modules/@pixelunion/shopify-surface-pick-up/dist/index.es.js
        function dist_index_es_classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
                throw new TypeError("Cannot call a class as a function");
            }
        }

        function dist_index_es_defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }

        function dist_index_es_createClass(Constructor, protoProps, staticProps) {
            if (protoProps) dist_index_es_defineProperties(Constructor.prototype, protoProps);
            if (staticProps) dist_index_es_defineProperties(Constructor, staticProps);
            return Constructor;
        }

        function dist_index_es_defineProperty(obj, key, value) {
            if (key in obj) {
                Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                });
            } else {
                obj[key] = value;
            }

            return obj;
        }

        function dist_index_es_ownKeys(object, enumerableOnly) {
            var keys = Object.keys(object);

            if (Object.getOwnPropertySymbols) {
                var symbols = Object.getOwnPropertySymbols(object);
                if (enumerableOnly) symbols = symbols.filter(function (sym) {
                    return Object.getOwnPropertyDescriptor(object, sym).enumerable;
                });
                keys.push.apply(keys, symbols);
            }

            return keys;
        }

        function index_es_objectSpread2(target) {
            for (var i = 1; i < arguments.length; i++) {
                var source = arguments[i] != null ? arguments[i] : {};

                if (i % 2) {
                    dist_index_es_ownKeys(Object(source), true).forEach(function (key) {
                        dist_index_es_defineProperty(target, key, source[key]);
                    });
                } else if (Object.getOwnPropertyDescriptors) {
                    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
                } else {
                    dist_index_es_ownKeys(Object(source)).forEach(function (key) {
                        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
                    });
                }
            }

            return target;
        }

        var LOCAL_STORAGE_KEY = 'pxu-shopify-surface-pick-up';
        var loadingClass = 'surface-pick-up--loading';

        var isNotExpired = function isNotExpired(timestamp) {
            return timestamp + 1000 * 60 * 60 <= Date.now();
        };

        var removeTrailingSlash = function removeTrailingSlash(s) {
            return s.replace(/(.*)\/$/, '$1');
        }; // Haversine Distance
// The haversine formula is an equation giving great-circle distances between
// two points on a sphere from their longitudes and latitudes


        var calculateDistance = function calculateDistance(latitude1, longitude1, latitude2, longitude2, unitSystem) {
            var dtor = Math.PI / 180;
            var radius = unitSystem === 'metric' ? 6378.14 : 3959;
            var rlat1 = latitude1 * dtor;
            var rlong1 = longitude1 * dtor;
            var rlat2 = latitude2 * dtor;
            var rlong2 = longitude2 * dtor;
            var dlon = rlong1 - rlong2;
            var dlat = rlat1 - rlat2;
            var a = Math.pow(Math.sin(dlat / 2), 2) + Math.cos(rlat1) * Math.cos(rlat2) * Math.pow(Math.sin(dlon / 2), 2);
            var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
            return radius * c;
        };

        var getGeoLocation = function getGeoLocation() {
            return new Promise(function (resolve, reject) {
                var options = {
                    maximumAge: 3600000,
                    // 1 hour
                    timeout: 5000
                };

                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(function (_ref) {
                        var coords = _ref.coords;
                        return resolve(coords);
                    }, reject, options);
                } else {
                    reject();
                }
            });
        };

        var index_es_location = null;

        var setLocation = function setLocation(_ref2) {
            var latitude = _ref2.latitude,
                    longitude = _ref2.longitude;
            return new Promise(function (resolve) {
                var cachedLocation = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY));
                var newData = {
                    latitude: latitude,
                    longitude: longitude,
                    timestamp: Date.now()
                };
                index_es_location = newData;
                localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(newData));

                if (cachedLocation !== null && cachedLocation.latitude === latitude && cachedLocation.longitude === longitude // Valid for 1 hour - per Debut's example
                        && isNotExpired(cachedLocation.timestamp)) {
                    resolve({
                        latitude: latitude,
                        longitude: longitude
                    });
                    return;
                }

                fetch('/localization.json', {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        latitude: latitude,
                        longitude: longitude
                    })
                }).then(function () {
                    return resolve({
                        latitude: latitude,
                        longitude: longitude
                    });
                });
            });
        };

        var getLocation = function getLocation() {
            return new Promise(function (resolve) {
                if (index_es_location && isNotExpired(index_es_location.timestamp)) {
                    resolve(index_es_location);
                    return;
                }

                resolve(getGeoLocation().then(setLocation));
            });
        };

        var SurfacePickUp = /*#__PURE__*/function () {
            function SurfacePickUp(el, options) {
                dist_index_es_classCallCheck(this, SurfacePickUp);

                this.el = el;
                this.options = index_es_objectSpread2({
                    root_url: window.Theme && window.Theme.routes && window.Theme.routes.root_url || ''
                }, options);
                this.options.root_url = removeTrailingSlash(this.options.root_url);
                this.callbacks = [];
                this.onBtnPress = null;
                this.latestVariantId = null;
                this.pickUpEnabled = localStorage.getItem(LOCAL_STORAGE_KEY) !== null;
            }

            dist_index_es_createClass(SurfacePickUp, [{
                key: "load",
                value: function load(variantId) {
                    var _this = this;

                    // Because Shopify doesn't expose any `pick_up_enabled` data on the shop object, we
                    // don't know if the variant might be, or is definitely not available for pick up.
                    // Until we know the shop has > 0 pick up locations, we want to avoid prompting the
                    // user for location data (it's annoying, and only makes sense to do if we use it).
                    //
                    // Instead, we have to make an initial request, check and see if any pick up locations
                    // were returned, then ask for the users location, then make another request to get the
                    // location-aware pick up locations.
                    //
                    // As far as I can tell the pick up aware locations differ only in sort order - which
                    // we could do on the front end - but we're following this approach to ensure future
                    // compatibility with any changes Shopify makes (maybe disabling options based on
                    // user location, or whatever else).
                    //
                    // Shopify has indicated they will look into adding pick_up_enabled data to the shop
                    // object, which which case this method can be greatly simplifed into 2 simple cases.
                    this.latestVariantId = variantId;

                    var getLocationThenInjectData = function getLocationThenInjectData() {
                        return getLocation() // If we get a location, inject data using that location
                                .then(function (coords) {
                                    return _this._getData(variantId).then(function (data) {
                                        return _this._injectData(data, coords);
                                    });
                                }) // Otherwise, inject data without location
                                ["catch"](function () {
                            return _this._getData(variantId).then(function (data) {
                                return _this._injectData(data, null);
                            });
                        });
                    };

                    this.el.classList.add(loadingClass); // If we've previously seen some pick up locations we know this variant may be available
                    // for pick up, so we request browser location data.

                    if (this.pickUpEnabled) {
                        return getLocationThenInjectData();
                    }

                    return this._getData(variantId).then(function (data) {
                        if (data.items.length > 0) {
                            _this.pickUpEnabled = true; // Inject initial data - the store displayed may not be the closest, since it was
                            // determined by IP geolocation, instead of browser side location. But better
                            // than nothing.

                            _this._injectData(data, null); // Then get browser location and go through the process again with the new location
                            // data. Any subsequent variants will skip the initial request and go
                            // directly to the browser based location data.


                            return getLocationThenInjectData();
                        } // If there are no items (pick up locations), just inject the (empty) data and return.
                        // We will continue to check for pick up locations on any new variants, since depending
                        // on product availability, the first product may have no pick up locations even if the
                        // store does have some.


                        return _this._injectData(data, null);
                    });
                }
            }, {
                key: "onModalRequest",
                value: function onModalRequest(callback) {
                    if (this.callbacks.indexOf(callback) >= 0) return;
                    this.callbacks.push(callback);
                }
            }, {
                key: "offModalRequest",
                value: function offModalRequest(callback) {
                    this.callbacks.splice(this.callbacks.indexOf(callback));
                }
            }, {
                key: "unload",
                value: function unload() {
                    this.callbacks = [];
                    this.el.innerHTML = '';
                }
            }, {
                key: "_getData",
                value: function _getData(variantId) {
                    var _this2 = this;

                    return new Promise(function (resolve) {
                        var xhr = new XMLHttpRequest();
                        var requestUrl = "".concat(_this2.options.root_url, "/variants/").concat(variantId, "/?section_id=surface-pick-up");
                        xhr.open('GET', requestUrl, true);

                        xhr.onload = function () {
                            var el = xhr.response;
                            var embed = el.querySelector('[data-html="surface-pick-up-embed"]');
                            var itemsContainer = el.querySelector('[data-html="surface-pick-up-items"]');
                            var items = itemsContainer.content.querySelectorAll('[data-surface-pick-up-item]');
                            resolve({
                                embed: embed,
                                itemsContainer: itemsContainer,
                                items: items,
                                variantId: variantId
                            });
                        };

                        xhr.onerror = function () {
                            resolve({
                                embed: {
                                    innerHTML: ''
                                },
                                itemsContainer: {
                                    innerHTML: ''
                                },
                                items: [],
                                variantId: variantId
                            });
                        };

                        xhr.responseType = 'document';
                        xhr.send();
                    });
                }
            }, {
                key: "_injectData",
                value: function _injectData(_ref3, userCoords) {
                    var _this3 = this;

                    var embed = _ref3.embed,
                            itemsContainer = _ref3.itemsContainer,
                            items = _ref3.items,
                            variantId = _ref3.variantId;

                    if (variantId !== this.latestVariantId) {
                        return null;
                    }

                    this.el.innerHTML = embed.innerHTML;
                    this.el.classList.remove(loadingClass);

                    if (items.length === 0) {
                        return this.el;
                    }

                    var processedDistances = false;

                    var processDistances = function processDistances() {
                        if (processedDistances) return;
                        processedDistances = true;
                        items.forEach(function (item) {
                            var distanceEl = item.querySelector('[data-distance]');
                            var distanceUnitEl = item.querySelector('[data-distance-unit]');
                            var unitSystem = distanceUnitEl.dataset.distanceUnit;
                            var itemLatitude = parseFloat(distanceEl.dataset.latitude);
                            var itemLongitude = parseFloat(distanceEl.dataset.longitude);

                            if (userCoords && isFinite(itemLatitude) && isFinite(itemLongitude)) {
                                var distance = calculateDistance(userCoords.latitude, userCoords.longitude, itemLatitude, itemLongitude, unitSystem);
                                distanceEl.innerHTML = distance.toFixed(1);
                            } else {
                                distanceEl.remove();
                                distanceUnitEl.remove();
                            }
                        });
                    };

                    this.el.querySelector('[data-surface-pick-up-embed-modal-btn]').addEventListener('click', function () {
                        processDistances();

                        _this3.callbacks.forEach(function (callback) {
                            return callback(itemsContainer.innerHTML);
                        });
                    });
                    return this.el;
                }
            }]);

            return SurfacePickUp;
        }();

        /* harmony default export */ var shopify_surface_pick_up_dist_index_es = (SurfacePickUp);

// CONCATENATED MODULE: ./source/scripts/components/MessageBanner.js
        function MessageBanner_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

        function MessageBanner_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

        function MessageBanner_createClass(Constructor, protoProps, staticProps) { if (protoProps) MessageBanner_defineProperties(Constructor.prototype, protoProps); if (staticProps) MessageBanner_defineProperties(Constructor, staticProps); return Constructor; }





        var MessageBanner_MessageBanner = /*#__PURE__*/function () {
            function MessageBanner(message, type) {
                var _this = this;

                MessageBanner_classCallCheck(this, MessageBanner);

                var bannerTemplate = document.querySelector('[data-templates] [data-message-banner]');
                this.banner = bannerTemplate.cloneNode(true);
                var messageElement = this.banner.querySelector('[data-message-banner-content]');
                messageElement.innerHTML = message;
                this.banner.classList.add("message--".concat(type));
                this.header = document.querySelector('[data-site-header]');
                this.closeButton = this.banner.querySelector('[data-message-banner-close]');
                this.header.appendChild(this.banner);
                this.bannerAnimation = transition({
                    el: this.banner,
                    state: 'closed'
                });
                this.bannerAnimation.animateTo('open');
                this.events = new EventHandler_default.a();
                this.events.register(this.closeButton, 'click', function () {
                    return _this._close();
                });
                this.events.register(document, 'click', function (e) {
                    return _this._handleDocumentClick(e.target);
                });
                this.events.register(document, 'touchStart', function (e) {
                    return _this._handleDocumentClick(e.target);
                });
                this.events.register(window, 'keydown', function (e) {
                    return _this._closeEsc(e);
                });
            }

            MessageBanner_createClass(MessageBanner, [{
                key: "unload",
                value: function unload() {
                    if (this.banner) {
                        this._close();
                    }
                }
            }, {
                key: "_closeEsc",
                value: function _closeEsc(e) {
                    if (e.key === 'Escape') {
                        this._close();
                    }
                }
            }, {
                key: "_close",
                value: function _close() {
                    var _this2 = this;

                    this.bannerAnimation.animateTo('closed').then(function () {
                        _this2.banner.remove();

                        _this2.banner = null;

                        _this2.events.unregisterAll();

                        _this2.bannerAnimation.unload();
                    });
                }
            }, {
                key: "_handleDocumentClick",
                value: function _handleDocumentClick(target) {
                    var $parent = jquery_default()(target).parents('[data-message-banner]');
                    if ($parent.length) return;

                    this._close();
                }
            }]);

            return MessageBanner;
        }();


// CONCATENATED MODULE: ./source/scripts/helpers/Images.js
        function Images_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

        function Images_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

        function Images_createClass(Constructor, protoProps, staticProps) { if (protoProps) Images_defineProperties(Constructor.prototype, protoProps); if (staticProps) Images_defineProperties(Constructor, staticProps); return Constructor; }

        var Images = /*#__PURE__*/function () {
            function Images() {
                Images_classCallCheck(this, Images);
            }

            Images_createClass(Images, [{
                key: "preload",

                /**
                 * Preloads an image in memory and uses the browsers cache to store it until needed.
                 *
                 * @param {Array} images - A list of image urls
                 * @param {String} size - A shopify image size attribute
                 */
                value: function preload(images, size) {
                    var imageArray = images;

                    if (typeof images === 'string') {
                        imageArray = [images];
                    }

                    for (var i = 0; i < imageArray.length; i++) {
                        this.loadImage(this.getSizedImageUrl(imageArray[i], size));
                    }
                }
                /**
                 * Loads and caches an image in the browsers cache.
                 *
                 * @param {string} path - An image url
                 */

            }, {
                key: "loadImage",
                value: function loadImage(path) {
                    var image = new Image();
                    image.src = path;
                    return image;
                }
                /**
                 * Adds a Shopify size attribute to a URL
                 *
                 * @param src
                 * @param size
                 * @returns {*}
                 */

            }, {
                key: "getSizedImageUrl",
                value: function getSizedImageUrl() {
                    var src = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
                    var size = arguments.length > 1 ? arguments[1] : undefined;

                    if (!size) {
                        return null;
                    }

                    if (size === 'master') {
                        return this.removeProtocol(src);
                    }

                    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

                    if (match) {
                        var prefix = src.split(match[0]);
                        var suffix = match[0];
                        return this.removeProtocol("".concat(prefix[0], "_").concat(size).concat(suffix));
                    }

                    console.warn("No ".concat(size, " found for '").concat(src));
                    return null;
                }
            }, {
                key: "removeProtocol",
                value: function removeProtocol(path) {
                    return path.replace(/http(s)?:/, '');
                }
            }]);

            return Images;
        }();


// CONCATENATED MODULE: ./node_modules/tslib/tslib.es6.js
        /*! *****************************************************************************
         Copyright (c) Microsoft Corporation. All rights reserved.
         Licensed under the Apache License, Version 2.0 (the "License"); you may not use
         this file except in compliance with the License. You may obtain a copy of the
         License at http://www.apache.org/licenses/LICENSE-2.0

         THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
         KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
         WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
         MERCHANTABLITY OR NON-INFRINGEMENT.

         See the Apache Version 2.0 License for specific language governing permissions
         and limitations under the License.
         ***************************************************************************** */
        /* global Reflect, Promise */

        var extendStatics = function(d, b) {
            extendStatics = Object.setPrototypeOf ||
                    ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
                    function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
            return extendStatics(d, b);
        };

        function __extends(d, b) {
            extendStatics(d, b);
            function __() { this.constructor = d; }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        }

        var __assign = function() {
            __assign = Object.assign || function __assign(t) {
                        for (var s, i = 1, n = arguments.length; i < n; i++) {
                            s = arguments[i];
                            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                        }
                        return t;
                    }
            return __assign.apply(this, arguments);
        }

        function __rest(s, e) {
            var t = {};
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
                t[p] = s[p];
            if (s != null && typeof Object.getOwnPropertySymbols === "function")
                for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
                    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                        t[p[i]] = s[p[i]];
                }
            return t;
        }

        function __decorate(decorators, target, key, desc) {
            var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
            if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
            else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
            return c > 3 && r && Object.defineProperty(target, key, r), r;
        }

        function __param(paramIndex, decorator) {
            return function (target, key) { decorator(target, key, paramIndex); }
        }

        function __metadata(metadataKey, metadataValue) {
            if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
        }

        function __awaiter(thisArg, _arguments, P, generator) {
            function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
            return new (P || (P = Promise))(function (resolve, reject) {
                function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
                function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
                function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
                step((generator = generator.apply(thisArg, _arguments || [])).next());
            });
        }

        function __generator(thisArg, body) {
            var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
            return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
            function verb(n) { return function (v) { return step([n, v]); }; }
            function step(op) {
                if (f) throw new TypeError("Generator is already executing.");
                while (_) try {
                    if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                    if (y = 0, t) op = [op[0] & 2, t.value];
                    switch (op[0]) {
                        case 0: case 1: t = op; break;
                        case 4: _.label++; return { value: op[1], done: false };
                        case 5: _.label++; y = op[1]; op = [0]; continue;
                        case 7: op = _.ops.pop(); _.trys.pop(); continue;
                        default:
                            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                            if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                            if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                            if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                            if (t[2]) _.ops.pop();
                            _.trys.pop(); continue;
                    }
                    op = body.call(thisArg, _);
                } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
                if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
            }
        }

        function __exportStar(m, exports) {
            for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
        }

        function __values(o) {
            var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
            if (m) return m.call(o);
            if (o && typeof o.length === "number") return {
                next: function () {
                    if (o && i >= o.length) o = void 0;
                    return { value: o && o[i++], done: !o };
                }
            };
            throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
        }

        function __read(o, n) {
            var m = typeof Symbol === "function" && o[Symbol.iterator];
            if (!m) return o;
            var i = m.call(o), r, ar = [], e;
            try {
                while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
            }
            catch (error) { e = { error: error }; }
            finally {
                try {
                    if (r && !r.done && (m = i["return"])) m.call(i);
                }
                finally { if (e) throw e.error; }
            }
            return ar;
        }

        function __spread() {
            for (var ar = [], i = 0; i < arguments.length; i++)
                ar = ar.concat(__read(arguments[i]));
            return ar;
        }

        function __spreadArrays() {
            for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
            for (var r = Array(s), k = 0, i = 0; i < il; i++)
                for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
                    r[k] = a[j];
            return r;
        };

        function __await(v) {
            return this instanceof __await ? (this.v = v, this) : new __await(v);
        }

        function __asyncGenerator(thisArg, _arguments, generator) {
            if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
            var g = generator.apply(thisArg, _arguments || []), i, q = [];
            return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
            function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
            function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
            function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
            function fulfill(value) { resume("next", value); }
            function reject(value) { resume("throw", value); }
            function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
        }

        function __asyncDelegator(o) {
            var i, p;
            return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
            function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
        }

        function __asyncValues(o) {
            if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
            var m = o[Symbol.asyncIterator], i;
            return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
            function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
            function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
        }

        function __makeTemplateObject(cooked, raw) {
            if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
            return cooked;
        };

        function __importStar(mod) {
            if (mod && mod.__esModule) return mod;
            var result = {};
            if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
            result.default = mod;
            return result;
        }

        function __importDefault(mod) {
            return (mod && mod.__esModule) ? mod : { default: mod };
        }

        function __classPrivateFieldGet(receiver, privateMap) {
            if (!privateMap.has(receiver)) {
                throw new TypeError("attempted to get private field on non-instance");
            }
            return privateMap.get(receiver);
        }

        function __classPrivateFieldSet(receiver, privateMap, value) {
            if (!privateMap.has(receiver)) {
                throw new TypeError("attempted to set private field on non-instance");
            }
            privateMap.set(receiver, value);
            return value;
        }

// CONCATENATED MODULE: ./node_modules/@material/base/foundation.js
        /**
         * @license
         * Copyright 2016 Google Inc.
         *
         * Permission is hereby granted, free of charge, to any person obtaining a copy
         * of this software and associated documentation files (the "Software"), to deal
         * in the Software without restriction, including without limitation the rights
         * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
         * copies of the Software, and to permit persons to whom the Software is
         * furnished to do so, subject to the following conditions:
         *
         * The above copyright notice and this permission notice shall be included in
         * all copies or substantial portions of the Software.
         *
         * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
         * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
         * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
         * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
         * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
         * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
         * THE SOFTWARE.
         */
        var MDCFoundation = /** @class */ (function () {
            function MDCFoundation(adapter) {
                if (adapter === void 0) { adapter = {}; }
                this.adapter_ = adapter;
            }
            Object.defineProperty(MDCFoundation, "cssClasses", {
                get: function () {
                    // Classes extending MDCFoundation should implement this method to return an object which exports every
                    // CSS class the foundation class needs as a property. e.g. {ACTIVE: 'mdc-component--active'}
                    return {};
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(MDCFoundation, "strings", {
                get: function () {
                    // Classes extending MDCFoundation should implement this method to return an object which exports all
                    // semantic strings as constants. e.g. {ARIA_ROLE: 'tablist'}
                    return {};
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(MDCFoundation, "numbers", {
                get: function () {
                    // Classes extending MDCFoundation should implement this method to return an object which exports all
                    // of its semantic numbers as constants. e.g. {ANIMATION_DELAY_MS: 350}
                    return {};
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(MDCFoundation, "defaultAdapter", {
                get: function () {
                    // Classes extending MDCFoundation may choose to implement this getter in order to provide a convenient
                    // way of viewing the necessary methods of an adapter. In the future, this could also be used for adapter
                    // validation.
                    return {};
                },
                enumerable: true,
                configurable: true
            });
            MDCFoundation.prototype.init = function () {
                // Subclasses should override this method to perform initialization routines (registering events, etc.)
            };
            MDCFoundation.prototype.destroy = function () {
                // Subclasses should override this method to perform de-initialization routines (de-registering events, etc.)
            };
            return MDCFoundation;
        }());

// tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
        /* harmony default export */ var base_foundation = (MDCFoundation);
//# sourceMappingURL=foundation.js.map
// CONCATENATED MODULE: ./node_modules/@material/base/component.js
        /**
         * @license
         * Copyright 2016 Google Inc.
         *
         * Permission is hereby granted, free of charge, to any person obtaining a copy
         * of this software and associated documentation files (the "Software"), to deal
         * in the Software without restriction, including without limitation the rights
         * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
         * copies of the Software, and to permit persons to whom the Software is
         * furnished to do so, subject to the following conditions:
         *
         * The above copyright notice and this permission notice shall be included in
         * all copies or substantial portions of the Software.
         *
         * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
         * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
         * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
         * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
         * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
         * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
         * THE SOFTWARE.
         */


        var component_MDCComponent = /** @class */ (function () {
            function MDCComponent(root, foundation) {
                var args = [];
                for (var _i = 2; _i < arguments.length; _i++) {
                    args[_i - 2] = arguments[_i];
                }
                this.root_ = root;
                this.initialize.apply(this, __spread(args));
                // Note that we initialize foundation here and not within the constructor's default param so that
                // this.root_ is defined and can be used within the foundation class.
                this.foundation_ = foundation === undefined ? this.getDefaultFoundation() : foundation;
                this.foundation_.init();
                this.initialSyncWithDOM();
            }
            MDCComponent.attachTo = function (root) {
                // Subclasses which extend MDCBase should provide an attachTo() method that takes a root element and
                // returns an instantiated component with its root set to that element. Also note that in the cases of
                // subclasses, an explicit foundation class will not have to be passed in; it will simply be initialized
                // from getDefaultFoundation().
                return new MDCComponent(root, new MDCFoundation({}));
            };
            /* istanbul ignore next: method param only exists for typing purposes; it does not need to be unit tested */
            MDCComponent.prototype.initialize = function () {
                var _args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    _args[_i] = arguments[_i];
                }
                // Subclasses can override this to do any additional setup work that would be considered part of a
                // "constructor". Essentially, it is a hook into the parent constructor before the foundation is
                // initialized. Any additional arguments besides root and foundation will be passed in here.
            };
            MDCComponent.prototype.getDefaultFoundation = function () {
                // Subclasses must override this method to return a properly configured foundation class for the
                // component.
                throw new Error('Subclasses must override getDefaultFoundation to return a properly configured ' +
                        'foundation class');
            };
            MDCComponent.prototype.initialSyncWithDOM = function () {
                // Subclasses should override this method if they need to perform work to synchronize with a host DOM
                // object. An example of this would be a form control wrapper that needs to synchronize its internal state
                // to some property or attribute of the host DOM. Please note: this is *not* the place to perform DOM
                // reads/writes that would cause layout / paint, as this is called synchronously from within the constructor.
            };
            MDCComponent.prototype.destroy = function () {
                // Subclasses may implement this method to release any resources / deregister any listeners they have
                // attached. An example of this might be deregistering a resize event from the window object.
                this.foundation_.destroy();
            };
            MDCComponent.prototype.listen = function (evtType, handler, options) {
                this.root_.addEventListener(evtType, handler, options);
            };
            MDCComponent.prototype.unlisten = function (evtType, handler, options) {
                this.root_.removeEventListener(evtType, handler, options);
            };
            /**
             * Fires a cross-browser-compatible custom event from the component root of the given type, with the given data.
             */
            MDCComponent.prototype.emit = function (evtType, evtData, shouldBubble) {
                if (shouldBubble === void 0) { shouldBubble = false; }
                var evt;
                if (typeof CustomEvent === 'function') {
                    evt = new CustomEvent(evtType, {
                        bubbles: shouldBubble,
                        detail: evtData,
                    });
                }
                else {
                    evt = document.createEvent('CustomEvent');
                    evt.initCustomEvent(evtType, shouldBubble, false, evtData);
                }
                this.root_.dispatchEvent(evt);
            };
            return MDCComponent;
        }());

// tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
        /* harmony default export */ var component = (component_MDCComponent);
//# sourceMappingURL=component.js.map
// CONCATENATED MODULE: ./node_modules/@material/dom/events.js
        /**
         * @license
         * Copyright 2019 Google Inc.
         *
         * Permission is hereby granted, free of charge, to any person obtaining a copy
         * of this software and associated documentation files (the "Software"), to deal
         * in the Software without restriction, including without limitation the rights
         * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
         * copies of the Software, and to permit persons to whom the Software is
         * furnished to do so, subject to the following conditions:
         *
         * The above copyright notice and this permission notice shall be included in
         * all copies or substantial portions of the Software.
         *
         * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
         * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
         * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
         * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
         * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
         * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
         * THE SOFTWARE.
         */
        /**
         * Determine whether the current browser supports passive event listeners, and
         * if so, use them.
         */
        function applyPassive(globalObj) {
            if (globalObj === void 0) { globalObj = window; }
            return supportsPassiveOption(globalObj) ?
            { passive: true } :
                    false;
        }
        function supportsPassiveOption(globalObj) {
            if (globalObj === void 0) { globalObj = window; }
            // See
            // https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener
            var passiveSupported = false;
            try {
                var options = {
                    // This function will be called when the browser
                    // attempts to access the passive property.
                    get passive() {
                        passiveSupported = true;
                        return false;
                    }
                };
                var handler = function () { };
                globalObj.document.addEventListener('test', handler, options);
                globalObj.document.removeEventListener('test', handler, options);
            }
            catch (err) {
                passiveSupported = false;
            }
            return passiveSupported;
        }
//# sourceMappingURL=events.js.map
// CONCATENATED MODULE: ./node_modules/@material/dom/ponyfill.js
        /**
         * @license
         * Copyright 2018 Google Inc.
         *
         * Permission is hereby granted, free of charge, to any person obtaining a copy
         * of this software and associated documentation files (the "Software"), to deal
         * in the Software without restriction, including without limitation the rights
         * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
         * copies of the Software, and to permit persons to whom the Software is
         * furnished to do so, subject to the following conditions:
         *
         * The above copyright notice and this permission notice shall be included in
         * all copies or substantial portions of the Software.
         *
         * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
         * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
         * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
         * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
         * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
         * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
         * THE SOFTWARE.
         */
        /**
         * @fileoverview A "ponyfill" is a polyfill that doesn't modify the global prototype chain.
         * This makes ponyfills safer than traditional polyfills, especially for libraries like MDC.
         */
        function closest(element, selector) {
            if (element.closest) {
                return element.closest(selector);
            }
            var el = element;
            while (el) {
                if (matches(el, selector)) {
                    return el;
                }
                el = el.parentElement;
            }
            return null;
        }
        function matches(element, selector) {
            var nativeMatches = element.matches
                    || element.webkitMatchesSelector
                    || element.msMatchesSelector;
            return nativeMatches.call(element, selector);
        }
        /**
         * Used to compute the estimated scroll width of elements. When an element is
         * hidden due to display: none; being applied to a parent element, the width is
         * returned as 0. However, the element will have a true width once no longer
         * inside a display: none context. This method computes an estimated width when
         * the element is hidden or returns the true width when the element is visble.
         * @param {Element} element the element whose width to estimate
         */
        function estimateScrollWidth(element) {
            // Check the offsetParent. If the element inherits display: none from any
            // parent, the offsetParent property will be null (see
            // https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/offsetParent).
            // This check ensures we only clone the node when necessary.
            var htmlEl = element;
            if (htmlEl.offsetParent !== null) {
                return htmlEl.scrollWidth;
            }
            var clone = htmlEl.cloneNode(true);
            clone.style.setProperty('position', 'absolute');
            clone.style.setProperty('transform', 'translate(-9999px, -9999px)');
            document.documentElement.appendChild(clone);
            var scrollWidth = clone.scrollWidth;
            document.documentElement.removeChild(clone);
            return scrollWidth;
        }
//# sourceMappingURL=ponyfill.js.map
// CONCATENATED MODULE: ./node_modules/@material/ripple/constants.js
        /**
         * @license
         * Copyright 2016 Google Inc.
         *
         * Permission is hereby granted, free of charge, to any person obtaining a copy
         * of this software and associated documentation files (the "Software"), to deal
         * in the Software without restriction, including without limitation the rights
         * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
         * copies of the Software, and to permit persons to whom the Software is
         * furnished to do so, subject to the following conditions:
         *
         * The above copyright notice and this permission notice shall be included in
         * all copies or substantial portions of the Software.
         *
         * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
         * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
         * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
         * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
         * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
         * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
         * THE SOFTWARE.
         */
        var cssClasses = {
            // Ripple is a special case where the "root" component is really a "mixin" of sorts,
            // given that it's an 'upgrade' to an existing component. That being said it is the root
            // CSS class that all other CSS classes derive from.
            BG_FOCUSED: 'mdc-ripple-upgraded--background-focused',
            FG_ACTIVATION: 'mdc-ripple-upgraded--foreground-activation',
            FG_DEACTIVATION: 'mdc-ripple-upgraded--foreground-deactivation',
            ROOT: 'mdc-ripple-upgraded',
            UNBOUNDED: 'mdc-ripple-upgraded--unbounded',
        };
        var strings = {
            VAR_FG_SCALE: '--mdc-ripple-fg-scale',
            VAR_FG_SIZE: '--mdc-ripple-fg-size',
            VAR_FG_TRANSLATE_END: '--mdc-ripple-fg-translate-end',
            VAR_FG_TRANSLATE_START: '--mdc-ripple-fg-translate-start',
            VAR_LEFT: '--mdc-ripple-left',
            VAR_TOP: '--mdc-ripple-top',
        };
        var numbers = {
            DEACTIVATION_TIMEOUT_MS: 225,
            FG_DEACTIVATION_MS: 150,
            INITIAL_ORIGIN_SCALE: 0.6,
            PADDING: 10,
            TAP_DELAY_MS: 300,
        };
//# sourceMappingURL=constants.js.map
// CONCATENATED MODULE: ./node_modules/@material/ripple/util.js
        /**
         * Stores result from supportsCssVariables to avoid redundant processing to
         * detect CSS custom variable support.
         */
        var supportsCssVariables_;
        function supportsCssVariables(windowObj, forceRefresh) {
            if (forceRefresh === void 0) { forceRefresh = false; }
            var CSS = windowObj.CSS;
            var supportsCssVars = supportsCssVariables_;
            if (typeof supportsCssVariables_ === 'boolean' && !forceRefresh) {
                return supportsCssVariables_;
            }
            var supportsFunctionPresent = CSS && typeof CSS.supports === 'function';
            if (!supportsFunctionPresent) {
                return false;
            }
            var explicitlySupportsCssVars = CSS.supports('--css-vars', 'yes');
            // See: https://bugs.webkit.org/show_bug.cgi?id=154669
            // See: README section on Safari
            var weAreFeatureDetectingSafari10plus = (CSS.supports('(--css-vars: yes)') &&
            CSS.supports('color', '#00000000'));
            supportsCssVars =
                    explicitlySupportsCssVars || weAreFeatureDetectingSafari10plus;
            if (!forceRefresh) {
                supportsCssVariables_ = supportsCssVars;
            }
            return supportsCssVars;
        }
        function getNormalizedEventCoords(evt, pageOffset, clientRect) {
            if (!evt) {
                return { x: 0, y: 0 };
            }
            var x = pageOffset.x, y = pageOffset.y;
            var documentX = x + clientRect.left;
            var documentY = y + clientRect.top;
            var normalizedX;
            var normalizedY;
            // Determine touch point relative to the ripple container.
            if (evt.type === 'touchstart') {
                var touchEvent = evt;
                normalizedX = touchEvent.changedTouches[0].pageX - documentX;
                normalizedY = touchEvent.changedTouches[0].pageY - documentY;
            }
            else {
                var mouseEvent = evt;
                normalizedX = mouseEvent.pageX - documentX;
                normalizedY = mouseEvent.pageY - documentY;
            }
            return { x: normalizedX, y: normalizedY };
        }
//# sourceMappingURL=util.js.map
// CONCATENATED MODULE: ./node_modules/@material/ripple/foundation.js
        /**
         * @license
         * Copyright 2016 Google Inc.
         *
         * Permission is hereby granted, free of charge, to any person obtaining a copy
         * of this software and associated documentation files (the "Software"), to deal
         * in the Software without restriction, including without limitation the rights
         * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
         * copies of the Software, and to permit persons to whom the Software is
         * furnished to do so, subject to the following conditions:
         *
         * The above copyright notice and this permission notice shall be included in
         * all copies or substantial portions of the Software.
         *
         * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
         * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
         * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
         * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
         * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
         * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
         * THE SOFTWARE.
         */




// Activation events registered on the root element of each instance for activation
        var ACTIVATION_EVENT_TYPES = [
            'touchstart', 'pointerdown', 'mousedown', 'keydown',
        ];
// Deactivation events registered on documentElement when a pointer-related down event occurs
        var POINTER_DEACTIVATION_EVENT_TYPES = [
            'touchend', 'pointerup', 'mouseup', 'contextmenu',
        ];
// simultaneous nested activations
        var activatedTargets = [];
        var foundation_MDCRippleFoundation = /** @class */ (function (_super) {
            __extends(MDCRippleFoundation, _super);
            function MDCRippleFoundation(adapter) {
                var _this = _super.call(this, __assign(__assign({}, MDCRippleFoundation.defaultAdapter), adapter)) || this;
                _this.activationAnimationHasEnded_ = false;
                _this.activationTimer_ = 0;
                _this.fgDeactivationRemovalTimer_ = 0;
                _this.fgScale_ = '0';
                _this.frame_ = { width: 0, height: 0 };
                _this.initialSize_ = 0;
                _this.layoutFrame_ = 0;
                _this.maxRadius_ = 0;
                _this.unboundedCoords_ = { left: 0, top: 0 };
                _this.activationState_ = _this.defaultActivationState_();
                _this.activationTimerCallback_ = function () {
                    _this.activationAnimationHasEnded_ = true;
                    _this.runDeactivationUXLogicIfReady_();
                };
                _this.activateHandler_ = function (e) { return _this.activate_(e); };
                _this.deactivateHandler_ = function () { return _this.deactivate_(); };
                _this.focusHandler_ = function () { return _this.handleFocus(); };
                _this.blurHandler_ = function () { return _this.handleBlur(); };
                _this.resizeHandler_ = function () { return _this.layout(); };
                return _this;
            }
            Object.defineProperty(MDCRippleFoundation, "cssClasses", {
                get: function () {
                    return cssClasses;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(MDCRippleFoundation, "strings", {
                get: function () {
                    return strings;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(MDCRippleFoundation, "numbers", {
                get: function () {
                    return numbers;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(MDCRippleFoundation, "defaultAdapter", {
                get: function () {
                    return {
                        addClass: function () { return undefined; },
                        browserSupportsCssVars: function () { return true; },
                        computeBoundingRect: function () { return ({ top: 0, right: 0, bottom: 0, left: 0, width: 0, height: 0 }); },
                        containsEventTarget: function () { return true; },
                        deregisterDocumentInteractionHandler: function () { return undefined; },
                        deregisterInteractionHandler: function () { return undefined; },
                        deregisterResizeHandler: function () { return undefined; },
                        getWindowPageOffset: function () { return ({ x: 0, y: 0 }); },
                        isSurfaceActive: function () { return true; },
                        isSurfaceDisabled: function () { return true; },
                        isUnbounded: function () { return true; },
                        registerDocumentInteractionHandler: function () { return undefined; },
                        registerInteractionHandler: function () { return undefined; },
                        registerResizeHandler: function () { return undefined; },
                        removeClass: function () { return undefined; },
                        updateCssVariable: function () { return undefined; },
                    };
                },
                enumerable: true,
                configurable: true
            });
            MDCRippleFoundation.prototype.init = function () {
                var _this = this;
                var supportsPressRipple = this.supportsPressRipple_();
                this.registerRootHandlers_(supportsPressRipple);
                if (supportsPressRipple) {
                    var _a = MDCRippleFoundation.cssClasses, ROOT_1 = _a.ROOT, UNBOUNDED_1 = _a.UNBOUNDED;
                    requestAnimationFrame(function () {
                        _this.adapter_.addClass(ROOT_1);
                        if (_this.adapter_.isUnbounded()) {
                            _this.adapter_.addClass(UNBOUNDED_1);
                            // Unbounded ripples need layout logic applied immediately to set coordinates for both shade and ripple
                            _this.layoutInternal_();
                        }
                    });
                }
            };
            MDCRippleFoundation.prototype.destroy = function () {
                var _this = this;
                if (this.supportsPressRipple_()) {
                    if (this.activationTimer_) {
                        clearTimeout(this.activationTimer_);
                        this.activationTimer_ = 0;
                        this.adapter_.removeClass(MDCRippleFoundation.cssClasses.FG_ACTIVATION);
                    }
                    if (this.fgDeactivationRemovalTimer_) {
                        clearTimeout(this.fgDeactivationRemovalTimer_);
                        this.fgDeactivationRemovalTimer_ = 0;
                        this.adapter_.removeClass(MDCRippleFoundation.cssClasses.FG_DEACTIVATION);
                    }
                    var _a = MDCRippleFoundation.cssClasses, ROOT_2 = _a.ROOT, UNBOUNDED_2 = _a.UNBOUNDED;
                    requestAnimationFrame(function () {
                        _this.adapter_.removeClass(ROOT_2);
                        _this.adapter_.removeClass(UNBOUNDED_2);
                        _this.removeCssVars_();
                    });
                }
                this.deregisterRootHandlers_();
                this.deregisterDeactivationHandlers_();
            };
            /**
             * @param evt Optional event containing position information.
             */
            MDCRippleFoundation.prototype.activate = function (evt) {
                this.activate_(evt);
            };
            MDCRippleFoundation.prototype.deactivate = function () {
                this.deactivate_();
            };
            MDCRippleFoundation.prototype.layout = function () {
                var _this = this;
                if (this.layoutFrame_) {
                    cancelAnimationFrame(this.layoutFrame_);
                }
                this.layoutFrame_ = requestAnimationFrame(function () {
                    _this.layoutInternal_();
                    _this.layoutFrame_ = 0;
                });
            };
            MDCRippleFoundation.prototype.setUnbounded = function (unbounded) {
                var UNBOUNDED = MDCRippleFoundation.cssClasses.UNBOUNDED;
                if (unbounded) {
                    this.adapter_.addClass(UNBOUNDED);
                }
                else {
                    this.adapter_.removeClass(UNBOUNDED);
                }
            };
            MDCRippleFoundation.prototype.handleFocus = function () {
                var _this = this;
                requestAnimationFrame(function () {
                    return _this.adapter_.addClass(MDCRippleFoundation.cssClasses.BG_FOCUSED);
                });
            };
            MDCRippleFoundation.prototype.handleBlur = function () {
                var _this = this;
                requestAnimationFrame(function () {
                    return _this.adapter_.removeClass(MDCRippleFoundation.cssClasses.BG_FOCUSED);
                });
            };
            /**
             * We compute this property so that we are not querying information about the client
             * until the point in time where the foundation requests it. This prevents scenarios where
             * client-side feature-detection may happen too early, such as when components are rendered on the server
             * and then initialized at mount time on the client.
             */
            MDCRippleFoundation.prototype.supportsPressRipple_ = function () {
                return this.adapter_.browserSupportsCssVars();
            };
            MDCRippleFoundation.prototype.defaultActivationState_ = function () {
                return {
                    activationEvent: undefined,
                    hasDeactivationUXRun: false,
                    isActivated: false,
                    isProgrammatic: false,
                    wasActivatedByPointer: false,
                    wasElementMadeActive: false,
                };
            };
            /**
             * supportsPressRipple Passed from init to save a redundant function call
             */
            MDCRippleFoundation.prototype.registerRootHandlers_ = function (supportsPressRipple) {
                var _this = this;
                if (supportsPressRipple) {
                    ACTIVATION_EVENT_TYPES.forEach(function (evtType) {
                        _this.adapter_.registerInteractionHandler(evtType, _this.activateHandler_);
                    });
                    if (this.adapter_.isUnbounded()) {
                        this.adapter_.registerResizeHandler(this.resizeHandler_);
                    }
                }
                this.adapter_.registerInteractionHandler('focus', this.focusHandler_);
                this.adapter_.registerInteractionHandler('blur', this.blurHandler_);
            };
            MDCRippleFoundation.prototype.registerDeactivationHandlers_ = function (evt) {
                var _this = this;
                if (evt.type === 'keydown') {
                    this.adapter_.registerInteractionHandler('keyup', this.deactivateHandler_);
                }
                else {
                    POINTER_DEACTIVATION_EVENT_TYPES.forEach(function (evtType) {
                        _this.adapter_.registerDocumentInteractionHandler(evtType, _this.deactivateHandler_);
                    });
                }
            };
            MDCRippleFoundation.prototype.deregisterRootHandlers_ = function () {
                var _this = this;
                ACTIVATION_EVENT_TYPES.forEach(function (evtType) {
                    _this.adapter_.deregisterInteractionHandler(evtType, _this.activateHandler_);
                });
                this.adapter_.deregisterInteractionHandler('focus', this.focusHandler_);
                this.adapter_.deregisterInteractionHandler('blur', this.blurHandler_);
                if (this.adapter_.isUnbounded()) {
                    this.adapter_.deregisterResizeHandler(this.resizeHandler_);
                }
            };
            MDCRippleFoundation.prototype.deregisterDeactivationHandlers_ = function () {
                var _this = this;
                this.adapter_.deregisterInteractionHandler('keyup', this.deactivateHandler_);
                POINTER_DEACTIVATION_EVENT_TYPES.forEach(function (evtType) {
                    _this.adapter_.deregisterDocumentInteractionHandler(evtType, _this.deactivateHandler_);
                });
            };
            MDCRippleFoundation.prototype.removeCssVars_ = function () {
                var _this = this;
                var rippleStrings = MDCRippleFoundation.strings;
                var keys = Object.keys(rippleStrings);
                keys.forEach(function (key) {
                    if (key.indexOf('VAR_') === 0) {
                        _this.adapter_.updateCssVariable(rippleStrings[key], null);
                    }
                });
            };
            MDCRippleFoundation.prototype.activate_ = function (evt) {
                var _this = this;
                if (this.adapter_.isSurfaceDisabled()) {
                    return;
                }
                var activationState = this.activationState_;
                if (activationState.isActivated) {
                    return;
                }
                // Avoid reacting to follow-on events fired by touch device after an already-processed user interaction
                var previousActivationEvent = this.previousActivationEvent_;
                var isSameInteraction = previousActivationEvent && evt !== undefined && previousActivationEvent.type !== evt.type;
                if (isSameInteraction) {
                    return;
                }
                activationState.isActivated = true;
                activationState.isProgrammatic = evt === undefined;
                activationState.activationEvent = evt;
                activationState.wasActivatedByPointer = activationState.isProgrammatic ? false : evt !== undefined && (evt.type === 'mousedown' || evt.type === 'touchstart' || evt.type === 'pointerdown');
                var hasActivatedChild = evt !== undefined && activatedTargets.length > 0 && activatedTargets.some(function (target) { return _this.adapter_.containsEventTarget(target); });
                if (hasActivatedChild) {
                    // Immediately reset activation state, while preserving logic that prevents touch follow-on events
                    this.resetActivationState_();
                    return;
                }
                if (evt !== undefined) {
                    activatedTargets.push(evt.target);
                    this.registerDeactivationHandlers_(evt);
                }
                activationState.wasElementMadeActive = this.checkElementMadeActive_(evt);
                if (activationState.wasElementMadeActive) {
                    this.animateActivation_();
                }
                requestAnimationFrame(function () {
                    // Reset array on next frame after the current event has had a chance to bubble to prevent ancestor ripples
                    activatedTargets = [];
                    if (!activationState.wasElementMadeActive
                            && evt !== undefined
                            && (evt.key === ' ' || evt.keyCode === 32)) {
                        // If space was pressed, try again within an rAF call to detect :active, because different UAs report
                        // active states inconsistently when they're called within event handling code:
                        // - https://bugs.chromium.org/p/chromium/issues/detail?id=635971
                        // - https://bugzilla.mozilla.org/show_bug.cgi?id=1293741
                        // We try first outside rAF to support Edge, which does not exhibit this problem, but will crash if a CSS
                        // variable is set within a rAF callback for a submit button interaction (#2241).
                        activationState.wasElementMadeActive = _this.checkElementMadeActive_(evt);
                        if (activationState.wasElementMadeActive) {
                            _this.animateActivation_();
                        }
                    }
                    if (!activationState.wasElementMadeActive) {
                        // Reset activation state immediately if element was not made active.
                        _this.activationState_ = _this.defaultActivationState_();
                    }
                });
            };
            MDCRippleFoundation.prototype.checkElementMadeActive_ = function (evt) {
                return (evt !== undefined && evt.type === 'keydown') ? this.adapter_.isSurfaceActive() : true;
            };
            MDCRippleFoundation.prototype.animateActivation_ = function () {
                var _this = this;
                var _a = MDCRippleFoundation.strings, VAR_FG_TRANSLATE_START = _a.VAR_FG_TRANSLATE_START, VAR_FG_TRANSLATE_END = _a.VAR_FG_TRANSLATE_END;
                var _b = MDCRippleFoundation.cssClasses, FG_DEACTIVATION = _b.FG_DEACTIVATION, FG_ACTIVATION = _b.FG_ACTIVATION;
                var DEACTIVATION_TIMEOUT_MS = MDCRippleFoundation.numbers.DEACTIVATION_TIMEOUT_MS;
                this.layoutInternal_();
                var translateStart = '';
                var translateEnd = '';
                if (!this.adapter_.isUnbounded()) {
                    var _c = this.getFgTranslationCoordinates_(), startPoint = _c.startPoint, endPoint = _c.endPoint;
                    translateStart = startPoint.x + "px, " + startPoint.y + "px";
                    translateEnd = endPoint.x + "px, " + endPoint.y + "px";
                }
                this.adapter_.updateCssVariable(VAR_FG_TRANSLATE_START, translateStart);
                this.adapter_.updateCssVariable(VAR_FG_TRANSLATE_END, translateEnd);
                // Cancel any ongoing activation/deactivation animations
                clearTimeout(this.activationTimer_);
                clearTimeout(this.fgDeactivationRemovalTimer_);
                this.rmBoundedActivationClasses_();
                this.adapter_.removeClass(FG_DEACTIVATION);
                // Force layout in order to re-trigger the animation.
                this.adapter_.computeBoundingRect();
                this.adapter_.addClass(FG_ACTIVATION);
                this.activationTimer_ = setTimeout(function () { return _this.activationTimerCallback_(); }, DEACTIVATION_TIMEOUT_MS);
            };
            MDCRippleFoundation.prototype.getFgTranslationCoordinates_ = function () {
                var _a = this.activationState_, activationEvent = _a.activationEvent, wasActivatedByPointer = _a.wasActivatedByPointer;
                var startPoint;
                if (wasActivatedByPointer) {
                    startPoint = getNormalizedEventCoords(activationEvent, this.adapter_.getWindowPageOffset(), this.adapter_.computeBoundingRect());
                }
                else {
                    startPoint = {
                        x: this.frame_.width / 2,
                        y: this.frame_.height / 2,
                    };
                }
                // Center the element around the start point.
                startPoint = {
                    x: startPoint.x - (this.initialSize_ / 2),
                    y: startPoint.y - (this.initialSize_ / 2),
                };
                var endPoint = {
                    x: (this.frame_.width / 2) - (this.initialSize_ / 2),
                    y: (this.frame_.height / 2) - (this.initialSize_ / 2),
                };
                return { startPoint: startPoint, endPoint: endPoint };
            };
            MDCRippleFoundation.prototype.runDeactivationUXLogicIfReady_ = function () {
                var _this = this;
                // This method is called both when a pointing device is released, and when the activation animation ends.
                // The deactivation animation should only run after both of those occur.
                var FG_DEACTIVATION = MDCRippleFoundation.cssClasses.FG_DEACTIVATION;
                var _a = this.activationState_, hasDeactivationUXRun = _a.hasDeactivationUXRun, isActivated = _a.isActivated;
                var activationHasEnded = hasDeactivationUXRun || !isActivated;
                if (activationHasEnded && this.activationAnimationHasEnded_) {
                    this.rmBoundedActivationClasses_();
                    this.adapter_.addClass(FG_DEACTIVATION);
                    this.fgDeactivationRemovalTimer_ = setTimeout(function () {
                        _this.adapter_.removeClass(FG_DEACTIVATION);
                    }, numbers.FG_DEACTIVATION_MS);
                }
            };
            MDCRippleFoundation.prototype.rmBoundedActivationClasses_ = function () {
                var FG_ACTIVATION = MDCRippleFoundation.cssClasses.FG_ACTIVATION;
                this.adapter_.removeClass(FG_ACTIVATION);
                this.activationAnimationHasEnded_ = false;
                this.adapter_.computeBoundingRect();
            };
            MDCRippleFoundation.prototype.resetActivationState_ = function () {
                var _this = this;
                this.previousActivationEvent_ = this.activationState_.activationEvent;
                this.activationState_ = this.defaultActivationState_();
                // Touch devices may fire additional events for the same interaction within a short time.
                // Store the previous event until it's safe to assume that subsequent events are for new interactions.
                setTimeout(function () { return _this.previousActivationEvent_ = undefined; }, MDCRippleFoundation.numbers.TAP_DELAY_MS);
            };
            MDCRippleFoundation.prototype.deactivate_ = function () {
                var _this = this;
                var activationState = this.activationState_;
                // This can happen in scenarios such as when you have a keyup event that blurs the element.
                if (!activationState.isActivated) {
                    return;
                }
                var state = __assign({}, activationState);
                if (activationState.isProgrammatic) {
                    requestAnimationFrame(function () { return _this.animateDeactivation_(state); });
                    this.resetActivationState_();
                }
                else {
                    this.deregisterDeactivationHandlers_();
                    requestAnimationFrame(function () {
                        _this.activationState_.hasDeactivationUXRun = true;
                        _this.animateDeactivation_(state);
                        _this.resetActivationState_();
                    });
                }
            };
            MDCRippleFoundation.prototype.animateDeactivation_ = function (_a) {
                var wasActivatedByPointer = _a.wasActivatedByPointer, wasElementMadeActive = _a.wasElementMadeActive;
                if (wasActivatedByPointer || wasElementMadeActive) {
                    this.runDeactivationUXLogicIfReady_();
                }
            };
            MDCRippleFoundation.prototype.layoutInternal_ = function () {
                var _this = this;
                this.frame_ = this.adapter_.computeBoundingRect();
                var maxDim = Math.max(this.frame_.height, this.frame_.width);
                // Surface diameter is treated differently for unbounded vs. bounded ripples.
                // Unbounded ripple diameter is calculated smaller since the surface is expected to already be padded appropriately
                // to extend the hitbox, and the ripple is expected to meet the edges of the padded hitbox (which is typically
                // square). Bounded ripples, on the other hand, are fully expected to expand beyond the surface's longest diameter
                // (calculated based on the diagonal plus a constant padding), and are clipped at the surface's border via
                // `overflow: hidden`.
                var getBoundedRadius = function () {
                    var hypotenuse = Math.sqrt(Math.pow(_this.frame_.width, 2) + Math.pow(_this.frame_.height, 2));
                    return hypotenuse + MDCRippleFoundation.numbers.PADDING;
                };
                this.maxRadius_ = this.adapter_.isUnbounded() ? maxDim : getBoundedRadius();
                // Ripple is sized as a fraction of the largest dimension of the surface, then scales up using a CSS scale transform
                var initialSize = Math.floor(maxDim * MDCRippleFoundation.numbers.INITIAL_ORIGIN_SCALE);
                // Unbounded ripple size should always be even number to equally center align.
                if (this.adapter_.isUnbounded() && initialSize % 2 !== 0) {
                    this.initialSize_ = initialSize - 1;
                }
                else {
                    this.initialSize_ = initialSize;
                }
                this.fgScale_ = "" + this.maxRadius_ / this.initialSize_;
                this.updateLayoutCssVars_();
            };
            MDCRippleFoundation.prototype.updateLayoutCssVars_ = function () {
                var _a = MDCRippleFoundation.strings, VAR_FG_SIZE = _a.VAR_FG_SIZE, VAR_LEFT = _a.VAR_LEFT, VAR_TOP = _a.VAR_TOP, VAR_FG_SCALE = _a.VAR_FG_SCALE;
                this.adapter_.updateCssVariable(VAR_FG_SIZE, this.initialSize_ + "px");
                this.adapter_.updateCssVariable(VAR_FG_SCALE, this.fgScale_);
                if (this.adapter_.isUnbounded()) {
                    this.unboundedCoords_ = {
                        left: Math.round((this.frame_.width / 2) - (this.initialSize_ / 2)),
                        top: Math.round((this.frame_.height / 2) - (this.initialSize_ / 2)),
                    };
                    this.adapter_.updateCssVariable(VAR_LEFT, this.unboundedCoords_.left + "px");
                    this.adapter_.updateCssVariable(VAR_TOP, this.unboundedCoords_.top + "px");
                }
            };
            return MDCRippleFoundation;
        }(MDCFoundation));

// tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
        /* harmony default export */ var ripple_foundation = (foundation_MDCRippleFoundation);
//# sourceMappingURL=foundation.js.map
// CONCATENATED MODULE: ./node_modules/@material/ripple/component.js
        /**
         * @license
         * Copyright 2016 Google Inc.
         *
         * Permission is hereby granted, free of charge, to any person obtaining a copy
         * of this software and associated documentation files (the "Software"), to deal
         * in the Software without restriction, including without limitation the rights
         * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
         * copies of the Software, and to permit persons to whom the Software is
         * furnished to do so, subject to the following conditions:
         *
         * The above copyright notice and this permission notice shall be included in
         * all copies or substantial portions of the Software.
         *
         * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
         * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
         * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
         * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
         * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
         * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
         * THE SOFTWARE.
         */






        var component_MDCRipple = /** @class */ (function (_super) {
            __extends(MDCRipple, _super);
            function MDCRipple() {
                var _this = _super !== null && _super.apply(this, arguments) || this;
                _this.disabled = false;
                return _this;
            }
            MDCRipple.attachTo = function (root, opts) {
                if (opts === void 0) { opts = { isUnbounded: undefined }; }
                var ripple = new MDCRipple(root);
                // Only override unbounded behavior if option is explicitly specified
                if (opts.isUnbounded !== undefined) {
                    ripple.unbounded = opts.isUnbounded;
                }
                return ripple;
            };
            MDCRipple.createAdapter = function (instance) {
                return {
                    addClass: function (className) { return instance.root_.classList.add(className); },
                    browserSupportsCssVars: function () { return supportsCssVariables(window); },
                    computeBoundingRect: function () { return instance.root_.getBoundingClientRect(); },
                    containsEventTarget: function (target) { return instance.root_.contains(target); },
                    deregisterDocumentInteractionHandler: function (evtType, handler) {
                        return document.documentElement.removeEventListener(evtType, handler, applyPassive());
                    },
                    deregisterInteractionHandler: function (evtType, handler) {
                        return instance.root_.removeEventListener(evtType, handler, applyPassive());
                    },
                    deregisterResizeHandler: function (handler) { return window.removeEventListener('resize', handler); },
                    getWindowPageOffset: function () { return ({ x: window.pageXOffset, y: window.pageYOffset }); },
                    isSurfaceActive: function () { return matches(instance.root_, ':active'); },
                    isSurfaceDisabled: function () { return Boolean(instance.disabled); },
                    isUnbounded: function () { return Boolean(instance.unbounded); },
                    registerDocumentInteractionHandler: function (evtType, handler) {
                        return document.documentElement.addEventListener(evtType, handler, applyPassive());
                    },
                    registerInteractionHandler: function (evtType, handler) {
                        return instance.root_.addEventListener(evtType, handler, applyPassive());
                    },
                    registerResizeHandler: function (handler) { return window.addEventListener('resize', handler); },
                    removeClass: function (className) { return instance.root_.classList.remove(className); },
                    updateCssVariable: function (varName, value) { return instance.root_.style.setProperty(varName, value); },
                };
            };
            Object.defineProperty(MDCRipple.prototype, "unbounded", {
                get: function () {
                    return Boolean(this.unbounded_);
                },
                set: function (unbounded) {
                    this.unbounded_ = Boolean(unbounded);
                    this.setUnbounded_();
                },
                enumerable: true,
                configurable: true
            });
            MDCRipple.prototype.activate = function () {
                this.foundation_.activate();
            };
            MDCRipple.prototype.deactivate = function () {
                this.foundation_.deactivate();
            };
            MDCRipple.prototype.layout = function () {
                this.foundation_.layout();
            };
            MDCRipple.prototype.getDefaultFoundation = function () {
                return new foundation_MDCRippleFoundation(MDCRipple.createAdapter(this));
            };
            MDCRipple.prototype.initialSyncWithDOM = function () {
                var root = this.root_;
                this.unbounded = 'mdcRippleIsUnbounded' in root.dataset;
            };
            /**
             * Closure Compiler throws an access control error when directly accessing a
             * protected or private property inside a getter/setter, like unbounded above.
             * By accessing the protected property inside a method, we solve that problem.
             * That's why this function exists.
             */
            MDCRipple.prototype.setUnbounded_ = function () {
                this.foundation_.setUnbounded(Boolean(this.unbounded_));
            };
            return MDCRipple;
        }(component_MDCComponent));

//# sourceMappingURL=component.js.map
// CONCATENATED MODULE: ./source/scripts/helpers/Ripple.js
        // This function sets up the ripple effect for the various buttons throughout the
// theme using CSS selectors.

        var Ripple_setupRippleEffect = function setupRippleEffect(rootElement) {
            if ('reduceAnimations' in document.body.dataset) {
                return;
            }

            var rippleElements = ['.button-primary', '.button-secondary', '.slideshow-slide__button', '.product-form--atc-button', '.mobile-nav-content .navmenu-link', '.mobile-nav-content .navmenu-button', '.live-search-button', '.form-options-selectable-boxes .option-value-name'];
            rootElement.querySelectorAll(rippleElements.join(',')).forEach(function (el) {
                if (!el.classList.contains('disabled') && !el.hasAttribute('disabled')) {
                    el.classList.add('mdc-ripple-surface');
                    component_MDCRipple.attachTo(el);
                }
            });
        };
        /* harmony default export */ var Ripple = ({
            setupRippleEffect: Ripple_setupRippleEffect
        });
// CONCATENATED MODULE: ./source/scripts/components/AddToCartFlyout.js
        function AddToCartFlyout_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

        function AddToCartFlyout_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { AddToCartFlyout_ownKeys(Object(source), true).forEach(function (key) { AddToCartFlyout_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { AddToCartFlyout_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

        function AddToCartFlyout_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

        function AddToCartFlyout_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

        function AddToCartFlyout_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

        function AddToCartFlyout_createClass(Constructor, protoProps, staticProps) { if (protoProps) AddToCartFlyout_defineProperties(Constructor.prototype, protoProps); if (staticProps) AddToCartFlyout_defineProperties(Constructor, staticProps); return Constructor; }









        var AddToCartFlyout_AddToCartFlyout = /*#__PURE__*/function () {
            function AddToCartFlyout(formData, options) {
                var callbacks = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

                AddToCartFlyout_classCallCheck(this, AddToCartFlyout);

                this.formData = formData;
                this.settings = AddToCartFlyout_objectSpread({
                    moneyFormat: null,
                    cartRedirection: false
                }, options.settings);
                this.atcButton = options.atcButton;
                this.header = document.querySelector('[data-site-header]');
                this.flyOutSelector = '[data-atc-banner]';
                this.atcTemplate = document.querySelector("[data-templates] ".concat(this.flyOutSelector));
                this.activeElement = document.activeElement;
                this.itemId = null;
                this.flyOut = null;
                this._onInit = this._onInit.bind(this);
                this._onError = this._onError.bind(this);
                this._onSuccess = this._onSuccess.bind(this);
                this._onCloseAll = this._onCloseAll.bind(this); // Allows ATC Flow to be overridden

                this.callbacks = AddToCartFlyout_objectSpread({
                    onInit: this._onInit,
                    onError: this._onError,
                    onSuccess: this._onSuccess,
                    onClose: this._onCloseAll
                }, callbacks);
                this._handleDocumentClick = this._handleDocumentClick.bind(this);
                this._closeFlyOut = this._closeFlyOut.bind(this);
                this._closeEsc = this._closeEsc.bind(this);
                this.events = new EventHandler_default.a();
                this.Images = new Images();
                this.messageBanner = null;
                this.callbacks.onInit();

                this._disableAtcButton();

                this._updateCart();
            }

            AddToCartFlyout_createClass(AddToCartFlyout, [{
                key: "unload",
                value: function unload() {
                    if (this.messageBanner) {
                        this.messageBanner.unload();
                    }

                    this._closeFlyOut();
                }
            }, {
                key: "_updateCart",
                value: function _updateCart() {
                    var _this = this;

                    var flyOut = this.atcTemplate.cloneNode(true);
                    var quantityField = this.formData.filter(function (data) {
                        return data.name === 'quantity';
                    });
                    var quantity = quantityField[0].value;
                    jquery_default.a.ajax({
                        type: 'POST',
                        url: "".concat(window.Theme.routes.cart_add_url, ".js"),
                        data: jquery_default.a.param(this.formData),
                        dataType: 'json'
                    }).done(function (response) {
                        _this.itemId = response.id;

                        if (response.image) {
                            var imageUrl = _this.Images.getSizedImageUrl(response.image, '200x');

                            _this.Images.loadImage(imageUrl);

                            var productImage = flyOut.querySelector('[data-atc-banner-product-image]');
                            productImage.innerHTML = "<img src=\"".concat(imageUrl, "\" alt=\"").concat(response.product_title, "\">");
                        }

                        var productTitle = flyOut.querySelector('[data-atc-banner-product-title]');
                        productTitle.innerHTML = response.product_title;
                        /*
                         TODO: Bring in `variant.options`, iterate through to get option
                         name for: <strong>Option name:</strong> Option
                         */

                        if (response.variant_options[0] !== 'Title' && response.variant_options[0] !== 'Default Title') {
                            var productOptions = flyOut.querySelector('[data-atc-banner-product-options]');
                            productOptions.innerHTML = response.variant_options.join(', ');
                        }
                        /*
                         TODO: Bring in variant, and use that to check compare_at_price
                         to see if the item is on sale
                         */


                        var productPriceQuantity = flyOut.querySelector('[data-atc-banner-product-price-quantity]');
                        productPriceQuantity.innerHTML = "".concat(quantity, " \xD7 ");
                        jquery_default.a.ajax({
                            type: 'GET',
                            url: "".concat(window.Theme.routes.cart_url, ".js"),
                            dataType: 'json'
                        }).done(function (secondResponse) {
                            if (_this.settings.cartRedirection) {
                                location.href = window.Theme.routes.cart_url;
                                return;
                            }

                            _this.callbacks.onSuccess(); // Reset formData in case instance is never cleared


                            _this.formData = {};
                            var lineItem = null;
                            secondResponse.items.forEach(function (item) {
                                if (item.id === _this.itemId) {
                                    if (!lineItem) {
                                        lineItem = item;
                                    } else {
                                        // If there are 2 lineItems with the same id, it means that there is
                                        // likely a BOGO offer on the product. We need to grab the highest discounted
                                        // price (BOGO will be 0) while also combining with the different discounts on
                                        // the product in the discounts array.
                                        lineItem.line_level_discount_allocations = lineItem.line_level_discount_allocations.concat(item.line_level_discount_allocations);
                                        lineItem.final_price = lineItem.final_price > item.final_price ? lineItem.final_price : item.final_price;
                                        lineItem.quantity += item.quantity;
                                    }
                                }
                            });
                            var productPriceValue = flyOut.querySelector('[data-atc-banner-product-price-value]');
                            productPriceValue.innerHTML = Shopify.formatMoney(lineItem.original_price, _this.settings.moneyFormat);
                            var productPriceDiscounted = flyOut.querySelector('[data-atc-banner-product-price-discounted]');

                            if (lineItem.final_price < lineItem.original_price) {
                                productPriceDiscounted.innerHTML = Shopify.formatMoney(lineItem.final_price, _this.settings.moneyFormat);
                                productPriceDiscounted.classList.remove('hidden');
                                productPriceValue.classList.add('original-price');
                            } else {
                                productPriceDiscounted.classList.add('hidden');
                                productPriceValue.classList.remove('original-price');
                            }

                            var productDiscounts = flyOut.querySelector('[data-atc-banner-product-discounts]'); // Price Per Unit

                            var unitPrice = flyOut.querySelector('[data-atc-banner-unit-price]');
                            var unitPriceString = unitPrice.innerHTML;

                            if (unitPrice && lineItem.unit_price_measurement) {
                                unitPriceString = unitPriceString.replace('** total_quantity **', "".concat(lineItem.unit_price_measurement.quantity_value).concat(lineItem.unit_price_measurement.quantity_unit));
                                unitPriceString = unitPriceString.replace('** unit_price **', Shopify.formatMoney(lineItem.unit_price, _this.settings.money_format));

                                if (lineItem.unit_price_measurement.reference_value === 1) {
                                    unitPriceString = unitPriceString.replace('** unit_measure **', lineItem.unit_price_measurement.reference_unit);
                                } else {
                                    unitPriceString = unitPriceString.replace('** unit_measure **', "".concat(lineItem.unit_price_measurement.reference_value).concat(lineItem.unit_price_measurement.reference_unit));
                                }

                                unitPrice.innerHTML = unitPriceString;
                                unitPrice.classList.remove('hidden');
                            }

                            if (lineItem.line_level_discount_allocations.length > 0) {
                                var discountItemTemplate = productDiscounts.firstElementChild.cloneNode(true);
                                productDiscounts.innerHTML = '';
                                lineItem.line_level_discount_allocations.forEach(function (discount) {
                                    var listItem = discountItemTemplate.cloneNode(true);
                                    var title = listItem.querySelector('.discount-title');
                                    var amount = listItem.querySelector('.discount-amount');
                                    title.innerHTML = discount.discount_application.title;
                                    amount.innerHTML = Shopify.formatMoney(discount.amount, _this.settings.moneyFormat);
                                    productDiscounts.appendChild(listItem);
                                });
                                productDiscounts.classList.remove('hidden');
                            } else {
                                productDiscounts.classList.add('hidden');
                            }

                            var subTotal = flyOut.querySelector('[data-atc-banner-cart-subtotal]');
                            subTotal.innerHTML = Shopify.formatMoney(secondResponse.total_price, _this.settings.moneyFormat);
                            var itemCount = flyOut.querySelector('[data-atc-banner-cart-button] span');
                            itemCount.innerHTML = secondResponse.item_count;

                            _this.header.appendChild(flyOut);

                            _this.flyOut = flyOut;
                            Ripple_setupRippleEffect(_this.flyOut); // Notifiy Header of new cart count

                            var countEvent = new CustomEvent('cartcount:update', {
                                detail: secondResponse
                            });
                            window.dispatchEvent(countEvent);
                            /*
                             If user has initiated a new ATC Flow before the first has finished,
                             the first FlyOut could have opened after the first attempt to close open flyouts so
                             we need to send out an event to close any open flyouts.
                             */

                            document.dispatchEvent(new Event('closeFlyouts'));
                            var closeButton = flyOut.querySelector('[data-atc-banner-close]');

                            _this.events.register(closeButton, 'click', function (e) {
                                return _this._closeFlyOut(e);
                            });

                            _this.events.register(document, 'click', function (e) {
                                return _this._handleDocumentClick(e);
                            });

                            _this.events.register(document, 'touchstart', function (e) {
                                return _this._handleDocumentClick(e);
                            });

                            _this.events.register(document, 'closeFlyouts', function (e) {
                                return _this._closeFlyOut(e);
                            });

                            _this.events.register(window, 'keydown', function (e) {
                                return _this._closeEsc(e);
                            });

                            _this._enableAtcButton();

                            _this.atcAnimation = transition({
                                el: _this.flyOut,
                                state: 'closed'
                            });

                            _this.atcAnimation.animateTo('open').then(function () {
                                trapFocus(_this.flyOut);
                            });
                        });
                    }).fail(function (response) {
                        var errorText;

                        try {
                            var responseText = JSON.parse(response.responseText);
                            errorText = responseText.description;
                        } catch (error) {
                            errorText = "".concat(response.status, " ").concat(response.statusText);

                            if (response.status === 401) {
                                errorText = "".concat(errorText, ". Try refreshing and logging in.");
                            }
                        }

                        _this._enableAtcButton();

                        _this.callbacks.onError(errorText);
                    });
                }
            }, {
                key: "_onError",
                value: function _onError(error) {
                    this.messageBanner = new MessageBanner_MessageBanner(error, 'error');
                }
            }, {
                key: "_onInit",
                value: function _onInit() {
                    if (this.messageBanner) {
                        this.messageBanner.unload();
                    }
                }
            }, {
                key: "_onSuccess",
                value: function _onSuccess() {
                    /*
                     By default, the ATC Flyout doesn't need any additional success callbacks
                     The `this.callbacks.onSuccess` is used to allow other views to initiate
                     behaviour when a product has been added to the cart
                     */
                }
            }, {
                key: "_onCloseAll",
                value: function _onCloseAll() {
                    /*
                     By default, the ATC Flyout doesn't need any additional close callbacks
                     The `this.callbacks.onClose` is used to allow other views to initiate
                     behaviour when the atc banner has been closed
                     */
                }
            }, {
                key: "_closeEsc",
                value: function _closeEsc(e) {
                    if (e.key === 'Escape') {
                        this._closeFlyOut(e);
                    }
                }
                /**
                 * Close an open FlyOut
                 *
                 * @private
                 */

            }, {
                key: "_closeFlyOut",
                value: function _closeFlyOut() {
                    var _this2 = this;

                    if (!this.flyOut) {
                        return;
                    }

                    removeTrapFocus(this.flyOut); // if the user clicked onto the search box, move focus
                    // to the search instead of going to the previous active element.

                    if (this.documentClickEventTarget && 'liveSearchInput' in this.documentClickEventTarget.dataset) {
                        this.documentClickEventTarget.focus();
                    } else if (this.activeElement) {
                        this.activeElement.focus();
                    }

                    this.atcAnimation.animateTo('closed').then(function () {
                        _this2.callbacks.onClose();

                        _this2.flyOut.remove();

                        _this2.flyOut = null;

                        _this2.events.unregisterAll();

                        _this2.atcAnimation.unload();

                        delete _this2.Images;
                    });
                }
            }, {
                key: "_disableAtcButton",
                value: function _disableAtcButton() {
                    this.atcButton.classList.add('processing');
                    this.atcButton.setAttribute('disabled', 'disabled');
                }
            }, {
                key: "_enableAtcButton",
                value: function _enableAtcButton() {
                    this.atcButton.removeAttribute('disabled');
                    this.atcButton.classList.remove('processing');
                }
            }, {
                key: "_handleDocumentClick",
                value: function _handleDocumentClick(e) {
                    var target = e.target;
                    var $parent = jquery_default()(target).parents('[data-atc-banner]');

                    if ($parent.length) {
                        return;
                    }

                    this.documentClickEventTarget = target;

                    this._closeFlyOut(e);
                }
            }]);

            return AddToCartFlyout;
        }();


// CONCATENATED MODULE: ./node_modules/drift-zoom/es/util/dom.js
        function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

// This is not really a perfect check, but works fine.
// From http://stackoverflow.com/questions/384286
        var HAS_DOM_2 = (typeof HTMLElement === "undefined" ? "undefined" : _typeof(HTMLElement)) === "object";
        function isDOMElement(obj) {
            return HAS_DOM_2 ? obj instanceof HTMLElement : obj && _typeof(obj) === "object" && obj !== null && obj.nodeType === 1 && typeof obj.nodeName === "string";
        }
        function addClasses(el, classNames) {
            classNames.forEach(function (className) {
                el.classList.add(className);
            });
        }
        function removeClasses(el, classNames) {
            classNames.forEach(function (className) {
                el.classList.remove(className);
            });
        }
//# sourceMappingURL=dom.js.map
// CONCATENATED MODULE: ./node_modules/drift-zoom/es/injectBaseStylesheet.js
        /* UNMINIFIED RULES

         const RULES = `
         @keyframes noop {
         0% { zoom: 1; }
         }

         @-webkit-keyframes noop {
         0% { zoom: 1; }
         }

         .drift-zoom-pane.drift-open {
         display: block;
         }

         .drift-zoom-pane.drift-opening, .drift-zoom-pane.drift-closing {
         animation: noop 1ms;
         -webkit-animation: noop 1ms;
         }

         .drift-zoom-pane {
         position: absolute;
         overflow: hidden;
         width: 100%;
         height: 100%;
         top: 0;
         left: 0;
         pointer-events: none;
         }

         .drift-zoom-pane-loader {
         display: none;
         }

         .drift-zoom-pane img {
         position: absolute;
         display: block;
         max-width: none;
         max-height: none;
         }

         .drift-bounding-box {
         position: absolute;
         pointer-events: none;
         }
         `;

         */
        var RULES = ".drift-bounding-box,.drift-zoom-pane{position:absolute;pointer-events:none}@keyframes noop{0%{zoom:1}}@-webkit-keyframes noop{0%{zoom:1}}.drift-zoom-pane.drift-open{display:block}.drift-zoom-pane.drift-closing,.drift-zoom-pane.drift-opening{animation:noop 1ms;-webkit-animation:noop 1ms}.drift-zoom-pane{overflow:hidden;width:100%;height:100%;top:0;left:0}.drift-zoom-pane-loader{display:none}.drift-zoom-pane img{position:absolute;display:block;max-width:none;max-height:none}";
        function injectBaseStylesheet() {
            if (document.querySelector(".drift-base-styles")) {
                return;
            }

            var styleEl = document.createElement("style");
            styleEl.type = "text/css";
            styleEl.classList.add("drift-base-styles");
            styleEl.appendChild(document.createTextNode(RULES));
            var head = document.head;
            head.insertBefore(styleEl, head.firstChild);
        }
//# sourceMappingURL=injectBaseStylesheet.js.map
// CONCATENATED MODULE: ./node_modules/drift-zoom/es/util/throwIfMissing.js
        function throwIfMissing() {
            throw new Error("Missing parameter");
        }
//# sourceMappingURL=throwIfMissing.js.map
// CONCATENATED MODULE: ./node_modules/drift-zoom/es/BoundingBox.js
        function BoundingBox_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

        function BoundingBox_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

        function BoundingBox_createClass(Constructor, protoProps, staticProps) { if (protoProps) BoundingBox_defineProperties(Constructor.prototype, protoProps); if (staticProps) BoundingBox_defineProperties(Constructor, staticProps); return Constructor; }




        var BoundingBox_BoundingBox =
                /*#__PURE__*/
                function () {
                    function BoundingBox(options) {
                        BoundingBox_classCallCheck(this, BoundingBox);

                        this.isShowing = false;
                        var _options$namespace = options.namespace,
                                namespace = _options$namespace === void 0 ? null : _options$namespace,
                                _options$zoomFactor = options.zoomFactor,
                                zoomFactor = _options$zoomFactor === void 0 ? throwIfMissing() : _options$zoomFactor,
                                _options$containerEl = options.containerEl,
                                containerEl = _options$containerEl === void 0 ? throwIfMissing() : _options$containerEl;
                        this.settings = {
                            namespace: namespace,
                            zoomFactor: zoomFactor,
                            containerEl: containerEl
                        };
                        this.openClasses = this._buildClasses("open");

                        this._buildElement();
                    }

                    BoundingBox_createClass(BoundingBox, [{
                        key: "_buildClasses",
                        value: function _buildClasses(suffix) {
                            var classes = ["drift-".concat(suffix)];
                            var ns = this.settings.namespace;

                            if (ns) {
                                classes.push("".concat(ns, "-").concat(suffix));
                            }

                            return classes;
                        }
                    }, {
                        key: "_buildElement",
                        value: function _buildElement() {
                            this.el = document.createElement("div");
                            addClasses(this.el, this._buildClasses("bounding-box"));
                        }
                    }, {
                        key: "show",
                        value: function show(zoomPaneWidth, zoomPaneHeight) {
                            this.isShowing = true;
                            this.settings.containerEl.appendChild(this.el);
                            var style = this.el.style;
                            style.width = "".concat(Math.round(zoomPaneWidth / this.settings.zoomFactor), "px");
                            style.height = "".concat(Math.round(zoomPaneHeight / this.settings.zoomFactor), "px");
                            addClasses(this.el, this.openClasses);
                        }
                    }, {
                        key: "hide",
                        value: function hide() {
                            if (this.isShowing) {
                                this.settings.containerEl.removeChild(this.el);
                            }

                            this.isShowing = false;
                            removeClasses(this.el, this.openClasses);
                        }
                    }, {
                        key: "setPosition",
                        value: function setPosition(percentageOffsetX, percentageOffsetY, triggerRect) {
                            var pageXOffset = window.pageXOffset;
                            var pageYOffset = window.pageYOffset;
                            var inlineLeft = triggerRect.left + percentageOffsetX * triggerRect.width - this.el.clientWidth / 2 + pageXOffset;
                            var inlineTop = triggerRect.top + percentageOffsetY * triggerRect.height - this.el.clientHeight / 2 + pageYOffset;

                            if (inlineLeft < triggerRect.left + pageXOffset) {
                                inlineLeft = triggerRect.left + pageXOffset;
                            } else if (inlineLeft + this.el.clientWidth > triggerRect.left + triggerRect.width + pageXOffset) {
                                inlineLeft = triggerRect.left + triggerRect.width - this.el.clientWidth + pageXOffset;
                            }

                            if (inlineTop < triggerRect.top + pageYOffset) {
                                inlineTop = triggerRect.top + pageYOffset;
                            } else if (inlineTop + this.el.clientHeight > triggerRect.top + triggerRect.height + pageYOffset) {
                                inlineTop = triggerRect.top + triggerRect.height - this.el.clientHeight + pageYOffset;
                            }

                            this.el.style.left = "".concat(inlineLeft, "px");
                            this.el.style.top = "".concat(inlineTop, "px");
                        }
                    }]);

                    return BoundingBox;
                }();


//# sourceMappingURL=BoundingBox.js.map
// CONCATENATED MODULE: ./node_modules/drift-zoom/es/Trigger.js
        function Trigger_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

        function Trigger_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

        function Trigger_createClass(Constructor, protoProps, staticProps) { if (protoProps) Trigger_defineProperties(Constructor.prototype, protoProps); if (staticProps) Trigger_defineProperties(Constructor, staticProps); return Constructor; }




        var Trigger_Trigger =
                /*#__PURE__*/
                function () {
                    function Trigger() {
                        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                        Trigger_classCallCheck(this, Trigger);

                        this._show = this._show.bind(this);
                        this._hide = this._hide.bind(this);
                        this._handleEntry = this._handleEntry.bind(this);
                        this._handleMovement = this._handleMovement.bind(this);
                        var _options$el = options.el,
                                el = _options$el === void 0 ? throwIfMissing() : _options$el,
                                _options$zoomPane = options.zoomPane,
                                zoomPane = _options$zoomPane === void 0 ? throwIfMissing() : _options$zoomPane,
                                _options$sourceAttrib = options.sourceAttribute,
                                sourceAttribute = _options$sourceAttrib === void 0 ? throwIfMissing() : _options$sourceAttrib,
                                _options$handleTouch = options.handleTouch,
                                handleTouch = _options$handleTouch === void 0 ? throwIfMissing() : _options$handleTouch,
                                _options$onShow = options.onShow,
                                onShow = _options$onShow === void 0 ? null : _options$onShow,
                                _options$onHide = options.onHide,
                                onHide = _options$onHide === void 0 ? null : _options$onHide,
                                _options$hoverDelay = options.hoverDelay,
                                hoverDelay = _options$hoverDelay === void 0 ? 0 : _options$hoverDelay,
                                _options$touchDelay = options.touchDelay,
                                touchDelay = _options$touchDelay === void 0 ? 0 : _options$touchDelay,
                                _options$hoverBoundin = options.hoverBoundingBox,
                                hoverBoundingBox = _options$hoverBoundin === void 0 ? throwIfMissing() : _options$hoverBoundin,
                                _options$touchBoundin = options.touchBoundingBox,
                                touchBoundingBox = _options$touchBoundin === void 0 ? throwIfMissing() : _options$touchBoundin,
                                _options$namespace = options.namespace,
                                namespace = _options$namespace === void 0 ? null : _options$namespace,
                                _options$zoomFactor = options.zoomFactor,
                                zoomFactor = _options$zoomFactor === void 0 ? throwIfMissing() : _options$zoomFactor,
                                _options$boundingBoxC = options.boundingBoxContainer,
                                boundingBoxContainer = _options$boundingBoxC === void 0 ? throwIfMissing() : _options$boundingBoxC;
                        this.settings = {
                            el: el,
                            zoomPane: zoomPane,
                            sourceAttribute: sourceAttribute,
                            handleTouch: handleTouch,
                            onShow: onShow,
                            onHide: onHide,
                            hoverDelay: hoverDelay,
                            touchDelay: touchDelay,
                            hoverBoundingBox: hoverBoundingBox,
                            touchBoundingBox: touchBoundingBox,
                            namespace: namespace,
                            zoomFactor: zoomFactor,
                            boundingBoxContainer: boundingBoxContainer
                        };

                        if (this.settings.hoverBoundingBox || this.settings.touchBoundingBox) {
                            this.boundingBox = new BoundingBox_BoundingBox({
                                namespace: this.settings.namespace,
                                zoomFactor: this.settings.zoomFactor,
                                containerEl: this.settings.boundingBoxContainer
                            });
                        }

                        this.enabled = true;

                        this._bindEvents();
                    }

                    Trigger_createClass(Trigger, [{
                        key: "_preventDefault",
                        value: function _preventDefault(event) {
                            event.preventDefault();
                        }
                    }, {
                        key: "_preventDefaultAllowTouchScroll",
                        value: function _preventDefaultAllowTouchScroll(event) {
                            if (!this.settings.touchDelay || !this._isTouchEvent(event) || this.isShowing) {
                                event.preventDefault();
                            }
                        }
                    }, {
                        key: "_isTouchEvent",
                        value: function _isTouchEvent(event) {
                            return !!event.touches;
                        }
                    }, {
                        key: "_bindEvents",
                        value: function _bindEvents() {
                            this.settings.el.addEventListener("mouseenter", this._handleEntry, false);
                            this.settings.el.addEventListener("mouseleave", this._hide, false);
                            this.settings.el.addEventListener("mousemove", this._handleMovement, false);

                            if (this.settings.handleTouch) {
                                this.settings.el.addEventListener("touchstart", this._handleEntry, false);
                                this.settings.el.addEventListener("touchend", this._hide, false);
                                this.settings.el.addEventListener("touchmove", this._handleMovement, false);
                            } else {
                                this.settings.el.addEventListener("touchstart", this._preventDefault, false);
                                this.settings.el.addEventListener("touchend", this._preventDefault, false);
                                this.settings.el.addEventListener("touchmove", this._preventDefault, false);
                            }
                        }
                    }, {
                        key: "_unbindEvents",
                        value: function _unbindEvents() {
                            this.settings.el.removeEventListener("mouseenter", this._handleEntry, false);
                            this.settings.el.removeEventListener("mouseleave", this._hide, false);
                            this.settings.el.removeEventListener("mousemove", this._handleMovement, false);

                            if (this.settings.handleTouch) {
                                this.settings.el.removeEventListener("touchstart", this._handleEntry, false);
                                this.settings.el.removeEventListener("touchend", this._hide, false);
                                this.settings.el.removeEventListener("touchmove", this._handleMovement, false);
                            } else {
                                this.settings.el.removeEventListener("touchstart", this._preventDefault, false);
                                this.settings.el.removeEventListener("touchend", this._preventDefault, false);
                                this.settings.el.removeEventListener("touchmove", this._preventDefault, false);
                            }
                        }
                    }, {
                        key: "_handleEntry",
                        value: function _handleEntry(e) {
                            this._preventDefaultAllowTouchScroll(e);

                            this._lastMovement = e;

                            if (e.type == "mouseenter" && this.settings.hoverDelay) {
                                this.entryTimeout = setTimeout(this._show, this.settings.hoverDelay);
                            } else if (this.settings.touchDelay) {
                                this.entryTimeout = setTimeout(this._show, this.settings.touchDelay);
                            } else {
                                this._show();
                            }
                        }
                    }, {
                        key: "_show",
                        value: function _show() {
                            if (!this.enabled) {
                                return;
                            }

                            var onShow = this.settings.onShow;

                            if (onShow && typeof onShow === "function") {
                                onShow();
                            }

                            this.settings.zoomPane.show(this.settings.el.getAttribute(this.settings.sourceAttribute), this.settings.el.clientWidth, this.settings.el.clientHeight);

                            if (this._lastMovement) {
                                var touchActivated = this._lastMovement.touches;

                                if (touchActivated && this.settings.touchBoundingBox || !touchActivated && this.settings.hoverBoundingBox) {
                                    this.boundingBox.show(this.settings.zoomPane.el.clientWidth, this.settings.zoomPane.el.clientHeight);
                                }
                            }

                            this._handleMovement();
                        }
                    }, {
                        key: "_hide",
                        value: function _hide(e) {
                            if (e) {
                                this._preventDefaultAllowTouchScroll(e);
                            }

                            this._lastMovement = null;

                            if (this.entryTimeout) {
                                clearTimeout(this.entryTimeout);
                            }

                            if (this.boundingBox) {
                                this.boundingBox.hide();
                            }

                            var onHide = this.settings.onHide;

                            if (onHide && typeof onHide === "function") {
                                onHide();
                            }

                            this.settings.zoomPane.hide();
                        }
                    }, {
                        key: "_handleMovement",
                        value: function _handleMovement(e) {
                            if (e) {
                                this._preventDefaultAllowTouchScroll(e);

                                this._lastMovement = e;
                            } else if (this._lastMovement) {
                                e = this._lastMovement;
                            } else {
                                return;
                            }

                            var movementX;
                            var movementY;

                            if (e.touches) {
                                var firstTouch = e.touches[0];
                                movementX = firstTouch.clientX;
                                movementY = firstTouch.clientY;
                            } else {
                                movementX = e.clientX;
                                movementY = e.clientY;
                            }

                            var el = this.settings.el;
                            var rect = el.getBoundingClientRect();
                            var offsetX = movementX - rect.left;
                            var offsetY = movementY - rect.top;
                            var percentageOffsetX = offsetX / this.settings.el.clientWidth;
                            var percentageOffsetY = offsetY / this.settings.el.clientHeight;

                            if (this.boundingBox) {
                                this.boundingBox.setPosition(percentageOffsetX, percentageOffsetY, rect);
                            }

                            this.settings.zoomPane.setPosition(percentageOffsetX, percentageOffsetY, rect);
                        }
                    }, {
                        key: "isShowing",
                        get: function get() {
                            return this.settings.zoomPane.isShowing;
                        }
                    }]);

                    return Trigger;
                }();


//# sourceMappingURL=Trigger.js.map
// CONCATENATED MODULE: ./node_modules/drift-zoom/es/ZoomPane.js
        function ZoomPane_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

        function ZoomPane_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

        function ZoomPane_createClass(Constructor, protoProps, staticProps) { if (protoProps) ZoomPane_defineProperties(Constructor.prototype, protoProps); if (staticProps) ZoomPane_defineProperties(Constructor, staticProps); return Constructor; }


        // All officially-supported browsers have this, but it's easy to
// account for, just in case.

        var divStyle = document.createElement("div").style;
        var HAS_ANIMATION = typeof document === "undefined" ? false : "animation" in divStyle || "webkitAnimation" in divStyle;

        var ZoomPane_ZoomPane =
                /*#__PURE__*/
                function () {
                    function ZoomPane() {
                        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                        ZoomPane_classCallCheck(this, ZoomPane);

                        this._completeShow = this._completeShow.bind(this);
                        this._completeHide = this._completeHide.bind(this);
                        this._handleLoad = this._handleLoad.bind(this);
                        this.isShowing = false;
                        var _options$container = options.container,
                                container = _options$container === void 0 ? null : _options$container,
                                _options$zoomFactor = options.zoomFactor,
                                zoomFactor = _options$zoomFactor === void 0 ? throwIfMissing() : _options$zoomFactor,
                                _options$inline = options.inline,
                                inline = _options$inline === void 0 ? throwIfMissing() : _options$inline,
                                _options$namespace = options.namespace,
                                namespace = _options$namespace === void 0 ? null : _options$namespace,
                                _options$showWhitespa = options.showWhitespaceAtEdges,
                                showWhitespaceAtEdges = _options$showWhitespa === void 0 ? throwIfMissing() : _options$showWhitespa,
                                _options$containInlin = options.containInline,
                                containInline = _options$containInlin === void 0 ? throwIfMissing() : _options$containInlin,
                                _options$inlineOffset = options.inlineOffsetX,
                                inlineOffsetX = _options$inlineOffset === void 0 ? 0 : _options$inlineOffset,
                                _options$inlineOffset2 = options.inlineOffsetY,
                                inlineOffsetY = _options$inlineOffset2 === void 0 ? 0 : _options$inlineOffset2,
                                _options$inlineContai = options.inlineContainer,
                                inlineContainer = _options$inlineContai === void 0 ? document.body : _options$inlineContai;
                        this.settings = {
                            container: container,
                            zoomFactor: zoomFactor,
                            inline: inline,
                            namespace: namespace,
                            showWhitespaceAtEdges: showWhitespaceAtEdges,
                            containInline: containInline,
                            inlineOffsetX: inlineOffsetX,
                            inlineOffsetY: inlineOffsetY,
                            inlineContainer: inlineContainer
                        };
                        this.openClasses = this._buildClasses("open");
                        this.openingClasses = this._buildClasses("opening");
                        this.closingClasses = this._buildClasses("closing");
                        this.inlineClasses = this._buildClasses("inline");
                        this.loadingClasses = this._buildClasses("loading");

                        this._buildElement();
                    }

                    ZoomPane_createClass(ZoomPane, [{
                        key: "_buildClasses",
                        value: function _buildClasses(suffix) {
                            var classes = ["drift-".concat(suffix)];
                            var ns = this.settings.namespace;

                            if (ns) {
                                classes.push("".concat(ns, "-").concat(suffix));
                            }

                            return classes;
                        }
                    }, {
                        key: "_buildElement",
                        value: function _buildElement() {
                            this.el = document.createElement("div");
                            addClasses(this.el, this._buildClasses("zoom-pane"));
                            var loaderEl = document.createElement("div");
                            addClasses(loaderEl, this._buildClasses("zoom-pane-loader"));
                            this.el.appendChild(loaderEl);
                            this.imgEl = document.createElement("img");
                            this.el.appendChild(this.imgEl);
                        }
                    }, {
                        key: "_setImageURL",
                        value: function _setImageURL(imageURL) {
                            this.imgEl.setAttribute("src", imageURL);
                        }
                    }, {
                        key: "_setImageSize",
                        value: function _setImageSize(triggerWidth, triggerHeight) {
                            this.imgEl.style.width = "".concat(triggerWidth * this.settings.zoomFactor, "px");
                            this.imgEl.style.height = "".concat(triggerHeight * this.settings.zoomFactor, "px");
                        } // `percentageOffsetX` and `percentageOffsetY` must be percentages
                        // expressed as floats between `0' and `1`.

                    }, {
                        key: "setPosition",
                        value: function setPosition(percentageOffsetX, percentageOffsetY, triggerRect) {
                            var imgElWidth = this.imgEl.offsetWidth;
                            var imgElHeight = this.imgEl.offsetHeight;
                            var elWidth = this.el.offsetWidth;
                            var elHeight = this.el.offsetHeight;
                            var centreOfContainerX = elWidth / 2;
                            var centreOfContainerY = elHeight / 2;
                            var targetImgXToBeCentre = imgElWidth * percentageOffsetX;
                            var targetImgYToBeCentre = imgElHeight * percentageOffsetY;
                            var left = centreOfContainerX - targetImgXToBeCentre;
                            var top = centreOfContainerY - targetImgYToBeCentre;
                            var differenceBetweenContainerWidthAndImgWidth = elWidth - imgElWidth;
                            var differenceBetweenContainerHeightAndImgHeight = elHeight - imgElHeight;
                            var isContainerLargerThanImgX = differenceBetweenContainerWidthAndImgWidth > 0;
                            var isContainerLargerThanImgY = differenceBetweenContainerHeightAndImgHeight > 0;
                            var minLeft = isContainerLargerThanImgX ? differenceBetweenContainerWidthAndImgWidth / 2 : 0;
                            var minTop = isContainerLargerThanImgY ? differenceBetweenContainerHeightAndImgHeight / 2 : 0;
                            var maxLeft = isContainerLargerThanImgX ? differenceBetweenContainerWidthAndImgWidth / 2 : differenceBetweenContainerWidthAndImgWidth;
                            var maxTop = isContainerLargerThanImgY ? differenceBetweenContainerHeightAndImgHeight / 2 : differenceBetweenContainerHeightAndImgHeight;

                            if (this.el.parentElement === this.settings.inlineContainer) {
                                // This may be needed in the future to deal with browser event
                                // inconsistencies, but it's difficult to tell for sure.
                                // let scrollX = isTouch ? 0 : window.scrollX;
                                // let scrollY = isTouch ? 0 : window.scrollY;
                                var scrollX = window.pageXOffset;
                                var scrollY = window.pageYOffset;
                                var inlineLeft = triggerRect.left + percentageOffsetX * triggerRect.width - elWidth / 2 + this.settings.inlineOffsetX + scrollX;
                                var inlineTop = triggerRect.top + percentageOffsetY * triggerRect.height - elHeight / 2 + this.settings.inlineOffsetY + scrollY;

                                if (this.settings.containInline) {
                                    if (inlineLeft < triggerRect.left + scrollX) {
                                        inlineLeft = triggerRect.left + scrollX;
                                    } else if (inlineLeft + elWidth > triggerRect.left + triggerRect.width + scrollX) {
                                        inlineLeft = triggerRect.left + triggerRect.width - elWidth + scrollX;
                                    }

                                    if (inlineTop < triggerRect.top + scrollY) {
                                        inlineTop = triggerRect.top + scrollY;
                                    } else if (inlineTop + elHeight > triggerRect.top + triggerRect.height + scrollY) {
                                        inlineTop = triggerRect.top + triggerRect.height - elHeight + scrollY;
                                    }
                                }

                                this.el.style.left = "".concat(inlineLeft, "px");
                                this.el.style.top = "".concat(inlineTop, "px");
                            }

                            if (!this.settings.showWhitespaceAtEdges) {
                                if (left > minLeft) {
                                    left = minLeft;
                                } else if (left < maxLeft) {
                                    left = maxLeft;
                                }

                                if (top > minTop) {
                                    top = minTop;
                                } else if (top < maxTop) {
                                    top = maxTop;
                                }
                            }

                            this.imgEl.style.transform = "translate(".concat(left, "px, ").concat(top, "px)");
                            this.imgEl.style.webkitTransform = "translate(".concat(left, "px, ").concat(top, "px)");
                        }
                    }, {
                        key: "_removeListenersAndResetClasses",
                        value: function _removeListenersAndResetClasses() {
                            this.el.removeEventListener("animationend", this._completeShow, false);
                            this.el.removeEventListener("animationend", this._completeHide, false);
                            this.el.removeEventListener("webkitAnimationEnd", this._completeShow, false);
                            this.el.removeEventListener("webkitAnimationEnd", this._completeHide, false);
                            removeClasses(this.el, this.openClasses);
                            removeClasses(this.el, this.closingClasses);
                        }
                    }, {
                        key: "show",
                        value: function show(imageURL, triggerWidth, triggerHeight) {
                            this._removeListenersAndResetClasses();

                            this.isShowing = true;
                            addClasses(this.el, this.openClasses);

                            if (this.imgEl.getAttribute("src") != imageURL) {
                                addClasses(this.el, this.loadingClasses);
                                this.imgEl.addEventListener("load", this._handleLoad, false);

                                this._setImageURL(imageURL);
                            }

                            this._setImageSize(triggerWidth, triggerHeight);

                            if (this._isInline) {
                                this._showInline();
                            } else {
                                this._showInContainer();
                            }

                            if (HAS_ANIMATION) {
                                this.el.addEventListener("animationend", this._completeShow, false);
                                this.el.addEventListener("webkitAnimationEnd", this._completeShow, false);
                                addClasses(this.el, this.openingClasses);
                            }
                        }
                    }, {
                        key: "_showInline",
                        value: function _showInline() {
                            this.settings.inlineContainer.appendChild(this.el);
                            addClasses(this.el, this.inlineClasses);
                        }
                    }, {
                        key: "_showInContainer",
                        value: function _showInContainer() {
                            this.settings.container.appendChild(this.el);
                        }
                    }, {
                        key: "hide",
                        value: function hide() {
                            this._removeListenersAndResetClasses();

                            this.isShowing = false;

                            if (HAS_ANIMATION) {
                                this.el.addEventListener("animationend", this._completeHide, false);
                                this.el.addEventListener("webkitAnimationEnd", this._completeHide, false);
                                addClasses(this.el, this.closingClasses);
                            } else {
                                removeClasses(this.el, this.openClasses);
                                removeClasses(this.el, this.inlineClasses);
                            }
                        }
                    }, {
                        key: "_completeShow",
                        value: function _completeShow() {
                            this.el.removeEventListener("animationend", this._completeShow, false);
                            this.el.removeEventListener("webkitAnimationEnd", this._completeShow, false);
                            removeClasses(this.el, this.openingClasses);
                        }
                    }, {
                        key: "_completeHide",
                        value: function _completeHide() {
                            this.el.removeEventListener("animationend", this._completeHide, false);
                            this.el.removeEventListener("webkitAnimationEnd", this._completeHide, false);
                            removeClasses(this.el, this.openClasses);
                            removeClasses(this.el, this.closingClasses);
                            removeClasses(this.el, this.inlineClasses);
                            this.el.setAttribute("style", ""); // The window could have been resized above or below `inline`
                            // limits since the ZoomPane was shown. Because of this, we
                            // can't rely on `this._isInline` here.

                            if (this.el.parentElement === this.settings.container) {
                                this.settings.container.removeChild(this.el);
                            } else if (this.el.parentElement === this.settings.inlineContainer) {
                                this.settings.inlineContainer.removeChild(this.el);
                            }
                        }
                    }, {
                        key: "_handleLoad",
                        value: function _handleLoad() {
                            this.imgEl.removeEventListener("load", this._handleLoad, false);
                            removeClasses(this.el, this.loadingClasses);
                        }
                    }, {
                        key: "_isInline",
                        get: function get() {
                            var inline = this.settings.inline;
                            return inline === true || typeof inline === "number" && window.innerWidth <= inline;
                        }
                    }]);

                    return ZoomPane;
                }();


//# sourceMappingURL=ZoomPane.js.map
// CONCATENATED MODULE: ./node_modules/drift-zoom/es/Drift.js
        function Drift_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

        function Drift_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

        function Drift_createClass(Constructor, protoProps, staticProps) { if (protoProps) Drift_defineProperties(Constructor.prototype, protoProps); if (staticProps) Drift_defineProperties(Constructor, staticProps); return Constructor; }






        var Drift_Drift =
                /*#__PURE__*/
                function () {
                    function Drift(triggerEl) {
                        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

                        Drift_classCallCheck(this, Drift);

                        this.VERSION = "1.4.0";
                        this.triggerEl = triggerEl;
                        this.destroy = this.destroy.bind(this);

                        if (!isDOMElement(this.triggerEl)) {
                            throw new TypeError("`new Drift` requires a DOM element as its first argument.");
                        } // Prefix for generated element class names (e.g. `my-ns` will
                        // result in classes such as `my-ns-pane`. Default `drift-`
                        // prefixed classes will always be added as well.


                        var namespace = options["namespace"] || null; // Whether the ZoomPane should show whitespace when near the edges.

                        var showWhitespaceAtEdges = options["showWhitespaceAtEdges"] || false; // Whether the inline ZoomPane should stay inside
                        // the bounds of its image.

                        var containInline = options["containInline"] || false; // How much to offset the ZoomPane from the
                        // interaction point when inline.

                        var inlineOffsetX = options["inlineOffsetX"] || 0;
                        var inlineOffsetY = options["inlineOffsetY"] || 0; // A DOM element to append the inline ZoomPane to

                        var inlineContainer = options["inlineContainer"] || document.body; // Which trigger attribute to pull the ZoomPane image source from.

                        var sourceAttribute = options["sourceAttribute"] || "data-zoom"; // How much to magnify the trigger by in the ZoomPane.
                        // (e.g., `zoomFactor: 3` will result in a 900 px wide ZoomPane imag
                        // if the trigger is displayed at 300 px wide)

                        var zoomFactor = options["zoomFactor"] || 3; // A DOM element to append the non-inline ZoomPane to.
                        // Required if `inlinePane !== true`.

                        var paneContainer = options["paneContainer"] === undefined ? document.body : options["paneContainer"]; // When to switch to an inline ZoomPane. This can be a boolean or
                        // an integer. If `true`, the ZoomPane will always be inline,
                        // if `false`, it will switch to inline when `windowWidth <= inlinePane`

                        var inlinePane = options["inlinePane"] || 375; // If `true`, touch events will trigger the zoom, like mouse events.

                        var handleTouch = "handleTouch" in options ? !!options["handleTouch"] : true; // If present (and a function), this will be called
                        // whenever the ZoomPane is shown.

                        var onShow = options["onShow"] || null; // If present (and a function), this will be called
                        // whenever the ZoomPane is hidden.

                        var onHide = options["onHide"] || null; // Add base styles to the page. See the "Theming"
                        // section of README.md for more information.

                        var injectBaseStyles = "injectBaseStyles" in options ? !!options["injectBaseStyles"] : true; // An optional number that determines how long to wait before
                        // showing the ZoomPane because of a `mouseenter` event.

                        var hoverDelay = options["hoverDelay"] || 0; // An optional number that determines how long to wait before
                        // showing the ZoomPane because of a `touchstart` event.
                        // It's unlikely that you would want to use this option, since
                        // "tap and hold" is much more intentional than a hover event.

                        var touchDelay = options["touchDelay"] || 0; // If true, a bounding box will show the area currently being previewed
                        // during mouse hover

                        var hoverBoundingBox = options["hoverBoundingBox"] || false; // If true, a bounding box will show the area currently being previewed
                        // during touch events

                        var touchBoundingBox = options["touchBoundingBox"] || false; // A DOM element to append the bounding box to.

                        var boundingBoxContainer = options["boundingBoxContainer"] || document.body;

                        if (inlinePane !== true && !isDOMElement(paneContainer)) {
                            throw new TypeError("`paneContainer` must be a DOM element when `inlinePane !== true`");
                        }

                        if (!isDOMElement(inlineContainer)) {
                            throw new TypeError("`inlineContainer` must be a DOM element");
                        }

                        this.settings = {
                            namespace: namespace,
                            showWhitespaceAtEdges: showWhitespaceAtEdges,
                            containInline: containInline,
                            inlineOffsetX: inlineOffsetX,
                            inlineOffsetY: inlineOffsetY,
                            inlineContainer: inlineContainer,
                            sourceAttribute: sourceAttribute,
                            zoomFactor: zoomFactor,
                            paneContainer: paneContainer,
                            inlinePane: inlinePane,
                            handleTouch: handleTouch,
                            onShow: onShow,
                            onHide: onHide,
                            injectBaseStyles: injectBaseStyles,
                            hoverDelay: hoverDelay,
                            touchDelay: touchDelay,
                            hoverBoundingBox: hoverBoundingBox,
                            touchBoundingBox: touchBoundingBox,
                            boundingBoxContainer: boundingBoxContainer
                        };

                        if (this.settings.injectBaseStyles) {
                            injectBaseStylesheet();
                        }

                        this._buildZoomPane();

                        this._buildTrigger();
                    }

                    Drift_createClass(Drift, [{
                        key: "_buildZoomPane",
                        value: function _buildZoomPane() {
                            this.zoomPane = new ZoomPane_ZoomPane({
                                container: this.settings.paneContainer,
                                zoomFactor: this.settings.zoomFactor,
                                showWhitespaceAtEdges: this.settings.showWhitespaceAtEdges,
                                containInline: this.settings.containInline,
                                inline: this.settings.inlinePane,
                                namespace: this.settings.namespace,
                                inlineOffsetX: this.settings.inlineOffsetX,
                                inlineOffsetY: this.settings.inlineOffsetY,
                                inlineContainer: this.settings.inlineContainer
                            });
                        }
                    }, {
                        key: "_buildTrigger",
                        value: function _buildTrigger() {
                            this.trigger = new Trigger_Trigger({
                                el: this.triggerEl,
                                zoomPane: this.zoomPane,
                                handleTouch: this.settings.handleTouch,
                                onShow: this.settings.onShow,
                                onHide: this.settings.onHide,
                                sourceAttribute: this.settings.sourceAttribute,
                                hoverDelay: this.settings.hoverDelay,
                                touchDelay: this.settings.touchDelay,
                                hoverBoundingBox: this.settings.hoverBoundingBox,
                                touchBoundingBox: this.settings.touchBoundingBox,
                                namespace: this.settings.namespace,
                                zoomFactor: this.settings.zoomFactor,
                                boundingBoxContainer: this.settings.boundingBoxContainer
                            });
                        }
                    }, {
                        key: "setZoomImageURL",
                        value: function setZoomImageURL(imageURL) {
                            this.zoomPane._setImageURL(imageURL);
                        }
                    }, {
                        key: "disable",
                        value: function disable() {
                            this.trigger.enabled = false;
                        }
                    }, {
                        key: "enable",
                        value: function enable() {
                            this.trigger.enabled = true;
                        }
                    }, {
                        key: "destroy",
                        value: function destroy() {
                            this.trigger._hide();

                            this.trigger._unbindEvents();
                        }
                    }, {
                        key: "isShowing",
                        get: function get() {
                            return this.zoomPane.isShowing;
                        }
                    }, {
                        key: "zoomFactor",
                        get: function get() {
                            return this.settings.zoomFactor;
                        },
                        set: function set(zf) {
                            this.settings.zoomFactor = zf;
                            this.zoomPane.settings.zoomFactor = zf;
                            this.trigger.settings.zoomFactor = zf;
                            this.boundingBox.settings.zoomFactor = zf;
                        }
                    }]);

                    return Drift;
                }(); // Public API

        /* eslint-disable no-self-assign */



        Object.defineProperty(Drift_Drift.prototype, "isShowing", {
            get: function get() {
                return this.isShowing;
            }
        });
        Object.defineProperty(Drift_Drift.prototype, "zoomFactor", {
            get: function get() {
                return this.zoomFactor;
            },
            set: function set(value) {
                this.zoomFactor = value;
            }
        });
        Drift_Drift.prototype["setZoomImageURL"] = Drift_Drift.prototype.setZoomImageURL;
        Drift_Drift.prototype["disable"] = Drift_Drift.prototype.disable;
        Drift_Drift.prototype["enable"] = Drift_Drift.prototype.enable;
        Drift_Drift.prototype["destroy"] = Drift_Drift.prototype.destroy;
        /* eslint-enable no-self-assign */
//# sourceMappingURL=Drift.js.map
// EXTERNAL MODULE: ./node_modules/flickity/js/index.js
        var js = __webpack_require__(4);
        var js_default = /*#__PURE__*/__webpack_require__.n(js);

// CONCATENATED MODULE: ./source/scripts/components/Youtube.js
        function Youtube_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

        function Youtube_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

        function Youtube_createClass(Constructor, protoProps, staticProps) { if (protoProps) Youtube_defineProperties(Constructor.prototype, protoProps); if (staticProps) Youtube_defineProperties(Constructor, staticProps); return Constructor; }


        var api = 'https://www.youtube.com/iframe_api';
        var apiLoadedCallbacks = [];
        var apiLoaded = false;

        window.onYouTubeIframeAPIReady = function () {
            apiLoadedCallbacks.forEach(function (apiLoadedCallback) {
                return apiLoadedCallback();
            });
            apiLoadedCallbacks = [];
            apiLoaded = true;
        };

        var Youtube_Youtube = /*#__PURE__*/function () {
            function Youtube(_ref) {
                var el = _ref.el,
                        videoUrl = _ref.videoUrl,
                        loop = _ref.loop;

                Youtube_classCallCheck(this, Youtube);

                var regex = /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/ ]{11})/i; // eslint-disable-line no-useless-escape

                this.el = el;
                this.id = videoUrl.match(regex)[1] || null;
                this.onApiLoaded = this._onApiLoaded.bind(this);
                this.isReady = false;
                this.onReady = this._onReady.bind(this);
                this.onReadyCallback = null;
                this.loop = loop ? 1 : 0;
                this.onStateChange = this._onStateChange.bind(this);
                this.onPlayCallback = null;

                if (apiLoaded) {
                    this._onApiLoaded();
                } else {
                    apiLoadedCallbacks.push(this.onApiLoaded);
                    script_default()(api);
                }
            }

            Youtube_createClass(Youtube, [{
                key: "play",
                value: function play() {
                    var _this = this;

                    return new Promise(function (resolve) {
                        _this.onPlayCallback = resolve;

                        if (_this.isReady) {
                            _this.player.playVideo();
                        } else {
                            _this.onReadyCallback = function () {
                                _this.player.playVideo();
                            };
                        }
                    });
                }
            }, {
                key: "pause",
                value: function pause() {
                    var _this2 = this;

                    return new Promise(function (resolve) {
                        _this2.onPlayCallback = resolve;

                        if (_this2.isReady) {
                            _this2.player.pauseVideo();
                        } else {
                            _this2.onReadyCallback = function () {
                                _this2.player.pauseVideo();
                            };
                        }
                    });
                }
            }, {
                key: "autoplay",
                value: function autoplay() {
                    var _this3 = this;

                    return new Promise(function (resolve) {
                        _this3.onPlayCallback = resolve;

                        if (_this3.isReady) {
                            _this3.player.playVideo();

                            _this3.player.mute();
                        } else {
                            _this3.onReadyCallback = function () {
                                _this3.player.playVideo();

                                _this3.player.mute();
                            };
                        }
                    });
                }
            }, {
                key: "unload",
                value: function unload() {
                    this.player.destroy();
                }
            }, {
                key: "_onApiLoaded",
                value: function _onApiLoaded() {
                    var playerVars = {
                        modestbranding: true,
                        showinfo: false,
                        controls: false,
                        loop: this.loop,
                        rel: 0
                    };

                    if (this.loop) {
                        // This is required to allow 'loop' to work based on the YouTube api
                        playerVars.playlist = this.id;
                    }

                    this.player = new YT.Player(this.el, {
                        videoId: this.id,
                        playerVars: playerVars,
                        events: {
                            onReady: this.onReady,
                            onStateChange: this.onStateChange
                        }
                    });
                }
            }, {
                key: "_onReady",
                value: function _onReady() {
                    this.isReady = true;

                    if (this.onReadyCallback) {
                        this.onReadyCallback();
                    }
                }
            }, {
                key: "_onStateChange",
                value: function _onStateChange(event) {
                    var state = event.data;

                    if (this.onPlayCallback && state === YT.PlayerState.BUFFERING) {
                        this.onPlayCallback();
                        this.onPlayCallback = null;
                    }
                }
            }]);

            return Youtube;
        }();


// CONCATENATED MODULE: ./source/scripts/components/Vimeo.js
        function Vimeo_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

        function Vimeo_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

        function Vimeo_createClass(Constructor, protoProps, staticProps) { if (protoProps) Vimeo_defineProperties(Constructor.prototype, protoProps); if (staticProps) Vimeo_defineProperties(Constructor, staticProps); return Constructor; }


        var Vimeo_api = 'https://player.vimeo.com/api/player.js';
        var Vimeo_apiLoaded = false;

        var Vimeo_VimeoPlayer = /*#__PURE__*/function () {
            function VimeoPlayer(_ref) {
                var el = _ref.el,
                        videoUrl = _ref.videoUrl;

                Vimeo_classCallCheck(this, VimeoPlayer);

                this.el = el;
                var urlParts = videoUrl.split('/');
                this.id = urlParts[urlParts.length - 1];
                this.onReadyCallback = null;
                this.onApiLoaded = this._onApiLoaded.bind(this);
                this.onProgress = this._onProgress.bind(this);
                this.onProgressCallback = null;

                if (Vimeo_apiLoaded) {
                    this._onApiLoaded();
                } else {
                    script_default()(Vimeo_api, this.onApiLoaded);
                }
            }

            Vimeo_createClass(VimeoPlayer, [{
                key: "play",
                value: function play() {
                    var _this = this;

                    return new Promise(function (resolve) {
                        _this.onProgressCallback = resolve;

                        if (Vimeo_apiLoaded) {
                            _this.player.on('play', _this.onProgress);

                            _this.player.play();
                        } else {
                            _this.onReadyCallback = function () {
                                _this.player.on('play', _this.onProgress);

                                _this.player.play();
                            };
                        }
                    });
                }
            }, {
                key: "pause",
                value: function pause() {
                    var _this2 = this;

                    return new Promise(function (resolve) {
                        _this2.onProgressCallback = resolve;

                        if (Vimeo_apiLoaded) {
                            _this2.player.on('pause', _this2.onProgress);

                            _this2.player.pause();
                        } else {
                            _this2.onReadyCallback = function () {
                                _this2.player.on('pause', _this2.onProgress);

                                _this2.player.pause();
                            };
                        }
                    });
                }
            }, {
                key: "autoplay",
                value: function autoplay() {
                    var _this3 = this;

                    return new Promise(function (resolve) {
                        _this3.onProgressCallback = resolve;

                        if (Vimeo_apiLoaded) {
                            _this3.player.on('play', _this3.onProgress);

                            _this3.player.setVolume(0);

                            _this3.player.play();
                        } else {
                            _this3.onReadyCallback = function () {
                                _this3.player.on('play', _this3.onProgress);

                                _this3.player.setVolume(0);

                                _this3.player.play();
                            };
                        }
                    });
                }
            }, {
                key: "unload",
                value: function unload() {
                    this.player.unload().catch();
                }
            }, {
                key: "_onApiLoaded",
                value: function _onApiLoaded() {
                    this.player = new window.Vimeo.Player(this.el, {
                        id: this.id
                    });
                    this.player.ready().then().catch();
                    Vimeo_apiLoaded = true;

                    if (this.onReadyCallback) {
                        this.onReadyCallback();
                    }
                }
            }, {
                key: "_onProgress",
                value: function _onProgress() {
                    this.player.off('play', this.onProgress);
                    this.player.off('pause', this.onProgress);

                    if (this.onProgressCallback) {
                        this.onProgressCallback();
                        this.onProgressCallback = null;
                    }
                }
            }]);

            return VimeoPlayer;
        }();


// CONCATENATED MODULE: ./source/scripts/components/Video.js
        function Video_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

        function Video_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

        function Video_createClass(Constructor, protoProps, staticProps) { if (protoProps) Video_defineProperties(Constructor.prototype, protoProps); if (staticProps) Video_defineProperties(Constructor, staticProps); return Constructor; }




        var Video_Video = /*#__PURE__*/function () {
            function Video(el, options) {
                Video_classCallCheck(this, Video);

                this.el = el;
                this.options = options;
                this.platform = el.getAttribute('data-video').trim();
                this.playButton = el.querySelector('[data-video-play-button]');
                this.videoEl = el.querySelector('[data-video-element]');
                this.onPlayClick = this._onPlayClick.bind(this);
                this.onPauseClick = this._onPauseClick.bind(this);
                this.autoplay = this._autoplay.bind(this);
                this.video = null;
                this.videoData = {
                    el: this.videoEl.childNodes[0],
                    videoUrl: this.videoEl.getAttribute('data-video-url'),
                    loop: this.options && this.options.loop
                };

                switch (this.platform) {
                    case 'youtube':
                        this.video = new Youtube_Youtube(this.videoData);
                        break;

                    case 'vimeo':
                        this.video = new Vimeo_VimeoPlayer(this.videoData);
                        break;

                    default:
                        this.video = null;
                        break;
                }

                this.el.addEventListener('click', this.onPlayClick);

                if (this.playButton) {
                    if (this.options && this.options.autoplay) {
                        this.autoplay();
                    }

                    this.playButton.addEventListener('click', this.onPlayClick);
                }
            }

            Video_createClass(Video, [{
                key: "_onPlayClick",
                value: function _onPlayClick() {
                    var _this = this;

                    this.el.classList.add('video-loading');
                    this.video.play().then(function () {
                        _this.el.classList.add('video-transitioning');

                        setTimeout(function () {
                            _this.el.classList.remove('video-loading');

                            _this.el.classList.remove('video-transitioning');

                            _this.el.classList.add('video-playing');
                        }, 200);
                    });
                }
            }, {
                key: "_onPauseClick",
                value: function _onPauseClick() {
                    this.video.pause();
                }
            }, {
                key: "_autoplay",
                value: function _autoplay() {
                    var _this2 = this;

                    this.el.classList.add('video-loading');
                    this.video.autoplay().then(function () {
                        _this2.el.classList.add('video-transitioning');

                        setTimeout(function () {
                            _this2.el.classList.remove('video-loading');

                            _this2.el.classList.remove('video-transitioning');

                            _this2.el.classList.add('video-playing');
                        }, 200);
                    });
                }
            }, {
                key: "play",
                value: function play() {
                    this._onPlayClick();
                }
            }, {
                key: "pause",
                value: function pause() {
                    this._onPauseClick();
                }
            }, {
                key: "unload",
                value: function unload() {
                    this.el.removeEventListener('click', this.onPlayClick);

                    if (this.playButton) {
                        this.playButton.removeEventListener('click', this.onPlayClick);
                    }

                    if (this.video) {
                        this.video.unload();
                    }
                }
            }, {
                key: "destroy",
                value: function destroy() {
                    this.unload();
                }
            }]);

            return Video;
        }();


// EXTERNAL MODULE: ./node_modules/photoswipe/dist/photoswipe.js
        var photoswipe = __webpack_require__(14);
        var photoswipe_default = /*#__PURE__*/__webpack_require__.n(photoswipe);

// EXTERNAL MODULE: ./node_modules/photoswipe/dist/photoswipe-ui-default.js
        var photoswipe_ui_default = __webpack_require__(15);
        var photoswipe_ui_default_default = /*#__PURE__*/__webpack_require__.n(photoswipe_ui_default);

// CONCATENATED MODULE: ./source/scripts/components/ProductClickToZoom.js
        function ProductClickToZoom_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

        function ProductClickToZoom_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

        function ProductClickToZoom_createClass(Constructor, protoProps, staticProps) { if (protoProps) ProductClickToZoom_defineProperties(Constructor.prototype, protoProps); if (staticProps) ProductClickToZoom_defineProperties(Constructor, staticProps); return Constructor; }








        var ProductClickToZoom_ProductClickToZoom = /*#__PURE__*/function () {
            function ProductClickToZoom(_ref) {
                var _this = this;

                var settings = _ref.settings,
                        slides = _ref.slides,
                        originalThumbnails = _ref.originalThumbnails,
                        startIndex = _ref.startIndex,
                        selectGalleryIndex = _ref.selectGalleryIndex;

                ProductClickToZoom_classCallCheck(this, ProductClickToZoom);

                this.settings = settings;
                this.photoswipeDialog = document.querySelector('[data-photoswipe]');
                this.thumbContainer = this.photoswipeDialog.querySelector('[data-photoswipe-thumbs]');
                this.thumbScroller = this.photoswipeDialog.querySelector('[data-photoswipe-thumb-scroller]');
                this.thumbScrollerButtons = this.photoswipeDialog.querySelectorAll('[data-gallery-scroll-button]');
                this.closeButton = this.photoswipeDialog.querySelector('.pswp__button--close');
                this.selectedSlide = slides[startIndex];
                this.thumbScroller.innerHTML = '';
                this.thumbnails = [];
                var selectedIndex = startIndex; // Clone the original thumbnails into the photoswipe dialog

                originalThumbnails.forEach(function (thumb, thumbIndex) {
                    if (thumb.dataset.mediaType !== 'image') {
                        if (startIndex > thumbIndex) selectedIndex--;
                        return;
                    }

                    var newThumb = thumb.cloneNode(true);

                    _this.thumbScroller.appendChild(newThumb);

                    _this.thumbnails.push(newThumb);
                });
                rimg_shopify_dist_index_es.watch(this.thumbContainer);
                this.selectedThumb = this.thumbContainer.querySelector('[data-gallery-selected="true"]');
                this.events = new EventHandler_default.a(); // Set up options for initializing PhotoSwipe

                var photoswipeSlides = [];
                slides.forEach(function (slide) {
                    if (['video', 'external_video', 'model'].indexOf(slide.dataset.mediaType) > -1) return;
                    photoswipeSlides.push({
                        src: slide.dataset.zoom,
                        msrc: slide.dataset.zoom,
                        h: slide.dataset.imageHeight,
                        w: slide.dataset.imageWidth
                    });
                }); // Adjust the bottom bar height to allow for the mobile thumbnails

                var bottomBarHeight = Layout.isGreaterThanBreakpoint('L', true) ? 0 : 75;
                var photoswipeOptions = {
                    index: selectedIndex,
                    barsSize: {
                        top: 0,
                        bottom: bottomBarHeight
                    },
                    fullscreenEl: false,
                    zoomEl: false,
                    shareEl: false,
                    counterEl: false,
                    arrowEl: false,
                    preloaderEl: false,
                    closeOnScroll: false,
                    showHideOpacity: true,
                    history: false,
                    loop: true,
                    clickToCloseNonZoomable: false,
                    timeToIdle: false,
                    timeToIdleOutside: false
                };

                if (this.settings.click_to_zoom === 'always' || Layout.isGreaterThanBreakpoint('S', true) && this.settings.click_to_zoom === 'desktop' || Layout.isLessThanBreakpoint('S') && this.settings.click_to_zoom === 'mobile') {
                    photoswipeOptions.getThumbBoundsFn = function () {
                        var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;

                        var bounds = _this.selectedSlide.querySelector('[data-rimg]').getBoundingClientRect();

                        return {
                            x: bounds.left,
                            y: bounds.top + pageYScroll,
                            w: bounds.width
                        };
                    };
                }

                this.photoswipe = new photoswipe_default.a(this.photoswipeDialog, photoswipe_ui_default_default.a, photoswipeSlides, photoswipeOptions);
                this.events.register(this.closeButton, 'click', function () {
                    return _this.photoswipe.close();
                }); // The following fixes an issue on iOS12 and below, where click events were not registering

                this.events.register(this.closeButton, 'touchstart', function () {
                    return _this.photoswipe.close();
                });
                this.thumbnails.forEach(function (thumb, index) {
                    _this.events.register(thumb, 'click', function () {
                        _this.photoswipe.goTo(index);
                    });
                });
                this.events.register(this.thumbScroller, 'scroll', function () {
                    return _this._handleScrollButtonVisibility();
                });
                this.events.register(this.thumbScrollerButtons[0], 'click', function () {
                    return _this._onScrollButtonClick(true);
                });
                this.events.register(this.thumbScrollerButtons[1], 'click', function () {
                    return _this._onScrollButtonClick(false);
                }); // Photoswipe documentation claims that the closeOnVerticalDrag option is always false if
                // the mouse is used, which is what we want. Unfortunately that's not how it actually works,
                // so we need to dynamically update the setting when a mouse is detected.

                if (this.photoswipe.options.mouseUsed) {
                    this.photoswipe.options.closeOnVerticalDrag = false;
                } else {
                    this.photoswipe.listen('mouseUsed', function () {
                        _this.photoswipe.options.closeOnVerticalDrag = false;
                    });
                }

                this.photoswipe.listen('afterChange', function () {
                    var index = _this.photoswipe.getCurrentIndex();

                    if (_this.selectedThumb) {
                        _this.selectedThumb.dataset.gallerySelected = false;
                    }

                    _this.selectedThumb = _this.thumbnails[index];
                    _this.selectedThumb.dataset.gallerySelected = true;

                    var slideIndex = _this.selectedThumb.getAttribute('data-gallery-index');

                    var slide = slides[slideIndex];

                    _this._adjustMobileThumbPosition();

                    _this._handleScrollButtonVisibility();

                    selectGalleryIndex(slideIndex);
                    _this.selectedSlide = slide;
                });
                this.photoswipe.listen('close', function () {
                    removeTrapFocus(_this.photoswipeDialog);

                    _this.selectedSlide.focus();

                    _this.photoswipe = null;
                });
                this.photoswipe.listen('destroy', function () {
                    _this.events.unregisterAll();

                    _this.photoswipe = null;
                }); // Detect if mouse is over the thumbnails, if it is allow scroll left/right

                this.events.register(this.thumbContainer, 'mouseenter', function () {
                    if (Layout.isLessThanBreakpoint('S')) {
                        _this.photoswipe.options.closeOnScroll = true;
                    }
                });
                this.events.register(this.thumbContainer, 'mouseleave', function () {
                    if (Layout.isLessThanBreakpoint('S')) {
                        _this.photoswipe.options.closeOnScroll = false;
                    }
                }); // If a user closes the dialog using the escape key, then we should focus
                // on the expand button.

                var closeEsc = function closeEsc(e) {
                    if (e.key === 'Escape') {
                        slides[0].parentNode.querySelector('[data-gallery-expand]').focus();
                    }
                };

                this.events.register(window, 'keydown', function (e) {
                    return closeEsc(e);
                });
                this.photoswipe.init();
                trapFocus(this.photoswipeDialog);
            }

            ProductClickToZoom_createClass(ProductClickToZoom, [{
                key: "_adjustMobileThumbPosition",
                value: function _adjustMobileThumbPosition() {
                    // This brings the thumbnail into view if it is not visible on the screen after
                    // a user swipes to a slide that it is tied to.
                    if (Layout.isLessThanBreakpoint('S')) {
                        var thumbBounds = this.selectedThumb.getBoundingClientRect();
                        var thumbWrapperBounds = this.thumbScroller.getBoundingClientRect();

                        if (thumbBounds.left + thumbBounds.width + 30 > thumbWrapperBounds.width) {
                            this.thumbScroller.scrollLeft = this.selectedThumb.offsetLeft + thumbBounds.width - thumbWrapperBounds.width + 35;
                        } else if (this.selectedThumb.offsetLeft < this.thumbScroller.scrollLeft) {
                            this.thumbScroller.scrollLeft = this.selectedThumb.offsetLeft - 35;
                        }
                    }
                }
            }, {
                key: "_handleScrollButtonVisibility",
                value: function _handleScrollButtonVisibility() {
                    if (Layout.isLessThanBreakpoint('S')) {
                        // We use 4px here just to ensure the user has scrolled a little bit before
                        // showing the buttons.
                        if (this.thumbScroller.scrollLeft > 4) {
                            this.thumbScrollerButtons[0].classList.add('visible');
                        } else {
                            this.thumbScrollerButtons[0].classList.remove('visible');
                        }

                        if (this.thumbScroller.scrollLeft < this.thumbScroller.scrollWidth - this.thumbScroller.clientWidth) {
                            this.thumbScrollerButtons[1].classList.add('visible');
                        } else {
                            this.thumbScrollerButtons[1].classList.remove('visible');
                        }
                    } else {
                        this.thumbScrollerButtons[0].classList.remove('visible');
                        this.thumbScrollerButtons[1].classList.remove('visible');
                    }
                }
            }, {
                key: "_onScrollButtonClick",
                value: function _onScrollButtonClick(scrollRight) {
                    if (scrollRight) {
                        this.thumbScroller.scrollLeft = this.thumbScroller.scrollLeft - 100;
                    } else {
                        this.thumbScroller.scrollLeft = this.thumbScroller.scrollLeft + 100;
                    }
                }
            }, {
                key: "unload",
                value: function unload() {
                    if (this.photoswipe) {
                        this.photoswipe.destroy();
                        this.photoswipe = null;
                    }
                }
            }]);

            return ProductClickToZoom;
        }();


// CONCATENATED MODULE: ./source/scripts/components/ProductGallery.js
        function ProductGallery_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

        function ProductGallery_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

        function ProductGallery_createClass(Constructor, protoProps, staticProps) { if (protoProps) ProductGallery_defineProperties(Constructor.prototype, protoProps); if (staticProps) ProductGallery_defineProperties(Constructor, staticProps); return Constructor; }








        var loadPlyrStyles = null;

        var ProductGallery_ProductGallery = /*#__PURE__*/function () {
            function ProductGallery(_ref) {
                var _this = this;

                var el = _ref.el,
                        settings = _ref.settings,
                        isQuickshop = _ref.isQuickshop;

                ProductGallery_classCallCheck(this, ProductGallery);

                this.el = el;
                this.settings = settings;
                this.isQuickshop = isQuickshop || false;
                this.events = new EventHandler_default.a();
                this.viewer = this.el.querySelector('[data-gallery-viewer]');
                this.navigation = this.el.querySelector('[data-gallery-navigation]');
                this.navScroller = this.el.querySelector('[data-gallery-scroller]');
                this.navScrollerButtons = this.el.querySelectorAll('[data-gallery-scroll-button]');
                this.figures = this.viewer.querySelectorAll('[data-gallery-figure]');
                this.thumbnails = this.navigation.querySelectorAll('[data-gallery-thumbnail]');
                this.zoomButton = this.viewer.querySelector('[data-gallery-expand]');
                this.selected = {
                    figure: this.viewer.querySelector('[data-gallery-selected="true"]'),
                    thumbnail: this.navigation.querySelector('[data-gallery-selected="true"]')
                };
                this.models = {};
                this.videos = {};
                this.selectedVideo = null;
                this.selectedModel = null;
                this.showingInitialSlide = true;
                this._setupSelectedVideo = this._setupSelectedVideo.bind(this);
                var features = [];

                if (this.el.querySelector('[data-media-type="video"]')) {
                    if (!(loadPlyrStyles instanceof Promise)) {
                        loadPlyrStyles = new Promise(function (resolve) {
                            var stylesheet = document.createElement('link');
                            stylesheet.setAttribute('rel', 'stylesheet');
                            stylesheet.href = 'https://cdn.shopify.com/shopifycloud/shopify-plyr/v1.0/shopify-plyr.css';
                            stylesheet.onload = resolve;
                            document.body.appendChild(stylesheet);
                        });
                    }

                    features.push({
                        name: 'video-ui',
                        version: '1.0',
                        onLoad: function onLoad() {
                            return loadPlyrStyles.then(function () {
                                return _this._setupSelectedVideo();
                            });
                        }
                    });
                }

                if (this.el.querySelector('[data-media-type="model"]')) {
                    this.viewInYourSpaceEl = this.el.querySelector('[data-shopify-xr]');
                    this.events.register(this.viewInYourSpaceEl, 'click', function () {
                        return _this._onViewInYourSpaceClick();
                    });
                    features.push({
                        name: 'model-viewer-ui',
                        version: '1.0',
                        onLoad: this._onModelLibraryLoad.bind(this)
                    });
                    features.push({
                        name: 'shopify-xr',
                        version: '1.0'
                    });
                }

                if (features.length) {
                    window.Shopify.loadFeatures(features);
                }

                if (this.isQuickshop) {
                    rimg_shopify_dist_index_es.watch(this.el); // Because of the way the quickshop is animated to open, if a video is first in the
                    // gallery the height of the slide will not be correct, so we need to wait until all the
                    // transitions end. This will only fire once, as opposed to listening to transitionend.

                    if (this.figures[0].dataset.mediaType === 'video') {
                        setTimeout(function () {
                            return _this._setSlideHeight();
                        }, 800);
                    }
                }

                this.events.register(this.navScroller, 'click', function (e) {
                    return _this._onThumbnailClick(e);
                });
                this.events.register(this.navScroller, 'scroll', function () {
                    return _this._handleScrollButtonVisibility();
                });
                this.events.register(this.navScrollerButtons[0], 'click', function () {
                    return _this._onScrollButtonClick(true);
                });
                this.events.register(this.navScrollerButtons[1], 'click', function () {
                    return _this._onScrollButtonClick(false);
                });

                if (this.settings.click_to_zoom !== 'disabled') {
                    var onZoomButtonClick = function onZoomButtonClick(e) {
                        e.stopPropagation();

                        _this._openImageZoom();
                    };

                    this.events.register(this.zoomButton, 'click', function (e) {
                        return onZoomButtonClick(e);
                    });
                    this.events.register(this.viewer, 'click', function (e) {
                        return onZoomButtonClick(e);
                    });
                }

                this._onResize = this._onResize.bind(this);
                this.events.register(window, 'resize', function () {
                    return _this._onResize();
                });

                if (Layout.isLessThanBreakpoint('S')) {
                    this._setupFlickity();

                    this._handleScrollButtonVisibility();
                }

                this._selectMediaByEl(this.selected.figure);
            }

            ProductGallery_createClass(ProductGallery, [{
                key: "selectMediaByVariant",
                value: function selectMediaByVariant(variant) {
                    if (!variant.featured_media) return;
                    var slide = this.viewer.querySelector("[data-media=\"".concat(variant.featured_media.id, "\"]"));

                    this._selectMediaByEl(slide);
                }
            }, {
                key: "unload",
                value: function unload() {
                    this.events.unregisterAll();

                    for (var i; i < this.figures.length; i++) {
                        if (this.models[i]) {
                            this.models[i].destroy();
                        }

                        if (this.videos[i]) {
                            this.videos[i].destroy();
                        }
                    }

                    if (this.isQuickshop) {
                        rimg_shopify_dist_index_es.unwatch(this.el);
                    }

                    this._closeImageZoom();

                    this._disableHoverZoom();

                    this._disableFlickity();
                }
            }, {
                key: "_onModelLibraryLoad",
                value: function _onModelLibraryLoad() {
                    var _this2 = this;

                    var onPlayListener = function onPlayListener() {
                        if (_this2.flickity) {
                            _this2.flickity.unbindDrag();
                        }
                    };

                    var onPauseListener = function onPauseListener() {
                        if (_this2.flickity) {
                            _this2.flickity.bindDrag();
                        }
                    };

                    this.el.querySelectorAll('.product-gallery--model').forEach(function (figureEl) {
                        var modelEl = figureEl.querySelector('model-viewer');
                        var galleryIndex = figureEl.dataset.galleryIndex;
                        var controls = ['zoom-in', 'zoom-out'];
                        if (document.fullscreenEnabled) controls.push('fullscreen');
                        _this2.models[galleryIndex] = new Shopify.ModelViewerUI(modelEl, {
                            controls: controls
                        });

                        _this2.events.register(modelEl, 'shopify_model_viewer_ui_toggle_play', onPlayListener);

                        _this2.events.register(modelEl, 'shopify_model_viewer_ui_toggle_pause', onPauseListener);
                    });
                }
            }, {
                key: "_onResize",
                value: function _onResize() {
                    // If the resize was trigger by a fullscreen, do not do anything
                    if (document.fullscreenElement) {
                        return;
                    }

                    if (Layout.isGreaterThanBreakpoint('S', true)) {
                        this._disableFlickity();
                    } else {
                        this._setupFlickity();
                    }

                    if (Layout.isGreaterThanBreakpoint('L', true) && !this.drift) {
                        this._setupHoverZoom();
                    } else if (Layout.isLessThanBreakpoint('L')) {
                        this._disableHoverZoom();
                    }

                    this._adjustGalleryPositioning();

                    this._handleScrollButtonVisibility();
                }
            }, {
                key: "_onThumbnailClick",
                value: function _onThumbnailClick(e) {
                    var button;
                    this.showingInitialSlide = false; // The target will be the button itself if the user is using a keyboard to navigate, but
                    // otherwise it will be the image that is clicked on.

                    if (e.target.classList.contains('product-gallery--media-thumbnail')) {
                        button = e.target;
                    } else if (e.target.parentNode.parentNode.classList.contains('product-gallery--media-thumbnail')) {
                        button = e.target.parentNode.parentNode;
                    } else {
                        return;
                    }

                    var selectedIndex = parseInt(button.dataset.galleryIndex, 10);

                    if (this.flickity) {
                        this.flickity.select(selectedIndex);
                    } else {
                        this._selectMediaByIndex(selectedIndex);
                    }
                }
            }, {
                key: "_onViewInYourSpaceClick",
                value: function _onViewInYourSpaceClick(e) {
                    var currentTarget = e.currentTarget;
                    var figure = this.viewer.querySelector("[data-media=\"".concat(currentTarget.dataset.shopifyModel3dId, "\"]"));

                    this._selectMediaByEl(figure);
                }
            }, {
                key: "_selectMediaByEl",
                value: function _selectMediaByEl(el) {
                    this._selectMediaByIndex(parseInt(el.dataset.galleryIndex, 10));
                }
            }, {
                key: "_selectMediaByIndex",
                value: function _selectMediaByIndex(index) {
                    var figure = this.figures[index];
                    this.selected.figure.dataset.gallerySelected = false;
                    this.selected.figure.setAttribute('aria-hidden', true);
                    this.selected.figure = figure;
                    this.selected.figure.dataset.gallerySelected = true;
                    this.selected.figure.setAttribute('aria-hidden', false);
                    var figureIndex = parseInt(this.selected.figure.dataset.galleryIndex, 10);
                    this.selected.thumbnail.dataset.gallerySelected = false;
                    this.selected.thumbnail = this.thumbnails[figureIndex];
                    this.selected.thumbnail.dataset.gallerySelected = true;
                    var _this$selected$figure = this.selected.figure.dataset,
                            media = _this$selected$figure.media,
                            mediaType = _this$selected$figure.mediaType;
                    this.viewer.dataset.selectedMediaType = mediaType;

                    this._disableHoverZoom();

                    if (this.selectedModel) {
                        this.selectedModel.pause();
                    }

                    if (this.models[figure.dataset.galleryIndex]) {
                        this.selectedModel = this.models[figure.dataset.galleryIndex];

                        if (!document.documentElement.classList.contains('has-touch') && !this.showingInitialSlide) {
                            this.selectedModel.play();
                        }
                    }

                    if (this.selectedVideo) {
                        this.selectedVideo.pause();
                    }

                    if (this.viewInYourSpaceEl) {
                        this.viewInYourSpaceEl.dataset.shopifyModel3dId = this.viewInYourSpaceEl.dataset.defaultModelId;
                    }

                    switch (mediaType) {
                        case 'model':
                            this.viewInYourSpaceEl.dataset.shopifyModel3dId = media;
                            break;

                        case 'video':
                        case 'external_video':
                            this._setupSelectedVideo();

                            break;

                        case 'image':
                            this._setupHoverZoom();

                            break;

                        default:
                            break;
                    }

                    if (this.flickity) {
                        this.flickity.bindDrag();
                        this.flickity.select(index);
                    }

                    this._adjustGalleryPositioning();
                }
            }, {
                key: "_setupSelectedVideo",
                value: function _setupSelectedVideo() {
                    if (this.selectedVideo) {
                        this.selectedVideo.pause();
                    }

                    var _this$selected$figure2 = this.selected.figure.dataset,
                            mediaType = _this$selected$figure2.mediaType,
                            galleryIndex = _this$selected$figure2.galleryIndex;
                    var shouldAutoplay = Layout.isGreaterThanBreakpoint('L', true) && this.settings.gallery_video_autoplay && !this.showingInitialSlide;

                    if (mediaType === 'video' || mediaType === 'external_video') {
                        var videoElement;

                        if (this.videos[galleryIndex]) {
                            this.selectedVideo = this.videos[galleryIndex];
                            if (shouldAutoplay) this.selectedVideo.play();
                        } else {
                            if (mediaType === 'video') {
                                // Plyr hasn't loaded yet, will be called again after loadFeatures
                                if (!Shopify.Plyr) return;
                                videoElement = this.selected.figure.querySelector('video');
                                this.selectedVideo = new Shopify.Plyr(videoElement, {
                                    loop: {
                                        active: this.settings.gallery_video_looping
                                    }
                                });
                                if (shouldAutoplay) this.selectedVideo.play();
                            } else {
                                videoElement = this.selected.figure.querySelector('[data-video]');
                                this.selectedVideo = new Video_Video(videoElement, {
                                    loop: this.settings.gallery_video_looping
                                });
                                if (shouldAutoplay) this.selectedVideo.play();
                            }

                            this.videos[galleryIndex] = this.selectedVideo;
                        }

                        this.selected.figure.focus();
                    }
                }
            }, {
                key: "_setupHoverZoom",
                value: function _setupHoverZoom() {
                    var _this3 = this;

                    if (this.settings.hover_zoom === 'disabled' || !Layout.isGreaterThanBreakpoint('L', true) || this.selected.figure.dataset.mediaType !== 'image' || document.documentElement.classList.contains('has-touch')) return;
                    var selectedImage = this.selected.figure.querySelector('[data-rimg]');
                    selectedImage.setAttribute('data-zoom', this.selected.figure.getAttribute('data-zoom'));
                    this.drift = new Drift_Drift(selectedImage, {
                        paneContainer: this.settings.hover_zoom === 'separate' ? this.el.querySelector('[data-zoomed-image]') : this.selected.figure,
                        inlinePane: false,
                        hoverBoundingBox: this.settings.hover_zoom === 'separate',
                        handleTouch: false,
                        onShow: function onShow() {
                            if (_this3.settings.hover_zoom === 'separate') {
                                var productMain = document.querySelector('.product-main');
                                var productAlt = document.querySelector('.product-form--alt');
                                productMain.classList.add('product-gallery--fade');
                                if (productAlt) productAlt.classList.add('product-gallery--fade');
                            }
                        },
                        onHide: function onHide() {
                            if (_this3.settings.hover_zoom === 'separate') {
                                var productMain = document.querySelector('.product-main');
                                var productAlt = document.querySelector('.product-form--alt');
                                productMain.classList.remove('product-gallery--fade');
                                if (productAlt) productAlt.classList.remove('product-gallery--fade');
                            }
                        }
                    });
                }
            }, {
                key: "_disableHoverZoom",
                value: function _disableHoverZoom() {
                    if (this.drift) {
                        this.drift.disable();
                        this.drift = null;
                    }
                }
            }, {
                key: "_setupFlickity",
                value: function _setupFlickity() {
                    var _this4 = this;

                    if (this.flickity || !Layout.isLessThanBreakpoint('S')) return;
                    this.flickity = new js_default.a(this.viewer, {
                        accessibility: false,
                        adaptiveHeight: true,
                        cellSelector: '.product-gallery--media',
                        contain: true,
                        friction: 0.5,
                        freeScroll: false,
                        initialIndex: parseInt(this.selected.figure.dataset.galleryIndex, 10),
                        lazyLoad: false,
                        percentPosition: false,
                        prevNextButtons: false,
                        pageDots: false,
                        selectedAttraction: 0.1,
                        setGallerySize: false,
                        wrapAround: true
                    });
                    this.flickityEvent = this.events.register(this.viewer, 'rimg:load', function () {
                        _this4._setSlideHeight();
                    });
                    this.flickity.on('change', function (index) {
                        _this4.showingInitialSlide = false;

                        _this4._selectMediaByEl(_this4.figures[index]);
                    }); // Flickity controls the pointerdown event which prevents model-viewer-ui from
                    // triggering .play() on mouseup. This returns this functionality.

                    this.flickity.on('staticClick', function (event, pointer, cellElement) {
                        var figure = cellElement.querySelector('.product-gallery--model');

                        if (figure && _this4.models[figure.dataset.galleryIndex]) {
                            var model = _this4.models[figure.dataset.galleryIndex];
                            model.play();
                        }
                    });
                    this.flickity.on('pointerDown', function () {
                        // Removes the focus ring when swiping with touch device
                        _this4.viewer.blur();
                    }); // We need to disable the product zoom open if a user is swiping
                    // This was an issue on mouse gestures, not on touch

                    if (this.settings.click_to_zoom !== 'disabled' && document.documentElement.classList.contains('no-touch')) {
                        this.flickity.on('dragEnd', function () {
                            _this4.swiped = true;
                        });
                    }

                    this._setSlideHeight();
                }
            }, {
                key: "_disableFlickity",
                value: function _disableFlickity() {
                    if (this.flickity) {
                        this.flickity.destroy();
                        this.flickity = null;
                        this.events.unregister(this.flickityEvent);
                    }
                }
            }, {
                key: "_setSlideHeight",
                value: function _setSlideHeight() {
                    this.navigation.classList.remove('loading'); // Use the stored image height for situations where the DOM is in a midway state.

                    var containerHeight = this.storedImageHeight || this.selected.figure.getBoundingClientRect().height;
                    this.storedImageHeight = null;
                    this.viewer.style.height = "".concat(containerHeight, "px");
                }
            }, {
                key: "_adjustGalleryPositioning",
                value: function _adjustGalleryPositioning() {
                    var _this5 = this;

                    if (this.settings.thumbnail_position === 'left') {
                        if (this.isQuickshop) {
                            if (Layout.isGreaterThanBreakpoint('L', true)) {
                                this.el.dataset.productGalleryThumbs = 'left';
                            } else {
                                this.storedImageHeight = this.selected.figure.getBoundingClientRect().height;
                                this.el.dataset.productGalleryThumbs = 'center';
                            }
                        } // We need to adjust the width of the thumbnails if they are positioned left
                        // and they wrap into 2 columns. CSS flexbox does not cause the width of the
                        // element to stretch. Looks like it's a problem with flexbox when wrapping columns:
                        // https://stackoverflow.com/questions/33891709/when-flexbox-items-wrap-in-column-mode-container-does-not-grow-its-width


                        if (Layout.isGreaterThanBreakpoint('L', true) || Layout.isGreaterThanBreakpoint('S', true) && !this.isQuickshop) {
                            if (this.el.firstChild !== this.navigation) {
                                var activeButton = document.activeElement;
                                this.el.insertBefore(this.navigation, this.viewer);
                                activeButton.focus(); // This prevents loss of focus if one of the thumbnails are selected
                            } // When switching layouts in the editor sometimes we need to wait for a few milliseconds
                            // before positioning the thumbs. The Quickshop is even a bit slower.


                            setTimeout(function () {
                                var leftmostBounds = _this5.thumbnails[0].getBoundingClientRect();

                                var thumbStyle = _this5.thumbnails[0].currentStyle || window.getComputedStyle(_this5.thumbnails[0]);
                                var thumbMargin = parseInt(thumbStyle.marginLeft, 10) * 2;
                                var wrapped = Array.prototype.some.call(_this5.thumbnails, function (thumb) {
                                    return thumb.getBoundingClientRect().left > leftmostBounds.left;
                                });

                                if (wrapped) {
                                    _this5.navigation.style.width = "".concat((leftmostBounds.width + thumbMargin) * 2, "px");
                                    _this5.navigation.style.maxWidth = "".concat((leftmostBounds.width + thumbMargin) * 2, "px");
                                }

                                _this5._setSlideHeight();
                            }, this.isQuickshop ? 500 : 100);
                        } else {
                            if (this.el.firstElementChild === this.navigation) {
                                this.el.appendChild(this.navigation);
                            }

                            this.navigation.style.width = '';
                            this.navigation.style.maxWidth = '';

                            this._setSlideHeight();
                        }

                        if (Layout.isLessThanBreakpoint('S')) {
                            this._adjustMobileThumbnailPosition();
                        }
                    } else {
                        this._setSlideHeight();

                        this._adjustMobileThumbnailPosition();
                    }
                }
            }, {
                key: "_adjustMobileThumbnailPosition",
                value: function _adjustMobileThumbnailPosition() {
                    // This brings the thumbnail into view if it is not visible on the screen after
                    // a user swipes to a slide that it is tied to. Only important on mobile.
                    if (Layout.isLessThanBreakpoint('S')) {
                        var thumbBounds = this.selected.thumbnail.getBoundingClientRect();
                        var thumbWrapperBounds = this.navScroller.getBoundingClientRect();

                        if (this.selected.thumbnail.offsetLeft + thumbBounds.width + 30 - this.navScroller.scrollLeft > thumbWrapperBounds.width) {
                            this.navScroller.scrollLeft = this.selected.thumbnail.offsetLeft + thumbBounds.width - thumbWrapperBounds.width + 35;
                        } else if (this.selected.thumbnail.offsetLeft < this.navScroller.scrollLeft) {
                            this.navScroller.scrollLeft = this.selected.thumbnail.offsetLeft - 35;
                        }
                    }
                }
            }, {
                key: "_handleScrollButtonVisibility",
                value: function _handleScrollButtonVisibility() {
                    if (Layout.isLessThanBreakpoint('S')) {
                        // We use 4px here just to ensure the user has scrolled a little bit before
                        // showing the buttons.
                        if (this.navScroller.scrollLeft > 4) {
                            this.navScrollerButtons[0].classList.add('visible');
                        } else {
                            this.navScrollerButtons[0].classList.remove('visible');
                        }

                        if (this.navScroller.scrollLeft < this.navScroller.scrollWidth - this.navScroller.clientWidth) {
                            this.navScrollerButtons[1].classList.add('visible');
                        } else {
                            this.navScrollerButtons[1].classList.remove('visible');
                        }
                    } else {
                        this.navScrollerButtons[0].classList.remove('visible');
                        this.navScrollerButtons[1].classList.remove('visible');
                    }
                }
            }, {
                key: "_onScrollButtonClick",
                value: function _onScrollButtonClick(scrollRight) {
                    if (scrollRight) {
                        this.navScroller.scrollLeft = this.navScroller.scrollLeft - 100;
                    } else {
                        this.navScroller.scrollLeft = this.navScroller.scrollLeft + 100;
                    }
                }
            }, {
                key: "_closeImageZoom",
                value: function _closeImageZoom() {
                    if (this.imageZoom) {
                        this.imageZoom.unload();
                        this.imageZoom = null;
                    }
                }
            }, {
                key: "_openImageZoom",
                value: function _openImageZoom() {
                    var _this6 = this;

                    if (this.selected.figure.dataset.mediaType !== 'image' || Layout.isGreaterThanBreakpoint('L') && this.settings.click_to_zoom === 'mobile' || Layout.isLessThanBreakpoint('L') && this.settings.click_to_zoom === 'desktop') return;

                    if (this.swiped) {
                        this.swiped = false;
                        return;
                    }

                    this._closeImageZoom();

                    this.imageZoom = new ProductClickToZoom_ProductClickToZoom({
                        settings: this.settings,
                        slides: this.figures,
                        originalThumbnails: this.thumbnails,
                        startIndex: parseInt(this.selected.figure.dataset.galleryIndex, 10),
                        selectGalleryIndex: function selectGalleryIndex(index) {
                            return _this6._selectMediaByIndex(index);
                        }
                    });
                }
            }]);

            return ProductGallery;
        }();


// CONCATENATED MODULE: ./source/scripts/components/ProductDetails.js
        function ProductDetails_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

        function ProductDetails_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

        function ProductDetails_createClass(Constructor, protoProps, staticProps) { if (protoProps) ProductDetails_defineProperties(Constructor.prototype, protoProps); if (staticProps) ProductDetails_defineProperties(Constructor, staticProps); return Constructor; }









        var ProductDetails_ProductDetails = /*#__PURE__*/function () {
            function ProductDetails(options) {
                ProductDetails_classCallCheck(this, ProductDetails);

                this.$window = jquery_default()(window);
                this.$formArea = options.$formArea;
                this.$details = options.$details;
                this.context = options.context;
                this.settings = options.settings;
                this.product = options.product;
                this.useHistory = options.useHistory;
                this.sectionId = options.sectionId;
                this.initialVariant = options.initialVariant || null;
                this.variantHelper = null;
                this.addToCartFlyout = null;
                this.atcCallbacks = options.atcCallbacks; // Form

                this.$form = this.$formArea.find('[data-product-form]');
                this.$productAtcButton = this.$formArea.find('[data-product-atc]');
                this.$productVariants = this.$form.find('[data-variants]');
                this.$productOptions = this.$form.find('[data-product-option]');
                this.detailsLink = this.$formArea[0].querySelector('[data-product-details-link]');

                if (this.detailsLink) {
                    this.detailsBaseHref = this.detailsLink.getAttribute('href');
                }

                this.variantFields = {
                    $price: this.$details.find('[data-price]'),
                    $priceMoney: this.$details.find('[data-price] .money'),
                    $compareAtPrice: this.$details.find('[data-price-compare-at]'),
                    $compareAtPriceMoney: this.$details.find('[data-price-compare-at] .money'),
                    $badge: this.$details.find('[data-badge-sales]'),
                    $badgeMoneySaved: this.$details.find('[data-price-money-saved]'),
                    $badgePercentSaved: this.$details.find('[data-price-percent-saved]'),
                    $sku: this.$details.find('[data-product-sku]'),
                    unitPrice: this.$details[0].querySelector('[data-unit-price]'),
                    totalQuantity: this.$details[0].querySelector('[data-total-quantity]'),
                    unitPriceAmount: this.$details[0].querySelector('[data-unit-price-amount]'),
                    unitPriceMeasure: this.$details[0].querySelector('[data-unit-price-measure]'),
                    taxLine: this.$details[0].querySelector('[data-tax-line]')
                };
                this.forms = new Forms_Forms(this.$form);

                if (this.product) {
                    if ('media' in this.product) {
                        this.gallery = new ProductGallery_ProductGallery({
                            el: options.gallery,
                            settings: this.settings,
                            isQuickshop: options.isQuickshop
                        });
                    }

                    this._bindEvents();

                    this._initOptions();
                }
            }

            ProductDetails_createClass(ProductDetails, [{
                key: "unload",
                value: function unload() {
                    this.$form.off(".product-details-".concat(this.sectionId));
                    this.$window.off(".product-details-".concat(this.sectionId));
                    this.forms.unload();

                    if (this.variantHelper) {
                        this.variantHelper.unload();
                    }

                    if (this.gallery) {
                        this.gallery.unload();
                    }
                }
            }, {
                key: "_bindEvents",
                value: function _bindEvents() {
                    var _this = this;

                    this.$window.on("shopify-variants:switch-variant.product-details-".concat(this.sectionId), function (event, data) {
                        return _this._switchVariant(event, data);
                    });
                    this.$form.on("submit.product-details-".concat(this.sectionId), function (event) {
                        return _this._addToCartFlyout(event);
                    });
                }
            }, {
                key: "_initOptions",
                value: function _initOptions() {
                    var _this2 = this;

                    this.surfacePickUp = new shopify_surface_pick_up_dist_index_es(this.$formArea[0].querySelector('[data-surface-pick-up]'));

                    var selectedVariant = function selectedVariant() {
                        return _this2.variantHelper ? _this2.variantHelper.getSelectedVariant() : _this2.product.variants[0];
                    }; // product has only default variant


                    if (this.$productVariants.length) {
                        this.variantHelper = new shopify_variants_es(this.product, this.$productVariants, this.$productOptions, {
                            mixedControls: true
                        });
                        this.variantHelper.selectVariant(this.initialVariant);
                    }

                    this.modal = new Modal_Modal({
                        onClose: function onClose() {
                            return _this2.modal.unload();
                        },
                        modalId: 1
                    });
                    this.surfacePickUp.load(selectedVariant().id);
                    this.surfacePickUp.onModalRequest(function (contents) {
                        var container = _this2.$formArea[0].querySelector('[data-surface-pick-up-modal-contents]');

                        var variantTitle = _this2.variantHelper ? "<div class=\"surface-pick-up-modal__variant\">".concat(selectedVariant().title, "</div>") : '';
                        var modalContents = "\n        <div class=\"surface-pick-up-modal__header\">\n          <h2 class=\"surface-pick-up-modal__title\">".concat(_this2.product.title, "</h2>\n          ").concat(variantTitle, "\n        </div>\n        ").concat(contents, "\n        ");

                        if (!container) {
                            container = document.createElement('div');
                            container.setAttribute('data-surface-pick-up-modal-contents', '');
                            container.style.display = 'none';
                            container.innerHTML = modalContents;

                            _this2.$formArea[0].appendChild(container);
                        } else {
                            container.innerHTML = modalContents;
                        }

                        _this2.modal.open('[data-surface-pick-up-modal-contents]', 'surface-pick-up');
                    });
                }
            }, {
                key: "_switchVariant",
                value: function _switchVariant(event, data) {
                    if (data.product !== this.product) return;
                    var variant = data.variant,
                            firstLoad = data.firstLoad;

                    if (firstLoad) {
                        return;
                    } // Update main select


                    this.$productVariants.val(data.variant.id);

                    if (this.gallery) {
                        this.gallery.selectMediaByVariant(variant);
                    }

                    this.surfacePickUp.load(variant.id); // Update Variant information

                    this._updatePrice(variant);

                    this._updateSKU(variant);

                    this._updateBadge(variant);

                    this._updateButton(variant);

                    this._updateSwatchLabel(variant);

                    this._updateFullDetailsLink(variant);

                    this._updateUnitPrice(variant);

                    if (this.useHistory) {
                        var url = "".concat(this.product.handle, "?").concat(jquery_default.a.param({
                            variant: variant.id
                        }));
                        history.replaceState({}, 'variant', url);
                    }
                }
            }, {
                key: "_updatePrice",
                value: function _updatePrice(variant) {
                    // Update compare at price
                    var hasComparePrice = !!variant.compare_at_price && variant.compare_at_price > variant.price;
                    this.variantFields.$compareAtPrice.toggleClass('visible', hasComparePrice);
                    this.variantFields.$compareAtPriceMoney.text(Shopify.formatMoney(variant.compare_at_price, this.settings.money_format)); // Update price

                    this.variantFields.$priceMoney.text(Shopify.formatMoney(variant.price, this.settings.money_format));
                }
            }, {
                key: "_updateSKU",
                value: function _updateSKU(variant) {
                    if (variant.sku === '') {
                        this.variantFields.$sku.parent().addClass('product-sku--empty');
                    } else {
                        this.variantFields.$sku.parent().removeClass('product-sku--empty');
                    }

                    this.variantFields.$sku.text(variant.sku);
                }
            }, {
                key: "_updateBadge",
                value: function _updateBadge(variant) {
                    var priceSaved = variant.compare_at_price ? variant.compare_at_price - variant.price : 0;
                    this.variantFields.$badge.toggle(!!priceSaved);

                    if (this.variantFields.$badgeMoneySaved.length) {
                        // Update badge if it shows money saved
                        this.variantFields.$badgeMoneySaved.text(Shopify.formatMoney(priceSaved, this.settings.money_format));
                    }

                    if (this.variantFields.$badgePercentSaved.length) {
                        // Update badge if it shows percentiles
                        var percentileSaved = Math.round(priceSaved * 100 / variant.compare_at_price);
                        this.variantFields.$badgePercentSaved.text(percentileSaved);
                    }
                }
            }, {
                key: "_updateButton",
                value: function _updateButton(variant) {
                    if (variant.available) {
                        this.$productAtcButton.text(this.context.product_available);
                        this.$productAtcButton.removeClass('disabled').prop('disabled', false);
                    } else {
                        this.$productAtcButton.text(this.context.product_unavailable);
                        this.$productAtcButton.addClass('disabled').prop('disabled', true);
                    }
                }
            }, {
                key: "_updateSwatchLabel",
                value: function _updateSwatchLabel(variant) {
                    if (this.settings.swatches_enable) {
                        var swatchLabel = this.$form[0].querySelector('[data-option-swatch-value]');

                        if (swatchLabel) {
                            swatchLabel.innerText = variant.options[parseInt(swatchLabel.dataset.optionSwatchValue, 10)];
                        }
                    }
                }
            }, {
                key: "_updateFullDetailsLink",
                value: function _updateFullDetailsLink(variant) {
                    if (this.detailsLink) {
                        this.detailsLink.setAttribute('href', "".concat(this.detailsBaseHref, "?variant=").concat(variant.id));
                    }
                }
            }, {
                key: "_updateUnitPrice",
                value: function _updateUnitPrice(variant) {
                    if (this.variantFields.unitPrice && variant.unit_price_measurement) {
                        this.variantFields.totalQuantity.innerHTML = "".concat(variant.unit_price_measurement.quantity_value).concat(variant.unit_price_measurement.quantity_unit);
                        this.variantFields.unitPriceAmount.innerHTML = Shopify.formatMoney(variant.unit_price, this.settings.money_format);

                        if (variant.unit_price_measurement.reference_value === 1) {
                            this.variantFields.unitPriceMeasure.innerHTML = variant.unit_price_measurement.reference_unit;
                        } else {
                            this.variantFields.unitPriceMeasure.innerHTML = "".concat(variant.unit_price_measurement.reference_value).concat(variant.unit_price_measurement.reference_unit);
                        }

                        this.variantFields.unitPrice.classList.remove('hidden');
                    } else if (this.variantFields.unitPrice) {
                        this.variantFields.unitPrice.classList.add('hidden');
                    }

                    if (this.variantFields.taxLine) {
                        if (variant.taxable) {
                            this.variantFields.taxLine.classList.remove('hidden');
                        } else {
                            this.variantFields.taxLine.classList.add('hidden');
                        }
                    }
                }
            }, {
                key: "_addToCartFlyout",
                value: function _addToCartFlyout(event) {
                    event.preventDefault();

                    if (this.addToCartFlyout) {
                        this.addToCartFlyout.unload();
                    }

                    var formData = this.$form.serializeArray();
                    var options = {
                        atcButton: this.$productAtcButton[0],
                        settings: {
                            moneyFormat: this.settings.money_format,
                            cartRedirection: this.settings.cart_redirection
                        }
                    };
                    this.addToCartFlyout = new AddToCartFlyout_AddToCartFlyout(formData, options, this.atcCallbacks);
                }
            }]);

            return ProductDetails;
        }();


// CONCATENATED MODULE: ./source/scripts/helpers/ProductReviews.js
        var initShopifyProductReviews = function initShopifyProductReviews() {
            if (!window.SPR) {
                return;
            }

            window.SPR.registerCallbacks();
            window.SPR.initRatingHandler();
            window.SPR.initDomEls();
            window.SPR.loadProducts();
            window.SPR.loadBadges();
        };
        /* harmony default export */ var ProductReviews = ({
            initShopifyProductReviews: initShopifyProductReviews
        });
// CONCATENATED MODULE: ./source/scripts/components/ProductQuickshop.js
        function ProductQuickshop_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

        function ProductQuickshop_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

        function ProductQuickshop_createClass(Constructor, protoProps, staticProps) { if (protoProps) ProductQuickshop_defineProperties(Constructor.prototype, protoProps); if (staticProps) ProductQuickshop_defineProperties(Constructor, staticProps); return Constructor; }









        var ProductQuickshop_ProductQuickshop = /*#__PURE__*/function () {
            function ProductQuickshop(options) {
                ProductQuickshop_classCallCheck(this, ProductQuickshop);

                this.$el = options.$el;
                this.id = options.id;
                this.initialVariant = options.initialVariant || null;
                this.quickShopSelector = "#shopify-section-".concat(this.id, " [data-product-quickshop]");
                this.$quickShop = jquery_default()(this.quickShopSelector);
                this.quickshopSpinner = this.$quickShop[0].querySelector('.quickshop-spinner');
                this.modalClass = options.modalClass;
                this.loaded = false;
                this.richText = null;
                this.productDetails = null;
                this.trigger = options.trigger;
                this.isOpen = false;
                this.openingAddToCart = false;
                this.url = this.$el.data('product-quickshop-url');
                this.hash = this.$el.data('quickshop-hash');
                this.modalCallbacks = {
                    onOpen: this._open.bind(this),
                    onClose: this._close.bind(this)
                };
                this.atcCallbacks = {
                    onInit: this._onATCInit.bind(this),
                    onError: this._onATCError.bind(this),
                    onSuccess: this._onATCSuccess.bind(this),
                    onClose: this._onATCClose.bind(this)
                };

                this._initialize();
            }

            ProductQuickshop_createClass(ProductQuickshop, [{
                key: "_initialize",
                value: function _initialize() {
                    var _this = this;

                    this.modal = new Modal_Modal(this.modalCallbacks);
                    this.modal.open(this.quickShopSelector, this.modalClass);
                    this.isOpen = true;
                    var $quickShopModalContent = this.modal.$modalInner.find('[data-modal-content]');
                    shopify_asyncview_dist_index_es.load(this.url, {
                        view: '_quickshop'
                    }, {
                        hash: this.hash
                    }).then(function (_ref) {
                        var html = _ref.html,
                                data = _ref.data;

                        // Stop populating the modal if it was closed before the content was loaded
                        if (!_this.isOpen) {
                            return;
                        }

                        $quickShopModalContent.html(html.content);
                        initShopifyProductReviews();
                        Ripple_setupRippleEffect($quickShopModalContent[0]);

                        if (window.Shopify && Shopify.PaymentButton) {
                            Shopify.PaymentButton.init();
                        }

                        _this.$message = $quickShopModalContent.find('[data-product-quickshop-message]');
                        _this.$formArea = $quickShopModalContent.find('[data-product-form-area]');
                        _this.gallery = $quickShopModalContent[0].querySelector('[data-product-gallery]');
                        _this.$details = $quickShopModalContent.find('[data-product-details]');
                        _this.$description = $quickShopModalContent.find('[data-product-description]');
                        _this.context = data.context;
                        _this.settings = data.settings;
                        _this.product = data.product;

                        _this._onQuickshopLoaded();
                    }).catch();
                }
            }, {
                key: "_onQuickshopLoaded",
                value: function _onQuickshopLoaded() {
                    var _this2 = this;

                    if (this.loaded) {
                        return;
                    }

                    if (this.$description && this.$description.length) {
                        this.richText = new RichText_RichText(this.$description);
                    }

                    var options = {
                        $formArea: this.$formArea,
                        gallery: this.gallery,
                        $details: this.$details,
                        atcCallbacks: this.atcCallbacks,
                        context: this.context,
                        settings: this.settings,
                        product: this.product,
                        useHistory: false,
                        isQuickshop: true,
                        initialVariant: this.initialVariant
                    };
                    this.modal.position();
                    this.modal.finishedLoading();
                    this.loaded = true;
                    window.requestAnimationFrame(function () {
                        _this2.productDetails = new ProductDetails_ProductDetails(options);
                    });
                }
            }, {
                key: "_open",
                value: function _open() {// do nothing
                }
            }, {
                key: "_close",
                value: function _close() {
                    if (this.productDetails) {
                        this.productDetails.unload();
                    }

                    if (this.richText) {
                        this.richText.unload();
                    }

                    if (!this.openingAddToCart) {
                        this.trigger.focus();
                    }

                    this.loaded = false;
                    this.isOpen = false;
                    this.$quickShop.empty();
                    this.$quickShop.html(this.quickshopSpinner);

                    this._toggleMessage('', false);

                    this.modal.unload();
                }
            }, {
                key: "_toggleMessage",
                value: function _toggleMessage(message, isVisible) {
                    if (this.$message) {
                        this.$message.html(message).toggleClass('visible', isVisible);
                    }
                }
            }, {
                key: "_onATCInit",
                value: function _onATCInit() {
                    this.openingAddToCart = true;
                    this.$message.removeClass('visible');
                }
            }, {
                key: "_onATCError",
                value: function _onATCError(error) {
                    var $content = jquery_default()("<div class=\"product-message--error\" tabindex=\"-1\">".concat(error, "</div>"));

                    this._toggleMessage($content, true);

                    $content.focus();
                }
            }, {
                key: "_onATCSuccess",
                value: function _onATCSuccess() {
                    this._close();
                }
            }, {
                key: "_onATCClose",
                value: function _onATCClose() {// Do nothing
                }
            }, {
                key: "unload",
                value: function unload() {
                    this._close();
                }
            }]);

            return ProductQuickshop;
        }();


// CONCATENATED MODULE: ./source/scripts/components/GridItemSwatches.js
        function GridItemSwatches_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

        function GridItemSwatches_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

        function GridItemSwatches_createClass(Constructor, protoProps, staticProps) { if (protoProps) GridItemSwatches_defineProperties(Constructor.prototype, protoProps); if (staticProps) GridItemSwatches_defineProperties(Constructor, staticProps); return Constructor; }





        var swatchGap = null;

        var GridItemSwatches_GridItemSwatches = /*#__PURE__*/function () {
            function GridItemSwatches(options) {
                var _this = this;

                GridItemSwatches_classCallCheck(this, GridItemSwatches);

                this.el = options.el;
                this.setInitialVariant = options.setInitialVariant;
                this.expanded = false;
                this.swatchImages = {};
                this.swatchVariantIds = {};
                this.selectedImage = null;
                this.state = {};
                this.events = new EventHandler_default.a();
                this.data = JSON.parse(this.el.querySelector('[data-swatch-data]').innerHTML);
                this.variants = this.data.variants;
                this.swatchesContainer = this.el.querySelector('[data-swatches-container]');
                this.cardLinks = this.el.querySelectorAll('[data-product-page-link]');
                this.cardLinkHref = this.cardLinks[0].getAttribute('href');
                this.activeControlTime = 0;
                this.activeControl = this.swatchesContainer.querySelector('[checked]');
                this.isPreselected = !!this.activeControl;
                this.swatches = this.swatchesContainer.querySelectorAll('[data-swatch]');
                this.swatchCount = this.swatches.length;
                this.swatchCountWrapper = this.el.querySelector('[data-swatch-count-wrapper]');
                this.swatchCount = this.swatchCountWrapper.querySelector('[data-swatch-count]');
                this.swatchWidths = Array.prototype.map.call(this.swatches, function (swatch) {
                    return swatch.getBoundingClientRect().width;
                });
                this.resize();
                this.el.querySelector('[data-swatches]').classList.add('processed');
                this.originalImages = {
                    primary: this.el.querySelector('.productitem--image-primary'),
                    alternate: this.el.querySelector('.productitem--image-alternate')
                };
                this.disableUnavailable(); // +/- button expansion events

                this.events.register(window, 'resize', just_debounce_default()(function () {
                    return _this.resize();
                }, 50));
                this.events.register(this.swatchCountWrapper, 'click', function () {
                    return _this._toggleExpanded();
                }); // Image injection events

                this.injectImagesMouseoverEvent = this.events.register(this.el, 'mouseover', function () {
                    return _this._injectImages();
                });
                this.injectImagesFocusinEvent = this.events.register(this.el, 'focusin', function () {
                    return _this._injectImages();
                }); // Image/swatch switching events

                this.events.register(this.swatchesContainer, 'mouseover', function (e) {
                    return _this._handleMouseOver(e);
                });
                this.events.register(this.swatchesContainer, 'mouseleave', function (e) {
                    return _this._handleMouseLeave(e);
                });
                this.events.register(this.swatchesContainer, 'click', function (e) {
                    return _this._handleClick(e);
                });
                this.events.register(this.swatchesContainer, 'change', function (e) {
                    return _this._handleChange(e);
                });
                this.events.register(this.swatchesContainer, 'focusin', function (e) {
                    return _this._handleSwatchFocus(e);
                });
            }

            GridItemSwatches_createClass(GridItemSwatches, [{
                key: "disableUnavailable",
                value: function disableUnavailable() {
                    var _this2 = this;

                    if (!this.variants) {
                        return;
                    }

                    var availableSwatches = {};
                    this.variants.forEach(function (variant) {
                        if (variant.available) {
                            availableSwatches[variant[_this2.data.swatchOptionKey]] = true;
                        }
                    });
                    var swatchInputs = this.swatchesContainer.querySelectorAll('input[name="swatch"]');
                    swatchInputs.forEach(function (swatch) {
                        if (!(swatch.value in availableSwatches)) {
                            swatch.disabled = true;
                        }
                    });
                }
            }, {
                key: "resize",
                value: function resize() {
                    var _this3 = this;

                    if (this.expanded) this._toggleExpanded();
                    var availableWidth = this.swatchesContainer.getBoundingClientRect().width - parseInt(window.getComputedStyle(this.swatchesContainer).paddingRight, 10);
                    var newShowSwatchCount = this.swatches.length;
                    var cumulativeWidth = 0;

                    for (var i = 0; i < this.swatches.length; i++) {
                        if (cumulativeWidth + this.getSwatchGap() + this.swatchWidths[i] < availableWidth) {
                            cumulativeWidth += swatchGap + this.swatchWidths[i];
                        } else {
                            newShowSwatchCount = i;
                            break;
                        }
                    }

                    if (newShowSwatchCount === this.showSwatchCount) return;
                    this.showSwatchCount = newShowSwatchCount;
                    this.swatches.forEach(function (swatch, index) {
                        if (index < _this3.showSwatchCount) {
                            swatch.classList.add('productitem--swatches-swatch-visible');
                            swatch.classList.remove('productitem--swatches-swatch-hidden');
                        } else {
                            swatch.classList.remove('productitem--swatches-swatch-visible');
                            swatch.classList.add('productitem--swatches-swatch-hidden');
                        }
                    });
                    this.swatchCountWrapper.style.left = "".concat(cumulativeWidth, "px");

                    if (this.swatches.length > this.showSwatchCount) {
                        this.swatchCountWrapper.style.display = 'flex';
                        this.swatchCount.innerText = "+".concat(this.swatches.length - this.showSwatchCount);
                    } else {
                        this.swatchCountWrapper.style.display = 'none';
                    }
                }
            }, {
                key: "_injectImages",
                value: function _injectImages() {
                    var _this4 = this;

                    this.events.unregister(this.injectImagesFocusinEvent);
                    this.events.unregister(this.injectImagesMouseoverEvent);
                    shopify_asyncview_dist_index_es.load(this.cardLinkHref, {
                        view: '_swatch-data'
                    }, {
                        hash: this.data.hash
                    }).then(function (_ref) {
                        var data = _ref.data;
                        if (_this4.imagesInjected) return;
                        _this4.imagesInjected = true;
                        var tempContainer = document.createDocumentFragment();

                        if (data.featuredImage) {
                            var tempEl = document.createElement('div');
                            tempEl.innerHTML = data.featuredImage;
                            var img = tempEl.querySelector('img');
                            tempContainer.appendChild(img);
                            _this4.featuredImage = img;
                        }

                        data.swatches.forEach(function (_ref2) {
                            var swatchValue = _ref2.swatchValue,
                                    imageString = _ref2.imageString,
                                    variantId = _ref2.variantId;
                            _this4.swatchVariantIds[swatchValue] = variantId;

                            if (imageString) {
                                var _tempEl = document.createElement('div');

                                _tempEl.innerHTML = imageString;

                                var _img = _tempEl.querySelector('img');

                                tempContainer.appendChild(_img);
                                _this4.swatchImages[swatchValue] = _img;
                            }
                        });

                        var imagesContainer = _this4.el.querySelector('[data-product-item-image]');

                        var salesBadge = imagesContainer.querySelector('[data-badge-sales]');
                        imagesContainer.insertBefore(tempContainer, salesBadge);
                        rimg_shopify_dist_index_es.watch(imagesContainer);

                        _this4._setState({
                            swatchName: _this4.activeControl ? _this4.activeControl.value : null,
                            primaryImage: _this4.originalImages.primary,
                            hideAlternateImage: !!_this4.activeControl
                        });
                    });
                }
            }, {
                key: "_setState",
                value: function _setState(_ref3) {
                    var swatchName = _ref3.swatchName,
                            primaryImage = _ref3.primaryImage,
                            hideAlternateImage = _ref3.hideAlternateImage;
                    var oldPrimaryImg = this.state.primaryImage;
                    var href = swatchName ? "".concat(this.cardLinkHref, "?variant=").concat(this.swatchVariantIds[swatchName]) : this.cardLinkHref;
                    this.cardLinks.forEach(function (link) {
                        return link.setAttribute('href', href);
                    });
                    this.setInitialVariant(this.swatchVariantIds[swatchName] || this.variants[0].id);

                    if (oldPrimaryImg) {
                        oldPrimaryImg.classList.remove('productitem--image-primary');
                        oldPrimaryImg.style.visibility = '';
                    }

                    if (primaryImage) {
                        primaryImage.classList.add('productitem--image-primary');
                        primaryImage.style.visibility = hideAlternateImage ? 'visible' : '';
                    }

                    if (this.originalImages.alternate) {
                        this.originalImages.alternate.style.visibility = hideAlternateImage ? 'hidden' : '';
                    }

                    this.state = {
                        swatchName: swatchName,
                        primaryImage: primaryImage,
                        hideAlternateImage: hideAlternateImage
                    };
                }
            }, {
                key: "_handleChange",
                value: function _handleChange(_ref4) {
                    var target = _ref4.target;
                    this.activeControlTime = Date.now();
                    this.activeControl = target;
                    var swatchName = target.value;
                    this.selectedImage = this.swatchImages[swatchName] || this.originalImages.primary;

                    this._setState({
                        swatchName: swatchName,
                        primaryImage: this.selectedImage,
                        hideAlternateImage: true
                    });
                }
            }, {
                key: "_handleClick",
                value: function _handleClick(_ref5) {
                    var target = _ref5.target;

                    if (target === this.activeControl && this.activeControlTime + 150 < Date.now()) {
                        // Allow deselection, if swatch has been active for more than the threshold
                        // because we can't guarantee the order of the click and change events
                        target.checked = false;
                        this.activeControl = null;
                        this.selectedImage = null; // Swaps in featured image if card was rendered on server with preselected swatch variant image.

                        if (this.isPreselected && this.featuredImage) {
                            this.originalImages.primary = this.featuredImage;
                            this.isPreselected = false;
                        }

                        this._setState({
                            swatchName: null,
                            primaryImage: this.state.primaryImage,
                            hideAlternateImage: true
                        });
                    }
                }
            }, {
                key: "_handleMouseOver",
                value: function _handleMouseOver(event) {
                    if (event.target.hasAttribute('data-swatch-tooltip')) {
                        this._setState({
                            swatchName: this.state.swatchName,
                            primaryImage: this.swatchImages[event.target.dataset.swatchTooltip] || this.originalImages.primary,
                            hideAlternateImage: true
                        });
                    }
                }
            }, {
                key: "_handleMouseLeave",
                value: function _handleMouseLeave(_ref6) {
                    var target = _ref6.target;

                    if (target.hasAttribute('data-swatches-container')) {
                        this._setState({
                            swatchName: this.state.swatchName,
                            primaryImage: this.selectedImage || this.originalImages.primary,
                            hideAlternateImage: !!this.selectedImage
                        });
                    }
                }
            }, {
                key: "_handleSwatchFocus",
                value: function _handleSwatchFocus(_ref7) {
                    var target = _ref7.target;

                    if (this.expanded === false && target.nextElementSibling.classList.contains('productitem--swatches-swatch-hidden')) {
                        this._toggleExpanded();
                    }
                }
            }, {
                key: "_toggleExpanded",
                value: function _toggleExpanded() {
                    var swatchesEl = this.el.querySelector('[data-swatches]');

                    if (this.expanded) {
                        this.expanded = false;
                        swatchesEl.classList.remove('productitem--swatches-expanded');
                        this.swatchCount.innerText = "+".concat(this.swatches.length - this.showSwatchCount);
                    } else {
                        this.expanded = true;
                        swatchesEl.classList.add('productitem--swatches-expanded');
                    }
                } // Getters are used to avoid having to get these properties for every card on the page

            }, {
                key: "getSwatchGap",
                value: function getSwatchGap() {
                    if (swatchGap === null) {
                        swatchGap = parseInt(window.getComputedStyle(this.swatches[0]).getPropertyValue('margin-right'), 10);
                    }

                    return swatchGap;
                }
            }, {
                key: "unload",
                value: function unload() {
                    this.events.unregisterAll();
                }
            }]);

            return GridItemSwatches;
        }();


// CONCATENATED MODULE: ./source/scripts/components/ProductGridItem.js
        function ProductGridItem_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

        function ProductGridItem_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

        function ProductGridItem_createClass(Constructor, protoProps, staticProps) { if (protoProps) ProductGridItem_defineProperties(Constructor.prototype, protoProps); if (staticProps) ProductGridItem_defineProperties(Constructor, staticProps); return Constructor; }











        var ProductGridItem_ProductGridItem = /*#__PURE__*/function () {
            function ProductGridItem(options) {
                var _this = this;

                ProductGridItem_classCallCheck(this, ProductGridItem);

                this.el = options.el;
                this.$el = jquery_default()(options.el);
                this.id = options.id;
                this.productQuickshop = null;
                this.quickshopInitialVariant = null;
                this.quickBuySettings = null;
                this.actionsOpen = false;
                this.defaultView = options.grid_list;
                this.events = new EventHandler_default.a();

                if (options.lazy) {
                    this.lazyLoader = new LazyLoader_LazyLoader(this.$el[0], function () {
                        return _this._init();
                    });
                } else {
                    this._init();
                }
            }

            ProductGridItem_createClass(ProductGridItem, [{
                key: "_init",
                value: function _init() {
                    var _this2 = this;

                    this.$window = jquery_default()(window);
                    this.$html = jquery_default()('html');
                    this.content = this.el.querySelector('[data-product-item-content]');
                    this.actions = this.el.querySelector('[data-product-actions]');
                    this.swatchesEl = this.el.querySelector('[data-swatches]');
                    this.quickBuyEl = this.el.querySelector('[data-quick-buy]');
                    this.quickshopSlimEl = this.el.querySelector('[data-quickshop-slim]');
                    this.quickshopFullEl = this.el.querySelector('[data-quickshop-full]');
                    this.hasProductActions = this.actions !== null;
                    this._addToCart = this._addToCart.bind(this);
                    this._actionsToggle = this._actionsToggle.bind(this);
                    this._openQuickShop = this._openQuickShop.bind(this);

                    if (this.hasProductActions) {
                        this._setSortByQueryParameters();

                        if (this.$html.hasClass('no-touch') && this.defaultView !== 'list-view') {
                            this.events.register(this.el, 'mouseenter', function (e) {
                                return _this2._actionsToggle(e);
                            });
                            this.events.register(this.el, 'mouseleave', function (e) {
                                return _this2._actionsToggle(e);
                            });
                            this.events.register(this.el, 'focusin', function (e) {
                                return _this2._actionsToggle(e);
                            });
                        } // $scripts checks existence of script in header before attempting to inject


                        script_default()(jquery_default()('[data-scripts]').data('shopify-api-url'), function () {
                            _this2.events.register(_this2.quickBuyEl, 'click', function (e) {
                                return _this2._addToCart(e);
                            });

                            _this2.events.register(_this2.quickshopSlimEl, 'click', function (e) {
                                return _this2._openQuickShop(e);
                            });

                            _this2.events.register(_this2.quickshopFullEl, 'click', function (e) {
                                return _this2._openQuickShop(e);
                            });
                        });
                    }

                    this.expandAnimation = transition({
                        el: this.content,
                        state: 'closed'
                    });

                    if (this.quickbuyEl !== null) {
                        this._initQuickBuy();
                    }

                    this._objectFitPolyfill();

                    if (this.swatchesEl) {
                        this.swatches = new GridItemSwatches_GridItemSwatches({
                            el: this.$el[0],
                            setInitialVariant: function setInitialVariant(id) {
                                _this2.quickshopInitialVariant = id;
                            },
                            product: this.product
                        });
                    }
                }
                /**
                 * Make Shopify aware of releavent collection search info
                 *  - tag
                 *  - vendor
                 *  - pagination
                 *  - sorting criteria
                 *
                 * @private
                 */

            }, {
                key: "_setSortByQueryParameters",
                value: function _setSortByQueryParameters() {
                    Shopify.queryParams = {};

                    if (location.search.length) {
                        for (var i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
                            var aKeyValue = aCouples[i].split('='); // Reset the page number when we apply (i.e. don't add it to params)

                            if (aKeyValue.length > 1 && aKeyValue[0] !== 'page') {
                                Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
                            }
                        }
                    }
                }
            }, {
                key: "_initQuickBuy",
                value: function _initQuickBuy() {
                    try {
                        this.quickBuySettings = JSON.parse(this.$el.find('[data-quick-buy-settings]').text());
                    } catch (error) {
                        console.warn("Quick buy: invalid QuickBuy data found. ".concat(error.message));
                    }
                }
            }, {
                key: "_openQuickShop",
                value: function _openQuickShop(event) {
                    event.preventDefault();
                    var leftThumbsClass = event.currentTarget.hasAttribute('data-thumbs-left') ? ' quickshop-thumbs-left' : '';
                    var modalClass = event.currentTarget.hasAttribute('data-quickshop-full') ? "quickshop-full".concat(leftThumbsClass) : 'quickshop-slim';

                    if (this.productQuickshop) {
                        this.productQuickshop.unload();
                    }

                    this.productQuickshop = new ProductQuickshop_ProductQuickshop({
                        $el: this.$el,
                        id: this.id,
                        modalClass: modalClass,
                        trigger: this.$el.find('.productitem--title a'),
                        initialVariant: this.quickshopInitialVariant
                    });
                }
            }, {
                key: "_isObjectFitAvailable",
                value: function _isObjectFitAvailable() {
                    return 'objectFit' in document.documentElement.style;
                }
            }, {
                key: "_objectFitPolyfill",
                value: function _objectFitPolyfill() {
                    if (this._isObjectFitAvailable()) {
                        return;
                    }

                    var $figure = jquery_default()('[data-product-item-image]', this.$el);
                    var featuredSrc = jquery_default()('img:not(.productitem--image-alternate)', $figure).attr('src');
                    var alternateSrc = jquery_default()('.productitem--image-alternate', $figure).attr('src');
                    $figure.addClass('product-item-image-no-objectfit');
                    $figure.css('background-image', "url(\"".concat(featuredSrc, "\")"));

                    if (alternateSrc) {
                        this.events.register(this.el, 'mouseover', function () {
                            $figure.css('background-image', "url(\"".concat(alternateSrc, "\")"));
                        });
                        this.events.register(this.el, 'mouseleave', function () {
                            $figure.css('background-image', "url(\"".concat(featuredSrc, "\")"));
                        });
                    }
                }
                /**
                 * Get height of element, and combined height of element + actions
                 *
                 * @returns 
                 * @private
                 */

            }, {
                key: "_getHeights",
                value: function _getHeights() {
                    var _this$el$getBoundingC = this.el.getBoundingClientRect(),
                            height = _this$el$getBoundingC.height;

                    var actionsHeight = this.actions.getBoundingClientRect().height;
                    return {
                        heightBase: height,
                        heightExpanded: height + actionsHeight
                    };
                }
            }, {
                key: "_actionsToggle",
                value: function _actionsToggle(event) {
                    if (!Layout.isGreaterThanBreakpoint('M')) return;
                    var $currentTarget = jquery_default()(event.currentTarget);
                    var $target = jquery_default()(event.target);
                    var openProductItem = false; // This function gets called on the element as well as the document focusin, so we want to
                    // be extra careful that we are inside the product card in question. We want the product card
                    // to close if another product card has received focus.

                    var productHasFocus = this.$el.is($currentTarget) || this.$el.is($target) || this.$el.is($target.parents('.productgrid--item').first()) || event.type === 'focusin' && $target[0].contains(this.$el[0]);

                    if (event.type === 'mouseenter' || event.type === 'mouseleave') {
                        openProductItem = event.type === 'mouseenter';
                    } else if (productHasFocus) {
                        openProductItem = true;
                    }

                    if (openProductItem) {
                        this._showActions();
                    } else {
                        this._hideActions();
                    }
                }
            }, {
                key: "_showActions",
                value: function _showActions() {
                    var _this3 = this;

                    if (this.actionsOpen) {
                        return;
                    }

                    var _this$_getHeights = this._getHeights(),
                            heightBase = _this$_getHeights.heightBase,
                            heightExpanded = _this$_getHeights.heightExpanded;

                    this.el.style.setProperty('--base-height', "".concat(heightBase, "px"));
                    this.el.style.setProperty('--open-height', "".concat(heightExpanded, "px")); // Store set the outer grid item to be open so it knows to adjust its z-index

                    this.el.setAttribute('data-open', ''); // Start animation, and transition base height to expanded height (in CSS)

                    this.expandAnimation.animateTo('open');
                    this.focusinEvent = this.events.register(document, 'focusin', function (e) {
                        return _this3._actionsToggle(e);
                    });
                    this.actionsOpen = true;
                }
            }, {
                key: "_hideActions",
                value: function _hideActions() {
                    var _this4 = this;

                    this.expandAnimation.animateTo('closed').then(function () {
                        _this4.el.removeAttribute('data-open');
                    });

                    if (this.focusinEvent) {
                        this.events.unregister(this.focusinEvent);
                    }

                    this.actionsOpen = false;
                }
            }, {
                key: "_addToCart",
                value: function _addToCart(event) {
                    event.preventDefault();

                    if (this.addToCartFlyout) {
                        this.addToCartFlyout.unload();
                    }

                    var atcButton = event.currentTarget;
                    var variantID = atcButton.getAttribute('data-variant-id');
                    var formData = [{
                        name: 'id',
                        value: variantID
                    }, {
                        name: 'quantity',
                        value: 1
                    }];
                    var options = {
                        atcButton: atcButton,
                        settings: {
                            moneyFormat: this.quickBuySettings.money_format,
                            cartRedirection: this.quickBuySettings.cart_redirection
                        }
                    };
                    this.addToCartFlyout = new AddToCartFlyout_AddToCartFlyout(formData, options);
                }
            }, {
                key: "unload",
                value: function unload() {
                    this.events.unregisterAll();

                    if (this.productQuickshop) {
                        this.productQuickshop.unload();
                    }

                    document.removeEventListener('focusin', this._actionsToggle);

                    if (this.swatches) {
                        this.swatches.unload();
                    }

                    this.lazyLoader.unload();
                }
            }]);

            return ProductGridItem;
        }();


// CONCATENATED MODULE: ./source/scripts/sections/StaticCollection.js
        function StaticCollection_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

        function StaticCollection_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

        function StaticCollection_createClass(Constructor, protoProps, staticProps) { if (protoProps) StaticCollection_defineProperties(Constructor.prototype, protoProps); if (staticProps) StaticCollection_defineProperties(Constructor, staticProps); return Constructor; }






        var StaticCollection_StaticCollection = /*#__PURE__*/function () {
            function StaticCollection(section) {
                var _this = this;

                StaticCollection_classCallCheck(this, StaticCollection);

                this.section = section;
                this.$el = jquery_default()(section.el);
                this.el = section.el;
                this.context = section.data.context;
                this.collectionUrl = this.context.collectionUrl;
                this.$focusItem = null;
                this.defaultView = this.context.grid_list;
                this.filtersContentSelector = '[data-productgrid-filters-content]';
                this.sortContent = '[data-productgrid-sort-content]';
                this.$sortTrigger = this.$el.find('[data-productgrid-trigger-sort]');
                this.$sortTriggerButton = this.$el.find('[data-productgrid-trigger-sort-button]');
                this.$sortTriggerModal = this.$el.find('[data-productgrid-modal-sort]');
                this.$filtersTrigger = this.$el.find('[data-productgrid-trigger-filters]');
                this.$filtersContent = this.$el.find(this.filtersContentSelector);
                this.$allTags = this.$filtersContent.find('.filter-item a:not([data-filter-toggle])');
                this.$advancedTags = this.$el.find('[data-tag-advanced] a');
                this.$additionalTags = this.$el.find('[data-filter-toggle]');
                this.$viewToggle = this.$el.find('[data-collection-view]');
                this.$gridContainer = this.$el.find('.productgrid--outer');
                this.filterCheckboxes = this.el.querySelectorAll('.filter-icon--checkbox');
                this._changeSorting = this._changeSorting.bind(this);
                this._changeSortingButton = this._changeSortingButton.bind(this);
                this._showSortModal = this._showSortModal.bind(this);
                this._showFiltersModal = this._showFiltersModal.bind(this);
                this._activateTag = this._activateTag.bind(this);
                this._advancedTags = this._advancedTags.bind(this);
                this._toggleTags = this._toggleTags.bind(this);
                this._toggleView = this._toggleView.bind(this);
                this._checkListView = this._checkListView.bind(this);
                this.events = [this.$sortTrigger.on('change.collection', this._changeSorting), this.$sortTriggerButton.on('click.collection', this._changeSortingButton), this.$sortTriggerModal.on('click.collection', this._showSortModal), this.$filtersTrigger.on('click.collection', this._showFiltersModal), this.$allTags.on('click.collection', function (e) {
                    return _this._activateTag(e.currentTarget);
                }), this.$additionalTags.on('click.collection', this._toggleTags), this.$viewToggle.on('click.collection', this._toggleView)]; // Product items

                this.productItems = [];
                this.fillAnimations = {};
                this.checkAnimations = {};

                this._initAnimations();

                this._setSortByQueryParameters();

                this._checkListView();

                this.modal = new Modal_Modal();
            }
            /**
             * Initialize animations on checkbox container
             * using filter tag as JSON key
             */


            StaticCollection_createClass(StaticCollection, [{
                key: "_initAnimations",
                value: function _initAnimations() {
                    var _this2 = this;

                    this.filterCheckboxes.forEach(function (el) {
                        var tagHandle = el.dataset.handle;
                        var checkmark = el.querySelector('.checkmark');
                        var checkmarkCheck = el.querySelector('.checkmark__check');
                        var state = 'unchecked';

                        if (el.closest('.filter-item').dataset.filterActive === "true") {
                            state = 'checked';
                        }

                        var fillAnimation = transition({
                            el: checkmark,
                            state: state
                        });
                        var checkAnimation = transition({
                            el: checkmarkCheck,
                            state: state
                        });
                        _this2.fillAnimations[tagHandle] = fillAnimation;
                        _this2.checkAnimations[tagHandle] = checkAnimation;
                    });
                }
            }, {
                key: "onSectionUnload",
                value: function onSectionUnload() {
                    var _this3 = this;

                    this.events.forEach(function ($el) {
                        return $el.off('.collection');
                    });
                    this.modal.unload();
                    Object.keys(this.fillAnimations).forEach(function (key) {
                        _this3.fillAnimations[key].unload();

                        _this3.checkAnimations[key].unload();
                    });
                    this.productItems.forEach(function (productItem) {
                        productItem.unload();
                    });
                }
            }, {
                key: "_initProductItems",
                value: function _initProductItems() {
                    var _this4 = this;

                    var view = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'grid-view';
                    var $productItems = this.$el.find('[data-product-item]');
                    $productItems.each(function (i, productItem) {
                        _this4.productItems.push(new ProductGridItem_ProductGridItem({
                            el: productItem,
                            id: _this4.section.id,
                            lazy: true,
                            grid_list: view
                        }));
                    });
                }
                /**
                 * Open Tags/Filters modal (on mobile)
                 *
                 * @param event
                 * @private
                 */

            }, {
                key: "_showFiltersModal",
                value: function _showFiltersModal(event) {
                    event.preventDefault();
                    this.$focusItem = jquery_default()(event.currentTarget);
                    this.modal.open(this.filtersContentSelector, 'productgrid-filters');
                }
                /**
                 * Open Sort by modal (on mobile)
                 *
                 * @param event
                 * @private
                 */

            }, {
                key: "_showSortModal",
                value: function _showSortModal(event) {
                    event.preventDefault();
                    this.$focusItem = jquery_default()(event.currentTarget);
                    this.modal.open(this.sortContent, 'productgrid-sort');
                }
            }, {
                key: "_deactivateTags",
                value: function _deactivateTags(currentFilterItem) {
                    var _this5 = this;

                    var currentGroup = currentFilterItem.closest('[data-filter-group]');
                    var activeTags = currentGroup.querySelectorAll('[data-filter-active="true"]');
                    activeTags.forEach(function (el) {
                        var itemTag = el.dataset.handle;
                        currentGroup.querySelector(".filter-item[data-handle='".concat(itemTag, "']")).dataset.filterActive = false;

                        if (_this5.fillAnimations[itemTag] && _this5.checkAnimations[itemTag]) {
                            _this5.fillAnimations[itemTag].animateTo('unchecked');

                            _this5.checkAnimations[itemTag].animateTo('unchecked');
                        }
                    });
                }
                /**
                 * Style a tag as active after click, before page transition
                 *
                 * @param event
                 * @private
                 */

            }, {
                key: "_activateTag",
                value: function _activateTag(target) {
                    var _this6 = this;

                    event.preventDefault();
                    var href = target.getAttribute('href');
                    var filterItem = target.closest('.filter-item');
                    var filterItemTag = filterItem.dataset.handle;
                    var animateTo = 'checked';

                    if (filterItem.dataset.filterActive === 'true') {
                        animateTo = 'unchecked';
                    }

                    this._deactivateTags(filterItem);

                    if (animateTo === 'checked') {
                        filterItem.dataset.filterActive = true;
                    } else {
                        filterItem.dataset.filterActive = false;
                    }

                    if (this.fillAnimations[filterItemTag] && this.checkAnimations[filterItemTag]) {
                        this.fillAnimations[filterItemTag].animateTo(animateTo);
                        this.checkAnimations[filterItemTag].animateTo(animateTo).then(function () {
                            if (_this6.$advancedTags.length === 0) {
                                location.href = href;
                            } else {
                                _this6._advancedTags(jquery_default()(target));
                            }
                        });
                    } else {
                        // If the animation is not registered to the tag, it is a swatch and should
                        // go straight to the advanced tags function
                        this._advancedTags(jquery_default()(target));
                    }
                }
                /**
                 * Used by advanced tags to concatenate tag searches
                 *
                 * @param event
                 * @private
                 */

            }, {
                key: "_advancedTags",
                value: function _advancedTags(link) {
                    var $target = link.parent();
                    var $filtersContent = $target.closest('nav');
                    var filterGroups = $filtersContent.find('[data-filter-group]');
                    var filterHandles = []; // Build the filter for the url based on what is in the dom

                    filterGroups.each(function (index, filterGroup) {
                        var selectedItems = filterGroup.querySelectorAll('[data-filter-active="true"]');

                        if (selectedItems.length) {
                            filterHandles.push(jquery_default()(selectedItems).data('handle'));
                        }
                    });

                    this._updateLocation(filterHandles.join('+'));
                }
            }, {
                key: "_updateLocation",
                value: function _updateLocation(filter) {
                    if (this.collectionUrl.indexOf('vendors') > -1) {
                        location.href = "".concat(this.collectionUrl, "&constraint=").concat(filter);
                    } else {
                        location.href = "".concat(this.collectionUrl, "/").concat(filter);
                    }
                }
                /**
                 * Expand / Collapse additional tags in the sidebar
                 *
                 * @param event
                 * @private
                 */

            }, {
                key: "_toggleTags",
                value: function _toggleTags(event) {
                    event.preventDefault();
                    var $trigger = jquery_default()(event.currentTarget);
                    var $items = $trigger.parent().siblings('[data-hidden-default]');
                    var siblingsVisible = $trigger.data('filter-toggle');
                    $items.toggleClass('filter-item--hidden', siblingsVisible);
                    $trigger.data('filter-toggle', !siblingsVisible).text(!siblingsVisible ? this.context.see_less : this.context.see_more);

                    if (this.modal.isOpen()) {
                        this.modal.position();
                    }
                }
                /**
                 * Make Shopify aware of releavent collection search info
                 *  - tag
                 *  - vendor
                 *  - pagination
                 *  - sorting criteria
                 *
                 * @private
                 */

            }, {
                key: "_setSortByQueryParameters",
                value: function _setSortByQueryParameters() {
                    Shopify.queryParams = {};

                    if (location.search.length) {
                        for (var i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
                            var aKeyValue = aCouples[i].split('='); // Reset the page number when we apply (i.e. don't add it to params)

                            if (aKeyValue.length > 1 && aKeyValue[0] !== 'page') {
                                Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
                            }
                        }
                    }
                }
                /**
                 * Sort by opens a modal on mobile, this handles button events
                 *
                 * @param event
                 * @private
                 */

            }, {
                key: "_changeSortingButton",
                value: function _changeSortingButton(event) {
                    var activeClass = 'utils-sortby--modal-button--active';
                    jquery_default()(event.currentTarget).addClass(activeClass).parent().siblings().find(".".concat(activeClass)).removeClass(activeClass);

                    this._changeSorting(event);
                }
                /**
                 * Change sorting of collection
                 *
                 * @param event
                 * @private
                 */

            }, {
                key: "_changeSorting",
                value: function _changeSorting(event) {
                    event.preventDefault();
                    var $target = jquery_default()(event.currentTarget);
                    Shopify.queryParams.sort_by = $target.val();
                    location.search = jQuery.param(Shopify.queryParams).replace(/\+/g, '%20');
                }
                /**
                 * Toggle grid or list view
                 *
                 */

            }, {
                key: "_toggleView",
                value: function _toggleView(event) {
                    var $target = jquery_default()(event.currentTarget);
                    Shopify.queryParams.grid_list = $target.data('collection-view');
                    location.search = jQuery.param(Shopify.queryParams).replace(/\+/g, '%20');
                }
                /**
                 * Check grid/list view toggle query parameters
                 *
                 */

            }, {
                key: "_checkListView",
                value: function _checkListView() {
                    var view = Shopify.queryParams.grid_list ? Shopify.queryParams.grid_list : this.defaultView;
                    this.$el.find('[href*="&grid_list"]').attr('href', function (i, url) {
                        var href = url;

                        if (url.indexOf('?') < 0) {
                            var replaceIndex = url.indexOf('&');
                            var firstHalf = url.substr(0, replaceIndex);
                            var secondHalf = url.substr(replaceIndex + 1);
                            href = firstHalf.concat('?', secondHalf);
                        }

                        href = href.replace('grid_list', "grid_list=".concat(view));
                        return href;
                    });
                    this.$el.find('.utils-viewtoggle-button').removeClass('active');
                    jquery_default()("[data-collection-view=".concat(view, "]")).addClass('active');
                    var className = view.replace('-', '');
                    this.$gridContainer.addClass("productgrid-".concat(className));

                    if (className === 'listview') {
                        this.$gridContainer.removeClass('productgrid-gridview');
                    } else {
                        this.$gridContainer.removeClass('productgrid-listview');
                    }

                    this._initProductItems(view);
                }
            }]);

            return StaticCollection;
        }();


// EXTERNAL MODULE: ./node_modules/@pixelunion/breakpoint/dist/cjs/index.js
        var cjs = __webpack_require__(5);

// CONCATENATED MODULE: ./node_modules/@pixelunion/shopify-cross-border/dist/index.es.js

        /*!
         * @pixelunion/shopify-cross-border v1.0.4
         * (c) 2020
         */

        function shopify_cross_border_dist_index_es_classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
                throw new TypeError("Cannot call a class as a function");
            }
        }

        function shopify_cross_border_dist_index_es_defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }

        function shopify_cross_border_dist_index_es_createClass(Constructor, protoProps, staticProps) {
            if (protoProps) shopify_cross_border_dist_index_es_defineProperties(Constructor.prototype, protoProps);
            if (staticProps) shopify_cross_border_dist_index_es_defineProperties(Constructor, staticProps);
            return Constructor;
        }

        function unwrapExports (x) {
            return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
        }

        function createCommonjsModule(fn, module) {
            return module = { exports: {} }, fn(module, module.exports), module.exports;
        }

        var EventHandler_1 = createCommonjsModule(function (module, exports) {

            exports.__esModule = true;

            var EventHandler =
                    /** @class */
                    function () {
                        function EventHandler() {
                            this.events = [];
                        }

                        EventHandler.prototype.register = function (el, event, listener) {
                            if (!el || !event || !listener) return null;
                            this.events.push({
                                el: el,
                                event: event,
                                listener: listener
                            });
                            el.addEventListener(event, listener);
                            return {
                                el: el,
                                event: event,
                                listener: listener
                            };
                        };

                        EventHandler.prototype.unregister = function (_a) {
                            var el = _a.el,
                                    event = _a.event,
                                    listener = _a.listener;
                            if (!el || !event || !listener) return null;
                            this.events = this.events.filter(function (e) {
                                return el !== e.el || event !== e.event || listener !== e.listener;
                            });
                            el.removeEventListener(event, listener);
                            return {
                                el: el,
                                event: event,
                                listener: listener
                            };
                        };

                        EventHandler.prototype.unregisterAll = function () {
                            this.events.forEach(function (_a) {
                                var el = _a.el,
                                        event = _a.event,
                                        listener = _a.listener;
                                return el.removeEventListener(event, listener);
                            });
                            this.events = [];
                        };

                        return EventHandler;
                    }();

            exports["default"] = EventHandler;
        });

        var Events = unwrapExports(EventHandler_1);

        var selectors = {
            disclosureList: '[data-disclosure-list]',
            disclosureToggle: '[data-disclosure-toggle]',
            disclosureInput: '[data-disclosure-input]',
            disclosureOptions: '[data-disclosure-option]'
        };
        var classes = {
            listVisible: 'disclosure-list--visible',
            alternateDrop: 'disclosure-list--alternate-drop'
        };

        var Disclosure = /*#__PURE__*/function () {
            function Disclosure(el) {
                shopify_cross_border_dist_index_es_classCallCheck(this, Disclosure);

                this.el = el;
                this.events = new Events();
                this.cache = {};

                this._cacheSelectors();

                this._connectOptions();

                this._connectToggle();

                this._onFocusOut();
            }

            shopify_cross_border_dist_index_es_createClass(Disclosure, [{
                key: "_cacheSelectors",
                value: function _cacheSelectors() {
                    this.cache = {
                        disclosureList: this.el.querySelector(selectors.disclosureList),
                        disclosureToggle: this.el.querySelector(selectors.disclosureToggle),
                        disclosureInput: this.el.querySelector(selectors.disclosureInput),
                        disclosureOptions: this.el.querySelectorAll(selectors.disclosureOptions)
                    };
                }
            }, {
                key: "_connectToggle",
                value: function _connectToggle() {
                    var _this = this;

                    this.events.register(this.cache.disclosureToggle, 'click', function (e) {
                        var ariaExpanded = e.currentTarget.getAttribute('aria-expanded') === 'true';
                        e.currentTarget.setAttribute('aria-expanded', !ariaExpanded);

                        _this.cache.disclosureList.classList.remove(classes.alternateDrop);

                        _this.cache.disclosureList.classList.toggle(classes.listVisible);

                        window.requestAnimationFrame(function () {
                            var _this$cache$disclosur = _this.cache.disclosureList.getBoundingClientRect(),
                                    left = _this$cache$disclosur.left,
                                    width = _this$cache$disclosur.width;

                            var _window = window,
                                    innerWidth = _window.innerWidth;
                            var gutter = 30;

                            if (left + width + gutter > innerWidth) {
                                _this.cache.disclosureList.classList.add(classes.alternateDrop);
                            }
                        });
                    });
                }
            }, {
                key: "_connectOptions",
                value: function _connectOptions() {
                    var _this2 = this;

                    var options = this.cache.disclosureOptions;

                    for (var i = 0; i < options.length; i++) {
                        var option = options[i];
                        this.events.register(option, 'click', function (e) {
                            return _this2._submitForm(e.currentTarget.dataset.value);
                        });
                    }
                }
            }, {
                key: "_onFocusOut",
                value: function _onFocusOut() {
                    var _this3 = this;

                    this.events.register(this.cache.disclosureToggle, 'focusout', function (e) {
                        var disclosureLostFocus = !_this3.el.contains(e.relatedTarget);

                        if (disclosureLostFocus) {
                            _this3._hideList();
                        }
                    });
                    this.events.register(this.cache.disclosureList, 'focusout', function (e) {
                        var childInFocus = e.currentTarget.contains(e.relatedTarget);

                        var isVisible = _this3.cache.disclosureList.classList.contains(classes.listVisible);

                        if (isVisible && !childInFocus) {
                            _this3._hideList();
                        }
                    });
                    this.events.register(this.el, 'keyup', function (e) {
                        if (e.defaultPrevented) {
                            return; // Do nothing if the event was already processed
                        }

                        if (e.key !== 'Escape' || e.key !== 'Esc') return;

                        _this3._hideList();

                        _this3.cache.disclosureToggle.focus();
                    });
                    this.events.register(document.body, 'click', function (e) {
                        var isOption = _this3.el.contains(e.target);

                        var isVisible = _this3.cache.disclosureList.classList.contains(classes.listVisible);

                        if (isVisible && !isOption) {
                            _this3._hideList();
                        }
                    });
                }
            }, {
                key: "_submitForm",
                value: function _submitForm(value) {
                    this.cache.disclosureInput.value = value;
                    this.el.closest('form').submit();
                }
            }, {
                key: "_hideList",
                value: function _hideList() {
                    this.cache.disclosureList.classList.remove(classes.listVisible);
                    this.cache.disclosureToggle.setAttribute('aria-expanded', false);
                }
            }, {
                key: "unload",
                value: function unload() {
                    this.events.unregisterAll();
                }
            }]);

            return Disclosure;
        }();

        if (!Element.prototype.matches) {
            Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
        }

        if (!Element.prototype.closest) {
            Element.prototype.closest = function closest(s) {
                var el = this;

                do {
                    if (el.matches(s)) return el;
                    el = el.parentElement || el.parentNode;
                } while (el !== null && el.nodeType === 1);

                return null;
            };
        }

        /* harmony default export */ var shopify_cross_border_dist_index_es = (Disclosure);

// CONCATENATED MODULE: ./source/scripts/Accordion.js
        function Accordion_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

        function Accordion_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Accordion_ownKeys(Object(source), true).forEach(function (key) { Accordion_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Accordion_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

        function Accordion_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

        function Accordion_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

        function Accordion_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

        function Accordion_createClass(Constructor, protoProps, staticProps) { if (protoProps) Accordion_defineProperties(Constructor.prototype, protoProps); if (staticProps) Accordion_defineProperties(Constructor, staticProps); return Constructor; }



        var Accordion_makeBlock = function makeBlock(el) {
            return {
                animation: transition({
                    el: el,
                    state: 'open',
                    stateAttribute: 'data-accordion-state',
                    stateChangeAttribute: 'data-accordion-animation'
                }),
                isOpen: true
            };
        };

        var setOpenHeight = function setOpenHeight(el) {
            el.style.setProperty('--menu-open-height', "".concat(el.scrollHeight, "px"));
        };

        var Accordion = /*#__PURE__*/function () {
            function Accordion(el) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

                Accordion_classCallCheck(this, Accordion);

                this.el = el;
                this.options = Accordion_objectSpread({
                    content: '[data-accordion-content]',
                    animate: true,
                    onStart: function onStart() {}
                }, options);
                this.blocks = new Map();
            }

            Accordion_createClass(Accordion, [{
                key: "closeAll",
                value: function closeAll() {
                    var _this = this;

                    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                    this.el.querySelectorAll(this.options.content).forEach(function (block) {
                        return _this.close(block, options);
                    });
                }
            }, {
                key: "openAll",
                value: function openAll() {
                    var _this2 = this;

                    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                    this.el.querySelectorAll(this.options.content).forEach(function (block) {
                        return _this2.open(block, options);
                    });
                }
            }, {
                key: "open",
                value: function open(el) {
                    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

                    this._open(el, options);
                }
            }, {
                key: "close",
                value: function close(el) {
                    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

                    this._close(el, options);
                }
            }, {
                key: "toggle",
                value: function toggle(el) {
                    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

                    var _this$_getBlock = this._getBlock(el),
                            isOpen = _this$_getBlock.isOpen;

                    if (isOpen) {
                        this._close(el, options);
                    } else {
                        this._open(el, options);
                    }
                }
            }, {
                key: "unload",
                value: function unload() {
                    this.blocks.forEach(function (_ref) {
                        var animation = _ref.animation;
                        return animation.unload();
                    });
                }
            }, {
                key: "_getBlock",
                value: function _getBlock(el) {
                    var block = el.matches(this.options.content) ? el : el.querySelector(this.options.content);

                    if (!this.blocks.has(block)) {
                        this.blocks.set(block, Accordion_makeBlock(block));
                    }

                    return this.blocks.get(block);
                }
            }, {
                key: "_open",
                value: function _open(el, _ref2) {
                    var _ref2$onComplete = _ref2.onComplete,
                            onComplete = _ref2$onComplete === void 0 ? function () {} : _ref2$onComplete,
                            _ref2$force = _ref2.force,
                            force = _ref2$force === void 0 ? !this.options.animate : _ref2$force;

                    var block = this._getBlock(el);

                    if (block.isOpen) return;
                    block.isOpen = true;
                    this.options.onStart({
                        el: block.animation.el,
                        state: 'open'
                    });
                    block.animation.animateTo('open', {
                        force: force,
                        onStart: function onStart(_ref3) {
                            var el = _ref3.el;
                            return setOpenHeight(el);
                        }
                    }).then(function (state) {
                        if (state === 'open') {
                            onComplete();
                        }
                    });
                }
            }, {
                key: "_close",
                value: function _close(el, _ref4) {
                    var _ref4$onComplete = _ref4.onComplete,
                            onComplete = _ref4$onComplete === void 0 ? function () {} : _ref4$onComplete,
                            _ref4$force = _ref4.force,
                            force = _ref4$force === void 0 ? !this.options.animate : _ref4$force;

                    var block = this._getBlock(el);

                    if (!block.isOpen) return;
                    block.isOpen = false;
                    this.options.onStart({
                        el: block.animation.el,
                        state: 'closed'
                    });
                    setOpenHeight(block.animation.el);
                    block.animation.animateTo('closed', {
                        force: force
                    }).then(function (state) {
                        if (state === 'closed') {
                            onComplete();
                        }
                    });
                }
            }]);

            return Accordion;
        }();


// CONCATENATED MODULE: ./source/scripts/sections/StaticFooter.js
        function StaticFooter_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

        function StaticFooter_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

        function StaticFooter_createClass(Constructor, protoProps, staticProps) { if (protoProps) StaticFooter_defineProperties(Constructor.prototype, protoProps); if (staticProps) StaticFooter_defineProperties(Constructor, staticProps); return Constructor; }







        var StaticFooter_StaticFooter = /*#__PURE__*/function () {
            function StaticFooter(section) {
                var _this = this;

                StaticFooter_classCallCheck(this, StaticFooter);

                this.$el = jquery_default()(section.el);
                this.el = section.el;
                this.currencyDisclosureEl = this.el.querySelector('[data-disclosure-currency]');
                this.localeDisclosureEl = this.el.querySelector('[data-disclosure-locale]');
                this.accordionTrigger = '[data-accordion-trigger]';
                this.disclosures = [];
                this.Accordion = new Accordion(this.el, {
                    onStart: function onStart(_ref) {
                        var el = _ref.el,
                                state = _ref.state;
                        el.parentNode.parentNode.querySelector(_this.accordionTrigger).dataset.accordionTrigger = state;
                    }
                });

                if (cjs["max"]('M')) {
                    this.Accordion.closeAll({
                        force: true
                    });
                }

                this.forms = new Forms_Forms(this.$el);

                if (this.currencyDisclosureEl) {
                    this.disclosures.push(new shopify_cross_border_dist_index_es(this.currencyDisclosureEl));
                }

                if (this.localeDisclosureEl) {
                    this.disclosures.push(new shopify_cross_border_dist_index_es(this.localeDisclosureEl));
                } // Handle Accordion interaction when window size changes


                cjs["onChange"](function (breakpoints) {
                    return _this.onBreakpointChange(breakpoints);
                });

                this._bindEvents();
            }

            StaticFooter_createClass(StaticFooter, [{
                key: "_bindEvents",
                value: function _bindEvents() {
                    var _this2 = this;

                    this.$el.on('click.footer', this.accordionTrigger, function (event) {
                        event.preventDefault();

                        _this2._toggleAccordion(jquery_default()(event.currentTarget).parent()[0]);
                    });
                }
            }, {
                key: "onSectionUnload",
                value: function onSectionUnload() {
                    this.$el.off('.footer');
                    this.forms.unload();
                    this.disclosures.forEach(function (disclosure) {
                        return disclosure.unload();
                    });
                    this.Accordion.unload();
                }
            }, {
                key: "onSectionBlockSelect",
                value: function onSectionBlockSelect(block) {
                    if (block.el.classList.contains('has-accordion')) this._toggleAccordion(block);
                }
            }, {
                key: "onSectionBlockDeselect",
                value: function onSectionBlockDeselect(block) {
                    if (block.el.classList.contains('has-accordion')) this._toggleAccordion(block);
                }
            }, {
                key: "_toggleAccordion",
                value: function _toggleAccordion(block) {
                    if (cjs["min"]('L')) return;
                    this.Accordion.toggle(block);
                }
            }, {
                key: "onBreakpointChange",
                value: function onBreakpointChange(breakpoints) {
                    if (breakpoints.current.min('L')) {
                        this.Accordion.openAll({
                            force: true
                        });
                    } else if (breakpoints.previous.min('L') && breakpoints.current.max('M')) {
                        this.Accordion.closeAll({
                            force: true
                        });
                    }
                }
            }]);

            return StaticFooter;
        }();


// CONCATENATED MODULE: ./source/scripts/components/StickyHeader.js
        function StickyHeader_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

        function StickyHeader_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

        function StickyHeader_createClass(Constructor, protoProps, staticProps) { if (protoProps) StickyHeader_defineProperties(Constructor.prototype, protoProps); if (staticProps) StickyHeader_defineProperties(Constructor, staticProps); return Constructor; }




        var StickyHeader_StickyHeader = /*#__PURE__*/function () {
            function StickyHeader(options, settings) {
                var _this = this;

                StickyHeader_classCallCheck(this, StickyHeader);

                this.body = document.querySelector('body');
                this.header = document.querySelector('[data-site-header]');
                this.menu = this.header.querySelector('[data-site-navigation]');
                this.menuToggle = options.menuToggle;
                this.postMessage = options.postMessage;
                this.settings = settings;
                this.transitioning = false;
                this.lastToggle = Date.now() - 1000;
                this.stickyClass = 'site-header-sticky';
                this.scrolledClass = 'site-header-sticky--scrolled';
                this.navOpenClass = 'site-header-nav--open';
                this._toggleStickyHeader = this._toggleStickyHeader.bind(this);
                this._toggleMenu = this._toggleMenu.bind(this);

                if (this.settings.sticky_header) {
                    this.body.classList.add(this.stickyClass);
                    window.requestAnimationFrame(function () {
                        // If browser doesn't support sticky, we don't want any of the sticky functionality.
                        if (window.getComputedStyle(_this.header).position.indexOf('sticky') > -1) {
                            _this.observer = new IntersectionObserver(function (entries) {
                                return _this._toggleStickyHeader(entries);
                            });

                            _this.observer.observe(document.querySelector('[data-header-intersection-target]'));

                            _this.toggleClick = function (event) {
                                event.preventDefault();
                                if (Layout.isGreaterThanBreakpoint('M')) _this._toggleMenu();
                            };

                            _this.menuToggle.addEventListener('click', _this.toggleClick);
                        }
                    });
                }
            }

            StickyHeader_createClass(StickyHeader, [{
                key: "closeNavigation",
                value: function closeNavigation() {
                    var _this2 = this;

                    if (this.transitioning) {
                        return;
                    }

                    this.menuToggle.classList.remove('active');

                    this.navTransitionOutEvent = function () {
                        _this2.header.classList.remove(_this2.navOpenClass);

                        _this2.transitioning = false;

                        _this2.menu.removeEventListener('transitionend', _this2.navTransitionOutEvent);
                    };

                    this.menu.addEventListener('transitionend', this.navTransitionOutEvent);
                    this.transitioning = true;
                    this.menu.setAttribute('style', "margin-top: -".concat(this.menu.getBoundingClientRect().height, "px;"));
                    this.postMessage('nav:close-all');
                }
            }, {
                key: "openNavigation",
                value: function openNavigation() {
                    var _this3 = this;

                    var onOpen = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};

                    if (this.transitioning || this.header.classList.contains(this.navOpenClass)) {
                        onOpen();
                        return;
                    }

                    this.menuToggle.classList.add('active');

                    this.navTransitionInEvent = function () {
                        _this3.transitioning = false;

                        _this3.menu.removeEventListener('transitionend', _this3.navTransitionInEvent);

                        onOpen();
                    };

                    this.menu.addEventListener('transitionend', this.navTransitionInEvent);
                    this.transitioning = true; // We need to wait for the browser to set the display to 'block' before we set the margin
                    // This will help with ensuring the different animations/transitions happen in sequence
                    // and not at the same time.

                    window.requestAnimationFrame(function () {
                        _this3.header.classList.add(_this3.navOpenClass);

                        window.requestAnimationFrame(function () {
                            _this3.menu.setAttribute('style', 'margin-top: 0;');
                        });
                    });
                }
            }, {
                key: "_toggleMenu",
                value: function _toggleMenu() {
                    if (this.header.classList.contains(this.navOpenClass)) {
                        this.closeNavigation();
                    } else {
                        this.openNavigation();
                    }
                }
                /**
                 * Sticky header only shows as sticky after scroll
                 *
                 * @private
                 */

            }, {
                key: "_toggleStickyHeader",
                value: function _toggleStickyHeader(entries) {
                    if (ScrollLock.isLocked || !Layout.isGreaterThanBreakpoint('M')) {
                        return;
                    }

                    var shouldShrink = !entries[0].isIntersecting; // Sticky header is scrolled, is and is visible -- nothing more to do!

                    if (shouldShrink && this.header.classList.contains(this.scrolledClass)) {
                        return;
                    } // We also check to make sure the toggle hasnt activated recently to stop jerky transitions


                    if (this.lastToggle + 500 > Date.now()) {
                        return;
                    }

                    this.lastToggle = Date.now();

                    if (shouldShrink) {
                        this._shrink();
                    } else {
                        this._expand();
                    }
                }
            }, {
                key: "_shrink",
                value: function _shrink() {
                    this.closeNavigation();
                    this.header.classList.add(this.scrolledClass);
                }
            }, {
                key: "_expand",
                value: function _expand() {
                    this.openNavigation();
                    this.header.classList.remove(this.scrolledClass);
                    this.menuToggle.classList.remove('active');
                }
            }, {
                key: "unload",
                value: function unload() {
                    this.body.classList.remove(this.stickyClass);
                    this.body.classList.remove(this.scrolledClass);

                    if (this.observer) {
                        this.observer.disconnect();
                    }

                    this.menuToggle.removeEventListener('click', this.toggleClick);
                }
            }]);

            return StickyHeader;
        }();


// CONCATENATED MODULE: ./source/scripts/components/navigation/NavMobileSubMenus.js
        function NavMobileSubMenus_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

        function NavMobileSubMenus_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

        function NavMobileSubMenus_createClass(Constructor, protoProps, staticProps) { if (protoProps) NavMobileSubMenus_defineProperties(Constructor.prototype, protoProps); if (staticProps) NavMobileSubMenus_defineProperties(Constructor, staticProps); return Constructor; }




        var NavMobileSubMenus_NavMobileSubMenus = /*#__PURE__*/function () {
            function NavMobileSubMenus(el) {
                NavMobileSubMenus_classCallCheck(this, NavMobileSubMenus);

                this.$el = jquery_default()(el);
                this.Accordion = new Accordion(el);
                this.closeAllSubmenus(); // Sub menu selectors

                this.activeMenuClass = 'navmenu-link-parent-active';
                this.activeMenu = ".".concat(this.activeMenuClass);
                this.linkClass = 'navmenu-link-parent';
                this.linkSelector = ".".concat(this.linkClass);
                this.navTrigger = '[data-navmenu-parent]';
                this.subMenu = '[data-navmenu-submenu]';
                this.buttonClass = 'navmenu-button';
                this.buttonSelector = ".".concat(this.buttonClass);

                this._bindEvents();
            }

            NavMobileSubMenus_createClass(NavMobileSubMenus, [{
                key: "unload",
                value: function unload() {
                    this.$el.off('.mobile-nav');
                    this.Accordion.unload();
                }
            }, {
                key: "closeSubMenus",
                value: function closeSubMenus(current) {
                    var _this = this;

                    var $current = jquery_default()(current);
                    $current.find(this.activeMenu).each(function (index, el) {
                        _this._closeSubmenu(jquery_default()(el));
                    });
                }
            }, {
                key: "closeAllSubmenus",
                value: function closeAllSubmenus() {
                    this.Accordion.closeAll({
                        force: true
                    });
                }
            }, {
                key: "_bindEvents",
                value: function _bindEvents() {
                    var _this2 = this;

                    // Prevent focus state from applying on mouse click
                    this.$el.on('mousedown.mobile-nav', '.navmenu-link', function (event) {
                        event.preventDefault();
                    });
                    this.$el.on('click.mobile-nav', "".concat(this.navTrigger, " > .navmenu-link-parent"), this._linkClicked.bind(this));
                    this.$el.on('click.mobile-nav', "".concat(this.navTrigger, " > .navmenu-button"), function (event) {
                        event.preventDefault();

                        _this2._toggleSubmenu(event);
                    });
                }
            }, {
                key: "_linkClicked",
                value: function _linkClicked(event) {
                    var $target = jquery_default()(event.currentTarget);

                    if (!$target.hasClass(this.activeMenuClass)) {
                        event.preventDefault();

                        this._openSubmenu($target);
                    }
                }
            }, {
                key: "_toggleSubmenu",
                value: function _toggleSubmenu(event) {
                    var $target = jquery_default()(event.currentTarget);
                    var $link = $target.hasClass(this.linkClass) ? $target : $target.siblings(this.linkSelector).first();

                    if ($link.hasClass(this.activeMenuClass)) {
                        this._closeSubmenu($target);
                    } else {
                        this._openSubmenu($target);
                    }
                }
            }, {
                key: "_openSubmenu",
                value: function _openSubmenu($target) {
                    var $menu = $target.siblings(this.subMenu).first();
                    var $link = $target.hasClass(this.linkClass) ? $target : $target.siblings(this.linkSelector).first();
                    var $button = $target.hasClass(this.buttonClass) ? $target : $target.siblings(this.buttonSelector).first();
                    $link.addClass(this.activeMenuClass);

                    var onComplete = function onComplete() {
                        $link.attr('aria-expanded', true);
                        $button.attr('aria-expanded', true);
                    };

                    this.Accordion.open($menu[0], {
                        onComplete: onComplete
                    });
                }
            }, {
                key: "_closeSubmenu",
                value: function _closeSubmenu($target) {
                    var $menu = $target.siblings(this.subMenu).first();
                    var $link = $target.hasClass(this.linkClass) ? $target : $target.siblings(this.linkSelector).first();
                    var $button = $target.hasClass(this.buttonClass) ? $target : $target.siblings(this.buttonSelector).first();
                    $link.removeClass(this.activeMenuClass);

                    var onComplete = function onComplete() {
                        $link.attr('aria-expanded', false);
                        $button.attr('aria-expanded', false);
                    };

                    this.Accordion.close($menu[0], {
                        onComplete: onComplete
                    });
                    this.closeSubMenus($menu);
                }
            }]);

            return NavMobileSubMenus;
        }();


// CONCATENATED MODULE: ./source/scripts/components/navigation/NavMobile.js
        function NavMobile_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

        function NavMobile_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

        function NavMobile_createClass(Constructor, protoProps, staticProps) { if (protoProps) NavMobile_defineProperties(Constructor.prototype, protoProps); if (staticProps) NavMobile_defineProperties(Constructor, staticProps); return Constructor; }








        var NavMobile_NavMobile = /*#__PURE__*/function () {
            function NavMobile(elements) {
                var _this = this;

                NavMobile_classCallCheck(this, NavMobile);

                this.el = elements.el;
                this.toggleOpen = elements.toggleOpen;
                this.mobileNav = this.el.querySelector('[data-mobile-nav]');
                this.navPanel = this.el.querySelector('[data-mobile-nav-panel]');
                this.navOverlay = this.el.querySelector('[data-mobile-nav-overlay]');
                this.toggleClose = this.el.querySelector('[data-mobile-nav-close]');
                this.isOpen = false;
                this.subMenus = null;
                this.events = new EventHandler_default.a(); // Revert navigation to original state on breakpoint change

                this.breakpointHandler = this.onBreakpointChange.bind(this);
                cjs["onChange"](this.breakpointHandler);
                this.navPanelAnimation = transition({
                    el: this.navPanel,
                    state: 'closed'
                });
                this.navOverlayAnimation = transition({
                    el: this.navOverlay,
                    state: 'closed'
                });
                this.events.register(this.toggleOpen, 'click', function (e) {
                    return _this._open(e);
                });
            }

            NavMobile_createClass(NavMobile, [{
                key: "unload",
                value: function unload() {
                    this._close();

                    this.events.unregisterAll();
                    cjs["offChange"](this.breakpointHandler);
                    ScrollLock.unlock();
                }
            }, {
                key: "onBreakpointChange",
                value: function onBreakpointChange() {
                    if (cjs["min"]('L') && this.isOpen) {
                        this._close();
                    }
                }
            }, {
                key: "_open",
                value: function _open(e) {
                    var _this2 = this;

                    e.preventDefault();

                    if (cjs["min"]('L')) {
                        return;
                    }

                    ScrollLock.lock(this.navPanel);
                    this.isOpen = true; // Activate Submenu handler

                    this.subMenus = new NavMobileSubMenus_NavMobileSubMenus(this.navPanel);
                    this.mobileNav.dataset.open = 'true';
                    this.navPanelAnimation.animateTo('open');
                    this.navOverlayAnimation.animateTo('open');
                    this.mobileNav.focus();
                    trapFocus(this.mobileNav);
                    this.overlayClickEvent = this.events.register(this.navOverlay, 'click', function (e) {
                        return _this2._close(e);
                    });
                    this.toggleCloseEvent = this.events.register(this.toggleClose, 'click', function (e) {
                        return _this2._close(e);
                    });
                    this.overlayTouchEvent = this.events.register(this.navOverlay, 'touchmove', function (e) {
                        return e.preventDefault();
                    });
                    this.closeEsc = this.events.register(window, 'keydown', function (e) {
                        if (e.key === 'Escape') {
                            _this2._close(e);
                        }
                    });
                }
            }, {
                key: "_close",
                value: function _close(e) {
                    var _this3 = this;

                    if (e) e.preventDefault();
                    this.navPanelAnimation.animateTo('closed');
                    this.navOverlayAnimation.animateTo('closed').then(function () {
                        _this3.mobileNav.dataset.open = 'false';
                        removeTrapFocus(_this3.mobileNav);

                        _this3.toggleOpen.focus();
                    });
                    ScrollLock.unlock();
                    this.isOpen = false; // Close any open drop down menus

                    if (this.subMenus) {
                        this.subMenus.closeSubMenus(this.navPanel);
                        this.subMenus.closeAllSubmenus(); // Unbind Mobile sub menus

                        this.subMenus.unload();
                    }

                    this.events.unregister(this.overlayClickEvent);
                    this.events.unregister(this.overlayTouchEvent);
                    this.events.unregister(this.toggleCloseEvent);
                    this.events.unregister(this.closeEsc);
                }
            }]);

            return NavMobile;
        }();


// CONCATENATED MODULE: ./source/scripts/helpers/site-main-dimmer.js

        var site_main_dimmer_el = document.querySelector('[data-site-main-dimmer]');
        var site_main_dimmer_animation = transition({
            el: site_main_dimmer_el,
            state: 'closed'
        });
        var openers = new Set();
        var site_main_dimmer_disableAnimations = ('reduceAnimations' in document.body.dataset);
        function dim(requestor) {
            if (site_main_dimmer_disableAnimations) return;
            if (openers.has(requestor)) return;
            openers.add(requestor);
            site_main_dimmer_animation.animateTo('open');
        }
        function clear(requestor) {
            openers.delete(requestor);
            if (openers.size) return;
            site_main_dimmer_animation.animateTo('closed', {
                force: site_main_dimmer_disableAnimations
            });
        }
// CONCATENATED MODULE: ./source/scripts/components/navigation/NavDesktopParent.js
        function NavDesktopParent_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

        function NavDesktopParent_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

        function NavDesktopParent_createClass(Constructor, protoProps, staticProps) { if (protoProps) NavDesktopParent_defineProperties(Constructor.prototype, protoProps); if (staticProps) NavDesktopParent_defineProperties(Constructor, staticProps); return Constructor; }



        // eslint-disable-line import/no-cycle

        var NavDesktopParent_NavDesktopParent = /*#__PURE__*/function () {
            function NavDesktopParent(el, options) {
                var _this = this;

                NavDesktopParent_classCallCheck(this, NavDesktopParent);

                this.listitem = el;
                this.link = null;
                this.submenu = null;
                this._isOpen = false;
                this.menu = null;
                this.parentMenu = options.parentMenu;
                this.closeSiblings = this.parentMenu.closeSiblings;
                var children = this.listitem.children;

                for (var i = 0; i < children.length; i++) {
                    if (children[i].classList.contains('navmenu-link')) {
                        this.link = children[i];
                    } else if (children[i].classList.contains('navmenu-submenu')) {
                        this.submenu = children[i];
                    }
                }

                this.animation = transition({
                    el: this.submenu,
                    state: 'closed'
                });

                this.open = function () {
                    _this._open();
                };

                this.close = function () {
                    _this._close();
                };

                this.closeEsc = function (e) {
                    if (e.key === 'Escape') {
                        _this.link.focus();

                        _this.close();
                    }
                };

                this.closeTimer = null;
                this.openTimer = null;

                this.mouseover = function () {
                    clearTimeout(_this.closeTimer);

                    if (!_this.submenu.classList.contains('navmenu-depth-3')) {
                        _this.openTimer = setTimeout(_this.open, 200);
                    } else {
                        _this.open();
                    }
                };

                this.mouseout = function () {
                    clearTimeout(_this.openTimer);
                    _this.closeTimer = setTimeout(_this.close, 400);
                };

                this.click = function (e) {
                    e.stopPropagation(); // if already open, continue to link destination

                    if (!e.target.classList.contains('navmenu-link-parent') || _this._isOpen) {
                        return;
                    }

                    e.preventDefault();

                    _this.open();
                };

                this.focusin = function (e) {
                    e.stopPropagation();

                    if (e.target.classList.contains('navmenu-link-parent')) {
                        _this.closeSiblings(_this);
                    }
                };

                this.listitem.addEventListener('mouseover', this.mouseover);
                this.listitem.addEventListener('mouseout', this.mouseout);
                this.listitem.addEventListener('touchend', this.click);
                this.listitem.addEventListener('click', this.click);
                this.listitem.addEventListener('focusin', this.focusin);
                document.body.addEventListener('click', this.close);
                document.body.addEventListener('focusin', this.close);
            }

            NavDesktopParent_createClass(NavDesktopParent, [{
                key: "forceOpen",
                value: function forceOpen() {
                    return this._open(true);
                }
            }, {
                key: "forceClose",
                value: function forceClose() {
                    return this._close(true);
                }
            }, {
                key: "_open",
                value: function _open() {
                    var _this2 = this;

                    if (this._isOpen) return;
                    this._isOpen = true;
                    dim(this);
                    this.closeSiblings(this);
                    window.addEventListener('keydown', this.closeEsc);

                    if (!this.menu) {
                        this.menu = new NavDesktopMenu_NavDesktopMenu(this.submenu);
                    }

                    this.animation.animateTo('open', {
                        hold: true,
                        onStart: function onStart(_ref) {
                            var el = _ref.el;
                            var height = 0;

                            for (var i = 0; i < el.children.length; i++) {
                                height += el.children[i].offsetHeight;
                            }

                            var _window$getComputedSt = window.getComputedStyle(el),
                                    paddingTop = _window$getComputedSt.paddingTop,
                                    paddingBottom = _window$getComputedSt.paddingBottom;

                            height += parseInt(paddingTop, 10);
                            height += parseInt(paddingBottom, 10);

                            _this2.listitem.style.setProperty('--menu-open-height', "".concat(height, "px")); // Check for alternate side dropdown


                            var bounds = _this2.submenu.getBoundingClientRect();

                            if (bounds.right > document.documentElement.clientWidth) {
                                _this2.listitem.classList.add('alternate-drop');
                            }
                        }
                    }).then(function (state) {
                        if (state === 'open') {
                            _this2.link.setAttribute('aria-expanded', true);
                        }
                    });
                }
            }, {
                key: "_close",
                value: function _close() {
                    var _this3 = this;

                    var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
                    if (!this._isOpen) return;

                    if (this.menu) {
                        this.menu.unload();
                        this.menu = null;
                    }

                    this._isOpen = false;
                    window.removeEventListener('keydown', this.closeEsc);
                    clear(this);
                    this.animation.animateTo('closed', {
                        force: force
                    }).then(function (state) {
                        if (state === 'closed') {
                            _this3.listitem.classList.remove('alternate-drop');

                            _this3.link.setAttribute('aria-expanded', false);

                            _this3.parentMenu.openSelectedBlock();
                        }
                    });
                }
            }, {
                key: "unload",
                value: function unload() {
                    this.forceClose();
                    this.listitem.removeEventListener('mouseover', this.mouseover);
                    this.listitem.removeEventListener('mouseout', this.mouseout);
                    this.listitem.removeEventListener('touchend', this.click);
                    this.listitem.removeEventListener('click', this.click);
                    this.listitem.removeEventListener('focusin', this.focusin);
                    window.removeEventListener('keydown', this.closeEsc);
                    document.body.removeEventListener('click', this.bodyClose);
                    document.body.removeEventListener('focusin', this.focusInClose);
                    this.animation.unload();
                }
            }, {
                key: "isOpen",
                get: function get() {
                    return this._isOpen;
                }
            }]);

            return NavDesktopParent;
        }();


// CONCATENATED MODULE: ./source/scripts/components/navigation/NavDesktopMeganavParent.js
        function NavDesktopMeganavParent_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { NavDesktopMeganavParent_typeof = function _typeof(obj) { return typeof obj; }; } else { NavDesktopMeganavParent_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return NavDesktopMeganavParent_typeof(obj); }

        function NavDesktopMeganavParent_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

        function NavDesktopMeganavParent_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

        function NavDesktopMeganavParent_createClass(Constructor, protoProps, staticProps) { if (protoProps) NavDesktopMeganavParent_defineProperties(Constructor.prototype, protoProps); if (staticProps) NavDesktopMeganavParent_defineProperties(Constructor, staticProps); return Constructor; }

        function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

        function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

        function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

        function _possibleConstructorReturn(self, call) { if (call && (NavDesktopMeganavParent_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

        function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

        function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

        function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }


        // eslint-disable-line import/no-cycle

        var NavDesktopMeganavParent_NavDesktopMeganavParent = /*#__PURE__*/function (_NavDesktopParent) {
            _inherits(NavDesktopMeganavParent, _NavDesktopParent);

            var _super = _createSuper(NavDesktopMeganavParent);

            function NavDesktopMeganavParent() {
                NavDesktopMeganavParent_classCallCheck(this, NavDesktopMeganavParent);

                return _super.apply(this, arguments);
            }

            NavDesktopMeganavParent_createClass(NavDesktopMeganavParent, [{
                key: "mouseout",
                value: function mouseout() {
                    // This prevents the menu from closing on mouseout when it's selected in the TE
                    if (!this.parentMenu.shouldBlockClose(this)) return;
                    this.timer = setTimeout(this.close, 400);
                }
            }, {
                key: "_open",
                value: function _open() {
                    var _this = this;

                    var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
                    if (this._isOpen) return;
                    this._isOpen = true;
                    window.addEventListener('keydown', this.closeEsc); // Handles the special meganav to meganav transition behaviour, where
                    // the drawer appears to stay open and transition from old to new height

                    var resolveOpenMeganavs = new Promise(function (resolve) {
                        var openMeganav = _this.parentMenu.openMeganav;

                        if (openMeganav) {
                            // Set height to start transitioning from: the open height of the previous meganav
                            _this.listitem.style.setProperty('--menu-closed-height', "".concat(openMeganav.openHeight, "px")); // Inject old meganav ghost content


                            var meganavGhostContent = openMeganav.content.cloneNode(true);

                            var _openMeganav$content$ = openMeganav.content.getBoundingClientRect(),
                                    width = _openMeganav$content$.width,
                                    left = _openMeganav$content$.left;

                            meganavGhostContent.classList.add('meganav-ghost'); // Set styles to absolutely position ghost content correctly

                            meganavGhostContent.style.left = "".concat(left, "px");
                            meganavGhostContent.style.width = "".concat(width, "px");

                            _this.submenu.appendChild(meganavGhostContent);

                            dim(_this); // Jump to ghost state

                            _this.animation.animateTo('ghost', {
                                force: true
                            }) // Close other meganav
                                    .then(function () {
                                        return _this.parentMenu.openMeganav.forceClose();
                                    }).then(resolve);
                        } else {
                            // If no other meganavs are open we can start immediately.
                            _this.listitem.style.setProperty('--menu-closed-height', 0);

                            dim(_this);
                            resolve();
                        }
                    });
                    resolveOpenMeganavs.then(function () {
                        return _this.closeSiblings(_this);
                    }).then(function () {
                        return _this.animation.animateTo('open', {
                            force: force,
                            hold: !force,
                            onStart: function onStart(_ref) {
                                var el = _ref.el;
                                var wrapper = el.querySelector('.navmenu-meganav-wrapper');
                                var maxHeight = parseInt(window.getComputedStyle(wrapper).maxHeight, 10);
                                var height = isFinite(maxHeight) ? Math.min(wrapper.scrollHeight, maxHeight) : wrapper.scrollHeight;

                                _this.listitem.style.setProperty('--menu-open-height', "".concat(height, "px"));

                                _this._openHeight = height;
                            }
                        });
                    }).then(function () {
                        _this.link.setAttribute('aria-expanded', true);

                        _this.parentMenu.openMeganav = _this; // Rapid mouse movement can sometimes cancel animation before ghost is removed,
                        // so when things finally settle make sure we're removing all ghosts.

                        _this.submenu.querySelectorAll('.meganav-ghost').forEach(function (ghost) {
                            ghost.parentNode.removeChild(ghost);
                        });
                    });
                }
            }, {
                key: "_close",
                value: function _close() {
                    var _this2 = this;

                    var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

                    // You would expect to see something like this to avoid "double closing" menus,
                    // but in practice it works more reliably to always run when the function is called,
                    // to avoid out-of-sync situations.
                    // if (!this._isOpen) return Promise.resolve();
                    if (this.parentMenu.openMeganav === this) {
                        this.parentMenu.openMeganav = null;
                    }

                    this._isOpen = false;
                    window.removeEventListener('keydown', this.closeEsc);
                    this.listitem.style.setProperty('--menu-closed-height', 0);
                    clear(this);
                    return this.animation.animateTo('closed', {
                        force: force
                    }).then(function () {
                        _this2.link.setAttribute('aria-expanded', false);

                        _this2.parentMenu.openSelectedBlock();
                    });
                }
            }, {
                key: "content",
                get: function get() {
                    return this.submenu.querySelector('.navmenu-meganav-wrapper');
                }
            }, {
                key: "openHeight",
                get: function get() {
                    return this._openHeight;
                }
            }, {
                key: "blockId",
                get: function get() {
                    return this.submenu.dataset.meganavId;
                }
            }]);

            return NavDesktopMeganavParent;
        }(NavDesktopParent_NavDesktopParent);


// CONCATENATED MODULE: ./source/scripts/components/navigation/NavDesktopMenu.js
        function NavDesktopMenu_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

        function NavDesktopMenu_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

        function NavDesktopMenu_createClass(Constructor, protoProps, staticProps) { if (protoProps) NavDesktopMenu_defineProperties(Constructor.prototype, protoProps); if (staticProps) NavDesktopMenu_defineProperties(Constructor, staticProps); return Constructor; }

        // eslint-disable-line import/no-cycle

        // eslint-disable-line import/no-cycle

        var NavDesktopMenu_NavDesktopMenu = /*#__PURE__*/function () {
            function NavDesktopMenu(_ref) {
                var _this = this;

                var children = _ref.children;

                NavDesktopMenu_classCallCheck(this, NavDesktopMenu);

                this.parents = [];
                this.children = children; // Meganav, if any, that is fully open (not animating).

                this._openMeganav = null; // Meganav, if any, that is selected for editing in the TE.

                this._selectedBlock = null;
                this._megaNavs = null;

                this.closeSiblings = function (current) {
                    _this.parents.forEach(function (parent) {
                        if (parent !== current) {
                            parent.close();
                        }
                    });
                };

                for (var i = 0; i < this.children.length; i++) {
                    var child = this.children[i];

                    if (child.dataset.navmenuMeganavTrigger !== undefined) {
                        this.parents.push(new NavDesktopMeganavParent_NavDesktopMeganavParent(child, {
                            parentMenu: this
                        }));
                    } else if (child.dataset.navmenuParent !== undefined) {
                        this.parents.push(new NavDesktopParent_NavDesktopParent(child, {
                            parentMenu: this
                        }));
                    } else if (child.classList.contains('navmenu-item')) {
                        child.addEventListener('focusin', this.closeSiblings);
                    }
                }
            }

            NavDesktopMenu_createClass(NavDesktopMenu, [{
                key: "selectBlock",
                value: function selectBlock(id) {
                    var _this2 = this;

                    // This is TE only, so only initialize the first time a block is selected
                    if (!this._megaNavs) {
                        this._megaNavs = {};
                        this.parents.filter(function (parent) {
                            return parent instanceof NavDesktopMeganavParent_NavDesktopMeganavParent;
                        }).forEach(function (megaNav) {
                            _this2._megaNavs[megaNav.blockId] = megaNav;
                        });
                    }

                    var newSelectedBlock = this._megaNavs[id];
                    if (this._selectedBlock === newSelectedBlock) return;

                    if (this._selectedBlock) {
                        this._selectedBlock.close();
                    }

                    this._selectedBlock = this._megaNavs[id]; // Force open give a better experience when changing settings.
                    // Otherwise the selected block visibly closes and reopens after every
                    // settings change.

                    this._selectedBlock.forceOpen();
                }
            }, {
                key: "openSelectedBlock",
                value: function openSelectedBlock() {
                    if (this._selectedBlock && this.parents.filter(function (parent) {
                                return parent.isOpen;
                            }).length === 0) {
                        this._selectedBlock.open();
                    }
                } // If a block is open and selected in the TE and no other blocks are open
                // we don't want to close it when we normally would.

            }, {
                key: "shouldBlockClose",
                value: function shouldBlockClose(block) {
                    if (block === this._selectedBlock && this.parents.filter(function (parent) {
                                return parent.isOpen;
                            }).length === 1) {
                        return false;
                    }

                    return true;
                }
            }, {
                key: "closeAllMenus",
                value: function closeAllMenus() {
                    this._selectedBlock = null;
                    this.parents.forEach(function (parent) {
                        return parent.close();
                    });
                }
            }, {
                key: "unload",
                value: function unload() {
                    this.parents.forEach(function (parent) {
                        parent.unload();
                    });

                    for (var i = 0; i < this.children.length; i++) {
                        this.children[i].removeEventListener('focusin', this.closeSiblings);
                    }
                }
            }, {
                key: "openMeganav",
                get: function get() {
                    return this._openMeganav;
                },
                set: function set(meganav) {
                    this._openMeganav = meganav;
                }
            }]);

            return NavDesktopMenu;
        }();


// EXTERNAL MODULE: ./node_modules/eventemitter2/lib/eventemitter2.js
        var eventemitter2 = __webpack_require__(16);
        var eventemitter2_default = /*#__PURE__*/__webpack_require__.n(eventemitter2);

// CONCATENATED MODULE: ./source/scripts/Search.js
        function Search_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { Search_typeof = function _typeof(obj) { return typeof obj; }; } else { Search_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return Search_typeof(obj); }

        function Search_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

        function Search_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

        function Search_createClass(Constructor, protoProps, staticProps) { if (protoProps) Search_defineProperties(Constructor.prototype, protoProps); if (staticProps) Search_defineProperties(Constructor, staticProps); return Constructor; }

        function Search_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) Search_setPrototypeOf(subClass, superClass); }

        function Search_setPrototypeOf(o, p) { Search_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return Search_setPrototypeOf(o, p); }

        function Search_createSuper(Derived) { var hasNativeReflectConstruct = Search_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Search_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Search_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Search_possibleConstructorReturn(this, result); }; }

        function Search_possibleConstructorReturn(self, call) { if (call && (Search_typeof(call) === "object" || typeof call === "function")) { return call; } return Search_assertThisInitialized(self); }

        function Search_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

        function Search_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

        function Search_getPrototypeOf(o) { Search_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return Search_getPrototypeOf(o); }


        /**
         * Search API Class
         */

        var Search = /*#__PURE__*/function (_EventEmitter) {
            Search_inherits(Search, _EventEmitter);

            var _super = Search_createSuper(Search);

            /**
             * Create a new Search instance, and override defaults
             *
             * @param options
             * @property {string} options.type - Search restriction. Use 'article', 'page', 'product', or ''
             * @property {string} options.view - Search template suffix. Specify different templates as needed
             */
            function Search() {
                var _this;

                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                Search_classCallCheck(this, Search);

                _this = _super.call(this);
                _this.searchType = options.type || '';
                _this.view = options.view || 'json';
                _this.inProgress = false;
                _this.xhr = window.XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject('Microsoft.XMLHTTP');
                _this._xhrLoad = _this._xhrLoad.bind(Search_assertThisInitialized(_this));
                _this._xhrError = _this._xhrError.bind(Search_assertThisInitialized(_this));
                _this._xhrAbort = _this._xhrAbort.bind(Search_assertThisInitialized(_this));

                _this._bindEvents();

                return _this;
            }

            Search_createClass(Search, [{
                key: "_bindEvents",
                value: function _bindEvents() {
                    this.xhr.addEventListener('load', this._xhrLoad);
                    this.xhr.addEventListener('error', this._xhrError);
                    this.xhr.addEventListener('abort', this._xhrAbort);
                }
                /**
                 * XHR was successfull
                 *
                 * @description XHR completed successfully
                 * @param {object} event
                 * @fires Search#complete
                 * @private
                 */

            }, {
                key: "_xhrLoad",
                value: function _xhrLoad(event) {
                    var response = {};
                    var _event$target = event.target,
                            readyState = _event$target.readyState,
                            status = _event$target.status;

                    try {
                        if (readyState > 3 && status === 200) {
                            response = JSON.parse(event.target.responseText);
                            this.emit('complete', response);
                        } else {
                            var message = "Invalid readyState: ".concat(readyState, ", or status: ").concat(status, ".");

                            this._xhrError(event, message);

                            return;
                        }
                    } catch (error) {
                        this._xhrError(event, 'Invalid JSON', error);

                        return;
                    }

                    this.inProgress = false;
                }
                /**
                 * XHR contains an error
                 *
                 * @description XHR has contained an error, and was unable to complete
                 * @param {object} event
                 * @param {object|string} message
                 * @param {object} error
                 * @fires Search#error
                 * @private
                 */

            }, {
                key: "_xhrError",
                value: function _xhrError(event) {
                    var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                    var error = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
                    this.inProgress = false;
                    this.emit('error', {
                        event: event,
                        message: message,
                        error: error
                    });
                }
                /**
                 * XHR has been aborted
                 *
                 * @description This event only fires if there is an active XHR request that has been terminated
                 * @fires Search#aborted
                 * @private
                 */

            }, {
                key: "_xhrAbort",
                value: function _xhrAbort() {
                    this.emit('aborted');
                }
                /**
                 * Perform the search
                 *
                 * @param {string} term - Search term(s)
                 * @fires Search#initialized
                 * @fires Search#cancelled
                 */

            }, {
                key: "execute",
                value: function execute(term) {
                    this.emit('initialized', {
                        term: term
                    });

                    if (this.inProgress) {
                        this.emit('cancelled');
                        this.xhr.abort();
                    }

                    this.inProgress = true;
                    var url = window.Theme.routes.search_url;
                    var params = {
                        q: term,
                        type: this.searchType,
                        view: this.view
                    };
                    var searchParams = Object.keys(params).map(function (key) {
                        var value = params[key];
                        return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(value));
                    }).join('&');
                    this.xhr.open('get', "".concat(url, "?").concat(searchParams));
                    this.xhr.setRequestHeader('Accept', 'application/json');
                    this.xhr.send();
                }
            }]);

            return Search;
        }(eventemitter2_default.a);
        /**
         * @description XHR initialized
         * @event Search#initialized
         * @type {object}
         */

        /**
         * @description XHR completed
         * @event Search#complete
         * @property {object} response - JSON response from end point
         */

        /**
         * @description XHR had an error
         * @event Search#error
         */

        /**
         * @description XHR cancelled due to user interaction. If an XHR is being
         *        processed, this does not terminate it
         * @event Search#cancelled
         */

        /**
         * @description XHR aborted due to user interaction, terminating previously executed XHR.
         * @event Search#aborted
         */



// CONCATENATED MODULE: ./source/scripts/components/search/SearchForm.js
        function SearchForm_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

        function SearchForm_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

        function SearchForm_createClass(Constructor, protoProps, staticProps) { if (protoProps) SearchForm_defineProperties(Constructor.prototype, protoProps); if (staticProps) SearchForm_defineProperties(Constructor, staticProps); return Constructor; }




        function sanitizeCategory(value) {
            return value.replace(/(tag|product_type):(searchfilter_)?/, '');
        }

        var SearchForm_SearchForm = /*#__PURE__*/function () {
            function SearchForm(container) {
                var _this = this;

                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

                SearchForm_classCallCheck(this, SearchForm);

                this.container = container;
                this.form = this.container.querySelector('[data-live-search-form]');
                this.filter = this.container.querySelector('[data-live-search-filter]');
                this.isLiveSearch = options.liveSearch ? options.liveSearch : false;

                this.setCategory = options.setCategory || function () {
                            /* do nothing */
                        };

                this.events = new EventHandler_default.a();
                this.events.register(this.form, 'submit', function (e) {
                    return _this.submitHandler(e);
                });

                if (this.filter) {
                    this.filterLabel = this.container.querySelector('[data-live-search-filter-label]'); // page-search-form uses a hidden input to persist the filter, in which case
                    // this.filter exists, but this.filterLabel does not.

                    if (this.filterLabel) {
                        this.setCategory(this.filterLabel.value);
                        this.events.register(this.filter, 'change', function (e) {
                            var value = e.target.value;

                            if (value) {
                                var newValue = sanitizeCategory(value);
                                _this.filterLabel.innerHTML = newValue;

                                _this.setCategory(newValue);

                                _this.form.classList.add('live-search-filter-active');
                            } else {
                                _this.filterLabel.innerHTML = e.target.dataset.filterAll;

                                _this.form.classList.remove('live-search-filter-active');

                                _this.setCategory('');
                            }
                        });
                    }

                    var hideFilterIfMobile = function hideFilterIfMobile() {
                        if (Layout.isLessThanBreakpoint('S')) {
                            _this.filter.value = '';

                            _this.form.classList.remove('live-search-filter-active');

                            if (_this.filterLabel) {
                                _this.filterLabel.innerHTML = _this.filter.dataset.filterAll;
                            }
                        }
                    };

                    hideFilterIfMobile();
                    Layout.onBreakpointChange(function () {
                        return hideFilterIfMobile();
                    });
                }
            }

            SearchForm_createClass(SearchForm, [{
                key: "unload",
                value: function unload() {
                    this.events.unregisterAll();
                }
            }, {
                key: "submitHandler",
                value: function submitHandler(event) {
                    event.preventDefault();
                    var form = event.currentTarget.cloneNode(true);
                    var termsInput = form.querySelector('[name=q]');
                    form.style.position = 'absolute';
                    form.style.left = '-1000px';
                    form.style.bottom = '-1000px';
                    form.style.visibility = 'hidden';
                    var terms = termsInput.value;

                    if (this.isLiveSearch && !terms) {
                        return;
                    } // Adds `*` after each word in search terms, doesn't add to last word


                    if (terms.indexOf(' ') > 0) {
                        terms = terms.split(' ').join('* ').trim();
                    } // Adds `*` at the end of the search terms


                    terms = "".concat(terms, "*"); // Add field filter

                    terms = this.filter && this.filter.value ? "".concat(terms, " ").concat(this.filter.value) : terms; // Update value

                    termsInput.value = terms; // Forms must be in the browser context in order to submit

                    window.document.body.appendChild(form);
                    form.submit();
                }
            }]);

            return SearchForm;
        }();


// CONCATENATED MODULE: ./source/scripts/components/search/LiveSearchTemplates.js
        /**
         * Shows a list item component when result is an article, or a page
         *
         * @param contentItem
         * @returns {string}
         * @constructor
         */
        function ContentItem(contentItem) {
            return "\n  <li class=\"search-flydown--content-item\">\n    <a href=\"".concat(contentItem.url, "\">").concat(contentItem.title, "</a>\n  </li>\n  ");
        }
        /**
         * Shows a header for the article and page results
         *
         * @param context
         * @returns {string}
         * @constructor
         */


        function ContentResultsHeader(context) {
            return "\n    <h5 class=\"search-flydown--content-title\">\n      ".concat(context.content_results.title, "\n    </h5>\n  ");
        }
        /**
         * Shows a list of results from articles, or pages
         *
         * @param props
         * @returns {jQuery|HTMLElement}
         * @constructor
         */


        function ContentResults(props) {
            var content = props.content,
                    context = props.context;
            var $title = ContentResultsHeader(context);
            var contentItems = content.map(function (contentItem) {
                return ContentItem(contentItem);
            });
            return $("\n    <div class=\"search-flydown--content-items\">\n      ".concat($title, "\n\n      <ul class=\"search-flydown--content-items-list\">\n        ").concat(contentItems.join(''), "\n      </ul>\n    </div>\n  "));
        }
        /**
         * Shows a message when there are no article or page results
         *
         * @param props
         * @returns {jQuery|HTMLElement}
         * @constructor
         */


        function ContentNoResults(props) {
            var context = props.context;
            var $title = ContentResultsHeader(context);
            return $("\n    <div class=\"search-flydown--content-items\">\n      ".concat($title, "\n\n      <p class=\"search-flydown--content-items-none\">\n        ").concat(context.content_results.no_results, "\n      </p>\n    </div>\n  "));
        }
        /**
         * Shows the product's compare_at_price, with connection for CurrencyConverter
         *
         * @param price
         * @returns {string}
         * @constructor
         */


        function ProductPriceCompareAt(price) {
            return "\n  <span class=\"search-flydown--product-price--compare-at\">\n    <span class=\"money\">".concat(price.compare_at_price, "</span>\n  </span>\n  ");
        }
        /**
         * Shows the product's price, with connection for CurrencyConverter
         *
         * @param price
         * @returns {string}
         * @constructor
         */


        function ProductPriceMain(price) {
            return "\n  <span class=\"search-flydown--product-price--main\">\n    <span class=\"money\">".concat(price.price, "</span>\n  </span>\n  ");
        }
        /**
         * Shows the product's prices
         *
         * @param props
         * @returns {string}
         * @constructor
         */


        function ProductPrice(props) {
            var price = props.price,
                    onSale = props.onSale,
                    consistentSaved = props.consistentSaved;
            var $compareAt = onSale && consistentSaved ? ProductPriceCompareAt(price) : '';
            var $price = ProductPriceMain(price);
            return "\n    <span class=\"search-flydown--product-price ".concat(onSale ? 'search-flydown--product-price-has-sale' : '', "\">\n      ").concat($price, "\n      ").concat($compareAt, "\n    </span>\n  ");
        }
        /**
         * Shows a product's main content
         *
         * @param product
         * @returns {string}
         * @constructor
         */


        function ProductContent(product) {
            var $price = ProductPrice({
                price: product.price,
                onSale: product.on_sale,
                consistentSaved: product.consistent_saved
            });
            var swatchCount = product.swatch_count ? "<span class=\"search-flydown--product-swatch-count\">".concat(product.swatch_count, "</span>") : '';
            return "\n    <div class=\"search-flydown--product-text\">\n      <span class=\"search-flydown--product-title\">\n        ".concat(product.title, "\n      </span>\n      ").concat($price, "\n      ").concat(swatchCount, "\n    </div>\n  ");
        }
        /**
         * Shows a product's image
         *
         * @param image
         * @returns {string}
         * @constructor
         */


        function ProductImage(image) {
            return "\n    <div class=\"search-flydown--product-image\">\n      ".concat(image, "\n    </div>\n  ");
        }
        /**
         * Shows a product list item component when result is a product
         *
         * @param product
         * @param enableImages
         * @returns {string}
         * @constructor
         */


        function ProductItem(product, enableImages) {
            var $image = enableImages ? ProductImage(product.image) : '';
            var $content = ProductContent(product);
            return "\n    <a class=\"search-flydown--product search-flydown--product\" href=\"".concat(product.url, "\">\n      ").concat($image, "\n      ").concat($content, "\n    </a>\n  ");
        }
        /**
         * Shows a list of product results
         *
         * @param props
         * @returns {jQuery|HTMLElement}
         * @constructor
         */


        function ProductResults(props) {
            var products = props.products,
                    enableImages = props.enableImages;
            var productItems = products.map(function (product) {
                return ProductItem(product, enableImages);
            });
            return $("\n    <div class=\"search-flydown--product-items\">\n      ".concat(productItems.join(''), "\n    </div>\n  "));
        }
        /**
         * Show a message when no product results are found
         *
         * @param props
         * @returns {jQuery|HTMLElement}
         * @constructor
         */


        function ProductNoResults(props) {
            var context = props.context,
                    terms = props.terms,
                    category = props.category;
            var title = context.no_results_products.title.replace('*terms*', terms);

            if (category) {
                title = context.no_results_products.title_in_category.replace('*terms*', terms).replace('*category*', category);
            }

            return $("\n    <div class=\"search-flydown--product-items--none\" data-live-search-no-products>\n      <h5>\n        ".concat(title, "\n      </h5>\n      <p>\n        ").concat(context.no_results_products.message, "\n      </p>\n      <p>\n        <a class=\"search-flydown--continue\" href=\"").concat(window.Theme.routes.all_products_collection_url, "\">\n          ").concat(context.view_all_products, "\n        </a>\n      </p>\n    </div>\n  "));
        }
        /**
         * Show's the Results footer, directing customers to all products
         *
         * @param props
         * @returns {jQuery|HTMLElement}
         * @constructor
         */


        function ResultsFooter(props) {
            var context = props.context,
                    terms = props.terms,
                    type = props.type;
            return $("\n    <div class=\"search-flydown--footer\">\n      <a class=\"search-flydown--continue\" href=\"".concat(window.Theme.routes.search_url, "?q=").concat(terms, "&type=").concat(type, "\">\n        ").concat(context.view_all_results, "\n      </a>\n    </div>\n  "));
        }


// CONCATENATED MODULE: ./source/scripts/components/search/LiveSearch.js
        function LiveSearch_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

        function LiveSearch_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

        function LiveSearch_createClass(Constructor, protoProps, staticProps) { if (protoProps) LiveSearch_defineProperties(Constructor.prototype, protoProps); if (staticProps) LiveSearch_defineProperties(Constructor, staticProps); return Constructor; }










        var MAX_RESULTS = 7;

        var LiveSearch_LiveSearch = /*#__PURE__*/function () {
            function LiveSearch(els, settings) {
                var _this = this;

                LiveSearch_classCallCheck(this, LiveSearch);

                this.$el = jquery_default()(els.el);
                this.$header = jquery_default()(els.header);
                this.closeEvents = [];
                this.settings = settings;
                this.enableContent = this.settings.enable_content;
                this.enableImages = this.settings.enable_images;
                this.mobileSearchBar = this.settings.show_mobile_search_bar;
                this.searchType = this.enableContent ? 'article,page,product' : 'product';
                this.category = '';
                var $form = this.$el.find('[data-live-search-form]');
                this.$input = $form.find('[data-live-search-input]');
                this.$button = $form.find('[data-live-search-submit]');
                this.$takeOverButton = $form.find('[data-live-search-takeover-cancel]');
                this.$filter = this.$el.find('[data-live-search-filter]');
                this.$flyDown = this.$el.find('[data-live-search-flydown]');
                this.$searchResults = this.$flyDown.find('[data-live-search-results]');
                this.$searchPlaceholder = this.$flyDown.find('[data-live-search-placeholder]');
                this.$quickLinks = this.$flyDown.find('[data-live-search-quick-links]');
                this.disableAnimations = 'reduceAnimations' in document.body.dataset;
                this.animationFlyDown = transition({
                    el: this.$flyDown.get(0),
                    state: 'closed'
                });
                this.animationSearchResults = transition({
                    el: this.$searchResults.get(0),
                    state: 'closed'
                });
                this.animationTakeover = transition({
                    el: this.$el[0],
                    state: 'closed'
                });

                if (this.$quickLinks.length) {
                    this.animationQuickLinks = transition({
                        el: this.$quickLinks.get(0),
                        state: 'closed'
                    });
                }

                this.staticSearch = new SearchForm_SearchForm(this.$el[0], {
                    liveSearch: true,
                    setCategory: function setCategory(category) {
                        _this.category = category;
                    }
                });
                this.search = new Search({
                    view: 'header',
                    type: this.searchType
                });
                this._search = this._search.bind(this);
                this._documentFocus = this._documentFocus.bind(this);
                this._searchCancelled = this._searchCancelled.bind(this);
                this._searchComplete = this._searchComplete.bind(this);
                this._searchError = this._searchError.bind(this);
                this.search.on('cancelled', this._searchCancelled);
                this.search.on('complete', this._searchComplete);
                this.search.on('error', this._searchError);

                this._closeEsc = function (e) {
                    if (e.key === 'Escape') {
                        e.stopPropagation();

                        _this.$input.focus();

                        _this._closeFlyDown(true);

                        _this._closeTakeOver();
                    }
                };

                this.events = [this.$input.on('keyup.live-search', just_debounce_default()(this._search, 250)), this.$input.on('focus.live-search', function (event) {
                    event.stopPropagation();

                    _this._onSearchFocus();
                }), this.$takeOverButton.on('click.live-search', function (event) {
                    event.preventDefault();

                    _this._closeFlyDown(true);

                    _this._closeTakeOver();
                }), this.$filter.on('change.live-search', function (event) {
                    var terms = _this.$input.val();

                    var hasTerms = terms.length > 0;
                    if (!hasTerms) return;

                    _this._search(event);
                })];
            }

            LiveSearch_createClass(LiveSearch, [{
                key: "open",
                value: function open() {
                    // If is XS, pop the search out into a Takeover screen
                    if (Layout.isLessThanBreakpoint('S')) {
                        this._openTakeOver();
                    }

                    this._openFlyDown();

                    this.$input.focus();
                }
            }, {
                key: "unload",
                value: function unload() {
                    this.events.forEach(function ($el) {
                        return $el.off('.live-search');
                    });
                    this.search.off('cancelled', this._searchCancelled);
                    this.search.off('complete', this._searchComplete);
                    this.search.off('error', this._searchError);

                    if (this.settings.use_dimmer) {
                        clear(this);
                    }

                    this.staticSearch.unload();
                    ScrollLock.unlock();
                }
            }, {
                key: "_onSearchFocus",
                value: function _onSearchFocus() {
                    this.$el.addClass('live-search--focused'); // If is XS, pop the search out into a Takeover screen

                    if (Layout.isLessThanBreakpoint('S')) {
                        this._openTakeOver();
                    }

                    this._openFlyDown();
                }
            }, {
                key: "_search",
                value: function _search(event) {
                    // Ignore non character key strokes
                    var invalidKeyStrokes = ['Alt', 'ArrowRight', 'ArrowLeft', 'ArrowUp', 'ArrowDown', 'Capslock', 'Control', 'Escape', 'Meta', 'Shift', 'Tab', 'Enter'];

                    if (event.key && invalidKeyStrokes.indexOf(event.key) !== -1) {
                        return;
                    }

                    var terms = this.$input.val();
                    var hasTerms = terms.length > 0; // If is XS, pop the search out into a Takeover screen

                    if (Layout.isLessThanBreakpoint('S')) {
                        this._openTakeOver();
                    } // If terms has length, this will be true


                    this._toggleButton(hasTerms);

                    if (hasTerms) {
                        // Clear previous results
                        this.$searchResults.html('');

                        this._openFlyDown(true); // Adds `*` after each word in search terms, doesn't add to last word


                        if (terms.indexOf(' ') > 0) {
                            terms = terms.split(' ').join('* ').trim();
                        } // Adds `*` at the end of the search terms


                        terms = "".concat(terms, "*");
                        var filter = this.$filter[0]; // Add field filter

                        terms = filter && filter.value ? "".concat(terms, " ").concat(filter.value) : terms;
                        this.search.execute(terms);
                    } else if (this.$quickLinks.length) {
                        this._openFlyDown();
                    } else {
                        this._closeFlyDown(true);
                    }
                }
            }, {
                key: "_searchError",
                value: function _searchError(response) {
                    console.warn('Search had error');
                    console.log(response.message, response.error, response.event);

                    this._toggleButton(false);
                }
                /**
                 * Search has been cancelled due to new search being performed
                 *
                 * @private
                 */

            }, {
                key: "_searchCancelled",
                value: function _searchCancelled() {// Searches are canceled on user interaction, UI should remain unchanged
                }
            }, {
                key: "_searchComplete",
                value: function _searchComplete(response) {
                    var _this2 = this;

                    var content = response.content,
                            products = response.products;
                    var terms = response.terms,
                            sanitizedTerms = response.sanitizedTerms;
                    content = content.slice(0, MAX_RESULTS);
                    products = products.slice(0, MAX_RESULTS);
                    var _this$settings = this.settings,
                            enableImages = _this$settings.enable_images,
                            context = _this$settings.context;
                    var settings = {
                        products: {
                            results: {
                                products: products,
                                enableImages: enableImages
                            },
                            noResults: {
                                context: context,
                                terms: sanitizedTerms,
                                category: this.category
                            }
                        },
                        content: {
                            results: {
                                context: context,
                                content: content
                            },
                            noResults: {
                                context: context
                            }
                        },
                        footer: {
                            context: context,
                            terms: terms,
                            type: this.searchType
                        }
                    };
                    var $productResults = products.length ? ProductResults(settings.products.results) : ProductNoResults(settings.products.noResults);
                    var $contentResults = content.length ? ContentResults(settings.content.results) : ContentNoResults(settings.content.noResults);
                    $productResults.find('.money').each(function (i, el) {
                        el.innerHTML = Shopify.formatMoney( // eslint-disable-line no-param-reassign
                                el.innerHTML, _this2.settings.money_format);
                    }); // Show results

                    this.$searchResults.html($productResults);

                    if (this.enableContent) {
                        this.$searchResults.append($contentResults);
                    }

                    this.$searchResults.append(ResultsFooter(settings.footer));

                    this._openFlyDown();

                    this._toggleButton(false);
                }
                /**
                 * Toggles search button while processing
                 *
                 * @param disable
                 * @private
                 */

            }, {
                key: "_toggleButton",
                value: function _toggleButton(disable) {
                    if (disable) {
                        this.$button.addClass('search-icon--processing').attr('disabled');
                    } else {
                        this.$button.removeClass('search-icon--processing').removeAttr('disabled');
                    }
                }
            }, {
                key: "_shouldOpenFlyDown",
                value: function _shouldOpenFlyDown() {
                    var placeholder = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
                    if (placeholder) return true;
                    var hasTerms = this.$input.val().length > 0;
                    var hasNoResults = this.$searchResults.find('[data-live-search-no-products]').length > 0;
                    var hasResults = this.$searchResults.children().length > 0;
                    var hasQuickLinks = this.$quickLinks.length;
                    return hasTerms && (hasResults || hasNoResults) || !hasTerms && hasQuickLinks;
                }
            }, {
                key: "_openFlyDown",
                value: function _openFlyDown() {
                    var _this3 = this;

                    var placeholder = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
                    if (!this._shouldOpenFlyDown(placeholder)) return;

                    var resize = function resize(_ref) {
                        var el = _ref.el;
                        // When this function is called, element is `display: block; height: 0;`
                        // but the wrapper's scrollHeight is the height we want to transition to
                        var container = el.querySelector(':scope > .visible');
                        var scrollHeight = container ? container.scrollHeight : 0;
                        el.style.setProperty('--open-height', "".concat(scrollHeight, "px"));
                    };

                    this._updateFlyDown(placeholder);

                    if (!this.$flyDown.data('is-open')) {
                        var $window = jquery_default()(window);
                        var $document = jquery_default()(document); // Only listen for events outside of the search flydown when its open

                        this.closeEvents = [$window.on('keydown.live-search', this._closeEsc), $document.on('focusin.live-search', this._documentFocus), $document.on('touchstart.live-search', this._documentFocus), $document.on('click.live-search', this._documentFocus)];

                        if (this.settings.use_dimmer) {
                            dim(this);
                        }

                        this.$flyDown.data('is-open', true);
                        this.animationFlyDown.animateTo('open', {
                            force: this.disableAnimations,
                            onStart: resize
                        }).then(function () {
                            return _this3.$el.addClass('live-search--active');
                        });
                    } else {
                        resize({
                            el: this.$flyDown.get(0)
                        });
                    }
                }
            }, {
                key: "_updateFlyDown",
                value: function _updateFlyDown() {
                    var placeholder = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
                    var hasTerms = this.$input.val().length > 0;
                    var hasNoResults = this.$searchResults.find('[data-live-search-no-products]').length > 0;
                    var hasResults = this.$searchResults.children().length > 0;
                    var hasQuickLinks = this.$quickLinks.length;

                    if (placeholder) {
                        this.$searchResults.removeClass('visible');
                        this.$quickLinks.removeClass('visible');
                        this.$searchPlaceholder.addClass('visible');

                        if (this.animationQuickLinks) {
                            this.animationQuickLinks.animateTo('hidden', {
                                force: this.disableAnimations
                            });
                        }

                        this.animationSearchResults.animateTo('hidden', {
                            force: this.disableAnimations
                        });
                    } else if (hasTerms && (hasNoResults || hasResults)) {
                        this.$searchPlaceholder.removeClass('visible');
                        this.$quickLinks.removeClass('visible');
                        this.$searchResults.addClass('visible');

                        if (this.animationQuickLinks) {
                            this.animationQuickLinks.animateTo('hidden', {
                                force: this.disableAnimations
                            });
                        }

                        this.animationSearchResults.animateTo('visible', {
                            force: this.disableAnimations
                        });
                    } else if (hasQuickLinks) {
                        this.$searchPlaceholder.removeClass('visible');
                        this.$searchResults.removeClass('visible');
                        this.$quickLinks.addClass('visible');
                        this.animationSearchResults.animateTo('hidden', {
                            force: this.disableAnimations
                        });
                        this.animationQuickLinks.animateTo('visible', {
                            force: this.disableAnimations
                        });
                    }
                }
                /**
                 * Close the FlyDown when no longer needed
                 *  - Keep focus styling if input is still being interacted with
                 *
                 * @param retainFocus
                 * @private
                 */

            }, {
                key: "_closeFlyDown",
                value: function _closeFlyDown() {
                    var _this4 = this;

                    var retainFocus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

                    if (!this.$flyDown.data('is-open')) {
                        return;
                    }

                    this.closeEvents.forEach(function ($el) {
                        return $el.off('.live-search');
                    });
                    this.closeEvents = [];
                    clear(this);
                    this.$flyDown.data('is-open', false);
                    this.$searchPlaceholder.removeClass('visible');
                    this.$quickLinks.removeClass('visible');
                    this.$searchResults.removeClass('visible');

                    if (this.animationQuickLinks) {
                        this.animationQuickLinks.animateTo('closed', {
                            force: this.disableAnimations
                        });
                    }

                    this.animationSearchResults.animateTo('closed', {
                        force: this.disableAnimations
                    });
                    this.animationFlyDown.animateTo('closed', {
                        force: this.disableAnimations,
                        onStart: function onStart(_ref2) {
                            var el = _ref2.el;
                            return el.style.setProperty('--open-height', '0');
                        }
                    }).then(function () {
                        _this4.$el.removeClass('live-search--active');

                        if (!retainFocus) {
                            _this4.$el.removeClass('live-search--focused');
                        }
                    });
                }
            }, {
                key: "_openTakeOver",
                value: function _openTakeOver() {
                    if (this.animationTakeover.state === 'open') return;

                    if (this.$header.hasClass('search--section')) {
                        document.body.classList.add('search-takeover-active');
                    }

                    ScrollLock.lock(this.$el[0]);
                    this.$el.addClass('live-search--takeover');

                    if (this.settings.use_dimmer) {
                        dim(this);
                    }

                    if (this.mobileSearchBar) {
                        // "Expand out" style
                        var el = this.$el[0];

                        var _el$getBoundingClient = el.getBoundingClientRect(),
                                top = _el$getBoundingClient.top,
                                right = _el$getBoundingClient.right,
                                left = _el$getBoundingClient.left,
                                width = _el$getBoundingClient.width;

                        el.style.setProperty('--live-search-takeover-initial-top', "".concat(top, "px"));
                        el.style.setProperty('--live-search-takeover-initial-right', "".concat(window.innerWidth - right, "px"));
                        el.style.setProperty('--live-search-takeover-initial-left', "".concat(left, "px"));
                        el.style.setProperty('--live-search-takeover-initial-width', "".concat(width, "px"));
                        el.parentNode.style.height = "".concat(el.parentNode.getBoundingClientRect().height, "px");
                        this.animationTakeover.animateTo('open', {
                            force: this.disableAnimations
                        });
                    } else {
                        // "Slide up" style
                        this.animationTakeover.animateTo('open', {
                            force: this.disableAnimations,
                            hold: true
                        });
                    }
                }
            }, {
                key: "_closeTakeOver",
                value: function _closeTakeOver() {
                    var _this5 = this;

                    if (this.animationTakeover.state === 'closed') return;

                    if (this.settings.use_dimmer) {
                        clear(this);
                    }

                    this.animationTakeover.animateTo('closed', {
                        force: this.disableAnimations
                    }).then(function () {
                        ScrollLock.unlock();
                        document.body.classList.remove('search-takeover-active');

                        _this5.$el.removeClass('live-search--takeover');

                        if (_this5.mobileSearchBar) {
                            _this5.$el[0].parentNode.style.height = '';
                        }
                    });
                }
                /**
                 * When the focus element has changed, either by clicking, touching, or tabbing
                 * check to see if it is within the flydown
                 *
                 * @param event
                 * @private
                 */

            }, {
                key: "_documentFocus",
                value: function _documentFocus(event) {
                    var $closest = jquery_default()(event.target).closest('[data-live-search]');

                    if ($closest.length) {
                        return;
                    }

                    this._closeFlyDown();

                    this._closeTakeOver();
                }
            }]);

            return LiveSearch;
        }();


// CONCATENATED MODULE: ./source/scripts/sections/StaticHeader.js
        function StaticHeader_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

        function StaticHeader_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { StaticHeader_ownKeys(Object(source), true).forEach(function (key) { StaticHeader_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { StaticHeader_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

        function StaticHeader_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

        function StaticHeader_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

        function StaticHeader_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

        function StaticHeader_createClass(Constructor, protoProps, staticProps) { if (protoProps) StaticHeader_defineProperties(Constructor.prototype, protoProps); if (staticProps) StaticHeader_defineProperties(Constructor, staticProps); return Constructor; }












        var StaticHeader_StaticHeader = /*#__PURE__*/function () {
            function StaticHeader(section) {
                var _this = this;

                StaticHeader_classCallCheck(this, StaticHeader);

                this.el = section.el;
                this.settings = section.data.settings;
                this.postMessage = section.postMessage;
                this.headerSearch = null;
                this.scripts = document.querySelector('[data-scripts]');
                this.menuToggle = this.el.querySelector('[data-menu-toggle]');
                this.cartCount = this.el.querySelector('[data-header-cart-count]');
                this.searchField = this.el.querySelector('[data-live-search]');
                this.siteNavigation = this.el.querySelector('[data-site-navigation]');
                this.desktopNavigation = this.siteNavigation.querySelector('ul.navmenu-depth-1');
                this.headerTools = this.siteNavigation.querySelector('[data-header-actions]');
                this.promoContent = this.el.querySelector('.small-promo');
                this.stickyHeader = new StickyHeader_StickyHeader({
                    header: this.el,
                    menuToggle: this.menuToggle,
                    postMessage: this.postMessage
                }, this.settings);
                this.navMobile = new NavMobile_NavMobile({
                    el: this.el,
                    toggleOpen: this.menuToggle
                });
                this.navDesktop = new NavDesktopMenu_NavDesktopMenu(document.querySelector('.site-navigation > [data-navmenu]'));
                this.forms = new Forms_Forms(this.el);
                this.events = new EventHandler_default.a();

                if (this.settings.live_search.enable) {
                    script_default()(this.scripts.dataset.shopifyApiUrl, function () {
                        _this.headerSearch = new LiveSearch_LiveSearch({
                            el: _this.searchField,
                            header: _this.el
                        }, StaticHeader_objectSpread(StaticHeader_objectSpread({}, _this.settings.live_search), {}, {
                            use_dimmer: true
                        }));
                        _this.mobileSearchButtonEl = section.el.querySelector('[data-mobile-search-button]');

                        if (_this.mobileSearchButtonEl) {
                            var disableAnimations = ('reduceAnimations' in document.body.dataset);
                            _this.mobileSearchButtonAnimation = transition({
                                el: _this.mobileSearchButtonEl,
                                state: 'visible'
                            });

                            _this.events.register(_this.mobileSearchButtonEl, 'click', function (e) {
                                e.stopPropagation();

                                _this.headerSearch.open();

                                _this.mobileSearchButtonAnimation.animateTo('hidden', {
                                    force: disableAnimations
                                });
                            });

                            _this.mobileSearchTakeoverCancel = section.el.querySelector('[data-live-search-takeover-cancel]');

                            _this.events.register(_this.mobileSearchTakeoverCancel, 'click', function () {
                                _this.mobileSearchButtonAnimation.animateTo('visible', {
                                    force: disableAnimations
                                });
                            });
                        }
                    });
                } else {
                    this.headerSearch = new SearchForm_SearchForm(this.searchField);
                }

                this.events.register(window, 'cartcount:update', function (event) {
                    _this.cartCount.dataset.headerCartCount = event.detail.item_count;

                    if (event.detail.item_count > 0) {
                        _this.cartCount.classList.add('visible');
                    } else {
                        _this.cartCount.classList.remove('visible');
                    }
                });
            }

            StaticHeader_createClass(StaticHeader, [{
                key: "onSectionSelect",
                value: function onSectionSelect() {
                    this.stickyHeader.openNavigation();
                }
            }, {
                key: "onSectionDeselect",
                value: function onSectionDeselect() {
                    this._closeAllNavigation();
                }
            }, {
                key: "onSectionUnload",
                value: function onSectionUnload() {
                    this.stickyHeader.unload();
                    this.navMobile.unload();
                    this.navDesktop.unload();
                    this.forms.unload();
                    this.headerSearch.unload();
                    this.events.unregisterAll();
                }
            }, {
                key: "onSectionMessage",
                value: function onSectionMessage(name) {
                    if (name === 'nav:close-all' && Layout.isGreaterThanBreakpoint('M')) {
                        this._closeAllNavigation();
                    }
                }
            }, {
                key: "onSectionBlockSelect",
                value: function onSectionBlockSelect(block) {
                    var _this2 = this;

                    if (!Layout.isGreaterThanBreakpoint('M')) {
                        return;
                    }

                    this.stickyHeader.openNavigation(function () {
                        _this2.navDesktop.selectBlock(block.id);
                    });
                }
            }, {
                key: "onSectionBlockDeselect",
                value: function onSectionBlockDeselect() {
                    this._closeAllNavigation();
                }
            }, {
                key: "_closeAllNavigation",
                value: function _closeAllNavigation() {
                    this.navDesktop.closeAllMenus();
                }
            }]);

            return StaticHeader;
        }();


// CONCATENATED MODULE: ./source/scripts/sections/StaticPassword.js
        function StaticPassword_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

        function StaticPassword_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

        function StaticPassword_createClass(Constructor, protoProps, staticProps) { if (protoProps) StaticPassword_defineProperties(Constructor.prototype, protoProps); if (staticProps) StaticPassword_defineProperties(Constructor, staticProps); return Constructor; }





        var StaticPassword_StaticPassword = /*#__PURE__*/function () {
            function StaticPassword(section) {
                StaticPassword_classCallCheck(this, StaticPassword);

                this.$el = jquery_default()(section.el);
                this.modalForms = null;
                this.newsletterForm = null;
                this.modalContents = '[data-passwordentry]';
                this.$newsletterForm = this.$el.find('[data-password-newsletter]');
                this.modalOpen = this.onModalOpen.bind(this);
                this.modalClose = this.onModalClose.bind(this);
                this._openModal = this._openModal.bind(this);
                this.modal = new Modal_Modal({
                    onOpen: this.modalOpen,
                    onClose: this.modalClose
                });

                if (this.$newsletterForm) {
                    this.newsletterForm = new Forms_Forms(this.$newsletterForm);
                }

                this._checkForPasswordAttempt();

                this._bindEvents();
            }

            StaticPassword_createClass(StaticPassword, [{
                key: "onSectionUnload",
                value: function onSectionUnload() {
                    this.$el.off('.static-password');

                    if (this.newsletterForm) {
                        this.newsletterForm.unload();
                    }

                    if (this.modalForms) {
                        this.modalForms.unload();
                    }
                }
            }, {
                key: "onModalOpen",
                value: function onModalOpen() {
                    var $contents = jquery_default()('[data-passwordentry-contents]');
                    this.modalForms = new Forms_Forms($contents);
                }
            }, {
                key: "onModalClose",
                value: function onModalClose() {
                    this.modalForms.unload();
                    this.modalForms = null;
                }
            }, {
                key: "_bindEvents",
                value: function _bindEvents() {
                    this.$el.on('click.static-password', '[data-passwordentry-toggle]', this._openModal);
                }
            }, {
                key: "_openModal",
                value: function _openModal() {
                    this.modal.open(this.modalContents, 'passwordentry');
                }
            }, {
                key: "_checkForPasswordAttempt",
                value: function _checkForPasswordAttempt() {
                    if (!jquery_default()('[data-passwordentry-errors]').length) {
                        return;
                    }

                    this._openModal();
                }
            }]);

            return StaticPassword;
        }();


// CONCATENATED MODULE: ./source/scripts/sections/Product.js
        function Product_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

        function Product_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

        function Product_createClass(Constructor, protoProps, staticProps) { if (protoProps) Product_defineProperties(Constructor.prototype, protoProps); if (staticProps) Product_defineProperties(Constructor, staticProps); return Constructor; }








        var Product_Product = /*#__PURE__*/function () {
            function Product(section) {
                var _this = this;

                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

                Product_classCallCheck(this, Product);

                this.section = section;
                this.$el = jquery_default()(this.section.el);
                this.context = section.data.context;
                this.settings = section.data.settings;
                this.product = section.data.product;
                this.richText = null;
                this.readmoreText = null;
                this.reviewForm = null;

                if (this.settings) {
                    this.isThreeColumn = this.settings.layout === 'layout--three-col';
                } // History


                this.isThemeEditor = window.Shopify && window.Shopify.designMode;
                this.useHistory = 'useHistory' in options ? options.useHistory : !!(!this.isThemeEditor && history.replaceState);
                var gallery = this.$el.find('[data-product-gallery]')[0]; // Product details

                this.$details = this.$el.find('[data-product-details]'); // Product description

                this.$description = this.$el.find('[data-product-description]');
                this.$readmore = this.$el.find('[data-product-readmore]'); // Product form containers

                this.$formRegular = this.$el.find('[data-product-form-regular]');
                this.$formAlt = this.$el.find('[data-product-form-alt]'); // Product form area

                this.$formArea = this.$el.find('[data-product-form-area]'); // Move product form and information on breakpoint change

                this.layoutHandler = this.onBreakpointChange.bind(this);
                Layout.onBreakpointChange(this.layoutHandler); // Product reviews

                this.$productReviews = this.$el.find('[data-product-reviews]');

                this._moveForm();

                if (this.$description.length) {
                    this.richText = new RichText_RichText(this.$description);
                }

                if (this.$readmore.length) {
                    this.readmoreText = new RichText_RichText(this.$readmore);
                }

                if (this.$productReviews.length) {
                    this.reviewForm = new Forms_Forms(this.$productReviews, '.spr-form-input');
                } // Instantiate ProductDetails after Shopify API is loaded


                script_default()(jquery_default()('[data-scripts]').data('shopify-api-url'), function () {
                    _this.productDetails = new ProductDetails_ProductDetails({
                        $formArea: _this.$formArea,
                        $details: _this.$details,
                        gallery: gallery,
                        context: _this.context,
                        settings: _this.settings,
                        product: _this.product,
                        useHistory: _this.useHistory,
                        sectionId: section.id
                    });
                });
            }

            Product_createClass(Product, [{
                key: "onSectionUnload",
                value: function onSectionUnload() {
                    Layout.offBreakpointChange(this.layoutHandler);

                    if (this.productDetails) {
                        this.productDetails.unload();
                    }

                    if (this.richText) {
                        this.richText.unload();
                    }

                    if (this.readmoreText) {
                        this.readmoreText.unload();
                    }

                    if (this.reviewForm) {
                        this.reviewForm.unload();
                    }
                }
            }, {
                key: "onBreakpointChange",
                value: function onBreakpointChange() {
                    this._moveForm();
                }
                /**
                 * Move product form if is a three column layout
                 * @private
                 */

            }, {
                key: "_moveForm",
                value: function _moveForm() {
                    if (!this.isThreeColumn) return;

                    if (Layout.isGreaterThanBreakpoint('M')) {
                        if (!jquery_default.a.contains(this.$formAlt[0], this.$formArea[0])) {
                            var $form = this.$formArea.detach();
                            this.$formAlt.append($form);
                        }
                    } else if (!jquery_default.a.contains(this.$formRegular[0], this.$formArea[0])) {
                        var _$form = this.$formArea.detach();

                        this.$formRegular.append(_$form);
                    }
                }
            }]);

            return Product;
        }();


// CONCATENATED MODULE: ./source/scripts/sections/StaticProduct.js
        function StaticProduct_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { StaticProduct_typeof = function _typeof(obj) { return typeof obj; }; } else { StaticProduct_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return StaticProduct_typeof(obj); }

        function StaticProduct_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

        function StaticProduct_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) StaticProduct_setPrototypeOf(subClass, superClass); }

        function StaticProduct_setPrototypeOf(o, p) { StaticProduct_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return StaticProduct_setPrototypeOf(o, p); }

        function StaticProduct_createSuper(Derived) { var hasNativeReflectConstruct = StaticProduct_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = StaticProduct_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = StaticProduct_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return StaticProduct_possibleConstructorReturn(this, result); }; }

        function StaticProduct_possibleConstructorReturn(self, call) { if (call && (StaticProduct_typeof(call) === "object" || typeof call === "function")) { return call; } return StaticProduct_assertThisInitialized(self); }

        function StaticProduct_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

        function StaticProduct_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

        function StaticProduct_getPrototypeOf(o) { StaticProduct_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return StaticProduct_getPrototypeOf(o); }



        var StaticProduct = /*#__PURE__*/function (_Product) {
            StaticProduct_inherits(StaticProduct, _Product);

            var _super = StaticProduct_createSuper(StaticProduct);

            function StaticProduct() {
                StaticProduct_classCallCheck(this, StaticProduct);

                return _super.apply(this, arguments);
            }

            return StaticProduct;
        }(Product_Product);


// CONCATENATED MODULE: ./source/scripts/components/ProductRowScroller.js
        function ProductRowScroller_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

        function ProductRowScroller_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

        function ProductRowScroller_createClass(Constructor, protoProps, staticProps) { if (protoProps) ProductRowScroller_defineProperties(Constructor.prototype, protoProps); if (staticProps) ProductRowScroller_defineProperties(Constructor, staticProps); return Constructor; }





        var ProductRowScroller_ProductRowScroller = /*#__PURE__*/function () {
            function ProductRowScroller(productRow) {
                ProductRowScroller_classCallCheck(this, ProductRowScroller);

                this.$window = $(window);
                this.flickity = null;
                this.productRow = productRow;
                this.$productRow = $(this.productRow); // Activate flickity on mobile

                this._mobileSlider = this._mobileSlider.bind(this);
                Layout.onBreakpointChange(this._mobileSlider);

                this._mobileSlider();
            }

            ProductRowScroller_createClass(ProductRowScroller, [{
                key: "unload",
                value: function unload() {
                    Layout.offBreakpointChange(this._mobileSlider);

                    this._destroyFlickity();
                }
            }, {
                key: "_initFlickity",
                value: function _initFlickity() {
                    this.flickity = new js_default.a(this.productRow, {
                        cellSelector: '.productgrid--item',
                        contain: true,
                        freeScroll: true,
                        percentPosition: false,
                        prevNextButtons: false,
                        pageDots: false,
                        setGallerySize: false
                    });

                    this._bindSlider();
                }
            }, {
                key: "_destroyFlickity",
                value: function _destroyFlickity() {
                    if (!this.flickity) {
                        return;
                    }

                    this.$window.off('.product-row');
                    this.$productRow.off('.product-row');
                    this.flickity.destroy();
                    this.flickity = null;
                }
            }, {
                key: "_mobileSlider",
                value: function _mobileSlider() {
                    // If is Large layout, attempt to destroy flickity
                    if (Layout.isGreaterThanBreakpoint('M')) {
                        this._destroyFlickity();

                        return;
                    } // Is XS/S/M, and flickity is init'd -- do nothing


                    if (this.flickity) {
                        return;
                    } // Is XS/S/M, and flickity is not init'd


                    this._initFlickity();
                }
            }, {
                key: "_bindSlider",
                value: function _bindSlider() {
                    var _this = this;

                    var $slider = this.$productRow.find('.flickity-slider');
                    this.$window.on('resize.product-row', just_debounce_default()(function () {
                        _this.$productRow.trigger('heightUpdate.product-row');
                    }));
                    this.flickity.on('cellSelect', function () {
                        _this.$productRow.trigger('heightUpdate.product-row');
                    });
                    this.$productRow.on('heightUpdate.product-row', function () {
                        if (!_this.flickity) {
                            return;
                        }

                        $slider.height(Math.ceil(_this.flickity.maxCellHeight));
                    }); // Sets the Slider to the height of the first slide

                    this.$productRow.trigger('heightUpdate.product-row');
                }
            }]);

            return ProductRowScroller;
        }();


// CONCATENATED MODULE: ./source/scripts/sections/StaticProductRecommendations.js
        function StaticProductRecommendations_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

        function StaticProductRecommendations_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

        function StaticProductRecommendations_createClass(Constructor, protoProps, staticProps) { if (protoProps) StaticProductRecommendations_defineProperties(Constructor.prototype, protoProps); if (staticProps) StaticProductRecommendations_defineProperties(Constructor, staticProps); return Constructor; }

        // eslint-disable-line







        var StaticProductRecommendations_StaticProductRecommendations = /*#__PURE__*/function () {
            function StaticProductRecommendations(section) {
                StaticProductRecommendations_classCallCheck(this, StaticProductRecommendations);

                this.section = section;
                this.productId = section.data.productId;
                this.limit = section.data.settings.limit;
                this.recommendedProducts = [];
                this.productsScroller = null;
                this.recommendationContainer = document.querySelector('[data-product-recommendations]');
                this.recommendUrl = "".concat(window.Theme.routes.product_recommendations_url, "?section_id=static-product-recommendations&limit=").concat(this.limit, "&product_id=").concat(this.productId);
                this._loadRecommendations = this._loadRecommendations.bind(this);
                this._resizeRowScroller = this._resizeRowScroller.bind(this);

                this._loadRecommendations();
            }

            StaticProductRecommendations_createClass(StaticProductRecommendations, [{
                key: "_loadRecommendations",
                value: function _loadRecommendations() {
                    var _this = this;

                    shopify_asyncview_dist_index_es.load(this.recommendUrl, {
                        view: ''
                    }).then(function (_ref) {
                        var html = _ref.html;
                        _this.recommendationContainer.innerHTML = html;
                        rimg_shopify_dist_index_es.watch(_this.recommendationContainer);

                        var productItems = _this.recommendationContainer.querySelectorAll('[data-product-item]');

                        var productItemLazyLoad = Layout.isGreaterThanBreakpoint('L', true);

                        if (productItems.length) {
                            productItems.forEach(function (productItem) {
                                _this.recommendedProducts.push(new ProductGridItem_ProductGridItem({
                                    el: productItem,
                                    id: _this.section.id,
                                    lazy: productItemLazyLoad
                                }));
                            });
                            initShopifyProductReviews();

                            if (window.Shopify && Shopify.PaymentButton) {
                                Shopify.PaymentButton.init();
                            }

                            _this.recommendationContainer.addEventListener('rimg:load', _this._resizeRowScroller);

                            _this.productsScroller = new ProductRowScroller_ProductRowScroller(_this.section.el.querySelector('[data-product-row]'));
                        }
                    });
                }
            }, {
                key: "_resizeRowScroller",
                value: function _resizeRowScroller() {
                    if (this.productsScroller && this.productsScroller.flickity) {
                        this.productsScroller.flickity.resize();
                    }
                }
            }, {
                key: "onSectionUnload",
                value: function onSectionUnload() {
                    if (this.productsScroller) {
                        this.productsScroller.unload();
                    }

                    this.recommendedProducts.forEach(function (productItem) {
                        productItem.unload();
                    });
                    this.recommendationContainer.removeEventListener('rimg:load', this._resizeRowScroller);
                }
            }]);

            return StaticProductRecommendations;
        }();


// CONCATENATED MODULE: ./source/scripts/sections/StaticRecentlyViewed.js
        function StaticRecentlyViewed_toConsumableArray(arr) { return StaticRecentlyViewed_arrayWithoutHoles(arr) || StaticRecentlyViewed_iterableToArray(arr) || StaticRecentlyViewed_unsupportedIterableToArray(arr) || StaticRecentlyViewed_nonIterableSpread(); }

        function StaticRecentlyViewed_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

        function StaticRecentlyViewed_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return StaticRecentlyViewed_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return StaticRecentlyViewed_arrayLikeToArray(o, minLen); }

        function StaticRecentlyViewed_iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

        function StaticRecentlyViewed_arrayWithoutHoles(arr) { if (Array.isArray(arr)) return StaticRecentlyViewed_arrayLikeToArray(arr); }

        function StaticRecentlyViewed_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

        function StaticRecentlyViewed_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

        function StaticRecentlyViewed_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

        function StaticRecentlyViewed_createClass(Constructor, protoProps, staticProps) { if (protoProps) StaticRecentlyViewed_defineProperties(Constructor.prototype, protoProps); if (staticProps) StaticRecentlyViewed_defineProperties(Constructor, staticProps); return Constructor; }





        var StaticRecentlyViewed_StaticRecentlyViewed = /*#__PURE__*/function () {
            function StaticRecentlyViewed(section) {
                var _this = this;

                StaticRecentlyViewed_classCallCheck(this, StaticRecentlyViewed);

                this.namespace = 'pxu';
                this.maxRecentlyViewed = 30; // Store a max of 30 items

                this.maxStorageTime = 30 * 24 * 3600; // Store items for 30 days only

                this.version = "".concat(section.data.currency, "-").concat(window.Theme.routes.root_url); // Version key is used to update localstorage when format changes

                this.storageKey = "".concat(this.namespace, "-recentlyViewed-").concat(this.version);
                this.$el = jquery_default()(section.el);
                this.time = section.data.time;
                this.flickity = null;
                this.recentlyViewed = section.data.recently_viewed_info;
                this.cardSettings = section.data.product_card_settings;

                if (this.recentlyViewed && this.time) {
                    this.recentlyViewed.timestamp = Math.round(new Date().getTime() / 1000);
                }

                this.slideImageLoaded = this._onSlideImageLoaded.bind(this);
                var recentlyViewed = [];

                if (this.time) {
                    recentlyViewed = this._getRecentlyViewed();

                    if (this.recentlyViewed) {
                        this.removeRecentlyViewed(this.recentlyViewed.handle, recentlyViewed);
                        recentlyViewed.push(this.recentlyViewed);
                    }

                    var promises = this._setRecentlyViewed(recentlyViewed); // Wait until promises are resolved before inserting markup into the DOM


                    jquery_default.a.when.apply(jquery_default.a, StaticRecentlyViewed_toConsumableArray(promises)).done(function () {
                        if (recentlyViewed.length) {
                            var cardsMarkup = _this._getRecentlyViewedCards();

                            var cardsData = _this._getRecentlyViewed();

                            _this.$el.find('[data-recently-viewed-container]').append(cardsMarkup);

                            cardsData.forEach(function (productData) {
                                var timestamp = _this.timeSince(productData.timestamp);

                                jquery_default()("[data-product-handle=".concat(productData.handle, "]")).prepend(timestamp);
                            });
                            rimg_shopify_dist_index_es.watch(_this.$el[0]);
                            _this.$carousel = _this.$el.find('.product-recently-viewed__content');
                            _this.slides = '.product-recently-viewed-card';

                            if (_this.$carousel.find(_this.slides).length > 1) {
                                _this._initSlider();
                            }
                        } else {
                            _this.$el.find('.product-recently-viewed--section').addClass('hide');
                        }
                    });
                } else {
                    if (this.recentlyViewed) {
                        recentlyViewed.push(this.recentlyViewed);

                        this._setRecentlyViewed(recentlyViewed);
                    }

                    this.$el.find('.product-recently-viewed--section').addClass('hide');
                }

                this.bindEvents();
            }

            StaticRecentlyViewed_createClass(StaticRecentlyViewed, [{
                key: "bindEvents",
                value: function bindEvents() {
                    var _this2 = this;

                    this.$el.on('click', '[data-remove-recently-viewed]', function (event) {
                        var $target = jquery_default()(event.currentTarget);
                        var handle = $target.closest('[data-product-handle]').data('product-handle');

                        var recentlyViewed = _this2._getRecentlyViewed();

                        _this2.removeRecentlyViewed(handle, recentlyViewed);

                        _this2._setRecentlyViewed(recentlyViewed);

                        $target.parents('[data-recently-viewed-card]').addClass('hide-card');
                        $target.parents('[data-recently-viewed-card]').nextAll().addClass('move-card');
                        setTimeout(function () {
                            var index = $target.parents('[data-recently-viewed-card]').index();

                            if (index !== 0) {
                                index--;
                            }

                            $target.parents('[data-recently-viewed-card]').nextAll().removeClass('move-card');

                            if ($target.parents('[data-recently-viewed-card]').length) {
                                _this2.flickity.remove($target.parents('[data-recently-viewed-card]'));
                            }

                            _this2.flickity.selectCell(index);
                        }, 500);
                    });
                    this.$el.on('click', '[data-clear-recently-viewed]', function () {
                        _this2.clearRecentlyViewed();
                    });
                }
            }, {
                key: "timeSince",
                value: function timeSince(timestamp) {
                    var now = Math.round(new Date().getTime() / 1000);
                    var secondsPast = now - timestamp;

                    if (secondsPast < 60) {
                        var secondsAgo = parseInt(secondsPast, 10);
                        return secondsAgo === 1 ? "".concat(secondsAgo, " ").concat(this.time.second, " ").concat(this.time.ago) : "".concat(secondsAgo, " ").concat(this.time.seconds, " ").concat(this.time.ago);
                    }

                    if (secondsPast < 3600) {
                        var minutesAgo = parseInt(secondsPast / 60, 10);
                        return minutesAgo === 1 ? "".concat(minutesAgo, " ").concat(this.time.minute, " ").concat(this.time.ago) : "".concat(minutesAgo, " ").concat(this.time.minutes, " ").concat(this.time.ago);
                    }

                    if (secondsPast <= 86400) {
                        var hoursAgo = parseInt(secondsPast / 3600, 10);
                        return hoursAgo === 1 ? "".concat(hoursAgo, " ").concat(this.time.hour, " ").concat(this.time.ago) : "".concat(hoursAgo, " ").concat(this.time.hours, " ").concat(this.time.ago);
                    }

                    var date = new Date(timestamp * 1000);
                    var currentDate = new Date(now * 1000);
                    var day = date.getDate();
                    var month = date.toDateString().match(/ [a-zA-Z]*/)[0].replace(' ', '');
                    var year = date.getFullYear() === currentDate.getFullYear() ? '' : ", ".concat(date.getFullYear());
                    return "".concat(month, " ").concat(day, " ").concat(year);
                }
            }, {
                key: "removeRecentlyViewed",
                value: function removeRecentlyViewed(handle, recentlyViewed) {
                    for (var i = 0; i < recentlyViewed.length; i++) {
                        if (recentlyViewed[i].handle === handle) {
                            recentlyViewed.splice(i, 1);
                        }
                    }

                    this._setRecentlyViewed(recentlyViewed);

                    var cards = sessionStorage.getItem(this.storageKey) ? JSON.parse(sessionStorage.getItem(this.storageKey)) : {};
                    delete cards[handle];
                    sessionStorage.setItem(this.storageKey, JSON.stringify(cards));

                    if (recentlyViewed.length === 0) {
                        this.$el.find('.product-recently-viewed--section').addClass('hide');
                    }

                    if (this.$carousel) {
                        this.$carousel[0].removeEventListener('rimg:load', this.slideImageLoaded);
                    }
                }
            }, {
                key: "clearRecentlyViewed",
                value: function clearRecentlyViewed() {
                    localStorage.removeItem(this.storageKey);
                    sessionStorage.removeItem(this.storageKey);
                    this.$el.find('[data-recently-viewed-card]').remove();
                    this.$el.find('.product-recently-viewed--section').addClass('hide');
                }
            }, {
                key: "_onSlideImageLoaded",
                value: function _onSlideImageLoaded() {
                    this.flickity.resize();
                }
            }, {
                key: "_initSlider",
                value: function _initSlider() {
                    this.flickityOptions = {
                        autoPlay: 0,
                        accessibility: true,
                        cellAlign: 'left',
                        cellSelector: this.slides,
                        groupCells: true,
                        pageDots: false,
                        contain: true,
                        arrowShape: {
                            x0: 10,
                            x1: 60,
                            y1: 50,
                            x2: 65,
                            y2: 45,
                            x3: 20
                        }
                    };
                    this.flickity = new js_default.a(this.$carousel[0], this.flickityOptions);
                    this.$carousel[0].addEventListener('rimg:load', this.slideImageLoaded);
                }
                /**
                 * Store recently viewed products
                 *
                 * @param {Object[]} productData - recently viewed products
                 * @param {number} productData[].timestamp - indicating when product was added to productData
                 * @param {string} productData[].handle - Shopify product handle
                 * @private
                 */

            }, {
                key: "_setRecentlyViewed",
                value: function _setRecentlyViewed(productData) {
                    var _this3 = this;

                    var now = Math.floor(Date.now() / 1000); // Unix timestamp for current date

                    var minStorageTimestamp = now - this.maxStorageTime;
                    var filteredData = productData.filter(function (item) {
                        return item.timestamp > minStorageTimestamp;
                    });

                    if (filteredData.length > this.maxRecentlyViewed) {
                        var removeCount = filteredData.length - this.maxRecentlyViewed;
                        filteredData.splice(0, removeCount); // Remove oldest if more than max number have been stored
                    }

                    try {
                        localStorage.setItem(this.storageKey, JSON.stringify(filteredData));
                    } catch (error) {
                        console.warn(error);
                    } // Retrieve markup for recently viewed cards and store in session


                    try {
                        var handles = filteredData ? filteredData.map(function (x) {
                            return x.handle;
                        }) : [];
                        var storedCards = sessionStorage.getItem(this.storageKey) ? JSON.parse(sessionStorage.getItem(this.storageKey)) : {};

                        if (storedCards.cardSettings) {
                            Object.keys(storedCards.cardSettings).forEach(function (key) {
                                if (storedCards.cardSettings[key] !== _this3.cardSettings[key]) {
                                    storedCards = {};
                                    sessionStorage.removeItem(_this3.storageKey);
                                }
                            });
                        }

                        storedCards.cardSettings = this.cardSettings;
                        var promises = handles.map(function (handle) {
                            if (storedCards[handle]) {
                                return null;
                            }

                            var fetchUrl = "".concat(window.Theme.routes.all_products_collection_url, "/products/").concat(handle, "?view=_recently-viewed");
                            return jquery_default.a.get(fetchUrl).catch(function (error) {
                                return console.error('Error:', error);
                            }).then(function (response) {
                                if (response) {
                                    storedCards[handle] = response;

                                    try {
                                        sessionStorage.setItem(_this3.storageKey, JSON.stringify(storedCards));
                                    } catch (error) {
                                        console.warn(error);
                                    }
                                }
                            });
                        });
                        return promises;
                    } catch (error) {
                        console.warn(error);
                        return false;
                    }
                }
                /**
                 * Get stored recently viewed products
                 *
                 * @returns {Array}
                 * @private
                 */

            }, {
                key: "_getRecentlyViewed",
                value: function _getRecentlyViewed() {
                    try {
                        var recentlyViewed = localStorage.getItem(this.storageKey) ? JSON.parse(localStorage.getItem(this.storageKey)) : [];
                        return recentlyViewed;
                    } catch (error) {
                        console.warn(error);
                        return [];
                    }
                }
            }, {
                key: "_getRecentlyViewedCards",
                value: function _getRecentlyViewedCards() {
                    var cards = sessionStorage.getItem(this.storageKey) ? JSON.parse(sessionStorage.getItem(this.storageKey)) : {};
                    var orderedItems = localStorage.getItem(this.storageKey) ? JSON.parse(localStorage.getItem(this.storageKey)) : {};
                    var markup = [];

                    for (var i = orderedItems.length - 1; i >= 0; i--) {
                        var cardKey = orderedItems[i].handle; // When store password is enabled and viewing the product page in preview
                        // mode, product cards for products which have been deleted from the admin
                        // will return the password page. Before inserting the card markup, we
                        // need to check that it contains a product.

                        var domParser = new DOMParser();
                        var card = domParser.parseFromString(cards[cardKey], 'text/html');

                        if (card.querySelector('.productgrid--item')) {
                            markup.push(cards[cardKey]);
                        }
                    }

                    return markup.join('');
                }
            }]);

            return StaticRecentlyViewed;
        }();


// CONCATENATED MODULE: ./source/scripts/sections/StaticSearch.js
        function StaticSearch_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

        function StaticSearch_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

        function StaticSearch_createClass(Constructor, protoProps, staticProps) { if (protoProps) StaticSearch_defineProperties(Constructor.prototype, protoProps); if (staticProps) StaticSearch_defineProperties(Constructor, staticProps); return Constructor; }





        var StaticSearch_StaticSearch = /*#__PURE__*/function () {
            function StaticSearch(section) {
                var _this = this;

                StaticSearch_classCallCheck(this, StaticSearch);

                this.section = section;
                this.$el = jquery_default()(section.el);
                this.$searchField = this.$el.find('[data-live-search]'); // Product items

                this.productItems = [];
                var $productItems = this.$el.find('[data-product-item]');
                $productItems.each(function (i, productItem) {
                    _this.productItems.push(new ProductGridItem_ProductGridItem({
                        el: productItem,
                        id: _this.section.id,
                        lazy: true
                    }));
                });
                this.searchForm = new SearchForm_SearchForm(this.$searchField[0]);
            }

            StaticSearch_createClass(StaticSearch, [{
                key: "onSectionUnload",
                value: function onSectionUnload() {
                    this.searchForm.unload();
                    this.productItems.forEach(function (productItem) {
                        productItem.unload();
                    });
                }
            }]);

            return StaticSearch;
        }();


// CONCATENATED MODULE: ./source/scripts/sections/DynamicBlogPosts.js
        function DynamicBlogPosts_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

        function DynamicBlogPosts_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

        function DynamicBlogPosts_createClass(Constructor, protoProps, staticProps) { if (protoProps) DynamicBlogPosts_defineProperties(Constructor.prototype, protoProps); if (staticProps) DynamicBlogPosts_defineProperties(Constructor, staticProps); return Constructor; }






        var DynamicBlogPosts_DynamicTwitterFeed = /*#__PURE__*/function () {
            function DynamicTwitterFeed(section) {
                DynamicBlogPosts_classCallCheck(this, DynamicTwitterFeed);

                this.$el = jquery_default()(section.el);
                this.$window = jquery_default()(window);
                this.flickity = null;
                this.$blogPosts = this.$el.find('[data-blog-posts]'); // Activate flickity on mobile

                this._mobileSlider = this._mobileSlider.bind(this);
                Layout.onBreakpointChange(this._mobileSlider);

                this._mobileSlider();
            }
            /**
             * Unbind events when section is re-drawn
             */


            DynamicBlogPosts_createClass(DynamicTwitterFeed, [{
                key: "onSectionUnload",
                value: function onSectionUnload() {
                    Layout.offBreakpointChange(this._mobileSlider);

                    this._destroyFlickity();
                }
            }, {
                key: "_initFlickity",
                value: function _initFlickity() {
                    this.flickity = new js_default.a(this.$blogPosts[0], {
                        cellSelector: '.article--excerpt-wrapper',
                        contain: true,
                        freeScroll: true,
                        percentPosition: false,
                        prevNextButtons: false,
                        pageDots: false,
                        setGallerySize: false
                    });

                    this._bindSlider();
                }
            }, {
                key: "_destroyFlickity",
                value: function _destroyFlickity() {
                    if (!this.flickity) {
                        return;
                    }

                    this.$window.off('.blog-posts');
                    this.$blogPosts.off('.blog-posts');
                    this.flickity.destroy();
                    this.flickity = null;
                }
            }, {
                key: "_mobileSlider",
                value: function _mobileSlider() {
                    // If is Large layout, attempt to destroy flickity
                    if (Layout.isGreaterThanBreakpoint('M')) {
                        this._destroyFlickity();

                        return;
                    } // Is XS/S/M, and flickity is init'd -- do nothing


                    if (this.flickity) {
                        return;
                    } // Is XS/S/M, and flickity is not init'd


                    this._initFlickity();
                }
            }, {
                key: "_bindSlider",
                value: function _bindSlider() {
                    var _this = this;

                    var $slider = this.$blogPosts.find('.flickity-slider');
                    this.$window.on('resize.blog-posts', just_debounce_default()(function () {
                        _this.$blogPosts.trigger('heightUpdate.blog-posts');
                    }));
                    this.flickity.on('cellSelect', function () {
                        _this.$blogPosts.trigger('heightUpdate.blog-posts');
                    });
                    this.$blogPosts.on('heightUpdate.blog-posts', function () {
                        if (!_this.flickity) {
                            return;
                        }

                        $slider.height(Math.ceil(_this.flickity.maxCellHeight));
                    }); // Sets the Slider to the height of the first slide

                    this.$blogPosts.trigger('heightUpdate.blog-posts');
                }
            }]);

            return DynamicTwitterFeed;
        }();


// CONCATENATED MODULE: ./source/scripts/sections/DynamicPromoBlocks.js
        function DynamicPromoBlocks_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

        function DynamicPromoBlocks_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

        function DynamicPromoBlocks_createClass(Constructor, protoProps, staticProps) { if (protoProps) DynamicPromoBlocks_defineProperties(Constructor.prototype, protoProps); if (staticProps) DynamicPromoBlocks_defineProperties(Constructor, staticProps); return Constructor; }


        // Adjusts the height of the block so it can contain the wrapper within it

        var DynamicPromoBlocks_adjustHeight = function adjustHeight(block) {
            var $block = jquery_default()(block);
            var $wrapper = $block.find('.promo-block--content-wrapper');
            var padding = window.getComputedStyle($block[0], null).getPropertyValue('padding-top').replace('px', '');

            if ($block.innerHeight() - padding * 2 < $wrapper.innerHeight()) {
                $block.css({
                    height: "".concat($wrapper.innerHeight() + padding * 2, "px")
                });
                $wrapper.css({
                    transform: 'none',
                    top: 'auto'
                });
            }
        }; // Removes height settings on the block because they only need to be there for small screens


        var DynamicPromoBlocks_resetHeight = function resetHeight(block) {
            var $block = jquery_default()(block);
            var $wrapper = $block.find('.promo-block--content-wrapper');
            $block.css({
                height: ''
            });
            $wrapper.css({
                transform: '',
                top: ''
            });
        };

        var DynamicPromoBlocks_DynamicPromoBlocks = /*#__PURE__*/function () {
            function DynamicPromoBlocks(section) {
                var _this = this;

                DynamicPromoBlocks_classCallCheck(this, DynamicPromoBlocks);

                this.$el = jquery_default()(section.el);
                this.content = '[data-promo-block-content]';
                this.expandedClass = 'promo-block--expanded';
                this.compressBlocks = section.data.compress_blocks; // Revert navigation to original state on breakpoint change

                this.layoutHandler = this.onBreakpointChange.bind(this);
                Layout.onBreakpointChange(this.layoutHandler);
                this._blockInteraction = this._blockInteraction.bind(this);
                this.$el.on('click.promo-block', this.content, this._blockInteraction);

                if (!this.compressBlocks && Layout.isLessThanBreakpoint('S')) {
                    this.$el.find(this.content).each(function (index, block) {
                        DynamicPromoBlocks_adjustHeight(block);
                    });
                }

                if (!this.compressBlocks) {
                    jquery_default()(window).on('resize', function () {
                        _this.$el.find(_this.content).each(function (index, block) {
                            if (Layout.isLessThanBreakpoint('S')) {
                                DynamicPromoBlocks_adjustHeight(block);
                            } else {
                                DynamicPromoBlocks_resetHeight(block);
                            }
                        });
                    });
                }
            }
            /**
             * Remove block's toggled state and attributes when leaving mobile
             */


            DynamicPromoBlocks_createClass(DynamicPromoBlocks, [{
                key: "onBreakpointChange",
                value: function onBreakpointChange() {
                    var _this2 = this;

                    if (!Layout.isLessThanBreakpoint('S')) {
                        this.$el.find(".".concat(this.expandedClass)).each(function (i, content) {
                            _this2._collapse(content);
                        });
                        this.$el.find(this.content).each(function (index, block) {
                            DynamicPromoBlocks_resetHeight(block);
                        });
                    } else if (!this.compressBlocks) {
                        this.$el.find(this.content).each(function (index, block) {
                            DynamicPromoBlocks_adjustHeight(block);
                        });
                    }
                }
                /**
                 * Unbind events when section is re-drawn
                 */

            }, {
                key: "onSectionUnload",
                value: function onSectionUnload() {
                    this.$el.off('.promo-block');
                    Layout.offBreakpointChange(this.layoutHandler);
                }
                /**
                 * Callback to open block on mobile from the TE
                 *
                 * @param block
                 */

            }, {
                key: "onSectionBlockSelect",
                value: function onSectionBlockSelect(block) {
                    if (!Layout.isLessThanBreakpoint('S')) return;

                    this._expand(block.el.querySelector(this.content));
                }
                /**
                 * Callback to close block on mobile from the TE
                 *
                 * @param block
                 */

            }, {
                key: "onSectionBlockDeselect",
                value: function onSectionBlockDeselect(block) {
                    if (!Layout.isLessThanBreakpoint('S')) return;

                    this._collapse(block.el.querySelector(this.content));
                }
                /**
                 * Expand a block on first click, then allow it to behave as normal
                 *
                 * @param event
                 * @private
                 */

            }, {
                key: "_blockInteraction",
                value: function _blockInteraction(event) {
                    var content = event.currentTarget;
                    var clicked = content.getAttribute('data-clicked'); // On second click, or on desktop, don't interfere with block

                    if (clicked || !Layout.isLessThanBreakpoint('S') || !this.compressBlocks) {
                        return;
                    }

                    event.preventDefault();
                    content.setAttribute('data-clicked', 'clicked');

                    this._expand(content);
                }
                /**
                 * Expand promo block
                 *
                 * @param content
                 * @private
                 */

            }, {
                key: "_expand",
                value: function _expand(content) {
                    var _this3 = this;

                    if (!this.compressBlocks) {
                        return;
                    }

                    var $content = jquery_default()(content);
                    $content.addClass('animating animating-in').one('trend', function () {
                        $content.removeClass('animating animating-in').addClass(_this3.expandedClass).off('trend');
                        DynamicPromoBlocks_adjustHeight($content);
                    });
                }
                /**
                 * Collapse a block
                 *
                 * @param content
                 * @private
                 */

            }, {
                key: "_collapse",
                value: function _collapse(content) {
                    var _this4 = this;

                    if (!this.compressBlocks) {
                        return;
                    }

                    var $content = jquery_default()(content);
                    $content.addClass('animating animating-out').one('trend', function () {
                        $content.removeClass("animating animating-out ".concat(_this4.expandedClass)).off('trend');
                        content.removeAttribute('data-clicked');
                        DynamicPromoBlocks_resetHeight($content);
                    });
                }
            }]);

            return DynamicPromoBlocks;
        }();


// CONCATENATED MODULE: ./source/scripts/sections/DynamicMenuList.js
        function DynamicMenuList_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

        function DynamicMenuList_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

        function DynamicMenuList_createClass(Constructor, protoProps, staticProps) { if (protoProps) DynamicMenuList_defineProperties(Constructor.prototype, protoProps); if (staticProps) DynamicMenuList_defineProperties(Constructor, staticProps); return Constructor; }





        var DynamicMenuList_DynamicMenuList = /*#__PURE__*/function () {
            function DynamicMenuList(section) {
                var _this = this;

                DynamicMenuList_classCallCheck(this, DynamicMenuList);

                this.$el = jquery_default()(section.el);
                this.context = section.data.context;
                this.accordionTrigger = '[data-accordion-trigger]';
                this.seeMoreTrigger = '[data-menulist-toggle]';
                this.Accordion = new Accordion(this.$el[0], {
                    content: '.menulist-menu--initial[data-accordion-content]',
                    onStart: function onStart(_ref) {
                        var el = _ref.el,
                                state = _ref.state;
                        el.parentNode.querySelector(_this.accordionTrigger).dataset.accordionTrigger = state;
                    }
                });
                this.seeMore = new Accordion(this.$el[0], {
                    content: '.menulist-menu--show-more[data-accordion-content]',
                    onStart: function onStart(_ref2) {
                        var el = _ref2.el,
                                state = _ref2.state;
                        el.parentNode.querySelector(_this.seeMoreTrigger).innerHTML = state === 'open' ? _this.context.see_less : _this.context.see_more;
                    }
                });

                if (cjs["max"]('XS')) {
                    this.Accordion.closeAll({
                        force: true
                    });
                }

                this.seeMore.closeAll({
                    force: true
                }); // Handle Accordion interaction when window size changes

                cjs["onChange"](function (breakpoints) {
                    return _this.onBreakpointChange(breakpoints);
                });

                this._bindEvents();
            }

            DynamicMenuList_createClass(DynamicMenuList, [{
                key: "_bindEvents",
                value: function _bindEvents() {
                    var _this2 = this;

                    this.$el.on('click.menu-list', this.accordionTrigger, function (event) {
                        event.preventDefault();

                        _this2._toggleAccordion(event.currentTarget.parentNode);
                    });
                    this.$el.on('click.menu-list', this.seeMoreTrigger, function (event) {
                        event.preventDefault();

                        _this2.seeMore.toggle(event.currentTarget.parentNode);
                    });
                }
            }, {
                key: "onSectionUnload",
                value: function onSectionUnload() {
                    this.$el.off('.menu-list');
                    this.Accordion.unload();
                    this.seeMore.unload();
                }
            }, {
                key: "onSectionBlockSelect",
                value: function onSectionBlockSelect(block) {
                    this._toggleAccordion(block.el);
                }
            }, {
                key: "onSectionBlockDeselect",
                value: function onSectionBlockDeselect(block) {
                    this._toggleAccordion(block.el);
                }
            }, {
                key: "_toggleAccordion",
                value: function _toggleAccordion(block) {
                    if (cjs["min"]('S')) return;
                    this.Accordion.toggle(block);
                }
            }, {
                key: "onBreakpointChange",
                value: function onBreakpointChange(breakpoints) {
                    if (breakpoints.current.min('S')) {
                        this.Accordion.openAll({
                            force: true
                        });
                    } else if (breakpoints.previous.min('S') && breakpoints.current.max('XS')) {
                        this.Accordion.closeAll({
                            force: true
                        });
                    }
                }
            }]);

            return DynamicMenuList;
        }();


// EXTERNAL MODULE: ./node_modules/twitter-fetcher/js/twitterFetcher_min.js
        var twitterFetcher_min = __webpack_require__(17);
        var twitterFetcher_min_default = /*#__PURE__*/__webpack_require__.n(twitterFetcher_min);

// CONCATENATED MODULE: ./source/scripts/sections/DynamicTwitterFeed.js
        function DynamicTwitterFeed_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

        function DynamicTwitterFeed_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

        function DynamicTwitterFeed_createClass(Constructor, protoProps, staticProps) { if (protoProps) DynamicTwitterFeed_defineProperties(Constructor.prototype, protoProps); if (staticProps) DynamicTwitterFeed_defineProperties(Constructor, staticProps); return Constructor; }







        var DynamicTwitterFeed_DynamicTwitterFeed = /*#__PURE__*/function () {
            function DynamicTwitterFeed(section) {
                DynamicTwitterFeed_classCallCheck(this, DynamicTwitterFeed);

                this.$el = jquery_default()(section.el);
                this.settings = section.data;

                this._load();
            }

            DynamicTwitterFeed_createClass(DynamicTwitterFeed, [{
                key: "_load",
                value: function _load() {
                    var _this = this;

                    this.$window = jquery_default()(window);
                    this.flickity = null;
                    this.$content = this.$el.find('[data-twitter-content]');
                    this.$wrapper = this.$el.find('[data-twitter-wrapper]');
                    this.$tweets = this.$el.find('[data-tweet-content]');
                    this.$template = jquery_default()(this.settings.template);
                    var _this$settings = this.settings,
                            onboarding = _this$settings.onboarding,
                            username = _this$settings.username,
                            retweets = _this$settings.retweets,
                            images = _this$settings.images;
                    var locale = this.settings.locale || 'en'; // Activate flickity on mobile

                    this._mobileSlider = this._mobileSlider.bind(this);
                    Layout.onBreakpointChange(this._mobileSlider);

                    this._mobileSlider();

                    if (onboarding || !username) {
                        return;
                    }

                    twitterFetcher_min_default.a.fetch({
                        profile: {
                            screenName: username
                        },
                        maxTweets: 3,
                        enableLinks: true,
                        showUser: true,
                        showTime: true,
                        dataOnly: false,
                        useEmoji: true,
                        showImages: images,
                        showRetweet: retweets,
                        lang: locale,
                        customCallback: function customCallback(tweets) {
                            return _this._renderTweets(tweets);
                        },
                        showInteraction: false
                    });
                }
                /**
                 * Unbind events when section is re-drawn
                 */

            }, {
                key: "onSectionUnload",
                value: function onSectionUnload() {
                    this.$window.off('.twitter');
                    this.$content.off('.twitter');
                    Layout.offBreakpointChange(this._mobileSlider);

                    this._destroyFlickity();
                }
            }, {
                key: "_initFlickity",
                value: function _initFlickity() {
                    this.flickity = new js_default.a(this.$content[0], {
                        cellSelector: '[data-tweet-content]',
                        contain: true,
                        freeScroll: true,
                        percentPosition: false,
                        prevNextButtons: false,
                        pageDots: false,
                        setGallerySize: false
                    });

                    this._bindSlider();
                }
            }, {
                key: "_destroyFlickity",
                value: function _destroyFlickity() {
                    if (!this.flickity) {
                        return;
                    }

                    this.flickity.destroy();
                    this.flickity = null;
                }
            }, {
                key: "_mobileSlider",
                value: function _mobileSlider() {
                    // If is Large layout, attempt to destroy flickity
                    if (Layout.isGreaterThanBreakpoint('S')) {
                        this._destroyFlickity();

                        return;
                    } // Is XS/S/M, and flickity is init'd -- do nothing


                    if (this.flickity) {
                        return;
                    } // Is XS/S/M, and flickity is not init'd


                    this._initFlickity();
                }
            }, {
                key: "_bindSlider",
                value: function _bindSlider() {
                    var _this2 = this;

                    var $slider = this.$content.find('.flickity-slider');
                    this.$window.on('resize.twitter', just_debounce_default()(function () {
                        _this2.$content.trigger('heightUpdate.twitter');
                    }));
                    this.flickity.on('cellSelect', function () {
                        _this2.$content.trigger('heightUpdate.twitter');
                    });
                    this.$content.on('heightUpdate.twitter', function () {
                        if (!_this2.flickity) {
                            return;
                        }

                        $slider.height(Math.ceil(_this2.flickity.maxCellHeight));
                    }); // Sets the Slider to the height of the first slide

                    this.$content.trigger('heightUpdate.twitter');
                }
                /**
                 * Retrieve information about user who tweeted
                 *
                 * @param el
                 * @returns 
                 * @private
                 */

            }, {
                key: "_extractAuthor",
                value: function _extractAuthor(el) {
                    var $el = jquery_default()(el);
                    var link = $el.find('a').attr('href');
                    var name = $el.find('[data-scribe="element:name"]').text();
                    var screenName = $el.find('[data-scribe="element:screen_name"]').text();
                    var $avatar = $el.find('img');
                    return {
                        $avatar: $avatar,
                        link: link,
                        name: name,
                        screenName: screenName
                    };
                }
                /**
                 * Retrieve link to tweet, and when it was tweeted
                 *
                 * @param el
                 * @returns 
                 * @private
                 */

            }, {
                key: "_extractMeta",
                value: function _extractMeta(el) {
                    var $el = jquery_default()(el);
                    var link = $el.find('a').attr('href');
                    var postedAt = $el.text();
                    return {
                        link: link,
                        postedAt: postedAt
                    };
                }
            }, {
                key: "_extractWrapperClass",
                value: function _extractWrapperClass() {
                    var wrapperClass = this.$wrapper.attr('class').match(/tweet--count-\d+$/);

                    if (wrapperClass) {
                        return wrapperClass[0];
                    }

                    return '';
                }
            }, {
                key: "_renderTweets",
                value: function _renderTweets(tweets) {
                    var _this3 = this;

                    var tweetsLength = tweets.length;
                    if (!tweets || !tweetsLength) return;
                    var tweetsArray = [];
                    var wrapperClass = "tweet--count-".concat(tweetsLength);
                    tweets.forEach(function (tweet) {
                        var $tweet = jquery_default()(tweet);

                        var $template = _this3.$template.clone();

                        var authorInfo = _this3._extractAuthor($tweet[0]);

                        var meta = _this3._extractMeta($tweet[2]);

                        var content = $tweet[1]; // Render header

                        $template.find('.tweet--header').attr('href', authorInfo.link);
                        $template.find('.tweet--header-image').html(authorInfo.$avatar);
                        $template.find('.tweet--header-name').text(authorInfo.name);
                        $template.find('.tweet--header-screenname').text(authorInfo.screenName); // Render content

                        $template.find('.tweet--content').append($tweet[3] ? $tweet[3] : null).append(content); // Render footer

                        $template.find('.tweet--footer').attr('href', meta.link).find('.tweet--footer--posted').text(meta.postedAt);
                        tweetsArray.push($template);
                    });
                    this.$wrapper.css('min-height', this.$wrapper.height());
                    this.$tweets.fadeOut().promise().then(function () {
                        _this3._destroyFlickity();

                        _this3.$tweets.remove();

                        _this3.$content.append(tweetsArray);

                        _this3.$wrapper.removeClass(_this3._extractWrapperClass()).addClass(wrapperClass).css('min-height', '');

                        _this3.$tweets = _this3.$el.find('[data-tweet-content]');

                        _this3._mobileSlider();
                    });
                }
            }]);

            return DynamicTwitterFeed;
        }();


// CONCATENATED MODULE: ./source/scripts/sections/DynamicFeaturedCollection.js
        function DynamicFeaturedCollection_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

        function DynamicFeaturedCollection_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

        function DynamicFeaturedCollection_createClass(Constructor, protoProps, staticProps) { if (protoProps) DynamicFeaturedCollection_defineProperties(Constructor.prototype, protoProps); if (staticProps) DynamicFeaturedCollection_defineProperties(Constructor, staticProps); return Constructor; }





        var DynamicFeaturedCollection_DynamicFeaturedCollection = /*#__PURE__*/function () {
            function DynamicFeaturedCollection(section) {
                var _this = this;

                DynamicFeaturedCollection_classCallCheck(this, DynamicFeaturedCollection);

                this.section = section;
                this.el = section.el;
                this.contentWrapperEl = section.el.querySelector('[data-content-wrapper]');
                this.contentEl = section.el.querySelector('[data-content]');
                /*
                 * We keep reference to the original layout of the collection
                 * because dependent upon viewport width, we may need to enforce
                 * one layout over the other.
                 */

                this.initialLayout = this.contentEl.dataset.layout; // Product items

                this.productItems = [];
                var productItemsEls = this.el.querySelectorAll('[data-product-item]');

                for (var i = 0; i < productItemsEls.length; i++) {
                    this.productItems.push(new ProductGridItem_ProductGridItem({
                        el: productItemsEls[i],
                        id: section.id,
                        lazy: false
                    }));
                }

                if (this.initialLayout === 'slideshow') {
                    window.requestAnimationFrame(function () {
                        return _this._initializeFlickity();
                    });
                } else {
                    this.onBreakpointChange = function () {
                        var useSlideshow = Layout.isLessThanBreakpoint('XL');

                        if (useSlideshow) {
                            _this._initializeFlickity();
                        } else {
                            _this._destroyFlickity();
                        }
                    };

                    Layout.onBreakpointChange(this.onBreakpointChange);

                    if (Layout.isLessThanBreakpoint('XL')) {
                        window.requestAnimationFrame(function () {
                            return _this._initializeFlickity();
                        });
                    }
                }
            }

            DynamicFeaturedCollection_createClass(DynamicFeaturedCollection, [{
                key: "onSectionUnload",
                value: function onSectionUnload() {
                    this.productItems.forEach(function (productItem) {
                        return productItem.unload();
                    });
                    this.layoutHandler.offBreakpointChange(this.onBreakpointChange);

                    this._destroyFlickity();
                }
            }, {
                key: "_initializeFlickity",
                value: function _initializeFlickity() {
                    if (this.flickity) return; // Already initialized

                    this.contentEl.dataset.layout = 'slideshow';
                    this.flickity = new js_default.a(this.contentEl, {
                        autoPlay: 0,
                        accessibility: true,
                        cellAlign: 'left',
                        cellSelector: '.productgrid--item',
                        groupCells: true,
                        pageDots: false,
                        contain: true,
                        arrowShape: 'M65.29 11.99L27.28 50L65.3 87.99L70.25 83.06L37.19 50L70.26 16.94L65.29 11.99Z'
                    });
                    var resize = js_default.a.prototype.resize;
                    var viewport = this.contentEl.querySelector('.flickity-viewport');
                    var slider = this.contentEl.querySelector('.flickity-slider');
                    /*
                     * We must wrap Flickity's slider element to allow the usage of
                     * clip, and clip-path to obscure the overflow product items.
                     * To use clip, and clip-path, the clipped element must be absolutely
                     * positioned. In this case, the only native Flickity element
                     * that is absolutely positioned is the slider; but, it moves with the first
                     * slide rather than remaining in the viewport removing it as a candidate.
                     * Therefore, it is necessary to include a wrapper element that we can
                     * absolutely position that remains within the viewport.
                     * The only thing we need to watch out for is that the elements
                     * are moved in a non-destructive manner.
                     */

                    var sliderWrapper = document.createElement('div');
                    sliderWrapper.classList.add('flickity-slider--wrapper');
                    viewport.appendChild(sliderWrapper);
                    sliderWrapper.appendChild(slider);

                    this.flickity.resize = function r() {
                        viewport.style.height = '';
                        resize.call(this);
                    };
                }
            }, {
                key: "_destroyFlickity",
                value: function _destroyFlickity() {
                    if (!this.flickity) return; // Already uninitialized

                    this.contentEl.dataset.layout = this.initialLayout;
                    var viewport = this.contentEl.querySelector('.flickity-viewport');
                    var slider = this.contentEl.querySelector('.flickity-slider');
                    /*
                     * Remember to move the Flickity native elements back
                     * into the correct DOM layout, before removing the added
                     * wrapper.
                     */

                    var sliderWrapper = this.contentEl.querySelector('.flickity-slider--wrapper');
                    viewport.appendChild(slider);
                    viewport.removeChild(sliderWrapper);
                    this.flickity.destroy();
                    this.flickity = null;
                }
            }]);

            return DynamicFeaturedCollection;
        }();


// CONCATENATED MODULE: ./source/scripts/sections/DynamicProduct.js
        function DynamicProduct_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { DynamicProduct_typeof = function _typeof(obj) { return typeof obj; }; } else { DynamicProduct_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return DynamicProduct_typeof(obj); }

        function DynamicProduct_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

        function DynamicProduct_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) DynamicProduct_setPrototypeOf(subClass, superClass); }

        function DynamicProduct_setPrototypeOf(o, p) { DynamicProduct_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return DynamicProduct_setPrototypeOf(o, p); }

        function DynamicProduct_createSuper(Derived) { var hasNativeReflectConstruct = DynamicProduct_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = DynamicProduct_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = DynamicProduct_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return DynamicProduct_possibleConstructorReturn(this, result); }; }

        function DynamicProduct_possibleConstructorReturn(self, call) { if (call && (DynamicProduct_typeof(call) === "object" || typeof call === "function")) { return call; } return DynamicProduct_assertThisInitialized(self); }

        function DynamicProduct_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

        function DynamicProduct_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

        function DynamicProduct_getPrototypeOf(o) { DynamicProduct_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return DynamicProduct_getPrototypeOf(o); }



        var DynamicProduct = /*#__PURE__*/function (_Product) {
            DynamicProduct_inherits(DynamicProduct, _Product);

            var _super = DynamicProduct_createSuper(DynamicProduct);

            function DynamicProduct(section) {
                DynamicProduct_classCallCheck(this, DynamicProduct);

                return _super.call(this, section, {
                    useHistory: false
                });
            }

            return DynamicProduct;
        }(Product_Product);


// CONCATENATED MODULE: ./source/scripts/sections/DynamicRichText.js
        function DynamicRichText_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

        function DynamicRichText_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

        function DynamicRichText_createClass(Constructor, protoProps, staticProps) { if (protoProps) DynamicRichText_defineProperties(Constructor.prototype, protoProps); if (staticProps) DynamicRichText_defineProperties(Constructor, staticProps); return Constructor; }




        var DynamicRichText_DynamicRichText = /*#__PURE__*/function () {
            function DynamicRichText(section) {
                var _this = this;

                DynamicRichText_classCallCheck(this, DynamicRichText);

                this.$el = jquery_default()(section.el);
                this.rte = [];
                this.$el.find('[data-rte]').each(function (i, el) {
                    _this.rte.push(new RichText_RichText(jquery_default()(el)));
                });
            }
            /**
             * Unbind events when section is re-drawn
             */


            DynamicRichText_createClass(DynamicRichText, [{
                key: "onSectionUnload",
                value: function onSectionUnload() {
                    this.rte.forEach(function (richTextArea) {
                        richTextArea.unload();
                    });
                }
            }]);

            return DynamicRichText;
        }();


// CONCATENATED MODULE: ./source/scripts/sections/DynamicSearch.js
        function DynamicSearch_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

        function DynamicSearch_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { DynamicSearch_ownKeys(Object(source), true).forEach(function (key) { DynamicSearch_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { DynamicSearch_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

        function DynamicSearch_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

        function DynamicSearch_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

        function DynamicSearch_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

        function DynamicSearch_createClass(Constructor, protoProps, staticProps) { if (protoProps) DynamicSearch_defineProperties(Constructor.prototype, protoProps); if (staticProps) DynamicSearch_defineProperties(Constructor, staticProps); return Constructor; }







        var DynamicSearch_DynamicSearch = /*#__PURE__*/function () {
            function DynamicSearch(section) {
                var _this = this;

                DynamicSearch_classCallCheck(this, DynamicSearch);

                this.$el = jquery_default()(section.el);
                this.settings = section.data.settings;
                this.search = null;
                this.$scripts = jquery_default()('[data-scripts]');
                this.$searchField = this.$el.find('[data-live-search]');
                this.forms = new Forms_Forms(this.$el);

                if (this.settings.live_search.enable) {
                    script_default()(this.$scripts.data('shopify-api-url'), function () {
                        _this.search = new LiveSearch_LiveSearch({
                            el: _this.$searchField,
                            header: _this.$el
                        }, DynamicSearch_objectSpread(DynamicSearch_objectSpread({}, _this.settings.live_search), {}, {
                            use_dimmer: false
                        }));
                    });
                } else {
                    this.search = new SearchForm_SearchForm(this.$searchField);
                }
            }

            DynamicSearch_createClass(DynamicSearch, [{
                key: "onSectionUnload",
                value: function onSectionUnload() {
                    this.search.unload();
                    this.forms.unload();
                }
            }]);

            return DynamicSearch;
        }();


// EXTERNAL MODULE: ./node_modules/@pixelunion/pxs-slideshow/dist/index.es.js
        var pxs_slideshow_dist_index_es = __webpack_require__(18);

// CONCATENATED MODULE: ./source/scripts/helpers/LoadInAnimations.js
        function LoadInAnimations_toConsumableArray(arr) { return LoadInAnimations_arrayWithoutHoles(arr) || LoadInAnimations_iterableToArray(arr) || LoadInAnimations_unsupportedIterableToArray(arr) || LoadInAnimations_nonIterableSpread(); }

        function LoadInAnimations_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

        function LoadInAnimations_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return LoadInAnimations_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return LoadInAnimations_arrayLikeToArray(o, minLen); }

        function LoadInAnimations_iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

        function LoadInAnimations_arrayWithoutHoles(arr) { if (Array.isArray(arr)) return LoadInAnimations_arrayLikeToArray(arr); }

        function LoadInAnimations_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

        var LoadInAnimations_classes = {
            block: 'pxu-lia-block',
            element: 'pxu-lia-element',
            playBlock: 'pxu-lia-block--play',
            resetBlock: 'pxu-lia-block--reset',
            playSection: 'pxu-lia-section--play',
            resetSection: 'pxu-lia-section--reset'
        };
        var mappingSelector = '[type="application/pxs-animation-mapping+json"]';
        /**
         * Find common parent of this block and the closest animation mapping block.
         *
         * @param {HTMLElement} node Block from which to begin search.
         */

        var getMappingParentFromBlock = function getMappingParentFromBlock(_ref) {
            var parentNode = _ref.parentNode;
            return parentNode.querySelector(mappingSelector) ? parentNode : getMappingParentFromBlock(parentNode);
        };

        var LoadInAnimations_reset = function reset(block, elements) {
            block.style.animationName = 'none';
            block.classList.add(LoadInAnimations_classes.resetBlock);
            elements.forEach(function (element) {
                element.style.animationName = 'none';
            });
        };

        var removeReset = function removeReset(block, elements) {
            block.style.animationName = '';
            block.classList.remove(LoadInAnimations_classes.resetBlock);
            elements.forEach(function (element) {
                element.style.animationName = '';
            });
        };

        var play = function play(block, elements) {
            block.style.animationPlayState = 'running';
            block.classList.add(LoadInAnimations_classes.playBlock);
            elements.forEach(function (element) {
                element.style.animationPlayState = 'running';
            });
        };

        var pause = function pause(block, elements) {
            block.style.animationPlayState = '';
            block.classList.remove(LoadInAnimations_classes.playBlock);
            elements.forEach(function (element) {
                element.style.animationPlayState = '';
            });
        };
        /**
         * Play, or reset animations for a collection of blocks.
         *
         * @param {[HTMLElement]} blocks Blocks to process
         * @param {String} state One of 'play' or 'reset'.
         */


        var loadInAnimations = function loadInAnimations(blocks) {
            var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'play';
            var callNextFrame = [];

            if (state === 'reset') {
                blocks.forEach(function (block) {
                    var elements = block.querySelectorAll(".".concat(LoadInAnimations_classes.element));
                    pause(block, elements);
                    LoadInAnimations_reset(block, elements);
                    callNextFrame.push(function () {
                        removeReset(block, elements);
                    });
                });
                var section = getMappingParentFromBlock(blocks[0]);
                section.classList.remove(LoadInAnimations_classes.playSection);
                section.classList.add(LoadInAnimations_classes.resetSection);
                callNextFrame.push(function () {
                    section.classList.remove(LoadInAnimations_classes.resetSection);
                });
            } else {
                blocks.forEach(function (block, blockIndex) {
                    // Set sequence for blocks
                    block.style.setProperty('--pxu-lia-outer-sequence', blockIndex); // Set sequence for sub elements (heading, text, button, etc)

                    var elements = block.querySelectorAll(".".concat(LoadInAnimations_classes.element));
                    elements.forEach(function (element, elementIndex) {
                        element.style.setProperty('--pxu-lia-inner-sequence', elementIndex);
                    });

                    if (block.classList.contains(LoadInAnimations_classes.playBlock)) {
                        LoadInAnimations_reset(block, elements);
                        callNextFrame.push(function () {
                            removeReset(block, elements);
                            play(block, elements);
                        });
                    } else {
                        play(block, elements);
                    }

                    var section = getMappingParentFromBlock(blocks[0]);

                    if (section.classList.contains(LoadInAnimations_classes.playSection)) {
                        section.classList.add(LoadInAnimations_classes.resetSection);
                        callNextFrame.push(function () {
                            section.classList.remove(LoadInAnimations_classes.resetSection);
                            section.classList.add(LoadInAnimations_classes.playSection);
                        });
                    } else {
                        section.classList.add(LoadInAnimations_classes.playSection);
                    }
                });
            }

            window.requestAnimationFrame(function () {
                return callNextFrame.forEach(function (fn) {
                    return fn();
                });
            });
        };
        /**
         * Manually trigger load-in animations. Existing animations will be reset and replayed.
         *
         * @param {[HTMLElement]} blocks Blocks for which to play animations
         */


        var playLoadInAnimations = function playLoadInAnimations(blocks) {
            return loadInAnimations(blocks, 'play');
        };
        /**
         * Manually reset load-in animations to initial state.
         *
         * @param {[HTMLElement]} blocks Blocks for which to reset animations
         */


        var resetLoadInAnimations = function resetLoadInAnimations(blocks) {
            return loadInAnimations(blocks, 'reset');
        };

        var intersectionCallback = function intersectionCallback(entries, observer) {
            var toAnimate = new Map();
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    // Animations only run once so stop observing
                    observer.unobserve(entry.target); // Find all blocks on same level that are now intersecting and arrange by parent section

                    var parentSequence = getMappingParentFromBlock(entry.target);
                    var existingSiblings = toAnimate.get(parentSequence);
                    toAnimate.set(parentSequence, existingSiblings ? [].concat(LoadInAnimations_toConsumableArray(existingSiblings), [entry.target]) : [entry.target]);
                }
            });
            toAnimate.forEach(function (blocks, parent) {
                return playLoadInAnimations(blocks, parent);
            });
        };

        var blockObserver = null;
        /**
         * Removes blocks from the global intersection observer for load in animations.
         *
         * @param {[HTMLElement]} blocks Blocks to stop observing for automatic load-in-animation play
         */

        var removeLoadInAnimationsAutoplay = function removeLoadInAnimationsAutoplay(blocks) {
            return blocks.forEach(function (block) {
                return blockObserver && blockObserver.unobserve(block);
            });
        };

        var initLoadInAnimationsAutoplay = function initLoadInAnimationsAutoplay() {
            // This assumes that animated elements are arranged by section,
            // block, and element. Animations are triggered when blocks
            // enter view, and are sequenced within sections by block and by subElement.
            // Sequencing information is applied as custom properties that can be referenced in css.
            blockObserver = new IntersectionObserver(intersectionCallback, {
                threshold: 0.3
            });

            if (!('reduceAnimations' in document.body.dataset)) {
                var observe = function observe(parent) {
                    parent.querySelectorAll(".".concat(LoadInAnimations_classes.block)).forEach(function (block) {
                        return blockObserver.observe(block);
                    });
                };

                observe(document);
            }
        };


// CONCATENATED MODULE: ./source/scripts/sections/DynamicSlideshow.js
        function DynamicSlideshow_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { DynamicSlideshow_typeof = function _typeof(obj) { return typeof obj; }; } else { DynamicSlideshow_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return DynamicSlideshow_typeof(obj); }

        function DynamicSlideshow_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

        function DynamicSlideshow_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) DynamicSlideshow_setPrototypeOf(subClass, superClass); }

        function DynamicSlideshow_setPrototypeOf(o, p) { DynamicSlideshow_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return DynamicSlideshow_setPrototypeOf(o, p); }

        function DynamicSlideshow_createSuper(Derived) { var hasNativeReflectConstruct = DynamicSlideshow_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = DynamicSlideshow_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = DynamicSlideshow_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return DynamicSlideshow_possibleConstructorReturn(this, result); }; }

        function DynamicSlideshow_possibleConstructorReturn(self, call) { if (call && (DynamicSlideshow_typeof(call) === "object" || typeof call === "function")) { return call; } return DynamicSlideshow_assertThisInitialized(self); }

        function DynamicSlideshow_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

        function DynamicSlideshow_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

        function DynamicSlideshow_getPrototypeOf(o) { DynamicSlideshow_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return DynamicSlideshow_getPrototypeOf(o); }




        var DynamicSlideshow_DynamicSlideshow = /*#__PURE__*/function (_Slideshow) {
            DynamicSlideshow_inherits(DynamicSlideshow, _Slideshow);

            var _super = DynamicSlideshow_createSuper(DynamicSlideshow);

            function DynamicSlideshow(section) {
                var _this;

                DynamicSlideshow_classCallCheck(this, DynamicSlideshow);

                _this = _super.call(this, section); // We are manually playing load in animations when
                // changing slides, so prevent automatic play.

                removeLoadInAnimationsAutoplay(_this.slides);
                playLoadInAnimations([_this.slides[0]]);

                if (_this.flickity) {
                    _this.flickity.on('change', function (index) {
                        // This is a delay to fake waiting until the slide has fully changed.
                        // Waiting until 'settle' is a bit too long.
                        setTimeout(function () {
                            resetLoadInAnimations(Array.prototype.filter.call(_this.slides, function (el, i) {
                                return i !== index;
                            }));
                        }, 100);
                        setTimeout(function () {
                            playLoadInAnimations([_this.slides[index]]);
                        }, 150);
                    });
                }

                return _this;
            }

            return DynamicSlideshow;
        }(pxs_slideshow_dist_index_es["a" /* default */]);


// CONCATENATED MODULE: ./source/scripts/sections/DynamicVideo.js
        function DynamicVideo_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

        function DynamicVideo_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

        function DynamicVideo_createClass(Constructor, protoProps, staticProps) { if (protoProps) DynamicVideo_defineProperties(Constructor.prototype, protoProps); if (staticProps) DynamicVideo_defineProperties(Constructor, staticProps); return Constructor; }



        var DynamicVideo_DynamicVideo = /*#__PURE__*/function () {
            function DynamicVideo(section) {
                DynamicVideo_classCallCheck(this, DynamicVideo);

                this.el = section.el;
                this.autoplay = section.data.autoplay;
                this.init();
            }

            DynamicVideo_createClass(DynamicVideo, [{
                key: "init",
                value: function init() {
                    var _this = this;

                    var videoEl = this.el.querySelector('[data-video]');
                    this.hasPlayed = false;

                    if (videoEl) {
                        this.video = new Video_Video(videoEl);
                    }

                    if (this.video && this.autoplay) {
                        var thresholds = {
                            play: 0.5,
                            pause: 0.2
                        };
                        this.playPauseObserver = new IntersectionObserver(function (entries) {
                            var _entries$ = entries[0],
                                    intersectionRatio = _entries$.intersectionRatio,
                                    isIntersecting = _entries$.isIntersecting;

                            if (intersectionRatio >= thresholds.play && isIntersecting && !_this.hasPlayed) {
                                // videoEl has just scrolled into view and is at least 50% visible: play video
                                _this.video._autoplay();

                                _this.hasPlayed = true;
                            } else if (intersectionRatio <= thresholds.pause && isIntersecting === false) {
                                // videoEl has scrolled out of view and is less than 20% visible: pause video
                                _this.video._onPauseClick();
                            }
                        }, {
                            threshold: [thresholds.pause, thresholds.play]
                        });
                        this.playPauseObserver.observe(videoEl);
                    }
                }
            }, {
                key: "onSectionUnload",
                value: function onSectionUnload() {
                    if (this.video) {
                        this.video.unload();
                    }

                    if (this.playPauseObserver) {
                        this.playPauseObserver.disconnect();
                    }
                }
            }]);

            return DynamicVideo;
        }();


// CONCATENATED MODULE: ./source/scripts/sections/DynamicNewsletter.js
        function DynamicNewsletter_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

        function DynamicNewsletter_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

        function DynamicNewsletter_createClass(Constructor, protoProps, staticProps) { if (protoProps) DynamicNewsletter_defineProperties(Constructor.prototype, protoProps); if (staticProps) DynamicNewsletter_defineProperties(Constructor, staticProps); return Constructor; }




        var DynamicNewsletter_DynamicNewsletter = /*#__PURE__*/function () {
            function DynamicNewsletter(section) {
                DynamicNewsletter_classCallCheck(this, DynamicNewsletter);

                this.$el = jquery_default()(section.el);
                this.forms = new Forms_Forms(this.$el);
            }

            DynamicNewsletter_createClass(DynamicNewsletter, [{
                key: "onSectionUnload",
                value: function onSectionUnload() {
                    this.forms.unload();
                }
            }]);

            return DynamicNewsletter;
        }();


// CONCATENATED MODULE: ./source/scripts/sections/DynamicHighlightsBanner.js
        function DynamicHighlightsBanner_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

        function DynamicHighlightsBanner_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

        function DynamicHighlightsBanner_createClass(Constructor, protoProps, staticProps) { if (protoProps) DynamicHighlightsBanner_defineProperties(Constructor.prototype, protoProps); if (staticProps) DynamicHighlightsBanner_defineProperties(Constructor, staticProps); return Constructor; }






        var DynamicHighlightsBanner_DynamicHighlightsBanner = /*#__PURE__*/function () {
            function DynamicHighlightsBanner(section) {
                DynamicHighlightsBanner_classCallCheck(this, DynamicHighlightsBanner);

                this.$el = jquery_default()(section.el);
                this.$window = jquery_default()(window);
                this.$carousel = this.$el.find('[data-highlights-slider]');
                this.slides = '[data-highlights-block]';
                this.flickity = null;
                this.flickityOptions = null;

                if (this.$carousel.find(this.slides).length > 1) {
                    this._initSlider();
                }
            }

            DynamicHighlightsBanner_createClass(DynamicHighlightsBanner, [{
                key: "_initSlider",
                value: function _initSlider() {
                    this.flickityOptions = {
                        autoPlay: 0,
                        accessibility: true,
                        cellAlign: 'left',
                        cellSelector: this.slides,
                        pageDots: false,
                        prevNextButtons: false,
                        contain: true
                    };

                    this._bindFlickity();
                }
            }, {
                key: "onSectionUnload",
                value: function onSectionUnload() {
                    this._destroyFlickity();

                    this.$window.off('.twitter');
                }
            }, {
                key: "_bindFlickity",
                value: function _bindFlickity() {
                    var _this = this;

                    if (Layout.isGreaterThanBreakpoint('M') === false && this.flickity === null) {
                        this.flickity = new js_default.a(this.$carousel[0], this.flickityOptions);
                    }

                    this.$window.on('resize', just_debounce_default()(function () {
                        if (Layout.isGreaterThanBreakpoint('M') === false && _this.flickity === null) {
                            _this._bindFlickity();
                        } else if (Layout.isGreaterThanBreakpoint('M') && _this.flickity) {
                            _this._destroyFlickity();
                        }
                    }));
                }
            }, {
                key: "_destroyFlickity",
                value: function _destroyFlickity() {
                    if (!this.flickity) {
                        return;
                    }

                    this.flickity.destroy();
                    this.flickity = null;
                }
            }]);

            return DynamicHighlightsBanner;
        }();


// CONCATENATED MODULE: ./source/scripts/templates/Account.js
        function Account_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

        function Account_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

        function Account_createClass(Constructor, protoProps, staticProps) { if (protoProps) Account_defineProperties(Constructor.prototype, protoProps); if (staticProps) Account_defineProperties(Constructor, staticProps); return Constructor; }





        var Account_Account = /*#__PURE__*/function () {
            function Account() {
                Account_classCallCheck(this, Account);

                this.$accountContents = jquery_default()('[data-template-account]');
                this.$loginContent = jquery_default()('[data-template-account-login]');
                this.$addressesContent = jquery_default()('[data-template-account-addresses]');
                this.$addressButtonFocus = null;
                this.checkFillAnimation = null;
                this.checkAnimation = null;
                this._loginToggle = this._loginToggle.bind(this);

                if (this.$loginContent.length) {
                    this._initLoginPage();
                }

                if (this.$addressesContent.length) {
                    this.defaultAddressCheckbox = this.$addressesContent[0].querySelector('.checkmark');
                    this.defaultAddressCheck = this.$addressesContent[0].querySelector('.checkmark__check');
                    this.checkFillAnimation = transition({
                        el: this.defaultAddressCheckbox
                    });
                    this.checkAnimation = transition({
                        el: this.defaultAddressCheck
                    });

                    this._initAddressPage();
                }

                if (this.$accountContents.length) {
                    this._init();
                }
            }

            Account_createClass(Account, [{
                key: "_init",
                value: function _init() {
                    new Forms_Forms(this.$accountContents);
                }
            }, {
                key: "_initLoginPage",
                value: function _initLoginPage() {
                    this.$loginToggle = this.$loginContent.find('[data-login-toggle]');
                    this.$login = this.$loginContent.find('[data-account-login-main]');
                    this.$recovery = this.$loginContent.find('[data-account-login-recovery]');
                    this.$recoveryHasMessage = this.$recovery.find('[data-recovery-has-message]');
                    this.$loginToggle.on('click', this._loginToggle);

                    if (this.$recoveryHasMessage.length) {
                        this._loginToggle();
                    }
                }
            }, {
                key: "_loginToggle",
                value: function _loginToggle() {
                    var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

                    if (event) {
                        event.preventDefault();
                    }

                    this.$login.toggleClass('visible');
                    this.$recovery.toggleClass('visible');
                }
            }, {
                key: "_initAddressPage",
                value: function _initAddressPage() {
                    var _this = this;

                    var $customerAddresses = this.$addressesContent.find('[data-address-id]');
                    this.$addressesContent.on('click', '[data-edit-address]', function (event) {
                        var $target = jquery_default()(event.currentTarget);
                        var itemId = $target.attr('data-edit-address');
                        $customerAddresses.removeClass('visible');
                        _this.$addressButtonFocus = $target;
                        jquery_default()("[data-address-id=\"".concat(itemId, "\"]")).addClass('visible').find('.form-field-input').eq(0).focus();
                    });
                    this.$addressesContent.on('click', '[data-edit-address-cancel]', function () {
                        $customerAddresses.removeClass('visible');
                        jquery_default()('[data-address-id="new"]').addClass('visible'); // Return focus to last used button

                        _this.$addressButtonFocus.focus();

                        _this.$addressButtonFocus = null;
                    });
                    this.$addressesContent.on('click', '[data-delete-address]', function (event) {
                        var itemId = jquery_default()(event.target).attr('data-delete-address');
                        Shopify.CustomerAddress.destroy(itemId, '');
                    });
                    $customerAddresses.each(function (i, el) {
                        var id = jquery_default()(el).attr('data-address-id');
                        var countryEl = "customer_addr_".concat(id, "_country");
                        var provinceEl = "customer_addr_".concat(id, "_province");
                        var options = {
                            hideElement: "address_province_container_".concat(id)
                        }; // Initiate provinces for address forms

                        new Shopify.CountryProvinceSelector(countryEl, provinceEl, options);
                    });
                    this.$addressesContent.on('click', '#address_default_address_new', function () {
                        var state = 'checked';

                        if (_this.defaultAddressCheckbox.dataset.animationState === 'checked') {
                            state = 'unchecked';
                        }

                        _this.checkFillAnimation.animateTo(state);

                        _this.checkAnimation.animateTo(state);
                    });
                }
            }]);

            return Account;
        }();


// CONCATENATED MODULE: ./source/scripts/templates/Contact.js
        function Contact_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




        var Contact_Contact = function Contact() {
            Contact_classCallCheck(this, Contact);

            this.$contactContents = jquery_default()('[data-template-contact]');

            if (this.$contactContents.length) {
                new Forms_Forms(this.$contactContents);
            }
        };


// CONCATENATED MODULE: ./source/scripts/templates/GiftCard.js
        function GiftCard_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

        function GiftCard_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

        function GiftCard_createClass(Constructor, protoProps, staticProps) { if (protoProps) GiftCard_defineProperties(Constructor.prototype, protoProps); if (staticProps) GiftCard_defineProperties(Constructor, staticProps); return Constructor; }



        var GiftCard_GiftCard = /*#__PURE__*/function () {
            function GiftCard() {
                GiftCard_classCallCheck(this, GiftCard);

                this.el = document.querySelector('.giftcard');
                this.$el = jquery_default()(this.el);
                this.qrCode = this.el.querySelector('[data-giftcard-qr]');
                this.giftCardCode = this.el.querySelector('[data-giftcard-code]');

                this._bindEvents();

                this.addQrCode();
            }

            GiftCard_createClass(GiftCard, [{
                key: "addQrCode",
                value: function addQrCode() {
                    return new QRCode(this.qrCode, {
                        text: jquery_default()(this.qrCode).data('giftcard-qr'),
                        width: 120,
                        height: 120
                    });
                }
            }, {
                key: "_bindEvents",
                value: function _bindEvents() {
                    var _this = this;

                    this.$el.on('click', '[data-giftcard-print]', function () {
                        window.print();
                    }); // Auto-select gift card code on click, based on ID passed to the function

                    this.$el.on('click', '[data-giftcard-code]', function () {
                        _this._selectText();
                    });
                }
            }, {
                key: "_selectText",
                value: function _selectText() {
                    var range = '';
                    var selection;

                    if (document.body.createTextRange) {
                        // ms method
                        range = document.body.createTextRange();
                        range.moveToElementText(this.giftCardCode);
                        range.select();
                    } else if (window.getSelection) {
                        // moz, opera, webkit method
                        selection = window.getSelection();
                        range = document.createRange();
                        range.selectNodeContents(this.giftCardCode);
                        selection.removeAllRanges();
                        selection.addRange(range);
                    }
                }
            }]);

            return GiftCard;
        }();


// CONCATENATED MODULE: ./source/scripts/templates/Page.js
        function Page_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




        var Page_Page = function Page() {
            Page_classCallCheck(this, Page);

            this.$pageContent = jquery_default()('[data-template-page]');

            if (this.$pageContent.length) {
                new RichText_RichText(this.$pageContent);
            }
        };


// CONCATENATED MODULE: ./source/scripts/helpers/FlickityTouchFix.js
// This is a helper class to fix a touch issue that came up in flickity
// on iOS devices as of version 13. It should smooth out some of the scroll
// and swipe issues that flickity is having on that version of iOS.
        var flickityTouchFix = function flickityTouchFix() {
            var touchingSlider = false;
            var touchStartCoordsX = 0;

            var onTouchStart = function onTouchStart(e) {
                if (e.target.closest && e.target.closest('.flickity-slider')) {
                    touchingSlider = true;
                    touchStartCoordsX = e.touches[0].pageX;
                } else {
                    touchingSlider = false;
                }
            };

            var onTouchMove = function onTouchMove(e) {
                if (!(touchingSlider && e.cancelable)) {
                    return;
                }

                if (Math.abs(e.touches[0].pageX - touchStartCoordsX) > 10) {
                    e.preventDefault();
                }
            };

            document.body.addEventListener('touchstart', onTouchStart);
            document.body.addEventListener('touchmove', onTouchMove, {
                passive: false
            });
        };

        /* harmony default export */ var FlickityTouchFix = (flickityTouchFix);
// CONCATENATED MODULE: ./source/scripts/helpers/ContainSwatchTooltips.js
        function ContainSwatchTooltips_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

        function ContainSwatchTooltips_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

        function ContainSwatchTooltips_createClass(Constructor, protoProps, staticProps) { if (protoProps) ContainSwatchTooltips_defineProperties(Constructor.prototype, protoProps); if (staticProps) ContainSwatchTooltips_defineProperties(Constructor, staticProps); return Constructor; }

        function setTooltipOffset(target) {
            var margin = 10;
            var _window = window,
                    innerWidth = _window.innerWidth;

            var _target$getBoundingCl = target.getBoundingClientRect(),
                    x = _target$getBoundingCl.x,
                    width = _target$getBoundingCl.width;

            var tooltipWidth = parseFloat(window.getComputedStyle(target, ':after').width);
            var required = tooltipWidth * 0.5;
            var available = 0;
            var offset = 0;

            if (x < innerWidth * 0.5) {
                // Closer to left side of screen
                available = x + width * 0.5 - margin;
                offset = required - available;
            } else {
                available = innerWidth - x - width * 0.5 - margin;
                offset = available - required;
            }

            target.style.setProperty('--swatch-tooltip-offset', "".concat(required >= available ? offset : 0, "px"));
        }

        function handleMouseover(_ref) {
            var target = _ref.target;
            // We need to check for dataset, because IE11 doesn't support
            // the dataset property for certain elements like svgs
            if (target.dataset && !target.dataset.swatchTooltip) return;
            window.requestAnimationFrame(function () {
                return setTooltipOffset(target);
            });
        }

        var ContainSwatchTooltips = /*#__PURE__*/function () {
            function ContainSwatchTooltips() {
                ContainSwatchTooltips_classCallCheck(this, ContainSwatchTooltips);

                window.addEventListener('mouseover', handleMouseover);
            }

            ContainSwatchTooltips_createClass(ContainSwatchTooltips, [{
                key: "unload",
                value: function unload() {
                    window.removeEventListener('mouseover', handleMouseover);
                }
            }]);

            return ContainSwatchTooltips;
        }();


// CONCATENATED MODULE: ./source/scripts/Empire.js
// jQuery plugins

        // eslint-disable-line

        // eslint-disable-line
// Global imports

        // Shared sections

        // Responsive Images

        // eslint-disable-line
// Section Manager

        // Polyfills

        // Static Sections












        // Dynamic sections












        // Templates




        // Flickity iOS fix






        var Empire_initEmpire = function initEmpire() {
            initLoadInAnimationsAutoplay();
            rimg_shopify_dist_index_es.init('[data-rimg="lazy"]', {
                round: 1
            });

            var initRipple = function initRipple() {
                return Ripple_setupRippleEffect(document);
            };

            if ('requestIdleCallback' in window) {
                window.requestIdleCallback(initRipple);
            } else {
                initRipple();
            }

            var sections = new Sections(); // Static sections

            sections.register('static-header', function (section) {
                return new StaticHeader_StaticHeader(section);
            });
            sections.register('static-announcement', function (section) {
                return new StaticAnnouncement(section);
            });
            sections.register('static-footer', function (section) {
                return new StaticFooter_StaticFooter(section);
            });
            sections.register('static-article', function (section) {
                return new StaticArticle_StaticArticle(section);
            });
            sections.register('static-blog', function (section) {
                return new StaticBlog_StaticBlog(section);
            });
            sections.register('static-cart', function (section) {
                return new StaticCart_StaticCart(section);
            });
            sections.register('static-collection', function (section) {
                return new StaticCollection_StaticCollection(section);
            });
            sections.register('static-password', function (section) {
                return new StaticPassword_StaticPassword(section);
            });
            sections.register('static-product', function (section) {
                return new StaticProduct(section);
            });
            sections.register('static-product-recommendations', function (section) {
                return new StaticProductRecommendations_StaticProductRecommendations(section);
            });
            sections.register('static-recently-viewed', function (section) {
                return new StaticRecentlyViewed_StaticRecentlyViewed(section);
            });
            sections.register('static-search', function (section) {
                return new StaticSearch_StaticSearch(section);
            }); // Dynamic sections (lazy loaded)

            sections.register('dynamic-blog-posts', function (section) {
                return new DynamicBlogPosts_DynamicTwitterFeed(section);
            }, {
                lazy: true
            });
            sections.register('dynamic-promo-mosaic', function (section) {
                return new DynamicPromoBlocks_DynamicPromoBlocks(section);
            }, {
                lazy: true
            });
            sections.register('dynamic-promo-grid', function (section) {
                return new DynamicPromoBlocks_DynamicPromoBlocks(section);
            }, {
                lazy: true
            });
            sections.register('dynamic-menu-list', function (section) {
                return new DynamicMenuList_DynamicMenuList(section);
            }, {
                lazy: true
            });
            sections.register('dynamic-twitter-feed', function (section) {
                return new DynamicTwitterFeed_DynamicTwitterFeed(section);
            }, {
                lazy: true
            });
            sections.register('dynamic-featured-collection', function (section) {
                return new DynamicFeaturedCollection_DynamicFeaturedCollection(section);
            }, {
                lazy: true
            });
            sections.register('dynamic-featured-product', function (section) {
                return new DynamicProduct(section);
            }, {
                lazy: true
            });
            sections.register('dynamic-rich-text', function (section) {
                return new DynamicRichText_DynamicRichText(section);
            }, {
                lazy: true
            });
            sections.register('dynamic-page', function (section) {
                return new DynamicRichText_DynamicRichText(section);
            }, {
                lazy: true
            });
            sections.register('dynamic-html', function (section) {
                return new DynamicRichText_DynamicRichText(section);
            }, {
                lazy: true
            });
            sections.register('dynamic-search', function (section) {
                return new DynamicSearch_DynamicSearch(section);
            }, {
                lazy: true
            });
            sections.register('dynamic-highlights-banner', function (section) {
                return new DynamicHighlightsBanner_DynamicHighlightsBanner(section);
            });
            sections.register('pxs-slideshow', function (section) {
                return new DynamicSlideshow_DynamicSlideshow(section);
            }, {
                lazy: true
            });
            sections.register('dynamic-video', function (section) {
                return new DynamicVideo_DynamicVideo(section);
            }, {
                lazy: true
            });
            sections.register('pxs-newsletter', function (section) {
                return new DynamicNewsletter_DynamicNewsletter(section);
            }, {
                lazy: true
            });
            sections.register('pxs-map', function (section) {
                return new index_es(section);
            }, {
                lazy: true
            });

            if (document.body.classList.contains('template-giftcard')) {
                new GiftCard_GiftCard();
            }

            if (document.querySelector('[data-template-account]')) {
                new Account_Account();
            }

            if (document.body.classList.contains('template-contact')) {
                new Contact_Contact();
            }

            if (document.body.classList.contains('template-page')) {
                new Page_Page();
            }

            if (document.querySelector('[data-swatch-tooltip]')) {
                new ContainSwatchTooltips();
            }
        };

        FlickityTouchFix();

        if (checkPolyfills.length) {
            script_default()(checkPolyfills, Empire_initEmpire);
        } else {
            Empire_initEmpire();
        }

        /***/ })
    /******/ ]);

function currencyFormSubmit(event) {
    event.target.form.submit();
}

document.querySelectorAll('.shopify-currency-form select').forEach(function(element) {
    element.addEventListener('change', currencyFormSubmit);
});





/* ADD AGE VERIFIER TO CART IF ALCOHOL IS IN CART*/
//$(document).ready(function() {
//    console.log('1');
//    $('#cart-age-verifier').on('click', '[name="checkout"], [name="goto_pp"], [name="goto_gc"]', function(e) {
//        console.log('1.1');
//        e.preventDefault();
//        if ($('#agree').is(':checked')) {
//            $(this).submit();
//        }
//        else {
//            alert("Your cart contains age restricted items. You must confirm that you are over 18 years old.");
//            return false;
//        }
//    });
//});

$('button.button-primary.checkout-button--disabled#checkout-button').on('click', function(e) {
    //if checkbox isn't required then it must be hidden
    if(!$('#agree').prop('required')){
        $(this).submit();
        return true;
    } else {
        if ($('#agree').is(':checked')) {
            $(this).submit();
        } else {
            alert("Your cart contains age restricted items. You must confirm that you are over 18 years old.");
            return false;
        }
    }
});

/* DISABLE DYNAMIC BUTTONS UNTIL VERIFIER CHECKED*/
$('#agree').change(function(){
    if($(this).is(":checked")) {
        $('#additional-buttons-c').addClass('div-enabled');
    } else {
        $('#additional-buttons-c').removeClass('div-enabled');
    }
});

/* IF VERIFED CHANGE STYLING OF VERIFIER BLOCK */
$('#agree').change(function(){
    if($(this).is(":checked")) {
        $('#cart-age-verifier').addClass('cart-age-verifier--enabled');
    } else {
        $('#cart-age-verifier').removeClass('cart-age-verifier--enabled');
    }
});

/* IF VERIFED MAKE STANDARD CHECKOUT ENABLED */
$('#agree').change(function(){
    if($(this).is(":checked")) {
        $('button#checkout-button').addClass('checkout-button--enabled');
    } else {
        $('button#checkout-button').removeClass('checkout-button--enabled');
    }
});

var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
    if (links[i].hostname !== window.location.hostname) {
        links[i].target = '_blank';
        links[i].rel = 'noreferrer noopener';
    }
}



